import React from "react";
import styled from "@emotion/styled";
import Box from "./Box";

const styles = `.st0{fill:#3A3A3A;}
.st1{fill:#A7A7A7;}
.st2{fill:#D3D3D3;}
.st3{fill:#BABABA;}
.st4{fill:#4A4A4A;}
.st5{fill:#464646;}
.st6{fill:#424242;}
.st7{fill:#525252;}
.st8{fill:#676767;}
.st9{fill:#C6C6C6;}
.st10{fill:#3B3B3B;}
.st11{fill:#888888;}
.st12{fill:#4D4D4D;}
.st13{fill:#6B6B6B;}
.st14{fill:#646464;}
.st15{fill:#565656;}
.st16{fill:#474747;}
.st17{fill:#4B4B4B;}
.st18{fill:#696969;}
.st19{fill:#5C5C5C;}
.st20{fill:#484848;}
.st21{fill:#8B8B8B;}
.st22{fill:#7E7E7E;}
.st23{fill:#454545;}
.st24{fill:#626262;}
.st25{fill:#555555;}
.st26{fill:#383838;}
.st27{fill:#919191;}
.st28{fill:#575757;}
.st29{fill:#616161;}
.st30{fill:#5D5D5D;}
.st31{fill:#C5C5C5;}
.st32{fill:#989898;}
.st33{fill:#666666;}
.st34{fill:#434343;}
.st35{fill:#878787;}
.st36{fill:#D5D5D5;}
.st37{fill:#5E5E5E;}
.st38{fill:#494949;}
.st39{fill:#969696;}
.st40{fill:#3F3F3F;}
.st41{fill:#3E3E3E;}
.st42{fill:#9A9A9A;}
.st43{fill:#585858;}
.st44{fill:#404040;}
.st45{fill:#2D2D2D;}
.st46{fill:#2E2E2E;}
.st47{fill:#010101;}
.st48{fill:#959595;}
.st49{fill:#999999;}
.st50{fill:#535353;}
.st51{fill:#939393;}
.st52{fill:#737373;}
.st53{fill:#A2A2A2;}
.st54{fill:#5F5F5F;}
.st55{fill:#595959;}
.st56{fill:#545454;}
.st57{fill:#949494;}
.st58{fill:#C3C3C3;}
.st59{fill:#E3E3E3;}
.st60{fill:#E7E7E7;}
.st61{fill:#EAEAEA;}
.st62{fill:#F2F2F2;}
.st63{fill:#E2E2E2;}
.st64{fill:#E5E5E5;}
.st65{fill:#F5F5F5;}
.st66{fill:#F7F7F7;}
.st67{fill:#EEEEEE;}
.st68{fill:#E8E8E8;}
.st69{fill:#EFEFEF;}
.st70{fill:#F3F3F3;}
.st71{fill:#F6F6F6;}
.st72{fill:#E4E4E4;}
.st73{fill:#E1E1E1;}
.st74{fill:#DFDFDF;}
.st75{fill:#0B0B0B;}
.st76{fill:#0C0C0C;}
.st77{fill:#F1F1F1;}
.st78{fill:#E0E0E0;}
.st79{fill:#CFCFCF;}
.st80{fill:#BBBBBB;}
.st81{fill:#DEDEDE;}
.st82{fill:#EBEBEB;}
.st83{fill:#ECECEC;}
.st84{fill:#F4F4F4;}
.st85{fill:#F0F0F0;}
.st86{fill:#EDEDED;}
.st87{fill:#A5A5A5;}
.st88{fill:#A8A8A8;}
.st89{fill:#CECECE;}
.st90{fill:#8C8C8C;}
.st91{fill:#8E8E8E;}
.st92{fill:#B5B5B5;}
.st93{fill:#C9C9C9;}
.st94{fill:#9D9D9D;}
.st95{fill:#C4C4C4;}
.st96{fill:#AAAAAA;}
.st97{fill:#DBDBDB;}
.st98{fill:#C7C7C7;}
.st99{fill:#060606;}
.st100{fill:#080808;}
.st101{fill:#E6E6E6;}
.st102{fill:#D6D6D6;}
.st103{fill:#DDDDDD;}
.st104{fill:#DADADA;}
.st105{fill:#DCDCDC;}
.st106{fill:#D4D4D4;}
.st107{fill:#030303;}
.st108{fill:#141414;}
.st109{fill:#606060;}
.st110{fill:#9B9B9B;}
.st111{fill:#8F8F8F;}
.st112{fill:#E9E9E9;}
.st113{fill:#D7D7D7;}
.st114{fill:#868686;}
.st115{fill:#343434;}
.st116{fill:#CCCCCC;}
.st117{fill:#D0D0D0;}
.st118{fill:#8A8A8A;}
.st119{fill:#8D8D8D;}
.st120{fill:#C0C0C0;}
.st121{fill:#B2B2B2;}
.st122{fill:#B8B8B8;}
.st123{fill:#F8F8F8;}
.st124{fill:#C2C2C2;}
.st125{fill:#B4B4B4;}
.st126{fill:#848484;}
.st127{fill:#020202;}
.st128{fill:#B3B3B3;}
.st129{fill:#B6B6B6;}
.st130{fill:#898989;}
.st131{fill:#6F6F6F;}
.st132{fill:#050505;}
.st133{fill:#AEAEAE;}
.st134{fill:#BEBEBE;}
.st135{fill:#717171;}
.st136{fill:#D2D2D2;}
.st137{fill:#CBCBCB;}
.st138{fill:#D8D8D8;}
.st139{fill:#9F9F9F;}
.st140{fill:#2C2C2C;}
.st141{fill:#111111;}
.st142{fill:#212121;}
.st143{fill:#C1C1C1;}
.st144{fill:#CACACA;}
.st145{fill:#808080;}
.st146{fill:#979797;}
.st147{fill:#767676;}
.st148{fill:#6D6D6D;}
.st149{fill:#6A6A6A;}
.st150{fill:#6C6C6C;}
.st151{fill:#BCBCBC;}
.st152{fill:#BDBDBD;}
.st153{fill:#D1D1D1;}
.st154{fill:#CDCDCD;}
.st155{fill:#BFBFBF;}
.st156{fill:#C8C8C8;}
.st157{fill:#B7B7B7;}
.st158{fill:#A1A1A1;}
.st159{fill:#A9A9A9;}
.st160{fill:#ACACAC;}
.st161{fill:#9E9E9E;}
.st162{fill:#727272;}
.st163{fill:#9C9C9C;}
.st164{fill:#858585;}
.st165{fill:#B9B9B9;}
.st166{fill:#B1B1B1;}
.st167{fill:#A4A4A4;}
.st168{fill:#B0B0B0;}
.st169{fill:#929292;}
.st170{fill:#747474;}`;

const icons = {
  "account-circle": (
    <React.Fragment>
      <path
        d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm0 14.2c-2.5 0-4.71-1.28-6-3.22.03-1.99 4-3.08 6-3.08 1.99 0 5.97 1.09 6 3.08-1.29 1.94-3.5 3.22-6 3.22z"
        fill="currentColor"
      />
      <path d="M0 0h24v24H0z" fill="none" />
    </React.Fragment>
  ),
  "herb-new-logo": (
    <React.Fragment>
      <path
        d="M0 0H25.1451L25.1737 0.143454C25.0075 0.241002 24.8383 0.335681 24.6691 0.430361C21.0938 2.39854 19.1871 5.45123 19.1154 9.49376C19.0208 14.7298 19.0896 19.9687 19.0925 25.2077C19.0925 25.3196 19.1126 25.4286 19.1269 25.5921C20.8897 25.6828 22.6564 25.5156 24.3709 25.0958C26.0912 24.674 27.7542 24.126 29.4086 23.5436C32.604 22.4227 35.9578 21.8193 39.3433 21.7562C39.4809 21.7562 39.6157 21.7332 39.8221 21.7131V20.9442C39.8221 17.2345 39.8451 13.5277 39.8221 9.81796C39.7791 5.45124 37.8122 2.2264 33.8326 0.286907C33.7334 0.224249 33.6377 0.156248 33.5459 0.0832031H58.8745C58.6824 0.209442 58.5562 0.306991 58.4186 0.37011C54.7085 2.37846 52.7531 5.47419 52.7445 9.70033C52.7215 21.6816 52.7215 33.6638 52.7445 45.6469C52.7445 49.9505 54.6655 53.1237 58.4788 55.1522C58.5935 55.2153 58.7024 55.2927 58.9605 55.4391H33.5C34.0132 55.1522 34.3602 54.9857 34.7128 54.7792C37.9986 52.7708 39.7619 49.8472 39.7992 46.0084C39.8594 39.7998 39.8164 33.5882 39.8164 27.3738V26.5906C38.2624 26.7455 36.7514 26.7713 35.3006 27.0726C33.535 27.4358 31.7985 27.9287 30.1053 28.5473C26.7799 29.7813 23.2744 30.4598 19.729 30.5556C19.5455 30.5556 19.3649 30.5843 19.081 30.6044V31.4307C19.081 36.1101 19.081 40.7925 19.081 45.4748C19.081 49.8702 20.9705 53.161 24.9071 55.2296C24.9989 55.2755 25.0791 55.3386 25.3228 55.5165C24.9903 55.5366 24.844 55.5538 24.6978 55.5538H0.209303C0.137624 55.5538 0.0688121 55.5538 0 55.5538V55.3731C0.100351 55.3157 0.200702 55.2583 0.30392 55.2067C4.10579 53.2815 6.13288 50.2001 6.14721 45.9367C6.18162 33.812 6.14721 21.6902 6.14721 9.56548C6.1686 8.25208 5.9295 6.94747 5.44376 5.72713C4.95801 4.50678 4.23526 3.39494 3.31732 2.45592C2.39409 1.48331 1.3361 0.651279 0 0.286907V0Z"
        fill="#141313"
      />
      <path
        d="M124.92 55.4621C125.281 55.244 125.462 55.1293 125.648 55.026C127.713 53.8784 128.859 52.1282 129.054 49.7928C129.195 48.1316 129.324 46.4675 129.327 44.8035C129.35 33.1015 129.35 21.3986 129.327 9.69465C129.276 7.96323 129.104 6.23752 128.811 4.53032C128.555 2.78019 127.423 1.60387 125.981 0.688638C125.711 0.516493 125.436 0.347218 125.164 0.172205C125.164 0.172205 125.149 0.134907 125.121 0.0402276C125.353 0.0402276 125.565 0.00292969 125.78 0.00292969C129.052 0.00292969 132.323 0.00292969 135.592 0.00292969C136.026 0.0148655 136.452 0.120566 136.842 0.312789C139.345 1.54649 140.492 3.67247 140.595 6.35218C140.718 9.24421 140.718 12.1391 140.77 15.034C140.77 15.2836 140.77 15.5332 140.77 15.8574C141.478 15.8574 142.12 15.8574 142.762 15.8574C145.822 15.7472 148.88 16.1229 151.823 16.9706C158.532 18.979 162.838 24.1433 163.598 31.1065C164.06 35.3614 163.75 39.5072 162.136 43.5095C159.842 49.1645 155.47 52.4582 149.87 54.3661C147.561 55.1444 145.139 55.5323 142.702 55.5137C137.019 55.5137 131.337 55.5137 125.654 55.5137C125.485 55.5109 125.31 55.4879 124.92 55.4621ZM140.824 19.3634V52.0048C141.988 52.0048 143.101 52.0508 144.207 52.0048C144.993 51.9814 145.772 51.858 146.527 51.6376C149.242 50.7769 150.937 48.9349 151.479 46.1032C152.425 41.1368 152.158 36.1991 150.994 31.3102C150.203 27.9936 148.861 24.9151 146.627 22.2899C145.131 20.5139 143.29 19.3806 140.824 19.3634Z"
        fill="#141313"
      />
      <path
        d="M94.3597 33.0463H70.4533C70.9952 36.8421 71.8467 40.4284 74.6422 43.1684C78.0341 46.4908 82.0424 47.2396 86.4865 45.6874C88.978 44.8267 91.0567 43.2688 92.9548 41.467C93.1154 41.3149 93.2845 41.1801 93.4508 41.0223L93.6114 41.1084C93.4623 41.5703 93.3247 42.0408 93.1612 42.4941C91.6158 46.6285 89.2533 50.2119 85.8069 53.0035C82.9599 55.2988 79.6397 56.1394 76.0012 55.9816C68.9824 55.6775 61.7571 50.0627 59.7731 41.8802C58.3595 36.0559 58.2362 30.1858 60.4784 24.5452C63.1305 17.8689 68.0735 13.5395 75.1726 12.2082C81.6811 10.9745 87.0972 13.3071 90.9937 19.5502C92.6996 22.2815 93.5569 25.3227 93.9612 28.4931C94.1504 29.9649 94.225 31.4626 94.3597 33.0463ZM83.1491 28.3611C82.8968 26.9065 82.7104 25.5322 82.4151 24.1809C81.899 21.8053 81.1421 19.51 79.6339 17.5303C79.0032 16.7098 78.2434 16.0413 77.1768 15.8462C75.5855 15.5593 74.4558 16.3454 73.5183 17.4844C71.7378 19.6449 70.9378 22.2098 70.588 24.944C70.4361 26.0744 70.3615 27.2163 70.2497 28.3869L83.1491 28.3611Z"
        fill="#141313"
      />
      <path
        d="M117.067 29.7176C117.101 27.1728 116.989 24.7742 116.387 22.4273C116.029 21.0301 115.527 19.6845 114.529 18.6C114.153 18.1783 113.685 17.849 113.161 17.6375C112.637 17.4261 112.071 17.3382 111.507 17.3806V18.0491C111.507 27.4568 111.507 36.8645 111.533 46.275C111.575 47.6154 111.713 48.951 111.946 50.2717C112.233 52.2284 113.342 53.6543 115.008 54.6757C115.226 54.8077 115.441 54.9454 115.653 55.086C115.685 55.1089 115.699 55.1606 115.765 55.2696H95.6606C95.8146 55.1392 95.9764 55.0185 96.1452 54.9081C98.6081 53.6055 99.6374 51.4336 99.818 48.7797C99.9241 47.2333 99.9872 45.6811 99.9872 44.1319C99.9872 36.7153 99.9872 29.2987 99.947 21.8851C99.9006 20.6833 99.7481 19.488 99.4912 18.3131C99.1414 16.4654 97.9658 15.1915 96.4147 14.2247L95.6377 13.7484C95.8262 13.7005 96.0178 13.666 96.2111 13.6451C102.519 13.6451 108.827 13.6308 115.134 13.6623C116.943 13.6752 118.735 14.0174 120.421 14.6722C123.679 15.9174 125.428 18.402 126.245 21.6756C126.448 22.479 126.87 23.4401 126.6 24.0856C126.331 24.7312 125.339 25.041 124.633 25.4485C122.34 26.7625 120.046 28.0536 117.752 29.3533C117.554 29.4652 117.356 29.5656 117.067 29.7176Z"
        fill="#141313"
      />
    </React.Fragment>
  ),
  "industry-logo-1": (
    <React.Fragment>
      <g
        transform="translate(0.000000,54.000000) scale(0.100000,-0.100000)"
        fill="#000000"
        stroke="none"
      >
        <path
          d="M125 339 c-60 -104 -112 -194 -114 -200 -2 -6 17 -9 50 -7 46 3 55 7
69 31 12 22 12 29 2 35 -9 6 3 35 47 111 l59 102 61 -103 c45 -76 57 -104 46
-106 -19 -4 -19 -8 2 -43 16 -26 22 -29 70 -29 29 0 53 2 53 4 0 8 -212 371
-224 383 -8 9 -38 -35 -121 -178z"
        />
        <path
          d="M532 333 c2 -58 7 -88 16 -91 8 -2 12 8 12 32 0 31 3 36 24 36 25 0
66 41 66 66 0 26 -31 44 -76 44 l-45 0 3 -87z m72 64 c28 -20 18 -61 -16 -65
-27 -3 -28 -1 -28 37 0 44 12 51 44 28z"
        />
        <path
          d="M680 330 c0 -53 4 -90 10 -90 6 0 10 18 10 40 0 22 4 40 10 40 5 0
22 -18 36 -40 40 -61 61 -54 24 8 -19 30 -19 34 -4 57 10 16 14 34 10 50 -6
22 -12 25 -51 25 l-45 0 0 -90z m66 66 c15 -12 17 -18 8 -33 -6 -10 -21 -19
-33 -21 -18 -3 -21 1 -21 32 0 39 13 46 46 22z"
        />
        <path
          d="M830 330 l0 -90 45 0 c25 0 45 5 45 10 0 6 -16 10 -35 10 -33 0 -35
2 -35 34 0 32 3 35 33 39 l32 4 -32 1 c-31 2 -33 5 -33 36 0 33 2 35 38 39 34
3 33 4 -10 5 l-48 2 0 -90z"
        />
        <path
          d="M950 330 c0 -53 4 -90 10 -90 6 0 10 28 11 63 l1 62 15 -42 c8 -24
21 -43 28 -43 7 0 20 19 28 43 l15 42 1 -62 c1 -35 5 -63 11 -63 6 0 10 37 10
91 0 105 -12 113 -43 29 l-20 -55 -19 58 c-30 89 -48 77 -48 -33z"
        />
        <path
          d="M1128 413 c20 -4 22 -10 22 -79 0 -67 -2 -74 -20 -74 -11 0 -20 -4
-20 -10 0 -5 23 -10 50 -10 28 0 50 5 50 10 0 6 -9 10 -20 10 -18 0 -20 7 -20
70 0 64 2 72 23 80 17 7 9 9 -33 8 -30 0 -45 -3 -32 -5z"
        />
        <path
          d="M1250 342 c0 -47 5 -83 12 -90 20 -20 76 -15 88 7 13 25 13 161 0
161 -6 0 -10 -32 -10 -75 0 -61 -3 -76 -18 -84 -11 -6 -24 -6 -35 0 -14 8 -17
24 -17 84 0 43 -4 75 -10 75 -6 0 -10 -33 -10 -78z"
        />
        <path
          d="M1380 336 c0 -100 18 -126 22 -34 l3 63 14 -43 c17 -52 39 -52 57 -2
l12 35 1 -52 c1 -28 6 -55 11 -58 6 -4 10 27 10 84 0 50 -4 91 -9 91 -4 0 -16
-21 -26 -47 -19 -52 -35 -76 -35 -53 0 29 -33 100 -46 100 -11 0 -14 -20 -14
-84z"
        />
        <path
          d="M176 180 c-32 -56 -56 -103 -54 -106 3 -2 58 -3 122 -2 l116 3 -57
103 c-32 56 -60 102 -63 102 -4 0 -32 -45 -64 -100z"
        />
        <path
          d="M540 160 c0 -43 3 -50 20 -50 10 0 24 9 30 21 13 23 5 69 -11 69 -6
0 -6 -7 1 -20 14 -26 4 -60 -17 -60 -12 0 -14 10 -11 45 2 25 0 45 -4 45 -5 0
-8 -22 -8 -50z"
        />
        <path
          d="M620 160 c0 -48 1 -50 28 -49 23 2 24 2 5 6 -27 5 -31 30 -5 36 16 4
16 5 0 6 -11 1 -18 9 -18 20 0 11 8 22 18 24 13 4 11 5 -5 6 -21 1 -23 -3 -23
-49z"
        />
        <path
          d="M773 198 c9 -7 18 -31 20 -53 l4 -40 1 42 c1 28 8 45 20 52 14 8 9
10 -22 11 -34 0 -37 -2 -23 -12z"
        />
        <path
          d="M1009 208 c-1 -2 -3 -24 -5 -50 -3 -45 -1 -48 21 -48 27 0 40 14 28
33 -4 6 -8 23 -8 37 0 15 -6 26 -17 28 -10 2 -19 2 -19 0z m31 -23 c0 -8 -4
-15 -9 -15 -13 0 -22 16 -14 24 11 11 23 6 23 -9z m0 -50 c0 -8 -7 -15 -15
-15 -16 0 -20 12 -8 23 11 12 23 8 23 -8z"
        />
        <path
          d="M1154 195 c-4 -9 -4 -19 0 -22 3 -3 1 -12 -5 -19 -18 -21 -3 -44 29
-44 23 0 28 5 30 28 1 20 -1 23 -8 12 -8 -13 -10 -13 -14 0 -3 8 -4 24 -3 34
3 24 -21 33 -29 11z m26 -4 c0 -6 -4 -13 -10 -16 -5 -3 -10 1 -10 9 0 9 5 16
10 16 6 0 10 -4 10 -9z m-4 -69 c-22 -5 -30 3 -21 18 5 8 11 7 22 -2 15 -12
14 -13 -1 -16z"
        />
        <path
          d="M1316 194 c-33 -32 -10 -92 31 -81 15 4 14 5 -3 6 -40 2 -40 65 0 81
16 7 17 9 4 9 -9 1 -24 -6 -32 -15z"
        />
        <path
          d="M1387 203 c-4 -3 -7 -26 -7 -50 0 -42 1 -44 28 -41 25 3 27 6 23 43
-4 45 -25 68 -44 48z m25 -35 c-15 -15 -26 -4 -18 18 5 13 9 15 18 6 9 -9 9
-15 0 -24z m11 -33 c1 -5 -6 -11 -15 -13 -11 -2 -18 3 -18 13 0 17 30 18 33 0z"
        />
        <path
          d="M1460 160 c0 -41 3 -50 18 -50 40 0 57 54 26 84 -30 31 -44 20 -44
-34z m40 25 c15 -19 5 -65 -15 -65 -11 0 -15 11 -15 40 0 42 9 50 30 25z"
        />
        <path
          d="M690 155 c0 -44 0 -45 33 -44 23 1 26 3 10 6 -19 4 -23 11 -23 44 0
21 -4 39 -10 39 -5 0 -10 -20 -10 -45z"
        />
        <path
          d="M851 159 c-7 -23 -10 -44 -7 -47 3 -3 6 0 6 6 0 7 9 12 20 12 11 0
20 -4 20 -10 0 -5 4 -10 9 -10 6 0 3 20 -6 45 -8 25 -18 45 -22 45 -4 0 -13
-18 -20 -41z m29 -4 c0 -8 -4 -15 -10 -15 -5 0 -10 7 -10 15 0 8 5 15 10 15 6
0 10 -7 10 -15z"
        />
        <path d="M938 143 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z" />
      </g>
    </React.Fragment>
  ),
  "industry-logo-2": (
    <React.Fragment>
      <g>
        <path
          d="M278.11,187.95c-6.32,4.43-12.9,6.67-20.11,7.9c-7.48,1.27-11.18,5.55-12.13,12.98c-1.04,8.17-2.32,16.34-4.02,24.39
		c-1.69,8.04-3.35,16.24-8.56,22.98c-1.96,2.53-4.57,5.76-7.9,4.59c-3.62-1.26-1.74-5.15-1.3-7.85c2.07-12.48,4.26-24.94,6.58-37.38
		c1.84-9.89,0.86-10.95-8.35-7.98c-4.99,1.61-10.35,2.43-13.94,7.02c-1.31,1.67-3.39,1.83-5.67,1.41
		c-15.12-2.78-25.77,4.29-33.38,16.36c-5.33,8.45-9.88,17.43-14.19,26.45c-6.23,13.03-14.72,24.39-26.15,32.97
		c-13.65,10.25-37.91,13.19-46.45-12.13c-9.11-27.03,6.47-66.32,32.51-78.66c3.9-1.85,7.95-2.28,12.08-1.82
		c6.62,0.73,11.06,4.35,11.92,11.06c0.88,6.82-1.96,12.54-8.31,15.14c-6.54,2.68-10.65-0.88-12.57-7.26
		c-0.92-3.06-2.57-2.46-4.58-0.96c-5.98,4.46-9.08,18.76-6.16,28.83c2.58,8.92,8.23,13.09,18.35,13.54
		c18.28,0.81,30.06-10.25,34.31-32.24c3.41-17.64-6.8-34.62-24.18-40.11c-15.01-4.74-28,0.57-39.91,8.94
		c-24.96,17.52-38.33,42.58-45.25,71.56c-3.38,14.17-4.25,28.16-0.79,42.75c7.09,29.86,39.54,37.93,61.77,24.48
		c10.25-6.2,18.81-14.18,25.8-23.86c5.61-7.78,11.2-15.57,16.7-23.22c2.96,1.13,3.02,3.52,3.91,5.27
		c6.88,13.58,15.05,15.81,27.81,7.36c2.45-1.62,4.76-3.5,6.9-5.5c1.95-1.83,3.9-2.41,6.4-1.38c11.53,4.75,19.18-0.47,25.4-9.73
		c1.54-2.29,2.52-5.35,7.62-6.6c-1.5,12.05-3.01,23.1-4.2,34.18c-0.85,7.88,2.41,10.5,9.77,7.66c9.71-3.75,12.77-12.62,14.91-21.56
		c2.12-8.86,3.53-17.9,4.84-26.93c0.85-5.86,3.1-7.29,8.04-3.75c13.17,9.43,22.85,5.91,32.1-7.49
		c12.28-17.77,13.84-38.09,9.47-58.53C304.31,187.26,288.63,180.58,278.11,187.95z M193.43,267.95c-5.71,5.73-11.33,4.56-14.05-3.19
		c-1.04-2.98-1.16-6.29-1.39-7.67c0.3-9.69,2.25-17.03,7.46-23.04c5.35-6.17,11.03-5.05,14.18,2.44
		C203.28,245.14,200.1,261.26,193.43,267.95z M282.49,239.84c-2.3,3.02-4.96,6.2-9.45,5.01c-3.83-1.01-5.33-4.27-6.31-7.8
		c-2.58-9.35-0.37-18.01,4.17-26.15c2.15-3.86,5.16-7.78,10.26-6.85c5.57,1.02,6.67,5.94,7.28,10.76c0.18,1.45,0.19,2.92,0.17,2.55
		C288.79,226.74,287.1,233.78,282.49,239.84z"
        />
        <path
          d="M195.59,202.48c15.93-4.31,28.13-13.08,32.94-30.06c2.49-8.79,4.93-17.56,6.55-26.54c3.61-20.04,8.21-39.76,17.14-58.26
		c6.36-13.16,15.74-23.18,30.5-30.39c-3.7,9.75-6.98,17.62-9.66,25.69c-2.73,8.22-6.23,14.78-14.66,19.5
		c-12.97,7.27-13.05,29.81,0.27,37.18c8.92,4.93,13.91,11.99,19.43,19.47c11.41,15.45,30.93,16.43,44.44,2.47
		c4.46-4.6,6.16-8.38-2.48-9.83c-1.91-0.32-4.07-1.37-5.35-2.78c-1.89-2.09-6.95-3.68-4.09-7.19c2.32-2.84,6.48-5.25,10.62-0.82
		c2.38,2.54,5.46,4.5,8.43,6.4c10.29,6.58,19.32,5.85,28.08-2.59c9.56-9.21,10.43-21.36,12.02-34.77c-4.54,1.91-5.53,4.87-7.16,7.09
		c-3.04,4.15-7.04,5.96-12.12,6.11c-6.1,0.19-8.24-2.02-5.73-7.98c2.11-5.01,5.74-8.9,9.18-12.91
		c16.14-18.85,21.07-40.51,15.57-64.38c-3.38-14.68-13.91-18.85-26.61-10.82c-14.76,9.33-24.56,22.7-29.77,39.36
		c-5.26,16.84-6.56,34.11-4.63,51.54c0.54,4.89-1.58,7.27-5.09,9.09c-3.61,1.87-6.15-0.77-8.45-3.01
		c-2.81-2.74-4.29-6.28-5.37-10.01c-2.7-9.3-1.71-18.66-0.59-28.04c1.85-15.57,6.27-30.29,16.29-44.28
		c-16.16,0.29-29.06,4.47-40.88,12.33c-22.37,14.88-39.93,33.78-50.52,58.81c-5.39,12.74-11.06,25.39-17.36,37.7
		c-5.94,11.6-18.59,16.39-29.93,12.38c-8.34-2.94-10.43-1.56-11.14,7.35C153.77,191.34,174.46,208.19,195.59,202.48z M262.7,123.56
		c-3.49,0.06-4.08-3.77-4.19-6.65c-0.12-2.94,1.8-5.51,4.61-5.36c3.47,0.18,1.34,3.77,2.35,5.26
		C264.84,119.58,266.37,123.5,262.7,123.56z M347.06,38.79c1.84-2.2,3.77-5.46,6.94-4.61c3.92,1.05,2.98,5.14,3.29,8.24
		c2.15,21.12-6.27,38.11-21.15,54.22C332.56,74.98,333.03,55.62,347.06,38.79z"
        />
        <path
          d="M512.32,174.49c-3.34,4.49-7.57,6.16-13.06,5.66c-4.45-0.4-5.96-3.42-6.88-6.94c-1.04-3.96,2.1-4.76,4.83-6.08
		c4.77-2.31,9.46-4.82,14.01-7.53c10.64-6.34,14.39-16.15,12.7-27.91c-1.3-9.07-7.36-14.93-16.04-16.94
		c-11.38-2.64-21.59-0.25-29.47,9.33c-12.19,14.83-18.01,31.68-16.25,50.81c0.66,7.17-2.68,11.73-7.72,15.79
		c-1.96,1.58-4.14,2.45-6.55,1.47c-2.87-1.17-2.37-3.94-2.07-6.13c1.43-10.49,3.17-20.95,4.64-31.44
		c0.96-6.82,1.63-14.24-4.76-18.58c-6.27-4.25-13.14-1.02-19.41,1.61c-2.1,0.88-3.9,2.63-5.62,4.22c-2.82,2.61-5.14,4.23-9.87,3.69
		c-10.59-1.22-18.71,5.27-22.04,15.49c-1.48,4.54-3.94,8.43-7.15,12.05c-4.86,5.49-8.2,7.08-13.51-0.32
		c-8.44-11.75-18.76-12.79-30.7-4.3c-25.68,18.27-26.99,51.54-17.23,73.13c3.06,6.78,8.75,10.01,16.46,9.56
		c11.92-0.7,20.64-6.21,26.34-16.66c5.03-9.23,6.45-19.49,8.7-29.53c0.7-3.12,0.76-6.59,3.18-9c1.57-1.56,3.27-4.24,5.83-2.89
		c2.13,1.12,0.87,3.7,0.59,5.65c-1.63,11.36-3.31,22.72-4.92,34.08c-0.29,2.07-2.16,4.92,2.02,5.25c7.88,0.62,19.92-9.3,21.29-17.26
		c2.4-13.92,4.91-27.82,7.45-41.72c1.15-6.3,3.97-11.7,9.33-15.5c2.32-1.64,4.49-4.56,7.73-2.57c3.04,1.87,2.29,5.18,1.8,8.07
		c-1.89,11.04-3.7,22.1-3.43,33.33c0.12,5.09-1.38,11.07,4.87,14.01c6.71,3.16,13.36,2.77,19.07-2.11c5.59-4.78,10.93-9.89,16-15.22
		c3.06-3.22,5.44-4.15,9.86-1.93c20.95,10.53,47.17-6.88,46.8-31.65C514.92,167.91,514.37,171.74,512.32,174.49z M359.94,202.82
		c-2.76,7.49-5.65,15.26-13.18,19.11c-4.41,2.26-6.83-1.92-8.58-5.46c-5.73-11.56-2.55-26.19,7.8-36.11
		c2.96,1.47,2.26,4.45,2.92,6.91c0.76,2.85,1.72,5.64,4.3,7.5C356.12,196.88,362.32,196.36,359.94,202.82z M489.21,154.38
		c-2.36-1.31-2.5-3.77-2.31-7.04c1.25-5.8,3.01-12.27,7.36-17.69c2.24-2.79,5.31-4.07,8.59-2.61c3.66,1.64,3.3,5.12,2.56,8.4
		c-1.45,6.47-4.71,11.95-9.34,16.62C494.22,153.91,492.16,156.02,489.21,154.38z"
        />
        <path
          d="M388.51,97.99c3.12-0.76,6.23-1.77,9.14-3.11c11.73-5.42,18.84-14.62,21.4-27.22c0.58-2.85,0.87-6.18-2.21-7.9
		c-2.53-1.41-4.33,0.89-6.1,2.33c-6.94,5.67-15.4,6.91-23.83,8.04c-11.8,1.58-14.17,4.1-14.04,15.62
		C373.02,99.5,375.18,101.24,388.51,97.99z"
        />
      </g>
    </React.Fragment>
  ),
  "industry-logo-3": (
    <React.Fragment>
      <g
        transform="translate(0.000000,64.000000) scale(0.100000,-0.100000)"
        fill="#000000"
        stroke="none"
      >
        <path
          d="M385 567 c-21 -12 -53 -42 -70 -65 -28 -40 -30 -50 -30 -127 0 -77 2
-87 30 -127 26 -36 93 -87 116 -88 3 0 18 32 33 70 15 39 31 70 35 70 3 0 17
-31 30 -70 28 -82 39 -86 103 -37 126 96 125 268 -1 364 -24 19 -50 33 -58 31
-9 -2 -26 -31 -40 -65 -14 -35 -28 -63 -32 -63 -4 0 -18 29 -30 65 -13 36 -28
65 -35 65 -6 0 -29 -10 -51 -23z m63 -106 c23 -59 26 -62 55 -59 28 3 33 9 55
66 13 34 27 62 31 62 4 0 21 -14 39 -31 49 -48 65 -128 38 -193 -13 -31 -62
-86 -77 -86 -4 0 -17 29 -30 65 -23 65 -23 66 -57 63 -32 -3 -36 -7 -57 -63
-12 -33 -26 -60 -31 -60 -20 0 -56 35 -74 71 -24 45 -26 101 -6 149 17 39 64
87 80 82 6 -2 21 -32 34 -66z"
        />
        <path
          d="M67 103 c-14 -13 -6 -33 13 -33 11 0 20 -5 20 -11 0 -7 -10 -9 -25
-7 -13 3 -22 1 -19 -3 3 -5 16 -9 30 -9 30 0 33 29 4 37 -11 3 -20 10 -20 15
0 6 9 8 20 5 11 -3 18 -1 14 4 -6 11 -28 12 -37 2z"
        />
        <path
          d="M137 102 c6 -4 13 -21 16 -37 l4 -30 2 32 c0 17 7 34 14 36 6 3 -1 6
-18 6 -16 0 -25 -3 -18 -7z"
        />
        <path
          d="M204 96 c-10 -25 0 -51 20 -54 27 -6 48 25 35 49 -12 22 -47 25 -55
5z m49 -8 c7 -21 -4 -38 -24 -38 -14 0 -19 7 -19 25 0 18 5 25 19 25 11 0 21
-6 24 -12z"
        />
        <path
          d="M297 103 c-4 -3 -7 -20 -7 -37 0 -21 3 -27 9 -17 5 7 6 22 3 33 -4
15 -1 19 13 17 11 -3 19 -14 20 -26 2 -34 13 -39 12 -6 -2 36 -30 57 -50 36z"
        />
        <path
          d="M393 103 c16 -4 16 -7 -4 -34 l-20 -29 28 1 c17 1 21 3 10 6 -15 4
-16 6 -2 26 21 29 19 37 -7 36 -18 -1 -19 -2 -5 -6z"
        />
        <path
          d="M480 98 c0 -7 -3 -23 -6 -35 -5 -20 -2 -23 20 -23 16 0 26 5 26 15 0
18 -17 20 -23 3 -2 -7 -8 -9 -13 -5 -5 5 -1 13 9 18 21 12 23 39 2 39 -8 0
-15 -6 -15 -12z"
        />
        <path
          d="M580 75 c0 -31 3 -35 25 -35 22 0 25 4 25 35 0 31 -3 35 -25 35 -22
0 -25 -4 -25 -35z m40 15 c0 -5 -7 -10 -15 -10 -8 0 -15 5 -15 10 0 6 7 10 15
10 8 0 15 -4 15 -10z m0 -30 c0 -5 -7 -10 -15 -10 -8 0 -15 5 -15 10 0 6 7 10
15 10 8 0 15 -4 15 -10z"
        />
        <path d="M663 75 c0 -22 2 -30 4 -17 2 12 2 30 0 40 -3 9 -5 -1 -4 -23z" />
        <path
          d="M707 103 c-3 -5 6 -8 19 -8 13 0 24 3 24 8 0 4 -9 7 -19 7 -11 0 -22
-3 -24 -7z"
        />
        <path
          d="M782 75 c0 -22 2 -32 5 -22 6 22 19 22 27 1 4 -9 9 -14 13 -11 3 4 0
13 -7 22 -10 12 -10 18 1 33 12 15 11 15 -8 -1 -21 -18 -21 -18 -26 0 -3 10
-5 0 -5 -22z"
        />
        <path
          d="M860 75 c0 -30 3 -35 23 -34 16 1 18 2 5 6 -10 2 -18 8 -18 13 0 5 8
11 18 13 16 4 16 5 0 6 -26 2 -22 19 5 24 19 4 18 4 -5 6 -26 1 -28 -2 -28
-34z"
        />
        <path
          d="M942 78 c-2 -34 1 -38 21 -37 15 1 17 3 5 6 -10 2 -18 17 -21 36 -4
31 -4 31 -5 -5z"
        />
        <path
          d="M694 67 c3 -10 6 -21 6 -23 0 -2 11 -4 25 -4 14 0 25 4 25 10 0 5 -7
7 -16 3 -11 -4 -23 1 -32 13 -14 18 -14 18 -8 1z"
        />
      </g>
    </React.Fragment>
  ),
  "industry-logo-4": (
    <React.Fragment>
      <g>
        <g>
          <g>
            <g>
              <g>
                <g>
                  <g>
                    <path
                      class="st0"
                      d="M284.89,20.46L284.89,20.46L284.89,20.46L284.89,20.46L284.89,20.46c-28.03,0-52.85,26.42-52.85,58.92
								c0,26.84,18.11,49.55,39.02,56.64c0.04,0.01,0.08,0.03,0.12,0.04s0.33,0.1,0.53-0.04c0.17-0.12,1.05-0.77,1.26-1.27
								c0.07-0.17-0.06-0.35-0.28-0.44c-0.01,0-0.4-0.14-0.41-0.14c-18.66-7.29-32.09-28.87-32.09-53.64
								c0-29.58,19.94-54.55,44.69-54.55c24.75,0,44.69,24.98,44.69,54.55c0,24.76-13.43,46.35-32.09,53.64
								c-0.01,0-0.32,0.13-0.33,0.14c-0.22,0.08-0.34,0.27-0.28,0.44c0.09,0.25,1.03,1.16,1.15,1.28c0.17,0.17,0.34,0.11,0.44,0.08
								c0.03-0.01,0.06-0.02,0.09-0.03c20.97-7.03,39.17-29.78,39.17-56.69C337.73,46.88,312.92,20.46,284.89,20.46z"
                    />
                  </g>
                  <path
                    class="st0"
                    d="M316.2,74.45c-0.55-1.38-1.33-2.7-2.31-3.85c2.31-1.52,3.28-4.52,2.36-7.11
							c-0.79-2.24-2.92-4.04-5.41-4.32c-0.74-0.08-1.49,0-2.23,0.15l0-0.07c-0.03-3.01-1.09-6.08-3.29-8.18
							c-2.18-2.07-5.25-3.13-8.2-3.28c-0.47-0.02-1.88-0.06-2.59,0.09c0.56-0.55,1.61-1.93,1.48-4.21c-0.1-1.62-1.41-5.58-6.3-5.58
							c-2.87,0-4.43,1.48-4.82,1.88c-0.39-0.41-1.96-1.88-4.82-1.88c-4.9,0-6.21,3.96-6.3,5.58c-0.14,2.29,0.92,3.66,1.48,4.21
							c-0.71-0.15-2.12-0.11-2.59-0.09c-2.95,0.15-6.02,1.21-8.2,3.28c-2.21,2.1-3.26,5.17-3.29,8.18l0,0.07
							c-0.74-0.16-1.49-0.24-2.23-0.15c-2.49,0.28-4.62,2.08-5.41,4.32c-0.92,2.59,0.06,5.59,2.36,7.11
							c-0.98,1.15-1.76,2.47-2.31,3.85c-0.91,2.26-1.21,5.13-0.88,7.54c0.34,2.5,1.42,4.91,3.16,6.74c3.35,3.52,9.2,4.69,13.39,1.96
							c1.66-1.05,2.97-2.62,3.7-4.4c0.74-1.78,0.92-3.77,0.48-5.59c-0.41-1.84-1.49-3.48-2.9-4.57c-0.15-0.11-0.37-0.12-0.52,0
							c-0.18,0.14-0.21,0.41-0.07,0.59c1,1.29,1.58,2.78,1.76,4.29c0.35,3.28-1.5,6.52-4.64,7.68c-2.92,1.08-6.34,0.03-8.31-2.34
							c-1.88-2.26-2.39-5.46-1.69-8.27c0.02-0.09,0.04-0.17,0.07-0.26c0.89-3.2,3.37-6.1,6.42-7.39c2.67-1.12,6.09-0.98,8.93-0.28
							c2.91,0.66,5.43,2.49,7.33,4.73c1.89,2.25,2.8,6.16,2.8,11.36l-0.01,28.91c0,19.77-4.41,23.4-6.63,25.15
							c-2.55,2.02-6.03,2.95-9.05,3.86c-1.62,0.49-3.22,1.05-4.76,1.75c-1.46,0.67-2.66,1.41-3.67,2.26
							c-0.73,0.61-1.36,1.36-1.78,2.22c-0.26,0.54-0.9,1.88-0.19,2.28c0.86,0.49,1.66-1.34,2.05-1.86c0.71-0.93,1.76-1.41,2.81-1.84
							c3.03-1.25,6.21-1.55,9.38-2.24c0.54-0.12,1.08-0.2,1.62-0.29c-0.36,0.06-1,1.78-1.16,2.12c-0.37,0.8-0.7,1.61-1.09,2.4
							c-0.82,1.66-1.88,2.97-3.51,3.87c-0.54,0.29-0.47,1.14,0.14,1.3c0.88,0.23,2.08-0.79,2.75-1.28c0.9-0.65,1.62-1.51,2.23-2.42
							c0.99-1.47,1.68-3.09,2.89-4.39c1.12-1.2,2.55-2.13,4.09-2.68c1.38-0.5,2.65-1.22,3.9-1.95c-0.11,1.66-0.75,3.32-1.67,4.7
							c-1.42,2.14-3.41,3.81-4.96,5.84c-0.53,0.7-1.23,1.8-1.32,2.7c-0.03,0.3,0.08,0.64,0.35,0.79c0.42,0.23,0.93-0.1,1.12-0.48
							c1.4-2.92,6.88-6.19,7.9-8.33c0.27,2.78-0.04,7.24-0.7,9.11c-0.2,0.58-0.73,1.6-0.5,2.19c0.26,0.64,0.98,0.47,1.34,0.06
							c0.72-0.81,1.13-2.07,1.45-3.09c0.91-2.83,1.26-5.87,1.31-8.3c0.65,1.13,2.98,3.3,4.3,4.34c1.15,0.91,2.11,2.31,2.38,3.77
							c0.08,0.42-0.01,0.98,0.44,1.2c0.25,0.12,0.57,0.07,0.77-0.11c0.64-0.61,0.12-2.25-0.09-2.95c-0.29-0.95-0.72-1.93-1.39-2.68
							c-1.14-1.28-2.3-2.55-3.31-3.93c-0.96-1.31-2.36-3.6-2.36-4.81c0.47,0,3.36,1.57,4.83,2.51c1.58,1.01,2.98,2.32,4.01,3.9
							c0.89,1.37,1.63,2.82,2.86,3.94c0.96,0.87,2.11,1.51,3.32,1.95c0.4,0.14,0.83-0.11,0.93-0.52c0.2-0.84-1.03-1.2-1.55-1.54
							c-0.81-0.54-1.48-1.28-2.01-2.09c-0.44-0.67-0.8-1.39-1.13-2.12c-0.13-0.29-0.61-1.88-0.93-1.96
							c3.06,0.79,6.15,1.49,9.18,2.39c1.11,0.33,2.26,0.65,3.23,1.3c0.48,0.32,0.91,0.71,1.2,1.21c0.26,0.45,0.36,1.34,1.08,1.18
							c1.15-0.25,0.26-2.08-0.09-2.66c-0.7-1.17-1.84-2.01-3-2.69c-2.87-1.67-6.12-2.65-9.27-3.6c-2.36-0.72-4.68-2.07-6.54-3.8
							c-1.26-1.17-6.62-6.07-6.62-25.67l-0.01-28.91c0-5.21,0.92-9.12,2.8-11.36c1.9-2.23,4.42-4.07,7.33-4.73
							c2.85-0.7,6.26-0.84,8.93,0.28c3.05,1.29,5.52,4.2,6.42,7.39c0.02,0.08,0.05,0.17,0.07,0.26c0.71,2.81,0.19,6.01-1.69,8.27
							c-1.97,2.37-5.39,3.42-8.31,2.34c-3.13-1.16-4.99-4.41-4.64-7.68c0.19-1.5,0.77-3,1.76-4.29c0.14-0.18,0.11-0.45-0.07-0.59
							c-0.15-0.12-0.37-0.12-0.52,0c-1.41,1.1-2.49,2.74-2.9,4.57c-0.44,1.83-0.26,3.82,0.48,5.59c0.74,1.78,2.04,3.35,3.7,4.4
							c4.19,2.73,10.04,1.56,13.39-1.96c1.74-1.83,2.82-4.24,3.16-6.74C317.4,79.58,317.1,76.71,316.2,74.45z M262.08,66.54
							c-1.83,0.61-3.6,1.59-5.1,2.94c-0.24-0.23-0.48-0.48-0.65-0.76c-0.86-1.31-0.93-2.98-0.24-4.19c0.62-1.25,1.93-1.98,3.17-2.01
							c1.27-0.04,2.45,0.61,3.09,1.63c0.03,0.05,1.01,1.39,1.56,1.93C263.3,66.22,262.69,66.34,262.08,66.54z M282.61,71.3
							c-2.07-2.23-4.69-3.91-7.56-4.86c1.14-1.14,2.47-3.07,2.24-5.59c-0.26-2.89-2.43-4.36-2.69-4.52
							c-0.11-0.07-0.25-0.07-0.35,0.02c-0.12,0.1-0.13,0.29-0.03,0.41c0.92,1.07,1.31,2.43,1.31,3.73c0,3.31-2.5,4.95-5.23,4.95
							c-2.35,0-5.01-2.33-5.01-5.72c0-6.41,5.25-7.95,8.23-7.95c4.18,0,9.09,3.89,9.09,9.97C282.61,64.76,282.61,67.44,282.61,71.3z
							 M277.67,48.3c-0.88-0.58-1.59-1.86-1.59-3.15c0-2.08,1.29-3.52,3.34-3.52c2.6,0,3.21,2.03,3.21,3.95c0,0.59,0.01,3,0.01,5.5
							C281.2,49.69,278.71,48.61,277.67,48.3z M287.14,45.58c0-1.92,0.61-3.95,3.21-3.95c2.04,0,3.34,1.44,3.34,3.52
							c0,1.3-0.7,2.57-1.59,3.15c-1.04,0.31-3.53,1.38-4.97,2.78C287.13,48.58,287.14,46.17,287.14,45.58z M299.46,65.44
							c-2.73,0-5.23-1.63-5.23-4.95c0-1.31,0.39-2.67,1.31-3.73c0.1-0.12,0.09-0.3-0.03-0.41c-0.1-0.09-0.24-0.09-0.35-0.02
							c-0.25,0.17-2.43,1.64-2.69,4.52c-0.22,2.52,1.1,4.45,2.24,5.59c-2.87,0.94-5.49,2.62-7.56,4.86c0-3.86,0-6.54,0-9.57
							c0-6.08,4.91-9.97,9.09-9.97c2.97,0,8.23,1.54,8.23,7.95C304.47,63.11,301.82,65.44,299.46,65.44z M312.79,69.48
							c-1.5-1.35-3.27-2.33-5.1-2.94c-0.61-0.19-1.22-0.32-1.83-0.46c0.56-0.53,1.53-1.87,1.56-1.93c0.64-1.01,1.83-1.67,3.09-1.63
							c1.24,0.03,2.55,0.77,3.17,2.01c0.69,1.21,0.62,2.88-0.24,4.19C313.27,69,313.04,69.24,312.79,69.48z"
                  />
                </g>
              </g>
            </g>
          </g>
          <g>
            <path
              class="st0"
              d="M101.29,465.61c0-7.92,5.32-12.77,14.03-12.77c3.44,0,6.37,0.76,8.93,2.39l-1.84,5.5
				c-2.24-1.3-4.2-1.84-6.44-1.84c-4.85,0-7.59,2.46-7.59,6.65c0,4.3,2.82,6.73,7.81,6.73c2.39,0,4.52-0.58,6.83-1.88l2.03,5.5
				c-2.49,1.63-5.64,2.42-9.37,2.42C106.6,478.31,101.29,473.57,101.29,465.61z"
            />
            <path
              class="st0"
              d="M151.74,473.24h-9.95l-1.81,4.63h-7.12l10.52-24.59h7.13l10.52,24.59h-7.49L151.74,473.24z M146.78,459.93
				l-2.93,8.07h5.82L146.78,459.93z"
            />
            <path
              class="st0"
              d="M195.29,453.28v24.59h-6.33L177.49,462v15.88h-6.62v-24.59h7.88l9.91,13.74v-13.74H195.29z"
            />
            <path
              class="st0"
              d="M232.67,453.28v24.59h-6.33L214.87,462v15.88h-6.62v-24.59h7.88l9.91,13.74v-13.74H232.67z"
            />
            <path
              class="st0"
              d="M259.94,473.24h-9.95l-1.81,4.63h-7.13l10.52-24.59h7.12l10.52,24.59h-7.49L259.94,473.24z M254.98,459.93
				l-2.93,8.07h5.82L254.98,459.93z"
            />
            <path
              class="st0"
              d="M303.01,470.93c0,4.63-3.11,6.94-9.29,6.94h-15.37v-24.59h14.86c6,0,9.01,2.24,9.01,6.73
				c0,2.64-1.23,4.38-3.72,5.28C301.53,466.08,303.01,467.96,303.01,470.93z M285.29,462.94h7.38c1.81,0,2.68-0.62,2.68-1.95
				c0-1.34-0.87-2.03-2.53-2.03h-7.52V462.94z M295.96,470.13c0-1.34-0.9-1.99-2.75-1.99h-7.92v4.05h8.06
				C295.09,472.2,295.96,471.51,295.96,470.13z"
            />
            <path class="st0" d="M314.87,453.28h6.94v24.59h-6.94V453.28z" />
            <path
              class="st0"
              d="M333.06,474.94l2.39-5.17c2.86,1.95,6.29,2.97,10.13,2.97c3.4,0,5.03-0.69,5.03-2.1
				c0-1.27-0.94-1.66-5.32-2.06c-8.39-0.8-11.1-2.71-11.1-7.85c0-4.96,4.23-7.88,11.43-7.88c4.27,0,7.92,1.01,10.81,2.93l-2.28,4.96
				c-2.31-1.55-5.06-2.31-8.1-2.31c-3.15,0-4.81,0.69-4.81,2.06c0,1.3,0.94,1.7,5.28,2.1c8.39,0.76,11.14,2.71,11.14,7.81
				c0,5.21-4.05,7.92-11.86,7.92C340.58,478.31,336.31,477.15,333.06,474.94z"
            />
            <path
              class="st0"
              d="M393.61,465.61c0-7.92,5.32-12.77,14.03-12.77c3.44,0,6.37,0.76,8.93,2.39l-1.84,5.5
				c-2.24-1.3-4.2-1.84-6.44-1.84c-4.85,0-7.59,2.46-7.59,6.65c0,4.3,2.82,6.73,7.81,6.73c2.39,0,4.52-0.58,6.83-1.88l2.03,5.5
				c-2.49,1.63-5.64,2.42-9.37,2.42C398.93,478.31,393.61,473.57,393.61,465.61z"
            />
            <path
              class="st0"
              d="M426.5,465.58c0-7.7,5.39-12.73,13.6-12.73c8.25,0,13.6,5.03,13.6,12.73c0,7.7-5.35,12.73-13.6,12.73
				C431.89,478.31,426.5,473.28,426.5,465.58z M446.64,465.58c0-4.01-2.6-6.69-6.55-6.69c-3.91,0-6.51,2.68-6.51,6.69
				s2.6,6.69,6.51,6.69C444.04,472.27,446.64,469.59,446.64,465.58z"
            />
            <path
              class="st0"
              d="M461.71,473.17c0-3.1,2.22-5.32,5.37-5.32c3.15,0,5.37,2.22,5.37,5.32c0,3.1-2.22,5.32-5.37,5.32
				C463.93,478.49,461.71,476.27,461.71,473.17z"
            />
          </g>
        </g>
        <g>
          <g>
            <g>
              <g>
                <g>
                  <g>
                    <path
                      class="st0"
                      d="M159.82,290.87v-2.45c-3.56,0-6.9-1.78-6.96-5.67c-0.12-3.24,0.17-6.49,0.88-9.66l1.85-7.73h31.81
								c0.85,3.5,1.71,7.07,2.19,9.03c0.56,2.8,0.8,5.64,0.74,8.48c-0.13,3.8-3.43,5.54-6.95,5.54v2.45h36.94v-2.45
								c-3.05,0-4.76-1.61-6.22-4.28l-0.59-1.18c-1.14-2.29-2.05-4.69-2.72-7.16l-24.66-97.38h-26.93l-23.22,92.09l-1.34,5.15
								c-0.65,2.5-1.56,4.93-2.71,7.25c-1.62,3.41-3.35,5.51-6.85,5.51v2.45H159.82z M160.09,247.48l11.36-46.2l11.46,46.2
								L160.09,247.48z"
                    />
                    <path
                      class="st0"
                      d="M419.71,178.41v2.46c2.99,0,4.34,1.28,4.57,3.99c0,0.11-0.01,0.22-0.01,0.33
								c0.1,5.26-0.79,10.52-1.93,15.68l-12.36,50.84l-1.55,11.6l-1.55-11.6l-12.36-50.84c-1.13-5.16-2.02-10.42-1.93-15.68
								c0-0.11-0.01-0.22-0.01-0.33c0.22-2.72,1.58-3.99,4.57-3.99v-2.46h-35.29v2.46c3.07,0,4.78,1.62,6.25,4.32
								c1.67,3.57,3.04,7.27,4.06,11.09l23.46,94.6l25.35,0l23.46-94.6c1.01-3.81,2.38-7.52,4.06-11.09
								c1.47-2.7,3.18-4.32,6.25-4.32v-2.46H419.71z"
                    />
                    <path
                      class="st0"
                      d="M65.94,288.42c-3.3,0-5.24-2.03-6.04-5.51c-0.72-4.27-1.12-8.6-1.12-12.94l0-54.98l-0.7-7.08l2.83,7.08
								l23.25,61.28c1.66,3.86,6.06,11.28,8.89,14.62h18.35v-91.59c0-4.66,0.43-9.31,1.26-13.89c0.93-2.88,2.8-4.54,5.77-4.54v-2.46
								H85.81v2.46c3.56,0,5.56,2.35,6.22,6.38c0.62,3.98,0.97,8,0.97,12.04l0,45.66l0.71,6.71l-26.24-73.26l-34.37,0v2.46
								c3.13,0,5.05,1.82,5.92,4.99c0.02,0.08,0.04,0.17,0.06,0.25c0.1,0.39,0.19,0.79,0.26,1.21v0c0.7,3.52,1.06,7.57,1.06,14.26
								l0,68.37c0,5.17-0.29,8.74-0.86,12.14c-0.68,3.99-2.67,6.32-6.21,6.32v2.46h12.52h7.56h12.53V288.42z"
                    />
                    <path
                      class="st0"
                      d="M534.77,266.08c-1.27,1.96-3.01,2.94-5.02,3.6c-6.9,1.83-14,2.8-21.16,2.8h-13.46v-30.03
								c0,0,15.62-0.22,21.49,0.47c3.91,0.7,6.19,2.68,6.19,6.18h2.45v-31.71h-2.45c0,3.46-2.23,5.42-6.04,6.15
								c-5.91,0.72-21.64,0.49-21.64,0.49v-28.64h13.46c6.05,0,12.07,0.72,17.96,2.03c2.54,0.67,4.71,1.62,6.25,3.98l2.33-0.79
								l-7.46-22.2h-60.49v2.45c3.03,0,4.88,0.99,5.94,3.87c1.17,3.17,0.79,11.17,0.79,16.66v66.5c0,4.95-0.28,14.92-1.46,17.25
								c-1.07,2.12-2.24,3.28-5.27,3.28v2.45h61.9l8.01-24L534.77,266.08z"
                    />
                    <path
                      class="st0"
                      d="M293.76,178.39c0,0-8.21,0.28-36.82,0.28c-28.61,0-36.85-0.28-36.85-0.28l-2.88,23l2.44,0.29
								c0.42-3.56,3.78-4.83,7.15-5.44l0-0.01c5.91-0.96,12.14-0.85,19.52-0.87l-0.04,72.48c0,10.83-0.72,13.81-1.15,15.39
								c-0.99,3.6-4.18,5.18-7.49,5.18v2.46l38.52-0.01v-2.44c-3.31,0-6.5-1.58-7.49-5.18c-0.44-1.58-1.15-4.55-1.15-15.3v-0.05
								l0.01-72.53c7.35,0.02,13.63-0.08,19.56,0.87v0c3.37,0.61,6.73,1.88,7.14,5.44l2.44-0.29L293.76,178.39z"
                    />
                    <path
                      class="st0"
                      d="M347.5,288.42c-3.31,0-5.14-1.58-6.19-5.4c-1.05-3.82-1.09-10.11-1.09-15.13l0-66.5
								c0-5.02,0.04-11.31,1.09-15.13c1.05-3.82,2.88-5.4,6.19-5.4v-2.46h-35.8v2.46c3.31,0,5.15,1.58,6.19,5.4
								c1.05,3.82,1.09,10.11,1.09,15.13v66.48c0,0,0,11.36-1.08,15.15c-1.08,3.81-2.88,5.4-6.19,5.4v2.46h35.79V288.42z"
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
          <g>
            <g>
              <g>
                <path
                  class="st0"
                  d="M146.14,421.25c-1.98-3.68-4.27-8.61-5.94-14.21l-7.44-27.53c0,0,0,0,0,0
						c4.33-2.17,15.01-11.19,15.01-30.07c0-18.88-10.68-27.9-15.01-30.07c-4.43-2.21-9.26-3.48-14.18-3.73
						c-0.54-0.03-50.07-0.04-50.07-0.04l0,2.46c3.58,0,5.58,2.37,6.24,6.42c0.63,3.95,0.95,8.18,0.95,14.15l0,72.2
						c0,2.38-0.12,5.9-0.49,9.21c-0.53,3.68-3.31,5.81-6.7,5.81v2.46l35.1,0l0-2.46c-3.54,0-5.68-2.29-6.22-6.31
						c-0.32-3.14-0.43-6.43-0.43-8.71l0-27.52h12.16c1.4,0,2.63,0.92,3.03,2.26l9.02,30.26c1.45,4.79,3.52,8.93,5.84,12.47h5.58
						l20.13,0l0-2.46C149.76,425.84,147.78,424.1,146.14,421.25z M119.17,364.4c-2.48,1.24-5.21,1.88-7.98,1.88H96.97l0-33.68h14.22
						c2.77,0,5.5,0.65,7.98,1.88c2.16,1.08,6.11,5.57,6.11,14.96S121.33,363.32,119.17,364.4z"
                />
              </g>
              <path
                class="st0"
                d="M203.12,430.1c25.95,0,40.15-26.18,40.15-58.48c0-32.3-14.21-58.5-40.15-58.5
					c-25.95,0-40.16,26.2-40.16,58.5C162.97,403.93,177.18,430.1,203.12,430.1z M203.09,330.81c11.15-0.02,17.8,18.25,17.8,40.73
					c0,22.48-6.53,40.68-17.68,40.69c-11.15,0.02-17.82-18.21-17.82-40.69C185.4,349.06,191.94,330.83,203.09,330.81z"
              />
              <path
                class="st0"
                d="M297.4,430.1c25.95,0,40.15-26.18,40.15-58.48c0-32.3-14.21-58.5-40.15-58.5
					c-25.95,0-40.16,26.2-40.16,58.5C257.24,403.93,271.46,430.1,297.4,430.1z M297.37,330.81c11.15-0.02,17.8,18.25,17.8,40.73
					c0,22.48-6.53,40.68-17.68,40.69c-11.15,0.02-17.82-18.21-17.82-40.69C279.68,349.06,286.22,330.83,297.37,330.81z"
              />
            </g>
            <path
              class="st0"
              d="M423.38,315.77c0,0-8.23,0.28-36.9,0.28c-28.67,0-36.93-0.28-36.93-0.28l-2.88,23.86l2.44,0.29
				c0.42-3.57,3.79-4.84,7.16-5.45l0-0.01c5.92-0.96,12.16-0.86,19.56-0.87l-0.04,71.83c0,10.86-0.71,13.84-1.15,15.43
				c-0.99,3.6-4.19,5.19-7.5,5.19v2.46l38.6-0.01l0-2.45c-3.31,0-6.51-1.59-7.5-5.19c-0.44-1.59-1.15-4.56-1.15-15.33
				c0-0.02,0-0.03,0-0.05l0.01-71.88c7.36,0.02,13.66-0.08,19.6,0.87l0,0c3.37,0.61,6.74,1.88,7.16,5.45l2.44-0.29L423.38,315.77z"
            />
            <g>
              <path
                class="st0"
                d="M481.53,365.16c-10.47-5.26-21.56-7.14-21.56-19.25c0-7.49,6.34-12.31,15.49-12.31
					c4.89,0,15.82,1.72,19.39,8.86l2.35-0.73l-4.15-25.96h-23.51c-9.64,0.57-18.03,3.56-24.15,10.5
					c-5.61,6.35-7.62,14.78-7.62,22.52c0,7.73,2.33,20.61,20.6,28.64c4.73,2.08,19.65,6.72,19.65,17.83
					c0,6.08-3.86,15.32-16.02,15.32c-13.69,0-19.14-5.04-21.05-8.86l-2.35,0.73l4.15,26.05h26.29c9.05,0,17.54-4.91,22.81-11.4
					c4.48-5.52,8.4-13.92,8.4-23.04C500.25,382.28,493.72,371.29,481.53,365.16z"
              />
            </g>
          </g>
        </g>
      </g>
    </React.Fragment>
  ),
  "industry-logo-5": (
    <React.Fragment>
      <style type="text/css">{styles}</style>
      <g>
        <path
          class="st0"
          d="M793.72,549.91c-4.66,14.49-10.49,28.5-17.32,42.1c-5.53-3.66-12.02-6.09-15.58-12.27
		c0.81-5.8,3.8-10.81,6.02-16.06c10.6-25.11,17.85-51.18,22.51-77.96c2.21-12.69,4.08-25.49,4.33-38.44
		c0.03-1.59-0.01-3.21,1.07-4.56c0.41-0.37,0.87-0.44,1.37-0.2c1.75,2.41,0.76,5.15,0.8,8.04c-0.14,0.29,0.87-0.3,0.25-0.36
		c-0.18-0.01-0.2-0.61,0.03-0.86c4.72-5.16,12.03-6.93,16.63-12.87c1.4,2.81,0.79,5.52,0.51,8.21c-0.71,22.66-3.94,44.95-9.69,66.88
		c-1.48,2.76-2.2,5.76-2.85,8.79c0.01,1.62,0.44,3.33-1.05,4.6c-1.87,7.35-4.1,14.6-6.79,21.69
		C793.53,547.75,793.48,548.8,793.72,549.91z"
        />
        <path
          class="st1"
          d="M44.2,305.26c2.98-12.4,7.85-24.13,12.64-35.89c8.66-21.27,19.43-41.43,31.85-60.73
		c0.86-1.33,1.85-2.57,2.79-3.85c2.55-0.67,4.27,1.12,6.02,2.32c4.28,2.92,9.45,4.71,12.43,9.38c0.04,2.39-1.32,4.21-2.52,6.07
		c-15.41,23.96-27.56,49.5-37.09,76.31c-0.63,1.78-1,3.73-2.72,4.92c-6.58,2.19-13.19,4.27-19.94,5.91
		c-2.4-0.13-2.62-2.16-3.31-3.79C44.3,305.7,44.25,305.48,44.2,305.26z"
        />
        <path
          class="st2"
          d="M164.1,122.27c9.26-8.98,19.7-16.51,30.2-23.91c19.09-13.47,39.29-25.08,60.42-35.05
		c0.69-0.33,1.53-0.35,2.3-0.52c1.67-0.72,3.08-0.59,3.97,1.21c2.66,5.35,6.14,10.38,6.45,16.64c-0.17,2.31-1.96,3.06-3.71,3.89
		c-27.08,12.69-52.16,28.54-75.39,47.37c-1.12,0.91-2.22,1.86-3.84,1.44c-3.13-1.88-5.83-4.36-8.89-6.32
		C172.08,124.73,168.65,122.09,164.1,122.27z"
        />
        <path
          class="st3"
          d="M109.62,216.31c-6.05-3.84-12.09-7.68-18.14-11.52c7.76-13.22,17.25-25.21,27.09-36.87
		c11.7-13.86,23.82-27.38,37.9-38.96c1.25,4.81,3.36,9.42,3.28,14.56c-0.05,3.24,1.57,6.05,2.71,8.98c0.49,2.71-1.62,4.02-3.16,5.52
		c-15.83,15.42-29.9,32.31-42.68,50.32C114.58,211.19,113.61,215.11,109.62,216.31z"
        />
        <path
          class="st4"
          d="M350.06,808.93c-20.98-3.07-41.2-9.1-61.19-15.97c-4.2-1.44-8.28-3.2-12.42-4.81
		c-1.3-5.82-6.72-8.92-9.2-13.96c-0.63-1.27-1.32-2.51-1.86-3.82c-1.96-4.84-1.21-6.19,4.05-7.46c8.58,2.01,16.32,6.25,24.56,9.2
		c23.16,8.28,46.74,14.83,71.15,18.13c1.27,0.17,2.56,0.26,3.42,1.4c-0.27,3.23-3.4,4.99-5.2,6.17c-3.9,2.57-6.58,6.94-11.41,8.23
		C351.82,806.09,352.02,808.72,350.06,808.93z"
        />
        <path
          class="st5"
          d="M522.02,802.18c-16.47,5.22-33.45,7.86-50.5,10.23c-4.89,0.68-9.77,1.52-14.74,1.2
		c-0.72,0.43-1.55,0.53-2.31,0.37c-10.78-2.29-21.68-0.7-32.52-1.05c-4.53-0.15-6.18-1.73-5.67-5.09c0.33-2.19,1.76-3.33,3.72-3.87
		c2.53-0.7,4.66-1.89,6.14-4.25c-2.01-1.53-4.36-0.76-6.44-1.26c-1.38-0.33-3.81,0.26-3.04-2.65c4.51-1.53,9.09-0.88,13.66-0.47
		c3.49,2.56,7.43,0.97,10.21,1.39c1.58-0.33,0.86-1.27,1.06-0.66c0.06,0.19,0.01,0.3-0.17,0.33c-3.02,0.51-6.03,0.8-9.01-0.26
		c0.65-2.26,2.6-2.03,4.26-2.08c3.15-0.1,6.31-0.21,9.46,0.15c3.39,0.64,6.72,1.79,10.25,1.56c0.65-0.11-0.34-0.81,0-0.27
		c-1.34,0.39-2.67,0.68-3.85-0.41c0.52-1.75,2.02-1.87,3.43-1.95c14.7-0.8,29.06-3.95,43.54-6.29c1.46-0.03,2.75,0.6,4.05,1.15
		c0.16,0.07,0.4,0.24,0.61,0.03c-0.51-0.12-0.76-0.46-0.79-0.98c3.71-3.21,8.67-2.68,12.92-4.28c1.6-0.6,3.4-0.83,5.14-1.05
		c1.85-0.16,3.62,0.09,5.24,1.07c1.68,1.33,4.13,2.06,3.86,4.92c-2.23,1.74-4.86,0.98-7.34,1.08c-1.99,0.08-3.04,0.62-2.46,2.84
		c0.28,1.08,0.4,2.27-0.02,3.29c-0.87,2.16-1.67,3.98,1.58,4.98C523.7,800.34,521.79,801.35,522.02,802.18z"
        />
        <path
          class="st0"
          d="M669.55,727.14c-24.33,20.27-50.83,37.09-79.63,50.28c-0.99-1.35-0.14-3.37-2.37-4.52
		c-1.8-0.93-3.3-3.46-1.92-5.74c1.5-2.47,3.68-0.44,5.54-0.07c1.74,0.35,3.3,1.12,4.39,2.72c0.12,0.54,0.54-0.79,0.09-0.33
		c-1.46-1.67-0.41-2.83,0.79-3.98c0.45-0.43,0.94-0.83,1-1.65c-1.12-0.91-2.6-1.43-3.5-2.84c-1.15-1.81-2.13-3.35,0.69-4.37
		c1.45-0.53,1.57-1.35,0.74-2.51c0.3-2.71,2.69-3.35,4.54-4.39c7.06-3.96,14.24-7.71,20.91-12.32c1.33-0.79,2.62-1.64,3.95-2.43
		c2.01-0.91,3.64-2.37,5.34-3.73c9.96-6.08,18.94-13.49,28.13-20.62c1.47-1.14,2.77-2.79,5.03-2.06
		C666.86,714.26,670.4,719.96,669.55,727.14z"
        />
        <path
          class="st6"
          d="M755.01,630.49c-8.4,14.71-18.66,28.11-29.35,41.17c-6.54,8-13.14,15.99-20.82,22.98
		c-2.97,1.72-5.91,0.35-8.78-0.26c-2.64-0.56-5.25-1.23-7.92-1.63c-1.65-0.47-3.41-0.6-4.97-1.41c-1.46-2.33,0.59-3.5,1.79-4.71
		c12.81-12.91,24.6-26.68,35.58-41.18c4.14-5.47,7.91-11.18,11.9-16.74c1.19-1.65,2-3.69,4.24-4.32c2.34,0.99,1.19,2.62,0.58,3.96
		c-1.04,2.31-1.98,4.68-3.63,6.99c2.95,0.21,6.17-1.51,8.34,0.69c2.18,2.22,0.05,5.52,1.64,8.91c-1.17-5.56,1.39-8.24,5.63-10.21
		C751.33,633.76,751.1,629.31,755.01,630.49z"
        />
        <path
          class="st7"
          d="M174.73,729.05c-14.57-11.19-28.11-23.5-40.29-37.28c0.01-3.92,2.43-6.69,5.76-6.97
		c4.74-0.41,7.53-2.5,9.37-6.53c2.15-0.38,3.11,1.37,4.25,2.56c15.48,16.1,32.37,30.57,50.43,43.69c1.84,1.33,4.35,2.28,4.47,5.18
		c-1.07,2.63-3.3,3.62-5.77,3.09C193.63,730.8,183.94,731.75,174.73,729.05z"
        />
        <path
          class="st8"
          d="M483.72,32.09c0.25-0.22,0.47-0.19,0.66,0.09c0.47,0.65,1.69,0.3,1.84,1.25c0.17,1.06-0.77,1.25-1.5,1.44
		c-1.56,0.4-3.13-0.33-5.56-0.06c2.22,2.24,4.34,2.01,6.29,1.44c6.12-1.77,12.23-1.41,18.37-0.32c10.17,1.49,20.07,4.04,29.71,7.61
		c0.96,1.55,2.33,2.32,4.17,2.44c2.84,0.19,4.38,1.15,2.24,4.13c-0.75,1.05-0.92,2.35-1.22,3.59c-1.6,6.49-1.6,6.49-7.69,4.7
		c1.78,4.16,1.25,4.92-3.51,4.84c-1.27-0.02-2.54-0.04-3.82-0.08c-9.59-1.73-18.89-4.68-28.47-6.42
		c-6.44-1.17-12.85-2.45-19.33-3.38c-2.42-0.35-5.21-0.03-7.02-2.36c2.19-2.81,3.97-5.98,8.04-6.71c2.28-0.41,1.85-1.95,0.28-2.9
		c-2.02-1.23-3.16-2.99-4.08-5.07c-1.48-3.34-0.67-4.95,3.09-4.95C478.69,31.37,481.24,31.54,483.72,32.09z"
        />
        <path
          class="st9"
          d="M270.72,56.52c6.54-2.56,12.75-6.06,19.83-7.13c9.47-2.96,18.98-5.76,28.44-8.75
		c3.56-1.13,7.39-1.66,11.09-2.48c3.52-0.78,6.43,1.96,9.74,2.77c1.69,0.41,0.93,2.48-0.53,3.29c-3.99,2.2-4.7,5.66-3.93,9.72
		c0.36,1.87,0.24,3.57-1.63,4.54c-1.82,0.94-3.36,0.34-4.62-1.21c-0.92-1.13-2.04-2.09-3.55-2.21c-1.36-0.1-3.21,0.56-2.5,1.9
		c1.76,3.31-0.89,4.14-2.48,5.69c-6.69,3.46-14.11,4.82-21.13,7.35c-3.55,1.28-6.94,3.29-10.9,3.23
		C282.27,68.03,275.65,63.18,270.72,56.52z"
        />
        <path
          class="st10"
          d="M595.3,753.96c1.4,0.25,2.79,0.53,3.87,2.26c-1.93,0.68-3.76,1.33-6.95,2.45c3.47-0.1,2.35,4.88,6.46,2.94
		c0.7-0.33,1.13,3.54-0.3,4.16c-5.18,2.27-1.36,3.48,1.23,5.25c-4.25,0.39-6.29-3.04-9.51-2.98c-1.27,0.02-2.56-2.15-3.75-0.51
		c-1.22,1.68,1.04,2.7,1.46,4.11c0.66,2.18,2.66,1.24,4.03,1.91c0.21,1.72-2.57,1.97-1.93,3.85c-10.54,5.47-21.45,10.08-32.74,13.77
		c-10.47-1.3-20.9-2.8-30.6-7.33c-1.4-0.96-2.99-1.08-4.62-0.99c-0.26-2.53,1.71-1.71,2.96-1.99c2.63,1,4.71-0.02,6.6-1.79
		c8.53-3.82,17.61-6.13,26.25-9.65c1.32-0.54,2.63-1.1,3.96-1.61c6.7-2.44,13.07-5.64,19.55-8.56c2.4-1.4,5.18-2.02,7.51-3.57
		c0.35-0.25,0.71-0.47,1.08-0.69C591.61,754.29,593.23,752.98,595.3,753.96z"
        />
        <path
          class="st6"
          d="M814.29,398.22c1.07,8.39,1.02,16.81,0.65,25.23c-0.85,3.06,0.31,6.31-0.68,9.29
		c-0.97,0.19-1.54-0.23-1.65-0.84c-0.71-4-3.68-4.79-7.04-5.08c-8.36-0.74-7.19-1.78-7.31,6.25c-0.03,1.91,0.13,3.84-0.11,5.74
		c-0.18,1.47,0.14,3.36-2.08,3.74l-0.29-0.12c-1.86-2.37-1.3-5.19-1.26-7.83c0.39-24.55-0.85-48.97-4.82-73.24
		c-1.16-7.06-3.29-13.95-3.64-21.14c0.19-1.23,0.21-2.85,1.7-3.03c1.38-0.16,1.99,1.34,2.6,2.41c1.25,2.21,2.35,4.52,2.59,7.07
		c0.2,2.13,0.97,3.95,2.2,5.65c6.55,12.8,11.7,26.22,17.57,39.33c1.17,2.61,0.95,5.3,0.96,8c0.02,4.7,0.03,9.39,0,13.43
		C814.18,408.57,812.93,403.34,814.29,398.22z"
        />
        <path
          class="st11"
          d="M47.77,549.12c-3.59-10.72-7.18-21.44-9.26-32.58c-2.15-7.42,0.51-14.86-0.05-22.29
		c-0.07-0.94,0.18-2.24,0.91-2.64c4.01-2.17,4.02-7.48,7.78-9.74c0.99-0.59,0.53-1.35,0.57-2.02c0.09-1.61-0.43-3.15-0.89-4.68
		c-0.52-1.75-0.77-3.46,0.91-4.81c1.77-1.43,2.73,0.72,4.13,0.91c1.92,1.68,1.51,4.09,1.83,6.21c1.96,12.85,4.61,25.55,7.83,38.14
		c0.55,2.14,1.06,4.31,0.99,6.55c-0.7,2.35,0.36,4.71,0.01,7.05c-0.47,3.13-1.67,3.81-4.72,2.32c0.85,5.09,0.19,9.4-4.98,11.75
		c-1.13,0.51-1.26,2.12-1.86,3.23C50.29,547.77,50.05,549.75,47.77,549.12z"
        />
        <path
          class="st12"
          d="M174.73,729.05c3.81-2.52,7.5,0.5,11.26,0.58c5.22,0.11,10.75-0.01,15.87,1.74c2.91,1,4.88,0.12,6.44-2.28
		c2.36-0.68,3.88,1,5.53,2.09c7.63,5.09,15.32,10.08,23.25,14.7c0.33,0.32,0.61,0.68,0.82,1.09c0.83,3.01,0.42,5.39-2.49,7.38
		c-3.47,2.38-6.87,5.16-3.11,10.05c0.63,0.82-0.04,1.82-1.09,2.25c-14.63-7.06-27.92-16.3-41.12-25.64
		C184.79,737.28,179.84,733.06,174.73,729.05z"
        />
        <path
          class="st13"
          d="M483.72,32.09c-3.57,0.42-7.33-0.64-10.78,1.36c0.09,1.11,1.94,0.87,1.79,2.23c-0.29,2.7,1.14,4.01,3.66,4.63
		c1.54,0.38,2.26,1.54,2.13,3.24c-0.16,2.08-1.61,1.94-3.06,2.08c-2.35,0.24-4.81,0.36-5.27,3.54c-0.33,2.27-2.37,0.73-3.44,1.39
		c-1.41,1.28-3.23,1.48-4.87,1.17c-4.99-0.95-10.34,0.33-15.02-2.42c-0.01-0.53-0.27-1.26,0.77-0.98c-0.27-0.75-0.71-0.15-1.03-0.09
		c-5.15,1.02-10.25,0.87-15.33-0.41c-0.49-0.08-0.97-0.22-1.44-0.4c-3.37-2.56-8.24-3.06-10.26-7.49c0.09-0.85,0.49-1.56,1.2-1.96
		c6.63-3.74,12.84-8.34,20.38-10.27C456.81,27.91,470.33,29.37,483.72,32.09z"
        />
        <path
          class="st14"
          d="M524.49,61.99c2.29-0.53,4.72,1.19,6.98-0.48c-0.58-1.54-4.23-1.54-2.44-4.12c1.67-2.41,3.25-0.61,4.72,0.65
		c1.59,1.36,2.68,0.65,3.21-1.05c0.94-3-0.15-6.61,3.08-9c0.63-0.46-1.02-1.62-1.82-1.22c-3.68,1.85-3.83-1.16-4.7-3.22
		c11.72,3.08,23.2,6.85,34.36,11.57c2.88,1.22,5.68,2.63,8.52,3.95c1.14,1.26,1.49,2.82,1.38,4.42c-0.41,5.78,1.15,11.63-0.53,17.37
		c-1.8,1.65-3.59,0.62-5.32-0.11c-14.39-6.08-28.93-11.74-43.97-16.02C526.51,64.3,524.72,64.07,524.49,61.99z"
        />
        <path
          class="st15"
          d="M119.09,674.54c-1.21-0.68-2.19-1.58-2.61-2.96c0.17-1.63-1.22-2.04-2.18-2.79c-1.21-0.64-1.9-1.72-2.46-2.91
		c0.51-0.53,1.1-0.98,1.55-1.56c0.49-0.42-0.26-0.52-0.28-0.28c-0.11,0.98-0.78,1.46-1.82,0.97c-1.78-1.19-2.88-2.92-3.71-4.84
		c1.42-2.79,4.74-2.28,6.89-4.08c0.22-0.61-0.54-0.87-0.8-1.36c-0.82-1.52-1.5-3.57-3.6-3.33c-2.26,0.26-1.99,2.54-2.41,4.16
		c-0.29,1.11-0.63,2.16-1.9,2.51c-7.83-9.94-14.99-20.33-21.19-31.37c-0.36-0.53-0.67-1.11-0.75-1.73
		c-0.23-1.76-3.43-3.25-0.65-5.27c2.97-2.15,7.2-1.89,8.72,0.91c2.04,3.76,4.65,4.78,8.48,3.2c5.01-1.11,7.14,3.7,10.86,5.26
		c3.16,1.86,4.42,5.25,6.36,8.05c3.03,4.38,6.71,8.35,8.75,13.37c2.39,6.88-0.78,12.67-4.2,18.05
		C120.88,670.52,121.37,673.25,119.09,674.54z"
        />
        <path
          class="st16"
          d="M416.31,796.2c3.36,2.35,7.53-0.02,11,1.89c0.77,0.43,2.04,0.17,2.17,1.4c0.13,1.28-1.08,1.19-1.87,1.65
		c-2.79,1.62-4.86,4.34-8.59,4.51c-1.92,0.09-1.8,2.28-1.7,3.9c0.12,2.05,1.61,2.06,3.09,2.06c5.57,0.01,11.13,0.01,16.7,0
		c1.26,0,2.59,0.15,3.16-1.46c0.33-0.93,0.93-1.17,1.79-0.51c4.36,3.34,9.65,3.26,14.72,3.96c-14.34,2.29-28.79,1.82-43.22,1.77
		c-10.96-0.04-21.91-0.46-32.77-2.04c-0.14-0.07-0.42-0.18-0.41-0.2c2.23-7.16-2.45-13.02-3.64-19.54c0.25-0.46,0.62-0.78,1.11-0.99
		c4.63,0.45,9.53-0.79,13.73,2.22c-0.94,0.58-0.94,0.58-2.08,0.76c3.7-0.62,7.5-0.33,11.17-1.33
		C406,793.95,411.38,793.3,416.31,796.2z"
        />
        <path
          class="st17"
          d="M231.21,766.66c0.6-1.05,0.7-2.04-0.29-2.96c-3.93-3.63-1.13-5.78,1.53-8.41c2.14-2.12,6.08-3.52,4.58-7.87
		c1.03-0.96,2.07-0.52,3.06,0.02c8.65,4.67,17.27,9.41,26.29,13.36c1.13,0.49,2.35,1.1,2.36,2.67c-3.52,1.58-3.56,3.63-2.03,7.11
		c1.96,4.44,5.57,7.39,8.11,11.2c1.1,1.65,3.37,3.71,1.63,6.38C260.82,782.13,245.54,775.39,231.21,766.66z"
        />
        <path
          class="st18"
          d="M630.14,87c8.71,5.1,17.15,10.59,24.9,17.08c1.4,2.72,4.02,4.1,6.44,5.6c1.4,0.86,2.52,1.94,3.59,3.09
		c1,1.08,0.74,2.11-0.77,2.43c-1.72,0.37-3.35,1.19-5.1,1.27c-4.05,0.18-8.22-0.31-11.46,2.62c2.2,1.08,6.08-1.5,7.29,2.13
		c0.7,2.11-1.47,3.64-3.64,4.29c-0.44,0.07-0.87,0.03-1.3-0.11c-1.35-1.05-2.79-1.95-4.48-2.38c-10.26-6.72-20.47-13.51-30.64-20.37
		c-0.39-0.26-0.56-0.76-0.7-1.23c0.37-3.45,3.22-4.96,5.51-6.83C623.11,91.9,626.08,88.7,630.14,87z"
        />
        <path
          class="st19"
          d="M711.61,154.89c3.03,2.41,5.4,5.42,7.63,8.55c4.25,7.29,9.59,13.84,14.23,20.87
		c4.03,6.11,8.18,12.16,12.2,18.28c0.82,1.24,2.18,2.48,1.18,4.29c-1.86,1.18-3.33-0.05-4.87-0.79c-6.31-3.04-13.05-5.13-19.13-8.66
		c-0.84-0.49-1.81-0.59-2.75-0.75c-5.05-3.72-8.02-9.27-11.99-13.93c-1.7-2-4.02-3.68-4.61-6.5c-1.52-6.62,1.1-12.02,6.1-15.72
		C712.11,158.64,708.93,155.92,711.61,154.89z"
        />
        <path
          class="st20"
          d="M754.16,210.38c12.38,18.65,22.3,38.58,31.01,59.15c0.29,0.69,0.23,1.54,0.33,2.31
		c-0.88,1.48-2.17,1.52-3.12,0.37c-2.17-2.65-5.05-3.04-8.14-3.14c-2.21-0.07-3.65-1.8-5.58-2.94c-1.03,1.24-0.01,3.33-1.78,4.06
		c-1.67-0.37-2.18-1.74-2.58-3.13c-4.5-15.73-9.76-31.24-13.84-47.09c-1.01-3.94-3.64-7.5-3-11.86c1.3-1.64,2.71-0.63,4.1-0.18
		C752.64,208.54,752.96,209.92,754.16,210.38z"
        />
        <path
          class="st21"
          d="M51.15,471.08c-2.66-0.22-5.03-0.32-3.22,3.62c1.45,3.15,2.9,6.42-1.61,8.66c-1.22,0.6-1.05,2.22-1.03,3.51
		c0.02,1.76-0.43,3.25-2.43,3.52c-2.71,0.36-3.55,2.35-3.23,4.46c1.1,7.34-1.9,14.42-1.11,21.7c-6.5-23.22-9.86-46.92-11.03-70.97
		c3.17,1.46,5.97,3.38,7.91,6.38c0.97,1.5,2.32,2.56,3.97,3.24c1.79,0.73,3.59,1.74,4.39,3.45c1.48,3.16,4,4.55,7.18,5.2
		C52.57,466.2,52.86,468.61,51.15,471.08z"
        />
        <path
          class="st22"
          d="M65.22,591.19c-3.51-6.09-6.27-12.51-8.47-19.19c0.75-10.79,4.68-20.77,7.81-30.95
		c0.24-0.77,0.81-1.37,1.5-1.81c2.2-0.35,2.69,1.39,3.14,2.82c3.97,12.57,9.46,24.53,14.63,36.62c0.79,1.85,1.95,3.71,1.14,5.9
		c-3.51,3.86-8.75,2.84-13.05,4.54C69.8,589.98,67.44,590.44,65.22,591.19z"
        />
        <path
          class="st23"
          d="M767.18,269.97c0-1.84,0-3.68,0-6.47c3.87,3.53,7.91,5.12,12.64,4.86c1.19-0.07,2.12,1.31,2.64,2.51
		c0.67,1.51,1.68,1.72,3.04,0.99c0.32,0.58,0.64,1.17,0.96,1.75c0.56,0.59-0.62,1.86,0.82,2.11c3.05,6.85,6.1,13.7,7.77,21.05
		c0.22,3.57-0.99,5.87-5.02,5.75c-0.79-0.02-2.07,0.14-2.12,0.73c-0.56,5.78-5.63,2.17-8.1,3.95c-1.06,0.76-1.66-0.4-1.96-1.32
		c-0.44-1.33-0.48-2.83-1.86-3.69c-3.31-4.95-4.64-10.67-6.4-16.23c-0.02-0.95,0.31-1.81,0.64-2.67c1.37-2.57,1.38-4.76-1.69-6.12
		c-0.51-0.51-0.93-1.07-1.29-1.69C766.4,273.65,765.57,271.82,767.18,269.97z"
        />
        <path
          class="st24"
          d="M675.45,120.24c8.98,6.84,17.13,14.56,24.77,22.84c0.86,2.99-2.45,2.2-3.3,3.53c0.06,1.18,0.9,1.73,1.54,2.4
		c2.09,2.2,1.87,3.58-0.23,6.26c-2.83,3.6-5.1,3.92-8.78,2.01c-1.47-0.76-3.21-1.34-4.97-1.46c-1.49-0.16-2.71-0.89-3.74-1.92
		c-4.82-4.81-9.7-9.56-14.91-13.96c-1.26-1.07-2.78-2.26-2.32-4.36c0.98-1.07,2.16-2.02,3.52-2.34c3.26-0.78,6.03-1.52,5.82-5.95
		c-0.12-2.54,2.69-1.02,4.09-1.72C672.79,123.43,672.53,122.45,675.45,120.24z"
        />
        <path
          class="st25"
          d="M119.09,674.54c-0.22-4.97,3.25-8.45,5.37-12.36c1.19-2.18,1.1-4.16,1.4-6.3c0.24-1.73-1.1-3.41-0.05-5.12
		c1.88-0.81,2.53,0.8,3.35,1.82c5.98,7.47,12.05,14.86,18.67,21.78c1.11,1.16,2.12,2.42,1.95,4.2c-0.83,4.97-3,7.59-8.79,6.99
		c-3.45-0.36-4.73,3.71-6.55,6.23C128.67,686.61,123.62,680.8,119.09,674.54z"
        />
        <path
          class="st20"
          d="M682.51,690.68c1.68,0.46,3.68-0.52,5.11,1.1c1.86,0.35,1.92,2.17,2.81,3.33c2.02,2.61,4.22,5.09,6.76,7.23
		c-8.46,9.11-17.77,17.28-27.65,24.81c-1.4-6.39-3.84-12.39-6.85-18.17c-0.47-1.27,0.25-2.2,1.08-2.89
		c5.57-4.61,10.8-9.6,16.18-14.43C680.64,691.03,681.48,690.55,682.51,690.68z"
        />
        <path
          class="st26"
          d="M814.29,398.22c0,5.72,0,11.45,0,17.17c-0.36,0.01-0.72,0.02-1.07,0.03c0-3.45-0.49-6.98,0.1-10.33
		c1.6-9.09-3.5-16.24-6.56-23.91c-3.88-9.74-8.45-19.21-12.72-28.8c-1.28-3.82,1-6.72,2.74-9.63c1.24-2.08,2.59-3.94,2.14-6.57
		c-0.21-1.24-0.09-2.66,1.37-3.24c1.56-0.62,2.14,0.89,3.1,1.69c0.18,0.54,0.68-0.48,0.21-0.04c-0.18,0.17-0.26,0.06-0.38-0.29
		c-0.6-1.69-1.15-3.35,1.36-3.96c2.15,7.85,3.91,15.79,5.14,23.84c1.46,9.56,3.37,19.06,3.56,28.78c1.09,3.15-0.27,6.49,0.76,9.65
		C814.59,394.46,814.69,396.33,814.29,398.22z"
        />
        <path
          class="st27"
          d="M50.12,463.63c-2.69,1.28-4.82,1.2-5.87-2.16c-0.26-0.84-0.82-1.88-1.55-2.25
		c-5.17-2.64-8.08-8.14-13.39-10.53c-1.47-0.66-0.94-2.26-1.84-3.12c-1-18.61-1.2-37.21,0.5-55.8c0.56-0.31,1.04-0.21,1.44,0.28
		c1.08,1.77,0.69,3.68,0.53,5.59c-1.06,12.41-0.31,24.83-0.41,37.75c3.47-2.74,6.99-1.87,10.38-1.88c5.32-0.02,5.61-0.44,5.91-5.64
		c0.25-4.38-1.13-8.94,1.26-13.14c0.62-0.25,1.13-0.11,1.55,0.41c0.91,1.41,1.01,3.02,0.99,4.61c-0.18,13.37,0.71,26.7,1.81,40.01
		C51.61,459.81,51.74,461.94,50.12,463.63z"
        />
        <path
          class="st20"
          d="M761.25,580.5c4.77,4.2,11.05,6.42,15.15,11.51c-0.95,2.37-1.72,4.84-3.42,6.83
		c-2.13,3.25-4.92,5.78-8.24,7.81c-7.74,4.75-14.87,10.4-22.29,15.63c-1.4,0.98-2.89,3.04-4.67,0.39c-0.36-1.9,0.63-3.37,1.55-4.85
		c6.63-10.63,12.68-21.58,18.15-32.86C758.33,583.22,758.71,580.89,761.25,580.5z"
        />
        <path
          class="st6"
          d="M738.25,622.5c1.14,1.37,1.98,0.21,2.78-0.41c7.84-5.97,15.77-11.79,24.08-17.1c2.79-1.78,5.25-4.08,7.86-6.15
		c-5.23,10.99-11.02,21.65-17.97,31.65c-1.2,0.41-2.67,0.67-3,2.08c-0.66,2.81-2.34,4.07-5.09,4.79c-1.83,0.48-3.33,2.12-2.28,4.48
		c1.15,2.57-0.88,3.16-2.14,4.41c-1.85-1.73-0.55-3.56-0.87-5.21c-1-5.2-2-6.04-7.18-4.11c-0.84,0.31-1.68,1.39-2.41,0.2
		c-0.62-1-0.26-2.11,0.54-3.08c2.24-2.74,4.19-5.63,4.21-9.37C735.97,623.08,737.04,622.74,738.25,622.5z"
        />
        <path
          class="st28"
          d="M630.14,87c-2.37,3.63-6.41,5.37-9.46,8.26c-2.05,1.94-4.38,3.57-5.95,5.97c-1.34,0.62-2.52,0.02-3.61-0.6
		c-6.8-3.8-13.56-7.68-20.49-11.23c-0.98-0.5-1.96-1.12-1.97-2.46c2.62-2.56,5.01-0.11,7.7,0.24c-2.54-0.76-4.7-2.21-1.92-4.41
		c4-3.15,7.09-7.47,11.96-9.51C614.65,77.27,622.58,81.82,630.14,87z"
        />
        <path
          class="st29"
          d="M65.22,591.19c2.74-4.78,8.16-2.84,12.13-4.64c2.26-1.03,5.13-1.25,7.61-2.24
		c4.79,5.63,8.83,11.64,9.42,19.32c-1.07,0.6-2.43,0.95-1.28,2.74c1.71,2.66,0.9,5.08-0.89,7.46c-2.06,2.73-4.33,0.69-6.52,0.53
		c-4.01-0.13-6.67-3.91-10.7-4C71.24,604.21,67.9,597.87,65.22,591.19z"
        />
        <path
          class="st30"
          d="M606.4,73.28c-3.58,4.42-8.25,7.7-12.45,11.29c0.92,1.94,2.14,0.65,3.04,0.91c1.28,0.37,2.47,1.29,2,2.73
		c-0.53,1.61-1.8,1.51-3.01,0.48c-2.09-1.78-4.56-2.05-7.16-1.83c-5.09,0.08-9.29-1.73-12.4-5.84c-0.01-7.32-0.01-14.64-0.02-21.96
		C586.95,62.64,596.76,67.78,606.4,73.28z"
        />
        <path
          class="st31"
          d="M162.13,152.98c-2.95-1.7-3.26-5.02-3.48-7.61c-0.36-4.1-0.53-8.14-2.4-11.85c-0.85-1.69,0.26-3.04,0.23-4.56
		c2.16-2.67,4.67-4.93,7.63-6.69c4.32-2.43,7.12,0.84,10.29,2.75c3.69,2.23,7.55,4.25,9.98,8.04c-0.22,3.84-3.95,4.65-6.04,6.85
		c-3.93,4.14-8.7,7.38-12.59,11.59C164.86,152.46,163.87,153.79,162.13,152.98z"
        />
        <path
          class="st31"
          d="M320.44,61.87c0.24-1.5,4.75-2.09,0.72-4.71c-1.21-0.79,2.47-4.43,4.7-3.74c1.8,0.56,3.91,1.43,4.52,3.18
		c0.69,1.98,1.78,1.58,2.88,1.14c1.37-0.55,2.09-2.05,1.13-3.12c-3.19-3.57,1.47-6.39,0.73-9.78c-0.27-1.25,1.64-1.04,2.7-1.17
		c0.97-0.12,2.13-0.31,2.05-1.49c-0.07-1.13-1.26-1.51-2.21-1.28c-2.06,0.49-4.06,1.43-4.94-1.72c-0.1-0.34-2.17-0.47-3.16-0.16
		c-7.77,2.41-15.82,3.73-23.56,6.39c-4.96,1.71-9.94,4.11-15.45,3.97c5.34-3.39,11.59-4.24,17.46-6.11
		c7.56-2.41,15.19-4.63,23.01-6.1c4.36,0.08,8.79-0.95,13.06,0.73c3.19,0.92,6.5,1.37,9.69,2.3c4.19,1.22,6.06,3.66,6.24,8.34
		c0.14,3.64-2.32,4.85-5.3,5.57c-0.61,0.15-1.04,0.71-1.57,1.05c-9.86,3.17-20.05,5.03-30.09,7.5
		C322.12,62.9,321.15,62.65,320.44,61.87z"
        />
        <path
          class="st32"
          d="M344.4,38.89c-4.39-1.08-9.04-0.22-13.38-1.71c14.54-3.66,29.3-5.95,44.18-7.76
		c11.74-1.42,23.49-2.1,35.29-2.25c1.18,2.19-0.42,2.83-1.86,2.44c-3.9-1.05-7.9-0.56-11.95-0.93c3.06,0.6,6.19-0.41,9.14,0.64
		c-0.46,2.1-2.12,1.95-3.43,2.26c-1.3,0.32-2.32,0.82-2.93,2.13c-2.15,4.63-6.42,5.64-10.76,5.19c-2.85-0.3-5.28,0.07-7.79,1.1
		C368.69,40.72,356.51,41.01,344.4,38.89z"
        />
        <path
          class="st33"
          d="M675.45,120.24c-1.06,3.11-1.09,3.3,0.53,3.57c1.52,0.26,3.57,0.21,2.88,2.27c-0.7,2.11-2.58,1.83-4.19,0.48
		c-0.14-0.12-0.56,0.08-1.11,0.19c1.29,4.42-0.16,6.98-5.04,7.13c-1.91,0.06-3.04,2.37-5.18,2c-4.99-0.1-6.96-4.93-10.78-6.91
		c-1.34-0.69-2.73-1.75-2.42-3.7c1.73-1.01,3.96-1.51,4.17-4.63c-3.15-0.85-7.87,1.1-9.52-4.67c2.57,1.72,4.28,2.11,5.58-0.98
		c0.58-1.38,2.38,0.96,4.16,0.83c3.49-0.25,6.74-1.65,10.3-1.84c-1.62-0.41-1.03-6.03-4.67-1.76c-0.07,0.08-0.29,0.04-0.44,0.06
		c1.29-4.36-5.47-4.13-4.68-8.2C662.21,109.01,669.25,114.1,675.45,120.24z"
        />
        <path
          class="st20"
          d="M376.98,794.35c3.73,3.16,2.84,8.32,5.2,12.12c0.68,1.1-0.53,5.24-1.39,6.86
		c-10.36-0.66-20.63-1.93-30.73-4.4c0.8-1.69,0.8-1.69-2.9-4.11c8.28,1.7,10.43-6.67,16.5-7.9c-1.97-5.2,3.76-2.46,4.75-4.61
		c1.61-1.28,3.19-1.19,4.74,0.07c1.56-0.54-2.15,2.59,0.84,1.19C375.02,793.1,376.13,793.5,376.98,794.35z"
        />
        <path
          class="st34"
          d="M776.65,301.62c3.34,0.28,1.29,3.31,2.4,4.74c2.16-3.22,5.1,0.27,7.44-0.72c0.53-1.64-2.48-1.16-1.43-2.41
		c0.93-1.11,2.99-2.5,3.94-2.14c4.52,1.68,4.78-1.9,6.05-4.33c2.55,5.88,4.26,12.02,5.6,18.27c-0.12,7.2-4.32,10.8-12.04,9.94
		c-2.56-0.28-2.13,3.69-4.76,2.79c-1.66-1.04-1.83-2.87-2.33-4.49c-1.62-5.26-3.02-10.58-4.77-15.8
		C776.14,305.61,775.22,303.6,776.65,301.62z"
        />
        <path
          class="st35"
          d="M66.49,539.11c-2.92,9.64-6.68,19.06-7.79,29.18c-0.17,1.56-1.41,2.42-1.95,3.72
		c-3.81-7.31-6.3-15.13-8.98-22.88c2.98-1.39,1.6-5.84,4.31-6.89c5.23-2.04,4.9-6.1,4.74-10.35c-0.03-0.77,0.06-1.64,0.41-2.3
		c0.4-0.75,1.39-0.97,2.1-0.6c1.66,0.86-1.34,2.16,0.4,3.3c1.98-1.56,2.16-3.61,1.54-5.83c-0.34-1.23-1.09-2.41,0.38-3.39
		C65.19,527.83,67.53,532.96,66.49,539.11z"
        />
        <path
          class="st36"
          d="M270.72,56.52c5.97,5.14,12.48,9.73,17.22,16.18c-0.02,1.11-0.77,1.74-1.63,2.13
		c-5.46,2.51-11.13,4.5-16.66,6.84c-0.89,0.38-1.86,0.31-2.73-0.24c-1.48-5.82-4.06-11.17-6.75-16.52c-0.84-1.67-1.71-2-3.15-2.14
		C261.32,60.1,266,58.27,270.72,56.52z"
        />
        <path
          class="st37"
          d="M684.38,155.08c3.37,0.76,7.19,0.17,10.2,3.3c0.85-1.96,0.97-4.33,4.13-5.13c2.14-0.55-0.31-2.7-1.18-3.56
		c-0.98-0.97-2.49-1.34-2.25-3.18c0.17-1.29-0.52-3.31,2.14-1.73c1.55,0.92,2.21-0.54,2.8-1.7c4.17,3.58,7.98,7.5,11.38,11.81
		c1.05,2.99,1.12,4.89-2.3,7.24c-4.32,2.97-5.54,8.43-5.26,13.84c-0.19-0.09-0.38-0.18-0.57-0.27c-1-1.03-1.77-2.31-3.2-2.86
		C694.22,167.6,688.15,162.37,684.38,155.08z"
        />
        <path
          class="st38"
          d="M796.08,442.55c1.83-4.29,0.43-8.78,0.83-13.16c0.16-1.71,0.03-3.45,0.03-5.81c3.74,2.49,7.53,1.55,11.09,2.2
		c3.78,0.7,6.65,1.24,5.21,6.43c1.79-3.03-0.11-6.2,1.71-8.76c0.28,7.1,0.37,14.19-0.61,21.24c0-2.22,0-4.44,0-6.8
		c-5.08,6.08-12.87,7.93-18.25,13.81C796.08,448.23,796.08,445.39,796.08,442.55z"
        />
        <path
          class="st10"
          d="M804.57,330.35c-1.72,1.29-0.42,3.35-1.25,4.88c-1.13-0.11-1.39-2.13-2.67-1.48
		c-1.53,0.78-0.76,2.2-0.35,3.34c0.66,1.83,0.43,3.22-1.11,4.66c-3.04,2.84-3.87,6.88-5.15,10.64c-3.54-2.59-1.49-7.18-3.68-10.28
		c-0.82-1.15-1.09-2.75-2.03-3.75c-1.17-1.26-0.81,0.46-1.14,0.86c-3.16-1.61-3-4.36-2.5-7.23c4.99-5.07,10.81-8.98,17.12-12.22
		C802.09,323.47,804.9,326.5,804.57,330.35z"
        />
        <path
          class="st39"
          d="M381.79,38.93c1.73-1.42,2.88-3.23,5.92-1.37c3.2,1.96,9.46-1.55,10.39-5.2c1.04-4.07,4.84-0.73,6.99-3.02
		c-3.47,0-6.59,0-9.72,0c0-0.3,0-0.61,0-0.91c4.29,0,8.59-0.07,12.88,0.04c1.17,0.03,2.27,0.53,2.22-1.3
		c8.61-1.08,17.22-0.87,25.82,0.06c-1.09,1.49-2.74,1.45-4.29,1.46c-5.99,0.03-11.99,0.23-18.11-0.15c1.56,2.65,3.61,4.95,5.15,7.56
		c0.79,1.34,2.41,2.84,0.35,4.51c-6.89,1.57-13.87,0.48-20.8,0.74c-3.63,0.14-7.28,0.12-10.92-0.05
		C385.47,41.2,383.21,41.07,381.79,38.93z"
        />
        <path
          class="st30"
          d="M420.17,39.82c-2.37-4.09-5.96-7.35-8.36-12.59c8.5,0,16.51,0,24.51,0c2.27,0.16,4.55,0.32,6.83,0.48
		c-7.03,4.06-14.07,8.12-21.11,12.18c-0.24,0.31-0.56,0.47-0.95,0.5C420.71,40.32,420.4,40.13,420.17,39.82z"
        />
        <path
          class="st40"
          d="M526.58,783.85c7.41,1.64,14.9,2.98,22.17,5.09c2.79,0.81,6.28-0.81,8.42,2.25
		c-6.78,3.02-13.79,5.37-21.02,7.04c-4.51-2.12-5.88-5.94-5.77-10.58C529.72,785.78,527.74,785.22,526.58,783.85z"
        />
        <path
          class="st5"
          d="M530.38,787.65c1.62,3.69,2.79,7.63,5.78,10.58c-4.52,2.02-9.28,3.17-14.14,3.95c-0.6-0.76,0.16-2.91-2.1-1.98
		c-0.85,0.35-1.88,0.75-2.48-0.44c-0.55-1.1,0.29-1.78,0.92-2.46c2.03-2.16,2.09-4.62,0.67-6.98c-1.52-2.54-0.01-2.65,1.82-2.66
		C524.02,787.64,527.2,787.65,530.38,787.65z"
        />
        <path
          class="st41"
          d="M751.84,208.6c-1.39,0.14-2.63-0.31-3.84-0.93c-0.33-0.07-0.61-0.24-0.83-0.5c-0.05-0.16-0.11-0.31-0.16-0.47
		c-8.78-13.06-17.56-26.11-26.31-39.19c-0.81-1.21-2.55-2.16-1.47-4.08c11.04,12.24,21.08,25.24,29.82,39.22
		c0.97,1.31,0.8,3.4,2.75,4.04l0.01,0.02C752.41,207.35,752.4,207.97,751.84,208.6z"
        />
        <path
          class="st42"
          d="M31.83,358.14c0.13-1.62-0.43-3.32,0.53-4.85c1.72-1.62,0.86-3.83,1.31-5.73c0.05-0.31,0.11-0.62,0.16-0.92
		c1.94-6.7,3.27-13.53,4.66-20.36c1-7.25,2.96-14.24,5.71-21.01c0.12,0.11,0.23,0.23,0.34,0.35c4.05,6.24,1.13,12.5-0.4,18.5
		c-2.64,10.34-4.91,20.76-7.55,31.1c-0.39,1.54-0.64,3.16-2.1,4.16C33.23,359.75,32.37,359.29,31.83,358.14z"
        />
        <path
          class="st43"
          d="M74.98,610.35c1.44-2.9,3.23-0.81,4.28,0.07c1.9,1.58,4.03,2.22,6.29,2.75c5.45,1.93,9.11,6.81,14.53,8.84
		c1.07,0.4,1.79,1.4,0.81,2.66c-4.56,2.66-7.97,1.84-9.99-3.26c-0.84-2.12-2.07-3.4-4.14-1.3c-1.19,1.2-2.79-0.15-4.1,1.03
		c0.88,1.76,2.53,3.32,1.89,5.57C80.68,621.65,77.81,616.01,74.98,610.35z"
        />
        <path
          class="st20"
          d="M697.2,702.33c-5.21-1.68-7.74-5.81-9.58-10.56c5.94-0.26,11.36,2.62,17.22,2.87
		C702.52,697.44,700.27,700.29,697.2,702.33z"
        />
        <path
          class="st13"
          d="M503.81,35.93c-6.32,0.29-12.73-0.44-18.89,1.86c-1.4,0.52-3.18,0.26-4.74,0.03
		c-1.89-0.28-2.73-2.16-2.62-3.54c0.17-2.15,2.25-0.95,3.45-0.98c1.22-0.03,2.61,1.01,3.66,0.69c1.83-0.55-0.4-1.13-0.29-1.81
		c3.7-0.11,7.23,0.81,10.73,1.84c-1.76,1.17-3.54,0.31-5.33,0.58c2.65-0.14,5.3,0.29,7.97-0.27
		C499.78,34.86,501.8,35.39,503.81,35.93z"
        />
        <path
          class="st25"
          d="M105.74,658.07c0.78-1.27,1.01-2.66,0.91-4.12c-0.14-2.22,1.17-3.99,2.91-4.47c1.96-0.55,3.92,1.62,4.26,2.95
		c0.57,2.2,2.2,2.82,3.88,4.06c-3.6,1.31-6.87,2.49-10.15,3.68C106.68,659.71,105.79,659.26,105.74,658.07z"
        />
        <path
          class="st44"
          d="M801.8,319.78c-4.59,4.06-10.71,6.24-14.23,11.64c-0.51,0.78-1.46,0.11-2.2-0.11
		c-1.69-0.9-2.14-2.15-1.04-3.81c1.4-0.83,1.12-2.55,1.98-3.7c0.62-0.82,1.39-1.62,2.32-1.34c6.76,2.02,10.05,0.12,11.44-6.7
		c0.06-0.27,0.38-0.49,0.57-0.74C800.91,316.64,802.37,317.97,801.8,319.78z"
        />
        <path
          class="st42"
          d="M31.83,358.14c0.65,0.32,1.3,0.65,1.95,0.97c2.43,3.21,0.53,6.4-0.06,9.59c-1.85,5.25-2.53,10.75-3.33,16.21
		c-0.25,1.69,0.05,3.53-1.42,4.85c-0.33,0-0.66,0-0.99,0C28.29,379.11,29.8,368.59,31.83,358.14z"
        />
        <path
          class="st45"
          d="M793.72,549.91c-1.9-2.91,0.63-5.15,1.36-7.53c1.79-5.83,2.63-11.99,5.65-17.42
		c-0.03,7.29-3.76,13.63-5.32,20.53C795.07,547.01,794.3,548.44,793.72,549.91z"
        />
        <path
          class="st42"
          d="M38.49,326.27c-0.13,7.11-1.6,13.92-4.66,20.36C34.95,339.74,35.69,332.77,38.49,326.27z"
        />
        <path
          class="st46"
          d="M801.79,520.36c-0.5-3.53,1.56-6.5,2.17-9.78c0.13,0.04,0.34,0.04,0.38,0.12c0.13,0.28,0.2,0.58,0.3,0.88
		C804.51,514.77,803.45,517.66,801.79,520.36z"
        />
        <path
          class="st8"
          d="M497.76,34.33c-2.81,1.61-5.72,0.28-8.6-0.03c1.98-0.1,3.97-0.19,5.95-0.29
		C495.99,34.12,496.87,34.22,497.76,34.33z"
        />
        <path
          class="st6"
          d="M814.04,392.62c-1.66-3.1-0.57-6.43-0.76-9.65C814.21,386.13,814.15,389.37,814.04,392.62z"
        />
        <path
          class="st25"
          d="M111.28,665.01c1.89-0.42,1.4-2.3,2.09-3.52c1.24,2.14,1.12,3.73-1.53,4.39
		C111.65,665.59,111.47,665.3,111.28,665.01z"
        />
        <path
          class="st42"
          d="M33.67,347.55c1.25,2.29,0.53,4.14-1.3,5.73C33.11,351.45,32.44,349.28,33.67,347.55z"
        />
        <path
          class="st16"
          d="M751.81,206.71c-4.47,1.07-1.54-2.9-2.75-4.04C750.33,203.77,751.26,205.11,751.81,206.71z"
        />
        <path
          class="st20"
          d="M787.28,275.71c-0.75,0.46-1.49,0.92-2.32,1.43c-0.6-1.77,1.33-2.28,1.51-3.55
		C787.27,274.09,787.5,274.82,787.28,275.71z"
        />
        <path
          class="st25"
          d="M114.29,668.79c1.52,0.31,3.4,0.34,2.18,2.79C115.75,670.65,115.02,669.72,114.29,668.79z"
        />
        <path
          class="st16"
          d="M751.84,208.6c-0.01-0.62-0.01-1.25-0.02-1.87c0.78,1.22,1.56,2.44,2.34,3.66
		C752.98,210.33,752.3,209.61,751.84,208.6z"
        />
        <path
          class="st47"
          d="M784.34,327.5c-0.06,1.38,0.33,2.64,1.04,3.81c-0.04,2.78,0.35,5.47,1.81,7.91
		c1.62,9.36,3.39,18.7,4.83,28.08c3.59,23.32,4.6,46.79,3.8,70.35c-0.05,1.59-0.02,3.18-0.03,4.77c-0.85,8.21-1.75,16.41-2.54,24.63
		c-1.96,20.19-6.48,39.85-11.87,59.35c-5.14,18.62-12.69,36.33-20.11,54.09c-7.04,14.34-14.97,28.2-23,42
		c-0.49,0.73-0.98,1.46-1.46,2.19c-9.94,14.45-20.25,28.61-31.71,41.91c-7.19,8.34-14.9,16.19-22.57,24.08
		c-6.61,6.1-13.21,12.19-19.82,18.29c-9.19,6.19-17.26,13.87-26.64,19.81c-1.85,1.17-3.46,2.74-5.63,3.38
		c-4.53,1.95-4.7,1.85-5.2-3.09c0.82-3.24,4.78-3.86,5.8-6.94c3.41-4.1,8.18-6.51,12.27-9.76c5.1-4.06,10.45-7.8,15.02-12.5
		c13.72-10.68,25.5-23.37,37.3-36.04c4.43-4.76,8.57-9.8,12.56-14.95c17.89-22.51,32.89-46.8,45.01-72.87
		c10.67-23.27,18.96-47.36,24.72-72.3c1.43-6.21,2.7-12.46,3.74-18.75c0.57-1.67,0.63-3.39,0.58-5.13c-0.09-2.56,0.52-4.99,1.27-7.4
		c0.7-1.62,0.69-3.34,0.67-5.07c0-1.27,0.12-2.52,0.39-3.76c0.69-1.98,0.49-4.05,0.57-6.09c0.64-3.71,1.02-7.43,0.86-11.2
		c0.11-1.42,0.1-2.84,0.46-4.23c1.04-5.97,0.47-11.99,0.42-17.97c-0.06-7.41,0.5-14.84-0.39-22.24c-0.43-1.64-0.4-3.32-0.44-5
		c-0.04-2.36,0.24-4.75-0.57-7.06c-0.26-1.04-0.33-2.11-0.42-3.18c-1.51-19.54-5.21-38.69-10.03-57.64
		c-3.26-13.11-7.69-25.84-12.38-38.49c-7.59-20.14-17.23-39.28-28.4-57.66c-1.07-1.77-2.1-3.56-3.18-5.32
		c-9.97-15.88-21.35-30.72-33.42-45.05c-4.59-4.67-8.76-9.72-13.35-14.39c-0.74-0.81-1.52-1.59-2.32-2.34
		c-14.25-14.66-29.88-27.72-46.38-39.74c-10.18-7.42-20.76-14.25-31.77-20.38c-8.3-4.8-16.55-9.69-25.49-13.26
		C542,75,503.79,64.31,463.87,59.56c-2.38-0.28-4.79-0.03-7.17-0.34c-10.25-1.27-20.54-1.8-30.86-1.61c-1.75,0.03-3.5,0.05-5.24,0
		c-36.31-0.29-71.74,5.34-106.4,16.01c-5.33,1.64-10.59,3.5-15.89,5.25c-13.43,4.21-26.01,10.48-38.73,16.39
		c-23.94,11.74-45.99,26.41-66.86,42.92c-9.01,7.17-17.27,15.19-25.86,22.83c-1.27,1.2-2.52,2.4-3.69,3.7
		c-0.29,0.34-0.6,0.65-0.92,0.96c-16.88,17.63-32.53,36.25-45.56,56.96c-17.05,25.32-29.89,52.71-39.92,81.47
		c-3.93,12.4-7.8,24.8-10.56,37.53c-4.19,21.15-7.02,42.42-8.26,63.99c-0.88,15.19-0.18,30.23,0.77,45.31
		c0.5,10.76,2.25,21.39,3.62,32.05c0.51,1.74,0.38,3.61,1,5.33c0.15,0.49,0.25,0.98,0.32,1.49c1.71,11.68,4.9,23.01,8.11,34.34
		c5.83,20.57,13.74,40.35,23.08,59.56c13.21,26.63,29.25,51.4,48.72,73.9c10.03,12.86,21.88,23.99,33.71,35.13
		c13.13,12.37,28.19,22.37,41.89,34.04c1.63,1.63,2.48,4.55,5.77,3.42c6.35,2.28,11.56,6.59,17.43,9.7
		c8.26,4.62,16.71,8.86,25.27,12.88c1.98,0.93,4.07,1.75,5.55,3.51c0.61,1.12,1.9,1.71,2.38,2.92c0.58,1.46,0.24,2.82-0.85,3.93
		c-0.99,1-2.19,1.31-3.45,0.54c-6.43-3.98-13.66-6.3-20.28-9.94c-4.64-2.55-9.03-5.67-14.19-7.23
		c-10.22-4.63-18.9-11.78-28.51-17.41c-20.96-15.17-40.56-31.91-58.52-50.54c-7.99-9.27-15.98-18.53-23.96-27.8
		c-5.09-7.12-10.19-14.24-15.28-21.36c-6.81-7.74-11.92-16.56-16.34-25.81c-1.99-6.95-6.12-12.87-9.23-19.28
		c-6.24-14.02-12.45-28.05-17.18-42.69c-0.29-0.88-0.86-1.67-1.3-2.51c-0.87-5.57-3.13-10.73-4.83-16.06
		c-4.07-17.21-7.8-34.49-10.51-51.97c-0.02-2.53,0.01-5.06-1.03-7.45c-1.13-16.92-2.01-33.85-1.99-50.82
		c-1.64-1.98-1.25-4.26-0.97-6.53c1.07-3.19,0.52-6.49,0.64-9.75c0.06-2.45-0.12-4.91,0.33-7.34c0.74-2.05,0.67-4.19,0.64-6.32
		c1.65-14.84,4.06-29.56,7.4-44.12c0.71-3.1,1.22-6.25,2.18-9.28c1.94-7.24,4-14.46,6.29-21.6c0.53-1.65,0.75-3.49,2.53-4.43
		c5.38-14.09,10.65-28.21,17.14-41.85c7.45-15.66,16.23-30.56,25.31-45.29c15.45-22.81,33.07-43.82,52.51-63.32
		c7.41-6.64,14.83-13.29,22.24-19.93c14.52-10.94,29.03-21.88,44.65-31.29c12.3-7.41,25.2-13.68,37.9-20.33
		c7.01-2.91,14.01-5.83,21.02-8.74c10.83-3.61,21.67-7.22,32.5-10.83c10.87-2.53,21.73-5.06,32.6-7.59
		c11.91-4.38,24.48-4.96,36.91-6.2c7.44-0.74,14.91-1.51,22.41-0.94c2.08,0.01,4.16,0.01,6.24-0.01c10.03-0.05,20.02,0.6,30,1.51
		c6.66,1.2,13.38,1.76,20.14,1.92c9.79,1.79,19.62,3.43,29.37,5.42c8.84,1.8,17.6,3.98,26.39,6c12.17,4.19,24.55,7.8,36.45,12.79
		c5.13,2.15,10.32,4.17,15.48,6.25c3.94,2.35,8.11,4.23,12.4,5.84c8.63,4.79,17.27,9.58,25.9,14.38
		c10.48,7.05,20.96,14.1,31.44,21.15c1.41,0.85,3.17,1.23,4,2.89c0,0-0.03,0-0.03,0c4.15,3.85,8.57,7.36,13.2,10.61
		c7.01,6.4,14.03,12.79,21.04,19.19c5.49,5.72,10.98,11.44,16.47,17.15c1.81,0.56,1.81,2.66,3.11,3.66c0,0,0.08,0.08,0.08,0.08
		c5.4,6.7,10.81,13.39,16.21,20.09c2.18,0.65,3.19,2.52,4.41,4.19c4.71,6.44,9,13.17,13.58,19.71
		c11.38,18.08,21.69,36.72,29.64,56.6c1.19,2.79,2.96,5.42,2.41,8.7c2.12,5.46,4.24,10.91,6.36,16.37
		C779.21,310.25,781.77,318.88,784.34,327.5z"
        />
        <path
          class="st48"
          d="M49.23,389.17c0.31,2.48,0.15,4.95-0.31,7.4c-0.83,3.23,0.31,6.6-0.66,9.82c0.4,2.15,0.34,4.29-0.13,6.42
		c0,0-0.46,0-0.46,0l-0.46,0c-2.57-5.47-1.56-11.29-0.87-16.8c0.64-5.12-0.77-10.15,0.28-15.19c0.19-0.92-0.13-1.97-1.05-2.5
		c-4.66-2.68-7.78-7.39-12.77-9.62c-0.11-3.24,1.55-6.3,0.97-9.58c3.02-9.87,5.29-19.93,7.59-29.99c1.02-4.44,2.26-8.82,3.46-13.22
		c0.95-3.48,0.44-6.89-0.3-10.3c1.95,0.45,1.27,2.82,2.67,3.66c5.03,6.16,8.59,13.21,12.4,20.12c-4.07,17.76-7.41,35.64-9.67,53.73
		C49.08,385.06,50.08,387.23,49.23,389.17z"
        />
        <path
          class="st49"
          d="M59.61,329.39c-5.49-5.87-9-12.96-12.4-20.12c5.67-3.25,12.56-3.11,18.21-6.45c0.34-0.2,1.15,0.39,1.75,0.62
		C64.65,312.09,62.13,320.74,59.61,329.39z"
        />
        <path
          class="st47"
          d="M236.81,746.51c1.42-0.03,2.77-0.11,4.17,0.58c8.64,4.24,16.44,10.21,26.03,12.6
		c1.08,0.27,2.18,1.89,3.48,2.74c1.65,1.07,2.95,1.39,3.99-0.36c0.94-1.57,0.64-2.94-1.37-3.65c-0.33-0.12-0.35-1.12-0.51-1.71
		c1.99-0.93,3.73,0.08,5.45,0.79c9.22,3.85,18.56,7.36,28,10.62c1.64,0.57,3.41,0.92,4.25,2.72c-0.22,2.81-2.1,3.18-4.4,3.01
		c-1.93-0.15-3.75-0.69-5.59-1.16c5.85,1.04,11.19,4.12,17.91,4.79c-1.74-2.39-3.7-1.96-5.27-2.53c-1.96-0.72-3.61-1.69-1.76-4.11
		c1.42-0.61,2.79-0.23,4.15,0.2c6.9,2.17,13.85,4.19,20.91,5.77c0.93,0.21,1.82,0.52,2.46,1.29c-0.13,3.85-1.74,5.26-4.7,3.4
		c-3.77-2.38-7.36-2.46-10.71-1.02c-1.19,0.1-0.5,0.91-0.73,0.32c-0.06-0.16,0.07-0.22,0.4-0.27c3.42-0.49,6.63,0.83,9.79,1.61
		c3.13,0.77,6.23,0.83,9.29,1.34c3.21,0.53,6.21,2.37,9.6,3c2.52,0.47,4.96,1,7.52,0.74c1.1-0.11,2.32-0.48,3.28,0.17
		c4.13,2.82,8.47,2.02,12.88,1.02c1.37-0.31,2.84-0.72,3.95,0.69c0.34,0.66-0.91,2.02,0.95,2.04c2.38,0.02,4.71,0.46,7.14,0.14
		c3.32-0.44,6.7-0.39,9.82,1.23c1.17,0.61,2.38,0.61,3.69,0.63c9.86,0.14,19.72-0.73,29.58,0.66c4.86,0.68,9.86,0.04,14.71-1.05
		c11.71-2.64,23.89-1.11,35.58-3.94c8.42-2.04,17.11-2.96,25.3-6.04c-3.95-0.27-7.55,1.5-11.39,1.98c-3.14,0.39-6.78,0.37-9.26,1.54
		c-3.03,1.42-5.75,1.25-8.69,1.65c-9.16,1.24-18.4,1.06-27.57,2.07c-3.84,0.42-6.36,4.15-10.63,3.75c-2.31-0.21-4.76,0.09-7.15,0.09
		c-1.14,0-2.89,0.53-2.84-1.5c0.04-1.62,1.55-1.2,2.59-1.32c0.56-0.06,1.12,0.09,1.67-0.12c-10.67,1.71-21.52-0.1-32.18,1.74
		c-1.68,0.29-3.08-0.4-4.57-1.03c-2.67-1.14-5.49-1.94-8.34-0.87c-3.25,1.22-5.92,0.4-8.39-1.75c-5.97-0.87-11.68-3.37-17.93-2.47
		c-4.87,0.7-9.35-0.99-13.63-3.08c-1.07-0.52-2.29-1.38-1.11-2.94c1.77-1.08,3.67-0.88,5.52-0.42c5.69,1.41,11.48,2.18,17.3,2.77
		c10.64,2.21,21.48,2.56,32.26,3.29c27.29,1.86,54.39-0.32,81.36-4.62c12.45-1.99,24.69-4.93,36.89-8.03
		c5.16-1.15,9.98-3.77,15.44-3.65c1.07,0.51,1.61,1.51,2.22,2.43c1.23,1.89,0.13,2.97-1.58,2.67c-5.97-1.06-10.99,1.85-17.11,3.46
		c3.51,2.28,6.08,0.28,8.5-0.47c5.16-1.6,11.22-1.22,14.89-6.35c0.27-0.38,0.82-0.75,1.24-0.6c5.58,2.07,9.62-2.23,14.38-3.49
		c1.42-0.37,2.75-0.95,3.93,0.43c0.08,0.21,0.16,0.42,0.23,0.64c-7.91,4.14-16.53,6.4-24.85,9.45c-1.93,0.71-3.88,1.36-5.83,2.04
		c-1.82,1.06-3.7,1.9-5.89,1.68c-1.22,0.27-2.64-0.09-3.56,1.13c-6.22,1.47-12.56,2.47-18.58,4.7c-0.76,0.85-1.71,0.5-2.61,0.4
		c-16,3.11-32.14,5.21-48.31,7.2c-1.76,1.11-3.6,0.64-5.44,0.29c-4.91,0.01-9.83-0.33-14.69,0.68c-0.56,0.75-1.12,0.65-1.69,0.01
		c-4.78,0.02-9.55,0.03-14.33,0.05c-5.44-0.52-10.89-0.97-16.36-0.67c-2.77,0.16-5.57,0.83-8.28-0.35
		c-4.8-1.32-9.75-1.27-14.66-1.59c-1.24,0.27-2.5,0.67-3.64-0.29c-1.51-1.05-3.21-1.12-4.95-0.98c-15.7-2.61-31.3-5.7-46.67-9.93
		c-18.15-4.99-35.6-11.87-53.01-18.92c-10.57-5.35-21.14-10.7-31.71-16.06C236.89,747.13,236.82,746.83,236.81,746.51z"
        />
        <path
          class="st16"
          d="M430.64,796.16c0.57,0,1.13-0.01,1.69-0.01c3.27,0,6.53,0,9.8,0C438.28,796.78,434.35,798.39,430.64,796.16z"
        />
        <path
          class="st25"
          d="M447.02,795.46c1.81-0.1,3.62-0.2,5.44-0.29c1.69,0.13,3.37,0.26,5.06,0.38
		C453.98,796.02,450.45,797.15,447.02,795.46z"
        />
        <path
          class="st50"
          d="M500.76,787.97c0.87-0.13,1.74-0.27,2.61-0.4c0.73,0.09,1.45,0.18,3.14,0.39
		C503.9,788.78,502.31,788.95,500.76,787.97z"
        />
        <path
          class="st47"
          d="M626.26,728.21c-0.51,3.31,0.35,5.17,4.15,3.94c-1.29,1.79-3.13,2.8-5.11,3.61
		c-3.72-3.29-8.46-2.38-9.99,2.22c-0.53,1.6-1.05,2.16-2.52,1.95c-1.95-0.28-2.44,1.03-3.02,3.08c2.38-2.19,5.02-3.03,7.22-4.72
		c1.29-1,3.07-1.94,4.78-0.36c-6.49,5.22-14.06,8.66-21.18,12.84c-1.78,1.04-3.52,2.14-5.28,3.21c-1.81,0.7-3.62,1.41-5.44,2.11
		c-1.26-1.89,0.28-2.54,1.51-3.16c2.13-1.08,3.98-2.58,5.42-3.28c-1.68,1.68-5.87-1.26-7.56,2.59c-0.62,1.42-0.76,2.75,0.66,3.82
		c-2.22,1.99-5.08,2.67-7.73,3.8c-0.12-0.19-0.25-0.37-0.37-0.56c-0.33-0.99,0.73-1.75,0.5-2.66c-5.37,0.04-9.62,2.13-12.68,6.61
		c-0.98,1.44-2.47,0.87-3.92,0.55c-3-0.67-2.99-0.58-4.38,2.27c-0.71,1.46-2.19,1.08-3.37,1.14c-3.01,0.14-5.59,0.43-8.16,2.83
		c-2.53,2.36-5.57,0.27-7.92-1.78c0.7-2.51,3.16-2.35,4.93-3.16c3.32-1.52,6.84-2.6,10.14-4.18c14.26-5.26,27.8-12.05,41.19-19.17
		c8.59-4.57,16.43-10.45,25.39-14.37C624.56,727.21,625.5,727.44,626.26,728.21z"
        />
        <path
          class="st47"
          d="M621.77,737.92c-5.63,0.32-8.93,5.51-14.37,7.13c0.07-2.31,3.09-3.34,1.78-5.7
		c-0.26-0.46,0.26-1.45,1.03-1.18c2.45,0.87,3.66,1.02,4.48-2.38c0.65-2.68,4.61-3.15,7.18-3.95c2.16-0.67,3.62,1.4,3.44,3.91
		C624.17,736.55,623.28,737.75,621.77,737.92z"
        />
        <path
          class="st47"
          d="M582.16,759.85c-6.46,3.44-13.01,6.66-20.07,8.71c0,0-0.09-0.17-0.09-0.17c-0.08-2.02,1.52-2.9,2.91-3.26
		c4.37-1.14,7.76-3.93,11.49-6.18c2.09-1.27,3.92-0.38,5.69,0.81L582.16,759.85z"
        />
        <path
          class="st41"
          d="M525.52,781.74c1.81-1.1,3.76-1.7,5.89-1.68C529.96,782.43,528.22,783.74,525.52,781.74z"
        />
        <path
          class="st51"
          d="M420.9,40.07c0.38-0.06,0.76-0.12,1.14-0.18c2.57,3.16,7.01,3.61,9.67,6.63c-3.61,1.87-7.36,0.95-11.08,0.58
		C418.26,44.66,419.44,42.36,420.9,40.07z"
        />
        <path
          class="st52"
          d="M448.6,48.65c-10.11-0.18-20.23-0.36-30.34-0.54c-0.1-0.57,0.13-0.95,0.67-1.15c0.76-0.22,1.5,0.07,2.25,0.11
		c3.81-0.3,7.67,0.64,11.45-0.5c5.93,1.52,12.04,0.77,18.1,1.74C450.02,48.42,449.31,48.53,448.6,48.65z"
        />
        <path
          class="st53"
          d="M432.64,46.57c-4.03,2.09-8.3,0.49-12.45,0.82c-0.11-0.16-0.21-0.32-0.32-0.47c0.16-0.1,0.32-0.2,0.48-0.3
		c3.79-0.03,7.57-0.06,11.36-0.09C432.02,46.53,432.33,46.55,432.64,46.57z"
        />
        <path
          class="st54"
          d="M94.19,603.58c2.35,1.35,3.09,3.92,4.39,6.02c4.07,6.55,7.98,13.19,11.95,19.8
		c-1.07,1.12-1.84-0.02-2.22-0.58c-1.81-2.65-4.49-3.58-7.41-4.14c-4.17-3.05-8.32-6.13-12.54-9.11c-1.02-0.72-2.3-1.08-2.8-2.39
		c2.07-0.79,4.77,3.42,6.52-1.04c0.73-1.88,1.46-3.06,0.02-5.02C90.72,605.22,90.1,602.72,94.19,603.58z"
        />
        <path
          class="st7"
          d="M391.66,795.19c2.76,0.12,5.52,0.23,8.28,0.35c-3.73,1.67-7.56,0.23-11.89,0.88
		C389.46,794.87,390.67,795.53,391.66,795.19z"
        />
        <path
          class="st43"
          d="M373.36,793.31c1.21,0.1,2.43,0.2,3.64,0.29c-0.01,0.25-0.02,0.5-0.02,0.75c-1.39,0-2.78,0.01-4.17-0.01
		c-0.57-0.01-0.76-0.34-0.33-0.76C372.68,793.39,373.06,793.39,373.36,793.31z"
        />
        <path
          class="st33"
          d="M650.17,125.28c-1.61-0.58-2.85-1.67-4-2.89C648.07,122.57,649.94,122.8,650.17,125.28z"
        />
        <path
          class="st13"
          d="M737.3,220.22c-5.68-8.05-11.37-16.11-17.05-24.16c3.26-1.31,5.12,1.61,7.59,2.59
		c6.44,2.57,12.79,5.35,19.18,8.05c0,0,0.02,0.05,0.02,0.05c0.84,1.02,0.7,2.3,0.08,3.12C744.21,213.66,742.34,218.46,737.3,220.22z
		"
        />
        <path
          class="st55"
          d="M737.3,220.22c2.76-3.22,5.46-6.48,8.29-9.64c1.02-1.14,1.6-2.31,1.44-3.83c0.32,0.31,0.64,0.61,0.96,0.92
		c1.51,5.12,3.02,10.25,4.51,15.37c2.67,9.16,4.96,18.46,8.11,27.45c2.27,6.47,3.1,13.42,6.55,19.47c-0.33,2.02,0.65,3.82,0.98,5.73
		c0.18,1.05-0.26,1.41-1.27,1.13C758.66,257.11,748.3,238.49,737.3,220.22z"
        />
        <path
          class="st20"
          d="M769.12,276.66c4.29,1.2,4.58,3.54,1.92,6.72C769.16,281.49,767.92,279.42,769.12,276.66z"
        />
        <path
          class="st56"
          d="M769.12,276.66c-0.03,2.43,1.01,4.55,1.92,6.72c-0.25,0.63-0.5,1.25-0.76,1.88
		c-1.13-2.81-2.26-5.62-3.39-8.42c0.42-0.38,0.84-0.75,1.27-1.13C768.48,276.02,768.8,276.34,769.12,276.66z"
        />
        <path
          class="st20"
          d="M775.65,275.3c-0.06,0.79-0.6,1.17-1.23,0.9c-0.47-0.21-0.98-0.82-1.06-1.32c-0.13-0.83,0.63-0.95,1.27-0.89
		C775.38,274.05,775.6,274.63,775.65,275.3z"
        />
        <path
          class="st57"
          d="M32.81,368.69c4.93-0.83,6.97,3.36,9.96,5.83c0.86,0.71,0.39,2.27,2.79,1.74c2.46-0.55,2.69,2.44,2.58,4.54
		c-0.58,10.66-1.08,21.32-0.92,32c0,5.42-0.12,10.84,0.03,16.25c0.08,2.83-0.79,4.16-3.79,3.91c-2.53-0.21-5.11,0.08-7.63-0.2
		c-2.92-0.32-5.37-0.09-6.89,3.32c-1.03-15.6-1.48-30.95,0.02-46.32C29,382.52,29.77,375.4,32.81,368.69z"
        />
        <path
          class="st58"
          d="M420.9,40.07c-0.18,2.18-0.37,4.36-0.55,6.54c-0.18-0.04-0.37-0.06-0.56-0.08c-0.5,0.61-1.19,0.47-1.84,0.44
		c-1.88-0.19-3.78-0.1-5.6-0.47c-0.13,0.31-0.08,0.54,0.2,0.75c0.23,0.26,0.29,0.54,0.19,0.86c-20.04,0.68-39.92,2.96-59.7,6.17
		c0.25-0.56,0.55-1.62,0.75-1.6c2.89,0.27,5.46-0.72,5.03-3.74c-0.44-3.06-0.25-7.05-5.38-7.66c-2.99-0.35-6.27-0.7-9.04-2.39
		c12.46,0.01,24.93,0.02,37.39,0.03c7.19,1.76,14.5,0.59,21.75,0.87c5.53,0.22,11.08,0.03,16.63,0.03
		C420.42,39.88,420.66,39.97,420.9,40.07z"
        />
        <path
          class="st39"
          d="M390.22,30.03c-3.11,0-6.22,0-9.33,0c0-0.16,0-0.32,0-0.48c3.1,0,6.21,0,9.31,0
		C390.2,29.71,390.21,29.87,390.22,30.03z"
        />
        <path
          class="st19"
          d="M707.34,159.82c-0.82-2.74,0.54-3.38,1.75-4.81C709.53,157.2,708.38,158.07,707.34,159.82z"
        />
        <path
          class="st19"
          d="M703.96,175.89c-1.55-0.78-2.22-2.31-3.11-3.66C703.28,172.27,703.5,174.18,703.96,175.89z"
        />
        <path
          class="st59"
          d="M753.82,576.86c-11.81,26.24-26.81,50.51-45.09,72.74c-2.94,1.74-5.59,3.95-9.5,3.38
		c-2.25-0.33-3.51,1.93-4.83,3.48c-5.55,6.58-12.39,10.25-21.21,9.56c-5.74-2.34-10.34-6.5-15.47-9.8
		c-1.03-0.67-1.44-1.71-0.06-2.62c5.78-1.79,7.78-5.78,7.55-11.68c-0.3-7.8-0.05-15.62-0.08-23.44c-0.01-3.62,0.64-6.68,4.73-7.79
		c2.47-0.67,2.89-2.69,2.92-4.9c0.06-4.78,0.01-9.57,0.03-14.35c0.01-2.66,0.7-4.85,2.73-6.83c3.08-3,5.01-7.03,4.63-11.2
		c-0.69-7.75,1.68-14.67,4.91-21.28c2.72-5.56,3.06-11.3,3.21-17.2c0.08-0.83,0.34-1.6,0.82-2.29c4.41-2.42,7.46-0.23,10.19,3.01
		c1.07,4.26,4.8,5.36,8.23,5.94c4.22,0.71,7.06,3.12,10.24,5.57c5.5,4.24,10.73,8.72,15.61,13.64c0.94,0.95,2.29,1,3.49,1.38
		c3.68,1.17,6.45,3.64,7.32,7.33c0.67,2.85,2,3.73,4.67,4.4C750.54,574.34,753.98,572.98,753.82,576.86z"
        />
        <path
          class="st60"
          d="M142.81,658.33c-13.33-14.67-24.36-31-34.65-47.86c-5.14-8.43-9.93-17.06-14.15-25.99
		c1.29-3.11,3.89-4.38,6.97-5.11c14.94-3.54,29.83-7.29,44.72-11.03c5.98-1.5,12.03-2.78,17.99-4.39c5.2-0.24,9.97-2.46,15.02-3.35
		c1.78,1.17,3.56,1.32,5.36,0c1.25-0.28,2.42-0.18,3.43,0.69c0.27,0.39,0.7,0.87,0.59,1.27c-1.17,4.61,0.8,9.78-2.58,14
		c-0.83,1.03-0.78,2.39-0.82,3.67c-0.14,4.37-0.04,8.4-2.98,12.56c-2.43,3.45-1.17,8.63,0.24,12.97c0.16,2.26,0.07,4.62-1.3,6.4
		c-3.63,4.7-3.3,10.13-2.95,15.43c0.27,4.09,0.13,7.84-2.21,11.36c-1.88,2.82-1.16,6.13-1.31,9.27c-0.16,3.46,0.49,6.98-0.64,10.37
		c-1.69,2.41-4.28,1.74-6.58,1.76c-2.73,0.03-5.06,0.23-5.89,3.51c-0.45,1.78-2.17,2.7-3.6,3.71c-1.23,0.88-2.59,1.3-3.98,0.29
		c-1.71-1.24-0.36-2.49,0.71-4.42C148.22,665.4,146.35,660.32,142.81,658.33z"
        />
        <path
          class="st61"
          d="M164.17,565.23c-9.27,3.07-18.92,4.7-28.33,7.25c-6.22,1.69-12.86,2.59-19,4.51
		c-7.62,2.38-16.28,1.86-22.83,7.49c-14.5-28.83-24.65-59.14-30.98-90.75c-0.28-1.39-0.35-2.82-0.51-4.24c1.3-1,1.95-0.16,2.41,1.2
		c0.59-1.22-0.08-1.71-0.65-2.14c-1.59-1.2-1.58-2.63-0.65-4.18c0.7-1.17,1.8-1.91,3.15-1.76c1.68,0.19,2.47,1.56,2.5,3.04
		c0.1,5.06,5.01,2.71,7.06,4.71c1.14,2.49,3.03,3.1,5.73,2.89c4.34-0.34,8.02,1.06,10.03,5.35c2.95,4.84,3.49,10.57,6.98,15.44
		c6.74,9.38,14.83,16.76,25.14,21.81c7.11,3.85,14.84,3.01,22.47,3.08c3.01,0.03,6.07-0.4,9.02,0.59c4.09,4,6.59,8.75,6.97,14.57
		c0.1,1.49,1.39,2.37,2.5,3.32c3.21,2.73,3.28,3.42-0.49,4.96C162.2,563.39,165.05,564.46,164.17,565.23z"
        />
        <path
          class="st62"
          d="M75.94,303.44c9.14-28.55,22.71-54.96,38.71-80.2c0.33-0.52,0.87-0.9,1.31-1.35
		c2.15-0.51,4.36-0.77,6.53-1.15c4.89-0.86,6.15,0.89,8.62,5.11c2.63,4.49,4.83,10.02,11.59,10.61c3.64,0.32,6.82,2.62,9.89,4.55
		c1.87,1.18,3.52,2.6,5.76,3.17c2.29,0.59,2.9,2.67,3.75,4.59c0.98,2.2,2.46,2.85,4.33,0.69c3.21-3.7,3.22-3.68,5.06,1.09
		c0.34,0.89,0.95,1.66,1.22,2.59c0.74,6.51-1.78,10.35-8.25,12.37c-1.3,0.41-2.34,0.88-2.84,2.24c-1.42,3.89-4.86,4.87-8.36,5.33
		c-5.94,0.79-11.04,3.57-16.1,6.4c-2.95,1.64-6.17,1.41-9.24,2.15c-1.67,0.4-3.56-0.09-4.99,1.26c-0.79,0.59-1.65,1.03-2.6,1.32
		c-2.69,0.63-5.01,0.1-6.91-2.04c-1.03-1.16-2.56-1.82-3.88-1.14c-2.59,1.32-4.79,3.66-7.96,0.9c-0.79-0.69-1.31,0.93-1.83,1.67
		c-3.09,4.38-6.07,8.81-10.03,12.54c-4.23,3.98-4.07,4.15-8.59,1.09c-1.52,2.26-1.59,5.19-3.33,7.34c-0.49,0.61-1.13,1.29-1.94,0.58
		C75.34,304.7,75.52,304,75.94,303.44z"
        />
        <path
          class="st63"
          d="M753.82,576.86c-1.91-1.63-4.21-2.01-6.61-2.04c-1.65-0.02-3.9-0.17-3.69-2.05c0.42-3.74-1.95-5.54-4.03-7.76
		c-0.51-0.54-0.63-1.58-1.57-1.56c-7.08,0.1-8.93-7.3-13.93-9.73c-6.16-2.99-8.94-10.96-17.16-10.8c-3.74,0.07-6.21-3.58-9.49-5.13
		c-0.68-0.32-0.56-0.59,1.78-1.32c3.14-2.18,6.16-1.39,8.73,0.82c5.1,4.39,11.68,3.63,17.53,5.35c1.57,0.46,3.05-0.52,4.32-1.59
		c3.79-3.17,7.1-6.84,10.65-10.26c1.55-1.5,1.58-3.4,1.59-5.31c0.01-3.04,0.86-5.36,4.41-5.6c2.39-0.17,3.21-1.59,3.25-3.84
		c0.07-4.4-0.64-8.95,2.4-12.85c0.67-0.86,0.54-2.3-0.09-3.21c-2.57-3.7-0.2-5.88,2.31-8.02c1.62-1.38,3.08-2.79,3.05-5.12
		c0-2.78,0.92-4.8,4-5.36c3.11-0.57,3.24-3.41,4.05-5.69c0.18-0.44,0.42-0.84,0.72-1.2c5.4-1.96,10.36-1.1,15.08,2.98
		c-0.68-4.5,1.57-8.12,0.82-12.1c-0.25-1.34,0.83-2.9,2.17-3.44c2.29-0.92,1.67,0.76,1.42,1.95c-0.06,1.16-0.13,2.32-0.19,3.48
		c-0.89,1.68,0,3.62-0.81,5.31c-0.36,2.38-0.72,4.76-1.08,7.14c-1.02,1.57,0.06,3.48-0.82,5.07c-1.52,12.98-4.82,25.59-8.43,38.1
		C768.86,541.55,762.55,559.67,753.82,576.86z"
        />
        <path
          class="st64"
          d="M731.69,226.91c12.95,19.86,23.75,40.8,31.76,63.14c-0.33,2.55-2.18,2.14-3.93,2.08
		c-3.86-0.13-7.3-0.36-7.98,5.27c-0.41,3.35-4.27,3.13-6.56,1.73c-1.93-1.18-1.18,0.88-1.87,0.91c-2.36,0.73-4.47-0.3-6.12-1.54
		c-2.84-2.14-5.89-2.58-9.22-2.33c-6.05-0.44-11.71-2.97-17.79-3.32c-0.62-0.04-1.39-0.22-1.77-0.66c-3.1-3.61-6.8-4.25-11.11-2.51
		c-0.73,0.3-1.7,0.17-2.29-0.35c-3.7-3.21-8.45-3.38-12.85-4.54c-4.74-9.06,2.97-12.74,10.98-13.31c2.91-0.21,5.26-0.27,7.1-2.58
		c0.95-1.2,2.17-2,3.66-1.96c4,0.12,6.13-2.06,7.34-5.56c0.79-2.29,2.52-4.05,3.63-6.15c1.2-2.28,3-4.2,1.18-7.34
		c-1.73-2.99,2.85-4.21,3.04-6.94c0.3-4.17,4.79-6.42,4.86-10.83c0.02-1.27,2.05-1.1,3.27-1.17
		C728.84,228.84,730.02,227.33,731.69,226.91z"
        />
        <path
          class="st65"
          d="M297.24,78.13c22.93-8.96,46.71-14.64,71.03-18.16c17.19-2.49,34.45-4.25,51.87-3.8
		c-0.6,5.39-0.45,10.87-2.08,16.13c-1.01,1.8-1.9,3.67-2.78,5.53c-1.17,2.45-2.95,3.65-5.64,3.55c-1.45-0.01-3.11-0.01-3.98-1.23
		c-2.16-3.03-5.24-2.51-8.24-2.55c-2.38-0.04-3.98,0.89-4.63,3.26c-0.72,2.64-2.33,4.53-4.92,5.46c-1.82,0.65-2.57,2.15-3.52,3.66
		c-3.62,5.79-9.77,9.32-17.06,4.8c-1.67-1.03-3.65-1.1-5.41-1.84c-0.74-0.31-1.49-0.58-2.09-1.13c-4.37-3.99-4.58-3.61-9.83-3.08
		c-5.09,0.51-10.53,1.82-15.18-2.01c-1.33-1.09-3.07-1.03-3.55,0.67c-1.5,5.31-6.36,7.81-9.35,11.84c-0.37,0.34-0.8,0.54-1.29,0.61
		c-2.03-0.09-3.02-1.48-3.84-3.08c-1.99-3.86-4.12-7.54-9.1-8.05c-0.97-0.1-2.12-0.74-2.08-1.68c0.18-4.68-3.25-5.9-6.6-7.31
		C298.23,79.42,297.63,78.86,297.24,78.13z"
        />
        <path
          class="st66"
          d="M191.98,137.68c20.58-17.17,42.93-31.59,67.1-43.18c1.28,0.01,2.61-0.03,3.64,0.84
		c2.58,2.19,5.57,2.82,8.86,2.73c2.67-0.07,4.68,0.94,5.06,3.9c0.45,3.51,5.04,4.63,4.53,9.11c2.46-4.69,5.14-5.39,11.35-3.5
		c0.37,0.39,0.51,0.84,0.42,1.37c-3.64,5.41-6.89,11.09-11.81,15.55c-2.25,2.03-4.32,3.21-7.13,1.01c-1.82-1.43-4.08-1.75-6.34-1.83
		c-2.08-0.08-4.15-0.04-6.23-0.04c-14,0-13.94,0.08-25.03,7.58c-2.63,1.78-1.43,5.23-3.74,6.95c-3.64,3.78-2.31,8.41-1.29,12.42
		c0.62,2.46,2.53,4.89,3.79,7.39c1.3,2.57,4.6,1,7,1.44c1.09,0.13,2.12,0.42,2.93,1.22c2.14,6.82,0.72,8.94-6.13,9.11
		c-2.07,0.05-4.14,0.07-6.21-0.11c-2.25-0.2-4.15-1.01-4.49-3.48c-0.5-3.58-2.84-4.18-5.83-4.06c-1.43,0.06-2.87,0.03-4.3-0.07
		c-1.44-0.1-3.84-0.24-3.88-1.24c-0.23-6.14-8.3-5.43-9.12-10.83c-0.12-0.79-0.12-1.59-0.15-2.38c-0.29-6.45-0.75-6.79-7.36-6.77
		C195.28,140.78,191.88,142.24,191.98,137.68z"
        />
        <path
          class="st67"
          d="M57.59,451.5c-1.58-11.56-1.87-23.2-1.58-34.83c0.6-24.62,3.13-49.04,8.44-73.12
		c0.2-0.91,0.62-1.77,0.93-2.66c0.65-0.46,0.35-1.66,1.25-1.82c1.08-0.2,1.41,0.79,1.35,1.5c-0.21,2.39,1.68,2.88,3.04,4.16
		c2.96,2.79,4,6.94,5.97,10.45c0.59,1.05,0.35,2.67,1.51,3.36c4.21,2.5,3.62,6.21,2.71,10.04c-2.44,4.5-3.08,9.48-3.84,14.43
		c-1.2,7.84,1.41,14.74,5.38,21.28c0.17,0.27,0.37,0.52,0.54,0.79c2.75,4.61,4.26,5.96,9.16,8.2c1.18,0.54,2.59,1.18,2.9,2.36
		c1.38,5.21,5.47,4.39,9.24,4.45c6.17,0.1,6.68,0.56,7.23,6.24c0.18,1.86,0.14,3.65,1.42,5.34c3.08,4.07,2.53,5.24-2.55,6.37
		c-2.97,0.12-4.87-1.06-5.38-4.18c-0.23-1.41-0.62-2.96-2.56-2.89c-1.91,0.07-2.22,1.65-2.46,3.04c-0.53,3.22-2.69,4.04-5.53,4.07
		c-6.39,0.07-12.81,0.41-19.15-0.1c-4.47-0.36-6.88,2.9-10.28,4.35c-3.5,1.49-6.87,3.45-6.85,8.11
		C58.49,450.89,57.98,451.22,57.59,451.5z"
        />
        <path
          class="st60"
          d="M457.54,58.05c15.05,0.49,29.75,3.46,44.38,6.64c25.46,5.53,49.98,13.92,73.63,24.86
		c1.29,0.6,2.49,1.38,3.74,2.08c2.55,2.93,2.52,5.89,0.78,9.34c-1.12,2.24-0.35,4.98-0.55,7.49c-0.26,3.3-0.98,6.31-4.83,7.22
		c-1.82,0.19-3.49-0.06-4.74-1.59c-0.51-0.62-1.07-1.41-1.87-1.37c-5.19,0.29-7.97-4.34-12.24-6.03c-2.53-1-5.21-1.28-7.66-2.43
		c-4.17-1.95-8.82-2.55-12.95-4.74c-2.99-1.59-6.24-0.13-9.37,0.12c-7.11-4.37-14.4-8.41-21.98-11.91
		c-3.44-2.63-7.47-4.22-11.29-6.15c-6.53-3.31-12.44-7.64-18.86-11.08c-6.38-3.42-12.67-7.14-19.78-9.03
		c-1.24-0.33-3.36-0.38-2.91-2.33c0.31-1.36,2.11-1,3.37-1C455.44,58.16,456.52,59.09,457.54,58.05z"
        />
        <path
          class="st68"
          d="M731.69,226.91c-1.12,2.41-2.42,4.48-5.65,3.33c-0.59-0.21-1.73-0.16-1.58,0.33c1.44,4.74-4.1,6.6-4.25,10.62
		c-1.69,1.39-2.99,0.43-4.69-0.34c-5.69-2.56-7.35-8.36-10.7-12.76c-1.73-2.28-3.4-4.55-5.53-6.46c-4.2-5.51-8.57-10.77-11.88-17.08
		c-3.2-6.12-9.04-11.01-15.42-13.77c-3.34-1.44-8.12-1.2-12.08-0.61c-3.07,0.45-6.27,0.53-9.33,1.67c-3.01,1.12-4.97-0.83-5.3-4.9
		c-0.36-4.44-0.09-8.92-1.04-13.33c-0.57-2.68-1.28-5.26-2.74-7.6c-0.42-0.67-1.45-1.54-1.15-1.99c2.49-3.69-1.5-4.3-2.79-6.17
		c4.54-5.05,10.07-4.54,14.77-0.42c3.36,2.94,7.1,6.39,12.19,6.75c5.65,0.4,9.12,4.67,13.3,7.64c0.83,0.59,1.05,2.27,2.21,2.36
		c6.02,0.48,9.6,6.08,15.32,7.19c0.9,0.17,1.75,0.53,2.69,0.42C710.77,195.71,722,210.73,731.69,226.91z"
        />
        <path
          class="st69"
          d="M457.54,58.05c-1.56,1.96-4,0.27-5.77,1.36c19.3,5.86,35.02,18.57,52.74,27.43c-1.45,3.47-4.66,3.29-7.11,2.4
		c-3.38-1.23-6.39-1.35-9.89-0.65c-2.71,0.54-5.67,0.55-8.53,0.54c-7.16,3.31-13.8,7.07-14.67,16.11c-0.08,0.8-0.42,1.52-1.03,2.09
		c-0.94,0.53-1.9,0.53-2.87,0.09c-3.93-7.16-0.94-15.9,6.89-20.23c0.92-0.51,2.24-0.39,2.75-1.62c-5.26-2.42-8.29-1.68-10.28,3.06
		c-1.77,4.21-6.17,4.36-9.28,6.11c-3.64,2.06-6.26,6.03-11,6.27c-1.47,0.08-1.62,1.79-1.69,3.08c-0.12,2.07-0.13,4.15-0.64,6.18
		c-1.19,4.78-2.64,5.72-7.92,5.04c-0.47-0.23-0.83-0.57-1.09-1.02c-0.99-2.67-0.84-5.25,0.47-7.79c2.49-4.83,1.49-9.41,0.21-14.56
		c-1.81-7.28-8.8-7.62-12.84-11.72c-1.52-2.91,0.47-5.25,1.27-7.78c0.04-4.42,1.53-8.72,0.98-13.18c-0.19-1.53,1.22-2.1,1.9-3.11
		C432.66,55.71,445.13,56.19,457.54,58.05z"
        />
        <path
          class="st69"
          d="M79.8,367.74c0.93-3.15,2.86-6.61-2.45-7.83c-0.41-0.1-1.12-0.64-1.07-0.79c1.51-4.88-4.57-6.94-4.2-11.38
		c0.07-0.83-0.24-1.82-1.05-1.96c-3.34-0.59-5.76-1.61-3.97-5.77c0.07-0.16-0.97,0.84-1.68,0.87c2.25-12.84,6.08-25.23,10.56-37.44
		c0.31,1.75,0.87,1.37,1.38,0.12c1.2-2.91,1.73-6.1,3.67-8.82c1.34,0.38,1.74,1.66,2.4,2.59c1.12,1.59,2.3,1.69,3.48,0.33
		c3.92-4.52,7.78-9.1,11.61-13.7c0.36-0.43,0.39-1.19,0.47-1.8c0.41-3.18,1.94-3.63,3.92-1.31c1.81,2.12,2.39,2.43,4.28-0.28
		c1.42-2.04,5.36-2.28,6.86,0.31c1.65,2.85,3.77,2.35,6.05,2.48c0.28,1.7-1.06,2.09-2.16,2.68c-6.67,0.38-12.79,2.31-18.04,6.58
		c-5.12,4.16-8.17,9.27-7.26,16.16c0.13,0.95,0,2.1,0.68,2.74c3.66,3.4,3.82,8.31,5.28,12.58c1.05,3.06,2.66,4,5.54,4.02
		c2.2,0.01,4.5-0.35,6.53,0.95c1.33,2.07,3.03,4.21,5.46,4.26c5.1,0.1,6.63,4.36,9.42,7.18c0.99,1,0.76,2.02-0.18,2.91
		c-2.29,2.16-4.13,5.17-7.53,5.58c-8.17,0.98-14.68,5.77-21.62,9.38c-4.71,2.45-8.59,6.42-12.71,9.89
		C82.15,368.84,80.92,368.68,79.8,367.74z"
        />
        <path
          class="st70"
          d="M171.84,252.7c-2.47-0.94-1.61-3.53-2.24-5.23c-1.83,0.06-1.52,1.24-1.59,2.1c-0.19,2.26-1.79,3.15-3.59,2.89
		c-1.72-0.25-3.9-0.63-3.74-3.38c0.17-2.77-1.29-4.07-4.02-4.07c-3.82,0.01-5.08-4.18-8.53-5.14c-2.66-0.75-4.96-2.53-8.01-2.63
		c-2.62-0.09-4.84-1.46-5.7-4.29c-0.47-1.55-1-3.06-2.96-3.3c-1.4-0.17-1.61-1.15-1.81-2.36c-0.83-5.03-4.07-7.13-8.66-4.97
		c-2.17,1.02-3.43,0.67-5.03-0.42c5.74-9.97,12.75-19.05,19.93-27.98c8.25-10.26,16.63-20.44,26.41-29.34
		c0.77-0.05,1.63,0.24,2.28-0.23c1.81-1.31,3.76-2.12,5.28,0.05c1.66,2.36-1.53,2.91-2.1,4.49c-2.26,5.46-2.09,11.26-2.44,16.98
		c-3.74,10.37-3.52,21.25-4.03,32.02c-0.05,0.99,0.17,1.86,1.01,2.54c5.47,4.43,5.79,11.04,6.94,17.17
		c0.53,2.83,0.54,5.57,2.67,7.88c1.49,1.62,1.42,3.81,0.89,5.91C172.58,251.92,172.27,252.35,171.84,252.7z"
        />
        <path
          class="st68"
          d="M698.06,181.79c-0.16,0.42-0.43,1.23-0.45,1.22c-4.09-1.28-8.5-1.78-11.84-4.84
		c-0.3-0.28-0.31-1.29-0.44-1.28c-5.01,0.08-7.84-3.2-11.01-6.41c-0.88-0.88-3-1.17-4.06-2.65c-0.45-0.64-1.11-1.55-1.72-1.58
		c-5.29-0.3-9.61-2.65-14.1-5.3c-1.86-1.1-3.36-1.73-3.99-3.78c-0.94-3.07-3.18-4.08-5.27-1.8c-2.24,2.44-5.44,0.25-7.41,2.42
		c-3.42-0.84-5.52-3.77-7.34-6.11c-3.43-4.39-8.04-6.56-12.57-9.12c-2.98-1.68-7.13-2.01-7.34-6.91c-0.05-1.27-2.13-1.86-3.44-2.28
		c-6.24-1.96-11.72-5.99-18.39-6.77c-2.59-2.36-2.02-4.73,0.06-7c1.28-1.39,2.63-2.83,4.31-3.68c4.07-2.08,7.53-4.53,8.6-9.4
		c0.25-1.15,1.3-2.23,2.91-1.6c13.74,7.1,26.3,16.01,38.6,25.3c14.16,10.69,27.64,22.16,39.71,35.22c0.27,0.99,0.75,1.77,1.89,1.89
		C689.46,171.9,694.23,176.42,698.06,181.79z"
        />
        <path
          class="st71"
          d="M167.05,167.37c0.06-1.36,3.56-0.46,1.94-2.66c-0.89-1.2-2.09-1.26-3.18,0.66c-1.25,2.19-2.56,0.59-3.51-0.8
		l0.04-0.04c1.65-0.93,2.86-2.27,3.73-3.93c8.16-8.18,16.65-15.98,25.92-22.91c0.42,2.46,2.49,2.74,3.96,1.97
		c2.92-1.52,5.56,0.57,8.35,0.04c1.63-0.31,2.04,1.14,2.05,2.55c0.01,1.92,0.15,3.84-0.02,5.74c-0.3,3.43,0.41,5.67,4.58,5.04
		c2.65-0.4,3.39,1.26,3.1,3.5c-0.46,3.57,1.34,4.45,4.48,4.16c1.74-0.16,3.52,0.1,5.26-0.06c3.67-0.34,5.18,0.39,5.95,4.86
		c1,5.78,6.74,1.92,10.29,2.73c1.9,0.43,4.81,0.97,4.72-2.77c-0.04-1.6,0-3.19,0-4.79c1.12-1.15,2.49-1.1,3.91-0.86
		c8.23,2.8,13.24,9.29,12.75,16.27c-0.23,3.23-1.37,5.21-5,4.68c-0.79-0.12-1.64-0.21-2.3-0.63c-3.7-2.33-6.59-3.38-8.39,2.39
		c-0.95,3.07-6.15,3.36-9.15,0.85c-1.56-1.31-3.08-2.02-5.09-2.21c-5.11-0.48-10.62,1.62-15.22-2.27c-0.09-0.07-0.34-0.12-0.45-0.04
		c-5.04,3.77-7.87-0.65-11.62-2.75c-3.27-1.83-7.16-2.68-11.09-2.6c-2.87,0.06-5.78-0.27-8.62,0.06
		C177.54,174.38,171.96,171.91,167.05,167.37z"
        />
        <path
          class="st67"
          d="M57.59,451.5c0.06-1.75,0.01-3.5,0.2-5.24c0.16-1.52-0.36-2.8,2.66-3.02c2.19-0.16,6.12-1.88,7.45-4.14
		c1.46-2.5,3.03-2.31,4.99-2.32c7.47-0.04,14.94-0.09,22.41,0.02c2.55,0.04,3.95-0.65,3.7-3.47c-0.24-2.62,0.65-4.22,3.68-4.27
		c3.26-0.06,4.25,1.61,3.96,4.47c-0.3,3.04,1.5,3.43,3.85,3.24c0.84,3.37-1.71,7.82-5.69,8.61c-4.27,0.85-7.21,4.13-11.51,5.15
		c-3.18,0.75-5.21,4.93-5.1,8.47c0.1,3.24-0.57,5.97-2.12,8.58c-2.35,3.96-3.38,8.17-3.04,12.77c0.23,3.07-0.29,6.01-1.98,8.69
		c-1.29,2.04-2.79,3.06-5.07,1.42c-1.28,0-2.57-0.11-3.83,0.02c-2.88,0.3-4.17-0.82-3.87-3.79c0.13-1.24,0.25-2.81-1.3-3.23
		c-1.13-0.31-2.02,0.58-2.66,1.62c-0.95,1.52-0.21,2.19,1.05,2.99c3.23,2.05-0.66,3.64-0.09,5.52c-3.3-0.13,0.23-3.99-2.76-4.09
		l-0.24-0.26l0.16-0.32c-1.05-2.56,0.39-4.8,0.76-7.26c-0.63,0.62,0.3,2.75-1.72,2.14C59.31,473.13,57.76,462.4,57.59,451.5z"
        />
        <path
          class="st64"
          d="M743.22,299.67c0-0.92,0-1.84,0-3.83c1.68,3.39,3.91,3.13,5.96,2.74c2.55-0.49,1.68-2.76,1.65-4.32
		c-0.05-2.57,1.2-2.96,3.46-3.33c3.05-0.49,6.27,0.95,9.15-0.88c5.31,12.34,9.46,25.06,12.45,38.16c0.7,1.76,1.24,4.02,1,5.44
		c-0.69,4,1.1,9.2-4.25,11.53c-0.73,0.42-1.5,0.77-2.27,1.11c-1.48,0.45-2.25,1.53-2.57,2.99c-0.46,2.72-2.08,4.26-4.77,4.72
		c-1.53,0.33-2.53,1.2-2.86,2.77c-0.44,1.28-0.56,2.7-1.64,3.7c-1.04,0.59-2.33,0.87-3.16,0.14c-3.32-2.94-7.08-2.94-11.15-2.31
		c-3.63,0.56-5.91-1.73-7.65-4.59c-0.94-1.54-0.84-3.06,0.54-4.3c4.94-4.46,8.25-9.94,10.41-16.2c0.62-1.8,2.33-2.99,3.26-4.65
		c1.33-4.79,0.87-9.62,0.26-14.43c-0.43-1.05-0.87-2.11-1.1-3.22c-0.14-1.69-0.67-3.14-2.41-3.85c-0.52-0.36-0.92-0.83-1.21-1.38
		c-0.39-1.61-1.87-2.08-3.04-2.88C742.4,301.76,742.33,300.73,743.22,299.67z"
        />
        <path
          class="st72"
          d="M142.81,658.33c1.54-0.11,2.96,0.41,3.83,1.59c1.63,2.23,3,4.04,6.18,1.96c1.17-0.77,2.85,0.86,3.34,2.02
		c1.05,2.46-2.28,1.33-2.76,2.76c2.55,0.84,6.74-1.12,6.77-3.71c0.03-3.95,2.23-3.9,4.97-3.8c2.55,0.09,5.11,0.02,7.67,0.02
		c6.02,0.37,9.03-4.55,12.55-7.89c3.14-2.98,7.42-4.29,10.07-7.84c0.72-0.97,2.38-0.64,3.52,0.21c0.38,4.41,3.19,7.01,6.77,9.02
		c0.54,2.95-1.92,3.8-3.67,4.97c-8.89,5.94-17.59,12.16-26.33,18.33c-3.98,2.81-3.78,2.78-0.24,6.11
		c15.36,14.48,31.73,27.68,49.24,39.5c6.36,4.29,13.12,7.92,19.57,12.04c1.82,1.16,4.2,1.78,4.9,4.27c0.01,0.31-0.02,0.61-0.11,0.91
		c-2.77-0.92-4.06,3.95-7.14,1.83c-5.67-3.23-11.34-6.47-17.01-9.7c-2.34-0.69-4.4-1.87-6.1-3.63c-27.37-19.83-53.24-41.32-75-67.39
		C143.41,659.45,143.14,658.86,142.81,658.33z"
        />
        <path
          class="st59"
          d="M771.99,344.73c2.18-2.14,2.18-2.14,2.42-10.74c1.58-0.15,0.89,1.94,2.25,2.18c0.18-2.73-1.45-5.25-0.76-7.97
		c4.83,15.59,7.31,31.65,9.51,47.76c0.5,3.62,0.61,7.3,0.91,10.95c-5.86,5.08-2.25,11.2-1.86,14.91c0-3.03,0-3.03,2.2-4.24
		c0.25,1.98,0.26,3.95,0.02,5.9c0.72-0.53-0.28-1.93,0.77-2.44c1.36,13.92,1.4,27.84,0.02,41.76c-1.24-0.93-0.05-2.58-1.13-3.96
		c-0.05-0.26-0.43,0.85,0.06,0.44c0.8,2.06,0.51,4.12,0.08,6.2c-0.48,0.05-1.16,0.09-1.26-0.35c-1.18-5.45-3.4-10.91-1.2-16.53
		c2.12-5.39,2-5.65-3.95-5.84c-3.42-0.11-6.99,0.8-10.23-1.1c-1.47-2.2-1.22-4.57-0.7-6.97c3.89-3.3,3.02-6.56-0.09-9.81
		c-0.89-14.26-0.36-28.53-0.29-42.79c0.01-1.11,0.19-2.3,0.82-3.2C772.68,354.53,772.7,349.7,771.99,344.73z"
        />
        <path
          class="st66"
          d="M292.63,107.93c-1.59,0-3.19,0.12-4.77-0.02c-3.16-0.29-5.41,0.26-4.86,4.23c0.13,0.92,0,2.11-1.24,2.2
		c-1.64,0.12-1.62-1.27-1.56-2.34c0.14-2.76-0.37-5.09-3.4-6.04c-0.85-0.26-1.48-0.9-1.34-1.73c0.95-5.88-3.2-5.23-6.55-4.84
		c-4.51,0.53-6.37-3.67-9.83-4.88c12.26-6.53,24.91-12.16,38.17-16.37c2.71,0,4.64,2.24,7.51,2.34c1.87,0.06,1.8,2.54,1.48,4.33
		c-0.29,1.59-0.06,3.01,1.97,2.95c5.91-0.2,7.68,4.16,9.44,8.49c0.58,1.41,1.49,2.38,2.8,3.07c0.15,2.41-1.34,2.45-3.11,2.19
		c-8.65-1.29-16.46,0.6-23.32,6.14C293.64,107.93,293.11,107.93,292.63,107.93z"
        />
        <path
          class="st59"
          d="M770.07,421.43c4.61,0,9.22,0.1,13.82-0.02c4.2-0.11,4.43,2.94,2.91,4.96c-4.88,6.44-0.69,12.71-0.43,19.04
		c0.39,0.24,0.7,0.56,0.93,0.96c0.28,3.89-0.24,7.72-1.02,11.52c-2.74,2.9-2.74,2.9-5.62-0.59c0.54,3.52,0.62,6.07-3.49,7.55
		c-2.84,1.03-4.99,3.74-8.41,4.52c-2.19,0.5-0.88,4.11-2.52,5.76c-4.49,1.99-7.68,1.61-8.48-1.43c-1.46-5.57-1.61-9.64,3.36-11.24
		c4.33-1.4,5.1-5.81,1.95-9.25c-3.7-4.04-3.88-5.73-0.66-10.3c1.06-1.51,1.36-2.76,0.39-4.32c-2.71-4.4-1.86-9.28-1.45-13.96
		C761.72,420.32,765.1,419.27,770.07,421.43z"
        />
        <path
          class="st73"
          d="M241.92,740.64c2.65-0.01,4.51-1.81,6.66-2.96c1.64-1.08,3.09-0.18,4.43,0.58
		c12.57,7.13,25.98,12.4,39.3,17.9c23.19,8.98,46.95,15.84,71.56,19.64c1.58,0.24,3.12,0.61,4.6,1.19c2.15,1.11,4.54,0.52,6.78,0.95
		c0.77,0.19,1.46,0.52,1.92,1.19c-0.87,2.57-3.14,0.53-4.18,1.34c1.14-0.03,2.64-0.09,4.13,0.09c1.11,0.13,2.5,0.41,2.58,1.69
		c0.1,1.42-1.43,1.73-2.42,1.67c-2.85-0.18-5.7,0.87-8.54-0.02c-7.65,0.28-14.84-2.74-22.4-3.11c-2.82,0.63-5.44,0.4-7.57-1.83
		c-9.31-2.53-18.62-5.05-27.94-7.58c-0.58,0.52-0.85,0.39-0.81-0.38c-12.48-4.77-24.96-9.53-37.44-14.3
		C262.39,751.3,251.64,746.96,241.92,740.64z"
        />
        <path
          class="st74"
          d="M623.24,728.15c-20.58,13.06-41.98,24.52-64.64,33.55c-0.4,0.16-0.92,0.01-1.39,0
		c-2.65-0.84-2.71-1.93-0.15-2.91c2.56-0.98,4.98-1.92,4.74-5.32c3.31-3.46,7.94-4.55,12.06-6.45
		c28.51-13.14,54.66-29.95,78.8-49.98c1.35-1.12,2.34-3.26,4.76-2.34c1.95,1.68,2.59,3.7,1.59,6.15
		c-8.28,8.08-18.07,14.27-27.03,21.5C629.5,724.94,626.77,727.15,623.24,728.15z"
        />
        <path
          class="st64"
          d="M604.56,104.91c-0.41,0.24-1.14,0.44-1.17,0.71c-0.89,7.92-8.14,9.93-13.09,14c-2.4,1.97-2.96,3.9-1.42,6.51
		c-2.79,2.16-6.98,0.11-9.49,3.13c-2.11-0.83-1.99-3.02-2.83-4.62c-2.97-2.87-4.68-6-2.06-10.01c3.32-0.54,3.68-3.13,3.81-5.73
		c0.22-4.22-0.83-8.64,2.29-12.32c0.41-0.48,0.46-1.08-0.17-1.62c-1.76-1.48-1.73-1.51-1.13-3.34
		C588.12,95.27,596.55,99.69,604.56,104.91z"
        />
        <path
          class="st73"
          d="M659.01,700.85c0.42-2.38-1.75-3.88-2.03-6.02c1.6-4.34,5.89-6.07,8.98-8.89c4.09-3.73,7.9-7.75,11.99-11.46
		c1.94-1.76,1.71-2.9-0.33-4.44c-1.8-1.36-4.36-2.17-4.66-4.98c9.47,0.45,16.52-3.88,22.05-11.17c0.67-0.88,1.1-2.11,2.31-2.21
		c3.53-0.29,7.32,0.56,10.13-2.59c0.1-0.11,0.83,0.34,1.27,0.52C694.18,668.66,677.63,685.76,659.01,700.85z"
        />
        <path
          class="st63"
          d="M766.23,475.11c0-1.59-0.01-3.18,0.02-4.77c0.01-0.95,0.28-2.67,0.85-2.46c5.3,1.94,6.64-5.23,11.39-4.76
		c1.62,0.16,1.6-2.13,1.47-3.43c-0.2-2.04-0.68-4.03,0.31-6.25c2.52,0.89-0.12,9,6.01,4.42c0.08,2.08,0.3,4.17-0.76,6.11
		c-0.14-0.54-0.3-1.68-0.7-1.35c-1.06,0.86-2.75,2.36-2.05,3.43c2.5,3.8-1.93,7.15-0.32,10.78c0.33,0.74-0.06,1.54-1.17,1.58
		c-0.91,0.03-2.08,0.73-2.65-0.25C775.52,472.83,770.54,475.4,766.23,475.11z"
        />
        <path
          class="st59"
          d="M786.37,397.46c-2.23,2.97,0,6.56-1.8,9.74c-0.55-5.54-3.98-10.54-2.79-16.38c0.47-2.28,2.72-2.95,4.55-3.9
		c0.04,0.78,0.07,1.55,0.11,2.33c0.72,2.18,0.28,4.43,0.39,6.65C786.87,396.47,786.71,396.99,786.37,397.46z"
        />
        <path
          class="st75"
          d="M623.24,728.15c2.91-1.93,5.83-3.86,8.74-5.79c-0.68,3.14-3.38,4.32-5.71,5.85
		C625.25,728.19,624.25,728.17,623.24,728.15z"
        />
        <path
          class="st76"
          d="M218.81,727.32c2.6,0.25,4.22,2.16,6.1,3.63C221.62,731.84,219.72,730.41,218.81,727.32z"
        />
        <path
          class="st61"
          d="M61.48,483.79c1.25-0.54,0.8-1.95,1.66-3.17c1.05,3.09-1.19,5.6-0.71,8.29
		C61.49,487.32,61.37,485.58,61.48,483.79z"
        />
        <path
          class="st57"
          d="M48.26,406.39c0.16-3.28-0.84-6.63,0.66-9.82C48.99,399.86,49.13,403.16,48.26,406.39z"
        />
        <path
          class="st77"
          d="M787.3,446.35c-0.31-0.32-0.62-0.64-0.93-0.96c0-2.14,0-4.28,0-6.42c0.19-0.02,0.38-0.04,0.57-0.06
		c0.18,1.3,0.36,2.6,0.53,3.9C787.41,443.99,787.36,445.17,787.3,446.35z"
        />
        <path
          class="st67"
          d="M786.37,397.46c0-0.32,0-0.63,0-0.95c0.29-0.44,0.58-0.45,0.88-0.01c0.07,1.51,0.13,3.03,0.2,4.54
		c-0.15,1.02-0.31,2.04-0.46,3.07c-0.21-0.01-0.42-0.02-0.63-0.02C786.37,401.88,786.37,399.67,786.37,397.46z"
        />
        <path
          class="st70"
          d="M166.06,160.6c-0.27,2.24-0.95,4.08-3.73,3.93C163.57,163.22,164.82,161.91,166.06,160.6z"
        />
        <path
          class="st59"
          d="M787.25,396.5c-0.29,0-0.59,0-0.88,0.01c0.02-2.42,0.04-4.84,0.06-7.26
		C787.48,391.58,787.38,394.04,787.25,396.5z"
        />
        <path
          class="st57"
          d="M49.23,389.17c0.13-2.03-0.8-4.18,0.72-6.05C50.14,385.19,50.21,387.24,49.23,389.17z"
        />
        <path
          class="st53"
          d="M412.74,48.11c-0.13-0.15-0.18-0.32-0.16-0.51c1.93-1.34,3.81-1.6,5.56,0.32c0,0,0.13,0.19,0.13,0.19
		C416.42,48.1,414.58,48.11,412.74,48.11z"
        />
        <path
          class="st68"
          d="M684.76,167.33c-0.36,0.6-0.94,1.03-1.47,0.45c-0.56-0.61-1.48-1.36-0.42-2.34
		C683.74,165.83,684.44,166.39,684.76,167.33z"
        />
        <path
          class="st63"
          d="M782.62,484.99c0.1-1.72-0.73-3.59,0.82-5.07C783.6,481.68,783.44,483.39,782.62,484.99z"
        />
        <path
          class="st63"
          d="M784.52,472.78c0.18-1.79-0.74-3.74,0.81-5.32C785.46,469.3,785.4,471.1,784.52,472.78z"
        />
        <path
          class="st57"
          d="M50.08,375.96c-2.23-2.16-2.28-3.98-4.01-4.94c-1.52-0.84-1-3.19-0.29-4.84c0.4-0.93,1.35-1.39,2.4-1.08
		c2.01,0.6,1.89,2.31,1.9,3.92C50.09,370.9,50.08,372.79,50.08,375.96z"
        />
        <path
          class="st78"
          d="M368.76,783.91c3.38,0.25,6.47-1.8,10.66-0.69c-3.08-3.12-6.39-1.84-9.48-2.54c2.38-1.58,5.14,0.39,7.05-1.61
		c1.41-1.48,3.19-1.14,4.93-1c42.02,3.29,83.78,2.39,124.96-7.84c1.7-0.42,3.4-0.88,5.18-0.74c3.07,1.36,7.14,0.91,8.83,4.81
		c-17.65,5.64-35.83,8.79-54.15,11.08c-31.3,3.91-62.61,3.69-93.88-0.43C371.46,784.75,369.98,784.85,368.76,783.91z"
        />
        <path
          class="st47"
          d="M436.18,791.24c-2.17,0.22-4.34,0.44-6.51,0.68c-0.09,0.01-0.16,0.23-0.24,0.35
		c4.5,2.18,11.57,1.18,14.93-2.18c0.7-0.7,1.36-1.48,2.38-1.39c5.73,0.5,11.3-1.93,17.09-0.76c3.8,0.77,7.27-1.71,11.2-1.4
		c2.56,0.2,5.19-0.45,7.54,0.93c1.15-1.99-1.59-1.29-1.15-2.96c9.37,1.5,17.89-3.11,27.01-4.16c0.17,4.12-0.01,3.5-3.61,4.57
		c-6.63,1.97-13.45,2.85-20.15,4.38c-8.52,1.94-17.25,2.36-25.91,3.35c-18.73,2.14-37.5,2.23-56.22,1.44
		c-8.83-0.37-17.72-1.97-26.7-2.15c2.47-2.13,4.62-5.09,7.9-1.74c0.35,0.35,1.67,0.21,2.22-0.17c4.09-2.83,7.76-0.84,11.47,0.86
		c0.71,0.32,1.65,1.14,2.09,0.93c6.19-3.08,12.89-0.98,19.29-1.61C424.43,789.63,430.46,790.3,436.18,791.24z"
        />
        <path
          class="st73"
          d="M520.9,774.28c-2.06-2.38-5.85-1.36-7.79-3.96c0.29-2.4,2.42-2.24,3.95-2.66
		c13.31-3.72,26.44-7.94,39.29-13.03c1.72-0.68,3.47-1.74,5.43-0.65c1.84,2.15,0.76,3.83-3.19,5.39c-0.83,0.32-3.97-0.2-1.39,2.34
		c-4.66,3.34-10.52,3.87-15.43,6.62c-0.11,0.18-0.22,0.37-0.33,0.56c-1.46,1.01-3.04,1.59-4.85,1.46c-0.21-0.04-0.42-0.08-0.63-0.12
		C530.94,771.58,525.92,772.93,520.9,774.28z"
        />
        <path
          class="st47"
          d="M582.08,759.75c-7.82,0.25-13.6,5.25-20.08,8.63c-3.25-1.21-5.47,1.58-8.27,2.11
		c-3.14,0.6-5.76,4.71-9.51,1.4c-0.54-0.47-1.37-0.07-1.58,0.53c-2.18,6.25-8.67,4.11-12.92,6.25c-2.11,1.06-5.07,2.48-8,2.27
		c-1.76-0.12-4-0.06-4.31-2.09c-0.34-2.28,2.45-1.31,3.21-2.03c3.12-2.97,7.77-0.99,10.83-3.9c2.1-2,3.31,2.38,5.82,0.86
		c0.53-1.3-2.74-1.82-1.31-3.56c0,0,0,0.02,0,0.02c1.93-0.67,4.3-0.02,5.82-1.92c0,0-0.02,0-0.02,0c1.69,0.42,3.38,0.83,5.06,1.26
		c0.86,0.22,1.98,1.08,2.47-0.18c2.06-5.25,6.28-3.06,9.89-3.03c0.45,0,0.89-0.17,1.3-0.25c0.53-1.85-1.74-1.12-1.93-2.46
		c2.77-0.81,5.36-3.37,8.49-0.52c0.69,0.63,2.03,0.04,1.96-0.53c-0.35-2.92,2.78-2.49,3.66-4.07c2.18-3.93,6.95-1.77,9.77-4.26
		c0.58-0.51,1.4,0.41,1.78,1.16c0.43,0.86,1.01,1.83-0.35,2.32C582.86,758.15,582.25,758.71,582.08,759.75z"
        />
        <path
          class="st47"
          d="M338.79,778.96c2.52,0.61,5.05,1.22,7.57,1.83c4.14,3.72,9.5,5.27,14.49,4.48c6.7-1.05,12.22,1.4,18.07,3.33
		c-3.61,0.29-6.96,3.14-10.62,1.83c-5.65-2.02-11.73-1.16-17.37-3.16c-1.99-0.7-5.59,0.36-6.28-0.74
		c-2.83-4.52-7.19-0.53-10.67-2.62c-3.57-2.15-8.38-2.24-12.6-3.22c4.58-3.23,8.98-3.97,13.6,0.18
		C336.6,782.34,337.92,780.46,338.79,778.96z"
        />
        <path
          class="st47"
          d="M310.04,771c0.36-0.06,0.63,0.07,0.81,0.38c0.27,2.55,1.67,2.9,4.01,2.51c2.01-0.34,3.43,1.37,4.76,2.68
		c0.53,0.52-0.24,1.14-0.71,1.49c-1.71,1.3-3.24,0.86-5.22,0.12c-5.37-2.01-10.92-3.52-16.78-5.34c2.22-2.47,4.4-1.31,6.46-0.58
		C305.88,773.14,308.27,773.83,310.04,771z"
        />
        <path
          class="st47"
          d="M295.23,771.38c-5.62-0.03-9.28-3.5-13.73-4.65c-1.23-0.32-2.51-0.98-3.89-1.25
		c-1.1-0.22-2.36-0.76-1.62-2.19c0.5-0.95,1.91-1.83,2.79-1.02c3.21,2.95,6.86,3.21,11,3.07
		C292.62,765.25,292.93,768.93,295.23,771.38z"
        />
        <path
          class="st47"
          d="M516.62,781.54c-0.45,1.66-1.72,1.19-2.72,1.31c-2.07,0.23-2.87-1.01-2.9-2.77c-0.02-1.46,1.3-0.99,2.11-1.01
		C514.91,779.03,515.89,780.18,516.62,781.54z"
        />
        <path
          class="st47"
          d="M589.89,756.05c-2.15-0.28-3.01-1.12-2.28-3.52c0.82-2.71,2.72-4.66,5.05-3.83c3.36,1.2,4.13-0.99,6.15-3.94
		c0.44,2.88,1.36,4.01-1.2,5.77c-2.59,1.78-6.15,2.37-7.74,5.54C589.86,756.07,589.89,756.05,589.89,756.05z"
        />
        <path
          class="st47"
          d="M607.22,741c-1.42,1.97-2.48,2.66-4.39,2.18C603.7,741.58,604.89,741.09,607.22,741z"
        />
        <path
          class="st79"
          d="M418.13,47.92c-1.85-0.11-3.7-0.21-5.56-0.32c-0.67-0.33-1.34-0.67-2.01-1c2.54-0.8,5.08-0.73,7.62-0.05
		c0.54,0,1.07-0.01,1.61-0.01c0.18,0.26,0.31,0.55,0.39,0.85C419.5,47.56,418.82,47.74,418.13,47.92z"
        />
        <path
          class="st80"
          d="M418.19,46.54c-2.54,0.02-5.08,0.03-7.62,0.05C413.1,44.74,415.64,45.34,418.19,46.54z"
        />
        <path
          d="M561.79,753.98c-15.95,6.26-32.21,11.61-48.68,16.34c-15.86,3.45-31.72,6.78-47.87,8.73c-28.16,3.4-56.29,2.75-84.45,0.26
		c-1.26-0.11-2.53-0.17-3.8-0.25c-0.48-0.04-0.96-0.08-1.44-0.13c-2.31-1.01-4.9,0.27-7.19-0.87c-19.65-3.34-39.12-7.46-57.99-14
		c-6.3-2.18-12.72-4.06-18.71-7.07c-4.49-3.05-8.18-6.87-14.45-7.36c-6.22-0.49-10.75-7.79-10.8-14.44
		c-0.04-5.27-0.11-10.53,0.02-15.8c0.09-3.59-1.25-5.46-5-5.22c-0.95,0.06-1.91,0.01-2.87-0.01c-6.67-0.09-7.13-0.34-7.44-6.88
		c-0.17-3.6-1.85-4.58-5.12-4.66c-6.17-0.15-13.43-5.63-15.19-11.17c-0.53-1.67,0.09-2.96,1.8-3.27c3.04-0.54,3.13-2.69,3.11-5.03
		c-0.01-2.55-0.1-5.11,0.02-7.66c0.27-5.48,0.45-10.88-4.97-14.38c-0.94-2.54,0.79-4.56,1.38-6.88c-1.12-0.15-1.96,0.97-3.07,0.61
		c-0.86-0.2-1.46-1.3-2.57-0.64c-0.67,0.4-1.42,0.68-2.14,0.99c-3.59,1.58-7.79,2.69-10.8,0.31c-2.95-2.33,1.45-5.19,1.35-8.05
		c2.64-3.74,6.63-5.5,10.63-7.24c1.19-0.07,2.41-0.08,3.27-1.14c0.33-0.26,0.7-0.44,1.11-0.54c2.27-0.15,3.88-1.45,5.31-3.05
		c0.31-0.31,0.68-0.54,1.08-0.73c1.84-0.33,3.22-1.27,3.97-3.02c0.54-0.75,1.32-1.13,2.19-1.34c1.62-0.14,2.84-1.01,3.88-2.21
		c4.94-3.67,10.71-5.45,16.5-7.11c3.09-0.89,5.98-0.48,8.3,2.04c25.43,33.09,59.21,51.38,100.32,56.88
		c8.85,1.18,17.72,1.82,26.62,2.4c11.66,0.57,23.32,0.76,34.96-0.14c9.02-0.78,18.11-0.5,27.11-2c14.2-2.37,28.06-5.81,41.36-11.35
		c6.18-1.69,12-4.21,17.42-7.63c14.63-6.53,27.17-16.15,39.26-26.44c2.17-1.85,4.25-3.82,5.75-6.29c3.08-4.03,6.97-7.37,9.88-11.56
		c1.48-2.13,3.75-2.05,6.05-1.58c8.6,1.77,16.86,4.65,24.76,8.4c9.58,4.55,19.59,8.39,27.88,15.32c0.81,1.55,2.06,2.42,3.86,2.47
		c6.01,3.16,12.17,6.02,17.86,9.76c1.19,0.78,2.45,1.49,2.83,3.02c5.29,3.57,10.58,7.14,15.87,10.7c0.32,0.34,0.6,0.73,0.97,1.01
		c8.22,6.01,8.22,6,1.03,12.98c-5.73,5.56-11.59,10.97-17.98,15.78c-27.98,24.26-59.14,43.42-93.16,57.99
		C563.11,753.13,562.47,753.59,561.79,753.98z"
        />
        <path
          class="st72"
          d="M632.95,640.16c-9.96-6.46-20.48-11.86-31.41-16.46c-7.05-2.97-14.24-5.49-21.73-7.17
		c-2.63-0.59-4.39-0.38-5.95,2.18c-2.46,4.04-5.9,7.33-9.21,10.7c-2.77-0.06-3.05-2-3.1-4.11c-0.04-1.7,0.21-3.36,0.7-4.99
		c5.24-5.53,4.28-11,0.81-17.26c-3.38-6.11-5.81-12.78-8.83-19.12c-1.81-3.78-1.8-7.02,1.4-9.94c2.53-2.31,3.44-6.52,7.82-6.65
		c1.93,2.65,4.54,4.77,4.98,8.48c0.28,2.33,2.6,2.63,3.9,0.9c2.25-2.99,5.33-3.18,8.5-3.45c4.39-0.38,8.18-1.99,11.81-4.58
		c4.39-3.14,9.88-4.11,14.77-6.37c8.89-4.1,18.61-6.04,27.46-10.46c4.7-2.34,9.1-5.26,13.84-7.34c4.57-2,9.58-3.06,14.24-5.02
		c1.76-0.74,3.42-1.59,5.12-2.41c3.5-1.7,5.14-4.38,5.65-8.01c3.63-1.12,7.11,0.4,10.57,0.93c3.58,0.55,0.63,3.02,0.46,4.53
		c1.75,0.91,3.25-0.81,4.79,0c0,6.47,0.59,13.06-3.75,18.65c2.37,4.95-4.57,6.29-4.08,10.87c0.45,4.19,0.61,8.52-0.59,12.8
		c-1.1,3.92-2,7.71-5.98,9.82c-1.4,0.74-0.92,2.26-0.93,3.47c-0.04,5.74-0.14,11.49,0.03,17.22c0.08,2.94-0.96,4.71-3.93,4.75
		c-3.36,0.04-3.83,1.98-3.81,4.72c0.07,9.41,0.04,18.82,0.02,28.23c-0.01,5.93-3.36,9.19-9.43,9.27
		c-7.11-4.14-14.23-8.27-21.34-12.41C634.78,641.41,633.47,641.41,632.95,640.16z"
        />
        <path
          class="st81"
          d="M758.56,486.62c1.31,4.68-3.33,5.42-5.34,7.84c-1.23,1.49-2.56,2.16-0.33,3.99c1.79,1.46,1.56,4.83,0.59,5.7
		c-4.06,3.65-2.45,8.16-2.49,12.31c-0.03,3.36-0.7,5.2-4.47,4.71c-1.66-0.21-3.63,0.1-3.21,2.34c1.61,8.49-5.59,11.42-10.07,15.85
		c-1.92,1.9-3.23,5.78-7.05,4.72c-5.86-1.63-12.69-0.46-17.52-4.67c-3.05-2.65-6.02-3.1-9.55-2.94c-2.67-2.59-5.67-4.36-9.59-3.84
		c-1.87-3.9,1.64-4.58,3.66-6.16c4.03-0.8,7.01,1.62,10.06,3.51c8.77,5.42,18.54,3.39,25.31-4.3c4.07-4.62,7-10.13,11.64-14.24
		c0.99-0.88,1.51-2.17,1.49-3.43c-0.09-4.94,2.48-8.77,5-12.65c1.79-4.49,0.99-9.06,0.43-13.62c-0.33-2.7-1-5.5,2.27-7.03
		c1.33-0.12,2.23,0.64,2.31,1.8C752.02,481.26,755.45,483.82,758.56,486.62z"
        />
        <path
          class="st74"
          d="M693.37,526.88c-0.3,2.57-4.93,2.25-3.83,5.75c0,0.64,0,1.28,0,1.92c-0.65,0.44-1.25,0.97-1.96,1.3
		c-1.98,0.91-4.2,1.36-5.32-0.97c-1.27-2.65,2.4-1.64,3-3.57c-3.63-1.21-7.88,0.17-11.06-2.5c-1.03,0.91-2.18,1.08-3.45,0.59
		c-3.91-3.53-7.71-7.16-10.54-11.69c-0.88-1.42-2.66-2.44-1.37-4.48c4.1-0.1,5.31,3.68,7.79,5.76c5.57,3.92,11.5,6.36,18.56,5.76
		C687.96,524.51,691.34,523.56,693.37,526.88z"
        />
        <path
          class="st60"
          d="M198.68,643.85c-3.93-1.51-4.06,2.98-6.32,4.27c-5.39,3.07-10.76,6.68-13.84,12.52
		c-0.83,1.58-1.9,1.85-2.67,0.21c-0.7-1.48-1.72-1.7-3.05-1.66c0-4.14,0.02-8.27-0.01-12.41c-0.03-3.79-0.33-7.46,2.75-10.65
		c1.96-2.03,1.4-5.19,0.8-7.8c-0.47-2.08,0.01-4.11-0.21-6c-0.76-6.54,4.27-11.02,5.29-16.83c0.03-1.44,0.53-2.82,0.59-4.25
		c0.15-3.43,2.15-4.92,5.31-4.65c3.73,0.32,6.31-1.33,8.71-3.9c4.23-4.52,8.75-8.74,13.06-13.18c1.52-1.57,3.34-2.93,4.01-5.23
		c0.59-2.04,2.17-1.98,3.86-1.48c1.94,0.57,3.44-0.21,3.21-2.21c-0.77-6.8,3.64-7.87,8.76-8.35c9.81-1.14,19.51,1.08,29.3,0.9
		c1.89-0.03,3.67,0.88,5.36,1.76c2.11,4.75,6.03,6.98,10.97,7.77c0.85,0.53,1.27,1.32,1.4,2.29c0.09,1.13,0.22,2.48-0.85,3.06
		c-3.83,2.08-6.31,5.91-9.58,8.17c-5.73,3.97-10.01,9.23-15.13,13.67c-3.3,2.85-5.87,6.13-10.55,7.59
		c-3.89,1.21-6.26,5.66-9.39,8.58c-2.85,2.65-5.03,6.1-9.6,6.43c-2.08,0.15-3.24,2.49-4.65,3.91
		C210.4,632.24,204.59,638.08,198.68,643.85z"
        />
        <path
          class="st72"
          d="M228.4,563.32c-0.38,0.27-0.8,0.82-1.14,0.78c-5.23-0.69-6.1,2.2-5.63,6.51c0.15,1.42,0.68,3.26-1.42,4.09
		c-7.37,2.91-8.97,4.62-14.21,10.43c-3.8,4.21-8.39,7.69-12.03,12.16c-1.15,1.41-3.69,0.67-5.54,0.48c-3.89-0.4-5.71,0.9-5.12,4.99
		c0.2,1.37-0.19,2.57-1.89,2.74c-2.03-0.24-2.17-1.81-1.87-3.2c0.97-4.47-2.81-10.02,3.41-13.51c1.07-0.6,0.22-4.51,0.39-6.88
		c0.2-2.93-0.86-5.81,2.87-8.17c2.94-1.86-1.12-2.32-2.46-3.55c3.03-2.23,3.87-5.28,3.41-8.78c4.16-2.7,8.82-0.7,13.19-1.41
		c7-0.46,13.9,0.77,20.84,1.3C223.49,562.33,226.36,561.37,228.4,563.32z"
        />
        <path
          class="st82"
          d="M200.6,561.39c-4.47,0-8.95,0-13.42,0.01c-1.28,0-2.56,0-3.83,0c-1.28,1.02-2.56,1.02-3.83,0
		c-5.14,1.19-9.92,3.76-15.34,3.83c-0.37-0.28-0.7-0.68-1.12-0.83c-0.96-0.35-2.51,0.04-2.45-1.59c0.06-1.58,1.48-1.26,2.53-1.42
		c1.16-0.18,2.92,0.67,3.33-0.9c0.45-1.71-1.43-1.63-2.49-2.18c-3.87-1.99-2.98-6.01-3.51-9.23c-0.45-2.71-0.42-4.58-4.01-5.13
		c-3.73-0.58,0.12-2.37,0.04-3.63c0.24-2.65,1.47-4.52,4.22-4.99c2.77-0.48,4.43-3.09,7.15-3.64c2.14,0.06,3.89-2.2,6.22-1.08
		c1.49,1.41,2.03,3.32,2.17,5.2c0.46,6.12,3.94,10.81,7.08,15.68c0.63,0.97,1.1,1.97,1.17,3.09c0.17,2.89,1.74,3.91,4.47,3.51
		c2.71-0.62,5.4-0.23,8.03,0.35C198.61,558.77,200.61,558.95,200.6,561.39z"
        />
        <path
          class="st72"
          d="M179.51,561.4c1.28,0,2.56,0,3.83,0c-0.11,1.33-0.82,1.93-2.15,1.85
		C180.02,563.17,179.63,562.42,179.51,561.4z"
        />
        <path
          class="st83"
          d="M75.97,490.45c4.8,0.38,5.58-3.87,5.52-6.49c-0.19-7.63,0.97-14.62,5.46-20.92c0.33-0.46,0.58-1.37,0.35-1.77
		c-3.35-5.8,2.79-8.21,4.36-12.22c0.38-0.96,1.65-0.75,2.59-0.78c2.15-0.07,4.55,0.56,5.09-2.77c0.21-1.32,1.81-1.16,2.86-1.03
		c4.53,0.54,5.46-3.92,8.2-5.86c0.31-0.22,0.08-1.21,0.09-1.85c1.29-0.21,3.04,0.59,3.61-1.32c0.58-1.95-1.08-2.04-2.3-2.78
		c-2.55-1.54-0.83-4.29-1.31-6.45c0.89-0.92,1.84-1.7,3.25-1.51c3.08,0.42,10.61,8.84,10.98,12.28c-0.9,2.89-2.79,5.08-5.34,6.53
		c-5.46,3.1-9.8,8.33-16.76,8.66c-1.81,0.08-3.18,1.45-4,3.12c-1.22,2.48-2.74,4.67-5.13,6.18c-0.99,0.62-1.4,1.67-1.63,2.82
		c-1.98,9.8-2.24,19.59,0.05,29.39c0.44,1.87,1.01,3.76-0.6,5.4c-2.38-3.94-5.98-5.38-10.37-4.66
		C77.61,494.97,75.58,494.34,75.97,490.45z"
        />
        <path
          class="st59"
          d="M91.31,499.08c-0.73-6.44-1.71-12.84-2.37-19.29c-0.64-6.26,2.15-11.78,1.95-17.77
		c6.07-2.74,6.4-12.94,15.43-11.88c0.6,0.07,1.44-0.01,1.82-0.38c4.93-4.74,12.36-6.43,15.76-13c0.7-0.9,0.61-2.37,1.99-2.79
		c2.29-0.46,4.32-2.43,6.91-1.2c1.91,2.4,0.82,4.18-1.3,5.55c-10.38,6.73-19.63,15.1-30.99,20.43c-5.26,2.47-6.13,8.2-6.7,13.48
		c-0.51,4.74-0.69,9.52,0.23,14.26c0.55,14.55,8.01,25.92,17.41,36.05c4.26,4.59,9.54,8.38,15.35,11.18
		c1.19,0.57,3.86,0.64,2.29,3.33c-2.09,0.21-4.15,0.08-6.15-0.58c-12.09-5.33-20.49-14.75-27.41-25.52
		C93.32,507.51,92.67,503.07,91.31,499.08z"
        />
        <path
          class="st59"
          d="M122.94,536.47c2.24,0,4.47,0,6.71,0c1.47-1.42,3.21-1.03,4.96-0.8c9.63,1.3,18.66-0.25,26.88-5.71
		c1.58-1.05,3.37-1.81,5.27-2.2c1.07-0.12,2.09,0.01,3.02,0.61c1.7,2.37-0.34,3.18-1.77,4.25c-3.39,3.22-8.77,3.47-11.51,7.67
		c-5.37,0-10.76-0.34-16.1,0.08C134.08,540.89,128.38,539.49,122.94,536.47z"
        />
        <path
          class="st69"
          d="M171.84,252.7c0-0.32,0-0.64,0-0.96c5.17-0.51,4.66,3.73,5.63,6.73c0.61,3.41-0.67,5.78-3.79,7.35
		c-4.49,2.24-7.3,7.05-12.82,7.94c-1.98,0.32-2.54,3.04-2.95,5.1c-0.3,1.54-0.11,3.19-1,4.61c-1.71,1.24-2.6,3.17-3.83,4.78
		c-3.52,4.61-7.8,5.56-12.98,3.34c-6.23-2.67-11.94-6.37-18.11-9.17c3.02-3.52,7.44-1.62,11.09-2.78c1.64-0.52,3.51-0.15,4.25-2.29
		c0.19-0.55,0.81-1.42,1.11-1.38c5.76,0.93,9.43-5.05,15.39-4.37c2.62,0.3,6.74-0.84,6.6-5.52c-0.04-1.41,1.07-1.66,2.29-1.88
		C169.46,263.02,171.84,259.98,171.84,252.7z"
        />
        <path
          class="st83"
          d="M121.98,282.41c1.15,0.53,2.25,1.19,3.62,0.6c2.02-0.88,3.31-0.84,4.31,1.79c0.96,2.51,15.25,8.02,17.38,6.78
		c2.58-1.51,5.02-3.64,6.26-6.48c0.69-1.58,1.64-1.7,2.94-1.73c0.69,0.55,0.97,1.31,1.11,2.15c-0.51,8.52-3.6,11.33-11.89,10.76
		c-2.53-0.17-5.11,0.2-7.57-0.63c-0.44-0.2-0.83-0.49-1.15-0.84c-0.75-1.68-1.86-2.84-3.89-2.73c-0.69-0.12-1.33-0.35-1.92-0.73
		c-3.3-4.27-8.65-4.12-13.04-6.06c0.64-0.64,1.28-1.28,1.92-1.92C120.71,283.05,121.35,282.73,121.98,282.41z"
        />
        <path
          class="st63"
          d="M758.56,486.62c-3.39-0.41-7.47-4.42-7.67-7.52c-0.09-1.38,0.41-2.91-0.95-3.99c-5.42-4.25-5.62-11.7,0-16.24
		c4.5-3.64,7.18-7.87,7.38-13.71c0.1-2.88,1.74-5.43,2.27-8.25c0.24-1.25,0.79-2.57,0.46-3.76c-1.82-6.6,0.56-12.83,1.45-19.19
		c0.92-2.39,0.29-5,1.09-7.41c0.18-0.48,0.45-0.91,0.78-1.3c1.74-1.2,1.48-3.06,1.51-4.77c0.09-6.37,0.44-12.78-0.09-19.11
		c-0.49-5.88-3.54-11.05-6.36-16.17c-0.48-0.57-0.86-1.21-1.12-1.91c-0.37-1.38,0.36-2.32,1.26-3.21c0.14-1.32-0.44-2.83,0.96-3.83
		c0.97-0.95,1.93-1.9,2.88-2.88c2.39-0.8,3.99-2.4,4.79-4.79c0.97-0.95,1.93-1.9,2.88-2.88c0.41-0.77,1.13-0.94,1.92-0.96
		c2.58,2.46,3.05,9.08,0.29,12.35c-1.97,2.34-2.24,4.7-2.23,7.46c0.05,13.85,0.02,27.7,0.02,41.55c-2.37,2.56-1.61,5.11,0,7.67
		c0,2.56,0,5.11,0,7.67c-7.67,0.01-7.68,0.01-7.66,7.92c0.01,3.6-0.67,7.3,2.9,10.02c1.77,1.35,0.49,2.58-0.94,3.74
		c-4.37,3.56-4.04,6.07,0.38,9.17c3.17,2.23,0.94,5.87,1.42,8.83c0.3,1.83-0.94,2.46-2.65,2.49c-2.72,0.03-5.86-0.15-5.32,3.98
		c0.48,3.63-0.85,9.04,6.12,7.54c0.61-0.13,1.27-0.02,1.91-0.02c-0.31,3.82-0.04,7.92-5.85,7.8
		C758,482.87,758.75,485.15,758.56,486.62z"
        />
        <path
          class="st63"
          d="M758.56,360.07c-0.32,0.96-0.64,1.92-0.96,2.87c-3.79,2.55-6.87-0.36-10.2-1.33
		c-2.21-2.79-5.34-2.67-8.23-2.04c-7.32,1.59-19.13,9.17-17.9,19.36c-0.06,0.49-0.17,0.96-0.32,1.42c-0.84,3.13-2.88,5.23-5.65,6.75
		c-3.76,1.54-7.54,1.56-11.35,0.2c-5.32-3.55-1.83-7.18-0.09-10.8c0.14-0.41,0.35-0.8,0.6-1.15c1.45-1.01,3.36-1.57,3.74-3.68
		c0.27-0.35,0.61-0.62,1-0.81c2.46-0.4,4.37-1.49,5.9-3.62c2.94-4.11,6.68-7.48,9.24-12.06c1.75-3.13,6.48-4.29,9.02-7.48
		c1.38-1.73,3.3-3.04,4.11-5.23c1.49-2.73,4.61-4.37,5.16-7.73c4.36-5.92,4.72-13.15,2.35-19.07c-2.2-5.52-5.3-11.6-11.13-15
		c-1.5-1.52-3.07-2.92-5.35-3.15c-0.41-0.19-0.74-0.46-1.01-0.82c-0.24-0.68-0.19-1.3,0.36-1.82c6.15-1.71,9.97,4,15.34,4.79
		c0.03,1.05-0.17,2.19,0.96,2.88c1.01,0.9,1.97,1.86,2.88,2.88c0.32,0.32,0.64,0.64,0.96,0.96c1.62,0.78,1.91,2.56,2.88,3.83
		c0.32,0.96,0.64,1.92,0.96,2.88c0.76,5.43,0.76,10.87,0,16.3c-4.47,3.9-4.54,10.3-8.37,14.68c-1.3,1.49-2.66,3.1-3.82,4.77
		c-0.87,1.25-3.96,1.43-2.4,3.84c1.4,2.16,2.72,4.63,6.11,4.57c2.94-0.05,5.69-1.38,8.9-0.33
		C754.62,357.7,755.33,361.47,758.56,360.07z"
        />
        <path
          class="st59"
          d="M700.08,221.06c4.21,2.61,6.92,6.83,8.62,11c1.84,4.49,6.48,5.3,8.74,8.85c0.31,0.48,1.81,0.21,2.76,0.28
		c0.05,1.33-0.16,2.45-1.55,3.17c-2.47,1.28-3.61,2.81-0.44,4.7c1.21,0.72,1.39,2.06,0.59,2.84c-4.06,4.03-6.12,9.23-8.68,14.15
		c-0.35,0.67-1.12,1.75-1.49,1.68c-5.3-1.07-8.13,3.08-11.79,5.43c-0.88,0.57-2.01,0.9-2.65,0.24c-2.37-2.44-4.1-0.1-6.27,0.33
		c-6.43,1.29-6.54,5.66-6.07,10.6c-4.57,2.94-6.21,2.85-10.01-0.56c-1.2-5.81,0.97-10.03,6.32-12.13c1.05-0.41,2.05-0.87,2.91-1.61
		c1.23-1.09,2.98-1.21,4.22-2.3c0.4-0.24,0.82-0.43,1.26-0.57c3.69-0.12,7.22-0.85,10.46-2.72c0.89-0.27,1.8-0.35,2.72-0.39
		c8.43-2.81,13.27-11.89,10.05-19.88c-2.07-5.12-3.95-10.37-6.69-15.21C702.32,226.23,697.87,224.91,700.08,221.06z"
        />
        <path
          class="st74"
          d="M672.29,283.37c2.91,3.2,6.32,1.3,9.58,0.96c4.74-0.33,9.28,0.04,12.85,3.72c1.37,1.41,2.56,0.21,3.91-0.04
		c3.13-0.59,6.84-3.09,8.61,2.2c0.21,0.63,1.55,1.09,2.44,1.26c6.06,1.19,12.13,2.28,18.2,3.4c0,0.64,0,1.28,0,1.92
		c-1.01,1.16-2.39,1.21-3.77,1.29c-8.25-0.51-16.21-2.72-24.11-4.79c-8.55-2.24-17.55-2.09-25.86-5.33
		C672.32,286.92,670.75,285.78,672.29,283.37z"
        />
        <path
          class="st84"
          d="M321.4,99.3c-0.8-4.14,3.59-4.86,5.33-7.22c1.03-1.4,2.07-2.54,2.55-4.34c1.12-4.21,3.71-4.83,6.89-1.82
		c2.57,2.43,13.31,2.75,15.89,0.47c3.02-2.66,6.17-2.1,7.2,1.81c0.71,2.69,2.1,3.75,4.44,3.92c2.73,0.2,4.46,2.34,6.79,3.16
		c4.41,1.56,10.55-1.38,12.84-5.83c0.5-0.98,0.72-2.62,1.45-2.87c4.45-1.54,7.14-4.32,7.81-9.1c0.19-1.38,1.77-1.34,2.81-1.14
		c3.91,0.76,9.05-2.5,11.48,3.46c0.17,0.41,1.79,0.23,2.74,0.33c-0.2,4.96-4.42,4.98-7.36,4.88c-4.94-0.18-8.71,2.14-12.76,4.09
		c-1.18,0.57-1.97,1.53-2.72,2.55c-0.72,0.96-1.46,1.91-2.54,2.51c-1.47,0.6-3.04,1.04-3.95,2.53c-1.92,3.01-4.24,3.15-7.76,2.4
		c-9.1-1.93-17.57-6.03-27.2-6.44c-8.41-0.36-13.95,2.97-18.69,9.07c-0.49,0.63-0.94,1.29-1.7,1.63
		C322.55,103.05,322.09,101.07,321.4,99.3z"
        />
        <path
          class="st70"
          d="M385.63,91.63c0.84-1.99,2.81-2.98,4.06-4.34c5.22-5.66,12.85-1.2,18.22-5.2c0.79-0.59,1.56-0.92,1.68-1.96
		c2.33,0.39,3.43-0.72,4.55-2.77c0.9-1.65,0.86-4.08,3.11-4.9c-0.32,2.56-0.64,5.11-0.95,7.67c0.47,2.36,0.6,4.69-0.7,6.88
		c-0.41,0.36-0.87,0.62-1.38,0.79c-8.11,0.94-16.38,1.1-23.87,5.03C388.67,92.88,386.95,93.05,385.63,91.63z"
        />
        <path
          class="st65"
          d="M321.4,99.3c2.47,0.15,1.82,2.63,2.88,3.83c0.8,0.86,0.86,1.82,0.4,2.86c-1.05,1.28-2.39,1.8-4.02,1.55
		c-6.53-3.88-13.05-5.1-19.53,0.12c-2.84,0.33-5.52,1.74-8.48,1.22c0-0.32,0-0.64,0-0.96c2.05-5.52,7.18-5.61,11.76-6.59
		c4.45-0.95,8.76-4.08,13.51-0.77c1.28,0.89,1.97-0.27,2.54-1.27C320.76,99.3,321.08,99.3,321.4,99.3z"
        />
        <path
          class="st62"
          d="M292.63,108.89c2.63-1.73,5.55-2.2,8.63-1.92c0.23,1.99-1.72,2.09-2.65,3.08
		c-6.99,1.67-8.37,8.55-11.87,13.28c-4.17,5.64-6.31,6.35-13.45,5.6c-9.18-0.97-18.71-2.41-27.22,3.23
		c-1.46,0.84-3.23,1.16-4.34,2.6c-0.25,0.33-0.53,0.64-0.82,0.95c-1.27,1.53-3.25,2.6-3.27,4.97c-0.03,0.43-0.11,0.85-0.22,1.26
		c-1.24,3.26-0.46,5.92,2.33,8c0.29,0.29,0.56,0.61,0.81,0.93c0.84,1.08,1.62,2.22,2.9,2.87c0.55,0.24,1.1,0.5,1.62,0.81
		c1.37,0.98,2.48,2.23,3.66,3.42c0.45,0.47,0.82,0.99,1.07,1.59c0.09,0.43,0.03,0.85-0.16,1.25c-0.41,0.24-0.79,0.19-1.13-0.14
		c-1.28,0-2.56,0-3.83,0c-0.96,0-1.92,0-2.87,0c-3.23-2.26-5.56-5.47-8.74-7.88c-3.82-2.89-3.85-11.48-0.84-15.13
		c0.7-1.29,1.1-2.64,0.96-4.13c-0.21-2.25,0.79-2.86,2.97-3.8c3.13-1.34,6.68-2.8,8.62-6.04c0.72-1.2,1.63-1.37,2.76-1.37
		c7.34,0,14.68-0.2,22,0.15c2.05,0.1,4.54,0.1,6.17,2.68c1.48,2.34,2.96-0.08,4.14-1.14c4.34-3.88,7.4-8.77,10.57-13.58
		C290.99,109.57,291.57,108.95,292.63,108.89z"
        />
        <path
          class="st71"
          d="M232.24,137.65c-1.71,6.29-2.58,12.46,5.31,16.64c2.86,1.52,2.2,4.72,4.28,6.37c-1.89,0-3.79,0.03-5.68-0.02
		c-1.07-0.03-2.51,0.16-2.71-1.27c-0.83-5.99-6.33-10.89-4.1-17.59c0.19-0.57,0.05-1.25,0.04-1.88
		C229.35,137.9,230.69,137.64,232.24,137.65z"
        />
        <path
          class="st61"
          d="M125.82,434.85c-0.64,0.64-1.28,1.28-1.92,1.92c-1.07-4.74-9.51-11.37-13.42-10.55
		c0.56-3.7-0.84-5.32-4.73-4.84c-2.2,0.27-4.47-0.03-6.7,0.07c-2.35,0.1-3.79-0.25-4.03-3.23c-0.31-3.79-3.39-4.66-6.64-4.42
		c-3.29,0.25-4.53-0.58-4.99-4.32c-0.44-3.57-2.43-7.22-4.57-10.26c-4.63-6.57-2.69-13.58-2.22-20.54c0.01-0.12,0.33-0.27,0.31-0.34
		c-1.37-4.18,1.74-7.12,2.9-10.61c1.28,0,2.56,0,3.84,0c1.89-0.19,1.51,1.16,1.34,2.16c-0.24,1.37-0.77,2.69-0.61,4.13
		c-2.9,6.39-3.96,12.99-2.44,19.94c0.27,1.24,0.21,2.61,1.2,3.54c6.07,5.74,11.13,12.52,19.23,16.02
		c8.23,3.55,14.49,10.24,21.96,15.07C126.37,429.91,128.54,432,125.82,434.85z"
        />
        <path
          class="st82"
          d="M478.62,87.8c4.31-0.61,8.92,0.91,12.97-1.83c0.51-0.35,1.45-0.83,2.14-0.03c3.3,3.8,6.99,2.87,10.77,0.9
		c7.04,2.77,13.33,6.95,19.96,10.51c0.79,0.43,1.05,1.13,1.14,1.95c-1.01,1.14-2.37,1.19-3.74,1.17c-4.45-0.7-8.4-2.73-12.54-4.39
		c-8.85-3.55-18.08-4.78-27.42-1.47c-1.55,0.55-2.76,1.55-3.83,2.77c-7.12,8.15-4.45,22.49,5.13,27.43
		c10.32,5.32,12.23,9.43,8.6,20.34c-1.3,3.92-0.97,8.29-3.42,11.85c-0.75,0.4-1.5,0.4-2.25-0.01c-2.26-4.88-1.01-10.04-1.07-15.06
		c-0.09-8.05-0.11-8.45-7.53-10.89c-2.02-0.67-3-2.14-4.11-3.74c-2.35-3.4-3.68-7.4-6.41-10.59c-1.32-1.54-1.44-3.63-1.11-5.49
		c1.05-5.91,3.62-11.38,5.16-17.18C471.91,90.81,476.32,90.22,478.62,87.8z"
        />
        <path
          class="st72"
          d="M521.76,99.31c1.28,0,2.56,0,3.84,0c4.09-2.45,7.99-2.14,12.33-0.13c5.04,2.33,10.75,3.31,15.79,5.38
		c3.3,1.36,8.81,0.85,9.95,6.21c0.03,0.13,0.26,0.35,0.31,0.33c4.52-1.82,6.73,3.19,10.5,3.55c-1,3.78,0.89,6.7,2.88,9.59
		c0.3,2.06-1.1,2.78-2.53,2.17c-3.11-1.31-2.85,0.89-3.47,2.66c-0.7,2.01,0.47,4.97-2.72,5.83c-1.29-5.3-4.23-10.27-3.01-16.07
		c0.52-2.46-1.35-4.01-3.05-4.98c-4.67-2.68-9.54-4.99-15.01-5.59c-5.54-0.32-11.25,0.27-16.2-3.08c-2.26-2.43-5.23-2.92-8.34-3.03
		c-0.44-0.1-0.84-0.29-1.21-0.53c-0.32-0.32-0.51-0.71-0.59-1.16C521.26,100.01,521.44,99.62,521.76,99.31z"
        />
        <path
          class="st72"
          d="M700.08,221.06c-0.75,3.57,3.79,4.5,3.84,7.67c-3.04,0.31-4.36-2.19-5.87-3.97
		c-2.72-3.22-5.62-6.31-8.04-9.77c-0.55-0.7-1-1.47-1.34-2.29c-0.8-2.52-2.22-4.57-4.48-6c-1.27-0.86-2.35-1.92-3.19-3.2
		c-1.07-1.64-2.44-2.98-4.04-4.1c-2.53-1.84-4.9-3.77-8.2-4.42c-5.39-1.05-9.91-0.2-13.65,4.13c-1.51,1.75-2.79,3.87-5.17,4.72
		c-2.19,0.47-4.42,0.83-6.22,2.3c-2.42,1.98-5.06,2.36-7.38,0.23c-2.39-2.2-0.41-4.44,0.71-6.45c4.4-7.92,6.52-16.15,3.85-25.13
		c-2.15-11.95-11.33-18.5-20.07-24.99c-5.96-4.42-12.39-8.23-18.05-13.11c-1.45-1.26-3.31-1.92-4.81-3.11
		c-4.01-3.7-8.41-5.38-13.88-3.31c-1.51,0.57-3.19,1.64-5.02,0.69c-0.34-0.69-0.3-1.33,0.21-1.92c1.73-5.84,6.43-1.78,9.58-2.88
		c3.77,0.08,6.92,0.27,10.52,3.06c2.73,2.11,7.66,2.71,11.42,4.55c0.88,0.43,2.29,0.8,1.83,1.72c-1.86,3.74,1.81,3.44,3.22,4.83
		c1.66,1.62,3.99,1.61,5.94,2.7c6.58,3.68,11.1,9.38,15.96,14.78c1.71,0.76,3.42,1.53,5.46,2.44c-2.21,1.93-1.63,3.02-0.18,5.47
		c2.5,4.23,3.3,9.5,3.35,14.63c0.02,2.55-0.1,5.11,0.14,7.65c0.15,1.56,1.53,4.1,2.66,3.08c3.09-2.78,6.96-1.38,10.33-2.57
		c4.16-1.46,10.42-1.3,14.01,0.97c5.19,3.28,9.86,7.9,14.18,12.63c2.36,2.59,2.4,6.02,4.81,8.77
		C695.21,213.93,698.25,217.16,700.08,221.06z"
        />
        <path
          class="st69"
          d="M460.41,106.97c0.96,0,1.92,0,2.88,0c2.05,2.33,1.37,5.18,1.26,7.8c-0.15,3.56,0.65,6.12,4.29,7.54
		c2.24,0.88,4.05,2.61,4.88,5.02c0.8,2.31,2.4,3.51,4.66,4.36c5.77,2.18,7.73,9.77,3.51,14.26c-2.79,2.97-2.82,4.47,1.09,6.2
		c3.69,1.63,3.06,5.36,1.68,7.84c-1.98,3.53-2.25,6.71-1.14,10.45c0.57,1.92,0.56,4.15-1.03,5.89c-3.92,1.18-4.71-1.44-5.1-4.32
		c-0.38-2.83,0.1-5.74-0.47-8.56c-1.08-5.38-4.59-6.75-8.91-3.32c-1.77,1.41-3.63,1.84-5.73,1.89c-3.18,0.07-6.37,0.12-9.54,0
		c-3.39-0.13-6.08,0.69-8.24,3.65c-2.35,3.23-6.24,3.57-9.89,3.93c-5.07,0.5-10.06-0.37-14.94,3.16c-3.12,2.26-8.38,0.67-12.45,2.28
		c-1.53,0.05-2.82-0.43-3.72-1.73c-0.25-0.52-0.37-1.08-0.38-1.66c1.32-9.53,2.15-19.11,3.18-28.67c0.21-1.9,0.19-3.82,1.53-5.37
		c1.71-1.23,2.97-2.73,3.43-4.89c0.38-1.8,1.45-3.33,3.29-3.71c4.19-0.88,4.81-4.03,5.17-7.47c0.23-2.19-0.18-4.44,0.75-6.56
		c0.28-0.48,0.67-0.83,1.16-1.08c2.48-0.75,4.91-1,7.13,0.73v0c1.42,1.63,1.04,3.36-0.1,4.81c-2.26,2.87-3.42,6.03-3.58,9.68
		c-0.12,2.74-1.35,4.43-4.56,4.17c-2.4-0.2-4.43,1.05-5.37,3.26c-0.74,1.74,0.1,3.54,1.45,4.77c1.94,1.77,4.23,2.98,6.97,1.96
		c9.14-3.4,16.15-9.28,20.57-18.05c0.78-1.54,1.77-2.92,3.47-2.92c8.01-0.01,8.7-6.43,10.58-11.83
		C458.68,109.14,457.91,107.04,460.41,106.97z"
        />
        <path
          class="st85"
          d="M460.41,106.97c-1.87,3.16-2.26,7.06-3.19,10.33c-1.41,4.94-4.12,5.46-7.6,5.85
		c-2.71,0.3-4.77,0.63-4.58,3.97c0.02,0.31,0.04,0.75-0.14,0.93c-5.24,5.13-8.93,12.1-16.63,14.36c-0.9,0.27-2,0.12-2.6,0.96
		c-2.78,3.9-5.66,1.15-8.44,0.11c-2.99-1.13-3.58-3.86-3.75-6.59c-0.17-2.75,4.9-6.33,7.45-5.03c2.14,1.09,2.92,0.08,2.88-1.41
		c-0.13-4.85,1.05-9.04,4.56-12.57c0.6-0.61,0.28-2.13,0.39-3.23c6.85-0.03,7.74-0.91,7.6-9.19c-0.07-3.96,0.05-7.09,5.34-6.21
		c0.55,0.09,1.47-0.13,1.73-0.52c3.17-4.81,8.29-6.39,13.31-8.06c1.67-0.56,1.51-1.69,1.8-2.9c1.06-4.4,10.01-6.86,13.33-3.65
		c1.42,1.38,1.52,2.8-0.67,3.6c-9.79,3.58-10.36,4.29-10.76,14.62C460.38,103.87,459.42,105.43,460.41,106.97z"
        />
        <path
          class="st67"
          d="M482.46,176c-0.22-3.1,0.65-6.29-1.52-9.2c-1.23-1.65,0.25-3.25,1.25-4.72c1.24-1.83,2.49-3.61,2.25-6.1
		c-0.19-1.87-0.6-3.14-2.74-2.97c-2.1,0.17-3.55-0.8-3.75-2.79c-0.19-1.85,0.11-3.92,2.19-4.8c4.58-1.93,1.52-5.81,2.25-8.7
		c0.71-2.8-1.88-2.65-3.55-3.35c-2.65-1.11-5.09-2.46-6.06-5.58c-0.93-2.99-3.77-4.68-6.3-5.19c-3.2-0.64-3.26-2.26-3.21-4.63
		c0.07-3.66,0.02-7.33,0.02-11c0-8.59,6.43-16.62,15.34-19.17c0.02,1.35-0.95,1.96-1.94,2.49c-4.15,2.23-6.62,5.28-5.79,10.38
		c0.39,2.36-1.77,3.98-2.55,6.03c-1.49,3.91-2.68,7.31,1.3,11c2.16,2.01,2.92,5.67,4.57,8.49c1.39,2.39,2.54,3.96,5.73,3.93
		c3.42-0.03,7.13,4.34,6.74,7.59c-0.77,6.38-0.14,12.75-0.38,19.12c-0.7,6.13-0.28,12.32-1.14,18.44c-0.24,0.52-0.63,0.89-1.15,1.12
		C483.43,176.48,482.92,176.35,482.46,176z"
        />
        <path
          class="st86"
          d="M428.77,114.64c-2.56,0-5.11,0-7.67,0c-2.01-2.72-1.3-5.31,0.33-7.88c4.08-6.41,3.72-10.25-1.41-15.92
		c-0.85-0.94-1.65-1.91-2.35-2.98c-0.54-0.82-0.46-3.18-2.33-1.03c0.37-2.23-0.88-4.69,0.96-6.71c2.14,0.06,4.69-0.64,5.07,2.73
		c0.03,0.26,0.32,0.57,0.57,0.71c2.02,1.13,5.71-0.92,6.33,2.01c1.23,5.83,5.03,11.25,3.34,17.59
		C430.6,106.98,427.55,110.28,428.77,114.64z"
        />
        <path
          class="st82"
          d="M83.64,373.49c-2.36-1.92,2.36-3.83,0-5.75c0.07-0.63-0.07-1.65,0.26-1.83c5.06-2.76,8.49-7.6,13.98-10.07
		c3.46-1.56,7.51-2.6,10.37-5.69c0.93-1.01,2.87-1.39,4.39-1.51c4.17-0.32,8.21-0.54,10.09-5.3c0.23-0.59,1.65-0.71,3.13-1.29
		c-2.2-1.19-4.04-2.08-4.3-4.6c-0.22-2.14-2.28-2-4.04-2.43c-3.07-0.75-7.2-0.68-7.03-5.64c1-1.11,2.3-1.13,3.64-0.99
		c2.64,0.86,5.41,1.43,7.71,3.16c2.19,2.45,4.68,4.23,8.17,4.37c3.7,0.15,4.56,2.76,4.86,5.93c0.32,3.28-0.97,5.29-4.15,5.9
		c-1.97,0.37-3.52,1.45-5.11,2.5c-8.43,4.7-16.79,9.56-25.9,12.9c-4.45,0.18-7.12,3.49-10.3,5.88c-0.58,0.62-1.04,1.33-1.53,2.02
		C86.65,372.2,85.87,374.12,83.64,373.49z"
        />
        <path
          class="st61"
          d="M114.32,329.39c-1.28,0-2.56,0-3.84,0c-0.48,0-0.96,0-1.44,0c-11.72,0-12.1-0.32-13.88-11.94
		c-0.19-1.2,0.06-2.34-1.23-3.35c-3.1-2.41-3.44-11.81-1.4-15.06c3.95-6.29,9.5-10.07,16.27-12.78c3.21-1.29,6.25-0.57,9.35-0.97
		c5.31-0.02,10.55,0.09,13.42,5.75c-1.03,1.12-2.32,1.14-3.68,0.87c-6.15-3.8-12.8-3.03-19.29-1.55c-4.91,1.11-7.14,5.61-9.18,9.69
		c-2.99,6-1.23,13.78,3.63,18.08c2.19,3.15,4.61,5.9,8.6,6.99C113.47,325.62,115.04,326.97,114.32,329.39z"
        />
        <path
          class="st84"
          d="M167.05,167.37c1.26,0.06,2.87-0.43,3.65,0.61c3.61,4.84,8.75,4.35,13.78,4.16
		c6.67-0.25,13.24,0.16,19.74,1.88c1.69,0.45,2.06,1.76,3.07,2.63c2.12,1.83,4.29,5.94,7.04,0.36c0.79-1.6,2.83-1.49,3.24,0.25
		c0.71,3.01,2.76,2.55,4.77,2.56c3.66,0.02,7.33-0.02,10.99,0.02c1.55,0.01,3.13-0.27,3.75,1.95c0.9,3.22,3.69,1.72,5.66,1.75
		c2.22,0.04,2.56-1.97,2.89-3.74c0.79-4.36,2.71-5.21,6.01-2.2c1.43,1.3,3.48,0.66,4.56,2.23c0.57,4.58-6.24,11.49-10.67,10.2
		c-5-1.46-9.97-1.05-14.97-1.18c-5.57,0.69-10.58-1.69-15.81-2.89c-4.45-1.02-8.55-3.45-12.69-4.54
		c-10.05-2.67-20.56-3.34-29.33,4.54c-1.19,1.07-2.32,2.23-4.12,2.12c-1.7-0.44-3.15-1.33-4.45-2.49
		C164.17,179.36,163.97,173.11,167.05,167.37z"
        />
        <path
          class="st77"
          d="M164.17,185.59c1.51,0.18,3.52-0.65,3.83,1.92c1.67,1.97,0.72,3.97,0.08,5.96
		c-3.88,9.35-5.32,18.68,0.39,27.88c3.16,5.09,2.46,11.16,4.29,16.58c0.5,1.5,0.46,3.17,1.43,4.53c0.22,0.43,0.38,0.88,0.49,1.35
		c0.36,1.57,0.14,3.31,1.34,4.64c1.38,1.91,1.92,4.07,1.86,6.4c-0.05,1.33-0.12,2.65-1.24,3.6c-1.4-2.38-0.93-6.1-4.79-6.71
		c-0.16-2.72,0.94-5.88-3-7.14c-1.2-0.38-0.92-1.96-0.8-3.01c0.63-5.56-1.63-10.48-3.26-15.56c-0.67-2.08-0.87-4.28-4.03-4.26
		c-1.68,0.01-1.55-1.93-1.26-3.08c2.14-8.36-0.47-17.13,2.49-25.53C162.82,190.8,163.43,188.11,164.17,185.59z"
        />
        <path
          class="st70"
          d="M230.32,187.5c5.22,0.62,10.74-1.55,15.69,1.7c0.32,0.21,1.03,0.19,1.37-0.03c3.7-2.39,7.34-4.86,8.83-9.34
		c1.33-0.18,3.38,0.54,3.58-1.36c0.34-3.09,1.53-6.83-0.7-9.19c-3.08-3.27-6.21-6.78-10.56-8.62c0.32,0,0.64,0,0.96,0
		c1.62-1.41,3.5-1.36,5.45-1c0.51,0.14,0.99,0.37,1.42,0.68c1.12,1.55,2.51,2.79,4.05,3.97c4.76,3.65,5.44,5.98,3.49,11.6
		c-0.78,2.25-1.54,4.51-2.31,6.77c-3.24,2.65-6.72,4.8-5.81,10.25c0.49,2.91-2.81,4.32-5.47,3.48c-6.83-2.16-13.97-3.65-19.92-8.01
		C230.18,188.24,230.24,187.83,230.32,187.5z"
        />
        <path
          class="st64"
          d="M751.85,329.39c0-5.43,0-10.87,0-16.3C753.4,318.53,753.4,323.96,751.85,329.39z"
        />
        <path
          class="st59"
          d="M770.07,345.69c0.21,2.13-0.75,3.09-2.88,2.88C766.98,346.44,767.94,345.48,770.07,345.69z"
        />
        <path
          class="st59"
          d="M762.4,353.36c0.21,2.13-0.75,3.09-2.88,2.88C759.31,354.11,760.27,353.15,762.4,353.36z"
        />
        <path
          class="st64"
          d="M747.06,305.42c-1.83-0.09-2.79-1.04-2.88-2.88C746.31,302.34,747.27,303.3,747.06,305.42z"
        />
        <path
          class="st64"
          d="M750.89,310.22c-1.73-0.7-2.08-2.43-2.88-3.83C750.5,306.52,750.98,308.15,750.89,310.22z"
        />
        <path
          class="st47"
          d="M231.1,659.77c0.33,0.54,0.56,1.43,1.01,1.57c6.2,1.83,4.88,6.87,4.91,11.32c0.03,4.31,0.03,8.62,0,12.93
		c-0.02,2.37-0.01,4.82-3.66,3.55c-0.78-0.27-1.7-0.07-1.83,0.94c-0.07,0.55,0.2,1.63,0.47,1.68c2.97,0.57,3.7,3.74,4.73,5.45
		c2.41,3.99,5.45,4.26,9.25,4.2c6.33-0.1,6.64,0,6.28,6.35c-0.25,4.46,1.46,5.29,5.49,5.22c11.14-0.19,9.89-1.33,9.95,9.91
		c0.02,3.99,0.14,7.99-0.03,11.97c-0.22,5.33,1.83,8.74,6.71,11.43c2.59,1.43,5.6,1.13,7.04,1.96c3.73,2.16,8.48,4,10.25,8.76
		c-13.26-4.64-25.93-10.58-38.35-17.1c-1.54-0.81-3.16-1.47-4.75-2.2c-17.6-10.34-34.75-21.34-50.57-34.33
		c-8.76-7.2-17.25-14.69-25.63-22.34c-2.1-1.91-2.14-2.73,0.25-4.39c11-7.61,21.87-15.41,32.79-23.14
		c2.75-3.26,5.89-5.86,10.39-6.18c-0.12,0.78-0.46,1.61-0.3,2.33c0.48,2.12-3.54,3.99-1.33,5.2c2.4,1.31,5.96,1.29,8.7-0.38
		c1.3-0.79,2.89-0.6,3.95-1.48c2.28-1.88,1.28,1.49,2.38,1.36c0.42,2.55-1.89,2.99-3.27,3.95c-9.17,6.36-18.22,12.91-27.56,19.02
		c-3.04,1.99-3.51,3.17-0.57,5.92c12.49,11.68,25.52,22.63,39.75,32.14c4.25,2.84,8.72,5.23,13.44,7.45
		c-0.58-1.78-2.8-2.89-1.68-5.08c1.66-1.35,2.96,0.49,4.87,0.65c-1.89-1.12-3.41-1.73-5.08-0.52c-1.63-0.07-2.51-1.23-3.37-2.38
		c-7.81-10.41-15.63-20.81-23.34-31.3c-2.03-2.76-2.47-5.26-0.81-8.32c2.27-4.18,4.23-8.54,6.46-12.75
		C228.77,661.78,229.24,660.13,231.1,659.77z"
        />
        <path
          class="st59"
          d="M215.8,647.31c-3.46,2.06-6.92,4.12-10.39,6.18c-0.47-0.4-0.94-1.14-1.41-1.15c-6.31-0.04-5.44-4.49-5.33-8.5
		c-1.5-3.94,2.87-4.41,4.31-6.26c3.8-4.89,9.26-8.46,13.33-13.18c2.26-2.63,4.34-3.61,7.63-3.87c2.06-0.16,3.59-3.04,4.61-4.46
		c2.62-3.64,7.08-5.49,8.9-9.72c0.18-0.42,1.07-0.81,1.6-0.77c6.99,0.52,8.68-6.43,13.19-9.4c4.4-2.9,6.15-9.09,12.22-10.07
		c0.38-0.06,0.92-0.5,1.01-0.86c1.14-4.51,4.54-6.49,8.59-7.63c1.71-0.48,0.18-2.57,1.74-2.96c7.22,3.14,9.01,6.8,6.9,14.11
		c-1.23,4.26-2.55,8.49-3.58,12.8c-1.78,6.87-4.34,13.55-4.89,20.71c-0.64,2.22-2.24,2.02-3.95,1.56c-1.59-2.31-3.7-2.51-6.24-1.8
		c-6.13,1.71-12.03,3.94-17.5,7.24c-1,1.36-2.61,1.49-4.03,2.01c-0.73,0-1.46-0.01-1.72,0.89c-1.17,1.75-2.8,2.7-4.89,2.86
		l0.02-0.02c-1.68,2.24-3.99,3.39-6.67,3.93l0.03-0.02c-0.72,1.17-1.82,1.71-3.13,1.9C222.54,642.73,218.95,644.67,215.8,647.31z"
        />
        <path
          class="st59"
          d="M770.07,413.76c-3.28-0.31-2.78-2.78-2.89-4.97c-0.1-2.11,0.96-2.83,2.89-2.7c2.37,0.33,3.86,1.65,3.73,4.07
		C773.69,412.31,772.23,413.51,770.07,413.76z"
        />
        <path
          class="st78"
          d="M368.37,778.06c2.45-0.16,4.86-0.01,7.19,0.87C373.16,778.68,370.58,779.93,368.37,778.06z"
        />
        <path
          class="st68"
          d="M579.29,129.02c0,0.64,0,1.28,0,1.92c-0.07,0.72-0.42,1.29-0.92,1.79c-4.37,2.22-7.73,5.22-8.16,10.51
		c-1.23,3.58-1.7,7.91-7.17,7.36c-5.16,0.17-10.31-0.41-15.47-0.04c-2.5,0-5,0.06-7.51-0.05c-1.94-0.09-3.94,0.23-5.71-0.91
		c-1.68-2.45-0.38-3.77,1.83-4.67c3.19-1.3,6.59-1.21,9.83-0.64c3.2,0.56,6.23,0.08,9.37-0.02c5.1-0.16,8.13-2.77,10.5-6.82
		c0.67-1.15,0.97-2.81,2.88-2.67c1.55-2.61,1.48-5.62,1.81-8.46c0.33-2.8,1.24-3.55,3.31-1.69c1.59,1.43,2.54,1.58,3.51-0.4
		C578.9,125.47,578.08,127.65,579.29,129.02z"
        />
        <path
          class="st47"
          d="M541.79,768.32c-0.89,3.83-3.84,1.39-5.82,1.92C537.77,769.16,539.75,768.64,541.79,768.32z"
        />
        <path
          class="st59"
          d="M502.6,669.77c-21.89,9.51-44.81,13.8-68.63,13.5c-4.54,0.77-9.11,0.16-13.66,0.35
		c-1.24-0.02-2.02-0.63-2.33-1.84c0.35-1.54,1.83-1.67,2.9-2.31c0.93-0.43,1.87-0.84,2.87-1.1c2.06-0.5,4.17-0.29,6.26-0.43
		c11.96-0.83,23.87-2.09,35.63-4.38c1.01-0.37,2.25,0.17,3.09-0.73c-6.62-0.29-13.28,0.92-20.19-0.92
		c3.92-5.13,7.72-9.64,10.02-15.21c1.07-2.58,3.38-5.13,5.95-5.8c3.9-1.03,6-3.36,7.43-6.66c0.64-1.48,2.56-2.02,2.58-3.86
		c1.12-1.81,3.1-2.14,4.88-2.7c11.58-3.63,22.57-8.5,32.78-15.09c1.2-0.78,2.45-1.49,3.99-1.3c4.07,2.87,5.79,6.88,5.89,11.78
		c0.06,2.81-0.72,5.73,0.8,8.41c0.6,1.81-0.36,3.06-1.54,4.21c-7.79,7.61-16.24,14.36-25.55,20.02c-0.09,0.24-0.91-0.05-0.44,0.48
		c0.16,0.19,0.88-0.05,1.35-0.01C498.92,666.96,502.4,665.68,502.6,669.77z"
        />
        <path
          class="st72"
          d="M231.1,659.77c-3.09,6.07-6.18,12.15-9.27,18.22c-0.6,1.17-0.99,2.31-0.04,3.55
		c9.16,12.1,18.29,24.22,27.43,36.33l0.02,0.01c1.35,2.11,2.7,4.23,4.39,6.86c-3.59-0.43-6.17-2.09-8.74-3.56
		c-18.49-10.59-34.41-24.51-50.02-38.84c-2.56-2.35-1.14-3.13,0.78-4.47c11.22-7.79,22.38-15.66,33.56-23.51
		c1.47-0.87,2.94-1.73,4.7-2.76C234.14,654.86,231.47,656.95,231.1,659.77z"
        />
        <path
          class="st73"
          d="M418.23,681.23c0.33,0.6,0.65,1.21,0.98,1.81c-7.52,1.06-15.04,0.7-22.57,0.19
		c-50.93-1.05-94.54-17.67-126.34-59.4c0.95-0.89,2.67-0.05,3.37-1.5c2.81,0.39,4.26,2.67,5.86,4.53
		c8.14,9.47,17.86,17.01,28.31,23.7c0.4,0.22,0.78,0.48,1.15,0.74c9.51,6.2,19.73,10.95,30.38,14.82
		c10.12,3.66,20.43,6.58,31.02,8.46c4.39,1.5,9.17,0.95,13.53,2.58c2.33,1.34,4.95,0.64,7.41,1.03c0.52,0.05,1.03,0.16,1.54,0.29
		c4.19,0.98,8.45,0.22,12.67,0.5c0.82,0.03,1.62,0.17,2.42,0.36C411.23,680.77,415.15,678.71,418.23,681.23z"
        />
        <path
          class="st63"
          d="M563,620.9c0.21,2.9-2.08,6.29,1.64,8.52c-10.3,11.96-23.12,20.71-36.57,28.62
		c-2.67,1.57-5.61,2.69-8.42,4.01c-2.66,0.94-3.98-0.5-4.88-2.72c1.07-2.37,3.38-3.31,5.43-4.44c15.1-8.29,27.99-19.27,39.42-32.07
		C560.5,621.84,561.14,620.24,563,620.9z"
        />
        <path
          class="st63"
          d="M648.21,678.09c1.88-2.38,1.88-4.6,0.29-7.34c-2.37-4.07-4.2-8.47-6.21-12.63c1.67-1.44,2.49-0.24,3.25,0.34
		c5.94,4.58,11.76,9.3,17.76,13.79c1.89,1.42,2.09,2.41,0.44,4.04c-2.59,2.57-5.07,5.24-7.59,7.87c-2.86,1.7-5.3,0.78-7.65-1.12
		C646.52,681.46,647.37,679.79,648.21,678.09z"
        />
        <path
          class="st78"
          d="M648.21,678.09c-0.22,4.5,1.55,5.86,7.94,6.08c-0.37,0.63-0.74,1.26-1.11,1.89
		c-1.38,2.51-3.21,4.55-5.94,5.64c-6.42,5.06-12.39,10.82-21.09,12.88C634.74,695.76,641.47,686.92,648.21,678.09z"
        />
        <path
          class="st87"
          d="M441.26,725.29c3.69,5.4,6.9,11.09,9.77,16.97c-0.37,2.84-2.67,2.39-4.54,2.67c-4.48-4.23-6.9-9.7-9.19-15.25
		c-0.19-1.08-0.23-2.18-0.11-3.26c0.14-1.23,0.19-2.75,1.65-3.03C440.02,723.16,440.58,724.47,441.26,725.29z"
        />
        <path
          class="st11"
          d="M460.39,758.95c1.13,0.49,1.82,1.49,1.71,2.57c-0.14,1.32-1.48,0.89-2.33,0.89
		c-11.75-0.05-23.5-0.15-35.26-0.24c1-1.97,2.9-1.64,4.57-1.68c4.11-0.1,8.21-0.04,12.31-0.04c2.19-0.19,4.27,0.54,6.4,0.91
		c0.65-0.06,0.06-1.07,0.18-0.44c-2.8,0.26-4.97-0.37-5.2-3.71c1.18-1.65,2.99-1.4,4.64-1.41c1.91-0.01,3.29-0.63,4-2.47
		c0.74-0.71,1.82-0.51,2,0.15C454.4,757.1,458.48,756.62,460.39,758.95z"
        />
        <path
          class="st81"
          d="M515.06,659.24c1.4,1.14,2.67,2.52,4.59,2.81c-5.21,3.62-10.97,6.03-17.05,7.72
		c-1.03-2.74-4.02-1.68-5.78-2.99c-0.29-0.48-0.23-0.92,0.17-1.31c4.54-2.45,9.4-4.17,14.14-6.16
		C512.37,658.78,513.73,658.06,515.06,659.24z"
        />
        <path
          class="st88"
          d="M399.84,750.96c2.82-5.89,6.21-11.46,9.75-16.94c1.93,2.46,1.15,5.69,2.39,8.35
		c-0.62,4.33-2.75,7.8-6.1,10.56C403.65,752.95,400.97,754.32,399.84,750.96z"
        />
        <path
          class="st89"
          d="M420.95,714.45c2.17-3.98,4.34-7.97,6.6-12.12c2.64,1.7,2.72,4.53,4.22,6.43c-0.03,2.17,0.77,4.51-1.28,6.27
		c-0.57,0.66-1.89-0.89-2.26,0.97c-0.33,1.65-1.47,3.05-3.49,3.15C422.63,718.26,420.67,717.25,420.95,714.45z"
        />
        <path
          class="st90"
          d="M460.39,758.95c-2.74,1.76-2.1-2.77-4.7-2c-0.62,0.3,0.47,1.99-0.96,2.49c-1.6-1.8-0.06-5.12-2.94-6.31
		c-3.69-1.67-5.28-4.57-5.02-8.56c1.42-0.77,2.84-1.55,4.26-2.32C455.26,747.2,456.77,753.67,460.39,758.95z"
        />
        <path
          class="st91"
          d="M399.84,750.96c1.81,1.23,3.89,1.23,5.96,1.26c1.22,1.42-0.29,2.66-0.23,3.99c0.24,0.98,1.59,1.34,1.43,2.55
		c-0.49,1.54-1.5,2.52-3.08,2.9c-3.23-0.19-6.58,0.99-9.66-0.85C395.75,757.32,397.49,753.96,399.84,750.96z"
        />
        <path
          class="st92"
          d="M411.4,742.58c-2.58-2.44-1.61-5.63-1.81-8.57c0.94-1.65,1.89-3.31,2.83-4.96c2.2-0.1,4.45-0.38,6.01,1.75
		C417.89,735.81,415.57,739.74,411.4,742.58z"
        />
        <path
          class="st93"
          d="M420.95,714.45c1.46,1.37,2.29,3.35,4.2,4.26c-0.03,4.85-2.25,8.38-6.47,10.7c-3.1-3.18-0.06-6.7-0.55-10.03
		C418.64,717.49,419.59,715.85,420.95,714.45z"
        />
        <path
          class="st94"
          d="M442.22,761.59c-5.9,0.19-11.81,0.38-17.71,0.57c-9,0.39-18,0.41-27,0.01c4.48-1.36,9.12-1.43,13.73-1.73
		c3.94-0.26,7.94,0.49,11.84-0.68c6.18-0.38,12.36-1.01,18.51,0.36C442.19,760.44,442.4,760.93,442.22,761.59z"
        />
        <path
          class="st95"
          d="M418.13,719.38c1.03,1.87,1.42,3.8,0.61,5.88c-0.53,1.35-0.93,2.72,0.38,3.9c0.5,1.06-0.06,1.59-0.98,1.93
		c-1.6-1.54-4.25-0.11-5.72-2.03C414,725.64,415.88,722.4,418.13,719.38z"
        />
        <path
          class="st96"
          d="M441.26,725.29c-1.24-0.42-3.16-2.81-2.91,1.03c0.08,1.23,0.03,2.47,0.03,3.7c-3.93-1.37-4.57-4.86-5.36-8.27
		c0.82-1.96,2.29-3.04,4.41-3.24C438.94,720.64,440.45,722.77,441.26,725.29z"
        />
        <path
          class="st97"
          d="M396.63,683.24c7.52-0.06,15.05-0.13,22.57-0.19c4.92,0.07,9.84,0.15,14.77,0.22
		C421.52,684.34,409.08,684.5,396.63,683.24z"
        />
        <path
          class="st58"
          d="M437.44,718.51c-1.35,0.99-2.71,1.98-4.06,2.97c-2.01-0.15-2.23-1.73-2.57-3.22c0.69-2.2-0.3-5.12,2.67-6.36
		C435.24,713.84,436.37,716.16,437.44,718.51z"
        />
        <path
          class="st32"
          d="M422.99,760.83c-3.09,1.95-6.5,0.7-9.76,0.92c-5.23,0.36-10.5-0.42-15.73,0.41
		c-1.24-0.08-3.16,1.45-3.26-1.37c3.52,0,7.04,0,10.55,0c5.11-2.57,10.53-1.13,15.83-1.2C421.57,759.74,422.39,760.08,422.99,760.83
		z"
        />
        <path
          class="st98"
          d="M433.48,711.9c-1.44,1.96-0.77,4.49-1.82,6.56c-2.63-0.01-2.62-1.67-2.21-3.57c2.18-1.52,0.7-4.41,2.32-6.14
		C432.74,709.58,433.2,710.69,433.48,711.9z"
        />
        <path
          class="st99"
          d="M229.25,638.94c1.98-1.72,4.18-3.07,6.67-3.93C234.89,638.34,233.15,640.48,229.25,638.94z"
        />
        <path
          class="st100"
          d="M649.1,691.71c1.98-1.88,3.96-3.76,5.94-5.64C655.24,690.24,652.78,691.62,649.1,691.71z"
        />
        <path
          class="st99"
          d="M235.9,635.03c1.36-1.43,3.15-2.11,4.89-2.86C240.39,635.22,238.83,636.3,235.9,635.03z"
        />
        <path
          class="st75"
          d="M632.95,640.16c1.3,0.03,2.29,0.53,2.81,1.79C634.23,642.27,632.19,643.42,632.95,640.16z"
        />
        <path
          class="st99"
          d="M226.15,640.82c0.8-1.04,1.8-1.74,3.13-1.9C229.3,641.32,228.23,641.9,226.15,640.82z"
        />
        <path
          class="st99"
          d="M242.52,631.28c1.12-1.11,2.57-1.58,4.03-2.01C245.92,631.37,244.3,631.49,242.52,631.28z"
        />
        <path
          class="st47"
          d="M515.06,659.24c-5.97,2.27-11.95,4.53-17.92,6.8c-0.95,0.35-1.9,0.72-2.14-0.81
		c10-6.94,19.86-14.06,28.14-23.11c3.38-4.97,8-8.84,11.87-13.38c3.37-3.95,6.85-7.82,10.23-11.78c2.5-2.77,3.31-6.02,3.12-9.72
		c-0.35-6.93,0.53-13.92-0.78-21.41c-6.36,6.31-12.92,11.33-19.51,16.31c-3.9,2.41-7.6,5.11-11.52,7.49
		c-47.74,28.59-98.54,34.98-152.15,21.01c-12.85-3.87-25.47-8.35-38.19-15.31c2.89,2.03,5.16,3.18,7.06,4.83
		c1.89,1.65,4.57,2.43,5.6,5.02c-0.87,1.24-1.27,2.5,0.06,4.13c0.56-1.49-1.51-3.03,0.21-4.11c1.53-0.43,2.77,0.32,3.98,1.04
		c7.33,4.38,15.16,7.64,23.29,10.21c13.74,4.32,27.72,7.11,42.18,6.99c2.89-0.02,5.68,0.72,8.53,0.89c2.53,0.33,5.13-0.17,7.63,0.51
		c1.09,1.48,2.52,1.9,4.31,1.55c1.52-0.3,3-0.55,4.33,0.86c1.18,1.25,0.36-0.83,0.96-0.75c0.71-0.57,1.53-0.65,2.39-0.52
		c1.05,0.22,2.06,1.01,3.17,0.16c1.12-0.81,2.04-1.87,3.19-2.65c0.42-0.15,0.85-0.18,1.29-0.12c0.98,0.34,1.41,1.14,1.75,2.03
		c0.25,0.72,0.37,1.44,0.18,2.2c-0.25,0.47-0.59,0.85-1.02,1.16c-8.62,3.55-17.88,4.27-26.91,5.94c-6.56,1.21-13.2,1.97-19.82,2.76
		c-2.02,0.24-4.1-0.07-6.07,0.64c-0.73,0.2-1.48,0.31-2.23,0.37c-1.94,0.06-3.88,0.2-5.77-0.4c-0.75-0.36-1.3-0.81-0.74-1.74
		c-2.36-0.42-0.27,1.55-1.06,1.99c-1.68,1.34-3.47,1.27-5.32,0.47c-2.01-3.25-4.85-5.45-8.64-6.02c-5.73-0.86-7.03-2.14-5.99-7.75
		c0.54-2.92-0.29-3.59-2.95-4.57c-3.33-1.22-5.95-4.07-9.58-5.09c-1.8-0.51-3.17-0.64-4.91,0.38c-5.55,3.25-10.09,2.21-14.26-2.98
		c-0.82-1.02-1.96-1.61-2.92-2.45c-1.43-1.24-2.05-2.73-1.78-4.67c0.62-4.4,0.33-4.61-4.14-3.48c-0.62,0.16-1.21,0.4-1.83,0.55
		c-2.89,0.71-6.05,0.84-5.59,5.37c0.29,2.87-1.37,6.1,2.31,7.99c0.84,0.43,1.33,1.39,1.68,2.28c1.19,3.03,3.26,4.51,6.6,4.38
		c1.82-0.07,3.54,0.59,4.14,2.59c0.59,1.96-0.7,2.96-2.23,3.68c-2.66,1.24-1.86,3.82-2.05,5.83c-0.17,1.88,1.69,2.36,3.23,2.95
		c3.11,1.2,6.45,1.97,9.2,3.92c1.76,1.25,3.93,2.78,0.97,5.09c-11.06-3.51-21.35-8.57-30.9-15.16c1.48-2.12,4.97-0.45,6.09-3.24
		c2.04-1.01,3.52,0.71,5.68,1.16c-3.59-5.16-8.24-9.18-11-14.59c-0.07-1.25-0.41-2.29-1.9-2.48c-6.83-6.75-13.78-13.38-14.76-23.79
		c-0.36-3.78-1.8-7.39-2.08-11.3c0.08,6.28-1.96,12.07-3.44,17.92c-1.09,4.31-0.46,7.66,2.87,10.77
		c6.76,6.31,12.97,13.23,20.95,18.13c1.58,0.97,3.47,1.82,3.76,4.05c-0.4,0.8-1.15,1.13-1.89,0.84c-2.62-1.03-3.47,0.64-4.21,2.58
		c-12.77-7.21-23.27-17.09-32.88-28.01c-0.41-0.47-0.88-0.9-1.32-1.35c-0.6-1.11-1.12-2.08-0.66-3.54
		c1.82-5.76,3.44-11.57,5.14-17.37c1.03,0.12,1.7,0.82,2.37,1.51c1.8,1.85,3.02,1.69,3.38-1.02c0.29-2.17,2.29-3.31,2.97-5.34
		c0.7-2.08,2.07-4.18,5.03-2.64c2.36,1.23,4.95,2.3,2.22,5.62c1.32,0.24,1.93-0.39,2.64-0.67c1.34-0.53,2.57-0.38,3.47,0.73
		c1.05,1.29,0.32,2.42-0.67,3.34c-3.13,2.91-2.42,6.81-0.51,9.17c2.21,2.72,4.55,6.65,9.5,5.63c1.88-0.39,2.54-0.88,2.78-2.95
		c0.45-3.96,1.75-7.85-2.92-10.34c-0.77-0.41-1.28-1.74-1-2.58c1.43-4.26,0.77-8.54,0.41-12.84c1.94-1.04,3.23,0.35,4.66,1.24
		c18.26,12.69,38.67,19.95,60.37,23.95c44.62,7.5,87.86,3.28,129.41-15.22c6.12-2.05,11.65-5.3,17.18-8.54
		c3.97-1.8,7.38-4.51,10.96-6.95c21.84-15.5,39.06-34.94,48.7-60.1c3.36-8.76,8.29-13.43,17.27-15.44
		c8.62-1.92,16.51-5.93,22.73-12.6c1.89-2.03,3.34-4.28,3.99-6.99c2.21-9.17,3.76-18.44,3.84-27.91c0.03-1.27,0.11-2.53,0.4-3.78
		c0.77-2.28,0.45-4.65,0.5-6.98c1.45-15.76,0.74-31.57,0.87-47.35c0.05-6.05-2.25-10.87-7.42-14.16c-3.89-2.47-5.12-1.9-5.05,2.69
		c0.19,11.2-0.04,22.38-2.22,33.39c-0.97,4.9-0.44,10.29-3.97,14.51c-2.47-0.34-2.13-2.37-2.28-3.98c-0.23-2.49,0.16-5.03-0.65-7.47
		c-0.52-6.14-1.12-12.28-2.04-18.38c-0.27-1.94,0.01-3.92-0.46-5.85c-0.15-0.44-0.26-0.9-0.35-1.36c-0.35-2.02-0.09-4.12-0.79-6.1
		c-0.13-0.44-0.22-0.89-0.29-1.35c-0.18-1.6-0.23-3.21-0.76-4.75c-0.35-1.63-0.57-3.28-1.02-4.89
		c-5.14-24.38-12.56-48.02-22.65-70.81c-0.45-1.02-0.96-2.01-1.23-3.1c-0.12-0.5-0.16-1.01-0.13-1.53c0.14-1.06,0.52-1.96,1.62-2.35
		c2.76-0.09,4.23,1.9,5.83,3.66c9.65,10.59,15.22,23.42,20.11,36.63c0.38,0.88,0.75,1.75,1.06,2.66c0.76,3.31,1.89,6.5,3.09,9.67
		c0.97,6.44,4.58,10.75,10.13,14.12c5.69,3.45,10.97,7.58,15.95,12.08c4.03,3.64,6.15,8.14,6.56,13.36
		c1.23,15.84,0.67,31.68-0.19,47.52c-1.3,12.34-1.78,24.76-4.22,36.97c-0.34,1.72-0.57,3.46-1.06,5.14
		c-0.34,1.22-0.84,2.39-1.36,3.55c-0.71,1.49-1.25,3.08-2.16,4.48c-7.97,12.58-19.78,20.92-32.6,27.44
		c-10.3,5.24-17.97,12.02-22.55,22.71c-2.63,6.13-6.93,11.46-10.72,16.99c-0.99,1.44-1.96,2.95-3.84,3.41
		c-0.36,0.3-0.71,0.61-1.09,0.89c-8.9,6.65-8.79,14.21-3.14,23.12c3.21,5.07,4.79,11.14,7.7,16.44c2.21,4.03,1.77,7.04-1.37,10.09
		c-0.88,0.85-1.42,2.04-2.12,3.08C549.77,637.11,533.26,649.23,515.06,659.24z"
        />
        <path
          class="st101"
          d="M563.03,567.29c7.86-10.8,14.8-22.16,20.88-34.05c0.86-1.69,2.28-2.51,3.86-3.33
		c9.6-4.98,18.94-10.4,27.63-16.85c6.41-4.76,12.09-10.27,16.7-16.83c3.96,0.76,4.46,3.99,4.96,7.12c0.3,1.88,0.01,3.82,0.19,5.72
		c0.12,1.32,0.45,2.58,2.07,2.78c1.83,0.23,2.66-0.87,2.84-2.48c0.3-2.61,1.42-4.41,4.03-5.33c2.94-1.04,4.91,0.09,6.58,2.35
		c1.11,1.9,2.89,3.63,3.05,5.83c0.32,4.32,0.86,8.14,6.31,8.67c0.72,0.07,1.35,0.93,1.59,1.67c1.1,3.3,3.78,4.87,6.66,6.25
		c1.28,0,2.56,0,3.83,0c-0.25,2.34,0.94,6.36-0.63,6.72c-3.47,0.8-5.28,3.6-8.23,4.88c-7.6,3.31-16.18,3.91-23.05,9.59
		c-3.12,2.58-8.05,3.34-11.83,5.61c-5.83,3.5-12.94,3.25-18.96,7.05c-2.69,1.7-6.9,2.99-10.53,4.1c-3.08,0.95-6.22,1.24-8.65,4
		c-2.85,3.25-7.29,3.34-11.22,3.79c-3.35,0.38-6.08,0.49-8.23,3.93c-1.46,2.33-5.16,1.47-5.65-1.12c-0.6-3.22-0.95-5.99-4.04-7.77
		C562.8,569.38,563.06,568.08,563.03,567.29z"
        />
        <path
          class="st102"
          d="M693.37,526.88c-3.3-1.75-6.94-1.26-10.28-0.82c-6.16,0.79-10.73-2.84-15.96-4.67
		c-1-0.35-1.49-1.12-1.56-2.17c-0.64-1.97-3.4-3.29-1.83-5.95c2.23-0.17,3.56,1.39,4.73,2.8c5.45,6.58,12.62,7.66,20.36,6.27
		c5.88-1.06,11.06-0.2,15.61,3.75c1.75,1.52,3.91,2.06,6.06,2.63c6.62,0.39,12.36-1.71,16.34-6.99c5.74-7.61,11.86-15.29,13.39-25
		c1.5-9.53,2.8-19.23-2.69-28.32c-4.55-7.54-1.92-12.46,7-13.98c4.43-1.05,5.74-4.21,7.21-8.31c4.25-11.83,3.35-23.96,3.64-36.06
		c0.05-2.16-0.97-4.94,2.18-6.08c2.72,2.05,2.69,5.12,2.24,7.85c-1.4,8.52-0.47,17.14-1.52,25.69c-1.09,8.88-3.48,16.75-11.15,22.16
		c-3.7,2.61-3.2,6.32-2.26,9.94c1.89,7.23,3.8,14.44,3.15,22.03c-0.13,1.56,0.24,3.21-0.96,4.54c-1.84,4.25-4.42,8.2-4.34,13.18
		c0.03,1.72-0.7,3.82-3.16,4.21c-0.56,0.09-1.41,0.58-1.5,1.01c-1.02,5.12-6.24,7.24-8.2,11.28c-1.64,3.38-4.63,4.52-6.93,6.3
		c-5.59,4.33-13.96,3.47-19.79-0.79C700.2,529.24,696.97,527.65,693.37,526.88z"
        />
        <path
          class="st103"
          d="M747.06,496.21c0-0.32-0.04-0.65,0.01-0.96c1.57-9.87-1.85-19.09-4.12-28.36c-1.1-4.5,0.9-6.82,3.74-8.72
		c7-4.7,8.71-11.71,10.09-19.37c1.51-8.38-0.17-16.87,1.67-25.2c0.68-3.08,0.25-6.36-0.84-9.43c-1.11-5.76-0.18-11.57-0.43-17.35
		c-0.13-2.99-0.04-6-0.02-8.99c-0.67-5.1-1.68-9.93-7.55-11.75c-2.02-0.63-2.93-2.27-2.84-4.41c0.1-0.22,0.2-0.44,0.3-0.66
		c3.72-0.52,6.75,2.81,10.54,1.92c0.32,0.32,0.64,0.64,0.96,0.96c4.72,8.21,5.91,17.13,5.3,26.42c-0.2,3,0.11,5.99,0.59,8.98
		c0.38,2.35,0.63,4.75-1.1,6.78c-1.86,2.36-0.59,5.12-0.96,7.67c-0.28,2.91,0.91,6.08-1.6,8.63c-0.36,0.36-0.45,1.29-0.27,1.83
		c2.84,8.68-1.54,16.73-2.24,25.1c-0.29,3.38-2.63,6.38-5.24,8.77c-7.53,6.89-7.8,8.26-3.11,17.03c-2.76,1.51-2.17,4.03-1.57,6.23
		c1.15,4.2,0.33,8.43,0.58,12.64C749.03,495.29,748.36,496.04,747.06,496.21z"
        />
        <path
          class="st59"
          d="M670.36,528.8c-3.17,0.26-5.92,0.27-6.51-4.08c-0.31-2.29-2.29-3.88-4.95-3.57
		c-3.35,0.39-4.51-1.37-3.81-4.22c1-4.08-2.37-6.68-2.94-10.18c-2.1-2.8-0.79-6.26-1.81-9.27c-0.41-1.77-0.45-3.55-0.12-5.34
		c0.42-1.41,0.51-2.82,0.02-4.24c-0.34-1.77-0.29-3.53,0.06-5.3c1.52-6,3.59-11.62,6.76-17.11c2.37-4.1,3.42-9.03,6.67-12.84
		c2.55-2.99,5.42-5.73,6.81-9.62c0.59-1.65,2.32-2.9,4.04-3.09c7.53-0.86,15.1-1.62,22.59,0.42c0.01,2.65-2.18,2.51-3.65,2.36
		c-5.22-0.52-9.34,2.12-13.65,4.28c-9.69,8.22-15.92,19.08-20.29,30.52c-3.15,8.24-3.72,17.64-1.19,26.68
		c0.84,3.02,1.61,6.1,0.48,9.25c3.41,3.79,4.58,9.46,9.86,11.69C670.32,525.83,670.41,527.32,670.36,528.8z"
        />
        <path
          class="st104"
          d="M658.86,513.46c-3.35-11.08-3.54-22.39-1.76-33.67c0.92-5.81,5.86-10.13,7.54-15.7
		c1.76-5.85,7.35-8.75,9.69-13.99c0.95-2.12,3.72-1.75,4.66-3.75c4.63-0.19,7.67-4.75,12.61-4.35c5.91,0.48,11.59,1.19,15.81,6.03
		c1.28,1.47,3.01,1.75,4.83,1.12c2.18-0.76,3.46-2.36,3.58-4.63c0.17-3.04-0.47-6.04-1.15-8.98c-0.47-2.02-1.61-2.42-3.89-1.78
		c-4.4,1.23-6.84-0.22-9.65-4.63c5.86-2.47,11.45-1.8,16.83,1.41c2.24,1.34,2.65,3.53,2.51,5.83c-0.2,3.36,0.02,6.6,0.73,9.94
		c1.16,5.38-1.12,8.08-6.65,8.82c-4.32,0.58-8.13-0.53-11.76-2.99c-7.77-5.28-19.14-5.84-25.89,2.26c-4.08,4.9-8.78,9.26-10.3,15.78
		c-2.14,5.46-5.14,10.62-5.94,16.56c-3.01,8.82-1.11,17.19,2.31,25.43c0.33,0.38,0.56,0.81,0.69,1.29c0.64,1.92,1.28,3.83,1.92,5.75
		C663.03,517.65,661.86,514.49,658.86,513.46z"
        />
        <path
          d="M308.02,589.05c2.15,4.06,2.28,8.05,0.39,12.36c-0.64,1.46,0.7,3.47,2.65,3.98c2.77,0.71,3.07,2.72,2.46,4.83
		c-0.65,2.26-2.01,4.19-0.54,6.75c0.72,1.26-0.83,1.79-2,1.9c-2.37,0.23-4.8-0.33-7.12,0.56c-0.14,0.05-0.31,0.01-0.47,0.02
		c0.1-4.25-6.03-3.55-6.12-7.82c-0.07-3.33-3.07-7.07,1.77-9.5c0.74-0.37,1.3-1.18,0.6-1.95c-0.8-0.88-1.94-1.38-2.81-0.09
		c-0.99,1.47-2.11,2.09-3.46,0.68c-1.2-1.26-1.78-2.44,0.84-2.99c0.66-0.14,0.06-2.19-0.83-2.15c-1.57,0.07-2.7-2.89-4.1-0.96
		c-1.76,2.43-3.02,5.25-4.28,8c-0.53,1.16,0.61,3.18-1.45,3.52c-1.47,0.24-2.71-0.71-3.55-2.02c-0.6-0.93-1.25-1.84-1.88-2.76
		c1.2-4.57,2.16-9.23,3.68-13.7c1.31-3.84,1.33-6.93-2.28-9.49c-1.39-0.99-2.49-2.38-3.72-3.58c-0.54-0.58-1.07-1.15-1.61-1.73
		c-3.27-1.64-4.59-5.14-7.11-7.49c-2.69-3.69-5.28-7.44-7.79-11.26c-0.76-1.12-1.43-2.29-2.15-3.44
		c-5.93-9.96-11.06-20.3-14.75-31.3c-0.96-2.86-2.2-5.6-3.54-8.29c-1.93-8.68-7.13-14.2-15.14-18.26
		c-7.71-3.91-15.43-8.51-19.58-16.89c-3.49-11.39-4.46-23.22-5.61-34.96c-1.28-13.17-2.66-26.37-2.26-39.66
		c0.06-1.92-0.03-3.84,0.32-5.73c1.62-8.35,7.8-12.83,14.51-16.71c4.4-2.55,9.01-4.76,13.8-6.52c2.76-1.01,4.5-2.71,5.05-5.75
		c1.28-7.05,3.38-13.91,5.25-20.83c4.19-13.28,10.34-25.69,16.91-37.91c1.45-1.44,2.31-3.24,3.01-5.13
		c9.99-15.34,20.67-30.16,33.49-43.29c4.32-4.43,9.15-8.34,13.93-12.29c6.74-6.04,14.56-10.51,22.12-15.36
		c2.29-1.28,4.69-2.38,6.92-3.76c0.79-0.42,1.58-0.82,2.38-1.23c4.16-1.99,8.51-3.57,12.56-5.8c0.47-0.21,0.94-0.38,1.44-0.51
		c24.81-9,50.28-14.37,76.77-14.24c17.47,1.23,34.41,4.74,50.58,11.61c6.55,3.32,13.75,5.37,19.57,10.11
		c0.21,3.04,3.61,1.87,4.8,3.63c-2.79,2.44-4.84,5.69-8.2,7.54c-6.34-1.04-11.85-4.4-17.86-6.39c-5.58-1.85-11.05-4.02-16.82-5.26
		c-19.94-5.31-40.19-7.28-60.76-5.6c-0.97,0.05-1.95,0.04-2.93,0.04c-0.36,0.01-0.73-0.02-1.09,0.02c0.32-0.01,0.64-0.01,1-0.01
		c1.2,0,2.35,0.01,3.51-0.02c17.12,1.7,34.14,3.83,50.2,10.54c2.34,1.06,4.51,2.41,6.41,4.12c2.34,2.11,5.52,4.27,3.93,7.92
		c-1.59,3.67-5.15,4.99-9.1,4.74c-1.64-0.1-3.16,0.24-4.71,0.61c-18.59,1.52-37.23,2.5-55.73,5.03c-6.46,0.88-12.93,1.79-19.26,3.45
		c-12.17,2.29-23.92,6.03-35.41,10.59c-12.17,4.25-23.18,10.72-33.81,17.88c-10.69,7.11-19.69,16.07-28.07,25.75
		c10.73-7.94,21.37-16,33.09-22.47c8.84-5.76,18.45-10.03,27.89-14.64c15.82-6.48,32.08-11.43,48.98-14.18
		c2.65-0.26,5.18-1.17,7.85-1.33c3.84-0.18,7.72,0.47,11.5-0.7c13.79-0.63,27.46,0.59,41.05,2.8c14.78,2.57,29.26,6.31,43.35,11.52
		c2.39,0.88,4.81,1.69,7.07,2.89c4.88,2.41,9.94,4.43,14.75,6.99c7.93,4.62,15.98,9.03,23.41,14.46c1.53,1.12,3.19,2.1,3.9,4.01
		c0.34,3.25,4.08,4.27,4.85,7.36c0.13,0.52,1.79-1.14,2.98-0.6c1.54,0.6,2.57,1.75,3.4,3.13c0.53,3.33,2.85,4.5,5.87,4.83
		c0.61,0.43,1.04,0.99,1.31,1.69c0.29,1.99,0.86,4.1-2.03,4.71c-2.13-1-3.73-2.79-5.77-3.94c-3.02-3.67-7.35-5.69-11.24-8
		c-7.48-4.44-14.3-10.23-23.07-12.27c-1.61-0.29-3.15-0.77-4.68-1.34c-3.16-1.42-6.13-3.25-9.43-4.37
		c-6.84-2.76-13.66-5.59-20.8-7.55c-2.72-0.97-5.47-1.82-8.3-2.42c-5.15-1.58-10.37-2.83-15.72-3.49c-0.49-0.05-0.97-0.15-1.45-0.28
		c-3.1-0.65-6.19-1.3-9.37-1.49c-0.52,0.01-1.03-0.01-1.55-0.04c-1.08-0.04-2.14-0.19-3.19-0.44c-12.87-0.85-25.72-0.83-38.52,0.99
		c-4.56,0.65-9.16,1.04-13.69,1.9c-1.79,0.48-3.68,0.4-5.45,1.01c-14.12,2.44-27.83,6.34-41.19,11.48c-0.44,0.17-0.9,0.3-1.36,0.42
		c-6.16,2.27-12.19,4.88-18.09,7.77c-0.77,0.39-1.56,0.77-2.29,1.25c-0.72,0.49-1.45,0.97-2.21,1.4
		c-11.43,5.69-21.55,13.26-31.19,21.55c-10.88,8.71-19.79,19.19-27.71,30.59c-2.11,3.04-3.72,6.28-4.55,9.89
		c-1,3.18-1.46,6.48-2.04,9.75c-0.99,10.25-0.03,20.51-0.24,30.75c-0.06,3,0.12,6-0.1,8.99c-0.15,2.33,0.15,4.68-0.35,6.99
		c-1.15,3.61-0.51,7.33-0.65,11.01c0.69,11.12-1.42,22.18-0.82,33.3c0.1,1.9-0.12,3.82,0.41,5.68c0.46,3.28,0.93,6.57,1.7,9.79
		c1.55,5.05,6.14,7.45,9.69,10.61c5.89,5.24,12.51,9.63,18.99,14.13c7.07,5.21,14.98,9,22.65,13.2c0.42,0.18,0.82,0.39,1.22,0.6
		c3.94,2.35,8.34,3.68,12.43,5.68c7.42,3.27,14.96,6.22,22.76,8.46c3.29,1.53,7.54,1.06,9.79,4.74c0.95,0.6-2.41,1.56,0.4,2.4
		c2.91,0.87,5.54,0.74,8.42,0.31c5.7-0.85,7.31,0.54,7.33,6.27c0.04,10.27-0.54,9.81,10.07,9.76c7.75-0.03,15.51,0.14,23.26-0.54
		c-3.61-0.91-7.27-0.6-10.89-0.7c-3.64-0.1-5.56-1.96-6.11-5.46c-0.26-1.65-0.26-3.23,1.27-4.31c1.6-1.14,3.34-1.29,4.84,0.06
		c1.4,1.26,2.81,2.05,4.73,1.53c7.64-2.04,15.07,0.66,22.61,0.96c6.72,0.27,13.52,0.65,20.2-1.06c2.43-0.62,5.04-0.97,7.56-0.65
		c5.83,0.72,12.11-1.38,17.41,2.86c0.92,0.74,2.48,0.68,3.74,0.53c6.18-0.72,12.34-1.49,18.58-0.66c0.74,0.1,1.75,0.06,1.81-1.04
		c0.05-0.92-0.7-1.36-1.49-1.61c-1.3-0.41-2.52-0.03-3.71,0.47c-1.18,0.49-2.23,1.32-3.48,1.57c-2.56,0.52-5.38-0.08-5.97-2.55
		c-0.58-2.4,2.21-3.21,4.24-3.5c4.63-0.66,9.18-3.03,14-0.88c0.17,0.08,0.38,0.46,0.73,0.04c2.78-3.37,4.65-3.72,9.9-2.04
		c3.4,1.09,4.72,3.57,4.76,6.92c0.05,3.51,0.29,7.03-0.3,10.51c-0.26,1.53-0.58,3.76-2.69,3.18c-5.55-1.54-8.68,1.68-11.81,5.25
		c-0.41,0.47-1,0.79-1.53,1.15c-4.42,2.37-9.34,3.23-14.13,4.22c-21.69,4.49-43.44,8.57-65.77,7.61c-7.94-0.34-15.8-1.44-23.65-2.47
		c-0.73,1.66,0.71,2.06,1.26,2.89c10.09,6.24,21.33,10.17,31.74,15.76c2.95,1.58,6.15,2.75,8.7,5c1.57,1.38,3.21,2.9,2.78,5.25
		c-0.48,2.58-2.66,3.48-4.9,3.98c-10.06,2.26-20.27,2.68-30.5,1.9c-7.48-0.57-14.93-1.54-22.3-2.98
		c-18.67-3.55-35.87-10.97-52.5-19.88c-5.73-4.38-12.38-7.46-17.67-12.47c-1.48-1.34-3.02-2.64-4.63-3.79
		c-0.24-0.18-0.46-0.4-0.65-0.62c0.2,0.24,0.42,0.47,0.69,0.68c1.55,1.15,3,2.39,4.47,3.62c2.84,3.17,6.46,5.4,9.63,8.19
		C306.53,586.17,308.33,586.89,308.02,589.05z"
        />
        <path
          class="st82"
          d="M260.04,553.73c2.61,3.72,5.21,7.45,7.82,11.17c-0.17,2.38-1.6,1.85-3.03,1.29
		c-11.99-2.89-24.21-2.83-36.43-2.88c-2.23-0.38-4.69,0.88-6.71-0.96c1.8-1.78,4.12-1.35,6.28-1.37c8.83-0.07,17.65-0.03,26.57,0.12
		C254.66,557.31,254.65,553.44,260.04,553.73z"
        />
        <path
          class="st59"
          d="M264.83,566.19c0.82-0.87,2.43,0.11,3.03-1.29c2.36,2.48,4.63,5.05,6.35,8.03c-3.76,2.73-5.35-2.62-8.58-2.44
		C265.1,570.52,262.68,568.13,264.83,566.19z"
        />
        <path
          class="st83"
          d="M260.04,553.73c-4.35,2.64-5.26,5.18-2.99,8.63c-11.83,0-23.59,0-35.36,0c-7.07,0.46-14.02-1.62-21.09-0.97
		c-3.47-2.81-7.47-2.49-11.5-1.91c-1.43-0.76-2.36-2.11-1.78-3.52c1.8-4.36,2.17-9.1,4.49-13.41c2.73-5.07,6.96-9.83,5.65-16.48
		c-0.47-2.38,0.7-4.38,2.37-6.41c2.7-3.28,5.29-7.2,5.03-11.53c-0.37-6.09,1.58-11.4,4.47-16.25c2.13-3.57,0.89-5.07-1.82-6.79
		c-1.21-0.77-2.29-1.75-2.97-3.05c-1.05-1.98-1.57-3.91,0.97-5.25c5.84,8.18,14.32,13.02,22.92,17.5c4.99,2.6,8.41,5.89,9.7,11.38
		c0.4,1.68,1.14,3.29,1.72,4.93c-2.14,6.37-1.31,12.96-1.42,19.47c-0.1,5.9,0.04,11.81-0.07,17.71c-0.05,2.87-0.99,4.96-4.22,5.36
		c-1.65,0.21-3.28,0.71-2.89,2.94c0.33,1.9,1.97,1.93,3.37,1.95c4.47,0.05,8.92,0.08,13.23,1.6c1.48,0.52,3.09,0.06,3.15-1.86
		c0.14-4.72,3.41-6.04,7.15-6.98C259.12,551.55,259.78,552.51,260.04,553.73z"
        />
        <path
          class="st67"
          d="M205.51,476.79c-2.05,3.05-0.42,5.44,2.04,6.67c1.89,0.95,2.71,3.04,4.93,3.53c1.52,0.34,1.13,1.75,0.33,2.67
		c-4.66,5.37-6.64,11.45-6.64,18.67c0,4.97-2.2,9.76-6.43,13.05c-1.11,0.87-1.02,1.89-1.03,2.96c-0.05,2.87-0.02,5.73-0.02,8.6
		c0,1.61,0.15,3.29-2.12,3.59c-1.41,0.19-1.81,1.28-1.67,2.46c0.29,2.52-2.45,4.08-2.61,5.36c-0.67,5.16-5.34,9.49-3.18,15.14
		c-3.85,0.44-6.71-0.2-5.78-5.15c0.08-0.44,0.08-1.14-0.19-1.38c-6.6-5.96-7.42-14.33-9.37-22.23c-0.84-1.97,0.19-2.42,1.89-2.33
		c3.13,1.68,2.89,4.66,2.9,6.91c-0.94-5.43,2.59-9.61,6.24-13.58c4.48-4.88,4.76-5.43,2-11.24c-0.83-1.75-1.31-3.52,0.1-4.88
		c2.02-1.96,1.74-4.3,1.82-6.66c0.23-7.5-0.55-15.02,0.66-22.49c0.1-0.63,0.29-1.52-0.09-1.87c-3.93-3.63-3.25-9.09-5.37-13.49
		c-2.29-4.73-4.24-9.44-8.4-12.96c-1.5-1.27-1.14-3.57-1.15-5.49c-0.04-8.47-0.14-16.94,0.04-25.4c0.08-3.7-0.57-6.29-4.91-6.4
		c-0.79-0.02-1.45-0.62-1.89-1.33c-0.57-1.58-0.12-3.32,1.3-3.6c3.96-0.79,6.7-3.96,10.67-4.8c4.56-0.97,8.38-4.07,13.12-5
		c2.36-0.46,2.23-4.37,4.74-5.52c1.21,1.45,0.89,2.78,0.36,4.13C197.61,422.33,199.63,449.74,205.51,476.79z"
        />
        <path
          class="st82"
          d="M175.67,528.8c-1.25,0.03-1.89,0.67-1.92,1.92c-1.96,0.51-3.38,2.65-5.75,1.92c0.54-1.33,2.06-2.17,1.91-3.83
		c-0.5-1.47,0.37-2.48,1.3-3.33c5.31-4.82,7.7-11.21,9.31-17.89c1.18-4.9,4.11-9.34,3.49-14.73c-0.32-2.84-0.34-5.65-1.33-8.42
		c-0.79-2.21-1.3-4.68,0.88-6.64c3.11,1.64,4.55,4.48,4.8,7.74c0.4,5.25,0.28,10.53,0.03,15.79c-0.05,0.96-0.19,1.97-0.75,2.75
		c-2.73,3.78-3.34,8.22-4.06,12.63c-0.57,3.5-1.86,6.77-3.13,10.04C179.63,528.89,178.21,530.29,175.67,528.8z"
        />
        <path
          class="st105"
          d="M167.04,528.8c-5.31,1.53-9.37,5.48-14.88,6.98c-7.6,2.08-14.98,1.59-22.51,0.69
		c-9.8-4.79-19.07-10.59-24.93-19.91c-5.72-9.1-12.94-17.96-11.5-29.94c0.44-0.24,0.87-0.21,1.27,0.09
		c1.06,1.55,1.25,3.38,1.65,5.14c0.38,1.72-0.46,3.71,1.16,5.15c0.34,0.25,0.65,0.53,0.95,0.82c0.28,0.34,0.51,0.7,0.7,1.09
		c2.61,7.93,6.74,14.99,12.36,21.15c1.59,1.74,3.43,3.3,5.61,4.35c9.49,8.64,20.77,10.37,32.88,8.14
		c7.74-1.42,13.19-6.49,17.82-12.5c2.22-2.89,4.14-6.01,6.43-8.86c2.63-1.88,2.28-4.72,2.39-7.41c0.05-0.71,0.17-1.41,0.34-2.1
		c2.07-8.83,1.59-17.48-1.74-25.93c-2.93-4.45-3.68-9.97-7.01-14.23c-0.2-1.96-0.83-3.69-2.67-4.74c-0.91-0.68-1.63-1.51-2.13-2.53
		c-1.31-2.98-4.07-4.72-6.07-7.11c-1.15-1.37-3.01-2.57-1.62-4.82c1.31-0.39,2.4,0.15,3.48,0.78c8.55,8.18,15.73,17.09,20.22,28.41
		c6.6,16.65,4.18,32.31-3.2,47.64C174.2,522.99,171.16,526.63,167.04,528.8z"
        />
        <path
          class="st64"
          d="M83.64,373.49c1.28-0.96,2.56-1.92,3.83-2.88c1.3,1.93,0.12,3.79-0.17,5.67
		c-4.7,12.47-0.16,24.01,11.62,31.35c11.2,6.98,21.72,15.05,33.15,21.7c0.57,0.33,0.85,0.93,1.06,1.55
		c0.12,0.78-0.03,1.47-0.61,2.04c-2.38,0.12-4.18,2.31-6.71,1.92c1.22-3.91-1.95-5.04-4.2-6.91c-10.07-8.32-22.12-13.68-32.28-21.87
		c-8.06-6.49-11.55-17.83-8.45-27.71C81.47,376.53,83.74,375.68,83.64,373.49z"
        />
        <path
          class="st105"
          d="M132.53,432.93c0-0.64,0-1.28,0-1.92c2.18-0.72,3.72,0.6,5.35,1.67c2,2.42,1.31,4.38-1.12,5.91
		c-2.14,1.34-4.18,2.88-6.64,3.63c-3.4,0.53-4.69,3.7-6.78,5.73c-5.37,5.2-11.77,8.59-18.56,11.26c-3.63,1.43-5.6,3.96-6.94,7.33
		c-0.18,0.46-0.41,0.88-0.67,1.3c-1.87,3.83-1.66,7.94-1.72,12.03c-0.04,2.29,0.64,4.78-1.26,6.74c-0.32,0-0.64,0-0.96,0
		c-1.87-9.82-1.99-19.44,4.62-27.72c1.45-1.82,4.26-2.59,6.52-3.7c8.61-4.22,15.84-10.46,23.42-16.16
		C129.83,437.5,134.43,437.63,132.53,432.93z"
        />
        <path
          class="st72"
          d="M167.04,528.8c4.16-5.46,9.4-10.35,10.99-17.3c2.07-9.1,5.01-17.67,3.12-27.83
		c-1.86-10.01-5.93-18.43-10.92-26.63c-3.07-5.05-7.83-9.07-11.83-13.55c-0.24-0.23-0.34-0.48-0.3-0.75
		c0.04-0.28,0.09-0.42,0.15-0.42c0.65-0.67,1.42-1.05,2.36-1.09c1.74,0.54,2.78,2.16,4.41,2.88c4.78,5.39,10.72,9.71,13.91,16.53
		c2.37,5.05,2.72,10.67,5.06,15.68c0.27,0.57-0.22,1.2-0.67,1.68c-0.99,5.16,2.33,9.65,2.07,14.87c-0.42,8.41-4.07,15.74-6.5,23.48
		c-1.61,5.14-5.32,8.8-9,12.46C168.96,528.8,168,528.8,167.04,528.8z"
        />
        <path
          class="st82"
          d="M176.63,258.45c0-1.28,0-2.56,0-3.84c4.19,2.67,2.33,6.76,2.44,10.39c-5.38,2.18-8.54,7.3-13.5,10.14
		c-2.87,1.65-4.47,4.86-5.85,7.96c-0.58,1.32-0.82,3.42-3.22,2.19c0-0.64,0-1.28,0-1.92c0-1.43-0.25-2.92,0.05-4.28
		c0.75-3.38,0.95-6.9,5.94-7.56c1.93-0.26,6.2-0.01,6.03-4.59c-0.02-0.6,2.57-1.45,4.03-1.92
		C175.84,263.97,176.97,261.7,176.63,258.45z"
        />
        <path
          class="st60"
          d="M156.5,285.29c3.06-2.12,2.73-6.55,5.77-8.62c5.49-3.74,9.04-10.24,16.27-11.51
		c0.48-0.33,0.91-0.27,1.28,0.18c0.33,0.72,0.3,1.44-0.02,2.16c-1.91,3.02-5.58,3.48-8.17,5.65c-4.92,4.12-8.11,9.25-10.49,15
		c-1.62,3.93-4.41,7.01-6.93,10.29c-1.88,2.45-4.69,2.59-7.43,2.41c-4.05-0.27-7.69-1.46-9.82-5.34c0.12-0.21,0.25-0.42,0.38-0.63
		c4.08,0.3,8.15-0.28,12.29,0.6c3.06,0.65,4.59-2.3,5.8-4.66C156.27,289.15,156.75,287.25,156.5,285.29z"
        />
        <path
          class="st60"
          d="M127.74,291.04c1.28,0,2.56,0,3.84,0c0.64,0,1.28,0,1.92,0c1.29,0.94,3.1,1.19,3.84,2.87
		c0,0.32,0,0.64,0,0.96c0,0-0.01,0.01-0.01,0.01c-1.07,0.94-2.26,1.05-3.54,0.54C132.15,293.45,128.54,294.17,127.74,291.04z"
        />
        <path
          class="st61"
          d="M137.33,293.92c-1.4-0.8-3.14-1.14-3.84-2.87C135.54,290.97,137.62,290.86,137.33,293.92z"
        />
        <path
          class="st78"
          d="M763.36,406.09c-1.77-10.79-0.14-21.76-1.77-32.58c-0.52-3.45-4.41-5.68-3.02-9.6
		c1.11,0.46,1.55,1.47,2.17,2.4c7.7,11.54,5.25,24.54,5.42,37.16C766.18,405.16,764.99,405.96,763.36,406.09z"
        />
        <path
          class="st78"
          d="M762.4,413.76c-1.05-2.73-2.59-5.52,0.96-7.67C762.94,408.63,764.32,411.4,762.4,413.76z"
        />
        <path
          class="st105"
          d="M724.05,296.8c1.28,0,2.56,0,3.84,0v0c2.16,0.48,4.4,0.79,5.75,2.87c3.26,0.85,5.55,2.78,6.82,5.95
		c0.41,1.02,0.86,2.16,1.63,2.87c4.9,4.53,5.25,10.25,5.09,16.43c-0.11,4.08-1.1,7.41-3.95,10.23c-0.18-0.18-0.35-0.36-0.54-0.54
		c-1.52-4.26,0.6-8.42,0.3-12.69c-0.57-8.18-3.67-14.58-11.21-18.41c-1.98-1-4.04-1.88-5.91-3.07
		C724.61,299.63,722.85,298.91,724.05,296.8z"
        />
        <path
          class="st103"
          d="M738.43,342.81c-2.59,5.03-6.49,8.81-11.43,11.43c-1.02,0.54-2.17,0.85-2.39,1.98
		c-1.27,6.41-7.61,9-10.57,14.16c-1.08,1.89-3.48,1.05-5.33,1.18c0.78-3.76,4.96-5.36,5.77-9.1c4.93-5.59,9.67-11.39,16.55-14.8
		C733.79,346.5,734.76,342.6,738.43,342.81z"
        />
        <path
          class="st97"
          d="M715.42,362.94c-1.14,3.73-3.92,6.18-6.71,8.63v0c-0.71,1.85-2.47,2.64-3.83,3.84c0,0.32,0,0.64,0,0.96
		c-0.94,1.09-2.24,1.81-3.18,2.86c-1.4,1.56-2.65,3.59-2.06,5.56c0.52,1.75,2.94,0.26,4.28,1.16c3.83,1.62,7.67,1.35,11.5,0
		c1.65-0.31,3.29-0.32,4.91,0.2c0.48,0.21,0.83,0.55,1.05,1.03c-0.18,0.87-0.79,1.31-1.56,1.61c-1.07,0.36-2.17,0.4-3.28,0.4
		c-7.13-0.03-14.25,0.14-21.37-0.09c-1.83-0.06-3.53-0.66-4.13-2.6c-0.68-2.19,0.76-3.17,2.54-3.81c2.19-0.79,3.02-2.67,3.68-4.68
		c1.69-2.43,3.59-4.67,6.13-6.28c2.89-1.14,4.66-3.53,6.53-5.83c1.18-1.44,2.43-2.85,4.3-3.45
		C714.7,362.45,715.1,362.6,715.42,362.94z"
        />
        <path
          class="st105"
          d="M720.22,379.24c0-9.56,4.62-15.02,13.35-18.66c3.48-1.45,6.6-2.47,10.26-2.47c2.1,0,3.44,0.51,3.24,2.91
		c0,0-0.01,0-0.01,0c-1.1,1.2-2.59,1.29-4,1.15c-5.92-0.58-10.48,1.98-14.46,5.99c-2.06,2.39-2.96,5.47-4.71,8.04
		C722.91,377.53,723.19,380.37,720.22,379.24z"
        />
        <path
          class="st103"
          d="M703.92,385.96c-1.41,0.81-2.93,1.07-4.55,0.94c-1.27-0.1-2.54-0.7-1.88-1.95c1.8-3.37,1.93-8.32,7.38-8.58
		c0.03,1.25,0.07,2.64-1.06,3.37C700.38,381.94,702.13,383.92,703.92,385.96z"
        />
        <path
          class="st105"
          d="M738.43,342.81c-2.24,1.92-4.48,3.83-6.72,5.75c-0.45-0.52-0.74-1.18-0.38-1.74
		c2.6-3.99,5.87-7.48,8.49-11.47c0.75-1.14,2.19-1.22,3.39-0.21c0,0,0,0.01,0,0.01C743.88,339.11,739.78,340.1,738.43,342.81z"
        />
        <path
          class="st105"
          d="M720.21,386.91c-1.68,0.1-3.31-0.05-4.79-0.96c2.17-1.44,3.65-3.45,4.79-5.76c0.68,0.54,0.97,1.29,1.12,2.12
		C721.55,383.99,721.39,385.58,720.21,386.91z"
        />
        <path
          class="st103"
          d="M704.88,375.41c-0.06-2.61,2.68-2.43,3.83-3.84C709.13,374.55,707.86,375.83,704.88,375.41z"
        />
        <path
          class="st97"
          d="M720.22,382.12c0-0.64,0-1.28,0-1.92c0-0.32,0-0.64,0-0.96c2.7,0.03,1.26-3.05,2.87-3.83
		C724.91,379.97,724.22,381.6,720.22,382.12z"
        />
        <path
          class="st74"
          d="M733.64,299.67c-2.38-0.03-3.59-2.41-5.75-2.87C730.37,296.61,732.78,296.59,733.64,299.67z"
        />
        <path
          class="st81"
          d="M690.5,214.35c4.84,4.45,7.88,10.58,13.42,14.38c3.91,6.85,7.71,13.9,8.39,21.81
		c0.42,4.95-3.33,8.83-7.02,11.72c-1.38,1.08-2.18,4.44-5.2,2.9c-0.55-1-0.1-1.86,0.35-2.72c10.72-10.78,6.25-19.16-0.39-30.6
		c-2.68-4.62-5.47-9.36-9.18-13.36C690.2,217.14,689.38,215.83,690.5,214.35z"
        />
        <path
          class="st81"
          d="M701.04,263.24c-0.32,0.64-0.64,1.28-0.96,1.92c-0.96,0-1.92,0-2.87,0c-3.59,1.95-8.11,0.17-11.51,2.87
		c-0.95,1.29-2.9,0.59-3.83,1.92c-0.04,1.28-0.06,2.39-1.75,2.87c-6.2,1.75-7.7,3.88-7.83,10.55c-0.4,1.79,0.88,2.75,1.91,3.83
		c-1.78,1.49-3.46,0.55-5.16-0.18c-3.76-3.76-1.71-7.69-0.34-11.61c6.68-7.36,14.63-12.58,24.65-14.01
		C696.01,261.04,698.73,261.55,701.04,263.24z"
        />
        <path
          class="st81"
          d="M685.7,268.03c0.16-2.19,1.52-2.89,3.51-2.88c2.66,0.03,5.33,0,7.99,0
		C693.97,268.49,689.8,268.12,685.7,268.03z"
        />
        <path
          class="st81"
          d="M681.87,269.95c0.31-2.57,2.33-1.74,3.83-1.92C685.39,270.6,683.37,269.77,681.87,269.95z"
        />
        <path
          class="st106"
          d="M669.4,286.25c1.6,0.32,3.19,0.64,4.79,0.96c3.48,0.26,6.89,0.79,10.14,2.15c0.72,0.3,1.53,0.73,2.25,0.65
		c10.12-1.12,19.01,4.67,28.91,5.18c2.67,0.14,5.52,1.84,8.55,1.61c0.85,3.22,4,3.6,6.3,4.47c12.18,4.58,15.54,17.57,13.36,28.2
		c-0.38,1.85-0.34,3.78-0.49,5.68c-0.77,0.15-2.02,0.05-2.23,0.48c-2.38,4.84-6.89,8.14-9.28,12.95c-6.71,3.34-11.4,8.97-16.3,14.38
		c-0.32,0-0.64,0-0.96,0c-0.34-0.34-0.51-0.75-0.53-1.23c2.93-5.54,8.11-9.15,12.01-13.88c4.3-5.22,9.78-9.51,12.14-16.18
		c5.49-8.46,2.01-21.22-6.74-26.57c-7.07-4.33-15.15-4.42-22.76-6.49c-11.09-2.34-22.01-5.4-33.18-7.34
		c-1.91-0.33-3.67-0.9-5.13-2.23C669.54,288.24,668.94,287.41,669.4,286.25z"
        />
        <path
          class="st62"
          d="M324.27,106.01c0-0.96,0-1.92,0-2.88c2.14-4.4,6.63-6.73,9.38-10.59c0.25-0.35,0.81-0.72,1.2-0.7
		c7.34,0.44,14.94-2.13,21.99,1.47c5.97,3.05,12.99,2.16,18.94,5.49c1.88,1.06,2.57-2.33,4.09-3.35c1.11-0.97,2.75-0.88,3.83-1.92
		c0.64-0.64,1.28-1.28,1.92-1.92c1.6,0,3.2,0,4.79,0c-2.95,5.09-7.08,9.44-12.09,11.95c-3.83,1.93-8.64-0.26-12.87-1.61
		c-6.83-6-15.12-5.55-23.35-5.21c-3.55,0.15-8.01,3.83-8.79,6.97c-0.19,0.43-0.49,0.76-0.89,1.01c-1.94,0.61-3.44,2.1-5.35,2.79
		C325.77,107.71,324.76,107.34,324.27,106.01z"
        />
        <path
          class="st70"
          d="M383.71,93.55c-0.73,1.75-2.19,2.01-3.83,1.92C380.6,93.72,382.07,93.46,383.71,93.55z"
        />
        <path
          class="st61"
          d="M415.35,86.83c0.43-0.63,0.86-1.25,1.43-2.09c2.36,2.58,3.82,5.98,7.45,7.54c2,0.86,1.72,12.02-0.56,13.79
		c-3.18,2.47-2.44,5.51-2.57,8.56v0c-2.74,3.62-5.95,6.36-10.93,5.73c-0.93-1.64-0.6-3.19,0.35-4.69c1.33-1.79,2.96-3.32,4.57-4.83
		c4.38-4.12,4.66-8.65,1.79-13.66c-0.27-0.78-0.27-1.64-0.59-2.41c-1.25-0.87-0.28-2.74-1.64-3.56c-0.57-1.44-1.46-2.85-0.25-4.38
		C414.71,86.84,415.03,86.84,415.35,86.83z"
        />
        <path
          class="st67"
          d="M414.39,86.84c0.32,1.59,0.63,3.19,0.95,4.78c-0.63,0.83-1.37,1.5-2.43,1.74
		c-7.21-1.32-14.26-0.45-21.21,1.66c-3.18,0.79-5.13,3.21-6.66,5.74c-2.18,3.61-5.23,4.77-9.19,4.59c-2.71-0.12-5.31-0.84-7.96-1.28
		c-1.43-0.24-2.76-0.94-2.41-2.86c8.58,3.28,15.6,1.36,21.08-6.16c0.99-1.36,2.55-2.3,3.84-3.43
		C397.87,87.3,406.11,86.98,414.39,86.84z"
        />
        <path
          class="st85"
          d="M324.27,106.01c0.96,0.32,1.92,0.64,2.88,0.96c3.37,1.63,3.45,4.4,2.59,7.49c-2.77,2.78-4.27,6.1-5.03,10
		c-0.82,4.2-2.13,8.31-3.85,12.29c-2.29,5.33-0.01,8.62,4.77,11.49c6.69,4.01,14.77,5.92,19.82,12.58c2.58,3.4,2.5,5.18-0.76,6.9
		c-6.21-6.73-13.71-11.45-22.07-15.2c-8.88-3.98-8.74-11.31-5.43-19.35c1.94-4.72,4.08-9.35,2.62-14.66
		c-0.26-0.94-0.18-1.92,0.12-2.83c0.75-2.3,0.63-4.31-1.7-5.69c0-1.54-0.01-3.09,2.2-3.02
		C321.71,106.65,322.99,106.33,324.27,106.01z"
        />
        <path
          class="st62"
          d="M320.43,106.97c-0.63,0.94-1.25,1.87-1.88,2.81c-0.17,0.12-0.35,0.24-0.52,0.37c-0.44,0-0.84-0.11-1.21-0.33
		c-1.37-1.2-3.25-0.84-4.79-1.55c-2.96-1.76-5.73-0.36-8.47,0.61c-1.77,0.63-3.44,1.61-5.17,0.01c0.96-0.64,1.92-1.28,2.87-1.92
		C305.93,101.53,315.74,101.53,320.43,106.97z"
        />
        <path
          class="st85"
          d="M298.39,108.89c3.36,0.44,5.84-2.18,8.99-2.58c2.12-0.27,4.15-0.8,5.39,1.63c0.13,1.92-1.44,1.99-2.58,2.04
		c-8.84,0.4-14.52,5.72-19.5,12.23c-1.93,2.53-3.8,5.1-5.69,7.66c-2.97,4.03-6.82,5.24-11.32,3.44c-3.92-1.56-7.95-2.13-12.07-2.4
		c-8.2-1.4-16.81,3.23-19.27,10.39c-1.34,1.49-0.39,2.86,0.24,4.25c1.27,6.14,6.52,8.14,11.21,10.67c2.01,1.09,4.8,1.31,4.3,4.66
		c-0.68,0.34-1.31,0.32-1.88-0.23c-0.32,0-0.64,0-0.95,0c-1.62-2.1-4.03,0.53-5.75-0.96c-0.32-0.32-0.64-0.64-0.96-0.96
		c-0.96-1.6-2.24-2.87-3.83-3.83c-0.64,0-1.28,0-1.92,0c-0.44-1.67-1.48-2.88-2.88-3.83v0c-2.5-2.73-4.75-5.54-2.88-9.59
		c0-0.32,0-0.64,0-0.96c0.11-2.7,3.05-3.5,3.83-5.75l0,0c0.86-1.52,2.67-1.77,3.83-2.88c2.37-3.21,6.45-4.41,9.54-4.46
		c7.28-0.11,14.65-1.71,22.02,1.01c3,1.1,6.98-0.67,8.57-4.39c1.83-4.27,5.56-7.23,7.42-11.44
		C293.44,109.92,296.77,110.83,298.39,108.89z"
        />
        <path
          class="st85"
          d="M237.03,141.48c-0.99,3.78,1.64,6.48,2.88,9.59C235.18,147.74,234.49,145.45,237.03,141.48z"
        />
        <path
          class="st85"
          d="M240.86,134.77c0.27,2.95-2.69,3.75-3.83,5.75C235.92,137.02,239.25,136.47,240.86,134.77z"
        />
        <path
          class="st85"
          d="M249.49,159.7c1.8,1.04,4.46-3.12,5.75,0.96c-1.92,0-3.83,0-5.75,0C249.49,160.34,249.49,160.02,249.49,159.7
		z"
        />
        <path
          class="st85"
          d="M244.7,154.91c2.28,0.28,3.56,1.55,3.83,3.83C246.9,157.82,245.62,156.54,244.7,154.91z"
        />
        <path
          class="st85"
          d="M239.91,151.07c2.48,0.14,2.97,1.77,2.88,3.83C241.75,153.68,240.1,152.92,239.91,151.07z"
        />
        <path
          class="st85"
          d="M244.7,131.9c-0.7,1.73-2.43,2.08-3.83,2.88C241.16,132.5,242.95,132.23,244.7,131.9z"
        />
        <path
          class="st73"
          d="M568.74,134.77c-1.77,2.01-2,4.8-3.98,6.85c-4.78,4.95-10.85,4.49-16.67,4.16c-3.14-0.18-6.31-0.6-9.42-0.3
		c-1.97,0.19-4.73,0.33-4.44,3.67c-2.25,7.52-4.04,15.1-8.41,21.97c-2.11,3.31-2.72,7.51-6.13,10.31c-7.77,6.4-16.05,6.75-24.9,2.78
		c-5.73-5.5-10.61-11.32-9.53-20.14c0.34-2.8,0.76-5.31,2.94-7.25c0.12-4.96,1.8-9.59,3-14.33c2.34-9.2,0.59-12.21-8.18-16.45
		c-2.91-1.41-5.51-3.42-7.74-6.31c-2.62-3.39-2.67-6.69-2.33-10.19c0.48-4.98,0.8-10.01,4.82-14.04c1.8-1.81,3.8-2.29,5.81-2.76
		c6.5-1.52,12.84-1.3,19.59,0.13c6.59,1.4,11.82,6.05,18.58,6.42c0,0.32,0,0.64,0,0.96c-2.43,2.06-4.94,0.56-7.43,0.17
		c-1.23-0.32-2.39-0.83-3.57-1.29c-4.31-2.13-9.02-3.04-13.63-4.09c-3.23-0.74-6.65-0.53-9.73,1.2c-6.57,1.67-9.82,5.99-10.36,12.66
		c-0.56,6.9,2.26,11.69,8.54,14.52c1.6,0.72,3.17,1.51,4.68,2.42c6.43,3.85,6.9,6.48,5.4,13.82c-1.78,8.71-5.03,17.12-5.28,26.16
		c-0.18,6.22,2.37,11.19,7.33,14.2c4.65,2.82,10.08,2.04,15.13-0.04c3.53-0.92,5.25-3.51,7.03-6.55c4.08-6.97,6.31-14.6,8.9-22.11
		c2.38-6.91,6.13-9.38,13.27-8.48c3.49,0.44,7.04,0.52,10.52,0.09c5.22-0.63,9.42-2.93,11.31-8.24c1.24-3.15,0.82-6.37,0.44-9.6
		c-0.15-0.44-0.26-0.89-0.34-1.34c-0.37-7.8-2.01-9.72-10.3-12.64c-2.33-0.82-5.44-0.71-6.03-4.15c5.85,0.68,11.14,3.05,16.01,6.12
		c2.43,1.54,4.64,3.71,2.81,7.57c-0.72,1.53-0.16,4.3,0.83,5.86C569.02,129.22,568.63,131.97,568.74,134.77z"
        />
        <path
          class="st68"
          d="M488.21,156.83c-3.58,7.94-2.77,15.22,3.12,21.84c1.36,1.52,2.4,3.32,3.59,5c-0.16,0.16-0.31,0.32-0.46,0.48
		c-1.28,0.64-2.58,0.6-3.9,0.16c-0.4-0.19-0.73-0.47-1-0.82c-1.03-2.38-2.78-4.16-4.76-5.77c-0.44-0.5-0.82-1.01-0.43-1.72
		c0.44-6.41-1.29-13.04,1.92-19.17C486.93,156.83,487.57,156.83,488.21,156.83z"
        />
        <path
          class="st103"
          d="M547.65,106.98c2.85,3.11,7.15,3.02,10.66,4.71c5.54,2.68,8.04,6.44,6.6,12.54
		c-0.43,0.25-0.88,0.29-1.35,0.11c-3.25-5.11-8.59-7.57-13.39-10.76c-3.02-2.01-6.46-1.08-9.56-2.12c-9.41-3.7-18.9-7.17-28.69-9.78
		c-1.75-0.47-3.93-0.76-3.64-3.48c1-0.42,1.99-0.53,2.94,0.14c0.96,0.32,1.92,0.64,2.88,0.96c2.3,1.67,5.17,1.07,7.67,1.91l0,0
		c3.14,1.14,6.73,0.77,9.59,2.88C536.43,107.07,542.05,106.97,547.65,106.98z"
        />
        <path
          class="st74"
          d="M531.35,104.1c-3.3-0.6-6.71-0.86-9.59-2.88C525.19,101.4,529,100.32,531.35,104.1z"
        />
        <path
          class="st74"
          d="M521.77,101.22c-2.69-0.1-5.58,0.6-7.67-1.91c2.59,0.05,5.01,1.44,7.67,0.96
		C521.76,100.58,521.77,100.9,521.77,101.22z"
        />
        <path
          class="st97"
          d="M598.46,132.86c5.91,2.77,10.19,7.82,15.65,11.18c6.08,3.75,11.52,8.23,17.08,12.66
		c5.82,4.64,8.91,10.41,10.42,17.38c1.79,6.28,0.8,12.47-0.66,18.64c-0.24,1-0.87,1.66-1.87,1.93c-2.83-0.44-1.3-2.28-1.1-3.62
		c0.63-4.23,1.99-8.36,1.06-12.77c-1.6-7.57-5.31-14-10.84-19.22c-5.68-5.35-12.25-9.67-18.34-14.54c-0.41-0.2-0.79-0.45-1.15-0.73
		c-1.24-1.33-2.82-2.07-4.54-2.56c-5.39-3.18-10.83-5.93-17.47-5.25c-4.71,0.48-8.98,3.85-9.98,8.58c-0.13,0.63-0.06-0.16-0.06,0.47
		c-0.06,7.87-3.6,12.84-11.19,15.75c-4.14,1.59-7.79,4.88-10.22,8.99c-4.19,5.11-8.19,10.2-8.75,17.28
		c-0.24,2.98,0.22,5.57,1.34,8.19c4.31,8.63,11.76,7.09,19.08,5.9c1.57-0.26,3.09-0.8,4.61-1.28c3.77-1.18,7.53-1.15,10.16,1.99
		c2.68,3.19,2.47,7.03,0.56,10.71c-2.55-0.19-2.07-2.41-2.55-3.91c-1.77-5.58-2.57-5.79-8.15-4.48c-6.59,1.55-13.28,3.17-20.07,0.77
		c-12.12-7.04-13.82-19.65-4.51-33.05c5.31-6.99,10.46-14.12,18.86-17.91c2.29-1.03,3.31-3.19,3.61-5.82
		c1.15-10.04,9.79-17.96,19.69-18.46C592.72,129.52,595.59,131.1,598.46,132.86z"
        />
        <path
          class="st81"
          d="M637.77,194.22c4.82-1.34,3.03-5.75,3.65-8.73c0.75-3.66,0.18-7.59,0.18-11.4c2.31,4.41,2.39,8.92,1.08,13.7
		c-1.36,4.97-1.82,10.21-5.44,14.36c-0.74,0.85-2.1,2.41-0.15,3.63c1.54,0.96,3.74,1.76,4.8,0.27c2.21-3.11,5.29-2.89,8.34-3.2
		c-1.31,3.39-3.46,5.94-7.15,6.8c-2.62,0.61-4.64,2.04-6.16,4.22c-0.25,0.34-0.54,0.64-0.85,0.93c-1.31,0.94-2.58,1.92-3.35,3.4
		c-0.31,0.54-0.62,1.08-0.94,1.61c-0.46,0.76-1,1.45-1.65,2.05c-0.34,0.32-0.7,0.61-1.06,0.91c-1.11,0.96-2.48,1.43-3.75,2.08
		c-3.23,1.65-6.44,2.05-9.25-0.73c-1.71-1.69-1.29-7.79,0.6-10.38c1.03-1.42,2.42-3.33,3.86-3.4c8.06-0.4,9.59-8.15,14.34-12.21
		C635.94,196.89,636.44,195.24,637.77,194.22z"
        />
        <path
          class="st97"
          d="M635.85,214.34c0.11-2.21,1.65-3.9,3.31-4.34c4.56-1.21,7.94-3.91,11.08-7.16
		c4.27-4.84,7.97-10.49,15.82-9.62c4.75,0.53,8.79,2.19,11.98,5.78c0.97,1.59,2.23,2.88,3.83,3.84c0.63,1.29,1.59,2.25,2.88,2.88
		c1.53,2.28,3.19,4.47,4.79,6.71c0.32,0.64,0.64,1.28,0.96,1.92c0.32,1.28,0.64,2.55,0.96,3.83c-0.36,0.31-0.77,0.47-1.24,0.48
		c-4.24-2.48-6.18-6.94-9.13-10.53c-1.34-3.01-3.53-5.17-6.58-6.44c-3.57-1.54-6.74-4.07-10.82-4.31c-2.66-0.27-5.01,0.27-6.67,2.6
		c-1.29,3.1-4.4,4.91-5.69,8.02c-3.69,2.01-7.62,3.56-11.19,5.82C638.87,214.63,637.44,215.54,635.85,214.34z"
        />
        <path
          class="st63"
          d="M598.46,132.86c-3.03-0.79-5.84-2.1-9.19-2.01c-9.36,0.25-18.18,8.52-18.57,18.04
		c-0.08,1.89-0.39,3.75-2.03,4.55c-8.79,4.28-14.77,11.64-21.02,18.73c-0.16-0.17-0.33-0.34-0.49-0.51
		c-0.46-0.88-0.46-1.8-0.23-2.74c2.65-4.34,5.8-8.29,9.58-11.69c2.62-2.36,4.93-4.9,6.49-8.08c3.08,0.43,5.11-0.29,5.07-4
		c-0.01-0.9,1.06-1.81,1.63-2.71c0.78-5.23,5.1-7.57,8.63-10.55c0.32-0.32,0.64-0.64,0.96-0.96
		C590.7,126.96,591.27,126.34,598.46,132.86z"
        />
        <path
          class="st81"
          d="M689.53,212.43c-2.54-1.56-4.35-3.65-4.79-6.71C687.29,207.28,689.1,209.37,689.53,212.43z"
        />
        <path
          class="st81"
          d="M681.86,202.84c-2.28-0.28-3.56-1.56-3.83-3.84C679.67,199.93,680.95,201.2,681.86,202.84z"
        />
        <path
          class="st85"
          d="M482.46,176c0.32,0,0.64,0,0.96,0c1.95,1.56,1.57,4.36,3.25,6.06c1.15,0.55,2.54,0.58,3.46,1.61
		c2.63,2.83,5.57,5.36,8.33,8.07c1.4,6.73,1.07,7.17-7.08,9.37c-8.51-0.5-16.28-4.14-24.51-5.85c-11.77-3.23-23.29-7.3-34.85-11.12
		c-7.18-2.37-14.67-3.98-21.62-7.07c-1.46-0.65-3.66-0.52-3.69-2.98c3.27-1.96,6.86-2.12,10.54-1.93c1.75,0.09,3.51,0.24,3.98-2.28
		c0.36-1.94,2.18-1.5,3.54-1.52c3.03-0.05,6.11,0.31,9.08-0.1c4.21-0.57,9.1-0.03,10.95-5.65c0.59-1.79,2.66-1.99,4.53-1.96
		c3.83,0.07,7.66,0.11,11.48-0.01c2.62-0.08,5.53,1.08,6.96-3.01c0.77-2.2,7.92-0.6,9.28,1.66c2.33,3.87,1.45,8.07,1.52,12.15
		C478.62,174.18,479.07,176.24,482.46,176z"
        />
        <path
          class="st65"
          d="M406.72,174.08c5.95,2.83,12.17,4.87,18.7,5.71c3.57,0.46,5.66,3.49,9.39,4.15
		c11.16,1.97,21.49,6.97,32.31,10.28c0.8,0.52,1.54,1.24,2.5,1.36c3.66,0.46,6.07,2.45,6.16,6.11c0.11,4.61-0.24,9.29-3.93,12.9
		c1.41,0.1,3.35,0.46,5.1,1.39c0.84,0.45,1.96,0.98,1.67,2.04c-0.39,1.42-1.49,2-2.96,1.17c-12.22-4.36-24.54-8.4-37.48-10.06
		c-4.4-0.56-8.82-0.94-13.24-1.41c-0.93-0.99-1.23-2.23-1.3-3.52c-0.11-2.19-1.08-3.58-3.34-3.99c-2.5-0.45-3.31-2.3-4.38-4.45
		c-2.81-5.6-5.45-11.3-8.51-16.77c-0.74-1.33-2.44-1.44-3.58-2.26c-1.52-1.09-2.75-2.42,0.03-3.59
		C404.81,173.44,405.76,173.76,406.72,174.08z"
        />
        <path
          class="st71"
          d="M403.85,173.12c-1.49,1.58-1.05,2.68,0.99,2.81c3.08,0.19,3.49,2.58,5.04,4.49c2.86,3.5,1.95,8.94,6.45,11.29
		c0.44,0.23,0.89,1.07,0.83,1.56c-0.53,4.33,1.31,6.11,5.64,5.98c1.7-0.05,2.11,1.67,2.11,3.21c0,1.75,0.01,3.5,0.01,5.26
		c-26.77-0.05-52.53,5.39-77.65,14.31c-2.56-2.85-2.27-3.96,1.42-4.82c2-0.47,4.13-0.41,6.03-1.35c1.73-0.86,3.75-0.61,5.5-1.38
		c-1.17-6.05,1.04-8.89,7.39-9c3.11-0.06,5.18-0.65,5.63-4.21c0.3-2.41,2.36-3.24,4.56-3.47c2.23-0.23,3.46-1.37,3.72-3.61
		c0.11-0.95,0.35-2.56,0.94-2.57c7.18-0.11,6.17-8.92,12.1-11.15c2.75-1.04,4.75-6.31,6.11-10.21c2.18-1.22,2.63,0.41,3.16,1.92
		C403.84,172.48,403.85,172.8,403.85,173.12z"
        />
        <path
          class="st70"
          d="M403.84,172.16c-0.99-0.59-1.39-2.07-2.87-1.92c-1.48,0.76-2.98,1.28-4.58,0.29
		c-1.31-1.36-0.63-2.76-0.13-4.18c3.6-6.57,3.03-13.71,2.91-20.8c-0.11-6.62,0.69-13,6.62-17.18c1.61-1.14,1.03-4.69,4.3-3.78
		c1.09,4.52,2.4,9.07-1.44,13.04c-0.25,0.58-0.76,1.18-0.71,1.73c0.77,7.88-2.78,15.34-2.17,23.19
		C406.03,165.96,405.35,169.14,403.84,172.16z"
        />
        <path
          class="st67"
          d="M408.64,137.65c1.91-4.36,0.54-8.95,0.95-13.42c-0.56-0.49-0.75-1.12-0.71-1.85c0.19-0.97,0.67-1.7,1.68-1.99
		c0.46-0.03,1.2,0.12,1.35-0.11c2.16-3.37,6.61-2.99,9.19-5.65c-0.01,2.4,0.21,4.82-0.07,7.18c-0.46,3.86-0.57,8.11-6.21,8.29
		c-2.05,0.06-2.08,1.96-2.52,3.53C411.77,135.48,411.73,138.04,408.64,137.65z"
        />
        <path
          class="st85"
          d="M410.48,151.58c-0.89-2.03-1.66-4.04,0.06-5.88c0.51-0.55,1.74-0.57,2.13,0.09
		C414.26,148.51,411.05,149.52,410.48,151.58z"
        />
        <path
          class="st69"
          d="M485.33,183.67c-1.67-2.3-0.73-5.25-1.92-7.67c0.32,0,0.64,0,0.96,0c0.32,0.32,0.64,0.64,0.96,0.96
		C486.68,179.19,487.16,181.43,485.33,183.67z"
        />
        <path
          class="st72"
          d="M86.51,376.36c-0.34-2.03,0.65-3.83,0.96-5.75c0.02-0.79,0.19-1.51,0.96-1.92c3.67-1.99,6.55-5.23,10.54-6.71
		c5.37,0.12,8.85-4.2,13.45-5.99c4.21-1.64,8.71-3.52,12.43-6.48c2.06-0.65,3.89-1.79,6.18-2.06c2.8-0.32,4.49-2.41,4.26-5.33
		c-0.22-2.79-1.14-5.67-4.54-5.65c-4,0.02-6.72-2.29-9.73-4.22c-2.24-0.96-4.47-1.92-6.71-2.88c-0.79-2.06-2.15-3.36-4.4-3.82
		c-3.72-0.76-5.84-3.32-7.11-6.72c0.38-0.34,0.82-0.5,1.33-0.49c9.03,6.68,19.95,9.54,29.73,14.71c1.96,1.03,4.14,1.76,5.38,3.81
		c3.19,6.29,2.71,8.68-2.48,12.33c-13,5.36-25.44,11.96-38.33,17.58c-2.84,1.24-5.27,3.45-7.32,5.98
		C89.9,374.25,89.02,376.41,86.51,376.36z"
        />
        <path
          class="st68"
          d="M121.03,332.27c3.87,1.14,7.24,3.48,11.4,4.09c2.91,0.42,4.63,3.47,4.41,6.12c-0.23,2.8-2.44,5.13-5.43,5.94
		c-2.13,0.57-4.36,0.76-6.55,1.11c1.25-1.21,2.54-2.56,4.28-2.74c3-0.31,4.88-0.69,4.56-4.74c-0.32-3.99-1.69-5.11-5.46-5.1
		C125.11,336.95,122.76,334.87,121.03,332.27z"
        />
        <path
          class="st64"
          d="M98.98,361.99c-3.68,1.98-6.13,5.89-10.54,6.71C91.49,365.74,94.41,362.57,98.98,361.99z"
        />
        <path
          class="st59"
          d="M103.77,318.84c-0.32,0-0.64,0-0.97,0c-6.4-3.48-8.19-14.56-3.5-21.67c5.32-8.07,16.03-11.8,25.33-8.94
		c1.58,0.48,1.92,2.05,3.1,2.8c1.55,1.84,5.32,0.32,5.76,3.83c-0.17,0.17-0.34,0.34-0.5,0.52c-2.74,1.27-5.24,0.31-7.7-0.89
		c-8.09-3.94-14.45-3.07-21.23,2.91c-1.02,1.09-1.88,2.28-2.28,3.76c-0.11,0.41-0.25,0.81-0.37,1.22c-0.55,2.4-0.51,4.79,0.06,7.17
		c0.14,0.41,0.25,0.83,0.35,1.25C101.81,313.65,104.21,315.91,103.77,318.84z"
        />
        <path
          class="st85"
          d="M230.32,187.5c5.92,2.45,11.83,4.91,17.76,7.34c4.76,1.95,6.65,0.44,6.34-4.74c-0.27-4.54,2.92-6.23,6.58-7.4
		c0.52,0.69,0.48,1.4,0.08,2.12c-1.73,1.57-2.44,3.51-2.7,5.86c-0.89,7.92-2.49,8.94-10.04,6.87c-1.24-0.14-2.49-0.29-3.68-0.68
		c-4.1-2.7-8.86-2.69-13.47-3.31c-8.53-1.79-16.61-5.08-24.94-7.54c-4.56-1.35-9.23-2.27-13.81-3.54
		c-7.28-2.02-19.21,4.11-22.35,10.99c-0.33,0.73-0.65,1.44-1.39,1.86c-1.58,0.13-1.11-1.37-1.64-2.07c0.31-1.92,1.3-3.73,0.96-5.75
		c1.42,0.03,2.37-0.83,3.22-1.8c5.41-6.2,12.7-7.31,20.24-6.98c3.75,0.16,8.17-1.28,11.18,1.18c5.96,4.87,13.75,3.85,20.14,7.22
		C224.8,188.19,227.78,187.43,230.32,187.5z"
        />
        <path
          class="st67"
          d="M167.05,193.26c0.77,0.41,0.94,1.13,0.96,1.92c0.4,0.39,0.7,0.83,0.92,1.34c0.33,7.33-0.63,14.67,1.17,22.02
		c1.42,5.79,3.28,11.53,3.75,17.54c-0.07,2.34,1.26,4.71-0.09,7.04c-2.97-3.76-3.1-8.41-3.73-12.81c-0.46-3.23-1.1-6.36-2.96-8.94
		c-5.87-8.14-3.05-16.87-1.97-25.47C165.21,194.95,166.37,194.13,167.05,193.26z"
        />
        <path
          class="st61"
          d="M173.75,243.11c-0.54-2.21-1.26-4.39-0.96-6.71c1.9-0.34,2.61,0.98,3,2.39c2.02,7.36,5.14,14.45,5.19,22.28
		c0.01,1.62,0.45,3.23-1.48,4.08c-0.32,0-0.64,0-0.96,0c-0.42-3.55,0.2-7.3-1.91-10.54c0.08-2.16-0.06-4.24-1.92-5.75
		c-1.12-1.44,0.22-3.36-0.96-4.79C173.76,243.75,173.75,243.43,173.75,243.11z"
        />
        <path
          class="st67"
          d="M173.76,244.07c1.6,1.34,0.72,3.18,0.96,4.79C173.12,247.52,173.99,245.68,173.76,244.07z"
        />
        <path
          class="st85"
          d="M261,184.63c0-0.64,0-1.28,0-1.92c-0.91-3.23,1.17-5.82,2.19-8.48c1.91-5-1.04-7.68-4.4-9.4
		c-2.21-1.13-2.69-2.17-2.59-4.16c0.64,0,1.28,0,1.93-0.01c3.13-2.2,5.35-0.73,7.06,1.94c4.19,6.54,3.72,13.08-0.19,19.57
		c-0.8,1.31-1.38,2.89-3.34,2.84C261.44,184.88,261.22,184.76,261,184.63z"
        />
        <path
          d="M259.13,720.97c2.21,6.45-0.42,11.82,0.76,17.1c0.15,0.68-0.38,1.5-0.99,1.29c-1.9-0.66-4.27,0.53-5.79-1.46
		c-1.29-1.7-1.83-3.94-4.64-4.36c-1.27-0.19-0.24-1.42,0.35-2.47C251.23,726.8,256.36,725.74,259.13,720.97z"
        />
        <path
          d="M249.22,717.87c0.94-1.28,2.42-1.59,3.76-1.52c1.4,0.07,2.8,0.78,3.05,2.45c0.08,0.54-0.13,1.38-0.52,1.68
		c-1.59,1.24-2.12-0.57-2.96-1.25c-1-0.81-1.88-1.69-3.31-1.36C249.24,717.88,249.22,717.87,249.22,717.87z"
        />
        <path
          d="M227.15,680.94c-0.2,0.26-0.52,0.89-0.67,0.85c-0.72-0.19-1.6-0.39-2.03-0.91c-0.51-0.62,0.18-1.14,0.81-1.26
		C226.15,679.46,226.71,680.02,227.15,680.94z"
        />
        <path
          class="st67"
          d="M491.08,200.93c0.13-0.8,0.45-1.84,1.26-1.74c6.97,0.9,5.36-4.04,5.45-7.85c3.64-2.47,7.73-1.17,11.61-1.26
		c9.84-0.21,17.55-7.65,17.81-17.57c1.21-6.53,4.12-12.48,6.53-18.59c1.08-2.74,4.11-3.23,6.23-4.77c2.56,0,5.11,0,7.67,0
		c2.29,1.04,4.7,0.45,7.04,0.44c2.68-0.01,3.33,0.82,2.57,3.45c-1.48,5.15-5.16,8.76-8.54,12.52c-2.8,3.1-4.79,6.66-6.87,10.18
		c-1.32,2.94-1.72,6.43-4.88,8.29c-2.85,4.12-5.65,8.26-7.41,13c-0.22,0.6,0.28,0.21-0.15,0.4c-5.72,2.61-6.91,9.57-12.17,12.59
		c-1.46,0.02-2.87-0.31-4.29-0.62c-5.32-1.44-10.71-2.68-15.63-5.31c-1.27-2.31-3.89-1.73-5.79-2.68
		C491.38,201.26,491.23,201.09,491.08,200.93z"
        />
        <path
          class="st68"
          d="M539.98,149.16c-4.37,3.05-6.25,7.77-8.08,12.44c-1.35,3.44-2.3,7.04-3.42,10.57
		c-2.76,5.18-5.32,10.51-10.38,13.99c-0.26,0.18-0.42,0.48-0.66,0.7c-4.96,4.6-18.83,2.64-22.52-3.18c0,0,0,0,0,0
		c5.38,0.83,10.51,2.89,16.29,1.14c5.75-1.74,11.4-6.74,12.52-12.59c0.17-0.89,0.51-1.89,1.11-2.54c4.12-4.49,5.24-10.19,6.53-15.83
		c0.44-1.9,0.95-3.71,2.86-4.69C536.14,149.16,538.06,149.16,539.98,149.16z"
        />
        <path
          class="st61"
          d="M540.94,176c0.29-3.86,2.87-6.64,5.13-9.25c4.24-4.88,9.05-9.27,10.52-16.04c-2.76-1.72-6.28,0.73-8.94-1.55
		c5.12,0,10.23,0,15.35,0c0.34,2.42-0.6,4.25-2.43,5.8c-4.95,4.18-8.99,9.21-12.91,14.33C546.3,172.41,545.21,175.8,540.94,176z"
        />
        <path
          class="st72"
          d="M578.33,131.9c-2.63,3.71-6.55,6.38-8.63,10.55C569.22,136.18,573.61,133.91,578.33,131.9z"
        />
        <path
          d="M338.67,666.81c1.05-1.67,0.76-2.84-1.05-3.88c-3.14-1.8-6.48-3.11-9.94-3.95c-3.31-0.81-4.28-2.91-3.71-6.35
		c0.44-2.69,0.83-4.6,3.83-5.08c0.9-0.14,1.25-0.92,1.03-1.83c-0.26-1.04-1.07-1.86-2.02-1.73c-5.2,0.72-8.47-1.27-9.65-6.47
		c-7.54-2.81-2.15-8.93-3.37-13.36c-0.25-0.9,0.21-2.38,1.3-2.09c3.88,1.04,6.9-1.89,10.53-1.94c3.31-0.05,4.73,1.28,2.76,4.15
		c-2.34,3.4-0.71,4.84,2.14,6.17c0.69,0.32,1.79,0.77,1.86,1.28c0.5,3.5,2.32,4.91,5.86,4.49c2.58-0.31,5.49,0.76,7.18-2.38
		c0.64-1.18,1.92-1.22,2.94-0.57c3.29,2.08,7.22,4.03,10.42,4.94c6.7,1.9,5.6,5.31,4.93,9.98c-0.51,3.56,2.62,3.71,4.96,3.25
		c4.91-0.98,5.97,4.21,9.43,5.44c-0.33,0.53-0.66,1.05-0.99,1.58c5.82,3.13,12.52,3.69,18.51,6.35c4.89,6.12,11.88,3.28,17.99,4.18
		c0.44,0.05,0.87,0.17,1.29,0.32c3.36,1.89,6.41,4,10.77,3.84c3.1-0.11,4.44,2.9,4.07,6.12c-2.07,0.35-4.15,0.69-6.24,0.17
		c-2.74,0.72-5.38-0.42-7.94-0.84c-8.28-1.35-16.62,0.85-24.72-0.46c-6.88-1.12-13.67-2.57-20.68-2.59
		C359.26,674.05,348.73,671.26,338.67,666.81z"
        />
        <path
          class="st101"
          d="M390.42,657.26c0.46-0.03,0.93-0.05,1.39-0.08c2.01-0.89,4.29,0.24,6.27-0.85
		c13.44-2.02,26.91-3.84,40.21-6.71c2.6-0.56,5.15-1.33,7.73-2c2.09-1.69,4.8-1.63,7.18-2.53c0.45-0.17,0.91-0.3,1.38-0.41
		c4.92-1,9.63-2.75,14.52-3.81c1.78-0.39,3.6-1.33,5.4-0.02c1.24,0.29,2.41,2.16,1.67,2.05c-4.22-0.62-2.95,3.42-4.58,4.88
		c-1.91,1.7-2.71,4.08-6.19,3.99c-2.61-0.07-5.3,3.86-5.45,5.05c-0.72,5.5-6.77,7.88-7.09,13.34c-0.02,0.36-1.87,0.61-2.85,1.55
		c6.86,0,13.73,0,20.59,0.01c0.1,0,0.29,0.19,0.28,0.26c-0.05,0.27-0.17,0.53-0.26,0.8c-0.47,0.37-1.01,0.6-1.6,0.69
		c-7.3,0.75-14.62,0.34-21.94,0.56c-11.08-0.05-22.07-0.79-32.66-4.42l0.08,0.03c-3.86-0.86-8.03,0.07-11.69-1.96
		c-3.61-3.6-6.63-7.98-12.1-9.19C390.32,658.38,390.22,657.74,390.42,657.26z"
        />
        <path
          class="st59"
          d="M516.9,608.35c3.5-2.35,6.99-4.7,10.49-7.05c1.57,6.02,7.06,7.8,11.51,10.73c2.49,1.64,5.96,2.2,6.78,5.8
		c-6.78,8.78-14.14,17.01-22.55,24.28c-2.11-0.23-2.82-1.06-2.47-3.45c0.92-6.27,0.05-12.21-4.81-16.93
		c-0.17-2.63,2.33-3.52,3.42-5.31c1.03-1.7-1.2-0.27-1.25-1.06C513.99,614.39,513.99,614.39,516.9,608.35z"
        />
        <path
          class="st99"
          d="M518.08,615.56c1.43-0.55,2.28-2.17,4.44-2.21c-0.76,4.14-4.58,5.62-6.67,8.39
		c-12.57,8.99-27,13.95-41.34,19.1c-7.05,1.11-13.61,4.3-20.76,5.01c-0.18-2.48-3.38-1.53-3.99-3.53c0.79-1.57,2.35-1.43,3.73-1.67
		c21.66-3.71,41.98-10.88,60.27-23.31C515.06,616.46,516.32,615.36,518.08,615.56z"
        />
        <path
          class="st107"
          d="M414.44,669.6c9.11,1.02,18.21,2.06,27.32,3.03c1.55,0.17,3.13,0.04,4.7,0.04
		c6.71,0.99,13.46,0.08,20.18,0.5c0.65,0.28,0.82,0.74,0.5,1.38c-12.34,2.66-24.83,4.08-37.42,4.71c-1.63-2.6-1.69-6.5-7.08-4.97
		C420.19,674.99,416.5,672.43,414.44,669.6z"
        />
        <path
          class="st107"
          d="M370.15,675.55c6.42-1.55,12.6-1.32,18.82,1.36c3.02,1.3,6.56,0.59,9.9,0.11c8.38-1.2,16.61-0.44,24.61,2.42
		c-0.79,0.25-1.58,0.49-2.37,0.74c-4.48,0.95-8.96,0.9-13.44,0.03c-0.5-0.01-0.99-0.02-1.49-0.03c-4.56-1.21-9.32,0.53-13.85-0.95
		l-0.21-0.16l-0.21,0.16c-2.65-1.05-5.57,0.35-8.2-0.92C379.29,676.86,374.46,677.5,370.15,675.55z"
        />
        <path
          class="st97"
          d="M407.67,680.2c4.48-0.44,8.96-0.41,13.44-0.03c-0.64,1.22-1.81,1.03-2.89,1.06
		C414.73,680.7,411.01,682.39,407.67,680.2z"
        />
        <path
          class="st108"
          d="M495,665.22c0.71,0.27,1.43,0.54,2.14,0.81c-0.09,0.25-0.2,0.5-0.32,0.74c-1.81,0.07-3.37,1.74-5.35,0.76
		C491.7,665.43,493.93,666.18,495,665.22z"
        />
        <path
          class="st77"
          d="M442.39,679.76c-1.45,0.78-2.73,0.65-4.21,0.12C439.63,679.14,440.91,679.18,442.39,679.76z"
        />
        <path
          class="st109"
          d="M467.14,674.55c-0.09-0.3-0.12-0.6-0.07-0.91c0.9-0.97,2.28-0.25,3.27-0.93c0,0,0.3,0.07,0.3,0.07
		C470.67,675.73,468.55,674.43,467.14,674.55z"
        />
        <path
          class="st97"
          d="M392.33,679.22c4.62,0.32,9.23,0.63,13.85,0.95C401.56,679.89,396.81,681.46,392.33,679.22z"
        />
        <path
          class="st97"
          d="M383.7,678.3c2.77-0.03,5.55-0.13,8.2,0.92C389.16,678.99,386.25,680.31,383.7,678.3z"
        />
        <path
          d="M429.45,714.89c0.74,1.19,1.48,2.38,2.21,3.57c0.57,1.01,1.14,2.01,1.72,3.02c1.34,3.04,2.95,5.92,5,8.54
		c2.8,4.85,5.6,9.7,8.39,14.56c1.34,3.05,2.82,6.01,5.02,8.56c1.15,2.56,1.05,4.11-2.49,3.69c-2.02-0.24-4.11,0.12-6.17,0.21
		c-0.71,0.6-1.51,1-2.44,1.14c-7.5,0.31-15,0.05-22.5,0.16c-4.8-0.16-9.71,0.61-14.28-1.59c0.63-1.51,1.25-3.01,1.88-4.52
		c2.26-2.98,4.19-6.16,5.61-9.63c2.67-3.59,4.75-7.51,6.73-11.5c0.33-0.64,0.65-1.28,0.98-1.93c2.44-3.23,4.47-6.71,6.04-10.45
		C427.22,718.15,426.06,713.96,429.45,714.89z"
        />
        <path
          class="st110"
          d="M441.2,757.04c0.64,0,1.29,0,1.93,0c0.98,2.58,3.57,3.01,6.29,4.56c-2.84,0-5.02,0-7.2,0
		c-0.04-0.25-0.06-0.51-0.08-0.76c-0.71-0.78-1.46-1.53-1.47-2.69C440.72,757.71,440.9,757.35,441.2,757.04z"
        />
        <path
          class="st35"
          d="M421.11,760.81c-5.43,0-10.87,0-16.3,0c0.64-0.95,1.29-1.9,1.93-2.86c3.41-1.03,6.9-0.22,10.33-0.49
		c0.52,0,1.05,0.01,1.57,0.03C420.22,758.04,421.57,758.75,421.11,760.81z"
        />
        <path
          class="st49"
          d="M418.25,757.91c-3.84,0.01-7.67,0.03-11.51,0.04c-1.08-0.07-2.31,0.18-2.82-1.21
		c4.78,0.09,9.56,0.19,14.34,0.28c0.29,0.2,0.39,0.4,0.29,0.59C418.45,757.81,418.35,757.91,418.25,757.91z"
        />
        <path
          class="st111"
          d="M421.11,760.81c-0.64-0.96-1.28-1.91-1.93-2.87c7.34-0.8,14.68-0.76,22.03-0.02
		c0.31,0.97,0.62,1.95,0.93,2.92c-6.38,0-12.77,0-19.15,0C422.37,760.83,421.74,760.82,421.11,760.81z"
        />
        <path
          class="st86"
          d="M544.79,312.04c-1.01-0.92-2.03-1.85-3.04-2.77c-3.24-1.79-6.33-3.76-8.36-7c-8.17-7.32-18-12.11-27.23-17.82
		c-2.26-5.29-1.6-10.07,0.83-15.42c1.94-4.28,2.11-9.49,2.91-14.31c0.29-1.71,0.16-3.51,1.55-4.86c1.38-1.08,2.74-0.59,4,0.18
		c11.56,7.05,23.16,14.04,32.89,23.53c-0.05-0.05,0.17,0.12,0.17,0.12s-0.17-0.24-0.22-0.28c-9.87-11.56-20.93-21.73-33.22-30.59
		c-1.8-1.3-4.43-2.23-4.08-5.3c2.2-7.69,2.31-15.89,5.66-23.3c4.68-1.69,8.9-1.65,13.56,1.06c6.06,3.52,12.43,6.61,18.91,9.4
		c3.28,1.41,5.92,4.19,9.69,4.62c0.41,0.05,0.84,0.56,0.92,1.03c1.35,8.02,8.97,6.96,14.01,9.56c1.36,0.7,3.01,0.86,4.33,1.86
		c7.22,5.44,14.67,10.46,22.89,14.34c3.16,1.49,5.23,4.62,7.53,7.27c1.47,1.69,2.83,3.53,5.44,3.4c1.03,0.08,2,0.33,2.85,0.94
		c1.81,3.02,1.3,6.72,3.16,9.82c2.43,4.07,5.13,7.55,10.03,8.62c0.78,0.17,1.7,0.34,2.1,1c2.47,4.2,5.14,8.27,8.11,12.14
		c0.56,0.73,0.24,1.84-0.51,2.6c-11.35-3.07-22.96-1.39-34.45-1.84c-3.47-0.14-6.2,0.21-6.81,4.61c-0.42,3.09-3.28,3-5.72,2.89
		c-2.43-0.11-3.79-1.43-4.04-3.87c-0.24-2.38-0.06-4.78-0.19-7.16c-0.09-1.75-0.06-3.8-2.59-3.73c-2.21,0.06-2.21,1.93-2.31,3.52
		c-0.1,1.75,0.02,3.51-0.06,5.25c-0.09,2.01,0.4,3.33,2.76,3.55c2.9,0.27,4.56,2.24,5.14,4.94c1.42,6.61,5.6,11.3,10.48,15.53
		c3.19,2.76,5.26,5.63,3.91,10.34c-1.04,3.62,2.07,6.92,2.02,10.63c-0.71,2.05-2.15,1.68-3.65,1.09
		c-4.03-9.1-7.48-18.47-12.96-26.87c-3.3-5.04-6.63-10.05-11.69-13.58c-1.45-0.62-3.21,0.13-4.54-1.04
		c-0.96-0.93-1.33-2.16-1.69-3.39c-0.44-1.54-1.25-2.63-3.05-2.33c-1.9,0.32-1.98,1.9-2.02,3.33c-0.13,4.95-0.18,9.91-0.02,14.85
		c0.16,4.84-1.32,8.77-5.32,11.63c-0.99,0.63-1.86,0.35-2.45-0.53c-2.74-4.03-6.8-7.03-8.94-11.53c-0.42-0.42-0.84-0.83-1.26-1.25
		C548.14,315.6,546.34,313.96,544.79,312.04z"
        />
        <path
          class="st112"
          d="M640.56,445.86c-0.04-12.1,0.37-24.21,0.68-36.3c0.34-13.25-3.99-23.18-15.57-29.85
		c-2.75-1.58-5.03-4.01-7.84-5.43c-6.27-3.17-9.3-8.29-10.1-15.02c0.22-2.31,1.04-3.92,3.31-5.26c5.82-3.46,9.3-9.46,14.16-14.01
		c5.89-5.52,11.4-11.43,17.2-17.05c2.48-2.4,4.35-5.48,4.69-9.17c0.88-1.06,1.94-1.51,3.29-0.95c2.47,2.78,3.88,6.16,5.21,9.55
		c1.36,3.47,3.75,5.4,7.45,5.75c3.97,0.37,7.76,1.63,11.62,2.49c5.78,1.29,6.31,5.22,2.98,9.81c-3.79,5.22-8.1,10.15-10.97,16.03
		c-0.82,1.67-0.73,3.39-0.77,5.12c-0.11,4.13,0.56,8.35-0.33,12.36c-0.75,3.39,0.74,4.2,3.4,4.61c4.54,4.26,4.8,8.7,0.77,12.93
		c-2.94,0.61-6.07,0.86-6.09,5.12c0,1.55-1.15,2.61-2.86,2.62c-1.71,0.02-2.44-1.05-2.98-2.56c-1.91-5.34-1.6-4.58-6.49-2.26
		c-5.77,2.74-6.35,7.26-6.83,12.47c-0.74,8.14-0.51,16.07,1.54,24.12c1.35,5.33,2.52,11.37-2.26,16.23
		c-0.62,0.63,0.26,1.44,0.27,2.19c-0.16,2.18-1.66,3.41-3.31,5.27C639.92,451.29,640.01,448.58,640.56,445.86z"
        />
        <path
          class="st101"
          d="M628.11,460.72c-0.14,9.76-1.48,19.37-4.04,28.78c-1.66,6.1-6.28,9.8-11.42,12.91
		c-7.27,4.39-15.23,7.09-23.38,9.2c-3.24,0.84-5.04,2.46-6.18,5.69c-8.28,23.51-22.36,43.04-41.39,59.01
		c-3.56,2.99-6.92,6.36-11.2,8.44c-1.69-2.75-3.6-5.47,0.19-8.14c0.83-0.58,0.8-1.7,0.67-2.66c-0.31-2.36,0.41-4.37,1.94-6.15
		c1.08-1.25,1.45-2.76,1.67-4.38c0.4-2.96,5.23-7.8,7.98-8.09c0.88-0.09,1.28,0.83,2.05,1.19c-0.28-1.38-1.5-1.8-2.36-2.57
		c-2.65-2.38-3.51-4.83-0.44-7.61c1.95-1.77,2.99-4.07,3.18-6.73c3.31-4.91,8.66-7.47,13.16-10.9c9.8-7.47,14.53-17.37,16.64-29.08
		c0.63-3.48-0.13-7.4,2.64-10.34c0.3,0.02,0.82,0.17,0.91,0.04c0.59-0.89,5.93-3.75,7.41-4.23c2.76-0.89,4.5-3.37,6.96-4.81
		c4.56-2.65,9.74-4.41,12.89-9.18c0.85-1.29,2.95-0.89,4.5-1.19c2.03-0.39,3.32-1.75,4.43-3.35c0.68-1.05,1.26-2.51,2.51-2.68
		c5.4-0.72,5.92-4.66,6.17-8.87c1.03-1.54,0.97-4.29,3.99-3.63C629.31,454.41,626.67,457.68,628.11,460.72z"
        />
        <path
          class="st60"
          d="M365.63,608.32c11.35,1.4,22.66,3.34,34.17,2.83c6.52-0.29,13.06-0.37,19.4-2.13c1.46-0.41,3.33-0.7,3.8-2.5
		c0.54-2.1-1.18-3.2-2.56-4.17c-8.4-5.87-18.09-9.22-27.19-13.71c-4.54-2.24-9.33-4.01-13.3-7.27c0.91-2.78,3.3-2.24,5.16-1.91
		c9.88,1.76,19.79,3.46,29.72,4.8c10.43,1.41,20.62,4.43,31.23,4.5c4.8,0.03,9.22,2.76,14.14,1.97c13.33,2.22,26.77,3.75,40.05,6.29
		c1.35,0.26,3.94-0.51,3.31,2.55c-2.81,2.22-6.25,3.05-9.48,4.34c-38.9,15.53-79.06,18.52-120.16,12.02
		c-0.6-0.1-1.17-0.44-1.75-0.66c-7.02-1.95-9.07-3.16-11.51-6.94C362.36,607.73,363.98,607.66,365.63,608.32z"
        />
        <path
          class="st83"
          d="M647.35,314.05c2.33,5.43-2.56,8.39-5.05,11.03c-4.65,4.94-9.33,10.03-14.47,14.45
		c-6.16,5.3-10.17,12.95-17.95,16.4c-1.54,0.68-0.38,2.92-2.16,3.32c-1.05-3.07-2.87-5.92-2.72-9.34c-0.32-1.25,0.17-1.78,1.37-1.28
		c2.09,0.87,0.02-1.01,0.71-1.03c0.53-2.58-1.72-4.27-2.13-6.69c-0.46-2.69-1.39-4.82,0-7.77c1.67-3.52-2.53-5.34-4.38-6.93
		c-4.74-4.06-8.83-8.33-9.97-14.56c-0.93-5.05-3.65-6.47-8.43-5.09c0-4.26,0.13-8.26-0.04-12.24c-0.13-3.02,1.53-3.31,3.91-3.33
		c2.45-0.02,4.03,0.45,3.83,3.4c-0.16,2.39-0.05,4.79-0.02,7.19c0.02,2.33-0.62,4.86,3.31,4.88c3.28,0.02,4.82-0.9,4.37-4.32
		c-0.37-2.83,1.16-3.49,3.71-3.47c10.38,0.09,20.77,0.21,31.15-0.06c3.12-0.08,4.44,3.13,7.31,2.98c4.62,0.3,6.1,1.76,5.82,6.51
		C645.36,310.44,645.38,312.48,647.35,314.05z"
        />
        <path
          class="st83"
          d="M562.08,330.12c4.53-4.24,5.23-9.6,4.8-15.45c-0.29-3.94-0.03-7.92-0.06-11.88c-0.02-2.15-0.15-4.23,3.03-4.1
		c2.4,0.1,5.01-0.43,4.67,3.4c-0.14,1.65,0.6,3.07,1.71,4.29c1.24,0.56,1.36,1.67,1.4,2.83c-0.59,0.91-1.27,1.75-1.79,2.64
		c0.88-0.29,0.88-2.02,2.32-1.61c6.68,12.76,11.29,26.34,15.57,40.02c3.56,11.39,7.06,22.83,8.64,34.73
		c-3.88-0.09-5.6-2.34-5.87-5.86c-3.53,0.89-5.43,2.8-6.07,6.69c-0.51,3.13-7.51,3.28-11.2,0.24c0.4,2.71-0.9,5.39,2.86,6.87
		c1.98,0.78,1.34,3.63,0.86,5.68c-1.17,1.26-1.5,2.93-2.13,4.47c-0.67,0.87-0.69,2.52-2.46,2.06c-1.32-1.2-1.24-2.86-1.43-4.42
		c-1.3-10.9-3.2-21.7-5.36-32.46c-0.47-4.32-1.84-8.42-3.09-12.55c0.02-2.95-1.99-5.43-1.94-8.39c-0.03-1.36-0.48-2.64-0.75-3.95
		c-0.21-1.48-0.89-2.83-1.27-4.26c0.1-1.59,0.42-3.22-0.98-4.48c-0.26-0.34-0.48-0.69-0.7-1.06
		C562.45,332.44,560.96,331.56,562.08,330.12z"
        />
        <path
          class="st83"
          d="M582.16,399.38c-1.09-1.87,2.91-6.66-3.37-5.7c-1,0.15-1.01-9.51,0.17-10.18c0.83-0.47,1.97-0.2,1.94,0.53
		c-0.2,4.57,3.05,2.64,5.15,2.9c2.9,0.36,4.11-0.9,3.79-3.8c-0.25-2.34,0.22-4.24,3.21-3.87c2.57,0.32,2.19-2.18,4.03-4.22
		c0.36,4.56,1.03,8.45,5.28,9.95c0.93,1.43,0.94,3.04,0.96,4.65c1,1.52-0.28,3.46,0.92,4.95l0.24,0.26l-0.14,0.33
		c0.5,1.52,0.41,3.06,0.2,4.61c-2.49-0.5-1.04,0.93-1.02,1.87c0.05,2.54,1.43-0.48,1.8,0.48l-0.02-0.03
		c0.95,1.87-0.38,4.07,0.88,5.9c1.51,6.28,1.55,12.71,1.98,19.1c0.75,2.46,0.24,4.97,0.31,7.46c-1.02,2.99,0.42,6.04-0.23,9.03
		c-0.88,3.38-2.84,5.4-6.46,6.18c-3.36,0.72-5.72,3.76-9.28,4.55c-1.59,0.36-1.22,2.74-1.24,4.3c-0.07,5.59,0,11.17-0.04,16.76
		c-0.01,1.6,0.11,3.28-0.72,4.68c-1.22,2.07-3.32,3.49-5.56,2.9c-2.53-0.66-1.29-2.99-1.18-4.84c0.29-5,1.35-10.18-2.99-14.3
		c-1.05-0.99-0.82-2.7-0.85-4.13c-0.07-3.83,0.07-7.66-0.11-11.49c-0.03-2.97,0.01-5.93,0.01-8.89c0.47-5.2-0.47-10.48,0.95-15.64
		c0.43-1.55,0.65-3.15,1.83-4.31c1.63-1.6,1.64-3.28,0.64-5.18c-0.45-0.85-0.87-1.92-0.47-2.75
		C584.72,407.27,583.63,403.33,582.16,399.38z"
        />
        <path
          class="st60"
          d="M640.56,445.86c0,2.32,0,4.65,0,7.61c1.2-1.72,2.08-2.98,2.96-4.24c6.35-2.29,12.24-5.28,16.72-10.59
		c1.14-1.35,3.14-1.47,4.71-2.22c5.69-2.71,6.49-8.34,1.69-12.39c-2.11-1.78-2.37-4.02-3.04-6.55c-1.42-5.36-0.06-10.53-0.31-15.77
		c-0.1-2.22,0.94-3.62,3.43-3.38c2.48,3.84,1.85,8.19,2.04,12.41c0.26,5.91,2.88,10.45,8.08,13.4c3.94,2.89,8.88,3.14,13.22,4.97
		c1.11,2.16,3.18,2.36,5.25,2.56c3.15,0.31,5.29,1.94,6.3,4.95c0.47,1.4,0.6,2.88-0.57,3.99c-1.2,1.14-2.56,1.03-3.83-0.03
		c-6.37,0-12.74,0.02-19.11-0.01c-4.19-0.02-7.07,1.59-7.7,6.03c-0.16,1.15-0.49,1.95-1.39,2.82c-4.42,4.26-8.63,8.32-9.72,15.19
		c-0.62,3.89-4.66,7.14-5.97,11.51c-0.65,2.18-0.45,4.76-2.13,6.64c-2.85,1.92-2.85,3.83,0,5.75c1.23,0.96,1.23,1.92,0,2.88
		c-0.63,0.11-1.32,0.26-1.77,0.66c-2.52,2.21-4.4,1.99-5.84-1.21c-0.48-1.06-1.34-2.65-2.8-1.11c-0.98,1.03-0.28,3.42,0.21,3.4
		c2.97-0.13,3.22,2.76,4.88,3.99c1.9,1.41,3.54,2.03,5.34,0.02c1.96,3.03,0.52,6.4,0.96,9.59c-1.88-1.19-3.22-3.03-6.22-1.45
		c-2.51,1.32-2.54,2.93-2.39,4.95c0.22,3.04-1.6,3.22-3.92,3.26c-2.44,0.03-3.91-0.46-3.82-3.38c0.17-4.97,0.9-10.17-3.72-13.88
		c0.61-1.3,1.22-2.59,1.83-3.89c1.86-0.43,1.54-1.6,0.96-2.85C637.82,475.08,638.63,460.4,640.56,445.86z"
        />
        <path
          class="st101"
          d="M503.54,599.59c-0.37-2.3-2.04-0.75-3.03-0.92c-13.36-2.26-26.73-4.41-40.11-6.59
		c-1.17-1.26-4.07,0.62-4.27-1.99c-0.22-2.8-0.83-6.88,1.91-7.89c5.63-2.08,8.25-7.62,13.29-10.07c7.7-3.75,16.06-5.01,24.45-5.83
		c2.38-0.23,4.48,1.46,6.43,3.11c0.18,0.08,0.33-0.18,0.01-0.51c-4.9-4.96-4.83-5.14,1.68-8.16c1.11-0.51,2.72-0.32,3.28-1.86
		c2.08-2.2,4.47-3.49,7.59-2.67c0.14,1.77,0.88,3.67-1.84,4.37c-1.95,0.51-2.03,2.33-1.82,3.91c0.5,3.68-0.3,7.57,2.45,10.88
		c1.32,1.58,0.76,3.98,0.74,6.02c-0.04,2.97-0.48,5.98,3.48,7.11c1.08,0.31,2.08,1.44,2.39,2.79
		C514.97,594.7,509.6,597.83,503.54,599.59z"
        />
        <path
          class="st101"
          d="M518.08,615.56c-15.05,11.78-32.33,18.79-50.68,23.38c-5.84,1.46-11.77,2.55-17.66,3.82
		c-0.14,0.18-0.29,0.37-0.43,0.55c-1.71,1.33-3.63-0.04-5.41,0.42l-0.39-0.15l-0.35,0.22c-5.17,2.25-10.66,2.42-16.09,1.9
		c-3.45-0.33-6.82-0.61-10.24-0.05c-11.7-0.88-23.48-0.93-35-3.66c-5.55-1.31-11.11-2.49-16.38-4.76c-1.09-1.97-1.66-4.08-3.52-5.8
		c-1.6-1.47-0.49-2.75,1.78-2.03c20.56,5.18,41.38,7.82,62.62,6.68c31.66-1.7,61.19-10.45,88.42-26.78c0.67-0.4,1.43-0.65,2.15-0.97
		c0.75,0.14,1.77,0.21,1.07,1.33c-0.89,1.41-1.99,2.69-2.85,3.83C515.44,615.62,519.33,611.25,518.08,615.56z"
        />
        <path
          class="st61"
          d="M628.11,460.72c-1.8-3.05-0.48-6.39-0.89-9.57c-1.44-3.07-0.25-6.21-0.14-9.3c0.1-3.01,0.26-5.99-0.16-8.98
		c0.98,7.58-1.26,14.79-2.57,22.11c0,1.26-0.16,2.55,0.03,3.79c0.52,3.26-0.69,5.15-4.04,5.38c-2.27,0.15-3.61,1.45-4.62,3.3
		c-3.09-1.57-3.59-3.52-1.52-5.99c0.83-1,2-1.55,3.06-2.25c1.32-0.87,2.51-2.65,1.66-3.55c-3.13-3.31-2.56-8.92-7.1-11.17
		c-1.16-0.58-2.91-0.22-2.92-2.25c-0.15-1.34,0.06-2.56,1.06-3.56c3.64-17.96,6.38-36,4.56-54.52c10.56,2.22,15.7,8.24,15.68,18.27
		c-0.03,15.94,0.18,31.88-1.18,47.79c-0.92,2.35,0.15,4.9-0.77,7.25C628.68,458.56,628.44,459.65,628.11,460.72z"
        />
        <path
          class="st112"
          d="M520.2,591.29c-5.05-2.24-8.49-5.35-7.14-11.64c0.4-1.85,0.66-4.09-1.97-5.27
		c-1.05-0.47-1.65-13.17-0.91-14.18c0.36-0.48,1.15-1.21,1.42-1.09c3.01,1.3,2.45-1.62,3.37-2.75c0.13-1.76,1.59-2.35,2.85-2.88
		c8.39-3.5,16.23-8.01,23.93-12.8c1.07-0.67,2.25-1.26,3.58-0.57c2.83,3.6-0.75,6.03-2.45,7.33c-3.02,2.31-1.52,3.56-0.01,5.22
		c0.95,1.05,2.16,1.85,3.17,2.85c0.75,0.75,1.85,1.52,1.02,2.79c-0.3,0.46-0.97,0.89-1.51,0.96c-1.62,0.21-1.56-1.15-1.86-2.19
		c-0.11-0.37-0.49-0.67-0.92-1.23c-1.54,1.64-2.28,4.18-5.07,3.77c-0.35-0.05-1.15,0.57-1.11,0.67c1.94,5.74-6.13,8.96-3.71,14.81
		c0.22,0.52,0.15,1.72,0.03,1.74c-5.54,1.22-1.74,5.25-2.41,7.9C527.37,587.42,523.89,589.52,520.2,591.29z"
        />
        <path
          class="st73"
          d="M309.06,634.21c4.38,5.61,8.76,11.21,13.41,17.16c-3.52,0.11-5.82-2.16-8.61-2.9l0.07,0.05
		c-10.36-6.8-19.5-15.01-28.03-23.95c-1.7-1.78-2.22-3.34-1.53-5.91c2.01-7.47,3.58-15.07,5.96-22.75
		c1.39,14.5,6.47,27.05,17.5,36.71C308.65,632.85,308.9,633.5,309.06,634.21z"
        />
        <path
          class="st72"
          d="M545.68,617.84c-4.4-3.85-9.96-5.86-14.65-9.26c-2.6-1.88-4.46-3.83-3.64-7.27c7-5.73,14.2-11.21,21.53-18.59
		c0.35,10.57,0.84,20.02,0.86,29.48C549.79,614.5,547.42,616.2,545.68,617.84z"
        />
        <path
          class="st72"
          d="M365.63,608.32c-1.33,0.08-2.67,0.17-4.56,0.29c4.02,2.49,7.14,5.24,11.07,6.67
		c-19-3.14-36.86-9.45-53.37-19.43c-2.4-1.45-4.7-3.07-7.04-4.61c-0.43-2.83-0.25-3.15,1.69-2.98
		C329.98,597.16,347.3,604.06,365.63,608.32z"
        />
        <path
          class="st78"
          d="M363.72,629.41c-0.98,0.26-2.68,0.86-0.84,1.67c3.16,1.39,2.92,3.61,2.58,6.16
		c-9.61-2.31-17.91-7.59-26.69-11.78l0.08,0.04c-4.91-4.16-11.13-6.64-15.14-12.13C336.58,620.02,350.12,624.8,363.72,629.41z"
        />
        <path
          class="st78"
          d="M390.42,657.26c5.67,1.2,9.69,4.57,12.46,9.55c-2.84,1.94-5.13-0.45-7.65-0.96
		c-4.77-1.48-9.56-2.93-14.31-4.46c-1.58-0.51-3.49-0.73-3.82-2.93c1.97-0.35,3.94-0.71,5.91-1.06c0.2-0.42,0.43-0.44,0.69-0.05
		C385.94,657.31,388.18,657.29,390.42,657.26z"
        />
        <path
          class="st113"
          d="M313.44,588.26c-2.01,0.17-0.67,2.25-1.69,2.98c-1.24-0.73-2.48-1.46-3.72-2.19
		c-3.24-2.77-6.51-5.5-9.72-8.31c-1.27-1.11-2.93-2.04-2.71-4.16l-0.1,0.11C302,579.75,307.54,584.27,313.44,588.26z"
        />
        <path
          d="M328.54,606.59c-2.56,2.52-5.25,3.83-8.56,2.26c-1.53-0.72-2.24-1.17-0.8-3.41c3.08-4.77,5.27-4.38,7.95,0
		C327.42,605.92,328.04,606.2,328.54,606.59z"
        />
        <path
          d="M396.77,653.3c-2.38-0.13-4.74,1.23-6-1.03c-0.98-1.76,0.41-3.68,1.17-5.35c1.02-2.27,2.94-1.6,4.89-1.27
		c1.95,0.33,4,0.07,6.09,0.72c-1.3,0.34-2.61,0.96-3.91,0.96c-1.48,0.01-3.07-1.21-4.26,0.63
		C393.22,650.32,396.31,650.96,396.77,653.3z"
        />
        <path
          class="st99"
          d="M416.82,645.65c8.78-0.61,17.55-1.23,26.33-1.84c-0.01,1.9-1.64,2.22-2.88,2.91c-0.96-0.21-1.92-0.32-2.88,0
		c-0.96,0-1.92,0-2.87,0c-2.8-1.26-5.93,1.08-8.67-0.79C422.84,645.83,419.83,645.74,416.82,645.65z"
        />
        <path
          d="M376.38,643.84c1.49,0.01,2.66-0.13,3.52,0.68c0.53,0.5,1.26,1.25,1.19,1.8c-0.15,1.18-1.16,1.19-2.18,0.89
		c-0.74-0.22-1.51-0.41-2.27-0.42c-1.47-0.03-3.86,1.89-3.96-1.08C372.61,643.41,375.16,644.02,376.38,643.84z"
        />
        <path
          d="M307.85,651.7c-0.15-1.27-1.55-2.54-0.03-3.82c1.35-1.13,2.58-0.37,3.88,0.18c0.69,0.29,1.48,0.32,2.23,0.46
		c0,0-0.07-0.05-0.07-0.05c0.27,5.47-4.16,1.93-6.09,3.18C307.77,651.65,307.85,651.7,307.85,651.7z"
        />
        <path
          d="M449.73,642.76c0.95,0.05,1.91,0.21,2.85,0.13c3.79-0.33,1.7,1.61,1.18,2.96l0.04-0.02c-2.63,0.01-5.03,1.96-7.78,0.88
		c-0.32-0.32-0.63-0.64-0.95-0.96c1.72-0.79,2.74-2.67,4.74-3.02L449.73,642.76z"
        />
        <path
          class="st114"
          d="M609.95,438.67c-0.03,1.19-0.07,2.38-0.1,3.57c-0.5,0.9-0.8,2.35-2.2,0.81c-0.02-2.71-0.33-5.42,0.19-8.12
		c0.1-2.61,0.2-5.22,0.3-7.83C609.87,430.78,607.54,435.1,609.95,438.67z"
        />
        <path
          d="M425.85,645.93c2.9,0.14,5.93-1.05,8.67,0.79c-0.24,0.84,0.86,1.75-0.14,2.55c-2.21-3.64-5.99-0.51-8.66-2.05
		C425.57,647.12,425.8,646.37,425.85,645.93z"
        />
        <path
          d="M338.76,625.46c0.19,0.42,0.27,0.96,0.59,1.24c1.62,1.43,2.34,2.98,0.51,4.69c-1.09,1.01-1.97-0.07-1.96-0.88
		c0.03-1.68-4.04-4.28,0.94-5C338.84,625.5,338.76,625.46,338.76,625.46z"
        />
        <path
          class="st63"
          d="M605.31,402.14c-1.42,0.54-0.64,2.33-1.88,3.21c0.07-2.7-2.38-5.05-0.5-7.77c0.2,0.56,0.41,1.12,0.95,2.62
		c0.2-2.25,0.32-3.63,0.45-5.02C605.27,397.41,605.44,399.75,605.31,402.14z"
        />
        <path
          class="st86"
          d="M578.15,310.24c-1.2,1.72-1.4,4.9-5.21,3.24c1.11-1.94,2.8-3.12,4.53-4.26c0.39-0.4,0.64-0.35,0.73,0.22
		C578.22,309.71,578.21,309.98,578.15,310.24z"
        />
        <path
          class="st112"
          d="M607.09,347.61c1.33,1.05,0.99,2.42,0.8,3.77c-1.47,0.44-0.53-3.67-2.88-1.46c-0.7-0.61-0.97-1.37-0.86-2.28
		C605.12,347.05,606.1,346.99,607.09,347.61z"
        />
        <path d="M437.4,646.72c0.13-0.98,0.4-1.86,1.67-1.71c0.99,0.12,1.09,0.94,1.21,1.71C439.32,649.74,438.36,648.22,437.4,646.72z" />
        <path
          class="st99"
          d="M449.81,642.74c-1.68,0.84-2.3,3.36-4.74,3.02c-0.03-0.89-0.31-1.63-1.18-2.03
		C445.78,642.89,447.78,642.77,449.81,642.74z"
        />
        <path
          class="st101"
          d="M634.88,489.49c1.08,0.73,2.86,1.3,2.04,2.94c-0.61,1.23-2.02,1.21-2.99-0.09
		C634.24,491.4,634.56,490.44,634.88,489.49z"
        />
        <path
          d="M406.33,654.22c-0.69-0.04-1.23-0.3-1.32-1.05c-0.11-0.98,0.46-1.46,1.35-1.55c0.78-0.08,1.73-0.11,1.52,1.07
		C407.75,653.44,407.29,654.16,406.33,654.22z"
        />
        <path
          class="st99"
          d="M446.02,646.72c2.62-0.04,5.08-1.54,7.78-0.88c-2.45,1.21-5.06,1.74-7.77,1.79
		C446.02,647.32,446.02,647.02,446.02,646.72z"
        />
        <path
          class="st115"
          d="M578.2,309.45c-0.25-0.06-0.49-0.14-0.73-0.22c-0.41-0.95-0.83-1.89-1.24-2.84
		c1.68-2.15,2.33-0.09,3.26,0.81C578.46,307.6,578.46,308.59,578.2,309.45z"
        />
        <path
          class="st101"
          d="M628.25,457.45c0.23-2.42-0.89-4.98,0.77-7.25C629.09,452.66,629.35,455.13,628.25,457.45z"
        />
        <path
          class="st78"
          d="M398.09,656.33c-1.89,1.74-4.16,0.67-6.27,0.84C393.82,656.28,395.94,656.16,398.09,656.33z"
        />
        <path
          d="M383.7,657.34l-0.33,0.23c0,0-0.36-0.18-0.36-0.18c-0.48-0.2-1.61-0.09-1.21-0.77c0.51-0.89,1.83-1.68,2.78-0.97
		C385.31,656.18,383.77,656.62,383.7,657.34z"
        />
        <path
          class="st63"
          d="M606.17,408.01c-1.76-1.75-0.86-3.89-0.88-5.89C606.16,403.99,606.29,405.98,606.17,408.01z"
        />
        <path
          class="st63"
          d="M604.24,394.58c-1.63-1.4-0.87-3.25-0.92-4.95C604.19,391.18,604.35,392.86,604.24,394.58z"
        />
        <path d="M309.06,634.21c-0.41-0.53-0.81-1.06-1.22-1.6c0.33-0.69,0.82-0.89,1.38-0.31C309.86,632.97,309.85,633.64,309.06,634.21z" />
        <path
          class="st116"
          d="M744.18,455.94c-7.27,0.5-9.4,4.82-5.96,11.22c7.27,13.55,5.76,27.16-0.77,40.43
		c-3.49,7.09-7.62,13.94-13.87,19.04c-3.71,3.03-8.26,3.65-12.96,3.14c-0.47-0.8-2.76-0.2-1.7-2.2c1.3-1.14,2.91-1.48,4.53-1.82
		c6.64-1.35,11.73-4.16,15.18-10.76c2.38-4.55,5.36-8.86,7.36-13.67c1.29-3.09,2.41-6.24,1.66-9.7c-0.36-3.95,0.78-7.85,0.48-11.76
		c-0.37-4.82-1.55-9.35-6.45-11.76c-0.34-0.33-0.6-0.71-0.81-1.13c-2.11-5.28-6.68-7.57-13.54-6.73c-2.05,0.25-4.01,0.92-6.02,1.34
		c-3.25,0.67-6.35,0.49-8.86-1.99c-1.37-1.36-2.93-1.72-4.75-1.37c-2.01-1.33-2.51-3.13-1.7-5.35c2.02-2.04,4.09-1.49,5.89,0.18
		c5.38,5.02,11.71,3.02,17.65,2.13c3.78-0.56,3.39-4.21,2.63-6.99c-1.17-4.32-2.06-8.63-1.94-13.11c0.03-1.1-0.05-2.24,0.8-3.14
		c3.42,0.49,1.7,3.92,3.18,5.51c1.33,2.55,2.15,5.31,3.15,7.99c3.07,8.23,12.75,9.87,18.53,3.14c4.3-5.01,5.4-11.19,5.44-17.39
		c0.07-11.8,1.43-23.53,1.25-35.35c-0.09-5.85,1.21-11.66-0.83-17.48c-1.13-3.23-2.13-6.37-5.13-8.34
		c-1.89-1.24-2.21-2.59-0.64-4.29c6.97-0.16,9.14,1.87,10.99,10.25c0.59,21.06-0.52,42.08-2.58,62.99
		C753.76,445.36,751.98,452.96,744.18,455.94z"
        />
        <path
          class="st117"
          d="M709,527.64c0.54,0.71,1.09,1.41,1.63,2.12c-2.58-0.18-5.01-0.76-6.95-2.64c-4.02-3.88-8.78-4.69-14.13-3.63
		c-5.71,1.13-11.59,1.36-16.66-1.82c-3.44-2.16-6.18-5.43-9.24-8.21c-0.32,0-0.64,0-0.96,0c-3.19-8.71-5.14-17.55-2.88-26.84
		c0.03-6.1,3.17-11.1,5.75-16.3c2.87-8.2,8.6-14.31,14.81-20.02c2.64-2.43,6.2-1.79,9.37-2.35c1.01-0.18,1.36,1.12,1.19,2.18
		c-0.6,1.46-1.73,2.28-3.2,2.7c-5.74,0.37-8.87,4.74-12.01,8.51c-8.69,10.43-11.61,23.12-12.6,36.27c-0.3,3.99,0.1,8.39,4.76,10.48
		c1.53,0.72,2.16,2.25,3.11,3.48c3.92,5.08,9.29,6.75,15.45,6.57c1.87,1.13,3.62,1.37,5.94,0.7c2.88-0.83,6.14-1.75,9.04,0.45
		c0.87,3.82,3.69,5.73,7.02,7.16C708.7,526.81,708.89,527.2,709,527.64z"
        />
        <path
          class="st106"
          d="M744.18,455.94c9.66-7.64,9.73-18.62,10.62-29.51c1.39-17,0.64-34.02,0.88-51.02
		c1.3-0.72,2.05,0.23,2.87,0.96c-0.47,9.26,1.04,18.59-0.96,27.8c-1.46,1.24-0.98,2.95-0.93,4.47c0.33,9.99-0.03,19.99-1.16,29.89
		c-0.53,4.65-2.49,9.27-4.49,13.58C749.91,454.53,746.86,455.34,744.18,455.94z"
        />
        <path
          class="st36"
          d="M758.56,376.37c-0.96-0.32-1.92-0.64-2.87-0.96c-0.02-6.37-4.16-8.62-9.58-9.58
		c-0.22,0.01-0.44,0.02-0.66,0.03c-4.95-1.14-9.83-1.96-13.61,2.73c-0.19,0.12-0.38,0.23-0.56,0.34c-0.41,0.17-0.84,0.24-1.28,0.22
		c-0.88-0.2-1.63-0.59-2.11-1.4c4.67-7.15,11.88-7.03,19.17-6.71c0.95,1.17,0.5,3.41,2.4,3.76
		C755.97,365.98,756.98,371.37,758.56,376.37z"
        />
        <path
          class="st78"
          d="M697.21,440.6c1.58-0.18,3.95,0.6,3.71-2.2c-0.21-2.43-1.4-4.58-3.97-5.32c-1.17-0.33-2.51-0.26-3.75-0.13
		c-3,0.33-3.99-1.11-3.66-3.86c3.51-2.26,7.18-1.58,10.88-0.61c0.21,0.2,0.42,0.4,0.63,0.6c3.76,1.87,6.91,6.21,12.03,2.87
		c0.24-0.15,3.06,0.76,3.26,2.81c0.32,3.15,0.78,6.29,0.96,9.45c0.2,3.53-1.82,5.5-5.04,6.57c-3.15,1.06-5.56-0.17-6.81-2.79
		c-1.02-2.14-2.25-2.89-4.38-2.6c-2.13,0.29-3.2-1.52-4.71-2.2c-2.91-1.32-6.62-1.73-9.45,0.63c-2.4,2-4.94,2.77-7.93,2.52
		c3.5-1.99,6.7-4.59,11.02-4.84C692.41,441.38,695.02,442.47,697.21,440.6z"
        />
        <path
          class="st101"
          d="M651.19,497.16c-0.43,4.04-1.89,4.58-4.81,1.61c-2.38-2.41-5.58-3.74-7.33-7.11
		c-1.64-3.16,1.01-3.09,2.15-4.08c2.09-1.79,2.11,0.5,2.72,1.58c0.7,1.22,1.43,2.43,2.25,3.81c1.55-0.79,2.42-4.36,5.02-1.56
		C651.19,493.33,651.19,495.25,651.19,497.16z"
        />
        <path
          class="st101"
          d="M651.19,488.54c-2.23,0.14-3.98-0.06-3.87-3.11c0.1-2.93,2.01-2.62,3.87-2.64
		C651.19,484.7,651.19,486.62,651.19,488.54z"
        />
        <path
          class="st106"
          d="M690.5,450.08c-3.61-2.41-7.17-1.35-9.94,1.09c-5.7,5.02-11.02,10.47-13.57,17.95
		c-0.17,0.5-0.93,0.8-1.42,1.2c-0.81-4.62,2.79-7.4,4.95-10.46c4.38-6.21,9.59-12.37,17.73-13.02c4.76-0.38,10.21,0.1,14.26,3.51
		c3.57,3,7.43,4.14,11.91,3.64c5.03-0.56,7.35-3.39,5.51-8.09c-1.12-2.88-0.97-5.35-0.73-8.14c0.45-5.27-2.34-8.23-8.12-8.61
		c-3.33-0.22-6.69-0.05-10.04-0.05l0,0c-0.76-0.88-0.85-1.83-0.33-2.86c0.35-0.4,0.77-0.69,1.26-0.87c3.28-0.69,6.58-0.52,9.87-0.11
		c3.07,0.79,5.7,2.44,8.3,4.17c0.74,0.69,1.12,1.52,1.03,2.55c-0.04,5.4,0.55,10.64,2.46,15.81c2.09,5.65-0.67,8.55-6.64,9.25
		c-6.48,0.77-12.5,1.32-17.33-4.23c-1-1.14-2.34,0.51-3.58,0.32C694.07,452.39,692.49,450.85,690.5,450.08z"
        />
        <path
          class="st102"
          d="M659.82,486.62c-0.84,9.14,1.23,17.97,2.88,26.84c-0.58-0.53-1.53-0.96-1.68-1.59
		C659.07,503.54,655.49,495.25,659.82,486.62z"
        />
        <path
          class="st118"
          d="M505.79,296.64c1.39,0.41,2.78,0.82,4.16,1.23c10.26,4.25,19.43,10.39,28.69,16.38
		c0.93,0.6,1.82,1.31,1.83,2.59c-0.48,1.43-2.97,3.09,0.74,3.91c3.3,0.73,3.55,3.72,4.09,6.38c-0.16,2.52,1.83,1.51,3.01,1.82
		c1.29,0.77,2.42,1.6,1.25,3.3c-1.1,3.25-2.45,6.03-6.58,6.46c-1.88,0.19-2.86,2.36-4.17,3.8c1.35,1.44,3.04,0.76,4.55,0.92
		c3.33,0.34,5.11-0.87,5-4.55c-0.07-2.17-0.19-4.48,1.11-6.49c1.95-0.55,2.03,1.13,2.24,2.15c0.75,3.73,2.22,6.87,5.85,8.64
		c0.71,0.34,1.13,1.1,0.42,1.93c-2.77,0.91-5.36,1.94-6.02,5.33c-0.21,1.08-1.18,2.12-2.25,2.35c-4.72,1.01-4.66,4.49-4.53,8.14
		c0.08,2.39,0.12,4.79-0.07,7.18c-0.41,5.15-3.37,8.08-8.55,8.57c-6.47,0.62-6.54,0.62-6.69,7.27c-0.08,3.62-0.83,6.73-4.77,7.91
		c-2.24,0.67-2.9,2.24-2.9,4.36c0,1.75,0.04,3.51-0.15,5.26c-0.38,3.53-2.37,5.44-5.88,5.82c-1.91,0.21-3.83,0.12-5.74,0.2
		c-2.34,0.09-3.85,1.33-3.46,3.59c0.86,4.92-2.77,9.94,0.49,14.81c0.44,0.65-0.54,1.76-0.74,2.7c-1.7,3.66-4.86,6.15-8.28,7.52
		c-6.11,2.45-11.11,6.68-16.94,9.51c-0.55,0.01-1-0.2-1.35-0.63c-0.45-0.71-0.59-1.49-0.58-2.31c2.92-20.55,6.65-40.97,9.61-61.51
		c1.98-10.9,4.22-21.75,5.4-32.78c0.61-5.69,1.97-11.28,2.34-17.01c1.99-5.71,2.45-11.72,3.25-17.64c0.59-4.4,1.22-8.78,2.05-13.14
		C502.57,298.66,502.85,296.38,505.79,296.64z"
        />
        <path
          class="st69"
          d="M197.77,394.71c0-0.94,0-1.88,0-2.82c-1.82,4.9-6.21,5.16-9.98,7.2c-4.07,2.21-9.99,1.23-12.62,6.32
		c-0.61,1.19-2.35,0.65-3.58,0.66c-2.01,0.01-3.43,0.64-3.58,2.89c-0.57,1.2-1.45,1.74-2.79,1.3c-0.37-0.27-0.67-0.61-0.9-1.01
		c-1.41-3.84-5.79-4.56-8.01-7.71c-1.5-2.12-3.77-3.8-5.94-5.44c-3.87-2.92-4.04-4.86-1.29-8.85c1.07-1.56,1.84-3.34,3.31-4.63
		c1.99-2.87,5.6-3.24,8.25-5.34c4.97-3.93,7.38-9.46,11.13-14.11c2.76-1.97,2.44-5,2.62-7.81c0.15-2.39-0.02-4.79,0.1-7.18
		c0.09-1.81,0.32-3.81,2.27-4.39c3.77-1.11,3.74-3.54,3.17-6.71c-0.44-2.51-0.03-5.17,1.48-7.35c6.19-8.95,10.36-19,15.62-28.46
		c1.26-2.27,2.49-4.05,5.23-4.23c1.5,0.01,2.89,0.4,4.14,1.24c6.39,8.77,12.84,17.49,17.94,27.14c1.48,2.8,4.2,4.74,6.26,7.13
		c3.22,3.75,6.55,7.6,5.59,13.18c-1.9,8-3.89,15.98-5.64,24.02c-0.44,2.01-1.78,2.34-3.23,2.95c-6.86,2.9-13.68,5.87-19.87,10.12
		C203,385.85,199.36,389.42,197.77,394.71z"
        />
        <path
          class="st70"
          d="M236.17,345.73c-1.61-5.36-3.52-10.43-8.28-14.07c-3.82-2.93-5.79-7.46-7.91-11.65
		c-2.17-4.29-6.03-7.43-7.97-11.62c-1.61-3.46-5.4-5.55-5.65-9.68c-2.67-6.04-1.59-12.23-0.75-18.4c2.11-3.17,4.32-0.7,6.14-0.02
		c3.66-4.48,3.1-10.7,7.71-14.73c2.1-1.83,1.03-5.42,0.07-8.16c-0.69-1.98-1.23-3.96-0.85-6.04c0.33-1.78,0.79-3.61,3.36-2.58
		c3.64,3.08,10.17,3.75,13.61,0.95c2.19-1.78,4.49-2.23,7.09-2.24c6.07-0.03,12.14-0.02,18.21-0.01c2.29,0,4.43-0.23,6.12-2.09
		c1.41-1.54,3.4-1.85,5.32-1.68c7.94,0.7,15.3-2.86,23.12-3.04c0.47-0.01,0.92-0.25,1.4-0.31c2.62-0.36,5.3-0.29,7.13,1.77
		c1.81,2.03-0.75,3.78-0.99,5.73c-13.02,11.46-25.07,23.82-35.04,38.08c-4.05,5.8-7.96,11.69-11.94,17.54
		c-2.6,0.56-1.96,3.04-2.76,4.67c-5.44,10.76-11.09,21.42-15.14,32.82C237.6,342.58,236.84,344.14,236.17,345.73z"
        />
        <path
          class="st47"
          d="M545.33,540.12c-9.82,5.98-19.96,11.35-30.35,16.24c-2.67,0.7-5.23,1.69-7.6,3.12
		c-6.67,3.43-13.54,6.35-20.88,8.05c-1.41,0.33-2.79,0.83-4.04-0.39c0.91-0.87,1.95-1.64,2.71-2.62c3.6-4.64,6.74-5.99,11.82-3.31
		c1.45-5.04,0.82-10.12,0.68-15.13c-0.07-2.55-9.86-6.07-12.18-4.62c-3.99,2.52-4.39,2.9-5.29,2.35c-3.44-2.11-5.85,1.98-9.07,1.34
		c-1.92-0.38-3.74,0.36-5.17,1.88c4.13,2.25,4.14,2.27,8.34,0.2c1.75-0.86,3.43-1.64,5.44-0.63c1.71,0.86,3.11,1.86,2.56,4
		c-0.61,2.38-2.22,1.87-4.14,1.6c-4.82-0.66-9.6-0.97-14.56,0.13c-4.32,0.96-8.77,1.09-12.67-2.8c-2.16-2.15-5.88,0.73-9.14-0.13
		c-3.02-0.8-7.12-1.34-9.51,0.07c-5.82,3.44-12.04-0.41-17.69,2.07c-2.04,0.9-4.01-0.62-6.06-0.81c-7.36-0.67-14.69-2.8-22.08-0.27
		c-1.26,0.43-1.79,0.22-2.52-1.09c-0.76-1.37-1.99-3.07-4.24-1.78c-1.29,0.74-2,1.59-1.32,3.07c0.85,1.85,0.13,4.87,3.45,4.93
		c3.99,0.07,7.98,0,11.97,0.06c1.53,0.02,3.7-0.36,3.79,1.81c0.09,2.21-2.04,1.99-3.6,2c-10.06,0.02-20.11-0.03-30.17,0.03
		c-2.78,0.02-4.2-1.02-4.08-3.93c0.08-2.07,0.01-4.15,0.01-6.22c-0.01-6.54-1.19-7.53-7.59-5.62c-2.67,0.8-4.59,0.37-7.1-0.87
		c-2.88-1.43-1.13-2.44-0.57-3.78c1.99-1.37,4.02-0.54,5.98-0.02c4.47,1.19,8.99,2.11,13.52,3.01c8.96,1.34,17.82,3.47,26.93,3.75
		c0.64,0.06,1.26,0.36,1.87,0.36c11.69,0.01,23.33,2.66,35.08,0.7c3.3-0.55,6.66-0.17,9.99-0.26c10.62-1.09,21.28-1.97,31.74-4.29
		c11.36-2,22.4-5.26,33.42-8.61c5.23-1.89,10.56-3.52,15.65-5.8c13.69-5.74,26.81-12.55,39.34-20.53c3.21-2.05,5.04-4.63,5.6-8.37
		c0.66-4.41,1.87-8.72,2.42-13.15c1.69-11.85,4.09-23.61,4.24-35.64c0.11-1.16,0.16-2.32,0.47-3.45c0.78-2.34,0.37-4.74,0.37-7.12
		c0.03-19.61,0.07-39.23-0.83-58.83c-0.04-2.94,0.07-5.87-0.47-8.81c-0.36-1.98-0.25-4.21,2.77-4.26
		c3.03,10.84,4.28,21.99,5.72,33.1c0.2,1.55,0.56,3.08,0.84,4.62c1.02,0.67,1.23,1.73,1.37,2.83c0.17,2.44,0.05,4.91,0.87,7.27
		c0.51,6.19-1.2,12.3-0.67,18.49c0.15,1.73-0.24,3.5,0.45,5.18c-0.53,2.86-0.46,5.71-0.04,8.57c-0.47,6.17-0.26,12.29,0.17,18.49
		c0.54,7.68-0.19,15.49-3.12,22.84c-1.81,6.87-1.88,14.02-4.28,20.86c-3.1,8.85-8.79,15.26-16.03,20.68
		C553.67,533.81,549.5,536.97,545.33,540.12z"
        />
        <path
          class="st119"
          d="M334.8,535.71c-7.93-2.26-15.72-4.87-23.14-8.5c0.25-3.19,2.94-3.27,5.09-3.82
		c1.52-0.39,3.22-0.45,4.76-0.22c3.6,0.53,5.37-0.94,5.92-4.44c0.66-4.17,3.01-6.64,7.46-6.51c2.48,0.07,4.15-1.08,5.66-2.95
		c2.8-3.47,5.52-7.05,9.27-9.63c1.72-1.19,3.38-2.43,5.52-2.72c0.47-0.06,1.29-0.15,1.33-0.39c0.98-5.8,7.38-6.76,10.01-11.38
		c2.32-4.07,6.95-6.53,9.94-10.55c1.35-1.81,5.17-2.16,5.32-5.85c0.03-0.79,0.64-1.68,1.41-1.79c4.03-0.57,6.63-2.73,7.9-6.57
		c0.09-0.28,0.39-0.6,0.67-0.65c6.34-1.13,10.75-5.8,16.17-8.59c2.15-1.11,3.46-1.88,4.31-4.32c1.91-5.47,5.56-9.76,11.41-11.17
		c2.77-0.67,3.71-2.76,5.21-4.46c-3.67-0.9-7.38-1.84-11.35-1.21c-1.15,0.18-3.17-0.14-1.71-2.55c0.63-1.04-1.01-0.71-1.43-1.23
		c-0.89-0.44-1.71-0.96-2.27-1.79c-0.15-0.52-0.04-0.97,0.32-1.36c2.84-1.41,5.12,1.18,7.78,1.1c5.97,1.84,11.67,4.49,17.78,5.9
		c1.18,0.34,2.13,1.05,3.01,1.87c1.66,1.64,3.12,3.3,5.97,3.12c1.86-0.12,3.17,1.53,1.36,3.17c-3.1,2.82-4.91,6.68-8.08,9.41
		c-0.96,0.82-1.74,1.76-3.09,2.11c-3.37,0.89-5.08,3.53-6.33,6.53c-0.12,0.29-0.19,0.62-0.21,0.93c-0.31,4.59-6.18,3.47-7.21,6.67
		c-1.3,4.03-3.56,5.72-7.56,5.9c-2.3,0.1-4.36,1.1-5.89,2.84c-2.33,2.64-4.66,5.19-7.82,6.94c-2.1,1.17-2.46,3.63-3.08,5.76
		c-1.09,3.7-3.2,5.8-7.29,6.51c-5.01,0.87-9.16,3.62-12.31,7.83c-1.91,2.55-5.84,2.61-7.45,5.4c-0.13,0.58-0.03,0.86,0.24,1.09
		c1.14,0.94,3.71,0.21,3.61,2.39c-0.09,1.85-2.23,1.93-3.62,2.64c-3.56,1.82-7.44,2.52-11.9,3.17c2.29,2.64,3.03,3.99-0.94,5.49
		c-2.24,0.85-6.2,1.73-6.69,5.59C347.08,529.27,342.31,534.9,334.8,535.71z"
        />
        <path
          class="st32"
          d="M298.48,520.93c-8.08-3.83-15.88-8.15-23.09-13.49c-1.91-5.1-3.01-10.31-2.29-15.79
		c4.03-0.35,3.88,2.91,4.37,5.33c0.53,2.6-0.01,5.35,0.64,7.97c-0.09-1.62-0.69-3.47,0.12-4.81c2.6-4.3,2.35-9.13,3.1-13.79
		c0.33-2.09,1.05-4.27,3.27-4.95c3.46-1.05,3.91-3.72,4.35-6.65c0.76-5.09,0.38-10.2,0.41-15.29c0.02-3.97,0.8-7.28,5.09-8.72
		c2.75-0.92,2.63-3.37,2.57-5.59c-0.12-4.52,0-8.66,5.65-10.08c2.27-0.57,1.96-3.02,2.04-4.91c0.21-5.73-0.4-11.48,0.76-17.18
		c1.25-6.16,1.96-6.86,8.45-6.36c1.67,0.13,1.88-0.74,2.1-1.87c0.51-2.71-0.35-4.99-2.1-7.07c-0.93-1.1-1.86-2.56-0.99-3.92
		c0.99-1.53,2.86-1.45,4.37-0.87c2.73,1.03,5.51,1.53,8.41,1.44c2.75,0.44,5.46,1.03,8.04,2.14c0.46,0.25,0.85,0.58,1.17,1
		c0.24,0.47,0.32,0.97,0.25,1.5c-3.42,13.57-7.53,26.94-11.57,40.34c-0.6,1.99-0.86,4.04-1.44,6.02
		c-3.16,7.77-4.11,16.23-7.54,23.91c-0.97,1.95-1.72,3.97-1.6,6.21c-1,5.13-2.97,10.01-4.03,15.12c-2.51,8.57-5.51,17-7.65,25.68
		C300.88,518.07,300.58,520.06,298.48,520.93z"
        />
        <path
          class="st21"
          d="M414.39,425.26c1.63,0.42,3.26,0.84,4.99,1.29c-0.9,1.13-2.67,0.66-3.33,2.91c5.26-2.21,9.93-0.52,14.63,1.06
		c-0.68,1.15-2,2.08-2.05,3.86c-0.04,1.71-1.44,2.18-3.03,2.4c-6.14,0.85-11.33,6.01-12.17,12.09c-0.19,1.37-0.6,3.13-1.85,2.93
		c-4.97-0.82-6.68,3.84-10.08,5.55c-1.56,0.78-3.12,2.2-4.68,2.19c-3.68-0.02-5.53,1.26-6.04,5.01c-0.28,2.11-2.06,3.15-4.3,2.87
		c-2.99-0.37-4.1,1.04-3.74,3.88c0.37,2.92-0.92,4.16-3.82,3.8c-2.86-0.36-4.22,0.81-3.85,3.77c0.35,2.8-0.68,4.23-3.71,3.92
		c-2.86-0.29-4.12,1.16-3.97,3.98c0.14,2.66-1.24,3.8-3.8,3.66c-2.93-0.16-4.1,1.35-3.84,4.1c0.25,2.69-0.85,3.68-3.56,3.62
		c-4.29-0.1-6.43,3.61-9.49,5.73c-2.4,1.67-4.27,4.31-5.25,6.4c-1.75,3.74-4.22,3.17-6.92,3.14c-2.66-0.03-4.57,0.64-5.46,3.49
		c-2.49,7.91-2.58,8.27-10.32,7.72c-3.16-0.22-4.94,1.18-7.1,2.57c-4.15-2-8.29-4-12.44-6c1.83-2.44,3.3-5.07,4.13-8.02
		c1.01-3.6,3.37-5.8,6.99-6.38c3.16-0.5,5.87-2.36,9.18-2.5c2.73-0.12,3.48-2.14,3.21-4.84c-0.71-6.88,0.6-8.19,7.59-7.51
		c2.62,0.25,4.36-0.98,5.79-2.71c3.04-3.67,6.29-6.76,11.47-6.96c2.04-0.08,3.08-1.65,3.22-3.59c0.21-3.01,1.54-4.77,4.72-4.86
		c0.79-0.02,2-0.13,2.19-0.74c1.96-6.25,9.23-6.1,12.64-10.66c1.8-2.41,4.29-4.28,4.74-7.55c0.18-1.35,1.02-2.27,2.38-2.73
		c7.67-2.58,12.66-8.32,16.93-14.75c3.31-4.98,7.19-8.89,13.5-9.44c1.41-0.12,2.32-0.96,3.2-1.91
		C412.05,425.3,413.13,424.9,414.39,425.26z"
        />
        <path
          class="st65"
          d="M303.05,247.86c-0.24-0.55-0.61-1.08-0.71-1.66c-0.22-1.35,2.66-2.56,0.86-3.56
		c-1.76-0.99-3.97-1.57-6.37-1.17c-7.94,1.33-15.68,4.04-23.9,3.6c-2.23-0.12-4.8-0.82-5.62,2.72c-0.39,1.68-2.45,1.04-3.8,1.05
		c-7.33,0.05-14.65,0-21.98,0.05c-1.24,0.01-3.28-0.13-3.6,0.5c-3.44,6.64-9.34,2.17-13.96,3.17c-2.61,0.57-2.18-2.02-2.28-3.69
		c-2.14-3.05-1.34-6.41-0.96-9.7c0.18-1.59,1.31-2.72,2.87-2.77c4.07-0.13,7.68-1.96,11.53-2.84c3.6-0.81,7.38-0.62,10.8,0.89
		c2.94,1.3,4.88,1.47,5.3-2.4c0.12-1.13,0.5-2.49,1.61-2.77c7.28-1.86,7.99-10.17,13.56-13.69c0.5-0.31-0.16,0.12,0.17-0.43
		c2.18-5.34,7.68-4.1,11.67-5.81c1.37-0.59,3.2-0.08,4.15-1.73c5.95-4.04,10.9-9.01,14.73-15.16c1.97-3.16,3.69-6.66,7.23-8.55
		c2.63,0.12,5.21,0.32,5.91,3.6c-0.73,3.05-3.59,3.41-5.83,4.36c-3.19,1.36-4.74,3.54-4.74,6.97c0,2.07,0.06,4.14-0.05,6.21
		c-0.23,4.29,0.18,6.8,5.46,9.07c6.45,2.78,12.51,7.46,18.04,12.23c1.64,1.41,3.22,3.63,2.12,6.33
		C317.87,237.75,310.46,242.8,303.05,247.86z"
        />
        <path
          class="st70"
          d="M443.91,248.77c2.96-1.71,6.47-0.17,9.59-1.86c3.67-1.98,4.27-3.49,1.68-6.94c-2.17-2.88-5.59-4.06-8.26-6.24
		c-1.51-1.43-3.32-2.87-2.34-5.24c0.91-2.2,3.14-2.39,5.22-2.73c2.75-0.44,5.21,1.2,7.92,0.97c10.91,2.23,21.08,6.6,31.29,10.84
		c0.86,0.36,1.76,0.6,2.65,0.89c4.83,0.93,8.62,3.69,12.11,6.95c-1.93,2.7-3.96,0.65-5.94,0.1c-1.87-0.52-3.64-1.73-3.45,2.02
		c0.21,4.03-2.84,5.66-6.42,6.36c-4.22,0.83-4.51,1.73-4.25,8.28c0.14,3.65,1.99,4.5,5.2,4.62c5.11,0.19,7.9,3.81,7.07,8.87
		c-0.4,2.43-2.29,2.17-4.06,2c-10.18-3.64-20.27-7.55-30.82-10.04c-6.35-1.5-12.73-2.88-19.09-4.32c1.52-1.4,0.84-3.11,0.9-4.83
		c0.12-3.15-1.84-7.08,2.56-9.07C444.98,249.14,444.26,249.41,443.91,248.77z"
        />
        <path
          class="st21"
          d="M411.51,426.22c0.11,2.1-0.64,3.48-2.98,3.21c-6.16-0.71-9.82,3.28-12.32,7.68
		c-3.6,6.32-9.45,10.19-14.26,15.18c-0.98,1.01-2.38,0.75-3.64,0.79c-1.28,0.05-1.91,0.6-2.25,1.93c-1.8,7.12-6.3,11.62-13.44,13.45
		c-0.45,0.11-1.23,0.3-1.25,0.5c-0.37,5.4-4.02,6.31-8.47,6.68c-1.21,0.1-0.78,2.22-0.81,3.45c-0.07,2.85-1.39,4.76-4.3,4.58
		c-4.6-0.28-7.41,2.2-9.94,5.49c-2.4,3.11-4.87,5.39-9.5,3.57c-3.45-1.35-5.78,1.82-4.75,5.82c1.34,5.18-0.18,6.24-5.49,7.46
		c-4.36,1-9.97,0.55-12.6,5.35c-1.25,2.29-1.85,4.98-3.19,7.36c-0.79,1.4-1.52,2.34-3.11,2.48c-0.31,0.08-0.55-0.01-0.73-0.29
		c2.55-8.72,5.07-17.44,7.67-26.14c0.45-1.5,1.22-2.9,1.84-4.34c2.83-2.53,2.43,0.5,3.07,1.76c0.24,0.67,0.61,2.1,1.32,1.16
		c2.81-3.71,6.94-3.62,10.8-4.08c3.4-0.4,4.57-2.01,4.65-5.32c0.21-7.91,0.88-8.65,8.79-9.08c3.99-0.22,6.79-1.42,7.67-5.63
		c0.2-0.94,0.64-2.12,1.58-2.25c3.71-0.51,5.09-3.61,7.49-5.71c2.82-2.48,5.38-4.49,6.12-8.31c0.17-0.9,1.23-1.58,2.19-1.68
		c3.15-0.32,4.41-3.24,6.47-4.55c5.03-3.21,6.35-11.01,13.81-10.98c1.24,0.01,2.58-0.79,2.97-2.12c0.98-3.32,3.29-5.32,6.14-6.98
		c1.55-0.9,2.16-2.32,1.11-4.06c-1.97-3.26,0.68-3.08,2.49-3.1c2.53-0.04,4.84,1.69,7.48,1.17c0.94-0.01,1.78,0.27,2.56,0.77
		c1.01,0.71,1.9,1.61,3.08,2.06c0.96,0.36,2.03,0.18,2.99,0.55C411.47,424.64,412.09,425.22,411.51,426.22z"
        />
        <path
          class="st120"
          d="M335.78,292.04c13.5-5.49,27.38-9.61,41.84-11.65c2.16-0.64,4.19-0.64,5.85,1.18
		c0.36,0.42,0.5,0.91,0.42,1.46c-0.44,0.74-1.16,1.24-1.95,1.19c-3.97-0.28-5.85,1.5-5.95,5.48c-0.03,1.29-0.94,2.43-2.07,3.08
		c-3.77,2.16-4.89,5.69-5.15,9.65c-0.28,4.34-3.48,7.36-5.28,10.93c-1.81,3.6-2.89,8.77-8.51,9.39c-0.93,0.1-1.33,1.36-1.45,2.31
		c-0.39,3.25-2.08,5.1-5.35,5.81c-3.05,0.66-2.34,3.38-2.45,5.5c-0.15,2.9-0.53,5.48-4.27,5.67c-3.08,0.16-4.58-1.37-5.38-4.24
		c-1.22-4.35,0.06-8.94-1.47-13.23c-0.39-9.36-0.12-18.72-0.17-28.07C334.45,294.88,334.61,293.31,335.78,292.04z"
        />
        <path
          class="st121"
          d="M314.69,301.59c0.47-0.66,1.08-1.03,1.92-0.95c1.63,0.33,3.05,0.91,3.43,2.78c-0.03,0.47,0.04,1.1-0.3,1.36
		c-5.88,4.49-4.7,10.91-4.62,16.98c0.06,4.37-0.11,8.41-5.73,9.26c-1.51,0.23-1.77,1.65-1.88,2.96c-0.14,1.74-0.15,3.49-0.07,5.23
		c0.19,4.01-0.86,6.88-5.59,7.03c-1.96,0.06-3.55,1.27-5.14,2.33c-1.36,0.91-2.76,1.77-4.17,0.05c-1.1-2.83-2.92-3.12-5.66-2.08
		c-10.2,3.88-15.42,12.21-19.75,21.45c-1.32,2.81-1.59,6.23-4.57,8.13c-2.89,0.8-5.52,0.65-7.44-2.05
		c-0.47-0.93-0.38-1.93,0.13-2.74c6.21-9.95,10.71-20.85,17.16-30.68c3.35-5.1,6.4-10.42,8.49-16.2
		c9.63-8.73,20.18-16.13,31.89-21.82C313.73,302.83,314.86,303.39,314.69,301.59z"
        />
        <path
          class="st51"
          d="M505.79,296.64c-1.72,0.69-2.06,2.06-2.29,3.79c-1.19,9.07-2.53,18.11-3.81,27.17
		c-0.21,1.45-0.69,2.77-1.89,3.72c-1.75-1.81-0.83-3.89-0.58-5.89c0.23-1.86,0.77-3.7,0.45-5.9c-6.82,1.35-8.99,7.25-10.55,11.98
		c-3.66,11.1-5.79,22.64-13.01,32.38c-3.72,5.02-5.22,11.27-7.21,17.16c-1.28,3.79-3.54,6.32-7.39,7.41
		c-0.47-0.04-0.9-0.22-1.28-0.5c-0.98-1.98-1.38-4.3-3.33-5.72c-2.91-4.1-3.76-9.05-5.59-13.59c-0.12-0.73,0-1.4,0.46-2
		c2.39-0.5,4.06,0.15,4.59,2.99c3.75-4.89,5.28-11.2,10.3-15.1c0.78-0.6,1.16-1.62,1.1-2.58c-0.31-4.48,0.8-7.97,5.3-10.12
		c1.85-0.89,1.98-2.57-0.66-3.68c-4.06-1.7-4.24-3.32-0.96-6.57c2.47-2.45,5.56-4.41,5.48-8.49c-0.01-0.47,0.28-1.13,0.65-1.22
		c4.21-1.05,4.95-4.95,7.16-7.81c2.97-3.86,1.97-8.41,4.91-12.21c-2.9-0.29-3.88,1.48-5.38,2.1c1.75,0.03,3.1,0.31,1.31,2.27
		c-1.02,1.12-2.55,1.25-4,1.29c-3.67,0.08-6.61,0.85-8.84,4.52c-1.3,2.14-4.7,0.81-7.19,0.46c-1.16-1.59,0.16-2.38,1.18-2.96
		c9.79-5.51,19.3-11.5,29.33-16.59c0.87-0.44,1.85-0.36,2.77-0.59C499.87,293.59,503.11,294.53,505.79,296.64z"
        />
        <path
          class="st66"
          d="M397.13,170.24c1.28,0.46,2.56-0.98,3.84,0c-0.05,2.61,0.71,5.47-2.94,6.63c-1.08,0.34-0.9,1.93-0.89,3.04
		c0.02,1.68-0.51,2.88-2.42,2.75c-3.42-0.24-4.58,1.49-4.31,4.65c0.24,2.82-1.08,4.28-3.93,3.99c-3.02-0.31-4,1.07-3.75,3.9
		c0.27,2.97-1.43,3.99-4.14,3.79c-2.86-0.21-4.77,0.71-4.45,3.97c0.31,3.04-1.14,4.01-3.93,3.72c-0.95-0.1-1.97,0.19-2.86-0.05
		c-3.43-0.95-4.78,1.54-6.25,3.7c-1.53,2.26,1.38,2.99,2,5.41c-4.84-0.56-8.74,2.62-13.49,2.45c-2.93-0.11-3.95,1.09-2.33,3.82
		c0,0-0.22,0.27-0.22,0.27l-0.33-0.11c-3.03-0.19-5.86,2.72-9.02,0.55c-2.14-3.43,0.06-7.95,4.58-9.37c0.9-0.28,1.88-0.24,2.8-0.44
		c4.78-1.02,5.52-2.03,5.64-7.59c-0.21-3.84,0.05-7.15,5.07-7.89c3.6-0.54,2.17-3.9,2.57-6.18c-0.05-2.18-0.19-4.36,0.48-6.48
		c0.3-0.74,0.81-1.66,1.51-1.66c4.97,0.02,5.8-3.7,6.8-7.31c1.33-1.07,2.92-1.08,4.5-1.13c1.74-0.07,3.5-0.06,5.23,0.06
		C384.09,175.2,391.1,174.96,397.13,170.24z"
        />
        <path
          class="st122"
          d="M450.26,278.46l0.29-0.16l0.27,0.2c5.54,1.3,10.98,3.03,16.64,3.79c2.89,0.22,5.6,1.1,8.25,2.21
		c-0.07,1.24-0.47,2.44,0.31,3.68c0.63,1.01,0.67,2.59-0.46,2.98c-3.69,1.27-5.23,4.9-8.16,6.96c-2.97,2.09-3.82,5.83-6.38,8.36
		c1.17,0.13,2.09-0.99,3.25-0.37c0.89,0.47,1.63,1.07,1.92,2.02c0.43,1.4-0.71,1.44-1.6,1.75c-1.31,0.46-1.95,1.58-2.45,2.79
		c-7.8,6.36-16.93,10.53-25.54,15.56c-0.68,0.4-1.49,0.55-2.23-0.02c-0.44-0.63-0.54-1.34-0.47-2.08c1.87-4.8,1.3-10.15,2.63-14.8
		c1.5-5.23,1.14-10.37,2.02-15.48c0.39-2.26,1.33-4.05,3.77-5.05c3.04-1.24,4.21-4.15,5.05-7.14c0.27-0.96,0.58-1.93-0.73-2.33
		c-1.2-0.37-2.2-0.05-2.76,1.18c-0.7,1.53-0.26,3.54-2.17,4.87c-2.48-2.36-2.01-5.19-1.1-7.83c0.97-2.79,3.48-1.37,5.4-1.42
		C447.42,278.1,448.87,277.94,450.26,278.46z"
        />
        <path
          class="st60"
          d="M482.46,567.14c8.64-1.46,16.55-5.3,24.92-7.66c-1.62,3.22-5.52,2.75-8.08,5.01
		c1.38,1.25,3.14,2.24,3.93,3.75c0.72,1.37,0.89,3.39-0.69,4.83c-1.99-4.83-4.98-5.72-10.27-5.01c-4.19,0.56-8.31,1.81-12.51,1.9
		c-4.84,0.1-7.59,4.35-11.91,5.29c-0.12,6.23-5.91,5.43-9.32,7.63c-2.06,1.33-0.45,3.91-1.25,5.79c-1.46,3.42,2.65,1.76,3.14,3.42
		c-12.35-1.31-24.67-2.68-36.89-5.02c-7.84-1.5-15.8-2.37-23.68-3.63c-4.51-0.72-8.99-1.65-13.49-2.47
		c-2.17-0.4-4.36-1.02-6.41,0.42c-2.37-1.08-4.23-2.61-5.13-5.92c5.59,0.79,10.71,1.5,15.82,2.23c23.92,3.43,47.29-0.59,70.62-5.17
		C468.4,571.11,475.6,569.8,482.46,567.14z"
        />
        <path
          class="st66"
          d="M325.28,232.7c-1.44-5.77-6.43-7.98-10.78-10.89c-2.89-1.93-6.23-3.31-8.35-6.25
		c-0.77-1.07-1.81-1.35-2.93-1.18c-4.25,0.64-5.33-1.49-4.85-5.23c0.14-1.1,0.13-2.25,0-3.35c-0.96-8.27,0.12-15.28,10.17-17
		c0.51-0.09,0.91-0.85,1.35-1.3c1.8-1.8,4.13-1.32,6.31-1.42c6.78-0.32,13.68,0.94,20.31-1.54c1.03-0.39,2.21-0.15,3.27,0.28
		c2.33,2.7,0.24,4.01-1.83,4.82c-5.01,1.97-10.09,3.84-15.65,3c-4.22,1.18-4.37,1.78-1.64,6.6c1.16,2.33,1.38,4.71,0.37,7.14
		c-1.03,1.51-2.8,1.25-4.26,1.74c-1.23,0.41-1.71,1.33-1.67,2.56c0.04,1.03,0.52,2.21,1.5,2.11c4.02-0.4,6.47,4.45,10.95,2.96
		c1.8-0.6,2.86,1.65,2.39,3.21c-1,3.29-0.96,5.99,2.18,8.1c0.44,0.3,0.17,1.21,0.18,1.84C330.34,230.87,327.5,231.21,325.28,232.7z"
        />
        <path
          class="st62"
          d="M491.91,277.68c0.76-1.1,4.04-0.44,2.76-2.46c-1.52-2.41,1.63-7.99-4.84-7.29c-2.29,0.25-5.88,1.46-6.84-1.53
		c-1.3-4.04-0.83-8.5-0.14-12.73c0.19-1.18,1.89-1.13,2.94-0.93c2.98,0.55,4.9-0.94,6.87-2.87c0.96-0.94,1.64-1.54,0.59-2.62
		c-0.84-0.87-2.42-1.36-0.93-2.93c1.26-1.32,2.69-1.29,4.37-0.84c2.27,0.62,3.98,3.63,6.87,1.68c4.06-0.68,6.74,1.23,8.64,4.6
		c-2.22,3.32-2,7.78-1.96,10.91c0.09,8-8.35,14.87-2.81,23.25c-0.42,0.17-0.84,0.34-1.25,0.52
		C501.41,282.19,496.66,279.93,491.91,277.68z"
        />
        <path
          class="st82"
          d="M258.15,550.79c-0.76,1.47-1.77,2.74-3.52,2.89c-2.32,0.2-2.62,1.85-2.19,3.4c1.63,5.79-2.88,5.12-5.18,4.04
		c-4.64-2.18-9.3-1.55-13.97-1.58c-2.75-0.02-4.08-0.68-4-3.74c0.07-2.67,0.57-4.42,3.68-3.98c3.63,0.52,4.15-1.47,4.11-4.51
		c-0.13-9.86-0.03-19.73-0.06-29.59c-0.01-2.78,0.14-5.44,2.83-7.12c4.64,9.04,6.91,19.09,11.9,27.99
		C253.99,542.59,256.02,546.72,258.15,550.79z"
        />
        <path
          class="st65"
          d="M443.91,248.77c0.94,0.06,1.88,0.13,2.99,0.2c-4.34,2.95-3.9,7.45-2.44,10.85c1.64,3.81-0.01,3.48-2.46,3.49
		c-13.79-1.73-27.63-2.71-41.53-2.88c-3.93,1.09-8.05-0.4-11.97,0.87c-2.44,0.66-4.89,1.34-7.46,1.04c-1.33,0.62-2.64,0.47-4.34,0
		c0.95-2.36,2.99-2.29,4.61-2.62c1.87-0.37,2.72-1.19,2.31-3.11c1.07-0.95,2.26-0.37,3.02-0.52c-0.99-0.17-2.34-0.39-3.4,0.98
		c-4.41,2.76-9.35,2.2-14.18,2.2c-0.91,0-1.84-0.52-1.65-1.8c10.28-2.87,20.84-4.06,31.39-5.3
		C413.79,250.42,428.84,249.53,443.91,248.77z"
        />
        <path
          class="st84"
          d="M497.8,202.84c2.69,3.06,6.97,1.98,10.12,3.88c1.6,0.96,3.77,0.41,5.22,1.87c1.63,4.57,0.67,6.29-3.89,6.66
		c-4.7,0.38-9.44-0.02-13.45,3.54c-1.7,1.51-4.67,0.26-8,1.66c3.47,1.04,6.12,1.87,8.02,3.91c1.35,1.45,2.76,2.92,0.49,4.76
		c-0.49,0.14-0.97,0.09-1.41-0.16c-6.05-3.99-12.83-6.52-19.24-9.8c0.71-0.29,1.81-0.4,2.05-0.91c0.56-1.17-0.74-1.01-1.35-1.25
		c-1.77-0.68-3.57-1.29-5.81-2.08c3.19-3.03,3.42-7.06,4.12-10.83c0.68-3.66-0.67-6.63-4.57-7.8c-1.27-0.38-2.43-0.76-2.98-2.09
		c7.09,0.82,13.53,4.39,20.71,4.94c1.12,0.09,2.18,1.16,3.26,1.77l0,0C492.97,202.78,495.88,201.09,497.8,202.84z"
        />
        <path
          class="st95"
          d="M436.78,276.56c0.85,0.09,1.69,0.19,2.54,0.28c1.39,1.28,1.38,3.19,0.8,4.44c-1.53,3.26-1.66,6.59-1.69,10.06
		c-0.02,2.15-1.11,3.21-3.44,2.03c-3.2-1.61-4.75-0.25-5.13,3.05c-0.11,0.95-0.41,2.38-1.22,2.42c-5.47,0.31-9.07,7.82-15.97,3.33
		c1.09,5.52,7.11,6.81,7.69,11.7c-1.69,1.53-3.03,0.29-4.1-0.76c-3.49-3.42-7.36-6.5-10-10.72c-2.47-4.14-0.66-7.81,2.3-10.26
		c3.87-3.21,3.44-7.23,3.7-11.29c0.21-3.21-3.69-1.3-4.63-4.6C417.51,276.3,427.13,275.82,436.78,276.56z"
        />
        <path
          class="st123"
          d="M332.29,228.89c-0.25-0.19-0.72-0.41-0.7-0.57c0.4-3.45-4.13-0.54-4.42-3.57c-0.24-2.5,2.23-3.84,1.91-6.24
		c-0.33-2.44-1.48-2.62-3.2-1.38c-2.04,1.47-3.58,1.25-4.44-1.18c-0.57-1.6-1.78-1.73-3.06-1.58c-3.41,0.41-4.86-0.66-4.75-4.43
		c0.12-3.95,2.62-3.19,4.9-3.27c0.64-0.02,1.27,0,1.91,0c0.92,0.34,1.53,1.16,2.39,1.57c2.91,1.41,4.28,0.67,4.15-2.5
		c-0.16-3.91-0.02-7.49,4.66-8.71c6.97-1.81,12.72-0.24,14.85,4.6c1.2,2.72,3.93,2.47,5.59,4.07c-0.01,6.93-1.03,8.47-8.27,8.43
		c-3.52-0.02-2.66,3.43-4.98,4.04c-4.89,1.27,0.58,3.2-0.18,4.79c-0.16,2.99-3.62,2.92-4.7,5.06
		C333.4,228.32,332.85,228.61,332.29,228.89z"
        />
        <path
          class="st124"
          d="M420.14,314.05c-2.5-2.67-4.86-5.49-7.56-7.94c-1.95-1.77-2.19-3.73-0.75-5.4c1.66-1.93,2.11,0.81,3.15,1.38
		c0.14,0.08,0.28,0.16,0.42,0.22c3.83,1.66,5.07-2.13,7.56-3.35c2.32-1.14,6.14,0.93,5.96-4.35c-0.15-4.23,2.76-4.73,8.13-1.61
		c0.69-1.84,0.57-3.78,0.16-5.53c-0.47-1.99-0.87-3.25,1.38-4.72c1.72-1.13,0.48-3.89,0.74-5.91c0.34,0.03,0.68,0.05,1.01,0.08
		c0.63,5.2,0.08,10.26-0.63,15.47c-1.1,8.13-3.16,16.19-3.18,24.43c-0.01,3.44-1.74,6.37-1.96,9.68c-0.02,0.61-0.04,1.22-0.05,1.83
		c-0.19,0.12-0.38,0.24-0.57,0.36c-0.46-0.07-0.85-0.26-1.21-0.55c-3.61-3.08-7.08-6.32-10.31-9.8
		C421.31,317.15,419.52,316.21,420.14,314.05z"
        />
        <path
          class="st125"
          d="M319.48,302.55c-1.38-0.01-2.33-0.64-2.87-1.91c5.72-3.52,11.87-6.1,18.17-8.34c0.79,0.96,0.49,2,0.23,3.03
		c-0.53,4.29,0.11,8.61-0.38,12.9c-3.46,7.02-2.97,14.81-4.11,22.26c-0.56,3.68-0.67,6.95-4.77,8.39c-1.06,0.37-2,1.22-2.33,2.3
		c-1.59,5.25-5.42,5.56-9.87,4.64c-2.11-4.42-1.16-9.05-0.81-13.61c0.15-1.94,1.63-3.16,3.42-3.6c3.06-0.76,4.03-2.7,3.89-5.64
		c-0.19-3.86-0.05-7.61,2.87-10.76c1.28-1.39,0.95-3.37-0.25-4.88C321.47,305.8,320.57,304.11,319.48,302.55z"
        />
        <path
          class="st114"
          d="M246.53,482.81c-1.15-3.1-1.97-6.26-1.82-9.61c0.42-1.71,1.31-3.17,3.25-2.46c3.32,1.22,3.4-0.83,3.49-3.06
		c0.06-1.43-0.2-2.84-0.23-4.27c-0.06-2.83,0.79-5.02,3.88-5.66c1.9-0.4,3.11-1.46,3.48-3.42c0.38-2.01,0.78-3.69,3.06-4.88
		c2.14-1.11,0.47-4.19,1.49-6.17c0.22-0.43,0.54-0.75,0.98-0.97c3.01,1.69,1.4,5.36,3.26,7.54c0.2,0.47,0.33,0.95,0.43,1.44
		c0.05,5.36,0.59,10.69,1.31,16c-1.21,3.13-2.56,6.15-5.7,7.92c-1.73,0.98-2.04,2.7-2.07,4.52c-0.02,1.43-0.03,2.85-0.15,4.28
		c-0.27,3.19-2.77,4.51-5.09,5.8c-2.32,1.29-3.24-0.96-4.63-2.16C249.72,486.12,247.39,485.24,246.53,482.81z"
        />
        <path
          class="st58"
          d="M436.78,276.56c-9.37,0-18.74,0-28.84,0c2.38,1.75,4.42,0.55,6.16,1.27c0.72,0.43-0.07,0.76-0.07,1.12
		c0.08,6.45-1.2,12.31-6.42,16.8c-2.42,2.09-1.36,4.54,0.05,6.8c-0.55,0.56-1.2,0.6-1.9,0.38c-8.26-6.9-15.34-15.04-23.28-22.29
		c-0.18-0.45-0.11-0.86,0.21-1.23C400.6,275.99,418.57,274,436.78,276.56z"
        />
        <path
          class="st126"
          d="M246.53,482.81c1.87,2.49,5.65,2.65,7,5.83c0.34,0.79,1.7,1.06,1.98,0.41c0.95-2.23,4.63-1.85,4.53-4.95
		c-0.05-1.59,0.05-3.18-0.01-4.77c-0.09-2.5-0.06-4.78,3.17-5.44c3.42-0.69,2.42-5.32,5.47-6.44c0.86,0.18,1.45,0.71,1.87,1.46
		c3.11,6.12,1.98,13.11,3.94,19.49c0.32,1.03-0.05,2.21-0.97,3.04c0.61,5.34,2.31,10.55,1.89,16.01
		c-9.81-5.96-18.62-13.22-27.04-20.98C247.27,485.46,246.31,484.44,246.53,482.81z"
        />
        <path
          class="st127"
          d="M512.19,249.77c-2.57-2.12-5.42-3.71-8.64-4.6c-4.43-1.4-7.97-4.39-11.9-6.7c0.4-0.22,1.09-0.37,1.17-0.67
		c0.91-3.54,3.7-4.92,6.75-6.02c0.18-0.14,0.35-0.28,0.53-0.43c4.42,1.16,8.04,3.56,10.99,7.03c11.5,8.59,22.9,17.28,32.57,27.99
		c2.13,2.36,4.39,4.62,5.87,7.48c0.39,0.9,0,1.05-0.79,0.83C537.1,265.58,525.45,256.5,512.19,249.77z"
        />
        <path
          class="st128"
          d="M280.9,324.46c1.6,0.16,1.85,0.99,1.05,2.24c-5.24,8.24-9.67,16.96-14.94,25.2
		c-2.6,4.06-4.78,8.56-6.68,13.01c-1.35,3.16-4.03,5.35-5.08,8.56c-0.38,0.26-0.79,0.34-1.24,0.23c-3.07-2.15-4.15-5.5-5.32-8.8
		c0.21-2.94,1.41-5.44,3.05-7.89C259.96,344.81,269.48,333.79,280.9,324.46z"
        />
        <path
          class="st129"
          d="M461.38,312.18c0.52-1.23,1.41-2.12,2.58-2.71c0.72-0.37,2.25-0.26,1.09-1.7c-0.71-0.88-1.64-1.72-2.71-0.33
		c-0.9,1.18-2.07,2.65-3.35,1.06c-1.22-1.51,1.15-2.24,1.57-3.35c2.14-5.68,7.24-9.1,10.92-13.39c1.98-2.31,4.39-2.8,2.21-6.1
		c0.68-0.38,1.35-0.77,2.03-1.15c7.26,1.99,14.26,4.68,21.08,7.83c-10.47,5.99-20.94,12-31.44,17.95c-0.86,0.49-1.64,0.95-2.09,1.84
		C462.65,312.64,462.02,312.73,461.38,312.18z"
        />
        <path
          class="st21"
          d="M245.69,415.68c0.12-13.8-0.51-27.62,0.76-41.4c0.99,0.65,1.22,1.67,1.37,2.73
		c0.13,5.32,0.22,10.65-0.27,16.36c1.32-6.51,2.51-12.57,6.05-17.86c0.46-0.33,0.96-0.41,1.51-0.26c1.34,0.77,2.1,2.06,2.11,3.48
		c0.03,4.92,1.98,9.51,2.3,14.37c-1.01,12.37-2.22,24.73-3.44,37.07c-0.2,0.47-0.54,0.84-0.99,1.08c-2.45-0.55-1.72-2.65-1.98-4.23
		c-0.28-1.63,0.4-3.3-0.05-4.97c-0.32,0.65,0.12,1.58-0.7,2.03c-0.75,0.42-1.47-0.09-1.44-0.63
		C251.09,419.55,247.24,418.39,245.69,415.68z"
        />
        <path
          class="st84"
          d="M383.71,256.53c0.48,1.29,3.23,0.66,2.55,2.8c-0.51,1.6-2.19,0.83-3.34,1.15c-1.66,0.46-3.33,0.84-5.03,1.26
		c0.93,0.95,2.12,0.37,3.15,0.62c-12.17,2.53-24.29,5.24-35.97,9.59c-4.28,1.59-8.56,3.22-12.84,4.83
		c-0.98,0.23-2.86,0.66-2.01-0.93c1.35-2.51,0.64-5.26,1.73-7.68c11.41-4.91,23.19-8.61,35.46-10.67
		C372.96,259.14,378.31,257.45,383.71,256.53z"
        />
        <path
          class="st70"
          d="M457.71,226.73c-1.66,1.23-3.15,0.19-4.81-0.13c-2.47-0.47-5.25,0.1-7.04,1.68
		c-1.99,1.76,0.91,3.55,1.06,5.45c-16.3-6.49-33.57-8.4-50.75-10.79c-0.56-0.53-1.61-0.82-0.96-1.94
		C416.45,218.5,437.26,220.61,457.71,226.73z"
        />
        <path
          class="st11"
          d="M254.29,431c0.28,0.01,0.55,0.01,0.83,0.02c1.94,1.72,1.39,4.06,1.36,6.16c-0.06,3.31,0.38,5.72,4.64,4.47
		c0.89-0.26,1.87,0,2.62,0.69c0.04,2.07,0.2,4.15,0.09,6.22c-0.08,1.42,0.88,4.06-2.51,2.62c-1.66-0.7-1.2,0.92-1.26,1.67
		c-0.26,3.34-0.59,6.34-5.25,6.15c-2.3-0.1-2.26,2.09-2.49,3.9c-0.26,2.07,1.19,3.94,0.35,6.09c-0.84,2.17,0.49,7.14-4.46,2.76
		c-1.59-1.4-2.41,0.72-3.49,1.45c-1.93-4.6-0.96-9.42-0.85-14.12c0.2-8.72,0.73-17.42,1.12-26.14c0.57-0.16,1,0.02,1.28,0.54
		c1.43,4.83,0.46,9.78,0.71,14.67c0.12,2.38-0.05,4.77,0.06,7.15c0.06,1.21-0.23,3.03,1.34,3.14c1.66,0.12,1.45-1.74,1.66-2.93
		c0.97-5.59,1.89-11.14,1.23-16.92C250.95,435.92,250.7,432.48,254.29,431z"
        />
        <path
          class="st130"
          d="M254.29,431c-3.24,4.59-1.84,9.82-1.44,14.65c0.4,4.77-2.48,8.79-1.93,13.51c0.17,1.47-2.04,1.69-3.52,1.48
		c-2.07-0.3-1.73-1.98-1.73-3.35c-0.04-8.12-0.03-16.23-0.04-24.35c-0.74-3.64-0.63-7.29-0.07-10.94c-0.46-2.11-0.18-4.21,0.13-6.31
		c2.47,1.7,2.47,1.7,4.14-0.56c1.11,2.72,1.68,5.43,1.7,8.42c1.58-1.18,0.16-2.96,1.33-4.06C254.65,423.18,254.28,427.11,254.29,431
		z"
        />
        <path
          class="st131"
          d="M334.8,535.71c6.3-2.72,11.54-7.14,17.28-10.75c8.47-5.72,16.43-12.24,25.97-16.24
		c0.72,0.04,1.38,0.26,1.92,0.76c-2.68,3.94-4.59,8.53-9.09,10.55c-0.08,0.7,0.06,0.97,0.42,1.04c1.75,0.35,4.37-0.31,4.26,2.55
		c-0.1,2.63-2.59,2.63-4.4,2.48c-6.38-0.51-12.28,0.62-17.64,4.24c-1.05,0.71-2.26,1.23-3.77,0.5c1.64,2.34,3.04,4.35,5.91,4.63
		c1.38,0.14,2.84,0.58,1.74,2.81c-0.87,1.78,1.09,1.31,1.93,1.68c1.77,0.6,4.07,0.51,4.22,3.22c-6.36-1.37-12.72-2.74-19.08-4.11
		C341.25,537.95,338.02,536.83,334.8,535.71z"
        />
        <path
          class="st62"
          d="M331.96,268.15c0.22,2.68,2.15,5.51-0.98,7.9c-0.48,0.37,0.79,0.49,1.25,0.71
		c-9.35,4.77-18.7,9.53-28.05,14.3c-3.45,0.23-3.59-3.52-5.79-4.8C308.62,278.45,319.91,272.6,331.96,268.15z"
        />
        <path
          class="st69"
          d="M298.39,286.26c3.92-0.8,3.47,3.67,5.79,4.8c-12.11,7.75-24.1,15.68-35.73,24.31
		C276.63,303.82,286.42,293.93,298.39,286.26z"
        />
        <path
          class="st122"
          d="M434.57,326.5c0.88-7.32,1.79-14.63,2.64-21.96c1.07-9.2,3.02-18.31,3.12-27.63
		c3.39-0.01,6.71,0.4,9.92,1.54c-0.79,0.04-1.59,0.1-2.38,0.11c-7.13,0.11-7.13,0.11-6.24,7.66c1.07-1.27,0.43-2.7,0.55-4
		c0.12-1.38,0.32-2.57,2.04-2.63c1.88-0.06,3.7-0.33,5.23,1.44c1.6,1.85-0.83,1.95-0.93,2.85c-0.32,2.87-1.47,5.21-3.55,7.15
		c-0.56,0.52-0.98,1.32-1.62,1.57c-4.79,1.86-5.78,9.03-1.29,13.01c-4.73,1.09-5.05,4.48-4.66,8.27
		C437.86,318.4,436.95,322.62,434.57,326.5z"
        />
        <path
          class="st120"
          d="M334.81,294.87c-0.01-0.86-0.01-1.72-0.02-2.58c0.33-0.09,0.66-0.17,0.99-0.26c0,11.17,0,22.35,0,33.52
		c0.52,10.23,2.05,20.41,1.47,30.69c-0.36,11.16,0.38,22.33,0.01,33.49c-0.07,2.16,0.67,4.93-2.57,5.78
		c-1.56-1.75-1.2-3.91-1.2-5.95c-0.04-24.92-0.24-49.84,0.13-74.75C333.71,308.2,333.99,301.5,334.81,294.87z"
        />
        <path
          class="st132"
          d="M540.14,316.58c-8.24-6.52-17.54-11.32-26.65-16.43c-1.22-0.69-2.36-1.51-3.54-2.28
		c2.22-0.49,4.01,0.7,5.8,1.63c9.33,4.83,18.13,10.56,26.9,16.32c0.96,0.63,2.1,1.49,2.22,2.93c-0.17,0.15-0.33,0.31-0.5,0.47
		C542.22,319.54,540.91,318.49,540.14,316.58z"
        />
        <path
          class="st132"
          d="M562.08,330.12c-0.1,1.49,2.33,1.72,1.72,3.46c-0.88,0.57-2,0.67-2.67,0.07c-3.94-3.5-8.87-5.89-11.78-10.53
		c0.13-0.2,0.25-0.39,0.38-0.59c2.95-0.5,1.29-2.84,1.74-4.34C555.7,321.56,558.9,325.83,562.08,330.12z"
        />
        <path
          class="st49"
          d="M246.74,377.35c-0.09-1.03-0.19-2.05-0.28-3.07c0.23-3.25,0.7-6.43,2.24-9.37c2.86,2.22,3.2,6.09,5.61,8.6
		c0.53,0.64,0.57,1.27-0.03,1.88l-0.01,0.02C251.67,375.7,250.03,379.73,246.74,377.35z"
        />
        <path
          class="st132"
          d="M533.39,302.27c3.11,1.94,6.17,3.95,8.36,7c-1.61-0.01-2.42,1.19-3.56,3.11c-0.56-3.2-1.49-5.48-3.67-6.72
		C532.96,304.76,532.47,303.83,533.39,302.27z"
        />
        <path
          class="st71"
          d="M333.96,228.04c0.65-2.53,3.14-3.36,4.7-5.06c2.7-0.21,5.23-2.11,8.08-0.8
		C342.65,224.52,338.36,226.39,333.96,228.04z"
        />
        <path
          class="st122"
          d="M467.46,282.29c-5.96,0.54-11.26-1.78-16.64-3.79C456.52,279.06,462.11,280.13,467.46,282.29z"
        />
        <path
          class="st132"
          d="M544.79,312.04c2.41,0.97,4.03,2.81,5.42,4.91C545.95,318.02,544.47,316.02,544.79,312.04z"
        />
        <path
          class="st83"
          d="M253.32,308.15c-0.32-2.29-2.15-5.47,2.76-4.67C255.6,305.3,255,307.04,253.32,308.15z"
        />
        <path
          class="st84"
          d="M388.51,261.31c3.86-2.02,7.98-0.54,11.97-0.87C396.52,261.24,392.52,261.37,388.51,261.31z"
        />
        <path
          class="st21"
          d="M245.56,421.99c0.02,3.65,0.05,7.3,0.07,10.94c-0.21,0-0.43,0-0.64,0
		C244.93,429.27,244.44,425.59,245.56,421.99z"
        />
        <path
          class="st127"
          d="M494.89,228.97c0.27-0.08,0.54-0.14,0.82-0.17c1.48,0.74,4.15-0.21,3.98,2.83c0,0-0.13,0.15-0.13,0.15
		c-1.53-0.22-3.11-0.28-4.58-0.7C493.34,230.6,494.73,229.7,494.89,228.97z"
        />
        <path
          class="st125"
          d="M392.39,222.81c-1.53,0.35-2.99,0.1-5.03-0.47c1.81-1.51,3.42-1.31,5.02-1.15
		C392.89,221.72,392.9,222.26,392.39,222.81z"
        />
        <path
          class="st133"
          d="M295.59,576.58c-2.89,0.45-3.59-1.96-4.82-3.68l-0.08,0.06c2.52,0.06,4.08,1.36,4.8,3.74
		C295.5,576.7,295.59,576.58,295.59,576.58z"
        />
        <path
          class="st132"
          d="M544.87,318.75c2.12,0.62,4.3,1.17,4.86,3.78c0,0-0.16,0.15-0.16,0.15c-2.85,0.42-4.48-0.82-4.97-3.63
		L544.87,318.75z"
        />
        <path
          class="st125"
          d="M314.69,301.59c0.98,0.52,1.92,1.07,2.31,2.55c-1.63-0.16-3.04-0.41-4.21-1.49
		C313.43,302.29,314.06,301.94,314.69,301.59z"
        />
        <path
          class="st134"
          d="M382.7,279.41c0.02,0.36,0.04,0.72,0.06,1.07c0.55,0.64,0.56,1.28,0,1.92c-1.27-1.8-3.13-2.1-5.14-2.03
		C379.19,279.45,380.94,279.38,382.7,279.41z"
        />
        <path
          class="st67"
          d="M392.39,222.81c0-0.54-0.01-1.08-0.01-1.62c0.94-0.06,1.88-0.12,2.83-0.18c0.32,0.65,0.64,1.3,0.96,1.94
		C394.91,222.9,393.65,222.85,392.39,222.81z"
        />
        <path
          class="st135"
          d="M290.78,572.9c-1.18-0.25-1.82-1.04-2.23-2.22c1.95-0.32,2.24,0.8,2.15,2.28
		C290.7,572.96,290.78,572.9,290.78,572.9z"
        />
        <path
          class="st83"
          d="M165.13,409.92c0.96-0.32,1.92-0.64,2.87-0.96c0.11,0.11,0.21,0.25,0.34,0.34c2.06,1.52,5.31-0.67,6.68,1.42
		c1.67,2.56,0.58,5.89,0.62,8.88c0.11,7.34,0.61,14.73-0.15,21.99c-0.56,5.37,3.16,7.41,5.82,10.38c0.64,0.72,2.13,0.89,1.96,2.22
		c-0.42,3.28,2.67,5.82,2.71,8.12c0.11,6.48,6.64,10.81,4.43,18.28c-1.7,5.72-0.33,12.34-0.35,18.56c-0.01,2.65,0.47,5.31-2.41,7.23
		c-1.8,1.2-0.42,2.63,0.67,3.95c2.76,3.34,2.58,8.1-0.55,10.59c-5.87,4.66-9.22,10.33-8.27,18.07c0.09,0.75-0.1,1.54-0.61,2.41
		c-2.43-3.85,0.07-9.03-3.2-12.61c5.53,0.5,4.71-5.02,4.99-7.08c1.42-10.39,8.05-19.51,6.72-30.63c-0.57-4.8-0.78-9.31-4.05-13.11
		c-3.84-9.73-4.28-21.17-14.45-27.71c-2-1.29-3.17-3.86-4.73-5.85c-1.47-4.77-1.64-9.09,0.66-14.07c2.16-4.66,3.19-10.3,0.41-15.6
		C164.46,413.27,163.67,411.57,165.13,409.92z"
        />
        <path
          class="st136"
          d="M164.16,454.02c0.37,0.91,1.01,1.55,1.92,1.92c1.12,1.5,2.27,2.98,2.87,4.79c3.1,4.39,4.52,9.56,6.72,14.37
		c2.83,8.79,3.5,17.74,1.91,26.85c0,0.64,0,1.28-0.01,1.92c-1.04,2.52-0.57,5.61-2.87,7.66c-4.74,8.98-10.99,16.85-20.21,21.19
		c-5.98,2.82-12.96,2.14-19.63,1.53c-7.48-0.68-13.42-4.22-18.65-9.29c-8.72-7.15-14.26-16.46-18.22-26.84l0,0
		c-3.81-10.44-4.89-20.97-0.96-31.64l0,0c0.99-1.71,1.89-3.47,3.38-4.87c1.43-1.35,2.59-1.52,3.7,0.27c0.42,1.38-0.22,2.35-1.2,3.2
		c-4.16,3.57-3.73,8.58-3.93,13.25c-0.72,16.69,6.24,30.3,17.5,42.02c7.97,8.3,17.73,10.8,29.16,9.96
		c15.28-1.12,28.81-19.14,28.92-33.26c0.1-14.27-3.24-27.08-11.75-38.56c-1.57-2.12-3.57-4.16-3.69-7.1
		C162.3,449.42,162.65,452.84,164.16,454.02z"
        />
        <path
          class="st102"
          d="M164.16,454.02c-1.77-0.68-2.56-2.98-4.8-2.87c-0.42,0.32-0.88,0.38-1.37,0.19
		c-2.97-1.62-4.73-4.62-7.49-6.5c-5.44-3.72-11.33-3.29-17.33-2.07c-1.3-0.04-2.58-0.12-3.51-1.21c2.1-1.28,4.07-2.85,6.32-3.78
		c2.81-1.17,2.45-2.8,1.36-4.85c-0.24-0.91,0.31-1.31,1.03-1.6c1.13-0.26,2.3-0.1,3.13,0.6c2.99,2.51,6.51,2.72,10.14,2.6
		c2.33,2.16,2.62,5.32,3.92,7.98c0.46,3.18,3.45,4.38,5.16,6.59C161.93,450.69,164.08,451.63,164.16,454.02z"
        />
        <path
          class="st78"
          d="M155.54,442.52c-3.36-1.52-2.86-4.96-3.84-7.67c0.53-1.49,0.76-3.13,1.98-4.31
		c4.91-2.62,6.96-8.92,4.63-14.49c-0.6-1.44-1.57-2.73-1.65-4.37c0.04-0.81,0.29-1.51,0.99-2c3.42,0.49,4.92,3.24,5.38,5.93
		c0.88,5.12,1.48,10.43-1.54,15.25c-1.81,3.67-3.06,7.49-3.08,11.65c0,0.32,0,0.64,0,0.96C157.45,443.16,156.5,442.84,155.54,442.52
		z"
        />
        <path
          class="st2"
          d="M98.02,498.12c0.32,0.34,0.79,0.62,0.95,1.02c3.78,9.93,10.5,17.89,17.27,25.82
		c-8.04-4.36-12.43-11.73-15.92-19.7C99.33,503.02,97.76,500.82,98.02,498.12z"
        />
        <path
          class="st2"
          d="M97.06,466.48c-1.49,8.87-3.29,17.71,0.6,26.5c0.65,1.48,0.26,3.41,0.35,5.14c-0.32,0-0.64,0-0.96,0
		c-1.55-1.61-0.62-4.05-1.91-5.75c-0.32-1.92-1.3-3.72-0.96-5.75c0.33-5.7-0.76-11.46,0.88-17.12
		C95.44,468.2,95.75,467.07,97.06,466.48z"
        />
        <path
          class="st102"
          d="M177.59,501.96c0.44-9.03-0.48-17.96-1.91-26.85c3.13,0.86,1.64,3.73,2.12,5.54
		C179.67,487.69,180.27,494.88,177.59,501.96z"
        />
        <path
          class="st102"
          d="M174.72,511.54c0.77-2.63,1.23-5.37,2.87-7.67C177.18,506.64,178.86,510.18,174.72,511.54z"
        />
        <path
          class="st105"
          d="M95.14,492.37c1.86,1.51,2,3.6,1.91,5.75C93.59,497.14,95.79,494.28,95.14,492.37z"
        />
        <path
          class="st102"
          d="M168.96,460.73c-1.25-1.42-2.66-2.74-2.87-4.79C168.05,456.94,169.19,458.42,168.96,460.73z"
        />
        <path
          class="st105"
          d="M138.29,431.97c-0.32,0.32-0.64,0.64-0.96,0.97c-1.6-0.64-3.19-1.28-4.79-1.92
		c-12.43-6.92-23.63-15.73-35.72-23.17c-9.87-6.08-14.44-16.92-12.14-28.23c0.25-1.24,0.73-2.45,1.83-3.25
		c5.21-7.61,13.1-10.95,21.09-14.96c8.44-4.23,17.45-7.24,25.58-12.06c1.03-0.61,2.05-0.79,3.18-0.79c0.65-0.56,1.34-0.51,2.05-0.15
		c0.27,0.43,0.37,0.9,0.3,1.4c-4.91,3.43-10.29,6.05-15.79,8.27c-4.58,1.85-9,3.89-13.16,6.51c-6.29,2.64-12.5,5.2-17.2,10.66
		c-4.93,5.74-5.64,15.35-0.87,21.31c9.51,9.33,20.19,16.99,32.16,22.88c2.98,1.47,5.05,4.28,8.01,5.85
		c1.85,1.54,4.04,2.61,5.82,4.25C138.25,430.26,138.83,430.98,138.29,431.97z"
        />
        <path
          class="st2"
          d="M129.65,441.56c1.28,0,2.56,0,3.83,0c0.05,2.5-2.37,2.1-3.62,3.07c-1.79,1.38-4.57,1.81-4.51,4.89
		c0.06,0.43,0.01,0.85-0.12,1.27c-0.6,1.07-1.69,1.29-2.74,1.59c-3.94,3.83-8.59,6.53-13.62,8.62c-0.39,0.13-0.79,0.19-1.2,0.2
		c-1.13-0.12-2.25-0.23-3.29,0.43c-0.18,0.05-0.36,0.1-0.54,0.14c-4.38-1.47-4.06,3.82-6.79,4.72c0.54-6.64,6.26-8.65,10.87-10.18
		c7.31-2.42,12.45-7.24,17.51-12.37C126.74,442.62,127.66,441.35,129.65,441.56z"
        />
        <path
          class="st68"
          d="M165.13,409.92c0.03,4.16,3.28,7.34,3.1,11.81c-0.12,3.09-3.41,6.03-0.65,9.24
		c-6.99,3.01-1.33,9.22-3.41,13.46c-2.15,0.2-2.54-1.94-3.83-2.88c-2.1-2.47-0.96-4.93,0.03-7.39c0.58-1.92,1.36-3.77,2.08-5.64
		c1.04-5.42,1.98-10.82-1.35-15.89c-0.47-0.72-0.19-1.51,0.41-2.13C162.61,409.72,163.78,409.27,165.13,409.92L165.13,409.92z"
        />
        <path
          class="st101"
          d="M161.29,433.89c-0.77,2.5-1.19,5.04-0.96,7.67c-0.41,0.77-1.13,0.94-1.92,0.96
		c-2.73-4.4,0.21-7.85,1.92-11.5c0.16,0.11,0.31,0.21,0.47,0.32C161.2,432.14,161.92,432.89,161.29,433.89z"
        />
        <path
          class="st112"
          d="M179.51,265.16c1.05-6.42-0.48-12.6-2.72-18.42c-1.32-3.43-0.55-7.74-3.99-10.34
		c-2.17-9.46-4.56-18.89-5.66-28.55c-0.44-3.87,1.43-7.74,0.87-11.72c0.77-0.55,1.53-0.62,2.26,0.06c1.52,2.5,0.92,5.27,0.93,7.93
		c0.03,7.8,0.7,15.26,3.87,22.72c2.09,4.93,2.23,10.8,4.46,15.93c1.01,5.74,1.41,11.61,3.46,17.15c0.56,1.53,0.69,3.08,0.1,4.64
		c-0.84,1.33-1.61,2.79-3.58,2.51C179.51,266.44,179.51,265.8,179.51,265.16z"
        />
        <path
          class="st59"
          d="M179.51,267.07c1-0.58,1.39-2.07,2.88-1.92c0.13,0.18,0.27,0.36,0.4,0.55c0.09,2.82-2.17,4.29-3.57,6.26
		c-0.35,0.29-0.74,0.5-1.17,0.67c-2.09,0.51-4.47,0.24-6,2.26c-5.09,3.83-6.46,10.08-9.81,15.05c-1.94,2.88-3.27,6.2-5.31,9.06
		c-3.5,4.91-8.97,6.17-14.33,3.34c-2.53-1.34-5.11-2.62-7.52-4.18c-1.15-0.74-2.75-1.36-1.6-3.27c0,0,0.01-0.01,0.01-0.01
		c1.28,0,2.55,0.01,3.83,0.01c7.63,6.65,14.06,8.31,20.99-3.97c1.97-3.48,3.63-7.3,5.46-10.87c2.41-4.7,6.8-8.23,11.6-10.73
		C176.76,268.59,178.12,267.81,179.51,267.07z"
        />
        <path
          class="st104"
          d="M695.29,383.08c-0.64,1.66-4.11,0.1-3.55,2.84c0.53,2.56,2.92,1.92,4.73,1.94
		c6.96,0.05,13.91,0.02,20.87,0.02c-0.51,2.71-2.76,2.13-4.48,2.21c-3.8,0.17-7.61,0.04-11.42,0.06
		c-6.95,0.03-14.04-0.96-20.44,2.91c-2.97-1-0.58-5.15-3.6-6.14c-1.44-2.82-3.08-5.34-5.83-7.24c-2.6-1.79-3.32-4.86-3.45-7.97
		c0.37-5.99-1.02-12.08,1.04-17.96c0.32-0.76,0.8-1.39,1.47-1.87c2.08-0.27,3.22-3.49,5.91-1.92c0.37,1.16,0.16,2.33-0.6,3.15
		c-5.3,5.73-3.26,12.44-2.63,18.96c2.56,9.51,7.93,10.31,15.67,10.29C691.14,382.35,693.35,381.28,695.29,383.08z"
        />
        <path
          class="st2"
          d="M679.95,392.66c2.47-1.14,5.73-1.02,6.7-4.5c0.29-1.04,1.27-0.4,2.03-0.25c9.12,1.9,18.34,0.6,27.51,0.73
		c0.38,0.01,0.76-0.5,1.15-0.77c0.96,0,1.92,0,2.88,0c1.7,3.88-1.26,3.96-3.58,4.07c-5.55,0.26-11.11,0.08-16.66,0.1
		c-4.93,0.01-9.84,0.42-14.47,2.16c-9.47,3.57-12.52,11.69-7.87,20.6c0.44,0.84,0.86,1.7,1.49,2.42c1.3,1.73,2.92,3.04,5.07,3.59
		c3.4,1.75,6.66,3.99,10.82,3.16c2.14,0.4,4.97-1.04,6.03,2.25l-0.01,0.01c-3.02,2.2-6.58,1.63-9.74,1.15
		c-7.77-1.18-14.76-4.09-18.79-11.57c-0.96-4.56-0.89-9.21-0.24-13.74c0.59-4.08,3.41-7.05,6.89-9.26
		C679.42,392.75,679.68,392.71,679.95,392.66z"
        />
        <path
          class="st137"
          d="M678.99,418.55c-4.66-4.33-6.1-9.94-4.33-15.65c2.11-6.81,7.71-10.08,14.67-11.22
		c8.86-1.44,17.78-0.77,26.68-0.94c2.04-0.04,4.44,0.47,4.21-2.87c0.32-0.32,0.64-0.64,0.96-0.96c0.6-0.61,1.33-0.75,2.15-0.61
		c0.54,0.16,0.92,0.5,1.17,1c0.39,3.05-1.53,4.39-3.95,5.38c-7.76,2.11-15.69,1.06-23.55,1.31c-2.35,0.07-4.76-0.25-6.96,0.9
		c-0.42,0.2-0.87,0.35-1.32,0.47c-1.26,0.49-2.86-0.06-3.87,1.22c-0.03,0.74,0.37,1.52-0.21,2.2c-0.52,0.38-1.11,0.59-1.72,0.72
		c-0.42,0.11-0.84,0.19-1.26,0.27c-2.46,0.62-3.14,2.53-3.31,4.71c-0.21,2.71,0.08,5.43,0.04,8.13c-0.03,1.99,1.3,0.72,1.84,1.18
		c0.62,0.8,0.7,1.71,0.57,2.67C680.55,417.46,680.05,418.24,678.99,418.55z"
        />
        <path
          class="st79"
          d="M703.92,372.53c-1.92,1.92-3.83,3.84-5.75,5.75c-3.8,3.88-13.1,5.9-17.69,3.82
		c-0.92-0.42-1.51-1.15-1.77-2.13c0.29-1.77,1-3.2,2.93-3.67c3.05,2.49,6.5,2.76,10.16,1.76c2.32-0.24,3.74-1.95,5.4-3.27
		c0.46-0.45,0.96-0.87,1.47-1.27c1.73-1.29,3.25-2.79,4.43-4.62c1.56-1.91,2.87-4.15,5.62-4.61c0.47,0.06,0.88,0.25,1.23,0.56
		C709.81,368.89,706.25,370.23,703.92,372.53z"
        />
        <path
          class="st2"
          d="M678.99,379.24c1.83,3.84,5.38,3.34,8.34,2.64c3.67-0.87,7.5-1.56,10.83-3.59c-0.67,1.77-0.21,4.22-2.88,4.79
		c-4.05-0.39-7.96,1.07-12.19,0.17c-5.46-1.16-9.79-4.75-10.82-10.72c0.36-0.31,0.77-0.38,1.22-0.22
		C675.32,374.63,678.25,376.07,678.99,379.24z"
        />
        <path
          class="st2"
          d="M723.09,386.91c-0.64,0-1.28,0-1.91,0c-0.32,0-0.64,0-0.97,0c0-1.6,0-3.19,0-4.79
		c3.58-1.11,2.72-4.13,2.87-6.71c1.96-2.33,1.85-5.96,4.8-7.67c0.79,0.02,1.5,0.19,1.92,0.96
		C728.02,374.94,725.64,380.95,723.09,386.91z"
        />
        <path
          class="st2"
          d="M703.92,372.53c1.36-2.98,5.23-4.06,5.76-7.66c0.9-2.11,1.88-4.1,4.79-2.89c0,0.32,0,0.64,0,0.96
		C710.46,365.6,709.02,371.09,703.92,372.53z"
        />
        <path
          class="st138"
          d="M690.5,218.18c0.32,0,0.64,0,0.96-0.01c7.78,9.54,15.53,18.99,16.41,32.18c0.4,6.05-3.64,9.08-6.82,12.88
		c-13.25-2.69-22.5,4.73-31.63,12.47c-1.28-1.97-0.17-3.59,1.23-4.54c5.06-3.45,8.82-8.78,15.05-10.57
		c2.02-0.63,4.11-0.47,6.18-0.49c9.08-0.08,14.09-6,12.22-14.94c-1.33-6.35-4.8-11.77-8.62-16.93
		C693.21,225.17,691.01,222.1,690.5,218.18z"
        />
        <path
          class="st36"
          d="M685.7,261.33c-5.04,2.47-8.69,6.81-13.31,9.84c-1.69,1.11-2.86,2.46-2.99,4.55c-0.35,3.51-2.89,7.02,0,10.54
		c0.32,0.64,0.64,1.28,0.96,1.92c-0.84,0.95-1.95,1.15-3.14,1.15c-4.59-0.58-3.8-4.08-3.87-7.12c0.44-12.22,10.09-16.57,18.67-21.86
		C683.38,260.18,684.69,260.2,685.7,261.33z"
        />
        <path
          class="st93"
          d="M708.71,297.75c6.77,1.4,13.72,1.55,20.24,4.67c6.38,3.05,10,7.97,12.56,14.07
		c1.64,3.89-0.31,13.34-3.07,15.78c-0.48,0.33-0.89,0.25-1.22-0.22c0.01-3.8,1.32-7.48,0.96-11.35c-0.25-2.68-0.86-5-3.08-6.68
		c-0.55-0.47-0.99-1.03-1.32-1.68c-1.47-4.85-5.47-7.18-9.76-8.23c-4.48-1.1-8.87-2.45-13.3-3.72
		C709.69,299.79,708.39,299.38,708.71,297.75z"
        />
        <path
          class="st98"
          d="M708.71,297.75c0.64,0.64,1.28,1.28,1.92,1.92c-1.56,1.45-3.29,0.73-4.87,0.2
		c-4.21-1.42-8.51-1.96-12.92-1.84c-2.97-0.49-5.89-1.21-8.72-2.26c-2.15-1.59-4.7-1.64-7.21-1.86c-0.45-0.07-0.9-0.18-1.34-0.3
		c-3.89-1.26-8.24-0.2-11.95-2.36c-0.31-3.02,2.7-1.9,3.86-3.08c0.96,0,1.93,0,2.89-0.01c3.54,2.59,7.99,1.46,11.8,2.88
		C690.77,294.26,700.17,294.31,708.71,297.75z"
        />
        <path
          class="st137"
          d="M737.47,332.27c0.32,0,0.64,0,0.97,0c-0.16,4.74-3.68,7.53-6.43,10.64c-5.71,6.48-11.69,12.72-17.55,19.07
		c-2.22-0.08-3.03,2.2-4.79,2.89c-0.32,0-0.64,0-0.97-0.01c-0.51-2.55,1.61-3.61,2.97-4.99c7.35-7.47,15.02-14.64,21.35-23.05
		c0.58-0.77,1.04-1.59,1.41-2.47c0.17-0.41,0.4-0.79,0.66-1.15C735.75,332.53,736.53,332.19,737.47,332.27z"
        />
        <path
          class="st47"
          d="M418.1,94.88c-0.6,0.34-0.97,0.81-0.84,1.54c-0.39,2.29-1.77,3.97-3.38,5.51
		c-5.34,6.56-11.48,12.43-16.49,19.27c-7.27,6.12-10.7,13.45-7.79,23.09c0.62,2.05,0.19,4.43,0.9,6.58
		c-0.1,4.25,1.89,8.46,0.27,12.74c-4.81,2.23-10.06,1.77-15.12,2.44c-0.54,0.04-1.07-0.03-1.57-0.21c-2.86-1.89-1.77-5.21-2.83-7.75
		c-0.48-2.4,0.04-4.89-0.66-7.28c-0.15-0.46-0.25-0.93-0.33-1.41c-0.31-3.04-0.2-6.12-0.97-9.11c-0.23-1.68,0.03-3.4-0.37-5.07
		c-0.17-0.34-0.33-0.69-0.52-1.03c-0.45-0.62-1.03-1.1-1.69-1.48c-0.87-0.49-1.79-0.9-2.53-1.58c-0.8-0.91-1.62-1.81-2.65-2.48
		c-1.12-0.85-2.09-1.9-3.42-2.45c-0.78-0.35-1.47-0.81-2.07-1.43c-1.88-1.83-3.95-3.41-6.29-4.62c-4.12-3.16-8.14-6.45-12.51-9.29
		c-1.12-0.74-2.14-1.61-3.21-2.42c-1.14-1.21-3.48-1.9-1.91-4.31c0.29,0.18,0.55,0.15,0.78-0.1c0.34-0.36,0.75-0.64,1.21-0.83
		c2.13-0.47,4.29-0.83,6.44-1.23c2.14-0.23,4.33,0.12,6.42-0.59c0.47-0.14,0.94-0.23,1.43-0.3c2.81-0.4,5.27,0.47,7.52,2.09
		c5.52,3.86,10.93,7.88,16.59,11.54c2.92,3.01,5.51,2.64,7.82-0.74c4.22-5.26,9.5-9.6,13.21-15.31c1.54-1.99,3.91-2.24,6.08-2.93
		c0.45-0.15,0.9-0.26,1.37-0.35c2.34-0.36,4.76-0.04,7.05-0.88c2.46-0.49,4.97-0.33,7.45-0.53
		C416.35,94.26,417.56,93.53,418.1,94.88z"
        />
        <path
          class="st67"
          d="M333.86,103.99c-0.33,0.02-0.65,0.05-0.98,0.07c-1.46-2.9,0.08-3.4,2.39-5.36c7.22-6.09,14.7-2.52,22.11-2.32
		c3.53,0.09,5.44,3.17,8.11,4.84c5.5,4.59,14.57,3.56,18.79-1.74c1.89-2.38,3.65-5.26,7.1-5.93c-1.09,5.58-4.79,9.22-9.19,12.34
		c-5.57,1.55-11.04,0.62-16.5-0.62c-0.98-0.19-1.87-0.57-2.59-1.28c-4.87-5.99-11.33-6.24-18.11-4.77
		C341.02,100.08,337.22,101.57,333.86,103.99z"
        />
        <path
          class="st67"
          d="M332.1,104.16c-0.75,2.43,2.12,2.33,2.69,3.84c1.12,5.29,4.49,8.89,8.42,12.39c3.11,2.77,7.59,4.74,7.86,9.88
		c-2.03,1.22-3.7,0.48-5.06-1.1c-3.49-4.05-7.88-6.86-12.54-9.34c-2.1-1.12-4.21-2.37-4.41-5.18c0.5-2.84-0.45-5.32-1.92-7.67
		C328.59,105.66,329.62,103.64,332.1,104.16z"
        />
        <path
          class="st67"
          d="M374.49,165.31l0.18,0.02c1.49,0.26,3.88-2.12,4.23,1.47c0.03,0.26,0.41,0.31,0.74,0.41
		c4.95,1.49,12.89-4.61,13.82-9.51c1.21-6.31,1.34-12.49,1.13-18.85c-0.17-4.85,1.8-9.32,5.29-12.92c3.57-3.69,5.97-8.58,11.06-10.7
		c0.19,0.12,0.39,0.25,0.58,0.38c-0.91,1.48-1.06,3.11-0.95,4.79c-0.32,0.64-0.65,1.28-0.97,1.91c-8.26,7.43-12.42,16.28-10.6,27.71
		c1.44,9.05-0.72,16.79-10.01,20.91c-6.55,3.72-9.11,2.77-15.59-0.92c-8.46-4.81-10.71-12.21-11.9-20.86
		c-0.56-4.03-0.38-8.87-5.41-10.86c-1.62-1.52-3.29-2.99-4.62-4.79c-0.53-1.32-0.28-2.55,0.44-3.72c1.09-0.9,2.35-0.97,3.67-0.77
		c5.67,2.18,7.7,7.39,9.84,12.32c1.71,3.94,2.78,8.14,3.55,12.41C369.74,158.06,372.62,161.46,374.49,165.31z"
        />
        <path
          class="st64"
          d="M413.41,101.17c1.28-1.58,2.57-3.16,3.85-4.75c3.56,4.23,3.59,8.26,0.43,12.78
		c-1.74,2.49-3.69,4.69-6.18,6.41c0,0-0.01-0.01-0.01-0.01c-1.68-2.05-1.23-4.2-0.31-6.37C412.14,106.6,413.93,104.21,413.41,101.17
		z"
        />
        <path
          class="st64"
          d="M418.1,94.88c-0.75-0.09-1.5-0.18-2.24-0.27c-1.78,0.52-3.54,0.54-5.34,0.02c0.31-2.17,2.21-1.07,2.91-2.03
		c0.41-0.77,1.13-0.94,1.92-0.97C416.99,92.09,416.62,94.27,418.1,94.88z"
        />
        <path
          class="st60"
          d="M413.43,92.59c-0.62,0.45-1.24,0.9-2.43,1.76c1.93,0.1,3.39,0.17,4.86,0.25c-2.49,0.95-5.09,1.09-7.72,0.99
		c-2.42,0.56-4.78,0.4-7.53,0.07c1.25-2.47,3.25-0.93,4.08-1.71c-1.02,0.35-2.44-0.11-3.78,0.27c-1.48,0.42-1.31,1.26-0.83,2.3
		l0.03-0.02c-2.66,0.45-5.72-0.07-7.34,2.97c-1.51,1.42-2.76,3.1-4.24,4.52c-10.37,9.95-18.98,10.34-29.97-0.64
		c-0.15-0.51-0.07-0.97,0.24-1.4c1.91-0.89,3.33,0.21,4.78,1.18c0.41,0.77,1.13,0.94,1.92,0.96c5.64,2.42,11.34,3.66,17.25,0.95
		c2.88-3.83,5.76-7.66,8.63-11.5c5.39-0.32,10.47-3.24,16.07-1.94C409.42,92.06,411.44,92.27,413.43,92.59z"
        />
        <path
          class="st70"
          d="M352.06,129.99c0.01,1.27,0.01,2.55,0.02,3.82c-1.04,1.09-2.3,1.05-3.62,0.74c-2.93-1.57-5.71-3.44-9.23-3.64
		c-1.72-0.1-2.59-1.54-3.49-2.95c-2.71-4.22-6.1-4.03-8.26,0.28c-1.07,2.14-2.2,4.25-3.19,6.43c-2.75,6.06-0.89,11.07,5.54,12.58
		c7.06,1.66,12.36,6.42,18.7,9.27c0.88,0.39,1.48,1.19,1.96,2.04c3.44,6.09,0.26,17.54-5.95,21.46c-0.88-0.59-1.05-1.49-1.05-2.45
		c-0.4-1.84,3.9-3.79-0.14-5.55c-2.18-1.75-0.14-2.95,0.56-4.33c0.18-0.12,0.36-0.23,0.54-0.34c2.42-0.4,2.4-2.68,1.55-3.62
		c-3.09-3.41-5.29-8.01-10.6-8.85c-2.66-0.42-5.11-1.37-6.61-3.9c-0.7-1.17-1.97-1.51-3.24-1.8c-5.94-1.36-8.7-6.65-6.17-12.22
		c2.33-5.11,3.8-10.47,4.77-15.93c0.57-3.21,1.91-5.3,4.9-6.4c4.71,5.5,12.53,6.86,16.96,12.71c1.33,1.75,2.69,3.11,5.09,2.63
		C351.43,129.69,351.75,129.68,352.06,129.99z"
        />
        <path
          class="st86"
          d="M318.56,109.78c3.9,0.47,2.75,3.34,2.73,5.7c-0.04,5.18,0.59,10.37-1.57,15.42
		c-0.99,2.31-2.85,4.15-3.14,6.87c-0.83,7.86,1.51,12.32,9.33,15.18c7.36,2.69,13.29,7.08,18.19,13.04c0.27,0.33,0.26,0.9,0.38,1.37
		c0,0-0.09,0.07-0.09,0.07c-0.38,0.31-0.8,0.55-1.27,0.71c-1.29,0.26-2.39-0.16-3.39-0.95c-4.22-7.07-11.26-9.77-18.5-12.54
		c-8.5-3.25-11.5-12.22-7.32-20.33c3.24-6.29,4.33-12.87,2.89-19.83c-0.41-1.87,0.24-3.36,1.65-4.57L318.56,109.78z"
        />
        <path
          d="M340.53,166.51c0.69,0.79,1.61,0.98,2.59,0.98c1.58,1.13,0.32,1.65-0.45,2.39c-2.68,2.62-6.34,3.32-9.5,4.99
		c-4.74,1.3-8.88,5.62-14.44,2.95c-3.75-1.59-7.47-3.26-11.26-4.76c-0.8-0.32-1.56-0.71-2.31-1.11c-1.41-0.83-2.91-1.44-4.49-1.86
		c-0.4-0.11-0.78-0.25-1.17-0.39c-2.24-1.08-3.32,0.08-3.98,2.06c-0.56,1.2-0.89,2.48-1.36,3.71c-2.1,4.65-3.68,9.49-5.51,14.25
		c-1.08,3.41-3.49,5.49-6.68,6.84c-4.77,2.03-9.48,4.21-14.33,6.05c-1.51,0.3-2.98,0.44-4.01-1.08c-0.25-2.02,0.96-3.67,1.37-5.53
		c1.44-3.95,3.36-7.7,4.74-11.68c2.21-5.64,4.28-11.34,6.5-16.97c3.07-5.57,3.04-5.67-2.35-7.92c-6.16-2.64-12.32-5.25-18.61-7.57
		c-3.77-1.73-7.67-3.15-11.55-4.6c-0.94-0.38-1.38-1.24-1.9-2.01c-3.14-1.28-2.88-2.59-0.04-3.92c5.46-3.98,11.69-6.24,18.12-8.06
		c5.78,1.31,10.89,4.4,16.44,6.31c1.14,0.51,2.3,0.96,3.45,1.43c6.64,2.72,6.64,2.72,8.63-4.01c1.85-4.85,4.58-9.34,5.98-14.38
		c1.12-4.2,3.73-6.82,7.95-8.06c5.1-1.5,9.43-5.37,15.18-4.92c0.28,0.16,0.58,0.25,0.9,0.28c-0.35,1.46-0.69,2.92-1.04,4.39
		c-0.02,3.64-1.89,6.74-2.96,10.08c-2.71,6.23-5.08,12.59-7.44,18.95c-0.23,0.59-0.51,1.16-0.75,1.75
		c-2.27,5.56-2.27,5.56,3.39,7.85c7.13,3.01,14.27,6.01,21.51,8.75C334.57,162.73,337.34,165.04,340.53,166.51z"
        />
        <path
          class="st82"
          d="M317.55,109.64c-4.69,1.96-9.28,4.27-14.11,5.79c-4.2,1.32-6.76,3.76-8.03,7.81
		c-3.46,1.32-4.53,4.75-6.41,7.42c-4.18,5.92-12.32,8.26-18.66,4.86c-3.06-1.64-6.97-1.29-9.44-4.18c-0.23-0.47-0.2-0.93,0.09-1.36
		c4.34-0.29,8.51,0.21,12.57,2.03c4.07,1.82,7.57,1.26,10.36-2.82c2.78-4.05,6.01-7.79,9.13-11.6c4.54-5.56,10.2-8.92,17.62-8.76
		c0.69,0.02,1.39-0.58,2.09-0.9C314.54,108,316.78,106.77,317.55,109.64z"
        />
        <path
          class="st82"
          d="M265.99,196.2c-0.24,1.79-0.7,3.48-2.1,4.75c-2.83-0.67-4.99-1.92-4.59-5.36c0.03-0.46,0.12-0.9,0.23-1.35
		c-0.18-4.46,2.94-7.67,4.34-11.53c0.98-4.19,3.61-7.86,2.97-12.59c-0.79-5.84-3.63-9.35-8.72-9.47c-0.88-1.85-2.44-2.71-4.38-3.19
		c-5.03-1.23-8.02-5.4-11.86-8.35c-1.66-1.28,0.24-2.58-0.05-3.86c0.63,0.37,1.26,0.73,1.89,1.1c2.58,3.02,6.61,3.67,9.7,5.87
		c0.41,0.25,0.79,0.53,1.15,0.83c1.63,1.56,3.37,2.82,5.61,3.51c9.66,3.01,13.02,8.64,11.14,18.48c-0.21,1.1-0.4,2.2-0.58,3.29
		c-0.07,0.46-0.19,0.9-0.34,1.34C268.37,185.03,265.2,190.08,265.99,196.2z"
        />
        <path
          class="st61"
          d="M261,129.98c0,0.32,0,0.64,0,0.96c-0.27,2.79-0.27,2.79-1.22,2.99c-5.93,2.62-11.7,5.62-17.97,7.41
		c-0.79-4.94,2.77-6.52,6.19-8.59C252.11,130.26,256.21,128.79,261,129.98z"
        />
        <path
          class="st97"
          d="M513.14,180.8c-11.73,5.78-22.41-0.06-23.97-12.65c-0.83-6.67,1.7-12.82,3.11-19.13
		c0.96-4.31,1.48-8.68,3.18-12.89c1.89-4.7-2.47-6.74-5.39-8.94c-2.14-1.6-4.83-2.43-7.2-3.76c-5.72-3.2-8.31-9.38-6.98-16.41
		c1.35-7.16,4.48-10.35,11.37-11.56c0.07,0.22,0.13,0.43,0.2,0.65c-0.23,1.21-1.17,1.82-2.08,2.48c-9.16,6.66-8.23,18.63,1.84,23.9
		c2.11,1.11,4.35,1.96,6.37,3.26c3.65,2.7,5.31,6.32,5,10.84c-0.59,2.35-0.76,4.82-1.85,7.05c-1.46,2.84-1.59,5.92-1.63,9.01
		c-0.14,1.43-0.61,2.76-1.22,4.05c-0.37,0.82-0.78,1.62-1.1,2.46c-0.77,1.86-0.38,3.89-0.85,5.79c-0.59,2.98,0.73,5.37,2.35,7.67
		c0.23,0.36,0.42,0.74,0.59,1.12c0.36,1.25,1.29,2.06,2.24,2.86c0.93,1.17,2,2.11,3.54,2.39c0.45,0.1,0.87,0.22,1.3,0.36
		c3.53,0.66,7.21-0.54,10.66,0.9C512.81,180.44,512.97,180.62,513.14,180.8z"
        />
        <path
          class="st97"
          d="M563.95,124.23c0.32,0,0.64,0,0.96,0c0,0,0,0,0,0c0.74,3.52,0.73,7.03,0,10.55
		c-1.24,6.16-6.09,8.49-11.31,9.36c-4.13,0.69-8.54,0.71-12.8-0.3c-4.12-0.98-9.2,2.05-10.38,6.11c-2.52,8.66-5.67,17.04-9.94,25.04
		c-1.72,3.23-3.62,5.46-7.34,5.8c0,0-0.01-0.01-0.01-0.01c-0.5-1.07,0.09-1.88,0.65-2.7c5.06-3.96,6.35-10.12,8.61-15.57
		c2.15-5.19,4.82-10.32,5.43-16.08c2.41-4.56,6.13-6.6,11.32-6.35c3.81,0.18,7.64,0.03,11.46,0.1c3.16,0.06,5.91-1.06,8.57-2.58
		c2.68-1.44,3.41-3.84,3.52-6.68C562.78,128.66,562.06,126.19,563.95,124.23z"
        />
        <path
          class="st74"
          d="M511.22,98.34c-0.96,0-1.92,0-2.88,0c-0.13,0.09-0.27,0.26-0.39,0.26c-6.99-0.43-13.9-1.44-20.7-3.13
		c0,0,0-0.01,0-0.01c2.66-2.93,6.31-2.33,9.33-1.73C501.57,94.72,506.81,95.34,511.22,98.34z"
        />
        <path
          class="st103"
          d="M564.91,134.78c0-3.52,0-7.03,0-10.55C566.46,127.74,566.46,131.26,564.91,134.78z"
        />
        <path
          class="st82"
          d="M494.92,183.67c4.4,4.52,10.3,3.91,15.77,4.35c4.74,0.38,12.64-6.7,14.63-12.75
		c0.58-1.77,0.73-3.45,3.15-3.12c0.97,5.93-2.18,9.48-6.02,13.76c-4.94,5.51-10.34,5.72-16.54,5.43c-2.7-0.12-5.41-0.02-8.12-0.02
		c-3.34-0.43-7.24-4.33-7.67-7.67C491.72,183.67,493.32,183.67,494.92,183.67z"
        />
        <path
          class="st82"
          d="M485.33,183.67c0-2.24,0-4.47,0-6.71c2.26,1.76,4.97,3.21,4.8,6.71
		C488.53,183.67,486.93,183.67,485.33,183.67z"
        />
        <path
          class="st102"
          d="M487.25,95.47c7.27-0.81,14.19,0.99,21.09,2.87c2.5,2.77,6.08,2.95,9.35,3.81
		c8.03,2.13,15.83,4.88,23.26,8.64c-0.34,0.38-0.76,0.62-1.26,0.73c-1.97,0.12-3.87-0.56-5.84-0.57
		c-6.02-0.97-11.49-3.61-17.22-5.48c-7.94-2.58-15.68-6.24-24.38-5.93c-2.32,0.08-4.4,0.42-6.23,1.85
		c-4.59,2.59-5.46,4.58-3.88,9.58c0.61,1.93,0.19,4.2,1.84,5.79c1.47,2.22,3.9,3.26,5.9,4.82c0.94,1.58,3.62,1.98,3.12,4.55
		c-4.84-1.92-9.76-3.46-12.91-8.29c-4.01-6.15-2.06-16.32,4.32-20C485.51,97.23,486.74,96.79,487.25,95.47z"
        />
        <path
          class="st36"
          d="M539.98,110.81c0.32,0,0.65,0,0.97-0.01c10.32-0.07,17.82,4.7,23,13.43c-0.27,3.53,0.64,7.14-0.57,10.61
		c-0.58,1.66-1.63,2.99-3.26,3.77c-1.67-3.61,0.76-6.77,1.49-9.99c0.53-2.37-1.64-1.08-1.6-2.11c-0.23-0.39-0.35-0.8-0.37-1.24
		c-1.08-7.22-7.16-8.4-12.55-10.41C544.49,113.9,540.95,114.6,539.98,110.81z"
        />
        <path
          class="st63"
          d="M547.65,172.17c-1.73,3.64-3.78,7.11-4.79,11.11c-2.3,9.1,1.49,15.47,8.61,20.53
		c2.31,1.7,4.86,2.09,7.68,1.68c4.83-0.71,9.77-0.58,14.38-2.73c2.46-1.15,4.57-0.41,5.61,2.55c1.83,5.21,2.7,10.71,4.82,15.83
		c2.14,7.71,8.13,11.71,14.89,14.42c6.99,2.8,11.73,6.83,13.7,14.55c0.96,3.75,3.54,7.45,6.49,10.43c3.49,3.53,5.82,7.97,9.24,11.56
		c1.1,1.15,1.75,2.66,1.6,4.37c-0.1,0.47-0.3,0.88-0.6,1.25c-3.57-0.92-5.28-4.2-7.89-6.33c-1.19-0.97-2.17-2.26-3.47-3.18
		c-4.62-6.59-10.36-12.45-12.7-20.49c-0.79-2.71-2.99-4.56-5.47-5.79c-3.86-1.91-7.3-4.61-11.43-6.01c-2.2-0.74-3.86-2.13-4.59-4.52
		c-1.07-3.52-4.61-5.6-5.34-9.49c-0.46-2.48-1.29-4.88-1.39-7.47c-0.18-4.73-2.53-6.66-7.2-5.66c-3.79,0.81-7.56,1.2-11.41,1.07
		c-10.2-0.32-19.84-7.69-19.97-20.16c-0.08-7.16,2.21-12.26,7.1-16.78C546.13,172.36,546.75,171.85,547.65,172.17L547.65,172.17z"
        />
        <path
          class="st2"
          d="M582.16,212.43c0-1.91,0.03-3.82-0.01-5.73c-0.08-4.48-3.49-7.4-7.79-6.12c-5.19,1.55-10.51,2.12-15.79,2.98
		c-4.36,0.71-9.35-2.79-11.88-8.38c0.21-0.08,0.41-0.15,0.62-0.23c2.47,0.45,4.08,2.35,6.08,3.59c1.48,0.92,3.03,1.78,4.9,1.43
		c1.07-0.31,2.09-0.77,3.19-1.01c0.7-0.17,1.41-0.28,2.13-0.34c1.15-0.11,2.12-0.68,3.1-1.21c12.22-6.66,19.16-0.09,20.47,11.56
		c0.43,3.8,0.73,7.6,1.66,11.31c0.27,1.08,0.72,2.07,1.62,2.81c0.32,0.31,0.59,0.65,0.82,1.03c2.03,5.12,6.9,5.78,11.31,7.18
		c0.75,0.69,1.22,1.48,0.82,2.55c-2.17,2.55-4.48,1.43-6.92,0.41c-6.78-2.85-11.01-7.92-13.29-14.78
		C582.21,217.21,581.42,214.93,582.16,212.43z"
        />
        <path
          class="st117"
          d="M554.36,169.29c2.2-4.95,6.64-7.95,11.06-9.96c5.83-2.66,9.11-5.69,9.98-12.56
		c1.35-10.64,8.57-14.4,19.18-11.55c3.93,1.06,7.06,3.56,10.6,5.31c1.24,1,2.67,1.77,3.83,2.88c0.57,0.63,0.58,1.31,0.21,2.03
		c-0.59,0.51-1.29,0.68-2.06,0.62c-1.26-0.21-2.13-1.02-2.9-1.96c-4.5-4.24-9.43-7.19-15.96-5.27c-1.26,0.46-2.62,0.21-3.9,0.54
		c-5.71,2.01-5.69,6.93-5.76,11.64c-0.06,4.49-0.64,8.52-5.46,10.44c-1.76,0.49-3.55,0.72-5.37,0.62c-3.78,0.61-6.08,3.54-8.87,5.69
		c-1.43,1.1-2.4,2.98-4.64,2.67C553.98,170.02,553.98,169.64,554.36,169.29z"
        />
        <path
          class="st113"
          d="M609.01,145.32c0-0.64,0-1.28,0-1.92c1.31-0.05,2.55,0.09,3.51,1.13c5.32,5.76,12.28,9.52,18.03,14.81
		c9.25,8.51,12.62,23.8,7.23,34.87c0.08,1.64-0.17,3.11-1.92,3.83c-0.92-0.52-1.38-1.34-1.54-2.36c0.93-3.47,2.99-6.46,3.27-10.28
		c1-13.83-6.58-22.52-17.02-29.66c-2.59-2.48-5.59-4.41-8.53-6.42C610.66,148.38,609.32,147.17,609.01,145.32z"
        />
        <path
          class="st105"
          d="M582.16,212.43c0.64,2.24,1.27,4.48,1.91,6.71c-0.27,0.97,1.86,2.75-0.95,2.87
		c-3.1-4.67-2.13-10.44-4.21-15.46c-1.44-3.5-2.87-4.08-6.41-2.85c-5.78,1.99-11.82,3.18-18.04,2.18c-1.32-0.21-2.43-0.75-2.99-2.07
		c6.44,2.16,12.92,0.91,19.1-0.65c7.66-1.93,9.11-1.5,10.57,6.27C581.35,210.49,581.06,211.68,582.16,212.43z"
        />
        <path
          class="st2"
          d="M554.36,169.29c0,0.32,0.01,0.64,0.01,0.96c1.35,1.9,0.05,3.38-0.95,4.72c-1.82,2.44-3.21,5.14-4.89,7.65
		c-1.05,2.74-0.42,5.59-0.53,8.4c-0.06,1.51,0.57,3.22-1.3,4.15c0,0-0.01,0-0.01,0c-3.81-7.96-0.5-14.74,3.65-21.31
		C551.41,172.17,553,170.81,554.36,169.29z"
        />
        <path
          class="st113"
          d="M609,143.4c-1.94-0.08-2.99-1.34-3.83-2.88C606.92,140.86,608.72,141.13,609,143.4z"
        />
        <path
          class="st136"
          d="M630.09,221.04c0.32-0.63,0.65-1.27,0.97-1.9c1.21-0.89,2.22-0.36,3.19,0.44c0.65,0.72,1.07,1.54,0.93,2.55
		c-1.37,4.51-4.6,7.43-8.43,9.83c-5.03,1.23-9.37,3.32-11.11,8.73c-0.17,1.41-0.58,2.71-1.82,3.57c-2.7-0.49-2.72-2.6-2.73-4.65
		c-0.01-2.79,0.37-5.52-2.5-7.53c-1.74-1.22-0.6-3.12,0.11-4.69c2.33-3.29,2.05-7.47,3.77-10.98c0.73-1.49,0.97-3.44,3.36-3.12
		c1.01,2.05-0.1,4.04-0.3,6.03c-0.56,5.65,0.49,6.92,6.05,6.58c0.63-0.04,1.27-0.04,1.9-0.05c1.41-0.2,2.87-0.09,4.26-0.48
		c0.31-0.24,0.6-0.5,0.86-0.8C629.21,223.44,629.03,221.97,630.09,221.04z"
        />
        <path
          class="st113"
          d="M624.35,226.81c-10.31,0.68-11.41-0.69-8.91-11.06c0.18-0.77,0.19-1.57,0.27-2.36
		c0.05-3.57,2.73-5.61,5.32-6.44c5.2-1.67,8.43-5.3,11.58-9.27c0.6-0.75,1.27-1.41,2.29-1.55c0.77,0.42,0.93,1.13,0.95,1.92
		c-0.09,2.39-2.17,3.37-3.48,4.9c-1.24,1.45-3.22,2.17-3.05,4.83c0.12,1.85-1.74,2.62-3.77,2.77c-6.53,0.49-10.55,4.97-9.61,11.04
		c0.6,3.92,4.13,3.86,6.78,3.04c2.23-0.69,4.74-1.58,6.42-3.58c0.72,1.6,0.71,3.19,0,4.79v0
		C627.7,226.97,625.77,225.63,624.35,226.81z"
        />
        <path
          class="st136"
          d="M633.94,220.1c-0.96-0.32-1.92-0.64-2.87-0.96c0.32-0.32,0.63-0.64,0.95-0.96c1-1.56,2.28-2.83,3.84-3.83
		c0,0,0-0.01,0-0.01c3.83-0.69,6.47-3.75,10.03-5.04c1.75-0.63,3.3-1.87,5.31-1.68c0.44-0.3,0.85-0.25,1.25,0.08
		c0.82,1.58,0.34,2.89-1.17,3.57c-2.01,0.91-2.93,2.86-4.45,4.22c-0.58,0.4-1.22,0.62-1.91,0.71c-1.17,0.22-2.93-0.94-3.18,1.39
		c-0.51,0.76-1.24,1.19-2.09,1.45C637.68,219.1,635.94,220.36,633.94,220.1z"
        />
        <path
          class="st113"
          d="M635.85,214.35c-0.92,1.64-2.19,2.92-3.84,3.83C632.29,215.9,633.57,214.62,635.85,214.35z"
        />
        <path
          class="st136"
          d="M629.14,225.85c0-1.6,0-3.19,0-4.79c0.32,0,0.63-0.01,0.95-0.02C629.87,222.67,630.74,224.5,629.14,225.85z"
        />
        <path
          class="st106"
          d="M652.14,207.63c-0.32,0-0.64,0-0.96,0c-0.74-4.18,4.44-5.06,4.8-8.62c2.41-1.36,5.12-1.9,7.67-2.88
		c4.41,0.22,7.85,2.76,11.5,4.79c2.58,1.89,4.82,4.13,6.71,6.71c2.88,3.52,5.75,7.03,8.63,10.55c4.27,7.3,9.75,13.85,13.27,21.63
		c3.45,7.64,2.6,14.25-3.2,19.89c-1.34,1.3-3.38,1.63-5.34,1.62c-3.17-0.02-6.35,0-9.52,0c-1.28,0-2.56,0-3.83,0
		c0.44-2.75,2.72-1.98,4.35-2.13c4.33-0.39,8.77-0.21,12.5-3.01c1.04-1.9,3.95-2.68,3.32-5.58c-0.13-0.64-0.19-1.29-0.22-1.94
		c0.27-3.32-0.74-6.23-2.54-9.01c-7.83-12.17-16.42-23.76-26.25-34.4c-1.6-1.73-3.6-2.57-5.74-3.25c-1.01-0.39-2.02-0.81-3.08-1.05
		c-3.26-0.57-5.64,1.02-7.81,3.15C655.09,205.39,653.77,206.71,652.14,207.63z"
        />
        <path
          class="st138"
          d="M681.87,207.64c-2.62-1.85-4.86-4.09-6.71-6.71C678.51,202.05,680.74,204.28,681.87,207.64z"
        />
        <path
          class="st138"
          d="M663.65,196.13c-2.15,2.05-4.86,2.58-7.67,2.88C658.04,196.72,660.58,195.71,663.65,196.13z"
        />
        <path
          class="st60"
          d="M547.65,172.16c-11,6.94-9.56,22.62-4.21,29.4c5.8,7.34,14.37,7.96,23.08,6.64c1.4-0.21,2.76-0.73,4.15-1.04
		c4.36-0.96,7.63,1.6,7.65,6.02c0.03,5.58,0.88,10.83,5.41,14.75c0.88,0.76,1.39,1.77,1.29,2.96c-0.17,2.01,1.11,3.03,2.69,3.43
		c3.6,0.92,6.41,3.31,9.67,4.83c5.14,2.39,8.73,5.52,10.44,11.45c1.09,3.8,3.01,7.89,7.12,10.45c1.92,1.2,2.48,4.58,3.66,6.98
		c-0.64,0.51-1.28,0.58-1.92,0c-0.96,0-1.92,0-2.87,0c-4.37-5.27-7.82-11.22-12.04-16.58c-4.69-5.97-11.33-9.47-17.95-12.85
		c-1.11-0.56-2.69-0.52-3.2-1.81c-1.94-4.86-5.45-8.98-7.34-13.67c-2.27-5.66-5.54-8.18-11.34-8.04c-0.64,0.02-1.29-0.12-1.91,0.04
		c-6.62,1.65-12.07,0.06-16.53-5.34c-2-2.42-4.13-4.88-6.97-6.48c-0.55-0.31-1.07-0.91-1.04-1.53c0.27-6.03-3.14-12.2,0.67-18.1
		c3.02-1.67,2.81-5.36,4.79-7.67c2.79-1.68,4.6-4.35,6.71-6.71C547.65,170.25,547.65,171.2,547.65,172.16z"
        />
        <path
          class="st62"
          d="M355.91,137.65c3.68-0.43,5.1,1.87,5.7,4.91c0.74,3.74,1.15,7.55,1.96,11.27c1.29,5.89,2.99,11.34,9.42,14.14
		c3.1,1.35,4.93,4.97,9.34,4.37c2.33-0.32,3.95-1.92,6.16-2.09c3.03-0.51,4.93-4.38,8.62-2.87c-0.25,0.96-1.52,1.92,0,2.87
		c0.11,0.3,0.22,0.59,0.33,0.89c-3.31,1.16-5.09,5.03-9.2,4.91c-5.35-0.16-10.7-0.04-16.05-0.04c-4.23-3.05-8.32-6.22-11.24-10.7
		c-1.62-2.48-2.45-5-2.59-7.97c-0.2-4.26-0.82-8.48-2.45-12.52C355,142.52,353.85,140.02,355.91,137.65z"
        />
        <path
          class="st85"
          d="M397.13,167.37c-3.21-0.05-5.23,3.48-8.62,2.87c0.39-0.49,0.67-1.24,1.18-1.45
		c8.55-3.51,9.18-10.68,8.22-18.32c-0.63-5.03-0.53-9.41,1.26-14.57c1.58-4.53,3.75-7.99,6.46-11.59c1.11-1.48,2.24-2.12,3.96-2.02
		c0,0.64,0,1.28,0,1.92c-0.78,3.28-4.06,4.79-5.48,6.94c-2.43,3.68-4.53,8.48-3.87,13.72C401.21,152.6,401.19,160.3,397.13,167.37z"
        />
        <path
          class="st105"
          d="M138.28,349.52c0-0.32,0-0.64,0-0.96c0.48-0.42-0.19,0.04,0.31-0.37c6.34-5.25,6.32-5.95-0.31-11.14
		c-3.7-2.83-7.89-5.01-12.2-6.32c-5.5-1.67-9.99-5.42-15.75-6.59c-2.44-0.49-4.38-3.46-6.55-5.3c-1.87-2.57-3.07-5.37-2.88-8.63
		c1.44-0.41,1.97,0.83,2.79,1.54c6.36,8.93,16.63,11.97,25.58,17.01c5.61,3.59,12.14,5.51,17.36,9.85c3.83,3.18,3.97,4.98-0.15,7.96
		C144.05,348.33,142.11,351.59,138.28,349.52z"
        />
        <path
          class="st73"
          d="M138.29,337.06c3.91-0.04,6.12,2.71,6.34,5.77c0.26,3.62-3.16,4.95-6.34,5.73c-0.64,0-1.28,0-1.92,0
		C141.22,345.43,140.7,341.4,138.29,337.06z"
        />
        <path
          class="st97"
          d="M102.82,312.13c-0.64-0.64-1.29-1.28-1.93-1.91c0,0,0,0,0,0c-0.73-2.88-0.73-5.75,0-8.63l0,0
		c0.74-1.23,0.88-2.76,1.92-3.84c1.37-4.53,5.78-5.64,9.22-6.37c4.25-0.9,9.15-1.52,13.25,1.73c2.38,1.89,5.3,1.94,8.2,1.77
		c3.56,3.9,8.2,6.26,13.1,7.5c4.33,1.09,7.88-0.84,10.06-5.24c2.9-5.85,6.9-11.11,9.36-17.25c1.07-2.67,3.46-4.48,5.83-6.12
		c1.95-1.66,4.56-0.96,6.71-1.91c0.52-0.51,1.12-0.59,1.79-0.33c0.33,0.32,0.48,0.7,0.47,1.16c-0.19,0.65-0.6,1.15-1.14,1.54
		c-0.36,0.22-0.74,0.4-1.14,0.55c-1.9,0.67-4.04,0.97-5.04,3.12c-4.89,6.45-8.65,13.56-12.69,20.54
		c-4.37,7.56-9.79,11.31-18.86,5.86c-6.05-3.59-12.85-5.55-19.05-8.88c-3.1-1.66-6.82-0.87-10.24-0.03c-0.41,0.2-0.83,0.36-1.26,0.5
		c-5.42,2.35-7.41,5.56-7.21,11.77C104.23,309.33,105.02,311.18,102.82,312.13z"
        />
        <path
          class="st105"
          d="M100.89,301.59c0,2.88,0,5.75,0,8.63C99.36,307.34,99.36,304.46,100.89,301.59z"
        />
        <path
          class="st105"
          d="M102.81,297.75c-0.15,1.52-0.67,2.86-1.92,3.84C100.8,299.95,101.07,298.48,102.81,297.75z"
        />
        <path
          class="st83"
          d="M260.04,195.17c-0.76,3.29,2.63,3.81,3.85,5.77c0.85,1.81,2.41,0.64,3.63,0.86c0.76-0.51,1.14-0.02,1.51,0.55
		c1.72,3.21,4.56,2.4,7.06,1.66c2.54-0.75,5.1-1.59,7.52-2.79c0.88-0.44,2.02-1.26,2.78,0.31c-1.33,4.38-4.81,5.86-8.86,6.33
		c-2.49,0.29-5.04,0.25-7.54,0c-2.89-0.28-5.28,0.37-7.11,2.71c-2.12,3.3-4.2,6.43-5.32,10.43c-1.57,5.63-6.7,8.77-12.08,9.61
		c-5.86,0.92-12,1.19-17.9-1.12c-2.78-1.09-5.74-1.89-8.77-2.19c-6.56-0.65-7.68,0.43-7.22,6.88c0.14,1.91,0.72,3.75,0.73,5.68
		c-0.25,1.94-0.31,4.09-3.29,3.2c-0.49-0.22-0.9-0.55-1.23-0.98c-1.2-4.12-2.85-8.1-3.89-12.27c-1.83-7.33,2.37-11.27,9.69-9.71
		c7.9,1.69,15.24,5.42,23.61,5.54c7.95,0.11,13.02-3.07,15.63-10.47c0.42-1.19,1.36-2.17,1.37-3.52c0.04-0.49,0.11-0.97,0.19-1.45
		c0.45-5.21-3.98-6.46-7.22-7.68c-14.27-5.36-28.68-10.33-43.49-14.11c-5.11-1.31-10.12-2.35-15.43-2.71
		c-6.88-0.46-10.89,3.43-14.9,7.78c-1.02,1.11-1.29,3.05-3.44,2.64c-0.64,0-1.28,0-1.92,0c0-0.32,0-0.64,0-0.96
		c1.75-6.19,6.12-9.01,11.85-11.85c7.45-3.69,13.93-2.08,20.8-0.08c8.86,2.58,17.65,5.42,26.48,8.11c1.35,0.41,2.76,0.63,4.14,0.93
		c4.23,2.15,9.27,1.43,13.42,3.83c1.28,0,2.56,0,3.83,0c3.08,2.17,6.13,4.61,8.91-0.46C257.87,194.9,259.04,194.67,260.04,195.17z"
        />
        <path
          class="st85"
          d="M260.04,195.17c-0.69,0.39-1.55,0.64-2.03,1.21c-3.27,3.91-5.89,3.87-9.48-0.25c7.2,2.32,8.26,1.54,8.63-6.35
		c0.12-2.57,0.15-5.22,3.83-5.16l0,0C262.7,188.33,259.68,191.6,260.04,195.17L260.04,195.17z"
        />
        <path
          class="st85"
          d="M244.7,196.13c-4.6-0.84-9.47-0.73-13.42-3.83C235.81,193.36,241.02,192.06,244.7,196.13z"
        />
        <path
          class="st83"
          d="M260.04,195.17c-0.6-3.6,0.96-7,0.96-10.54c1.49,0.15,1.88-1.34,2.87-1.92
		C263.88,187.26,260.67,190.82,260.04,195.17z"
        />
        <path
          class="st82"
          d="M536.14,183.67c-2.32,5.76,1.23,11.44,0.18,17.26c-0.51,2.82,3.6,1.26,4.37,3.49
		c1.5,4.31,6.32,5.51,8.82,9.22c1.39,2.06,5.99,0.97,9.1,0.38c8.88-1.68,12.37,0.87,15.96,8.8c2.12,4.68,4.96,9.17,7.42,13.78
		c1.03,1.92,5.06,1.35,7.75,3.27c8.06,5.75,15.31,11.77,19.92,20.91c1.18,2.35,3.78,4.2,4.14,7.26c-1.73-0.03-3.59,0.3-4.64-1.65
		c-3.78-7.06-11.17-9.54-17.25-13.73c-4.87-3.35-10.76-5.22-14.62-10.04c-0.85-1.06-2.03-1.5-3.4-1.42
		c-2.84,0.16-5.36-0.4-7.23-2.83c-0.41-0.53-1.4-1.02-2.03-0.93c-4.42,0.62-6.17-1.22-5.57-5.58c0.07-0.52-0.45-1.63-0.67-1.62
		c-3.87,0.12-6.4-3.29-9.4-3.99c-4.23-0.99-6.76-6.06-11.72-4.46c-0.94-5.29-7.16-2.73-9.78-6.68c-1.6-2.41-6.9-0.49-10.53-0.76
		c-1.37-1.6-1.37-3.19,0-4.79c1.65-1.01,3.44-2.16,3.68-4.14c0.47-3.81,2.16-6.12,6.14-6.51c0.51-0.05,1.39-0.65,1.4-1.02
		c0.19-5.87,5.55-9.14,7.14-14.29c0.03-0.1,0.28-0.19,0.41-0.18C535.88,183.43,536.01,183.58,536.14,183.67z"
        />
        <path
          class="st62"
          d="M516.97,209.55c0,1.6,0,3.19,0,4.79c-1.39,7.49-2.74,14.99-4.22,22.46c-0.12,0.61-1.09,1.05-1.67,1.57
		c-3.8-2.25-7.59-4.5-11.39-6.75c-1.33-0.94-2.66-1.89-3.98-2.83c0.78-2.68-2.73-6.61-6.09-6.37c-1.73,0.13-3.19,0.88-3.29-1.72
		c-0.1-2.71,1.8-2.52,3.59-2.54c3.05-0.03,5.69,0.31,8.2-2.95c2-2.59,6.89-1.52,10-1.2c5.31,0.55,5.15-1.98,5.02-5.44
		C514.46,208.73,515.96,208.15,516.97,209.55z"
        />
        <path
          class="st85"
          d="M497.8,202.84c-2.22-0.69-5.31,1.66-6.71-1.92C493.41,201.27,496.23,199.85,497.8,202.84z"
        />
        <path
          class="st107"
          d="M395.23,665.84c2.55,0.32,5.1,0.64,7.65,0.96c3.88,0.94,7.75,1.89,11.63,2.83c-4.47,0.65-9,0.04-13.54,0.74
		C399.33,670.63,397.16,667.45,395.23,665.84z"
        />
        <path
          class="st59"
          d="M470.33,672.71c-1.09,0.31-2.18,0.62-3.27,0.93c-6.87-0.23-13.79,0.42-20.61-0.96
		C454.42,672.69,462.38,672.7,470.33,672.71z"
        />
        <path
          class="st139"
          d="M441.21,757.92c-7.34,0.01-14.69,0.01-22.03,0.02c-0.31-0.01-0.62-0.02-0.94-0.03
		c-0.01-0.3,0-0.59,0.01-0.89c7.65,0.01,15.3,0.01,22.95,0.02C441.22,757.33,441.22,757.62,441.21,757.92z"
        />
        <path
          class="st112"
          d="M616.67,268.04c0.64,0,1.28,0,1.92,0c4.52,2.09,7.2,6.21,10.54,9.59c1.66,1.02,2.98,2.4,4.14,3.95
		c0.26,0.35,0.49,0.72,0.71,1.1c3.08,4.67,7.09,8.54,10.8,12.66c0.63,1.38,1.66,2.39,2.94,3.18c0.33,0.34,0.6,0.72,0.84,1.13
		c1.22,2.75,1.21,5.83,2.47,8.61c0.7,1.55,0.66,3.43-0.81,4.84c-0.96,0.32-1.92,0.64-2.87,0.96c-2.97,0.22-4.56-0.55-3.33-3.99
		c1.52-4.26,0.07-7.16-4.34-8.48c-0.55-4.52-5.66-6.07-6.69-10.42c-0.62-2.59-2.13-4.5-5.67-4.12c-3.26,0.35-4.92-3.35-6.33-5.17
		C618.08,278.12,615.64,273.41,616.67,268.04z"
        />
        <path
          class="st140"
          d="M548.74,274.68c0.26-0.28,0.53-0.55,0.79-0.83c0.8,0.52,1.67,1.64,1.1,2.1
		C549.81,276.61,549.19,275.43,548.74,274.68z"
        />
        <path
          class="st112"
          d="M666.53,398.42c-1.76,1.17-3.88,2.2-1.22,4.6c0.4,0.36,0.74,1.57,0.57,1.7c-5.82,4.53,1.11,9.96-1.04,14.86
		c-0.67,1.53,1.64,2.87,3.02,3.87c5.06,3.65,4.49,10.94-1.36,13.69c-3.26,1.53-7.18,1.93-7.95,6.42c-5.77-0.15-8.45,7.91-15.02,5.66
		c-1.22-0.6-1.53-1.05-0.51-2.45c3.93-5.4,2.93-11.4,1.42-17.26c-2.84-10.97-2.44-21.77,0.89-32.56c0.52-1.69,1.19-2.46,2.9-2.38
		c1.58,0.07,2.56-0.39,3.12-2.18c0.88-2.85,3.48-1.47,5.35-1.56c2.38-0.11,2.03,1.85,2.21,3.42c0.17,1.55-0.83,4,2.01,3.95
		c2.44-0.05,1.82-2.27,1.76-3.7c-0.24-5.85,4.18-3.1,6.75-3.77C671.54,394.47,670.14,396.85,666.53,398.42z"
        />
        <path
          class="st72"
          d="M650.23,313.09c0.37-5.06-2.42-9.49-2.87-14.38c3.13-1.05,3.38,1.48,3.87,3.33c0.52,1.97,0.66,4.04,1.6,5.9
		c2.23,11.85,8.67,15.57,19.65,17.32c5.57,0.89,8.67,4.97,12.11,8.55c1.68,1.74,0.32,3.63-1.12,5.42
		c-3.75,4.68-8.26,8.63-12.15,13.16c-0.32,0.32-0.64,0.64-0.96,0.96c-0.91,1.2-2.04,2.27-2.32,3.85c-2.42,6.2-0.19,12.29,0.4,18.42
		c0.12,1.21,1.07,2.41,0,3.62c-4.07,0.48-5.26-0.7-4.13-5.09c0.93-3.59,0.46-7.6,0.24-11.41c-0.23-3.98,0.49-7.57,3.2-10.55
		c4.13-4.54,5.67-11.03,11.29-14.5c1.7-1.05-0.97-5.65-4.3-5.88c-4.33-0.3-8.15-2.55-12.49-2.45c-3.09,0.07-5.54-1.51-6.85-4.16
		C653.46,321.27,651.93,317.14,650.23,313.09z"
        />
        <path
          class="st63"
          d="M668.45,379.24c-1.96-7.6-4.73-15.17-0.96-23.01c2.27,3.15,1.11,6.77,1.43,10.2c0.19,2.03-0.53,4.14,0.48,6.1
		c0.25,3.27,1.29,5.82,4.66,7.34c2.75,1.24,3.43,4.24,3.97,7.04c1.98,4.14-1.64,6.51-3.37,9.1c-3.99,5.95-4.42,16.92-0.26,23.03
		c1.26,1.85,3.58,3.48,1.72,6.22c-5.73-3.42-8.87-8.41-8.57-15.14c0.18-3.99-0.81-7.8-1.02-11.71c1.91-2.2,3.54-4.5,2.87-7.67
		C672.22,386.47,671.95,383.2,668.45,379.24z"
        />
        <path
          class="st112"
          d="M578.16,489.13c1.68-13.72,2-27.54,2.95-41.32c0.04,3.5-0.08,7.02,0.16,10.51c0.16,2.3-1.82,6.2,3.44,5.53
		c0.88-0.11,1.5,1.14,1.11,1.74c-3.34,5.17,3.66,11.21-3.23,16.56c7.22-1.59,7.22-1.59,7.23-6.69c0.01-6.37-0.02-12.75,0.02-19.12
		c0.01-1.24-0.36-3.47,0.65-3.49c4.02-0.11,6.57-3.75,9.8-4.24c3.77-0.57,5.65-1.92,6.8-5.14c0.37-0.51,0.76-0.53,1.17-0.05
		c0.53-0.39,1.06-0.78,1.59-1.18c0.03,3.1,1.37-0.3,1.98,0.4c1.95,2.24,6.38,2.75,4.94,7.36c-0.29,0.93,0.61,1.51,1.5,2.09
		c3.59,2.33,3.16,6.69-0.75,8.54c-4.32,2.04-4.68,3.38-1.81,6.81c-1.47,2.47-3.34,4.19-6.53,3.86c-1.63-0.17-3.18,0.04-3.91,1.95
		c-2.29,6.03-9.58,5.1-13.26,9.36c-0.64,0.74-2.2,1-2.76,2.24c-1.06,2.34-3.38,2.3-4.91,1.55c-3.8-1.87-4.89-1.42-3.51,2.86
		c0.36,1.12-0.66,2.36-1.83,2.26C577.86,491.41,578.49,489.94,578.16,489.13z"
        />
        <path
          class="st112"
          d="M624.35,454.98c0.37-4.96-0.84-9.99,1.65-14.89c1.01-1.99,0.83-4.98-1.04-7.21
		c-0.74-0.88-0.87-2.09-0.1-3.09c0.54-0.71,1.38-0.69,2.17-0.41c1.13,0.41,1.16,1.44,1.12,2.37c-0.3,6.47,0.89,13.01-0.93,19.4
		C626.26,452.43,625.3,453.7,624.35,454.98z"
        />
        <path
          class="st90"
          d="M544.6,319.05c1.41,1.55,3.03,2.81,4.97,3.63c4.86,3.49,8.48,8.6,14.24,10.91c0,0,0.11,0.13,0.11,0.13
		c1.42,1.78,0.28,4.01,1.06,5.91c0.8,1.35,0.79,2.94,1.31,4.37c0.43,1.5,0.78,3.01,0.09,4.53c-4.57,2.59-7.26,1.35-8.18-3.8
		c-6.76-1.46-6.83-7.56-8.63-12.46c0-1.38-0.64-2.34-1.92-2.88c-0.87-0.77-2.22-0.82-2.88-1.92c-1.34-2.75-1.67-6.37-6.18-6.23
		c-0.82,0.03-3.95-1.5-0.72-3.28c0.79-0.43,1.82-0.4,2.27-1.39C541.63,317.41,543.11,318.23,544.6,319.05z"
        />
        <path
          class="st112"
          d="M581.15,439.24c-0.97-8.12-0.92-16.29-1.06-24.45c0.39-2.1,1.06-4.19,0.24-6.34
		c0.03-2.06-1.28-4.11-0.09-6.18c1.99-0.06-1.84-4,1.92-2.88c0.63,0.9,1.06,2.21,1.91,2.61c2.96,1.4,2.2,3.59,1.26,5.57
		c-0.46,0.97-1.63,1.92-1.24,2.92c1.86,4.82,0.44,8.81-1.82,13.23C579.85,428.46,581.6,434.04,581.15,439.24z"
        />
        <path
          class="st141"
          d="M572.56,367.73c-1.97,0.94-2.13,2.59-1.55,4.36c0.91,2.76,0.68,5.54,0.47,8.34
		c-0.62,0.09-1.09-0.13-1.41-0.67c-1.83-7.05-2.33-14.26-2.63-21.5c0.37-1.3,0.2-3.02,2.3-3.01
		C570.76,359.4,572.58,363.36,572.56,367.73z"
        />
        <path
          class="st142"
          d="M569.74,355.25c-1.21,0.73-0.83,2.05-1.13,3.11c-3.25-2.5-2.73-6-2.47-9.42c0.48-0.77-0.25-2.35,1.51-2.27
		C567.34,349.78,570.09,352.14,569.74,355.25z"
        />
        <path
          class="st55"
          d="M564.78,340.08c-1.48-1.96-0.62-4.24-0.86-6.37c1.93,1.44,2.92,3.07,1.05,5.26
		C565.39,339.43,565.33,339.8,564.78,340.08z"
        />
        <path
          class="st83"
          d="M580.24,402.25c0.32,2.24,0.64,4.47,0.96,6.71c-1.01,0.47-1.38-0.28-1.8-0.95c-0.09-0.85-0.18-1.7-0.27-2.56
		C579.34,404.34,579.07,403.04,580.24,402.25z"
        />
        <path
          class="st0"
          d="M567.65,346.68c-0.34,0.7-0.67,1.4-1.01,2.11l-0.42,0.08l-0.18-0.39c-0.1-1.49-0.21-2.98-0.31-4.48
		c-0.44-0.96,0.03-1.22,0.91-1.17C566.97,344.12,567.31,345.4,567.65,346.68z"
        />
        <path
          class="st16"
          d="M566.63,342.83c-0.3,0.39-0.6,0.78-0.91,1.17c-0.88-1.17-0.85-2.56-0.94-3.92c0.06-0.37,0.13-0.74,0.19-1.1
		C566.42,339.88,566.29,341.45,566.63,342.83z"
        />
        <path
          class="st112"
          d="M582.17,460.59c0-9.23,0-18.46,0-27.69c0-1.59,0.29-3.01,2.36-2.67c1.81,0.3,1.9,2.52,1.35,2.96
		c-4.97,3.96-1.64,9.28-1.86,13.68C583.79,451.43,582.49,455.89,582.17,460.59z"
        />
        <path
          class="st71"
          d="M608.26,443.41c-0.39,0.02-0.78,0.03-1.17,0.05c0.37-2.83-0.8-5.8,0.75-8.53
		C607.98,437.76,608.12,440.59,608.26,443.41z"
        />
        <path
          class="st112"
          d="M585.57,454.79c0.58,1.48,0.7,2.76-0.1,4.22C584.88,457.52,584.77,456.24,585.57,454.79z"
        />
        <path
          class="st105"
          d="M676.12,425.26c-0.18-0.92-0.02-2.2-0.58-2.72c-6.47-6.04-5.31-13.9-5.11-21.43
		c0.12-4.42,4.8-6.41,6.25-10.29c0.48-1.29,1.47-2.39,1.35-3.9c4.48,0.64,2.13,3.55,1.92,5.75c0,0,0,0,0,0
		c-8.38,6.55-8.95,10.13-6.71,23.01c7.08,9.29,16.84,11.48,27.8,10.55c0,0.96,0,1.91,0,2.87c-3.84,0-7.67,0-11.51,0
		C684.43,430.01,680.34,427.41,676.12,425.26z"
        />
        <path
          class="st47"
          d="M690.5,450.08c3.56-2.11,4.17,1.21,5.59,3.03c0.34,1.74,0.89,3.38,2.06,4.75c0.71,0.57,1.39,1.17,1.74,2.04
		c1.44,2.99-0.71,4.28-2.68,5.7c-6.56,4.73-11.84,10.47-14.51,18.29c-0.53,1.21-0.72,2.52-1.03,3.79c-0.8,3.63-1.04,7.3,0.28,10.83
		c0.85,2.29,2.27,3.76,4.35,0.87c1.41-3.31,4.19-5.8,5.38-9.24c4.09-9.24,8.07-18.55,15.84-25.52c5.88-4.13,12.05-5.14,18.77-2.05
		c2.41,1.11,4.42,2.41,5.31,5.02l-0.05-0.06c7.2,6.15,6.4,14.41,5.78,22.53c-0.19,2.5-0.7,5.05-1.64,7.44
		c-2.38,7.15-5.5,13.89-10.18,19.9c-3.33,4.28-7.26,7.57-12.4,9.34c-1.37,0.3-2.75,0.6-4.12,0.9l0.02,0.03
		c-1.03-0.33-0.67-1.38-1.06-2.04c-0.5-1.31-0.85-2.68-1.55-3.92c-0.19-0.37-0.35-0.75-0.48-1.13c-0.43-1.62-1.28-3.09-1.76-4.69
		c-0.43-2.57,1.52-3.57,3.16-4.78c3.7-2.75,7.12-5.75,9.17-10.01c0.74-1.3,1.39-2.65,1.76-4.11c0.1-0.42,0.23-0.83,0.37-1.24
		c0.58-1.88,0.98-3.8,1.75-5.62c0.67-1.65,0.64-3.39,0.56-5.1c-0.09-2.01,0.14-4.44-2.32-5.13c-2.26-0.63-3.14,1.57-4.3,2.99
		c-1.24,1.57-2.24,3.29-3.04,5.12c-4.6,8.44-7.86,17.65-14.33,25.02c-2.92,2.92-5.64,6.18-10.31,6.19
		c-8.81,0.91-14.88-3.12-19.07-10.56c-2.59-1.97-2.86-4.98-3.08-7.77c-1.49-18.64,5.39-33.97,18.81-46.64
		c1.2-1.13,2.73-1.63,4.23-2.17C688.51,451.4,689.5,450.74,690.5,450.08z"
        />
        <path
          class="st143"
          d="M746.1,365.83c0.34,0.92-1.12,1.9,0.43,2.9c7.98,5.16,7.82,13.46,7.77,21.52c-0.01,1.81-0.54,3.74-0.53,5.64
		c0.07,14.29-0.66,28.55-1.93,42.78c-0.79,8.83-7.8,15.59-16.54,15.23c-3.66-0.15-7.29-1.44-8.49-6c-0.91-3.47-2.46-6.78-3.72-10.17
		c-1.52-9.7-4.37-11.89-14.85-12.55c-6.03-0.38-12.07-0.87-18.09-1.55c-1.56-0.13-2.82-1.04-4.2-1.63c-1.6-1.89-5.66-1.06-5.45-4.95
		c0.16-0.51,0.49-0.86,0.98-1.08c1.92-0.64,3.54,0.04,5.07,1.12c2.46,1.94,5.27,2.96,8.39,3.01c7.18,0.11,14.25,1.35,21.35,2.15
		c5.36,0.61,8.38,4.3,9.63,9.36c0.84,3.4,1.4,6.86,2.1,10.3c0.33,1.59,0.59,3.14,2.05,4.13c1.67,2.98,5.29,1.12,7.41,2.97
		c0.18,2.36-1.2,1.54-2.24,1.54c2.93-0.15,5.66-1,8.11-2.8c4.76-6.53,4.67-14.13,5.4-21.73c1.17-12.18,0.48-24.39,1.3-36.57
		c0.3-4.42,0.54-9.54-2.15-13.81c-1.09-0.96-0.72-2.91-2.39-3.47c-4.18-0.18-8.44-1.32-12.31,1.3c-1.76,0.76-2.6-0.53-3.54-1.6
		c-0.48-1.35,0.53-2.19,1.1-3.17l0.01-0.01C735.18,364.04,740.46,363.99,746.1,365.83L746.1,365.83z"
        />
        <path
          class="st95"
          d="M713.12,526.74c10.89-6.74,17.14-16.95,21.42-28.64c0.8-1.47,1.41-2.98,1.56-4.68
		c0.12-1.3,0.64-2.41,2.34-2.01c1.98,2.83,0.63,5.81-0.48,8.15c-2.29,4.85-2.58,10.88-7.71,14.22c-0.47,0.3-0.73,1.05-0.91,1.65
		C726.88,523.45,720.64,526.01,713.12,526.74z"
        />
        <path
          class="st95"
          d="M731.61,467.59c-8.46-7.03-14.36-7.52-23.66-1.97c-4.75,0.78-6.73-2.66-8.87-5.84
		c-0.31-0.64-0.62-1.28-0.93-1.92c1.45-1.83,3.04-1.47,4.29,0.05c2.78,3.36,6.09,3.34,9.84,2.1c4.28-1.41,8.58-1.53,13.02-0.31
		C729.49,460.85,732,462.96,731.61,467.59z"
        />
        <path
          class="st95"
          d="M738.43,491.41c-3,1.24-1.17,5.3-3.9,6.69c0.92-4.96,2.04-9.87,1.9-14.99c-0.15-5.7-1.86-10.83-4.88-15.59
		c3.92,0.54,7.57,4.78,7.72,9.97C739.42,482.12,738.75,486.77,738.43,491.41z"
        />
        <path
          class="st144"
          d="M689.54,422.39c8.52,0.64,17.06,1.12,25.57,2c4.78,0.49,7.99,6.21,7.99,13.33c-2.02-1.46,0.11-4.3-1.92-5.75
		c-0.77-0.41-0.94-1.13-0.96-1.92c-2.42-1.54-4.72-3.34-7.67-3.84c-3.83,0-7.67-0.01-11.5-0.01c-2.02-1.83-4.49-0.58-6.72-0.96
		C693.21,423.5,689.8,425.58,689.54,422.39z"
        />
        <path
          class="st31"
          d="M687.51,452.06c-12.46,9.8-19.57,22.69-21.82,38.28c-0.9,6.21-0.26,12.35,1.87,18.3
		c-1.77,1.04-2.37-0.13-3.28-1.43c-3.77-5.42-2.2-11.23-1.56-17.03c1.26-11.32,5.28-21.63,12.59-30.23
		C678.34,456.38,681.16,451.07,687.51,452.06z"
        />
        <path
          class="st95"
          d="M705.12,516.25c0.91,1.43,1.7,2.9,1.88,4.62c-0.43,2.29-1.51,3-3.49,1.4c-0.84-0.68-1.49-1.59-2.47-2.1
		c-3.12-2.34-6.84-1.06-9.45,0.01c-2.57,1.05-3.39-0.51-4.97-0.98c3.61-1.67,6.78-3.97,9.66-6.68
		C699.9,512.18,703.64,511.55,705.12,516.25z"
        />
        <path
          class="st116"
          d="M701.04,520.17c2.11-0.79,3.57,3.88,5.96,0.7c0,0,0,0.03,0,0.03c0.15,1.5,0.77,2.81,1.59,4.04
		c0.14,0.9,0.29,1.81,0.43,2.71C705.26,526.34,701.41,525.11,701.04,520.17z"
        />
        <path
          class="st116"
          d="M730.76,368.7c-0.32,0.96-0.64,1.91-0.96,2.87c-1.65,5.21-1.77,11-5.75,15.34c-0.32,0-0.64,0-0.96,0
		c0.36-6.76,3.05-12.67,6.71-18.22C730.12,368.7,730.44,368.7,730.76,368.7z"
        />
        <path
          class="st116"
          d="M746.1,365.82c-5.27,0.11-10.75-0.9-15.33,2.88C735.23,363.05,740.37,362.09,746.1,365.82z"
        />
        <path
          class="st116"
          d="M712.54,426.22c3.33-0.27,5.73,1.32,7.67,3.84C717.23,429.64,715.13,427.44,712.54,426.22z"
        />
        <path
          class="st145"
          d="M570.79,379.99c0.22,0.17,0.45,0.32,0.69,0.45c0.94,18.74,1.8,37.48,1.1,56.25
		c-0.14,3.64,0.11,7.31-0.83,10.89c-1.02-1.43-0.7-2.94-0.56-3.45c0.26,1.35-0.63,3.72,0.41,6.06c-0.42,12.31-2.04,24.47-4.68,36.49
		c-1.17,4.82-1.22,4.94-6.03,2.84c-6.1-2.66-11.72-6.23-17.53-9.46c-4.03-3.08-8.81-4.75-13.25-7.07c-6.23-3-12.1-6.67-18.3-9.72
		c-8.46-5.52-17.77-9.51-26.38-14.75c-1.44-0.88-3.34-1.23-3.95-3.16c2.91-4.04,7.54-6.28,11.6-8.09c4.75-2.12,8.69-4.78,12.38-8.17
		c1.12-1.75,2.75-2.87,4.56-3.79c5.12-1.93,9.34-5.4,13.91-8.26c0.71-0.49,1.46-0.92,2.22-1.32c0.99-0.5,1.78-1.28,2.68-1.9
		c8.37-4.48,16.4-9.53,24.46-14.53c3.61-2.24,7.01-4.95,10.88-6.62c3.73-1.61,5.63-3.75,5.3-7.88
		C569.35,383.14,569.16,381.26,570.79,379.99z"
        />
        <path
          class="st90"
          d="M570.79,379.99c-0.05,0.79-0.2,1.59-0.12,2.37c0.61,5.85-1.02,9.04-7.16,12.15
		c-7.64,3.87-14.92,9.02-22.35,13.63c-4.03,2.5-7.64,5.99-12.68,6.59c-1.54-0.28-1.76,0.79-1.93,1.9c-0.64,0.32-1.27,0.65-1.91,0.97
		c-6.53-0.02-10.15,4.8-14.38,8.62c-1.6,0.96-3.2,1.92-4.8,2.89c-0.17-1.64,1.9-4-1.51-4.66c-0.2-0.04-0.5-1.35-0.24-1.74
		c2.83-4.22,1.57-8.96,1.7-13.49c0.08-2.65,1.34-3.07,3.59-3.17c11.03-0.53,11.07-0.58,11.76-11.98c0.12-2.05,0.46-3.39,2.9-3.33
		c3.78,0.09,5-2.17,4.81-5.58c-0.02-0.32,0-0.64,0-0.96c0.06-8.33,0.06-8.33,8.43-8.79c3.95-0.22,6.79-3.01,6.89-6.99
		c0.1-4.15,0.09-8.31,0-12.46c-0.05-2.26,0.43-3.76,3.12-3.58c2.18,0.15,4.38-0.97,4.28-2.94c-0.3-5.92,3.68-4.66,7-4.72
		c1.51,3.56,4.03,4.99,7.84,3.75c0.21,0.08,0.42,0.18,0.6,0.31c0.35,3.26,0.82,6.49,1.97,9.58
		C569.33,365.57,570.06,372.78,570.79,379.99z"
        />
        <path
          class="st146"
          d="M490.13,381.17c0.8,6.43-1.51,12.57-2.35,18.78c-1.74,12.99-4.33,25.91-6.27,38.9
		c-0.23,1.56-0.66,3.1-1,4.65c-2.39,1.16-2.67-0.85-3.16-2.23c-3.96-11.14-8.34-22.12-12.9-33.03c-0.98-3.35-3.06-6.43-2.55-10.16
		c3.03-3.14,3.98-8.43,9.55-8.99c1.74-0.18,2.17-2.01,1.92-3.4c-1.16-6.35,3.69-11.02,4.53-16.8c0.24-1.61,1.87-1.94,3.3-2.33
		c6.38-1.73,8.43-4.7,7.57-11.32c-0.3-2.31,0.55-3.7,2.46-4.61c2.14-1.02,3.79-0.36,3.22,2.1c-1.17,5.07-0.6,10.29-2.46,15.41
		C490.56,372.08,491.28,376.86,490.13,381.17z"
        />
        <path
          class="st48"
          d="M490.13,381.17c-0.05-10.11,3.88-19.76,3.34-29.89c-3.84,1.51-3.84,1.51-2.71,5.38
		c1.28,4.4-3.3,10.97-8.01,11.01c-3.03,0.02-4.58,0.82-4.13,4.05c0.04,0.31,0.14,0.75-0.02,0.94c-4.11,4.83-3.88,10.63-4.01,16.46
		c-0.05,2.26-2.41,1.62-3.87,1.61c-2.21-0.02-3.81,0.35-3.61,3.09c0.25,3.43-4.31,1.92-4.8,4.63c-4.03-2.52-4.71-6.25-3.82-10.55
		c3.35-1.48,5.96-3.19,7.21-7.27c3.19-10.43,7.8-20.29,14.61-28.96c0.8-1.02,1.23-2.22,1.21-3.55c-0.07-6.2,2.28-12.07,4.36-17.51
		c1.86-4.86,4.43-10.75,10.62-12.81c0.76-0.25,1.38-0.81,2.16-0.23c1.05,0.79,0.93,1.81,0.73,3c-0.61,3.57-1.06,7.18-1.57,10.77
		c0.32,9.28-2.23,18.23-3.28,27.35c-0.78,6.85-2.23,13.62-3.43,20.42C490.96,379.81,490.46,380.47,490.13,381.17z"
        />
        <path
          class="st91"
          d="M465.2,408c3.45,5.66,5.54,11.88,7.66,18.1c1.94,5.7,5.41,10.82,6.37,16.9c0.04,0.23,0.83,0.33,1.27,0.49
		c0.06,0.61,0.12,1.21,0.18,1.82c-0.19,0.15-0.39,0.29-0.58,0.44c-0.48,0.12-0.96,0.13-1.45,0.05c-9.54-3.11-19.31-5.59-28.45-9.87
		c-2.17-2.27-6.79-1.64-7.62-4.16c-0.88-2.7,3.89-3.55,4.98-6.29c0.65-1.61,1.32-3.24,2.19-4.78c0.55-0.97,0.83-2.64,1.68-2.8
		C457.62,416.73,459.47,409.67,465.2,408z"
        />
        <path
          class="st147"
          d="M481.49,445.36c5.76,3.21,11.81,5.8,17.31,9.62c3.37,2.34,7.91,3.11,11.37,5.72
		c0.74,0.56,1.35,1.29,2.01,1.94c-1.27,1.13-2.69,0.69-4.08,0.36c-4.23-0.99-6.23,0.06-6.77,4.27c-0.47,3.59-0.82,6.96-4.42,8.98
		c-1.25,0.7-0.54,1.49,0.36,2.14c1.57,1.13,1.86,2.76,0.74,4.17c-1.33,1.7-3.13,1.14-4.76,0.2c-0.83-0.48-1.91-0.93-2.18-1.79
		c-0.47-1.5-1.58-0.87-2.45-1.08c-2.29-2.54-1.85-6.06-3.24-8.92c-1.12-6.87-3.37-13.46-5.06-20.19c-0.47-1.86-1.3-3.63,0.24-5.36
		c0,0,0.12-0.12,0.12-0.12C480.95,445.35,481.22,445.37,481.49,445.36z"
        />
        <path
          class="st90"
          d="M549.57,332.27c0,1.27,0,2.54,0,3.81c0,8.7-2.56,10.62-11.33,8.65c-1.58-0.36-2.71-1.67-1.74-2.48
		c1.84-1.52,3.32-4.69,4.89-4.75C545.51,337.35,547.85,335.6,549.57,332.27z"
        />
        <path
          class="st90"
          d="M544.77,327.47c1.39-0.02,2.79-0.03,2.88,1.92c-1.17,0.3-1.94,2.22-3.18,1.4
		C543.08,329.88,544.4,328.58,544.77,327.47z"
        />
        <path
          class="st86"
          d="M202.52,297.75c-2.05,0.8-3.12,2.17-4.37,4.2c-5.66,9.26-9.22,19.66-15.86,28.39c-2,2.63-1.81,6.32-0.67,9.52
		c0.89,2.51,0.7,3.82-2.29,4.14c-2.78,0.3-3.81,1.96-3.75,4.92c0.09,4.08,0.59,8.2-0.66,12.29c-0.56,1.82-1.1,2.87-3.08,2.68
		c-2.38-5.13-1.69-10.47-0.49-15.61c0.77-3.31,1.99-6.61,3.36-9.79c0.31-0.67,0.75-1.27,1.25-1.82c2.76-2.7,3.2-6.56,4.83-9.82
		c5.99-8.85,8.34-19.46,13.93-28.53c1.81-2.94,2.15-6.61,2.66-10.06c0.21-1.4,0.1-2.88,1.19-4.03c2.2-0.13,2.2,1.8,2.92,3.07
		C202.13,290.77,205.34,293.97,202.52,297.75z"
        />
        <path
          class="st112"
          d="M175.67,338.02c-2.56,8.44-4.96,16.9-3.83,25.88c-3.79,8.99-9.68,15.89-19.17,19.17
		c-0.15-0.16-0.3-0.31-0.46-0.47c-0.29-0.62-0.33-1.26-0.17-1.92c0.15-0.42,0.4-0.78,0.71-1.1c1.04-0.84,2.08-1.69,3.09-2.57
		c8.43-6.55,12.63-14.89,10.59-25.69c-0.54-2.85-0.12-5.02,2.4-6.57c2.63-1.63,2.59-5.06,4.76-7
		C174.33,337.45,175.03,337.49,175.67,338.02z"
        />
        <path
          class="st82"
          d="M165.13,409.92c-0.96,0.32-1.92,0.64-2.87,0.96c-1.39-2.78-3.49-4.89-6.25-6.3
		c-2.17-1.11-4.03-2.54-5.18-4.73c-0.88-1.67-2.46-2.39-4.06-3.13c-2.47-1.13-4.76-2.53-6.67-4.49c-1.61-1.64-1.92-3.36,0.07-4.84
		c1.93-1.43,2.75-3.94,5.02-5.01c0.71-0.3,1.44-0.45,2.21-0.52c1.87-0.08,3.74-0.16,5.27,1.21c0,0,0,0.01,0,0.01
		c-1.53,2.06-1.87,4.71-4.07,6.61c-1.49,1.28-0.11,4.02,1.46,4.82c5.39,2.78,7.85,9.03,13.76,11.15
		C165.61,406.31,165.04,408.38,165.13,409.92z"
        />
        <path
          class="st62"
          d="M202.52,297.75c1.1-3.83-2.25-6.85-1.92-10.55c-0.95-5.36-0.08-6.74,5.11-8.09c0.22,0.14,0.43,0.28,0.65,0.42
		c0,6.39,0,12.78,0,19.17C204.96,298.86,203.71,298.41,202.52,297.75z"
        />
        <path
          class="st62"
          d="M267.71,215.3c-0.02,1.12-0.21,2.02-1.1,2.97c-2.74,2.95-7.89,4.2-6.85,9.97c0.28,1.56-1.81,1.52-3.01,1.41
		c-3.21-0.32-4.59,0.76-4.47,4.23c0.11,3.44-2.27,4.54-5.31,2.82c-5.15-2.92-10.43-3.37-15.57-0.31c-1.72,1.02-3.34,1.11-4.99,0.91
		c-3.88-0.45-5.17,1.16-4.77,4.88c0.24,2.2,0.04,4.46,0.04,6.69c-3.41,1.69-2.48,5.02-1.32,6.85c1.95,3.1,1.98,6.54,1.06,9.13
		c-1.26,3.53-5.43,5.91-4.44,10.55c-3.59,0.34-2.91,3.05-2.98,5.35c-0.04,1.15-0.12,2.3-1.62,2.48c-1.08,0.13-1.97-0.28-2.1-1.42
		c-0.29-2.62-2.22-2.22-3.93-2.27l0,0c-2.33-3.33,0.42-5.32,2.4-6.68c7.49-5.17,6.2-12.25,5.14-19.61
		c-0.95-6.65-2.49-13.36-0.85-20.13c1.03-4.22,6.25-6.24,12.44-4.63c4.57,1.19,8.88,2.85,13.86,2.77c5.75-0.09,10.31-2.65,15-5.15
		c2.54-1.36,3.19-4.17,3.97-6.81C259.83,214.15,262.46,213.11,267.71,215.3z"
        />
        <path
          class="st135"
          d="M530.4,472.23c4.78,1.62,9.25,3.86,13.4,6.72c-0.61,0.73-1.51,1.53-1.51,2.38c0.01,8.36-7,11.85-11.64,16.95
		c-2.83,3.11-4.38,6.96-6.4,10.52c-1.71,3.01-2.7,6.41-4.59,9.39c-1.44,2.26-1.18,4.9-0.23,7.35c0.49,1.27,1.02,2.38-0.53,3.25
		c-4.8,2.69-10.01,4.32-15.26,5.84c-1.88,0.31-2.6-0.96-2.97-2.39c-2.42-9.38-5.13-18.7-6.57-28.3c-0.07-0.47,0.1-0.94,0.24-1.39
		c0.13-0.31,0.41-0.7,0.61-0.62c2.59,1.01,3.85-0.04,4.35-3.65c0.52-3.74,1.99-4.62,5.9-3.51c3.97,1.12,5.82-0.04,6.55-4.15
		c0.22-1.26,0.17-2.54,0.22-3.82c0.11-2.98,1.59-4.82,4.55-5.22c3.92-0.54,6.74-2.07,8.07-6.24
		C525.34,472.99,527.07,470.64,530.4,472.23z"
        />
        <path
          class="st131"
          d="M518.9,528.79c1.93-2.31-1.51-2.97-1.54-5.19c-0.11-7,5.19-11.52,6.87-17.62
		c1.69-6.14,8.41-9.08,10.41-15.16c0.05-0.14,0.21-0.35,0.31-0.34c7.45,0.72,4.23-5.73,5.74-8.88c0.78-1.61,1.12-2.85,3.12-2.65
		c6.11,3.06,11.81,6.86,18.06,9.72c3.04,1.39,4.04,0.35,5.06-2c-0.16,5.79-2.12,11.25-3.08,16.89c-0.21,1.22-0.98,1.92-1.94,2.57
		C548.37,515.22,534.3,523.26,518.9,528.79z"
        />
        <path
          class="st148"
          d="M363.56,543.18c-1.22-1.56-2.92-1.96-4.78-1.94c-2.35-2.89,0-3.58,2.05-3.83
		c5.84-0.71,10.06-3.94,13.79-8.14c2.38-2.67,5.63-1.42,8.53-1.79c2.93,0.11,5.36-0.41,6.18-3.85c0.65-2.74,2.79-3.68,5.42-3.79
		c1.75-0.08,3.51-0.03,5.26-0.09c0.96-0.03,2.63-0.03,2.68-0.54c0.61-6.16,8.27-6.11,9.81-11.34c0.23-0.77,0.59-1.82,1.27-1.94
		c6.92-1.22,9.79-10.18,17.84-9.26c1.48,0.17,2.93-0.61,3.27-2.25c0.66-3.26,2.98-3.88,5.81-4.62c4.13-1.08,9.72-0.36,10.67-6.69
		c4.81-1.09,6.76-5.53,10.07-8.38c2.09-1.79,5.47-1.39,8.29-1.85c1.43-0.23,3.18-0.29,3.44-2.01c0.74-4.86,4.34-4.78,7.9-4.92
		c1,0,1.84-0.69,2.84-0.67c2.13,4.35-0.4,10.47-4.89,10.87c-4.8,0.43-7.6,3.08-11.11,6.12c-5.16,4.46-9.29,11.84-18.08,10.43
		c-1.07-0.17-2.59,0.11-2.89,1.24c-1.05,4.01-4.48,5.12-7.31,7.34c-2.93,2.31-5.07,5.52-8.88,7.05c-1.43,0.58-0.67,3.64-2.13,5.1
		c-0.36,0.36-0.77,0.63-1.24,0.82c-1.83,0.61-3.74,0.61-5.61,0.47c-3.5-0.27-6.23,0.42-7.1,4.38c-0.2,0.9-0.88,2.01-1.73,2.13
		c-4.71,0.66-5.65,4.9-7.83,7.96c-2.8,0.93-5.36,1.91-7.71,4.14c-2.65,2.51-6.15,4.52-10.26,4.45c-1.84-0.03-3.41,0.63-4.36,2.38
		c-1.23,2.26-1.56,3.69,1.97,3.79c2.1,0.06,5.78-1.64,5.67,3.01C381.3,546.83,372.43,545,363.56,543.18z"
        />
        <path
          class="st149"
          d="M470.33,543.35c-10.53,2.42-21.19,3.87-31.99,4.22c-0.3-0.32-0.47-0.71-0.5-1.15
		c0.06-1.13,0.1-2.27,1.23-2.96c1.06-0.68,2.72-0.82,3.06-2.13c0.93-3.58,3.2-5.17,6.73-5.69c1.78-0.27,2.38-2.04,2.56-3.68
		c0.4-3.82,2.92-4.67,6.12-4.34c4.48,0.46,8.34,0.54,10.53-4.81c1.14-2.79,4.99-2.49,7.78-2.76c3.03-0.28,5.29-0.9,5.55-4.48
		c0.13-1.78,1.26-3.05,3.07-3.15c5.13-0.29,6.57-3.77,7.21-8.03c0.15-0.75,0.39-1.45,0.79-2.1c0.32-0.45,0.76-0.64,1.3-0.57
		c0.45,0.28,0.67,0.68,0.66,1.21c-0.21,1.8,0.86,3.31,1.05,5.08c0.84,8.06-1.73,11.93-9.23,15.54c-4.59,2.21-9.36,4.68-10.76,10.61
		c-1.27,5.34-4.88,8-10.54,7.44c-4.11-0.41-7.29,3.43-11.01,2.56c1.77,0.17,3.84-0.54,5.99-1.12
		C463.34,542.11,466.95,540.66,470.33,543.35z"
        />
        <path
          class="st149"
          d="M470.33,543.35c-5.33-0.91-10.33,1.14-15.49,1.68c-1.98,0.21-4.09,0.48-6.09-0.34
		c0.14-0.35,0.27-0.88,0.37-0.87c6.51,0.45,12-4.14,18.62-3.62c5.12,0.4,6-4.49,6.88-7.74c1.68-6.23,7.1-7.7,11.53-10.21
		c2.22-1.26,3.88-2.65,5.76-4.3c5.67-4.99,2.04-10.61,2.06-15.98c0.3-0.24,0.6-0.23,0.9,0c2.31,10.21,4.61,20.43,6.93,30.64
		c0.23,1.01,1.01,1.55,1.85,2.02C492.81,538.58,481.7,541.45,470.33,543.35z"
        />
        <path
          class="st150"
          d="M438.3,547c0.02,0.19,0.04,0.39,0.05,0.58c-16,1.68-31.97,1.4-47.93-0.61c-0.66-2.91-3.02-1.66-4.71-1.82
		c-1.89-0.18-3.8-0.04-5.8-0.04c0.73-5.86,2.78-9.36,9.56-8.9c2.53,0.17,6.64-1.87,7.61-4c1.87-4.12,4.73-3.32,7.73-3.39
		c0.82-0.51,1.41-1.22,2.04-1.95c3.25-3.74,6.78-6.87,12.16-7.39c3.81-0.37,7.48-1.67,8.81-6.01c1.7-0.8,2.25-2.64,3.48-3.88
		c3.14-3.14,6.5-5.6,11.31-5.1c2.59,0.27,4.9-0.32,7.1-2.1c2.79-2.26,6.22-3.09,9.88-2.49c1.83,3.08-0.06,4.76-2.42,6.14
		c-1.64,0.96-3.59,1.39-4.83,2.98c-2.77,2.43-5.88,2.29-8.9,0.76c-2.64-1.34-3.78-0.61-5.13,1.94c-2.81,5.28-6.95,9.34-13.07,10.67
		c-1.87,0.4-2.76,1.36-2.97,3.16c-0.37,3.09-2.32,4.39-5.23,4.47c-3.47,0.09-6.28,1.64-8.06,4.41c-2.29,3.57-5.42,5.21-9.48,5.5
		c-0.79,0.06-1.56,0.29-2.34,0.48c-1.78,0.44-3.71,1.13-3.47,3.25c0.23,1.98,2.36,1.75,3.88,1.96c0.94,0.14,1.91,0.04,2.88,0.06
		c10.67,0.04,21.33-0.09,31.99-0.03C434.5,545.65,436.61,545.37,438.3,547z"
        />
        <path
          d="M368.51,551.07c-2.91,1.08-5.04,0.79-4.92-3.07c0.04-1.3,0.01-2.7,1.77-2.81c1.52-0.1,3.96-0.65,4.13,1.1
		c0.23,2.34,1.02,2.07,2.53,1.61c1.29-0.39,2.98-1.47,3.53,0.64c0.41,1.6-1.54,1.67-2.5,2.34
		C371.61,551.89,370.09,551.84,368.51,551.07z"
        />
        <path
          class="st83"
          d="M579.4,408.01c0.6,0.32,1.2,0.63,1.8,0.95c1.95,2.38,0.59,4.13-1.11,5.82
		C579.22,412.59,579.34,410.3,579.4,408.01z"
        />
        <path
          class="st118"
          d="M571.6,450.18c-1.94-2.43-0.41-5.09-0.22-7.67c0.12,1.69,0.25,3.37,0.37,5.06
		C571.7,448.44,571.65,449.31,571.6,450.18z"
        />
        <path
          class="st119"
          d="M450.79,435c4.68,2.98,10.3,3.37,15.3,5.53c4.39,1.91,9.03,3.27,13.55,4.87c0.31,0.4,0.33,0.81,0.06,1.23
		c-4.39,3.62-9.66,5.84-14.3,9.06c-5.46,2.65-10.07,6.67-15.34,9.64c-15.51,9.81-31.1,19.47-46.57,29.34
		c-1.91,1.02-3.84,2-5.45,3.49c-0.34,0.26-0.71,0.48-1.1,0.67c-2.04,0.55-3.61,2.19-5.74,2.56c-0.41-0.09-0.77-0.29-1.05-0.61
		c-0.18-0.41-0.25-0.82-0.06-1.26c0.02-0.05-0.16-0.16-0.17-0.15c-0.3,0.8,0.12,1.33,0.67,1.82c0.14,0.43,0.07,0.83-0.18,1.2
		c-3.72,3.18-7.95,5.45-12.49,7.21c-7.51,4.57-15.03,9.13-22.53,13.71c-1.06,0.65-1.91,1.71-3.33,1.64
		c1.43-2.78-2.32-1.29-2.36-2.99c0.91-1.37,2.16-0.76,3.3-0.34c1.34,0.5,2.89,0.62,3.3-0.79c0.87-2.97,2.52-3.8,5.57-3.12
		c-1.24-1.02-2.48-2.05-4.57-3.77c6.52-1.69,12.66-2.19,17.88-5.32c-0.11-0.25-0.16-0.63-0.35-0.71c-1.63-0.78-4.44,0.95-4.98-1.36
		c-0.51-2.18,1.85-3.47,3.68-4.48c1.38-0.77,2.85-1.37,4.25-2.1c0.88-0.46,2.66-0.7,0.42-2.01c-1.28-0.75-0.06-1.44,0.55-1.51
		c5.72-0.6,8.85-7.21,15.42-6.31c2.18,0.3,3.28-2.69,3.85-4.92c0.9-3.51,1.67-6.83,5.96-8.15c1.73-0.53,3.16-2.66,4.32-4.34
		c2-2.89,4.76-4.04,8.07-4.32c0.79-0.07,1.6-0.01,2.39-0.11c4.53-0.57,1.82-6.24,4.65-7.18c3.07-1.02,6.33-0.71,6.41-5.32
		c0.04-2.61,4.79-6.07,7.25-7.17c2.99-1.33,5.03-4.22,6.86-6.91c1.3-1.92,2.22-4.03,4.77-5.2c-3.43-0.28-6.97,0.24-8.36-3.73
		C444.3,431.21,447.33,434.09,450.79,435z"
        />
        <path
          class="st57"
          d="M449.88,366.79c-0.01,0.63-0.01,1.27-0.02,1.9c1.76,2.51,1.38,5.75,3.1,8.4c1.11,1.7,0.18,3.97-2.18,4.41
		c-5.81,1.07-8.64,5.65-11.84,9.74c-1.71,2.19-4.15,3.25-6.11,4.83c-4,3.22-10.23,4.55-11.08,11.05c-0.19,1.41-0.84,2.97-2.36,3.38
		c-5.41,1.46-9.9,4.91-15.14,6.84c0.87,0.65,2.04,0.59,2.93,1.18c3.13,0.91,6.17,2.05,9.19,3.23c1.63,0.64,3.69,1.03,3.76,3.46
		c-2.82,0.48-4.85-2.3-7.66-1.84c-6.04-0.28-11.29-3.27-16.95-4.89c-1.3-0.56-2.5-1.31-3.74-1.99c-0.96-0.63-2.22-0.89-2.73-2.12
		c-0.08-2.64,1.93-2.56,3.63-2.6c1.94-0.05,3.17-0.73,4.16-2.5c3.18-5.68,6.89-10.56,13.73-12.73c2.72-0.87,5.2-3.21,8.3-3.94
		c0.86-0.2,0.8-1.26,0.91-2.04c0.06-1.18,0.19-2.34,0.7-3.42c1.1-1.68,2.88-2.43,4.55-3.32c2.18-1.16,3.89-2.72,4.54-5.21
		c0.8-3.04,2.78-4.49,5.93-4.39c0.95,0.03,1.95-0.31,2.84-0.15c4.29,0.74,4.98-3.57,7.53-5.22c1.23-0.13,1.38-0.64,0.5-1.52
		c-0.27-0.56-0.41-1.15-0.48-1.75c-0.11-2.18-0.72-4.24-1.6-6.23c-0.45-1.08-0.92-2.16-0.96-3.35c0.04-0.76,0.27-1.43,0.93-1.89
		C449.13,357,449.35,361.96,449.88,366.79z"
        />
        <path
          class="st27"
          d="M420.13,425.21c-3.85-3.36-9.09-3.44-13.41-5.7c0.91-1.11,2.26-1.04,3.48-1.32
		c7.09-1.65,13.72-4.02,17.23-11.19c0.14-0.28,0.28-0.39,0.28-0.39c6.7-0.52,8.79-8.26,14.96-9.57c2.31-0.49,3.65-1.77,4.08-4.09
		c0.34-1.82,1.16-3.8,3.18-3.64c4.16,0.33,5.06-2.2,5.59-5.38c2.78-0.18,2.33,1.89,2.47,3.54c0.44,2.79,0.9,5.57,2.06,8.2
		c1.81,4.11,1.28,5.85-2.74,7.52c-2.34,0.97-3.87,2.48-5.37,4.44c-2.89,3.78-5.85,7.68-11.45,7.45c-1.17-0.05-2.5,0.48-2.52,1.73
		c-0.09,6.74-5.58,6.18-10.5,7.62c2.66,1.55,5.09,2.36,7.42,3.4c1.46,0.65,3.59,0.77,3.46,3.21
		C431.9,430.29,426.2,427.19,420.13,425.21z"
        />
        <path
          class="st111"
          d="M438.36,431.03c-3.12-2.6-7.24-2.98-10.73-4.77c-0.84-0.43-2.74,0.27-2.13-1.55
		c0.38-1.11,0.84-2.88,2.78-2.69c4.55,0.45,8.71,0.44,8.23-6.04c-0.15-2,1.4-2.42,2.92-2.18c6.28,0.97,9.32-3.54,12.03-7.69
		c1.38-2.11,2.69-3.3,4.94-3.85c3.8-0.93,4.88-2.79,2.94-6.61c-1.17-2.31-1.24-5.17-1.8-7.79c0.32-0.43,0.64-0.42,0.94,0.02
		c0,0,0,0,0,0c0.89,3.66,1.68,7.35,3.83,10.55c0.96,3.19,1.93,6.38,2.89,9.58c-0.4,1.88-2.63,2.46-3.22,3.6
		c-2.51,4.9-8.76,5.26-11.26,9.9c-4.07,7.55-4.06,7.55-7.96,10.07c3.18,0.46,5.81,1.5,8.02,3.42c-3.69,0.24-6.7-2.82-10.47-2.2
		C439.67,432.21,439.01,431.62,438.36,431.03z"
        />
        <path
          class="st21"
          d="M395.24,417.56c5.88,1.52,11.66,3.36,17.23,5.81c0,0.31,0.01,0.61,0.01,0.92c-0.64,0.62-1.28,0.54-1.92,0.01
		c-0.96,0.25-1.92,1.52-2.88,0c-0.74-0.97-1.98-1.19-2.87-1.92c-0.64-0.32-1.28-0.64-1.92-0.96c-2.34-0.28-4.81,0.07-6.9-1.42
		c-1.07-1.06-3.9,0.32-3.61-2.61C393.36,416.92,394.32,416.98,395.24,417.56z"
        />
        <path
          class="st21"
          d="M410.56,424.31c0.64,0,1.28-0.01,1.92-0.01c0.79,0.03,1.5,0.2,1.91,0.97c-0.96,0.32-1.92,0.64-2.88,0.96
		C411.2,425.58,410.88,424.94,410.56,424.31z"
        />
        <path
          class="st42"
          d="M273.5,491.43c-1.29-7.67-2.59-15.35-3.88-23.02c-1.88-5.92-2.21-12.09-2.86-18.2l-0.02-0.03
		c-0.62-1.83-1.85-3.52-1.22-5.63c1.66-0.81,2.18,0.65,3.03,1.49c1.05,1.52,1.33,3.25,1.37,5.05c0.03,1.42-0.02,2.84,0.07,4.25
		c1.02,4.24,1.24,8.67,3.08,13.44c0.96-2.36-0.29-3.38-1.09-4.58c-1.41-2.12-1.74-4.14,1.07-5.49c0.4-0.17,0.8-0.34,1.18-0.53
		c1.28-1.78-0.67-2.51-1.21-3.67c-1.21-2.55-0.93-4.22,2.21-4.82c5.1-0.96,6.26-2.26,6.52-7.59c0.15-3.12,0.8-5.68,4.27-6.59
		c1.85-0.48,2.39-1.91,2.44-3.65c0.06-2.23-0.04-4.47,0.13-6.7c0.18-2.2,0.92-4.47,3.05-5.02c4.35-1.14,5.03-4.33,5.37-7.95
		c0.03-0.32-0.01-0.68,0.13-0.94c3.39-6.13,4.29-12.76,4.13-19.65c-0.04-1.5,1.07-2.61,2.48-3.27c0.71-0.29,1.44-0.4,2.2-0.35
		c3.12,0.73,6.07,2.06,9.25,2.56c2.91,0.73,5.72,1.78,8.56,2.72c1.1,0.36,2.61,0.5,2.47,2.29c-3.02,0.04-6.05,0.27-8.83-1.44
		c-1.09-0.67-2.79-1.03-3.59-0.07c-0.97,1.16,0.23,2.58,1.22,3.14c3.23,1.84,2.67,4.81,2.49,7.6c-0.28,4.47-1.11,4.85-4.66,2.45
		c-2.3-1.55-5.16,0.57-5.86,4.08c-1.32,6.63-0.96,13.32-0.89,19.99c0.03,3.25-0.27,5.64-4.44,5.65c-2.46,0.01-3.48,1.8-3.3,4.31
		c0.15,2.07-0.05,4.15,0.05,6.22c0.12,2.75-0.46,4.58-3.82,4.73c-3.3,0.14-3.89,2.62-3.9,5.47c-0.01,6.99,0.45,14.01-0.9,20.96
		c-0.27,1.4,0.06,3.11-2.02,3.13c-5.4,0.05-5.14,4.23-5.64,7.74c-0.49,3.39,1.09,7.06-2.54,10c-1.11,0.9-1.09,4.23,0.52,6.22
		c0.73,0.9,0.12,1.49-0.49,1.98c-1.15,0.91-1.05-0.59-1.56-0.82c-2.32-1.08-1.69-3.06-1.71-4.85
		C276.32,498.23,277.02,494.27,273.5,491.43z"
        />
        <path
          class="st110"
          d="M334.97,398.41c-0.09-0.33-0.17-0.65-0.26-0.98c0.08-0.21,0.16-0.42,0.24-0.64
		c7.37-7.16,16.53-11.88,24.61-18.09c4.92-3.78,10.45-6.76,15.3-10.68c17.4-12.04,34.92-23.89,52.11-36.22
		c1.95-1.4,3.76-3.69,6.75-2.65c2.24,1.76,2.83,4.34,3.44,6.91c0.08,0.46,0.09,0.93,0.04,1.39c-2.11,1.84-4.3,3.52-5.44,6.34
		c-0.59,1.47-2.52,1.98-4.14,1.98c-3.16-0.01-4.58,1.64-5.04,4.56c-0.53,3.33-2.73,4.59-5.85,4.07c-2.11-0.35-2.74,0.34-2.85,2.36
		c-0.14,2.47-1.37,4.2-4.08,4.47c-1.54,0.15-2.46,1.19-3.5,2.24c-2.22,2.26-5.19,3.77-7.41,5.81c-4,3.69-7.33,7.86-13.22,8.65
		c-1.09,0.15-1.34,2.05-1.75,3.25c-0.5,1.45-1.34,2.58-2.9,2.88c-2.52,0.48-3.74,2.97-5.5,3.92c-6.31,3.39-8.54,11.76-16.46,12.98
		c-1.72,0.27-2.96,1.7-3.36,3.58c-1.11,0.71-2.29,0.67-3.5,0.39C346.55,402.58,340.28,401.76,334.97,398.41z"
        />
        <path
          class="st118"
          d="M392.34,417.6c0.83,1.54,3.01,0.36,3.84,1.91c-1.15,0.84-2.47,0.35-3.71,0.47c-6.43,0.64-6.77,0.9-8.65,7.16
		c-0.09,0.31-0.11,0.85-0.28,0.88c-6.47,1.17-7.04,10.65-14.75,10.31c-3.18-0.14-5.27,1.84-7.69,4.4
		c-3.38,3.57-7.79,5.95-10.46,10.66c-1.08,1.91-4.72,2.76-5.67,5.79c-0.3,0.95-1.34,1.31-2.26,1.61c-0.61,0.2-1.53,0.18-1.78,0.61
		c-2.58,4.43-6.63,7.23-10.7,10.05c-0.22,0.15-0.22,0.8-0.4,0.83c-7.26,1.19-8.25,10.14-14.91,12.02c-2.3,0.65-1.64,2.28-1.53,3.86
		c0.18,2.45,0.42,5.09-3.49,4.21c-0.09-1.18,0.46-2.98-1.9-1.92c0.19-5.38,3.08-10.07,3.84-15.31c0.33-0.34,0.63-0.71,0.89-1.11
		c0.78-3.86,2.83-7.32,3.48-11.24c0.33-2,1.89-3.26,3.52-4.31c4.39-2.82,8.42-6.29,13.57-7.77c1.71-0.49,2.1-1.82,2.22-3.3
		c0.2-2.38,1.3-3.95,3.8-4.1c2.46-0.15,3.58-1.36,4.07-3.79c0.83-4.11,3.82-6.41,7.78-6.63c4.71-0.27,7.01-2.38,7.38-6.97
		c0.27-3.32,2.21-5.16,5.49-5.65c2.14-0.32,3.72-1.07,2.97-3.75c-0.45-1.59-2.05-3.33-0.31-4.84c1.94-1.68,3.89-0.21,5.77,0.58
		c0.58,0.25,1.23,0.33,1.82,0.58c0.99,0.34,1.81,1.88,3.06,0.42c0.6-0.26,1.22-0.33,1.86-0.28c1.52,1.27,5.31-0.98,5,3.26
		c-0.04,0.55,0.65-0.12,0.96-0.24c1.69-0.62,3.36-0.48,5.04-0.06C391.12,416.26,391.89,416.72,392.34,417.6z"
        />
        <path
          class="st11"
          d="M375.08,413.76c-0.32,0-0.65,0.04-0.96-0.01c-3.45-0.62-9.74-4.95-5.45,4.37c0.6,1.3-0.44,3.54-2.95,3.3
		c-4.67-0.44-5.92,1.95-6.14,6.3c-0.19,3.68-2.17,6.36-6.77,6.25c-5.42-0.13-7.97,2.24-8.34,7.46c-0.19,2.74-1.55,3.23-3.7,2.99
		c-3.15-0.36-4.44,0.96-4.05,4.08c0.34,2.63-0.75,3.79-3.51,3.64c-4.33-0.23-6.21,4.11-9.91,5.47c-6.39,2.35-7.45,8.63-8.6,14.47
		c-0.27,1.36-0.66,2.43-1.95,3.03c-0.91-2.12,0.5-3.86,0.96-5.75c2.08-7.58,4.13-15.16,6.27-22.72c0.14-0.51,0.89-0.84,1.36-1.26
		c1.22-2.83,2.08-5.73,2.57-8.82c0.56-3.55,2.8-6.35,6.29-7.1c4.25-0.91,6.38-4.59,9.83-6.44c0.78-0.42,0.93-1.2,0.81-2.06
		c-0.34-2.65,0.12-4.53,3.52-3.76c1.49,0.33,1.5-1.41,2.37-1.95c4.5-2.78,7.98-7.82,14.5-6.08c1.56,0.42,3.39-0.66,5.15-0.75
		c1.68,0.06,3.04,1.16,4.67,1.4c2.26,2.02,6.34,0.42,7.86,3.91c-0.64,0-1.28,0-1.92,0C376.36,414.36,375.72,414.32,375.08,413.76z"
        />
        <path
          class="st129"
          d="M326.21,395.53c-3.85-1.29-7.69-2.58-11.54-3.87c-3.67-2.76-4.76-5.43-1.69-9.87c2.2-3.19,3.1-7.1,7.21-8.87
		c1.66-0.71,1.67-2.94,1.83-4.69c0.22-2.4,0.37-5,2.24-6.63c5.99-5.21,5.92-12.03,5.11-18.92c-0.73-6.26,1.04-12.27,1.15-18.42
		c0.03-1.61,0.74-2.39,2.44-1.79c0.64,0.6,0.8,1.38,0.85,2.21c0.04,2.24-0.03,4.49,0.51,6.7c-0.26,22.01,0.58,44.02-0.49,66.02
		C331.29,396.78,328.75,396.16,326.21,395.53z"
        />
        <path
          class="st130"
          d="M366.45,408.98c-2.67,0.5-5.18,3.67-8.1,0.46c-0.19-0.21-1.11-0.15-1.29,0.09
		c-3.21,4.16-10.77,3.51-11.15,10.41c-1.88,0.12-1.58-3.12-3.46-1.94c-1.62,1.03-0.85,2.43,0.19,3.62c0.64,0.73,0.49,1.88-0.28,1.99
		c-4.94,0.65-6.48,6.67-11.94,7.01c-3.46,0.21-5.92,3.86-5.9,7.2c0.03,3.31-1.31,5.38-3.15,7.57c0.38-8.18,4.16-15.48,6.06-23.27
		c1.72-7.05,3.78-14.02,5.73-21.01c0.3-1.06,0.74-2.12,1.83-2.69c6.01,0.99,11.69,2.94,17.12,5.66
		C356.76,406.05,362.31,405.44,366.45,408.98z"
        />
        <path
          class="st151"
          d="M333.83,397.41c-2.16-3.25,0.17-6.48,0.14-9.74c-0.22-19.11-0.11-38.22-0.11-57.33
		c-0.93-1.9-0.25-3.93-0.46-5.89c-0.71-3.39-1.04-6.81-0.88-10.27c-0.11-2.09,0.61-3.99,1.35-5.88c0.48-4.46-1.03-9.07,0.95-13.43
		c0.01,33.56,0.02,67.11,0.03,100.67c0.59,0.61,0.49,1.23,0.05,1.87c0,0-0.17,0.02-0.17,0.02c0,0-0.44,0.01-0.44,0.01L333.83,397.41
		z"
        />
        <path
          class="st51"
          d="M313.73,469.37c0.37,2.03-0.65,3.83-0.96,5.75c-0.31,0.01-0.62,0.02-0.93,0.02
		C311.69,472.96,311.89,470.89,313.73,469.37z"
        />
        <path
          class="st85"
          d="M267.71,215.3c-6.65,0.23-6.98-1.87-8.94,7.57c-0.51,2.44-2.58,4.32-4.82,4.9c-4.02,1.03-7.34,4-11.36,4.41
		c-3.99,0.41-8.3,1.61-12.1-1.01c-4.04-2.79-8.46-1.8-12.82-1.44c-1.78,0.15-3.39,1.3-3.39,2.86c-0.01,3.88-0.83,7.62-0.39,11.69
		c0.88,8.13,4.5,16.39,0.4,24.73c-0.74,1.5-1.32,2.44-2.8,3.33c-2.61,1.59-5.55,3.29-5.14,7.19c-3.95,1.03-6.11,3.41-5.75,7.67
		c-0.64-0.96-1.28-1.92-1.92-2.87c-1.39-1.27-1.22-2.97-1.27-4.61c0.24-3.68,1.63-6.29,5.65-7.18c6.19-1.38,9.16-4.42,9.01-10.98
		c-0.16-7.1,0.16-14.26-0.93-21.32c-0.8-3.58-1.01-7.2-1.02-10.88c-0.01-2.76,1.12-3.38,3.7-3.59c5.1-0.41,9.73,1.25,14.48,2.47
		c7.58,1.94,14.98,3.11,22.4-1.2c2.87-1.67,5.67-3.97,5.81-6.45c0.27-4.76,3.49-7.46,5.44-11.03c5.98-3.28,12.55-2.1,18.91-2.48
		c0.83-0.05,1.56-0.02,2.18,0.56c0.12,1.91-0.64,3.21-2.69,2.83c-3.75-0.68-6.55,2.74-10.33,2.15
		C268.71,212.42,268.31,214.23,267.71,215.3z"
        />
        <path
          class="st77"
          d="M283.05,207.64c-3.16,0-6.32-0.03-9.48,0.01c-2.45,0.03-4.92-0.52-6.83,2.06c-1.22,1.64-3.19,0.64-4.78-0.15
		c2.09-2.57,4.53-3.38,8.03-3.03c4.74,0.47,9.79,1.14,13.93-2.62c0.98-0.89,1.98-1.54,2.01-2.98c0.33-1.06,12.19-17.59,13.02-18.14
		c5.54-3.69,11.44-4.39,17.7-2.18c0.14,2.48-1.88,2.18-3.27,2.32c-2.2,0.21-4.34,0.65-6.47,1.15c-0.91,0.23-1.97-0.26-2.76,0.55
		c-5.76,7.16-9.77,15.72-17.33,21.47C285.58,207.03,284.55,207.71,283.05,207.64z"
        />
        <path
          class="st70"
          d="M304.14,184.63c0.41-0.77,1.13-0.94,1.92-0.96c5.31-0.29,10.6-1.17,15.95-0.4c5.24,0.76,10.01-0.7,14.49-3.33
		c2.42-1.56,4.51-4.02,7.91-2.98c0,0.96,0,1.92,0,2.88c1.44,1.54-1.85,2.88-0.19,4.76c0.32,0.36-1.92,2.11-3.64,0.99
		c-10.1,2.63-20.42,1.86-30.68,1.92C308.67,185.16,306.2,185.31,304.14,184.63z"
        />
        <path
          class="st21"
          d="M309.89,492.37c3.52-0.47,3.06-2.66,1.98-4.89c-1.43-2.98-0.63-4.52,2.68-4.51c3.51,0.02,5.14-1.23,5.04-5.11
		c-0.09-3.73,3.79-3.77,6.14-4.47c2.15-0.63,3.49-0.95,3.37-3.48c-0.13-2.67,1.9-2.58,3.66-2.44c2.75,0.22,4.34-0.6,4-3.68
		c-0.05-0.45,0.01-1.24,0.26-1.36c4.53-2.14,7.2-6.69,11.25-9.06c2.34-1.37,4.08-1.93,3.77-4.79c-0.33-3.01,0.69-4.54,3.96-4.17
		c2.7,0.3,4.54-0.35,4.78-3.72c0.33-4.66,4.79-3.19,7.2-3.61c3.91-0.68,7.68-0.1,7.35-5.94c-0.11-1.94,2.09-2.15,3.73-2.02
		c2.59,0.2,3.68-0.69,3.73-3.49c0.1-4.86,2.34-6.65,7.15-6.38c2.07,0.12,4.13,0.17,6.2,0.26c1.93,1.71,4.83,0.01,6.71,1.92
		c-3.7,2.47-6.89-2.11-10.48-0.74c3.01,2.49,2.96,5.28-0.38,7.08c-2.87,1.54-5.52,2.75-5.68,6.81c-0.11,3-3.5,2.29-5.41,2.86
		c-3.08,0.92-4.84,1.69-6.44,5.37c-1.4,3.2-5.6,7.57-8.61,8.63c-4.27,1.51-5.14,2.87-6.81,6.83c-1.3,3.08-5.5,7.03-8.93,8.67
		c-2.96,1.41-4.79,2.05-5.42,5.38c-0.46,2.46-2.7,3.42-5.05,3.7c-1.26,0.15-2.55,0-3.82,0.07c-6.23,0.32-6.77,0.88-6.78,6.88
		c-0.01,6.57-0.06,6.32-6.93,7.64c-3.09,0.59-7.12-0.17-8.76,4.13c-0.33,0.87-2.19,1.89-3.32,1.15
		C308.86,495.12,310.28,493.57,309.89,492.37z"
        />
        <path
          class="st21"
          d="M404.81,422.39c1.39-0.02,2.79-0.03,2.87,1.92C406.3,424.3,405.34,423.66,404.81,422.39z"
        />
        <path
          class="st152"
          d="M334.89,397.41c-0.02-0.62-0.03-1.24-0.05-1.87c1.54-1.42,0.9-3.29,0.91-4.96
		c0.06-11.45,0.03-22.9,0.03-34.35c2.59,0.32,1.94,2.48,2.18,4.03c0.24,1.57,0.13,3.19,0.5,4.75c0.27,1.11,0.59,2.32,1.72,2.73
		c3.17,1.14,5.82-1.12,8.75-1.63c2.27-0.4,1.75-2.72,1.83-4.4c0.09-1.75,0.04-3.51,0.04-5.27c0.01-2.91,0.95-5.03,4.23-5.26
		c2.67-0.19,3.47-1.79,3.42-4.21c-0.04-1.91-0.06-3.83,0.08-5.75c0.09-1.29,0.18-3.3,1.16-3.47c5.77-1.03,6.44-7.99,11.56-9.6
		c2.36-0.74,2.57-2.63,2.5-4.6c-0.16-5-0.06-9.77,6.22-11.24c1.16-0.27,1.4-1.65,1.75-2.71c0.57-1.75,1.5-3.45,3.3-3.83
		c4.25-0.89,4.52-3.89,4.33-7.28c-0.05-0.96-0.19-1.91-0.12-2.87c0.12-1.57-0.06-3.54,1.95-3.89c1.96-0.35,1.82,1.83,2.7,2.82
		c-2.28-4.97-8.37-6.78-10.2-12.13c-0.32,0-0.64,0-0.95-0.01c0-0.64,0-1.28,0-1.92c2.94,1.08,4.95,3.38,6.96,5.58
		c5.17,5.66,11.47,10.22,16.05,16.45c0.83,2.4,0.83,2.4-1.03,2.39c2.7-0.91,5.8,1.1,8.28,4.45c0.6,0.81,2.06,1.44,1.1,2.73
		c-0.68,0.91-1.76,0.4-2.65,0.08c-1.48-0.52-3.1-2.31-3.43,1.25c-0.16,1.77-2.46,1.84-4.02,1.77c-3.92-0.17-5.01,1.93-4.74,5.39
		c0.1,1.27-0.03,2.55,0.02,3.82c0.12,3.35-0.48,6.04-4.66,6.29c-2.46,0.15-3.14,2.04-2.96,4.12c0.45,5.35-0.19,10.15-5.36,13.22
		c-0.8,0.47-1.51,1.44-1.39,2.4c0.43,3.37-1.12,4.62-4.32,4.66c-1.18,0.01-1.76,1.26-2.35,2.21c-1.66,2.67-3.69,4.83-7.23,4.83
		c0.65,1.92,2.12,1.75,3.25,2.04c3.81,0.96,3.56,2.55,0.84,4.64c-6.3,6.12-14.28,9.91-21.19,15.2
		C347.77,388.72,341.25,392.96,334.89,397.41z"
        />
        <path
          class="st134"
          d="M383.71,282.42c5.33,3.99,9.26,9.33,14.12,14.13c-4.18,0.35-4.18,0.35-6.76-4.27
		c-1.62,3.71,0.27,7.31-0.49,10.83c-0.5,2.33-1.04,3.52-3.49,3.29c-0.31-0.03-0.64,0.06-0.95,0.06c-5.1,0.07-1.15,7.46-6.02,7.54
		c-5.31,0.09-5.12,3.67-5.04,7.34c0.04,1.6-0.06,3.2,0.02,4.79c0.11,2.11-0.54,3.43-2.93,3.26c-0.47-0.03-0.95,0.08-1.43,0.09
		c-5.09,0.08-1.04,7.74-6.02,7.49c-6.25-0.32-4.83,3.95-4.96,7.41c-0.05,1.28-0.12,2.57,0.01,3.83c0.31,2.99-0.67,4.63-3.95,4.19
		c-3-0.4-4.07,1.06-3.75,3.89c0.07,0.63,0.01,1.28,0.01,1.92c-0.02,9.42-0.01,9.47-9.16,11.34c-2.89,0.59-4.99,0.17-5.81-3.59
		c-0.71-3.25,0.81-6.75-1.33-9.72c0-10.23,0-20.45,0-30.68c1.79,1.91,0.86,4.26,0.89,6.4c0.03,2.42,0.47,4.72,1.03,7.04
		c0.62,2.61,2.64,1.76,4.24,1.86c1.86,0.11,2.5-1,2.46-2.71c-0.03-1.75,0.08-3.51-0.01-5.26c-0.13-2.31,0.54-3.75,3.17-3.49
		c3.23,0.32,4.83-1.05,4.52-4.4c-0.29-3.06,1.12-4.45,4.2-4.25c0.95,0.06,2.59-0.13,2.53-0.84c-0.41-4.47,5.13-6.09,4.8-10.43
		c-0.05-0.62-0.04-1.73,0.22-1.82c5.32-1.8,2.93-6.94,4.46-10.35c0.99-2.2,1.51-4.39,4.29-5.09c2.26-0.57,2.86-2.51,2.48-4.55
		c-0.77-4.07,0.95-5.2,4.75-4.74C381.01,283.07,382.63,284.17,383.71,282.42z"
        />
        <path
          class="st128"
          d="M306.06,388.79c-0.64,0.02-1.29,0.03-1.93,0.05c-4.11,0.52-7.77-1.44-11.67-2.08
		c-4.39-1.94-9.13-2.74-13.69-4.13c-2.48-0.76-4.38-1.92-4.53-4.81c1.68-11.11,6.77-20.49,14.54-28.49c0.98-1.01,2.04-2.1,3.71-1.78
		c0.89,0.11,1.36,2.06,2.24,1.04c2.59-2.98,5.71-4.19,9.59-4c1.42,0.07,1.7-1.2,1.72-2.39c0.02-1.91,0.05-3.83,0.02-5.74
		c-0.07-3.77-0.95-7.89,5.32-7.29c2.25,0.21,2.35-2.14,2.35-3.95c0-4.14,0.06-8.29-0.02-12.43c-0.05-2.76-0.17-5.27,3.23-6.46
		c1.35-0.47,2.54-1.94,2.54-3.78c3.12,2.1,6.42,4.07,5.75,8.68c-0.09,0.62,0.02,1.67-0.29,1.81c-5.86,2.72-3.1,7.96-3.42,12.15
		c-0.22,2.87-0.65,4.41-3.96,4.31c-2.97-0.09-4,1.84-3.86,4.75c0.18,3.81,0.04,7.63,0.04,11.44c2.52,4.15,1.48,8.57,0.89,12.91
		c-0.22,1.59-1.6,2.41-3.07,2.6c-3.57,0.46-4.1,2.83-4.03,5.81c0.12,5.39-0.16,10.79,0.19,16.19
		C307.83,385.26,308.14,387.38,306.06,388.79z"
        />
        <path
          class="st47"
          d="M292.48,347.56c-9.37,7.78-14.44,18.06-17.21,29.66c-0.79,11.65-3.72,23.11-3.3,34.88
		c-0.13,4.61-0.03,9.22-0.05,13.83c-0.04,3.47,0,6.93-0.05,10.4c-0.03,2.29-0.34,4.44-2.78,5.52c-0.47,0.26-0.98,0.44-1.51,0.56
		c-1.28,0.46-2.54-0.42-3.83-0.07c0,0-0.03-0.01-0.03-0.01c-8.28,1.4-8.27,1.4-8.37-7.57c-0.01-1.25-0.17-2.5-0.26-3.75
		c0.31-12.69,1.93-25.26,3.1-37.88c0.7-4.14,0.34-8.42,1.78-12.47c0.69-1.93,1.2-3.89,2.88-5.25c3.13-8.57,6.7-16.89,13.38-23.45
		c3.6-3.54,7.77-6.03,12.64-7.38C291.59,343.85,292.95,344.55,292.48,347.56z"
        />
        <path
          class="st42"
          d="M262.88,375.42c-1.55,5.9-3.11,11.81-4.66,17.72c-1.72-5.82-0.98-12.19-3.93-17.74
		c0.01-0.63,0.02-1.26,0.03-1.89c0.31-0.01,0.63-0.02,0.94-0.03C257.43,375.58,260.14,375.54,262.88,375.42z"
        />
        <path
          class="st27"
          d="M449.88,366.79c-2.59-3.86-1.99-9.18-5.76-12.49c-1.41-1.31-1.54-3.33-2.66-4.81
		c-2.17-4.92-3.56-10.12-5.3-15.19c0.19-2.17-2.3-3.59-1.66-5.89c0,0,0.01-0.08,0.01-0.08c8.82-5.61,18.32-10.08,26.87-16.16
		c0.63-0.02,1.25-0.04,1.88-0.06c2.96-0.92,6.43,0.18,8.73-3.33c1.54-2.35,4.47-3.25,7.61-2.47c1.39,0.35,2.84-0.12,3.94-1.25
		c-0.74-1.18-2.15-0.15-3.07-1c2.26-1.6,4.1-3.78,7.18-4.94c0.82,2.59,2.26,4.83-0.84,6.98c-0.61,0.42-0.45,2.08-0.51,3.17
		c-0.11,2.15,0.6,4.65-2.77,5.07c-0.87,0.11-1.1,1.12-1.03,1.93c0.34,3.66-0.74,5.94-4.96,5.53c-0.85-0.08-1.78,0.55-1.62,1.38
		c1.04,5.61-3.9,7.19-6.73,10.19c-1.6,1.69-1.69,3.08,0.93,3.6c1.64,0.33,4.17-0.35,4.29,1.92c0.12,2.43-1.92,4.75-4,5.3
		c-3.18,0.84-3.8,2.65-3.24,5.17c1.18,5.27-3.11,7.47-5.66,10.65c-0.35,0.44-1.59,0.67-1.55,0.83c0.89,4.45-3.46,6.65-4.34,10.3
		c-0.22,0.93-0.15,2.06-1.42,2.09c-1.28,0.03-1.72-1.18-1.34-2.01C454.36,367.96,451.76,367.66,449.88,366.79z"
        />
        <path
          class="st51"
          d="M455.62,384.02c1.53,5.95,1.35,6.24-5.06,6.15c-2.38-0.03-2.69,1.42-2.57,3.06c0.22,3.29-1.73,5.17-4.43,4.98
		c-3.95-0.29-5.63,2.17-6.59,4.83c-0.99,2.73-2.45,3.3-4.91,3.07c-2.63-0.24-4.33,0.66-4.31,3.67c0,0.72-0.28,1.84-0.79,2.12
		c-6.38,3.5-12.16,8.64-20.24,7.62c-1.79-1.43-4.96-0.24-6.1-3.39c5.08-0.05,8.88-3.35,13.26-4.84c4.97-1.69,7.86-3.71,7.54-9.2
		c-0.03-0.49,1.01-1.46,1.6-1.49c3.2-0.18,5.57-1.17,5.98-4.79c0.04-0.36,0.62-0.99,0.89-0.96c7.73,0.95,8.56-6.93,12.92-10.26
		c1.96-1.49,3.17-3.46,6.09-3.7c3-0.25,5.11-1.62,2.73-5.4c-1.19-1.89-1.22-4.5-1.77-6.79c3.12,3.97,3.35,9.17,5.77,13.44
		C456.15,382.76,456.21,383.39,455.62,384.02z"
        />
        <path
          class="st48"
          d="M455.62,384.02c0-0.63,0.01-1.26,0.01-1.89c3.07,0.87,3.03,3.28,2.85,5.75c-0.32,0-0.63-0.01-0.94-0.02
		C457.62,386.22,457.33,384.77,455.62,384.02z"
        />
        <path
          class="st66"
          d="M340.57,185.59c4.28,0.08,2.23-4.05,3.84-5.75c6.04-4.61,6.12-11.11,5.79-17.83
		c-0.13-2.71-0.83-4.86-3.79-5.11c-3.11-0.27-5.2-2.77-7.09-4.27c-4.4-3.47-10.26-2.73-14.4-6.52c-3.82-3.5-4.37-6.85-2.16-11.35
		c1.64-3.35,4.08-6.37,4.51-10.29c0.15-1.35,0.78-1.39,2.3-0.89c3.1,1.02,7.54-0.63,7.73,5.07c0.04,1.32,1.96,1.39,3.25,1.32
		c3.32-0.2,5.75,1.32,7.69,3.85c1.87,2.56,5.11,4.24,5.15,7.98c2.16,4.96,2.31,10.22,1.83,15.43c-0.44,4.77,2.59,8.84,2.18,13.52
		c0.65,0.95-2.08,2.62,0.67,3.13c0.93,0.56,1.93,0.87,3.03,0.81c2.16,0.21,4.49-0.46,6.31,1.32c0,0.79-0.1,1.6,0.02,2.37
		c0.63,4.07-0.81,6.04-5.14,5.32c-0.95-0.16-1.9,0.06-2.55,0.93c-1,0.64-2.13,0.37-3.21,0.41c-1.56,0.06-2.84,0.55-2.92,2.36
		c-0.07,1.78,1.15,2.42,2.68,2.66c1.23,0.2,2.51,0.27,3.44,1.28c-0.01,1.73-0.01,3.45-0.02,5.18c-0.01,1.44-0.59,2.68-2.16,2.41
		c-6.07-1.07-5.79,2.83-5.49,6.8c-3.72,0.3-6.82,0.27-7.1-4.97c-0.14-2.66-7.93-3.96-13.47-2.61c-3.52,0.86-3.53,3.59-3.37,6.39
		c0.02,0.32,0.06,0.63,0.09,0.95c0.16,1.78,2.42,4.27-1.11,4.91c-2.94,0.53-6.31,0.85-6.68-3.7c-0.15-2.58,0.52-5.26-0.96-7.67
		c1.97-2.22,1.26-5.12,1.92-7.67c5.85,1.24,11.04-1.66,16.53-2.64C339.5,188.41,339.93,186.84,340.57,185.59z"
        />
        <path
          class="st71"
          d="M352.07,141.49c0.03-1.48-0.02-3.12-1.69-3.56c-2.41-0.64-2.15-2.37-2.15-4.11c1.28,0,2.56,0,3.84,0
		c2.27,0.28,3.55,1.56,3.83,3.83c-0.02,6.72,4.34,12.61,3.79,19.38c-0.4,4.96,2.26,8.53,5.45,11.44c2.58,2.35,5.07,4.67,7.05,7.53
		c-1.6,0-3.2,0-4.79,0c-2.56,0-5.11,0-7.67,0c-3.77-7.18-4.97-14.93-4.74-22.92C355.12,148.88,354.82,144.91,352.07,141.49z"
        />
        <path
          class="st123"
          d="M359.74,191.34c-0.47,0-0.95,0.05-1.41-0.01c-2.05-0.27-4.66,0.96-5.89-1.64c-0.73-1.54-0.96-3.62,0.33-4.9
		c2.09-2.08,4.61-1.22,6.97-0.16C359.74,186.86,359.74,189.1,359.74,191.34z"
        />
        <path
          class="st123"
          d="M321.4,191.34c0.84,2.93,2.85,6.15-1.92,7.67C316.1,195.07,316.78,192.36,321.4,191.34z"
        />
        <path
          class="st84"
          d="M383.15,256.69c1.98-1.26,3.13-1.36,4.48-0.7C386.34,257.01,384.95,256.28,383.15,256.69z"
        />
        <path
          class="st3"
          d="M375.11,368.81c0.77-1.63,3.13-3.78-1.42-3.37c-1.28,0.11-2.68-0.86-3.99-1.42c-0.99-0.42-1.46-1.23-1.06-2.31
		c0.31-0.85,0.95-1.24,1.87-1c4.2,1.1,5.51-2.07,7.15-4.8c1.01-1.69,1.62-4.13,4.5-2.06c0.94,0.68,2.35-0.45,1.83-1.14
		c-3.34-4.48,1.68-6.19,3.33-7.24c2.95-1.87,3.19-3.92,3.1-6.68c-0.06-1.75,0.06-3.51-0.02-5.26c-0.12-2.72,0.88-4.41,3.83-4.11
		c3.36,0.35,4.18-1.35,3.87-4.26c-0.11-1.1-0.02-2.23-0.02-3.34c0-6.91,0-6.96,6.89-7.76c4.76-0.55,1.82-3.06,1.13-5.62
		c2.7,1.24,4.99,2.3,7.28,3.36c-2.23-3.08-3.73-7.28-9-5.48c-0.81,0.28-1.93,0.02-2.79-0.29c-1.16-0.42-1.85-1.45-1.23-2.65
		c0.55-1.06,1.53-0.65,2.49-0.28c1,0.38,2.75,3.48,2.9-0.58c0.63,0.01,1.27,0.03,1.9,0.04c3.88,4.13,7.12,8.96,12.47,11.49
		c3.35,4.22,7.21,7.95,11.35,11.38c1.02,0.85,2.01,1.5,2.06,2.93c0.33,0.22,0.44,0.43,0.31,0.62c-0.12,0.19-0.24,0.28-0.37,0.28
		c-11.91,7.35-23.08,15.78-34.61,23.69C391.03,358.34,383.04,363.53,375.11,368.81z"
        />
        <path
          class="st49"
          d="M433.49,329.26c0-0.3,0.02-0.6,0.06-0.9c0.32,0.02,0.64,0.04,0.95,0.06c0.84,1.86,2.15,3.55,1.94,5.76
		c0.54,0.65,0.55,1.29-0.01,1.93C435.45,333.83,434.47,331.54,433.49,329.26z"
        />
        <path
          class="st92"
          d="M306.06,388.79c0-7.72,0.14-15.45-0.07-23.17c-0.1-3.73,0.3-6.31,4.98-5.6c2.05,0.31,2.78-0.94,2.76-2.89
		c-0.05-3.81-0.01-7.63-0.01-11.45c1.28-0.7,2.64-1.1,4.12-0.96c2.24,0.21,3.52-0.38,3.66-3.04c0.13-2.42,1.93-4.17,4.28-4.5
		c3.11-0.44,3.45-2.35,3.27-4.77c-0.5-6.72,2.8-13.02,2.09-19.81c-0.17-1.64,1.48-3.06,2.71-4.31c0,1.92,0,3.84,0,5.76
		c-1.3,2.77,0.3,5.85-0.95,8.62c-0.53,0.3-1.53,0.6-1.52,0.89c0.03,5.55-2,11.01-1.08,16.54c1.01,6.06,1.33,11.93-1.13,17.76
		c-0.45,1.07-0.75,2.03-1.79,2.62c-3.35,1.87-4.16,4.93-4.08,8.49c0.08,3.3-0.8,6.07-4.72,6.45c-1.57,0.15-2.17,1.21-2.61,2.42
		c-0.32,0.89-0.15,2.04-0.65,2.76c-2.49,3.6-4.26,7.15-0.64,11.06C311.71,390.97,308.67,390.53,306.06,388.79z"
        />
        <path
          class="st11"
          d="M266.76,450.2c0.88,6.08,3.25,11.92,2.86,18.2c-0.32-0.32-0.64-0.64-0.95-0.96
		C266.11,461.91,266.83,456.01,266.76,450.2z"
        />
        <path
          class="st11"
          d="M263.77,442.34c0.83-0.83,1.86-0.87,2.93-0.74c0.71,1.26-0.07,2.06-0.88,2.85c0.31,1.91,0.61,3.82,0.92,5.73
		C263.78,448.31,265.93,444.51,263.77,442.34z"
        />
        <path
          class="st91"
          d="M246.74,377.35c2.6-0.32,4.59-2.98,7.54-1.94c-2.47,6.29-4.6,12.7-6.38,20.41
		C245.75,389.01,246.91,383.14,246.74,377.35z"
        />
        <path
          class="st131"
          d="M390.4,501.91c-0.01-0.31-0.01-0.61-0.01-0.92l0.02-0.02c0.31-0.01,0.62-0.01,0.93,0.01
		c2.92,1.03,4-1.62,5.77-2.89l-0.01,0.01c1.83-1.42,3.89-2.5,5.76-3.86c6.25-5.75,14-9.25,21.08-13.72
		c8.57-5.41,16.76-11.46,25.89-15.96c5.65-2.34,10.08-6.64,15.36-9.59c4.3-3.68,9.31-6.2,14.31-8.73c1.3,4.38,3.29,8.62,2.83,13.37
		c-0.4,1.19-1.29,1.88-2.49,1.91c-2.94,0.07-4.61,1.88-6.02,4.13c-1.08,1.72-2.56,3.17-4.62,2.94c-7.02-0.79-11.65,4.37-17.35,6.81
		c-3.05,1.3-5.9,3.19-7.53,6.39c-0.6,1.19-1.78,1.84-3.08,2.1c-2.14,0.43-3.4,1.58-3.57,3.84c-0.21,2.73-1.94,3.82-4.46,4.07
		c-0.95,0.09-2.37,0.13-2.61,0.92c-1.51,4.94-6.28,5.55-9.77,7.96c-3.04,2.1-6,3.56-9.63,3.58c-2.74,0.02-3.88,1.25-4.17,4.04
		c-0.58,5.52-1.68,6.34-7.32,6.51c-1.44,0.04-2.87-0.01-4.31,0.05c-0.96,0.04-2.59,0.14-2.62,0.76c-0.36,6.73-9,7.09-10.02,13.22
		c-3.37,0.29-8.01-1.7-8.12,4.49c-5.3-1.44-6.5,6.45-11.79,5.17c-1.02-0.25-2.22-0.09-3.27,0.17c-1.54,0.37-1.3,1.51-0.78,2.61
		c-1.78-0.01-2.81-1.3-4.02-2.28c0.53-0.98,2.31-0.46,2.3-2.5c-5.64,1.87-6.72-3.97-10.27-5.75c1.19-3.72,3.64,0.37,5.55-1.09
		c5.76-4.38,12.46-5.51,19.58-4.7c1.12,0.13,3.01,0.42,2.8-1.53c-0.2-1.84-1.86-1.27-3.06-0.96c-1.05,0.26-2.24,1.08-2.95-0.28
		c-0.74-1.42,0.43-2.95,1.32-3.24c4.84-1.54,5.36-7.5,9.83-9.29c1.61-2.89,4.9-3.46,7.39-5.05
		C388.5,503.78,389.28,502.69,390.4,501.91z"
        />
        <path
          class="st135"
          d="M390.4,501.91c0.05,2.08,1.11,4.2-3.1,3.55c-2.21-0.34-4.94,2.67-7.43,4.17c-0.65,0-1.29-0.01-1.94-0.01
		C381.65,506.33,386.04,504.15,390.4,501.91z"
        />
        <path
          class="st47"
          d="M122.25,451.24c1.03,0.06,1.89-0.31,2.63-1c1.19-1.43,3.01-1.76,4.53-2.61c0.4-0.19,0.82-0.35,1.24-0.49
		c2.58-0.79,5.15-1.57,7.64-2.63c1.37-0.56,2.76-1.02,4.27-0.6c19.23,10.09,30.02,25.6,30.53,47.66c0.08,3.65,0.24,7.32-0.55,10.96
		c-5.7,26.36-34.34,36.02-54.31,17.79c-15.04-13.72-20.86-31.24-17.44-51.54c0.26-1.57,0.62-3.15,1.96-4.24
		c0.36-0.93,0.73-1.86,1.09-2.79c0,0,0,0.04,0,0.04c0.91-1.64,2.1-2.09,3.7-0.9l-0.06-0.02c1.53,0.26,3.1,0.38,4.47,1.22
		c2.51,1.58,5.65,2.13,7.61,4.62c0.55,3-1.23,5.58-1.52,8.44c-1.79,12.89,2.68,23.42,12.4,31.72c4.46,3.8,9.7,4.41,15.21,1.94
		c5.8-2.6,8.69-7.22,9.46-13.31c0.44-3.49,0.12-6.98-0.68-10.42c-0.12-3.3-1.35-6.28-2.61-9.25c-1.13-3.74-4.49-5.74-6.77-8.58
		c-0.72-0.66-1.16-1.78-2.5-1.49c-0.25,1.5,0.94,2.47,1.28,3.74c0.55,1.51,1.06,3.02,1.58,4.54c0.8,3.47,3.65,6.54,2.04,10.48
		c-0.55,0.88-1.39,1.36-2.3,1.78c-2,0.78-4.07,1.38-6.08,2.15c-3.73,1.57-6.18,0.46-7.3-3.46c-0.62-2.05-1.89-3.85-2.3-5.98
		c-1.48-6.45-4.27-12.46-6.43-18.67c-0.48-0.87-0.89-1.76-1.18-2.71C121.62,455.48,119.89,453.23,122.25,451.24z"
        />
        <path
          class="st95"
          d="M102.76,464.55c-3.81,17.85-0.79,34.3,10.54,48.79c7.54,9.64,17.21,15.86,29.98,14.91
		c15.81-1.17,27.32-13.52,28.57-30.25c1.66-22.14-7.27-38.99-25.83-50.92c-1.34-0.86-2.68-1.73-4.02-2.59
		c1.11-2.3,2.85-1.8,4.82-1.3c4.89,1.22,7.73,5.3,11.59,7.95c0.32,0,0.63,0.01,0.95,0.01c5.78,8.18,11.88,16.31,14.39,26.14
		c3.5,13.71,3.77,27.53-4.45,39.84c-8.19,12.26-25.34,18.02-39.44,13.34c-6.75-2.24-12.36-6.69-17.18-12.24
		c-6.82-7.85-11.61-16.83-13.88-26.71c-1.85-8.06-2.3-16.62,0.9-24.78C100.29,465.25,100.34,463.35,102.76,464.55z"
        />
        <path
          class="st137"
          d="M158.42,451.15c-3.68-0.82-5.71-4.23-9-5.71c-2.42-1.09-4.67-2.71-7.41-0.94c-1.14,0.34-2.29,0.67-3.43,1.01
		c-2.7,0.8-6.23-0.81-7.97,2.77l-0.22,0.24l-0.31-0.1c-1.75,0.21-3.38,1.15-5.22,0.82c-1.33-0.11-1.56-0.54-0.72-1.7
		c2.34-3.24,6.24-3.98,9.35-5.97C144.21,438.49,152.18,442.55,158.42,451.15z"
        />
        <path
          class="st153"
          d="M138.29,431.97c-0.32-0.64-0.64-1.27-0.96-1.91c2.65-1.34,5.21-0.19,7.71,0.46c1.38,0.36,2.69,0.69,4.1,0.54
		c1.76,0.61,2.94-1.23,4.59-1.12c0.21,0.24,0.29,0.49,0.27,0.75c-0.03,0.27-0.07,0.41-0.13,0.41c-0.38,1.45,0.35,3.53-2.16,3.75
		c-3.43,1.46-6.61,1.69-9.58-1.23C141.2,432.71,139.59,432.5,138.29,431.97z"
        />
        <path
          class="st101"
          d="M145,383.08c-1.64,1.58-1.58,4.48-4.39,5.27c-1.34,0.37-1.27,1.65-0.13,2.61c0.85,0.71,1.55,1.79,2.52,2.15
		c6.98,2.54,10.63,9.44,16.97,12.8c2,1.06,3.37,2.47,2.29,4.98c-0.56,0.4-0.95,0.99-0.56,1.58c3.57,5.28,2.85,10.93,1.51,16.64
		c-0.88,0.75-1.07,2.55-2.87,1.92l0,0c3.8-9.25,2.85-16.22-2.87-21.09c-5.02-4.45-9.2-9.94-15.73-12.49
		c-1.53-0.67-3.03-1.38-4.18-2.64c-0.85-1.03-1.25-2.23-1.36-3.54C136.95,384.11,139.21,382.03,145,383.08z"
        />
        <path
          class="st113"
          d="M153.86,431.1c-0.13-0.44-0.25-0.88-0.38-1.32c-0.2-0.4-0.3-0.83-0.28-1.28c0.78-2.98-1.1-6.68,2.85-8.93
		c0.85-0.48-0.52-3.16-0.6-4.88c-0.03-0.99,0.11-1.92,0.71-2.74c0.4-0.41,0.84-0.44,1.3-0.11c3.19,4.43,3.48,9.15,2.2,14.41
		C158.82,429.67,157.27,431.24,153.86,431.1z"
        />
        <path
          class="st73"
          d="M157.46,411.84c-0.32,0-0.64,0-0.96-0.01c-2.61-0.75-3.22-3.35-4.73-5.11c-1.07-1.63-2.31-3.03-4.35-3.44
		c-1.35-0.34-2.42-1.08-3.22-2.22c-0.72-1.51-2.75-2.43-2.09-4.57c6.51,2.88,11.91,7.02,15.34,13.42
		C157.46,410.56,157.46,411.2,157.46,411.84z"
        />
        <path
          class="st102"
          d="M138.28,349.52c4.55,0.38,6.67-3.79,10-5.66c1.33-0.74-0.46-2.73-1.86-3.99
		c-5.23-4.71-12.41-6.01-17.73-10.49c0.53-0.61,1.22-0.85,2-0.91c6.75,1.96,12.66,5.8,18.97,8.72c3.42,1.58,6.7,2.8,10.47,2.42
		c1.88,0.25,3.76-0.7,5.65-0.06c0.72,4.62-3.43,5.45-5.89,7.61c-0.84,0.44-1.69,0.82-2.62,1.01c-0.47,0.05-0.93,0.02-1.39-0.08
		c-2.85-1.41-5.83-0.81-8.26,0.51c-7.94,4.33-16.5,7.24-24.51,11.39c-3.92,2.03-8.09,3.54-12.4,4.6c-0.47-0.11-0.86-0.35-1.19-0.7
		c2.46-3.16,6.22-4.5,9.66-5.6C125.96,356.13,131.55,351.61,138.28,349.52z"
        />
        <path
          class="st89"
          d="M131.58,426.2c-7.8-4.86-15.82-9.39-23.32-14.67c-5.98-4.22-12.61-7.81-16.96-14.07
		c-0.38-1.68,0.93-1.9,2-2.34c2.09-0.02,3.51,1.12,4.66,2.72c5.6,6.23,12.86,10.29,19.62,15c4.94,3.43,10.74,5.52,15.14,9.8
		c0.78,0.76,1.96,1.16,1.93,2.52C133.89,426.3,132.71,426.17,131.58,426.2z"
        />
        <path
          class="st136"
          d="M93.24,395.5c-0.65,0.65-1.29,1.31-1.94,1.96c-4.63-3.97-5.63-16.12-1.69-20.81
		c5.31-6.31,11.65-11.03,19.91-12.75c0.32,0,0.64,0,0.96,0c0.19,3.4-3.2,3.08-4.79,4.62c-1.78,1.13-3.16,2.7-4.62,4.19
		c-1.89,0.26-2.63,1.96-3.84,3.08c-6.17,4.02-4.5,10.25-4.5,16C92.74,393.05,93.69,394.18,93.24,395.5z"
        />
        <path
          class="st116"
          d="M131.58,426.2c0.7-1.12,1.83-0.91,2.88-0.95c1.04-0.99,2.22-0.54,2.83,0.24c1.26,1.61,2.28,0.67,3.42,0.03
		c3.63,1.28,7.29,2.52,8.99,6.48c-4.35,0.81-8.2-1.59-12.37-1.94C135.22,429.06,133.23,427.89,131.58,426.2z"
        />
        <path
          class="st98"
          d="M111.23,462.73c-1.25-0.62-2.49-1.23-3.74-1.85c5.09-2.96,10.38-5.59,14.76-9.64
		c-1.28,2.33,1.49,4.28,0.61,6.57C119.02,459.55,116.41,464.18,111.23,462.73z"
        />
        <path
          class="st134"
          d="M124.86,449.23c1.63-0.96,3.38-1.15,5.22-0.82c-1.53,1.17-3.27,1.76-5.2,1.83
		C124.87,449.91,124.87,449.57,124.86,449.23z"
        />
        <path
          class="st98"
          d="M107.54,460.9c-1.37-0.25-2.74-0.53-3.7,0.9C104.44,458.87,105.83,459.21,107.54,460.9z"
        />
        <path
          class="st72"
          d="M160.34,431.02c0.96-0.64,1.92-1.28,2.87-1.92c-0.41,1.69-0.62,3.46-1.92,4.8
		C160.97,432.93,160.66,431.97,160.34,431.02z"
        />
        <path
          class="st64"
          d="M169.92,196.13c2.55-1.5,3.01-4.54,5.14-6.58c7.96-7.58,16.81-5.14,25.81-3.36
		c11.8,2.33,22.83,7.24,34.43,10.32c6,1.59,12.45,3.74,17.65,7.74c1.85,1.42,4.82,3.26,1.82,6.4c-1.93,0.08-3.48-0.6-4.55-2.24
		c0.4-1.05,0.53-1.81-0.65-2.75c-2.74-2.18-5.91-2.97-9.22-3.54c-1.19-0.19-2.3-0.57-3.31-1.22c-14.56-4.88-28.79-10.76-44.08-13.39
		c-10.31-1.77-21.09,6.53-20.77,16.93c0.37,12.21,4.97,23.48,8.19,35.05c2.48,2.77,2.15,6.37,2.88,9.66
		c0.33,2.76,0.81,5.47,2.43,7.84c0.24,0.44,0.4,0.9,0.52,1.38c0.28,2.03,0.58,4.06-0.75,5.88c-0.5,0.26-0.98,0.22-1.43-0.11
		c-2.71-6.78-3.71-14.01-5.47-21.04c-2.01-4.33-4.07-8.65-3.86-13.62c0.03-0.62,0.06-1.39-0.25-1.87
		c-5.76-8.88-4.31-18.88-4.52-28.62C169.9,198.05,169.92,197.09,169.92,196.13z"
        />
        <path
          class="st68"
          d="M178.55,243.11c2.72,6.81,4.35,13.92,5.75,21.09c-0.37,0.85-0.86,1.47-1.91,0.96c0,0,0,0,0,0
		c-0.1-5.83-3.01-11.11-3.35-16.93C178.94,246.55,178.59,244.83,178.55,243.11z"
        />
        <path
          class="st63"
          d="M182.39,265.16c0.64-0.32,1.28-0.64,1.91-0.96c0.32,0,0.64,0,0.96,0c2.28,4.45,0.23,7.73-4.79,7.67
		c-0.64,0-1.28,0-1.92,0C179.14,269.24,182.08,267.95,182.39,265.16z"
        />
        <path
          class="st63"
          d="M178.55,271.87c-2.05,1.29-4.35,1.72-6.71,1.91C173.4,270.79,176.23,272.21,178.55,271.87z"
        />
        <path
          class="st79"
          d="M673.24,372.53c-0.32,0-0.64,0-0.96,0c-1.92-5.19-0.97-10.58-0.73-15.84c0.13-2.84,4.82-3.59,4.57-7.17
		c-0.49-2.54,1.69-3.34,3.05-4.68c1.52-0.77,1.69-2.44,2.49-3.7c0.99-1.27,2.35-2.16,3.48-3.27c3.95-3.87,3.14-7.82-2.27-9.19
		c-4.49-1.14-8.72-3.02-13.29-3.91c-9.15-1.8-13.06-8.96-16.24-16.69c-0.54-1.32-0.8-2.76-1.18-4.15c-0.41-2.3-0.49-4.61-0.03-6.91
		c0.31-1.06,0.88-1.91,1.92-2.37c4.03,1.22,2.59,5.05,3.69,7.68c0.18,4.73,2.23,8.73,4.89,12.48c0.81,1.97,2.65,2.57,4.36,3.46
		c7.41,3.86,15.6,5.39,23.43,8.01c4.98,1.67,6.12,4.64,3.25,9.11c-2.86,4.46-6.45,8.31-10.27,11.96c-1.96,1.87-3.74,3.86-5.14,6.26
		c-2.62,4.51-4.5,9.09-3.84,14.46C674.62,369.61,674.59,371.31,673.24,372.53z"
        />
        <path
          class="st105"
          d="M653.11,304.47c2.33,4.97,4.04,10.13,7.96,14.39c4.86,5.29,11.8,4.86,17.51,7.64c0.13,0.06,0.32,0,0.47,0.02
		c4.24,0.4,8.91,1.2,10.08,5.69c1.01,3.89-2.75,6.35-5.7,8.56c-0.51,0.38-1.04,0.73-1.55,1.09c-0.73,1.23-0.9,2.75-1.92,3.83
		c-1.63,0.92-2.91,2.2-3.83,3.83c-1.76,0.69-2.23,3.53-4.8,2.87c-0.59-4.9,4.46-5.52,6.6-8.35c1.74-2.3,3.07-5.02,5.8-6.87
		c2.09-1.42-0.41-3.32-1.73-4.91c-4.63-5.56-11.57-5.71-17.64-7.85c-7.69-2.71-11.62-7.83-12.2-16.12
		C651.82,306.86,651.89,305.52,653.11,304.47z"
        />
        <path
          class="st105"
          d="M669.4,372.54c-1.78-1.91-0.94-4.27-0.88-6.39c0.09-3.38-0.5-6.63-1.03-9.91c0.03-1.88,1.65-2.18,2.87-2.88
		C668.55,359.67,669.76,366.14,669.4,372.54z"
        />
        <path
          class="st104"
          d="M673.24,415.67c-4.59-7.33-1.7-20.03,6.71-23.01C672.14,398.71,672.87,407.24,673.24,415.67z"
        />
        <path
          class="st137"
          d="M689.54,422.39c1.19,1.62,4.11,0.37,4.79,2.86c-4.23,0.69-7.47-1.34-10.55-3.83c0.64-0.62,1.28-0.54,1.92,0
		C686.98,421.75,688.26,422.07,689.54,422.39z"
        />
        <path
          class="st144"
          d="M685.7,421.43c-0.64,0-1.28,0-1.92,0c-2.31,0.23-3.79-0.93-4.79-2.88c0.32-0.64,0.64-1.28,0.96-1.91
		c0.37-0.32,0.69-0.27,0.95,0.14C680.81,420.07,685.03,418.92,685.7,421.43z"
        />
        <path
          class="st47"
          d="M732.77,373.51c0.14-2.22,1.02-3.36,3.53-3.14c3.46,0.3,6.95,0.27,10.42,0.38c1.78,4.79,2.24,9.85,1.54,14.76
		c-1.27,8.86-0.35,17.74-0.9,26.59c-0.03,0.59-0.12,1.18-0.25,1.76c-1.34,6.88-0.3,13.84-0.62,20.75
		c-0.91,4.97-0.67,10.19-3.21,14.82c-1.71,0.25-3.41,0.85-5.13,0.09c-0.7-0.87-1.69-0.74-2.64-0.78c-5.34-0.23-5.89-0.6-6.01-5.95
		c-0.15-6.7-0.23-13.42-0.06-20.11c0.32-2.46-0.55-3.86-3.26-3.81c-2.02,0.04-4.04,0.05-6.06,0.07
		c-13.01-1.75-26.31,0.42-39.17-3.04c-1.87-4.22-1.31-8.69-1.31-13.1c0.31-1.74,0.4-3.62,2.55-4.25l0.37,0.05
		c7.96-0.5,15.91-1.06,23.89-0.3c6.89,1.42,13.83,0.64,20.76,0.51c3.12-0.06,3.82-2.32,4.01-4.87c0.33-4.58,0.05-9.16,0.15-13.74
		c0.01-1.06,0.03-2.12,0.07-3.17c0.01-0.78,0.13-1.55,0.39-2.29C732.05,374.24,732.37,373.84,732.77,373.51z"
        />
        <path
          class="st1"
          d="M732.73,376.36c-0.01,0.96-0.02,1.92-0.03,2.88c-1.1,2.57-0.38,5.27-0.49,7.9
		c-0.29,6.91-6.32,12.76-13.4,12.67c-4.09-0.05-8.2,0.42-12.27-0.32c-8-0.07-16.02,0.25-23.98-0.92c0.64-0.13,1.29-0.25,1.94-0.38
		c5.06-1.05,9.92-3.05,15.2-3.01c5.26,0.04,10.51,0.06,15.77-0.01c7.26-0.09,10.24-2.35,12.49-9.34c0.64-1.97,0.96-4.02,1.62-5.98
		C730.1,378.26,730.31,376.28,732.73,376.36z"
        />
        <path
          class="st128"
          d="M732.73,376.36c-2.46,2.07-2.13,5.19-2.91,7.87c-2.65,9.13-5.92,12.75-15.68,12.32
		c-5.58-0.24-11.19-0.35-16.75,0.05c-4.3,0.31-8.38,2.71-12.9,1.59c-0.55-0.56-1.1-1.12-1.65-1.67c0.65-0.49,1.4-0.77,2.2-0.9
		c8.53-2.39,17.17-1.7,25.9-1.53c12.5,0.24,12.98-1.39,16.38-13.23c0.48-1.67,0.65-3.42,1.62-4.92c0.91-1.41,1.92-2.63,3.83-1.49
		C732.75,375.09,732.74,375.72,732.73,376.36z"
        />
        <path
          class="st143"
          d="M732.77,374.45c-3.14,0.34-3.51,2.77-3.92,5.18c-0.53,3.15-1.85,6.02-2.97,8.99
		c-2.15,5.68-6.66,6.67-11.79,6.91c-0.48,0.02-0.96,0.04-1.44,0c-9.34-0.8-18.68-1.55-27.9,0.97c-0.29-2.52,2.32-0.67,2.88-1.92
		c0.32,0,0.63,0,0.95,0c5.59-2.66,11.57-1.5,17.31-1.25c5.27,0.23,10.3-0.03,15.3-1.62c1.34-1.37,2.86-2.63,2.88-4.79
		c2.21-5,2.05-10.89,5.75-15.34c1.51-0.15,1.91,1.41,2.97,1.94C732.77,373.82,732.77,374.14,732.77,374.45z"
        />
        <path
          class="st143"
          d="M682.17,398.52c-1.53,0.84-1.06,2.44-1.4,3.73c-1.69,3.73,1,7.86-1.06,11.55c-0.61,0.22-0.88,1.73-1.71,0.77
		c-1.91-2.18-1.07-13.28,1.1-15.16C679.91,398.71,680.99,398.29,682.17,398.52z"
        />
        <path
          class="st143"
          d="M721.17,391.71c-4.47,2.16-8.82,3.16-14.09,2.23c-6.02-1.06-12.38-0.81-18.51,0.64
		c1.22-1.44,2.84-1.9,4.66-1.91C702.55,392.58,711.9,393.12,721.17,391.71z"
        />
        <path
          class="st88"
          d="M679.71,413.8c1.5-3.75-2.16-7.96,1.06-11.55c0.04,4.5,0.08,8.99,0.12,13.49c0.35,0.19,0.46,0.38,0.36,0.59
		c-0.11,0.21-0.21,0.31-0.33,0.31c0,0-0.03,0.14-0.03,0.14c-0.31-0.08-0.63-0.13-0.95-0.14
		C679.87,415.69,679.79,414.75,679.71,413.8z"
        />
        <path
          class="st143"
          d="M687.62,394.58c-0.96,0.64-1.92,1.28-2.88,1.92c-0.64,0.01-1.27,0.01-1.91,0.02
		C683.77,394.25,685.77,394.6,687.62,394.58z"
        />
        <path
          class="st98"
          d="M673.24,372.53c-1.67-12.03,3.25-21.27,12.11-28.9c3.28-2.83,5.69-6.42,8.04-10.01
		c2.05-3.13,0.65-5.18-2.57-6.07c-8.66-2.39-17.33-4.7-25.49-8.58c-1.87-0.89-3.38-1.73-3.59-3.95c1.53-1.12,2.69-0.06,3.89,0.67
		c5.08,3.12,10.57,5.06,16.45,6.09c4.24,0.74,8.4,1.97,12.27,3.91c4.19,2.1,5.03,4.98,2.6,9.01c-2.92,4.84-7.49,8.23-11.3,12.28
		c-4.08,4.33-7.81,8.85-8.97,14.92c0.65,4.03-0.4,8.67,4.13,11.29c1.02,0.67,1.43,1.63,1.33,2.83c-0.14,0.17-0.29,0.33-0.44,0.5
		c-1.08,0.73-0.67,2.93-2.69,2.72C676.67,377.35,674.23,375.56,673.24,372.53z"
        />
        <path
          class="st143"
          d="M735.55,334.18c-2.53,4.86-6.11,8.99-9.74,12.99c-5.51,6.07-11.39,11.81-17.11,17.69
		c-1.97,1.23-3.56,2.83-4.8,4.79c-1.94,1.26-3.54,2.85-4.79,4.8c-0.32,0.32-0.64,0.64-0.96,0.96c-0.75,0.61-1.7,0.49-2.56,0.73
		c-0.45-0.05-0.87-0.2-1.25-0.46c-0.44-0.64-0.3-1.26,0.03-1.88c0.24-0.36,0.54-0.68,0.87-0.96c1.22-0.8,2.34-1.71,3.13-2.98
		c0.9-1.27,2.16-2.08,3.47-2.84c3.86-2.62,6.95-6.02,9.84-9.62c6.39-7.3,13.66-13.77,19.88-21.24
		C732.52,335.03,733.6,333.57,735.55,334.18z"
        />
        <path
          class="st98"
          d="M694.33,375.41c0.32,0,0.64,0,0.96,0c0.4,2.29-1.76,2.67-2.88,3.83c-2.75,0.45-5.44,0.77-8.28,0.1
		c-1.83-0.43-2.29-1.32-2.45-2.83c0,0,0.25-0.21,0.25-0.21c1.37-0.24,2.64,0.61,4.01,0.33C688.99,377.9,691.38,374.7,694.33,375.41z
		"
        />
        <path
          class="st137"
          d="M699.12,374.45c0.54-2.66,2.14-4.25,4.79-4.8C702.7,371.63,701.1,373.23,699.12,374.45z"
        />
        <path
          class="st137"
          d="M692.41,379.24c0.96-1.28,1.92-2.55,2.88-3.83c0.96,0,1.91-0.01,2.87-0.01
		C696.27,376.72,694.98,378.94,692.41,379.24z"
        />
        <path
          class="st154"
          d="M700.08,256.53c-3.53,3.86-8.37,3.3-12.89,3.85c-1.79,0.21-3.79-0.7-5.32,0.95
		c-5.3,2.74-9.36,7.2-14.26,10.53c-2.55,1.73-1.94,6.35-3,9.6c-0.75,0.62-0.27,2.32-1.9,2.18c-0.86-0.35-1.32-1.02-1.5-1.9
		c0.14-1.18,0.16-2.36-0.04-3.55c1.22-4.21,3.38-7.86,6.5-10.95c0.34-0.29,0.72-0.5,1.13-0.66c3.32-1.21,6.76-2.28,7.65-6.39
		c0.21-0.65,0.58-1.2,1.04-1.69c3.58-2.82,7.41-4.81,12.18-3.61c2.06,0.82,4.14,1.3,6.34,0.57
		C697.5,255.32,698.93,255.36,700.08,256.53z"
        />
        <path
          class="st116"
          d="M662.69,283.37c0.64-0.64,1.28-1.28,1.92-1.92c0.95,2.24-2.28,6.27,2.87,6.71
		c-1.27,0.96-2.55,1.91-3.82,2.87c0.07,1.85-1.19,2.99-2.25,4.24c-0.69,0.74-1.24,1.58-1.71,2.49c-1.42,1.31-1.56,3.35-2.77,4.78
		c-1.96-2.18,0.02-5.83-2.86-7.67c-0.93-0.26-1.35-0.94-1.52-1.83c0.11-1.23-0.04-2.51,0.61-3.66
		C656.15,287.09,659.13,284.78,662.69,283.37z"
        />
        <path
          class="st129"
          d="M735.55,334.18c-7.67,7.99-15.34,15.98-23.01,23.97c-2.39,1.5-3.98,3.88-6.18,5.55
		c-1.09,0.83-1.68,2.82-3.69,2.06c-0.59-0.82-0.6-1.71-0.31-2.63c3.63-3.75,6.73-8,10.67-11.47c6.35-3.86,10.25-10.33,15.86-14.99
		c1.73-1.44,1.54-3.75,2.05-5.72c3.97-3.94,2.48-8.31,1.03-12.69c-0.64-1.95-1.15-3.94-1.89-5.85c-1.4-2.03-3.21-3.23-5.63-4.05
		c-16.71-5.67-34.1-8.27-51.28-11.86c-2.15-0.45-4.1-0.06-5.99,0.96c-1.91,0.28-3.41-0.23-4.15-2.17c-0.21-2.19,0.79-3.16,2.97-3.09
		c3.38,0.1,6.78-0.03,10.12,0.76l0,0c2.4,1.25,5.35,0.34,7.67,1.91c2.87,0.64,5.75,1.29,8.62,1.93c11.8,2.02,23.54,4.23,34.77,8.56
		c3.37,1.3,6.13,3.21,7.41,6.77c0.32,0.32,0.64,0.64,0.96,0.96c4.13,5.56,4.13,14.84,0.01,20.15
		C735.57,333.56,735.56,333.87,735.55,334.18z"
        />
        <path
          class="st155"
          d="M734.6,312.13c-5.62-7.18-14.3-8.01-22.13-10.49c-6.55-2.07-13.57-2.38-20.06-4.84
		c6.37-0.93,12.17,1.78,18.22,2.87c6.35,1.64,13.06,2.12,18.83,5.64C732.01,306.87,734.7,308.49,734.6,312.13z"
        />
        <path
          class="st155"
          d="M735.57,333.24c3.1-6.72,2.68-13.43-0.01-20.15c3.96,2.8,5.24,8.49,3.36,15.21
		c-0.38,1.35-0.96,2.64-1.45,3.96C737.06,333.03,736.35,333.21,735.57,333.24z"
        />
        <path
          class="st155"
          d="M676.11,292.96c-3.1,0-6.21,0.07-9.3-0.02c-2.06-0.06-3.34,0.51-3.16,2.83c-1.43,0.98-2.31,0.41-2.88-1.03
		c0.96-1.23,1.93-2.47,2.89-3.7C667.83,291.58,672.15,291.08,676.11,292.96z"
        />
        <path
          class="st155"
          d="M683.79,294.87c-2.74,0.09-5.42-0.05-7.67-1.91C678.71,293.44,681.88,291.62,683.79,294.87z"
        />
        <path
          class="st72"
          d="M413.41,101.17c0.22,0.87,2.52,0.21,1.42,2.16c-0.98,1.74-1.59,3.7-2.36,5.57
		c-3.92,7.54-10.22,13.28-15.11,20.09c-2.42,3.37-2.94,7.55-2.67,11.32c0.49,6.88-1.04,13.51-1.39,20.27
		c-0.08,1.46,0.05,4.37-3.18,2.82c-0.25-4.26-0.51-8.53-0.76-12.79c0.14-5.03-0.42-10.08-0.07-15.09c0.29-4.05,2.24-7.55,4.94-10.58
		c1.26-1.42,2.62-2.77,2.79-4.81C402.08,113.45,407.64,107.22,413.41,101.17z"
        />
        <path
          class="st64"
          d="M374.49,165.31c-0.47-0.05-1.29,0.03-1.35-0.15c-1.57-4.67-5.18-8.18-6.05-13.5
		c-1.34-8.16-3.78-16.37-11.19-21.68c-7.93-3.64-13.29-10.2-18.83-16.55c-1.13-1.3-1.3-2.56,0.58-3.41
		c4.36,2.91,8.83,5.68,12.48,9.52c1.81,2.08,3.81,3.89,6.52,4.72c0.69,0.38,1.38,0.75,2.06,1.13c0.55,1.55,1.68,2.33,3.28,2.5
		c1.42,0.51,2.66,1.19,2.75,2.94c3.58,5.94,4.81,12.68,6.66,19.22l-0.04-0.08c0.97,2.53-0.38,5.31,0.84,7.82
		C373.71,160.07,371.94,163.35,374.49,165.31z"
        />
        <path
          class="st61"
          d="M390.12,163.39c2.09,0.09,2.12-1.33,2.24-2.87c0.59-8.03,1.88-16.08,1.69-24.08
		c-0.16-6.55,4.49-10.01,7.35-14.5c3.03-4.77,7.33-8.73,11.08-13.04c-1.33,2.09-0.87,4.44-0.97,6.7
		c-5.46,5.03-11.15,9.9-14.32,16.82c-1.37,2.98-1.8,6.21-1.37,9.62c0.53,4.23,1.2,8.57-0.94,12.64c-0.63,1.19-0.5,2.39-0.33,3.7
		c0.52,3.96-2.2,7.7-6.12,7.96c-4.17,0.27-7.97,4.49-12.46,1.17c-0.48-1.82,2.04-0.43,1.97-1.9c-1.08-0.09-2.17-0.18-3.27-0.27
		C379.73,163.98,384.95,163.9,390.12,163.39z"
        />
        <path
          class="st78"
          d="M358.78,103.14c2.91,1.87,5.65,4.09,8.75,5.55c6.86,3.23,15.69,0.65,20.56-6c1.25-1.71,2.84-2.89,4.25-4.35
		c1.1-0.58,1.47,0.32,1.97,0.96c-3.75,5.77-8.77,10.42-13.51,15.31c-2.77,1.59-5.73,1.56-8.76,1.08
		c-5.42-3.78-10.83-7.57-16.25-11.35C355.9,101.74,357.35,102.46,358.78,103.14z"
        />
        <path
          class="st97"
          d="M397.01,120.12c1.17,1.74,0.78,3.08-0.72,4.52c-4.43,4.25-6.45,9.5-5.86,15.65c0.34,3.52-0.52,6.89-1.08,10.3
		c-0.79-5.92-1.56-11.85-2.4-17.77c-0.15-1.08,0.24-1.86,0.88-2.57C390.88,126.87,393.95,123.5,397.01,120.12z"
        />
        <path
          class="st112"
          d="M363.58,103.14c-1.6-0.32-3.2-0.64-4.8-0.95c-3.35,1.26-5.8-2.02-9.08-1.78c-1.77,0.13-1.26,1.03-1.45,1.85
		l-0.3,0.21l-0.33-0.16c-2.25,1.16-4.85-0.73-7.05,0.84c-2.18,0.74-4.41,1.07-6.71,0.86C339.49,95.82,360.01,94.69,363.58,103.14z"
        />
        <path
          class="st82"
          d="M337.67,110.02c-1.21,1.54-0.13,2.44,0.83,3.57c4.61,5.4,9.6,10.37,15.44,14.46
		c0.74,0.52,1.32,1.28,1.97,1.93c-1.28,0-2.56,0.01-3.85,0.01c-0.32,0-0.63,0-0.95-0.01c-3.12-3.8-6.75-7.04-10.44-10.3
		c-3.31-2.92-7.77-5.89-5.88-11.69C335.75,108.67,336.71,109.35,337.67,110.02z"
        />
        <path
          class="st97"
          d="M371.41,150.05c-2.97-6.15-5.43-12.47-6.66-19.22c1.17-0.24,1.76,0.77,2.63,1.21
		c0.21,1.14,1.08,1.47,2.05,1.68l-0.02-0.02c0.98,1.85-0.27,4.02,0.83,5.86C371.4,142.97,371.41,146.51,371.41,150.05z"
        />
        <path
          class="st74"
          d="M348.25,102.25c-0.19-1.19-2.41-0.58-2-2.02c0.27-0.97,1.57-0.7,2.45-0.94c3.98-1.08,6.6,2.36,10.08,2.9
		c0,0.32,0,0.64,0,0.96c-1.15,0.02-2.36-0.09-2.99,1.21C353.46,102.97,351.08,101.81,348.25,102.25z"
        />
        <path
          class="st144"
          d="M372.04,115.7c2.79-1.4,5.79-1.14,8.76-1.08C376.99,119.63,376.99,119.63,372.04,115.7z"
        />
        <path
          class="st78"
          d="M400.08,96.52c-1.23-1.31-2.31-2.69,0.67-2.91c2.27-0.17,4.57-0.03,6.85,0.81c-1.81,0-3.63,0-5.44,0
		c-0.02,0.27-0.03,0.54-0.05,0.8c2,0.12,4.01,0.24,6.02,0.36C405.54,96.65,402.81,96.61,400.08,96.52z"
        />
        <path
          class="st138"
          d="M356.67,124.27c-3.67,0.49-5.83-1.1-6.52-4.72C352.87,120.36,354.96,122.05,356.67,124.27z"
        />
        <path
          class="st78"
          d="M394.31,99.31c-0.66-0.32-1.31-0.64-1.97-0.96c2.06-2.85,4.86-2.58,7.77-1.84
		C398,97.08,395.94,97.75,394.31,99.31z"
        />
        <path
          class="st74"
          d="M340.57,103.13c-0.24-0.89-0.73-2.25,0.93-1.7c2.03,0.67,4.08,0.6,6.12,0.86
		C345.35,103.27,342.97,103.26,340.57,103.13z"
        />
        <path
          class="st97"
          d="M372.21,157.79c-1.85-2.44-0.77-5.19-0.84-7.82C372.42,152.5,372.25,155.15,372.21,157.79z"
        />
        <path
          class="st138"
          d="M362.01,127.89c-2.61,1.16-3.82,0.48-3.28-2.5C359.82,126.23,360.92,127.06,362.01,127.89z"
        />
        <path
          class="st36"
          d="M369.43,133.72c-0.86,0.17-1.02,1.9-2.14,1.18c-1.31-0.84-0.3-1.91,0.09-2.86
		C368.53,132.04,369.17,132.65,369.43,133.72z"
        />
        <path
          class="st36"
          d="M370.24,139.56c-1.64-1.76-0.72-3.88-0.83-5.86C370.64,135.52,370.18,137.58,370.24,139.56z"
        />
        <path
          class="st112"
          d="M382.75,105.05c-4.39,3.68-10.77,3.32-17.25-0.95C371.19,105.4,376.95,105.63,382.75,105.05z"
        />
        <path
          class="st83"
          d="M316.6,180.8c-5.76,0.17-11.79-1.17-16.85,2.94c-1.2,0.98-3.04,1.97-3.29,3.21
		c-1.27,6.45-6.75,9.55-10.54,13.98c-4.27,2.7-8.71,4.83-13.95,4.84c-2.22,0.01-3.32-0.7-3.3-2.93c1.56-1.53,3.84-2.19,5.63-2.2
		c10.24-0.08,13.93-8.07,18.38-14.95c1.57-2.44,3.04-4.76,5.42-6.42c4-3.89,8.6-4.06,13.68-2.54c4.97,1.49,9.96,3.3,15.31,1.57
		c2.46-0.79,4.83-1.61,5.77-4.36c3.01-1.4,6.01-2.82,9.03-4.19c1.02-0.46,2.27-0.7,1.25-2.26c0.42-0.02,0.84-0.04,1.26-0.07
		c0.79,1.53-1.34,2.34-0.94,3.78c2.14,1.55,0.87,2.7-0.53,3.63c-2.78,1.83-5.39,3.89-8.16,5.73c-5.59,2.55-11.15,5.59-17.27,1.37
		C317.1,181.66,316.87,181.2,316.6,180.8z"
        />
        <path
          class="st85"
          d="M334.82,179.83c1.91-2.68,4.61-4.39,7.49-5.74c1.53-0.72,1.87-1.48,1.14-2.88c4.73,1.69,4.73,1.69,0.95,5.75
		c-2.36,1.07-5.07,1.51-6.71,3.84C336.52,181.12,335.08,182.22,334.82,179.83z"
        />
        <path
          class="st61"
          d="M340.53,166.51c-3.43-0.7-6.48-2.32-9.58-3.85c-3.32-3.69-7.88-5.49-12.3-7.01
		c-8.87-3.05-10.11-11.23-7.8-19.24c1.19-4.12,2.59-8.13,2.78-12.44c0.82-3.39,2.08-6.62,3.78-9.66c0.59,0.44,1.76,1,1.7,1.3
		c-1.22,5.97-0.13,12.33-3.33,17.98c-5.17,9.13-2.26,16.91,7.63,20.86c2.05,0.82,4.13,1.66,6.27,2.19
		C335.11,157.99,337.25,162.86,340.53,166.51z"
        />
        <path
          class="st59"
          d="M313.63,123.97c1.3,3.29,1.3,6.41-0.62,9.57c-2.71,4.47-2.33,9.59-1.39,14.25c1.08,5.36,6.86,5.84,10.86,8.14
		c3.13,1.8,7.57,2.1,8.47,6.74c-7.58-2.3-14.74-5.67-21.97-8.85c-0.65-3.66-4.56-6.39-3.03-10.67
		C308.2,136.64,310.53,130.15,313.63,123.97z"
        />
        <path
          class="st64"
          d="M259.78,133.93c0.08-1.13-2.66-3.41,1.22-2.99c4.3,1.96,9.13,2.48,13.16,5.36
		c1.96,1.41,11.82-2.61,12.95-5.03c1.08-2.31,3.2-3.87,4-6.43c0.54-1.74,2.32-2.54,4.32-1.6c-1.93,4.78-3.86,9.57-5.79,14.35
		c-4.37,1.42-8.39,4.44-13.4,2.96C270.74,138.35,265.26,136.14,259.78,133.93z"
        />
        <path
          class="st59"
          d="M269.62,179.82c0-0.32,0-0.63,0.01-0.95c0.77-1.73,1.53-3.5,1.84-5.35c1.35-7.93-1.64-13.08-9.34-15.9
		c-3.17-1.16-6.14-2.57-8.81-4.63l0,0c-0.39-1.71,1.01-1.76,2.02-2.16c6.57,2.12,12.92,4.75,19.11,7.8c1.91,2.71,2.99,5.69,3,9.03
		c-2.14,5.74-4,11.6-6.81,17.08C268.23,183.53,268.9,181.68,269.62,179.82z"
        />
        <path
          class="st59"
          d="M307.32,172.03c4.03,1.11,7.89,2.66,11.51,4.76c-2.75,3.64-5.79,1.01-8.4,0.05
		c-4.63-1.71-8.5-1.23-11.93,2.35c-3.6,1.29-4.23,4.74-5.78,7.61c-0.99,1.84-1.58,5.47-5.13,2.53c1.66-4.89,3.33-9.78,5.8-14.34
		C297.76,172.65,302.34,171.37,307.32,172.03z"
        />
        <path
          class="st64"
          d="M287.61,189.33c5.02,1.24,4.48-3.42,5.78-5.78c1.23-2.23,1.54-4.99,5-4.68c0.25,0.21,0.33,0.43,0.25,0.64
		c-0.08,0.21-0.16,0.32-0.24,0.32c-4.78,4.67-6.97,11.1-11.41,16.14c-5.17,5.86-11.73,5.91-18.31,6.86
		c-0.38-0.34-0.76-0.69-1.15-1.03c4.32-1.94,8.58-4.04,12.99-5.78C283.86,194.71,286.59,193,287.61,189.33z"
        />
        <path
          class="st101"
          d="M298.39,179.84c0-0.32,0-0.64,0-0.96c2.05-3.77,7.29-4.81,11.02-3.01c2.82,1.36,6.04,3.3,9.43,0.93
		c5.42,2.71,9.26-2.26,14-2.86c0.87,2.03-1.75,4.88-4.61,5.58c-5.05,1.24-10.06,0.93-14.71-0.96
		C308.07,176.34,303.19,176.49,298.39,179.84z"
        />
        <path
          class="st113"
          d="M276.23,140.56c3.8-1.12,8.08-0.74,11.22-3.88c1.07-1.07,1.42,0.67,2.18,0.92c-2.5,7.7-2.5,7.71-10.02,4.63
		C278.44,141.75,277.35,141.12,276.23,140.56z"
        />
        <path
          class="st72"
          d="M269.62,179.82c-0.11,1.73,0.1,3.4,1.02,4.92c-1.23,3.95-2.68,7.81-4.65,11.46
		C262.29,189.65,267.56,185.09,269.62,179.82z"
        />
        <path
          class="st97"
          d="M307.32,172.03c-4.63,1.04-9.1,2.78-13.91,2.96c0.41-1.25,0.83-2.5,1.24-3.75c1.88-0.73,3.2-3.08,5.72-2.01
		l-0.04-0.02c1.5,1.02,3.29,1.28,4.93,1.93C305.95,171.43,306.64,171.73,307.32,172.03z"
        />
        <path
          class="st113"
          d="M305.95,143.16c0.69,2.74,1.1,5.61,3.36,7.64c1.36,1.22,0.72,2.12-0.33,3.03c-1.03-0.34-2.03-0.77-3.08-0.99
		c-3.22-0.69-3.47-2.42-2.01-5.02C304.72,146.33,305.27,144.71,305.95,143.16z"
        />
        <path
          class="st101"
          d="M255.34,150.83c-0.67,0.72-1.35,1.44-2.02,2.16c-3.15-2.27-8.34-1.6-9.59-6.63
		C247.98,146.87,251.61,148.99,255.34,150.83z"
        />
        <path
          class="st2"
          d="M277.45,167.66c-1.98-2.68-2.77-5.76-2.99-9.03C281.15,160.52,281.15,160.52,277.45,167.66z"
        />
        <path
          class="st116"
          d="M300.37,169.22c-2.09,0.16-3.23,3-5.72,2.01C295.27,166.89,297.41,166.91,300.37,169.22z"
        />
        <path
          class="st116"
          d="M305.26,171.14c-1.95,0.15-3.7-0.23-4.93-1.93C302.18,169.33,303.84,169.92,305.26,171.14z"
        />
        <path
          class="st101"
          d="M253.33,152.99c5.82,1.97,11.19,4.9,16.43,8.01c2.71,1.61,3.77,10.21,2.06,14.29
		c-0.54,1.28-1.45,2.39-2.19,3.58c0.32-2.66,0.47-5.36,0.99-7.98c1.11-5.5-4.56-12.41-10.07-13.04
		C257.27,157.48,255,155.71,253.33,152.99z"
        />
        <path
          class="st9"
          d="M489.17,122.3c-2.12-1.35-4.62-2.25-5.77-4.77c-0.26-1.45,0.84-1.63,1.8-1.93c1.02-0.14,1.99,0,2.85,0.59
		c0.66,1.52,1.71,2.61,3.33,3.16c1.05,0.36,2.02,0.93,2.99,1.5c9.51,5.63,11.66,11.89,7.36,22.01c-1.01,2.38-1.81,4.74-1.98,7.32
		c-1.06,4.37-3.32,8.58-1.78,13.31c0,2.55-0.05,5.08-2.27,6.9c-0.88-0.1-1.79,0-2.68-0.16c-2.3-4.47,0.4-8.93-0.01-13.4
		c0.32-1.27,0.64-2.54,0.97-3.81c0.29-0.29,0.54-0.62,0.75-0.99c0.12-3.22,1.25-6.19,2.21-9.21c0.14-0.42,0.33-0.82,0.55-1.2
		c0.19-0.44,0.21-0.92,0.33-1.38C500.29,130.78,497.97,128.08,489.17,122.3z"
        />
        <path
          class="st144"
          d="M493.96,170.28c0.34-0.7,0.66-0.6,0.98,0.02c5.54,2.15,10.77,5.48,17.14,4.47c0.95,0.45,1.46,1.16,1.33,2.25
		c-1.07,1.95-3.06,2.23-4.94,2.73c-0.49,0.05-0.97,0.07-1.46,0.08c-5.35,0.36-9.23-2.62-13.05-5.73c-0.01-0.31-0.02-0.63-0.02-0.94
		C493.3,172.18,493.1,171.22,493.96,170.28z"
        />
        <path
          class="st136"
          d="M489.17,122.3c9.88,4.52,13.46,7.45,8.63,20.14c-0.78-1.92-0.71-3.84,0-5.76c-0.02-4.23-1.95-7.59-4.8-10.54
		C491.72,124.87,490.45,123.59,489.17,122.3z"
        />
        <path
          class="st136"
          d="M493.96,170.28c-0.01,0.95-0.01,1.91-0.02,2.86c-3.13-1.75-3.49-4.54-2.86-7.69c1.3-2.1-0.29-4.61,0.96-6.71
		c0.02-0.79,0.19-1.51,0.97-1.92c1.75,2.46,0.98,5.08,0.45,7.67C493.06,166.49,492.34,168.47,493.96,170.28z"
        />
        <path
          class="st136"
          d="M493.96,174.08c4.61,1.22,8.18,5.35,13.42,4.8c-1.91,2.63-4.38,1.3-6.71,0.95c-1.49-0.67-3.1-1.2-3.84-2.87
		C495.01,176.87,494.04,175.92,493.96,174.08z"
        />
        <path
          class="st102"
          d="M500.67,179.83c2.23-0.37,4.69,0.87,6.71-0.95c0.32-0.01,0.64-0.01,0.96-0.01c1.92,0.64,3.83-1.8,5.75,0
		c-0.32,0.64-0.64,1.27-0.96,1.91C509,180.25,504.69,181.94,500.67,179.83z"
        />
        <path
          class="st102"
          d="M494.92,152.99c-0.31,0.01-0.63,0.02-0.94,0.03c0.01-3.33-0.45-6.75,1.9-9.61c0.16,0.2,0.32,0.41,0.48,0.61
		C496.51,147.1,495.22,149.97,494.92,152.99z"
        />
        <path
          class="st102"
          d="M497.79,136.69c0,1.92,0,3.84,0,5.76c0,0,0,0,0,0c-0.54,0.51-0.82,1.56-1.92,0.96c0,0,0,0,0,0
		C496.9,141.27,496.23,138.66,497.79,136.69z"
        />
        <path
          class="st102"
          d="M492.04,158.74c-0.37,2.23,0.89,4.69-0.96,6.71C491.46,163.22,490.21,160.76,492.04,158.74z"
        />
        <path
          class="st102"
          d="M496.83,176.96c1.28,0.96,2.56,1.91,3.84,2.87C498.61,179.93,496.98,179.43,496.83,176.96z"
        />
        <path
          class="st89"
          d="M560.24,126.14c0.53,0.92,3.39-1.43,2.4,2.21c-0.91,3.36-1.75,6.82-2.53,10.26
		c-6.07,4.46-13.1,2.91-19.75,2.73c-5.34-0.15-9.22,1.3-11.89,5.9c-2.68,7.68-5.62,15.27-8.45,22.9c-0.64,1.72-1.32,3.65-3.5,4.19
		c-0.55-0.08-0.88-0.38-1.02-0.92c1.17-5.94,3.98-11.3,6.1-16.89c1.29-3.41,1.67-7.05,3.39-10.35c3.05-5.83,7.12-9.19,14.21-9
		c4.01,0.11,8.08,2.06,12.1,0.13c3.21-0.26,4.84-2.15,5.77-5.14C557.75,130.02,557.95,127.49,560.24,126.14z"
        />
        <path
          class="st136"
          d="M516.02,174.09c4.39-2.31,4-7.25,5.84-10.93c1.89-3.78,2.82-8.03,4.23-12.06c0.5-1.45,0.58-3.2,2.39-3.86
		c0.84,5.11-2.38,9.19-4.1,13.42c-2.6,6.41-3.53,14.06-10.28,18.21c-1.92-0.73-3.83,1.57-5.75,0c1.6-0.64,3.2-1.28,4.79-1.92
		C513.73,175.64,514.36,174.35,516.02,174.09z"
        />
        <path
          class="st9"
          d="M485.17,100.99c4.16-4.83,9.69-3.05,14.33-2.02c9.07,2.01,17.95,5.01,26.5,8.77c2.67,1.17,5.57,1.12,8.23,2.12
		c0.32,0.49,0.27,0.93-0.16,1.33c-3.04,1.63-5.83,0.33-8.66-0.74c-7.99-3.03-16.26-5.23-24.34-7.97c-3.75-1.27-7.52-0.63-11.29-0.24
		c-1.21,0.08-2.43,0.11-3.6-0.28C485.7,101.78,485.37,101.45,485.17,100.99z"
        />
        <path
          class="st89"
          d="M534.23,110.81c0-0.32,0-0.64,0-0.96c2.03-0.34,3.83,0.64,5.75,0.96c4.23,3.58,10.07,2.92,14.74,5.7
		c3.1,1.84,4.53,4.64,6.55,7.14c0.52,0.65-0.56,1.27-1.28,1.59c-0.79,0.13-1.31-0.3-1.79-0.84c-4.03-5.22-10.18-6.76-15.83-9.2
		C539.54,113.98,536.09,113.85,534.23,110.81z"
        />
        <path
          class="st156"
          d="M485.6,116.44c-0.86,0.1-1.71,0.24-2.2,1.09c-3.98-4.75-4.28-11.88-0.75-16.37c0.87-1.1,1.68-0.21,2.52-0.17
		c0.11,0.15,0.23,0.29,0.37,0.42c0.79,0.96,0.76,2.1,0.36,3.12C484.36,108.47,483.48,112.41,485.6,116.44z"
        />
        <path
          class="st47"
          d="M485.6,116.44c-4.45-2.33-3.05-5.78-1.82-9.25c0.67-1.9,1.18-3.86,1.76-5.79c1.1-0.68,2.21-0.07,3.31-0.04
		c1.17,0.33,2.42,0.09,3.57,0.54c2.26,0.13,4.34,0.98,6.44,1.71c18.05,6.25,36.39,11.64,54.48,17.78c2.02,0.83,4.26,1.28,5.67,3.2
		c0.33,0.21,0.65,0.43,0.98,0.64c0.04,0.31,0.13,0.61,0.26,0.9c-0.8,2.35-1.81,4.66-2.34,7.07c-0.79,3.59-2.24,5.85-6.39,4.58
		c-0.92,0.66-1.8,0.32-2.67-0.11c-4.35-2.19-9.22-2.91-13.67-4.81c-8.74-2.83-7.17-2.84-9.82,5.19c-2.81,8.43-5.83,16.79-8.26,25.34
		c-1.53,3.47-2.35,7.2-3.86,10.69c-0.28,0.4-0.65,0.71-1.1,0.91c-0.83,0.78-1.02,2.53-2.81,1.9c-4.63-1.63-9.26-3.24-13.86-4.95
		c-0.34-0.13-0.37-1.08-0.54-1.65c1.41-1.93,1.85-4.16,2.03-6.47c0.6-4.06,1.6-8.02,2.93-11.91c2.09-5.56,3.93-11.2,5.63-16.88
		c0.65-1.58,1.35-3.14,1.81-4.82c1.62-5.95,1.66-5.93-4.13-7.86c-2.17-0.76-4.35-1.49-6.56-2.15c-2.78-1.28-6.06-1.41-8.44-3.62
		C487.34,116.54,486.47,116.49,485.6,116.44z"
        />
        <path
          class="st105"
          d="M653.11,292.96c0.32,0.64,0.64,1.28,0.96,1.92c-0.32,0.64-0.65,1.28-0.97,1.92
		c-4.82,0.6-7.91-2.64-11.11-5.3c-3.27-2.72-5.98-6.08-9.01-9.08c-0.55-2.4-2.86-3.63-3.83-5.75c-1.88-5.75-6.56-9.57-10.03-14.19
		c-3.51-4.67-6.94-9.16-8.55-14.95c-1.46-5.25-5.44-8.26-10.52-10.2c-6.11-2.33-11.94-5.29-15.3-11.4c-0.68-1.23-1.09-2.6-1.62-3.91
		c1.63-0.52-0.21-2.2,0.95-2.87c2.45,6.19,6.19,11.14,12.52,13.93c2.3,1.01,4.32,1.98,6.66,0.45c0.75-0.77,1.67-0.98,2.7-0.78
		c2.92,1.55,4.08,4.45,4.85,7.28c2.13,7.82,5.76,14.47,11.55,20.38c4.82,4.93,8.35,11.12,12.88,16.41
		c3.24,4.45,6.86,8.53,11.48,11.63C648.75,290.08,651.68,290.46,653.11,292.96z"
        />
        <path
          class="st81"
          d="M629.14,276.66c2.09,1.37,4.09,2.81,3.83,5.75c-1.17-1.68-3.76-2.23-3.84-4.79
		C629.14,277.3,629.14,276.98,629.14,276.66z"
        />
        <path
          class="st47"
          d="M585.06,138.61c0.9-1.59,1.91,0.15,2.85-0.09c0.37-0.28,0.77-0.35,1.21-0.24c2.56,1.21,4.54,3.26,6.95,4.7
		c8.86,6.59,17.91,12.93,26.84,19.43c0.38,0.24,0.74,0.52,1.09,0.8c1.2,1.08,2.38,2.19,3.52,3.34c11.15,14.15,6.98,31.15-9.17,37.44
		c-0.31,0.08-0.62,0.13-0.93,0.2c-8.94,2.1-8.94,2.1-9.03,11.29c-1,4.98-0.74,10.08-1.37,15.09c-0.18,0.49-0.47,0.91-0.87,1.24
		c-3.08,0.43-4.65-2.23-6.96-3.4c-2.99-2.86-6.97-4.43-9.81-7.49c-0.28-0.68-0.34-1.39-0.24-2.12c0.92-6.84,0.01-13.73,0.53-20.58
		c0.15-2.01-0.98-3.27-2.44-4.38c-2.8-2.12-5.58-4.27-8.53-6.18c-1.73-0.9-3.16-4.08-5.42-0.66c-2.09,2.96-4.35,5.8-6.46,8.74
		c-1.13,1.57-2.06,3.34-3.99,4.14c-0.52-0.01-1.04-0.03-1.56-0.04c-4.27-1.3-7.14-4.91-11.12-6.7c-1.49-0.74-2.61-1.77-2.81-3.53
		c0.46-1.54,1.36-2.79,2.51-3.88c2.28-2.03,3.51-4.88,5.52-7.11c0.8-0.94,1.38-2.02,1.92-3.12c0.57-1.1,1.16-2.18,2.12-3
		c0.95-0.64,1.22-1.66,1.47-2.68c1.64-2.44,3.4-4.81,5.32-7.05c0.48-0.48,1.05-0.8,1.73-0.91c2.65-0.2,4.7,1.13,6.67,2.64
		c1.03,0.77,2.13,1.44,3.14,2.23c0.97,0.82,2.02,1.52,3.11,2.18c6.9,5.01,13.72,10.11,20.76,14.93c1.43,1.28,3.03,2.28,4.85,2.91
		c3.03,0.97,5.33,0.09,6.92-2.67c0.33-1,0.71-1.97,1.27-2.86c1.04-1.7,0.14-3.06-0.76-4.42c-1-1.34-2.36-2.28-3.68-3.25
		c-7.59-5.9-15.51-11.34-23.31-16.96c-1.34-1.05-2.6-2.22-4.09-3.08c-1.37-1.07-2.96-1.85-4.12-3.19
		C577.68,144.72,582.07,142.04,585.06,138.61z"
        />
        <path
          class="st124"
          d="M562.83,199.91c1.11-1.57,2.23-3.14,3.34-4.7c1.74-1.11,3.19-2.62,5.2-3.35
		c9.16-3.36,16.47,0.86,17.79,10.46c0.54,3.93,1.22,7.86,1.06,11.87c-0.96,2.55,0.42,5.78-2.29,7.82
		c-2.36-6.13-0.99-12.92-3.61-19.07c-3.04-7.14-9.07-9.28-15.77-5.05C566.75,199.01,565.07,200.18,562.83,199.91z"
        />
        <path
          class="st117"
          d="M547.73,189.62c0.92,0.92,1.84,1.84,2.76,2.76c1.44,2.41,3.58,4.13,5.74,5.83c0.89,0.7,2.38,1.04,1.96,2.71
		c-5.21,0.84-7.57-4.03-11.5-5.75c0.86-4.43-1.32-9.09,0.95-13.42C549.85,184.35,548.66,186.99,547.73,189.62z"
        />
        <path
          class="st144"
          d="M599.66,227.66c1.92,1.28,3.83,2.56,5.75,3.83c-1,1.03-2.05,0.79-3.11,0.12c-4.51,0.4-7.96-1.61-11-4.72
		c-0.93-0.96-1.16-1.82-0.52-2.94C593.97,224.64,596.39,227.17,599.66,227.66z"
        />
        <path
          class="st143"
          d="M558.19,200.92c-2.99-1.86-5.5-4.28-8.13-6.59c-1.48-1.3,0.53-1.27,0.42-1.95
		c4.18,1.65,7.42,4.66,10.78,7.49C560.25,200.22,559.22,200.57,558.19,200.92z"
        />
        <path
          class="st124"
          d="M599.66,227.66c-3.92,1.05-6.51-1.07-8.88-3.71c-0.32-0.01-0.63-0.01-0.95-0.01
		c-0.64-1.29-0.83-2.54,0.35-3.66C593.34,222.73,596.5,225.19,599.66,227.66z"
        />
        <path
          class="st144"
          d="M590.18,220.27c-0.12,1.22-0.23,2.44-0.35,3.66c-0.93-0.36-1.56-1-1.91-1.93c2.21-2.16-0.23-5.38,1.72-7.6
		c1.19,1.63,0.61,3.38,0.37,5.11C590.26,219.73,590.31,219.98,590.18,220.27z"
        />
        <path
          class="st153"
          d="M602.3,231.61c1.04-0.04,2.08-0.08,3.11-0.12c0,0,0.39-0.03,0.39-0.03c0.39-0.32,0.82-0.36,1.27-0.14
		c0.66,1.15-0.06,1.71-0.94,2.2c-0.96,0-1.92,0-2.88,0C602.93,232.88,602.62,232.25,602.3,231.61z"
        />
        <path
          class="st58"
          d="M579.33,149.99c1.58,0.54,2.84,1.53,3.88,2.82c2.8,4.81,6.12,9.2,10.72,12.44c2.11,1.49,4.03,3.14,5.64,5.15
		c1.1,1.37,1.53,2.86,0.24,4.33c-1.25,1.43-2.6,0.61-3.91-0.01c-4.63-2.17-8.5-5.63-13.21-7.69c-1.61-0.71-3.06-1.73-4.93-1.48
		c-1.07-0.05-2.17,0.29-3.23-0.13c-2.39-0.64-3.76-3.68-6.77-2.86c-0.59-0.64-0.54-1.27,0.03-1.89c1.59,1.02,3.18-0.32,4.77-0.01
		c4.31-0.55,6.57-3.17,5.76-7.07C578.02,152.07,577.59,150.81,579.33,149.99z"
        />
        <path
          class="st58"
          d="M595.34,143.54c-2.5-1.24-4.7-2.89-6.72-4.78c1.35-2.33,3.61-1.39,5.06-0.78c3.9,1.63,8.16,2.6,11.49,5.44
		c0.37,0.91,1.01,1.54,1.92,1.91c4.73,3.21,9.15,6.83,13.73,10.24c4.12,2.17,6.98,5.78,10.2,8.98c0.98,0.98,2.01,2.08,1.24,3.72
		c-4.13,0.5-5.12-4-8.2-5.16c-6.03-4.2-11.59-9.02-17.5-13.36C603.09,147.19,599.5,144.83,595.34,143.54z"
        />
        <path
          class="st116"
          d="M567.8,160.67c-0.01,0.63-0.02,1.26-0.03,1.89c-0.34,0.32-0.68,0.64-1.01,0.95
		c-7.92,5.88-13.58,13.36-16.26,22.94c-0.73,1.22-1.28,2.59-2.76,3.16c-0.03-2.62-0.06-5.24-0.08-7.87c1.9-4.03,5.62-7,6.72-11.5
		C558.84,167.05,562.04,162.07,567.8,160.67z"
        />
        <path
          class="st116"
          d="M579.33,149.99c-0.52,1.17-0.79,2.05,0.2,3.4c2.06,2.83-0.89,4.63-2.15,6.58c-1.1,1.71-2.92,2.51-4.82,0.69
		c3.62-1.65,5.13-4.46,4.81-8.4c-0.29-3.69-0.08-7.39,1.9-10.61c1.23-2,2.34-4.93,5.78-3.04c-0.87,2.9-3.25,4.84-4.7,7.36
		C579.67,147.18,577.86,148.19,579.33,149.99z"
        />
        <path
          class="st116"
          d="M605.16,143.41c-3.57-1.44-7.12-2.96-10.73-4.28c-1.85-0.67-3.8-1.48-5.82-0.39c0,0-0.39,0.01-0.39,0.01
		l-0.31-0.24c0.27-2.04,1.87-2.03,3.23-1.79C596.42,137.65,601.6,138.87,605.16,143.41z"
        />
        <path
          class="st116"
          d="M620.51,155.87c-5.02-2.82-9.64-6.15-13.42-10.55c0.64,0,1.28,0,1.92,0c3.31,3.82,8.81,5.02,11.51,9.58
		c0.24,0.22,0.33,0.43,0.24,0.65C620.67,155.76,620.59,155.87,620.51,155.87z"
        />
        <path
          class="st154"
          d="M620.51,155.87c0-0.32,0-0.65,0.01-0.97c8.4,2.85,18.03,16.27,18.26,25c0.16,5.82-0.09,11.41-3.88,16.23
		c-2.54,4.31-5.57,9.11-9.98,10.54c-4.05,1.31-6.37,3.68-8.99,6.29c-0.11,0.11-0.15,0.28-0.22,0.42c-2.8,2.41-2.76,6.01-3.81,9.14
		c-0.65,1.94-0.12,4.49-2.89,5.25c-0.17-0.18-0.35-0.36-0.53-0.53c-0.53-7.58,1.35-14.27,7.29-19.41c1.07-0.93,2.17-1.83,3.23-2.77
		c5.3-2.91,10.18-6.06,12.92-11.98c3.04-6.57,3.72-12.96,1.02-19.69c-0.64-1.6-1.34-3.24-0.91-5.05c-1.92-4.67-6.07-7.3-9.56-10.53
		C621.78,157.18,621.15,156.52,620.51,155.87z"
        />
        <path
          class="st47"
          d="M661.65,278.75c0.3,0.87,0.73,1.74,0.05,2.63c-3.06,3.52-5.78,7.57-11.32,7.17c-1.82-1.68-4.08-2.97-5.12-5.4
		c-2.44-4.53-5.73-8.43-9.04-12.32c-0.48-0.46-0.88-0.99-1.2-1.58c-1.16-2.34-2.81-4.31-4.61-6.17c-0.47-0.46-0.86-0.97-1.18-1.55
		c-2.06-3.77-4.96-6.93-7.49-10.37c-2.27-3.71-5.45-6.84-6.97-11.03c-0.21-0.58-0.76-1.5-0.57-1.7c3.11-3.14,6.44-6.03,10.6-7.7
		c0.39-0.16,1.1,0.5,1.66,0.77c1.28,0.63,2.29,1.56,3.14,2.69c0.73,1.16,1.54,2.26,2.48,3.28c0.26,0.31,0.5,0.63,0.71,0.97
		c0.8,1.45,2.01,2.59,2.98,3.91c7.21,9.6,14.11,19.42,21.47,28.89c0.87,1.44,1.92,2.75,2.97,4.06
		C661.04,276.34,661.23,277.59,661.65,278.75z"
        />
        <path
          class="st98"
          d="M614.79,240.15c2.97,3.2,5.51,6.71,7.73,10.47c1.22,4.5,4.46,7.57,7.6,10.71c0.3,0.35,0.6,0.7,0.9,1.04
		c-0.06,3.42,3.18,4.44,4.81,6.62c0.31,0.35,0.63,0.71,0.94,1.06c2.52,4.6,5,9.24,9.42,12.39c0.42,2.6,3.85,2.91,4.2,5.55
		c-0.17,0.14-0.34,0.28-0.51,0.42c-2.05,0.03-3.77-1.01-5.59-1.72c-3.05-3.43-6.2-6.78-9.35-10.13c-0.31-0.31-0.56-0.65-0.77-1.04
		c-0.76-2.54-2.73-4.13-4.57-5.83c-0.5-0.4-0.91-0.88-1.22-1.44c-0.86-2.42-2.43-4.36-4.19-6.17c-0.29-0.33-0.55-0.67-0.78-1.04
		c-3.3-3.86-5.33-8.55-8.26-12.66c-0.93-1.3-1.63-2.67-1.34-4.35C614.13,242.76,614.46,241.46,614.79,240.15z"
        />
        <path
          class="st2"
          d="M613.81,244.07c0.64,1.28,1.28,2.55,1.91,3.83c1.58,5.31,5.38,9.19,8.63,13.43l0,0
		c1.65,2.2,3.48,4.27,4.79,6.71c0.32,0.32,0.64,0.64,0.96,0.96c1.6,2.24,3.51,4.25,4.8,6.71v0c0.52,0.64,0.61,1.28,0,1.92
		c-4.56-3.13-6.74-8.28-10.22-12.33c-2.12-2.47-4.06-5.19-6.33-7.6c-3.18-3.38-5.85-7.05-6.64-11.8c-0.76-4.6-3.09-8.53-5.57-12.37
		c0.31-0.66,0.62-1.31,0.94-1.97c-0.86-1.28-0.28-2.71-0.42-4.07c0.09-0.48,0.36-0.82,0.83-1c0.87-0.03,1.09,0.73,1.52,1.24
		c0,0,0.02,0.05,0.02,0.05c0.1,1.66-0.9,3.27,1.56,4.63c2.46,1.36,1.95,4.6,1.61,7.1C611.9,241.48,612.47,242.83,613.81,244.07z"
        />
        <path
          class="st124"
          d="M628.76,234.64c-0.76-1.03-1.52-2.07-2.28-3.1c2.75-3.2,6.24-5.77,8.14-9.69c0.44,0.15,0.78,0.41,1.02,0.82
		c0.61,1.25,1.05,2.56,1.42,3.9C637,233.44,634.83,235.55,628.76,234.64z"
        />
        <path
          class="st58"
          d="M633.94,220.1c1.57-2.19,3.8-2.09,6.1-1.76c-0.57,2.75-2.24,4.03-5.06,3.75c0,0-0.35-0.24-0.36-0.24
		C634.39,221.26,634.16,220.68,633.94,220.1z"
        />
        <path
          class="st136"
          d="M624.35,226.81c1.34-1.6,3.18-0.72,4.79-0.96C627.8,227.45,625.96,226.58,624.35,226.81z"
        />
        <path
          class="st47"
          d="M634.98,222.09c1.99-0.84,3.63-2.16,5.06-3.75c0.5-0.44,1-0.88,1.5-1.32c0.48-1.42,2.09-0.91,2.93-1.72
		c0.59,0.04,1.19,0.08,1.78,0.12c0.2,0.08,0.41,0.16,0.61,0.24c1.21,0.96,2.15,2.18,3.22,3.29c8.63,12.26,17.97,24.01,26.84,36.1
		c0.9,1.32,2.17,2.54,1.19,4.37c-0.33,0.34-0.66,0.68-1,1.01c-2.01,3.38-5.31,5.04-8.72,6.57l0.01,0c-1.6,1.32-2.47,0-3.46-0.94
		c-0.68-0.89-1.36-1.78-2.1-2.63c-7.95-10.4-15.44-21.15-23.78-31.26c-1.34-1.98-1.73-4.43-3.18-6.36
		C635.5,224.59,634.21,223.59,634.98,222.09z"
        />
        <path
          class="st116"
          d="M652.14,207.63c2.81-4.98,8.39-9.49,12.48-7.67c0.2,3.14-2.8,3.46-4.43,4.96c-1.28,1.17-2.79,2.1-4.18,3.16
		c-1.03,0.91-1.08,2.22-1.47,3.41c-1.41,4.31-3.74,5.39-8.33,3.96c0,0,0.03-0.03,0.03-0.03c1.16-2.26,1.52-5.17,5.08-5.31
		C652.25,210.07,652.09,208.56,652.14,207.63z"
        />
        <path
          class="st58"
          d="M644.46,215.3c-0.85,0.79-1.64,1.67-2.93,1.72c-0.4-0.56-1.25-1.43-1.12-1.63
		C641.65,213.54,643.09,215.5,644.46,215.3z"
        />
        <path
          class="st47"
          d="M655.51,206.83c3.19-2.09,6.4-4.14,9.11-6.87c1.13-0.28,1.88,0.44,2.67,1.04c3.83,2.92,6.32,6.98,9.23,10.7
		c1.02,1.32,1.83,2.79,2.97,4.02c0.43,0.47,0.81,0.97,1.16,1.49c1.13,1.77,2.23,3.56,3.61,5.15c0.43,0.48,0.81,0.98,1.17,1.51
		c1.79,2.64,3.76,5.14,5.75,7.63c3.9,5.82,8.84,10.94,11.76,17.43c-0.01,0.59-0.02,1.17-0.03,1.76c-1.79,3.03-4.42,4.9-7.81,5.77
		c-2.27,2.35-3.87,0.86-5.42-0.95c-1.89-0.58-2.64-2.3-3.75-3.67c-8.41-11.05-16.56-22.3-24.95-33.37
		c-1.26-1.66-2.54-3.28-4.12-4.66C655.72,211.62,653.17,209.69,655.51,206.83z"
        />
        <path
          class="st143"
          d="M679.54,217.4c-0.23-0.27-0.47-0.55-0.7-0.82c-0.18-2-1.13-3.4-3.11-4c-3.15-3.61-5.94-7.48-8.44-11.57
		c3.27,0.43,5.63,1.98,7.67,4.74c2.8,3.79,6.64,6.83,9.34,10.68c6.01,8.61,13.02,16.54,17.84,25.97c1.08,2.12,0.77,4.32,0.8,6.52
		c-4.56-5.4-8.68-11.12-12.6-16.99c-0.41-3.79-3.61-5.51-5.91-7.89c-0.24-0.31-0.47-0.63-0.71-0.94
		C682.74,220.9,682.29,218.3,679.54,217.4z"
        />
        <path
          class="st9"
          d="M695.1,256.45c2.6-1.92,5.2-3.85,7.81-5.77c1.62,3.19-2.37,3.67-2.83,5.85
		C698.42,256.5,696.76,256.47,695.1,256.45z"
        />
        <path
          class="st136"
          d="M130.61,329.39c-0.64,0-1.28,0-1.92,0c-9.3-4.74-19.8-7.68-25.87-17.26c1.2-3.41-0.88-7.05,0.88-10.5
		c1.76-3.44,3.45-6.68,8.01-6.6c-0.07,3.82-2.62,6.64-4.07,9.89c-0.99,2.24-1.89,4.33-0.47,6.67c0.3,2.92,3.43,3.38,4.74,5.42
		c0.86,0.87,1.91,1.49,2.92,2.16c1.35,0.99,2.95,1.41,4.49,1.96c0.81,0.34,1.56,0.78,2.22,1.36c1.62,2.01,4.08,2.69,6.2,3.91
		C128.96,327.11,130.91,327.19,130.61,329.39z"
        />
        <path
          class="st47"
          d="M106.65,312.14c-1.48-0.99-2.81-1.91-1.63-4.09c2.32-4.29,4.48-8.67,6.7-13.01c0.14,0.2,0.33,0.27,0.57,0.22
		c1.65-0.25,3.04,0.57,4.52,1.04c9.59,4.91,19.36,9.42,29.1,14c1.92,1.1,3.91,2.06,5.9,3.01c1.92,0.45,3.73,3.5,5.77,0.18
		c1.29-2.05,2.06-4.34,3.06-6.53c4.47-8,7.67-16.61,11.91-24.71c0.75-1.38,1.48-2.77,2.17-4.19c0.67-1.19,1.21-2.51,2.74-2.9
		c1.2-0.1,2.25,0.38,3.31,0.86c2.58,1.48,5.43,2.45,7.87,4.21c1.86,1.96,0.92,4.04,0.26,6.11c-7.6,15.99-15.47,31.86-22.9,47.93
		c-0.85,1.44-1.41,3.08-2.77,4.18c-1.74,0.85-3.32,0.16-4.89-0.53c-14.95-7.27-30.15-14.03-44.96-21.57
		c-0.39-0.18-0.76-0.4-1.13-0.62c-1.2-0.78-2.5-1.38-3.79-2.01C107.68,313.37,107.16,312.76,106.65,312.14z"
        />
        <path
          class="st73"
          d="M180.47,271.87c3.8-1.18,5.85-3.45,4.79-7.67c0-2.24,0-4.47,0-6.71c2.22-0.19,2.44,1.68,2.92,3.05
		c0.54,1.55,0.97,3.01,2.9,3.24c2.2,1.57,2.17,4.06,2.64,6.01c2.74-4.95,8.36-7.78,11.27-12.91c0.25-0.84,0.52-1.67,1.07-2.37
		c2.36-2.11,1.45-4.89,1.43-7.44c-0.01-1.7-0.73-3.45,0.77-4.9c0.32,0,0.64-0.01,0.96-0.01c3.33,8.15,4.21,16.23-0.8,24.09
		c-1.23,1.94-2.94,3.34-5.19,4c-7.96,2.87-7.79,2.88-8.13,11.12c-0.17,4.07,0.81,8.61-3.09,11.77c-1.82-1.8-1.42-4.15-1.31-6.29
		c0.19-3.84-0.7-7.2-3.29-10.06c-1.27-3.16-5.02-1.96-6.95-3.95C180.47,272.51,180.47,272.19,180.47,271.87z"
        />
        <path
          class="st113"
          d="M188.13,275.7c5.4,4.83,3.55,11.28,3.84,17.25c1.06,3.7-0.56,7-2.39,9.77c-5.29,8.01-7.85,17.3-12.59,25.54
		c-0.4,0.69-0.75,1.4-1.23,2.04c-1.7,1.99-3.85,3.6-5.19,5.93c-1.09,1.32-1.81,2.96-3.3,3.95c-0.44,0.15-0.84,0.06-1.18-0.25
		c-1.92,0.31-3.72,1.3-5.75,0.95c-0.73-2.54,2.15-1.82,2.81-3.1c-0.1-1.54,0.81-2.63,1.66-3.75c1.97,1.84,1.52-0.42,1.99-1.16
		c1.53-2.4,3.17-4.71,4.57-7.22c5.85-10.44,10.5-21.42,15.25-32.37c1.06-2.45,1.4-4.79,1.4-7.31c-0.14-1.8,2.48-3.55,0.08-5.38
		c-1.8-3.08-4.71-3.8-7.98-3.77c-0.84-0.37-1.68-0.73-2.53-1.1c-0.63-1.12,0.44-1.39,0.96-1.94c0.32,0,0.64,0,0.96,0
		C182.83,272.42,185.41,274.38,188.13,275.7z"
        />
        <path
          class="st117"
          d="M175.41,278.53c-0.6,1.27-1.19,2.55-1.79,3.82c-2.9,1.24-3.62,4.18-5.02,6.55
		c-2.37,4.02-5.01,7.9-6.95,12.18c-2.87,2.5-5.07,5.87-9.03,6.98c-0.46,0.17-0.93,0.28-1.41,0.35c-4.17,0.05-7.96-0.73-10.27-4.72
		c0.32-0.57,0.71-0.63,1.18-0.18c2.6,0.01,4.35,2.32,7.13,2.29c5.1-0.06,8.32-3.5,10.08-6.99c3.93-7.77,8.45-15.08,13.46-22.14
		C175.01,275.41,175.18,277.02,175.41,278.53z"
        />
        <path
          class="st136"
          d="M142.12,303.5c-0.32,0-0.64,0-0.97,0.01c-2.81,2.38-5.11-0.72-7.7-0.72c-5.82-2.05-11.24-5.3-17.57-5.82
		c-1.4-0.16-2.64-0.66-3.61-1.72c0.14-0.77,0.43-2.11,1.02-1.89c2.94,1.07,6.22-1.21,8.64,0.25
		C128.4,297.5,136.02,298.97,142.12,303.5z"
        />
        <path
          class="st138"
          d="M188.13,275.7c-3.07,0.26-5.45-2.62-8.62-1.92c0.32-0.32,0.64-0.64,0.96-0.96
		C183.36,272.88,186.45,272.43,188.13,275.7z"
        />
        <path
          class="st138"
          d="M175.41,278.53c-0.78-0.76-1.18-2.03-2.61-1.87c1.22-2.35,3.69-2.2,5.75-2.88
		c-0.32,0.65-0.64,1.29-0.96,1.94C176.86,276.66,176.14,277.6,175.41,278.53z"
        />
        <path
          class="st47"
          d="M206.29,257.66c-3.72,4.77-8.41,8.56-12.9,13.12c-0.93-2.5-1.7-4.54-2.46-6.59
		c-3.21-4.2-3.74-9.42-5.12-14.24c-4.36-15.27-8.4-30.62-12.85-45.87c-0.91-3.3,0.25-5.91,2.61-8.19c2.18-2.1,4.25-4.33,6.48-6.39
		c1.47-1.36,3.11-2.24,5.2-1.81c19.11,5.98,38.28,11.8,57.4,17.77c2,0.88,4.35,1.1,5.82,3.02c1.44,0.72,2.87,1.43,4.31,2.15
		c-0.01,0.23,0.09,0.36,0.31,0.4c-3.03,4.84-7.32,8.54-11.77,11.9c-2.69,2.03-5.67-0.65-8.53-1.15c-8.85-2.61-17.6-5.53-26.35-8.46
		c-1.98-0.79-4.04-1.38-6.06-2.03c-3.32-1.52-7-1.38-10.48-2.58c2.7,2.77,2.61,6.38,3.83,9.45c1.03,3.22,1.95,6.47,2.94,9.71
		C201.35,237.79,205.28,247.35,206.29,257.66z"
        />
        <path
          class="st59"
          d="M235.24,221.01c5.55,2.59,9.68,0.86,13.27-3.84c1.79-2.34,4.36-4.09,6.58-6.11c1.21,3.56-1.21,7.01-2.73,8.8
		c-2.9,3.41-6.06,7.41-12.09,7.14c-7.4-0.34-14.45-1.3-21.24-4.32c-2.72-1.21-5.82-1.02-8.69-2.22c-2.61-1.1-6.4,3.7-5.75,7.04
		c0.42,2.16,1.13,4.29,1.95,6.35c1.06,2.69,2.02,5.36,1.73,8.31c0.21,3.62,0.23,7.27,0.69,10.85c0.38,2.94-0.89,2.39-2.56,1.6
		c-0.97-8.06-3.82-15.68-5.6-23.54c-0.71-3.13-0.37-6.36-0.17-9.52c0.18-2.83,2.01-4.61,4.79-5.27c2.2-0.52,4.51-0.71,6.65-0.15
		c6.76,1.76,13.59,3.37,20.19,5.6C234.05,222.33,234.24,221.02,235.24,221.01z"
        />
        <path
          class="st61"
          d="M202.52,269c4.42-1.61,7.61-5.76,7.65-10.23c0.05-5.56,0.3-11.13-0.94-16.62c2.35,1.07,1.84-0.71,1.92-1.92
		c1.25,0.98,1.69,2.61,1.66,3.84c-0.2,6.79,1.49,13.55,0.28,20.35c-1.09,6.14-3.68,8.66-10.07,9.34c-3.68,0.39-4.08,2.96-4.33,5.77
		c-0.83,0.97-0.82,2.2-1.11,3.35c-0.26,1-0.65,2.13-2.12,1.26C193.39,277.03,196.37,272.28,202.52,269z"
        />
        <path
          class="st81"
          d="M632.97,282.41c2.95,1.05,4.96,3.34,6.95,5.56c3.66,4.08,8.1,6.9,13.18,8.82c0,2.56,0,5.12,0.01,7.68
		c0.15,1.39-0.31,2.64-0.96,3.83c-1.57-1.3-1.89-3.05-1.94-4.98c-0.06-2.03-0.24-4.1-2.85-4.61l0,0c-1.01-0.9-1.98-1.85-2.87-2.87
		C639.81,292.08,635.68,287.86,632.97,282.41z"
        />
        <path
          class="st72"
          d="M644.48,295.84c1.83,0.08,2.79,1.04,2.87,2.87C645.23,298.92,644.27,297.97,644.48,295.84z"
        />
        <path
          class="st80"
          d="M699.08,459.79c2.89,2.05,5.09,5.14,8.87,5.84c-7.38,6.91-10.85,16.23-15.36,24.91
		c-1.4,0.73-2.71,1.63-4.36,1.75c-5.52,0.39-7.41-2.14-6.37-8.56c2.31-8.81,7.99-15.04,15.64-19.46
		C699.8,462.93,699.71,461.69,699.08,459.79z"
        />
        <path
          class="st157"
          d="M705.12,516.25c-1.51-2.22-3.71-3.26-6.18-2.43c-1.73,0.58-1.7-1.07-2.65-1.3
		c5.93-7.66,9.42-16.71,14.29-24.97c6.27-0.59,7.28,0.44,8.85,9.06l0.07,0.33l-0.25,0.22c-1.51,0.98-1.58,2.58-1.78,4.12
		c-1.88,4.93-5.66,8.17-9.82,11.09C706.29,513.32,704.38,513.93,705.12,516.25z"
        />
        <path
          class="st121"
          d="M681.86,483.72c0.03,6.81,2.15,8.29,8.95,6.35c0.51-0.14,1.18,0.3,1.78,0.47c-0.43,3.83-3.71,6.14-5.07,9.48
		c-7.21-2.75-7.81-3.89-6.72-12.73C680.78,485.98,680.77,484.69,681.86,483.72z"
        />
        <path
          class="st121"
          d="M719.43,496.62c-0.68-2.01-2.57-3.18-2.66-5.84c-0.11-3.4-4.35-1.57-6.19-3.22c0.44-1.87,0.9-3.74,2.6-4.95
		c7.81-1.01,8.27-0.55,8.1,8.09C720.66,492.67,720.05,494.64,719.43,496.62z"
        />
        <path
          class="st158"
          d="M721.28,490.7c-1.51-5.54-1.51-5.54-8.1-8.09c0.49-1.58,1.59-2.72,2.82-3.71c2.52-2.02,4.55-1.39,5.38,1.6
		C722.31,483.84,722.65,487.31,721.28,490.7z"
        />
        <path
          class="st159"
          d="M680.81,487.28c0.04,1.74,0.14,3.48,0.1,5.21c-0.05,2.06,0.06,3.83,2.87,3.76c2.47-0.06,1.69,3.3,3.74,3.77
		c-0.4,1.96-1.72,3.08-3.6,2.97c-2.07-0.12-2.7-2.02-3.13-3.68C679.76,495.32,679.39,491.29,680.81,487.28z"
        />
        <path
          class="st121"
          d="M717.47,501.28c-0.18-1.71-2.17-4.19,1.78-4.12C719.26,498.8,718.68,500.18,717.47,501.28z"
        />
        <path
          class="st95"
          d="M708.59,524.95c-1.73-0.88-1.99-2.33-1.59-4.04C708.01,522.07,708.4,523.47,708.59,524.95z"
        />
        <path
          class="st160"
          d="M743.06,449.16c2.64-4.49,0.54-9.64,2.01-14.3c1.96-3.12,0.2-6.44,0.52-9.66c0.39-3.89-0.39-7.84,0.4-11.73
		c-0.22-0.24-0.21-0.47,0.03-0.69c1.88-0.15,1.47,1.29,1.47,2.27c0.01,3.64,0.15,7.28-0.01,10.92c0.13-9.96-0.55-19.93-0.22-29.87
		c0.24-6.91-0.29-13.87,0.83-20.75c0.62,0.1,1.51-2.15,1.76-0.13c0.7,5.73,2.4,11.39,1.14,17.29c-0.36,1.68-0.12,3.49-0.1,5.23
		c0.17,13.79-0.67,27.54-1.93,41.26c-0.37,4.01-3.72,6.66-4.74,10.37C743.77,449.65,743.38,449.6,743.06,449.16z"
        />
        <path
          class="st161"
          d="M680.92,416.64c-0.03-0.3-0.04-0.6-0.03-0.9c13.43,0.65,26.86,1.29,40.3,1.94c3.88-0.47,6.37,2.63,9.64,3.73
		c-0.09,7.11,0.11,14.24-0.4,21.32c-0.32,4.49,0.81,6.52,5.51,5.87c0.88-0.12,1.84,0.3,2.77,0.47c-0.4,0.48-0.9,0.62-1.49,0.42
		c-2.5-1.13-6.7,2.07-7.67-2.99c-1.23-1.71-1.08-3.69-1.07-5.63c-0.26-4.53,0.72-9.14-1.83-13.49c-2.09-3.55-4.83-5.81-8.79-6.66
		c-8.45-1.81-17.02-1.94-25.6-1.78c-2.29,0.36-4.5,0.21-6.53-1.07C684.28,416.8,682.62,416.66,680.92,416.64z"
        />
        <path
          class="st129"
          d="M685.72,417.86c1.92,0.22,3.83,0.47,5.71-0.23c6.1,2.32,12.55,1.32,18.82,1.8
		c12.84,0.97,16.47,4.12,18.3,16.77c0.22,1.52-0.15,3.25,1.09,4.54c-0.03,1.92-0.06,3.84-0.09,5.76c-2.32,0.73-2.26-1.29-2.51-2.45
		c-0.81-3.69-1.38-7.43-2.05-11.15c-1.13-6.27-4.6-9.08-10.98-9.62c-7.06-0.59-14.07-1.75-21.18-2.07
		C690.3,421.1,687.48,420.25,685.72,417.86z"
        />
        <path
          class="st158"
          d="M748.1,375.33c0.51,16.94,0.5,33.88-0.41,51.53c-1.67-5.08,0.81-9.86-1.67-14.1
		c0.3-11.63,0.62-23.25,0.89-34.88c0.05-2.38-0.12-4.77-0.19-7.15C748.97,371.74,747.66,373.8,748.1,375.33z"
        />
        <path
          class="st128"
          d="M737.21,449.49c0.5-0.14,0.99-0.28,1.49-0.42c1.45,0.03,2.91,0.06,4.36,0.08c0.39,0.07,0.77,0.13,1.16,0.2
		c-3.02,1.48-6.2,2.08-9.64,1.66C734.98,449.56,736.78,450.69,737.21,449.49z"
        />
        <path
          class="st162"
          d="M494.86,501.97l-0.45,0.01c0,0-0.45-0.01-0.45-0.01c0,0-0.01-0.01-0.01-0.01c-0.89-0.96-1.07-2.08-0.78-3.31
		c-0.2-1.33,3.39-3.42-0.82-3.94c-0.44-0.22-0.78-0.54-1.02-0.96c-0.63-4.63-3.85-8.86-2.12-13.84c2.29-2.56,2.27,1.6,4.06,1.47
		c0.97-0.07,2.1,1.91,3.68,1c0.42-0.24,0.7-1.06,0.7-1.61c0-1.84-1.48-1.61-2.7-1.86c-2.8-0.57-1.71-1.91-0.24-2.65
		c4.17-2.08,6.04-5.18,5.16-9.85c-0.46-2.44,2.24-3.06,2.98-5.06c1.36-3.68,3.11,0.23,4.74,0.44c1.54,0.2,3.07,0.57,4.6,0.86
		c6.57,2.25,12.23,6.23,18.22,9.59c-3.17-0.51-4.93,2.17-5.05,4.03c-0.35,5.41-4.25,5.96-7.87,6.31c-3.66,0.35-4.64,1.98-4.36,5.22
		c0.24,2.74,0.2,5.54-2.05,7.51c-1.71,1.49-3.45,4.38-6.01,0.65c-0.86-1.26-2.69-0.96-3.98-0.26c-1.74,0.95-0.74,1.98,0.08,3.06
		c0.3,0.39,0.27,1.63,0.08,1.7c-3.04,1.18-2.83,4.06-3.29,7.5C496.41,505.47,496.76,503.07,494.86,501.97z"
        />
        <path
          class="st118"
          d="M510.26,426.21c0.9-1.4-0.16-4.05,1.89-4.45c4.37-0.86,6.62-8.03,12.49-4.17
		C520.29,421.2,515.68,424.38,510.26,426.21z"
        />
        <path
          class="st118"
          d="M526.55,416.63c-0.35-0.87-2.11-1.32-0.97-2.59c1.22-1.36,2.07-0.16,2.9,0.69
		C528.44,415.97,527.8,416.6,526.55,416.63z"
        />
        <path
          class="st150"
          d="M481.5,459.77c0.92-4.75-1.9-8.94-2-13.54c0.02-0.28,0.07-0.56,0.14-0.83c0.31-0.02,0.62-0.01,0.92,0.03
		c1.47,6.14,2.7,12.35,4.54,18.38c0.76,2.5,1.21,4.9,1.2,7.45c1.55,3.71,1.15,7.87,2.63,11.6c0.63,4.01-0.51,6.47-4.96,7.56
		c-3.6,0.88-7.12,1.51-10.79,1.39c-2.72-0.09-4.43,0.67-4.93,3.79c-0.84,5.27-5.61,3.45-8.81,4.45c-3.74,1.72-8.61,1.11-11.14,5.39
		c-0.17,0.28-0.91,0.39-1.34,0.32c-7.33-1.31-12.95,1.41-17.37,7.17c-0.31,0.4-1.17,0.38-1.77,0.55c0.32-1.21,0.98-2.45,0.89-3.63
		c-0.24-3.13,0.95-4.39,4.09-4.07c1.96,0.2,3.58-0.53,3.58-2.81c0.01-2.71,1.62-3.69,3.9-3.8c3.06-0.16,4.86-1.52,4.76-4.67
		c-0.09-2.71,1.38-3.07,3.6-3.1c4.98-0.05,9.26-0.07,12.9-5.45c2.04-3.02,6.29-5.47,9.07-8.8c1.39-1.66,3.91-1.9,6.18-2.02
		c5.19-0.27,7.85-4.13,6.64-9.58c-1.26-1.06-1.02-2.66-1.43-4.02C481.86,460.92,481.96,460.27,481.5,459.77z"
        />
        <path
          class="st13"
          d="M488.21,482.79c-1.43-3.71-1.3-7.68-1.9-11.53c2.4,2.4,1.22,6.01,2.91,8.65c0.49,4.87,3,9.35,2.84,14.35
		c0.56,0.71,0.52,1.41-0.01,2.11c-0.55,0.17-1.01,0.04-1.39-0.39C488.09,491.91,488.8,487.23,488.21,482.79z"
        />
        <path
          class="st68"
          d="M195.81,284.33c1.63-1.2,0.38-4.12,2.87-4.79c0,1.6,0,3.2,0,4.8c0.02,6.45-1.05,12.56-4.93,17.98
		c-2.67,3.74-3.77,8.31-5.31,12.5c-1.73,4.71-5.01,8.28-7.02,12.67c-0.41,0.62-0.88,1.16-1.7,1.2c-0.44-0.25-0.73-0.62-0.87-1.11
		c-0.35-1.77,0.67-3.03,1.61-4.31c1.33-1.8,2.64-3.67,3.21-5.81c1.57-5.88,4.19-11.31,7.26-16.47
		C194.02,295.77,195.48,290.26,195.81,284.33z"
        />
        <path
          class="st68"
          d="M175.67,338.02c-0.64,0-1.28,0-1.92,0c-0.49-1.21,0.59-2.03,0.73-3.09c1.13-2.58,0.72-6.36,5.02-6.5l0,0
		c0.78,3.45-1.44,5.91-2.88,8.63C176.31,337.38,175.99,337.7,175.67,338.02z"
        />
        <path
          class="st112"
          d="M176.63,337.06c0.96-2.88,1.92-5.75,2.88-8.63c0.64-0.32,1.28-0.64,1.92-0.96
		C180.24,330.88,180.04,334.77,176.63,337.06z"
        />
        <path
          class="st64"
          d="M175.67,336.1c-0.64,0.64-1.28,1.28-1.91,1.92c-0.73,3.5-1.77,6.84-5.26,8.61c-2.08,1.05-1.3,2.53-0.9,4.08
		c2.79,11.03-3.42,23.24-12.05,27.58c-0.89,0.73-2.14,0.94-2.88,1.92l0,0c-1.58,1.64-4.08,1.42-5.75,2.87c-0.64,0-1.28,0-1.91,0
		c-5.21,0.51-7.98,3.2-7.67,8.63c-3.73-1.88-1.94-4.74-1.33-7.39c0.35-0.65,0.81-1.2,1.41-1.63c1.31-0.73,2.92-0.87,4.06-1.98
		c0.32-0.29,0.66-0.56,1.01-0.81c0.35-0.26,0.72-0.48,1.11-0.69c2.77-1.49,6.72-0.37,8.57-3.9c0.33-0.32,0.69-0.6,1.09-0.83
		c8.39-5.44,13.94-12.19,11.19-23.09c-0.82-3.24,0.38-6.22,2.3-8.89c2.28-1.38,2.56-4.16,4.2-6
		C172.41,334.8,173.86,333.45,175.67,336.1z"
        />
        <path
          class="st101"
          d="M146.91,383.08c1.15-2.49,3.22-3.14,5.75-2.87c0,0.96,0,1.91,0,2.87
		C150.75,383.07,148.83,383.07,146.91,383.08z"
        />
        <path
          class="st101"
          d="M152.66,380.2c0.09-1.94,1.48-1.93,2.88-1.92C155,379.56,154.05,380.2,152.66,380.2z"
        />
        <path
          class="st148"
          d="M481.5,459.77c0.32,0.32,0.64,0.64,0.96,0.96c-0.28,2.24,1.02,4.47,0,6.71c-1.43,0-2.87,0.09-4.3-0.01
		c-2.42-0.17-3.64,0.77-3.36,3.29c0.31,2.82-1.13,3.47-3.69,3.5c-2.67,0.03-5.34,0.56-8,0.95c-2.15,0.31-3.56,1.61-3.59,3.79
		c-0.04,2.91-1.44,4.08-4.18,3.81c-2.7-0.26-3.85,0.88-3.57,3.57c0.23,2.18-0.68,3.35-2.99,3.14c-1.98-0.18-3.67,0.8-5.5,1.26
		c-3.49,0.88-7.57,0.42-7.43,6.02c0.04,1.47-2.27,1.23-3.68,1.38c-4.44,0.47-9.64-0.25-10.51,6.25c-4.76,1.19-9.03,2.91-9.79,8.67
		c-0.03,0.23-1.47,0.44-2.23,0.37c-2.83-0.27-4.2,0.75-3.9,3.76c0.29,2.85-1.17,4.08-3.99,3.96c-2.07-0.09-4.15,0.09-6.21-0.04
		c-3.15-0.2-4.99,0.5-5.29,4.28c-0.39,4.95-4.62,3.03-7.49,3.41c0.44-3.79-0.32-8.34,6-7.85c1.96,0.15,1.78-2.01,1.63-3.35
		c-0.41-3.57,1.36-4.5,4.5-4.16c1.1,0.12,2.23,0.02,3.35,0.02c7.08,0,7.22,0,7.47-7.14c0.1-2.85,1.28-3.51,3.81-3.44
		c3.99,0.12,8.02,0.27,10.55-3.88c0.36-0.6,1.73-0.91,2.58-0.82c3.44,0.35,4.96-1.19,5.3-4.52c0.25-2.49,1.94-3.52,4.4-3.21
		c3.08,0.4,4.51-0.82,4.1-4.01c-0.33-2.58,0.64-3.95,3.45-3.69c1.07,0.1,2.48,0.31,3.02-0.89c3-6.58,10.12-7.36,14.94-11.12
		c3.95-3.08,7.36-3.16,11.42-3.3c0.97-0.03,2.01-0.03,2.51-1.02C473.83,462.42,476.43,459.31,481.5,459.77z"
        />
        <path
          class="st150"
          d="M427.81,513.46c1.31,6.55-4.21,6.58-7.73,6.98c-5.34,0.62-8.94,3.39-12.38,6.89
		c-0.81,0.82-1.68,1.47-2.9,1.46c1.08-3.88,1.4-8.31,7.23-8.17c1.19,0.03,2.03-1.84,2.01-2.99c-0.06-4.21,2.51-4.38,5.64-4.21
		C422.39,513.58,425.1,513.46,427.81,513.46z"
        />
        <path
          class="st131"
          d="M482.46,467.44c0.24-2.24-1.86-4.47,0-6.71c1.59,1.34,0.72,3.18,0.96,4.79
		C483.4,466.31,483.23,467.03,482.46,467.44z"
        />
        <path
          class="st13"
          d="M491.09,496.21c0.32,0,0.63,0,0.95,0c1.82,1.66,1.75,3.64,0.97,5.75c0,0.64,0,1.28,0,1.92
		c-5.15,0.82-9.55,3.88-14.65,4.84c-1.17,5.63-8.49,5.92-9.9,11.38c-0.16,0.61-0.74,1.28-1.29,1.33c-4.98,0.41-8.01,4.66-12.53,6.33
		c-3.42,1.27-8.72,2.12-9.91,7.31c-0.1,0.45-0.43,1.11-0.79,1.14c-5.32,0.5-6.27,5.3-8.64,8.71c-1.28,0.7-2.7,1.25-4.09,1.05
		c-7.12-1.06-14.15,0.71-21.23,0.49c0.63-5.65,3.58-9.24,8.16-10.54c6.3-1.79,12.79-3.2,18.07-7.48c3.21-1.04,7.1-1.2,7.33-5.99
		c0.04-0.74,0.79-1.48,1.54-1.72c6.55-2.15,12.33-6.01,18.38-9.08c4.32-2.2,7.78-6.46,12.86-7.9c0.79-6.95,6.62-5.7,11.02-6.78
		C488.58,496.66,489.8,496.25,491.09,496.21z"
        />
        <path
          class="st13"
          d="M435.48,544.14c0.32-1.21,0.98-2.45,0.89-3.63c-0.24-3.13,0.95-4.44,4.09-4.06c1.12,0.13,3.01-0.18,2.9-1.04
		c-0.94-7.35,8.26-4.19,9.38-9.23c5.79,1.74,7.69-6.42,13.29-5.25c0.34,0.07,1.16-0.44,1.15-0.66c-0.17-5.33,6.56-5.22,7.25-7.69
		c1.82-6.45,6.41-6.14,10.99-7.06c1.31-0.26,2.86-1.16,3.56-2.24c2.02-3.11,2.83-0.5,4.01,0.6c-1.3,8.12-1.28,8.2-8.33,9.57
		c-1.94,0.38-2.34,1.44-2.19,2.98c0.4,3.96-1.65,4.87-5.17,4.79c-2.33-0.05-4.68,0.62-7.01,1c-1.02,0.17-1.96,0.79-2,1.77
		c-0.25,6.59-4.96,5.2-8.86,4.92c-3.87-0.29-7.36-0.87-6.91,5.06c0.2,2.57-2.24,3.65-4.77,3.45c-2.58-0.21-3.91,0.66-3.69,3.45
		c0.34,4.37-4.15,2.36-5.72,4.24C436.96,546.09,436.12,545.43,435.48,544.14z"
        />
        <path
          class="st148"
          d="M435.48,544.14c0.96,0.32,1.92,0.64,2.88,0.96c1.07,0.67,0.09,1.27-0.06,1.9c-13.07,0-26.14-0.01-39.21-0.01
		c2.55-2.95,5.81-3.24,10.51-0.93C418.18,544.76,426.84,544.63,435.48,544.14z"
        />
        <path
          class="st149"
          d="M493.01,501.96c0.33-2.03-0.64-3.83-0.97-5.75c0.01-0.65,0.02-1.3,0.02-1.95c0.31,0.02,0.63,0.03,0.94,0.04
		c1.24,1.04,2.03,2.19,0.99,3.82c-0.01,1.28-0.03,2.57-0.04,3.85C493.63,501.96,493.32,501.96,493.01,501.96z"
        />
        <path
          class="st13"
          d="M491.09,496.21c-2.31,2.77-5.72,3.8-8.71,2.91c-2.8-0.84-3.84-0.29-3.65,2.11c0.32,4.07-2.36,5.02-5.24,5.35
		c-3.37,0.38-5.89,1.26-6.45,5.04c-0.08,0.56-0.66,1.54-0.89,1.51c-3.96-0.57-6.49,3.52-9.22,3.7c-4.64,0.3-6.35,6.19-11.27,4.74
		c-0.28-0.08-1.39,1.14-1.34,1.7c0.54,6.45-3.92,5.62-7.89,5.55c-2.33-5.17-1.66-7.36,3.11-9c1.89-0.65,2.97-1.63,3.2-3.57
		c0.44-3.85,2.23-6.11,6.47-5.75c1.2,0.1,1.98-0.82,2.56-1.82c-0.16-1.97,0.69-2.7,2.72-2.97c3.09-0.41,5.38-1.96,4.95-5.66
		c0.29-0.53,0.61-1.53,0.87-1.52c4.79,0.22,7.65-1.2,7.17-6.81c-0.14-1.68,2.26-1.13,3.59-1.24c4.17-0.37,8.23-0.21,12.5-1.4
		c4.22-1.17,4.35-3.27,4.62-6.28C489.1,487.28,490.83,491.58,491.09,496.21z"
        />
        <path
          class="st150"
          d="M451.78,508.67c-0.13,1.94-1.23,2.96-3.11,2.83c-3.8-0.25-4.56,2.06-4.56,5.12c0,1.75,0.12,4.4-2,4.2
		c-6.99-0.66-5.61,4.05-5.66,7.98c-0.3,2.52-1.4,3.92-4.27,3.89c-3.73-0.04-6.23,3.66-10.25,3.55c-1.66-0.04-3.45,1.3-5.41,1.23
		c-1.6-0.06-3.13,0.75-2.91,2.38c0.46,3.4-1.92,4.63-4,6.2c-3.49,0.5-7.16-1.07-10.51,0.93c-5.89-0.05-8-1.83-6.64-5.52
		c0.36-0.98,0.91-1.92,1.88-1.93c7.07-0.03,12.5-3.03,16.59-8.72c1.34-1.86,3.37-2.23,5.54-2.02c3.1,0.3,5-0.78,4.64-4.25
		c-0.3-2.83,1.15-3.46,3.69-3.47c3.83-0.03,11.39-6.16,12.53-9.85c1.49-4.82,2.28-5.15,6.31-2.6
		C446.34,510.33,449.06,509.87,451.78,508.67z"
        />
        <path
          class="st52"
          d="M465.19,454.96c-4.87,3.59-8.87,8.58-15.36,9.59C454.78,461.06,459.4,457.08,465.19,454.96z"
        />
        <path
          class="st135"
          d="M397.11,498.09c-0.26,0.86-1.63,1.09-1.22,2.36c0.54,1.66-0.05,3.09-1.76,3.25
		c-2.74,0.25,0.59-2.11-0.91-2.51c-0.6-0.16-1.25-0.14-1.88-0.21C393.04,499.56,394.62,497.91,397.11,498.09z"
        />
        <path
          class="st119"
          d="M390.39,500.99c-2.46-0.19-0.57-2.33-1.46-3.32c-0.45-0.51,0.09-1.19,0.84-1.27
		c0.99-0.11,1.54,0.51,1.44,1.39c-0.13,1.08-0.52,2.12-0.8,3.18C390.41,500.97,390.39,500.99,390.39,500.99z"
        />
        <path
          class="st135"
          d="M402.87,494.23c-1.39,2.09-3.33,3.34-5.76,3.86C398.39,495.85,400.39,494.69,402.87,494.23z"
        />
        <path
          class="st32"
          d="M436.43,336.11c0-0.64,0.01-1.29,0.01-1.93c2.78,4.78,4.5,9.96,5.77,15.31c2,1.87,0.87,4.61,1.89,6.75
		c0.32,0.96,0.65,1.91,0.97,2.87c0.98,1.76,0.47,3.04-1.29,3.87c-1.3,0.61-2.6,1.57-3.98,1.6c-6.09,0.13-7.46,5.31-10.09,9.14
		c-0.17,0.45-0.41,0.86-0.69,1.25c-1.67,2.27-4.77,1.13-6.76,2.97c-3.08,2.84-8.66,3.12-8.64,9.13c0.01,1.28-2.07,1.81-3.51,1.97
		c-1.71,0.19-3.09,0.63-3.28,2.64c-0.68,2.12-2.5,2.89-4.16,4.15c-4.09,3.11-10.08,3.73-12,9.96c-1.03,3.34-4.44,5.3-9.05,4.75
		c3.13,1.19,6.52,0.85,7.84,4.16c1.05,0.05,2.17-0.15,2.88,0.94c-0.59,0.59-1.3,0.7-2.08,0.52c-6-1.21-11.71-3.34-17.4-5.5
		c-1.74-1.12-3.59-2.02-5.49-2.86c-0.74-0.33-1.36-0.92-1.18-1.86c0.19-0.98,1.05-1.2,1.82-1.16c4.54,0.25,6.21-2.05,6.09-6.35
		c-0.05-1.73,1.26-2.96,2.88-3.45c2.38-0.71,4.02-3.15,5.87-3.66c5.01-1.39,7.84-5.66,11.69-8.32c3.69-2.55,10.03-3.14,10.78-9.37
		c0.07-0.6,0.68-1.15,1.26-1.38c7.28-2.89,12.35-8.94,18.76-13.05c0.67-0.43,1.61-0.85,1.66-1.62c0.36-5.07,3.88-6.37,8.06-7.15
		c1.15-0.22,2.28-0.29,1.15-2.67c-1.17-2.44,1.09-5.83,0.61-8.95c-0.09-0.6,0.13-1.25-0.39-1.75
		C436.44,336.74,436.44,336.43,436.43,336.11z"
        />
        <path
          class="st39"
          d="M389.47,414.71c-3.29-2.4-7.73-2.17-11.01-4.8c1-1.51,2.2-0.65,3.37-0.46c4.29,0.69,8.28-2.2,8.5-6.6
		c0.14-2.78,1.15-3.74,3.75-3.47c0.47,0.05,1.3,0.12,1.38-0.08c2.02-4.48,7.8-3.81,10.3-7.58c4.88-4.02,10.08-2.91,15.34-0.96
		c-0.13,1.21,0.41,3.26-0.93,3.37c-3.46,0.29-6.03,3.16-8.47,3.73c-7.73,1.8-11.07,7.08-14.16,13.17c-0.87,1.7-1.65,2.92-3.99,2.07
		C392.05,412.56,389.96,412,389.47,414.71z"
        />
        <path
          class="st48"
          d="M421.1,390.75c-5.1,0.47-10.33-1.03-15.34,0.96c-0.18-2.32,0.17-4.18,3.2-3.84c3.67,0.41,4.83-1.57,4.46-4.85
		c-0.33-2.89,0.89-4.1,3.78-3.8c0.76,0.08,2.06,0.06,2.24-0.33c1.95-4.04,6.25-2.94,9.33-4.44c0.54,2.44-1.24,4.65-0.6,7.22
		c0.24,0.97-1.34,2.19-2.66,2.21c-2.24,0.04-3.28,1.54-4.41,3.03C421.1,388.19,421.1,389.47,421.1,390.75z"
        />
        <path
          class="st48"
          d="M428.77,373.49c0.55-4.46,5.08-8.59,9.29-9.76c2.58-0.72,6.62-0.21,7.01-4.62c1.6,1.96,1.98,4.28,1.91,6.71
		c-2.82,6.48-6.7,8.93-13.56,8.26C431.88,373.93,430.25,374.18,428.77,373.49z"
        />
        <path
          class="st39"
          d="M428.77,373.49c2.03-2.39,4.33-0.23,6.47-0.27c5.52-0.12,8.96-3.14,11.74-7.4c0,0.64,0,1.28,0,1.92
		c0.6,0.64,0.56,1.28,0,1.92c-3.13,1.69-3.13,1.69-1.07,5.67c-4.3-2.02-7.99,0.85-11.93,0.13c-1.49-0.27-2.62,0.75-2.8,2.05
		c-0.84,5.92-5.48,7.6-10.08,9.4c-0.21-2.38,0.24-4.13,3.26-3.87c1.51,0.13,3.02-0.26,3.23-2.09c0.24-2.2-2.25-1.24-3.21-2.65
		c1.18-1.51,4.67-0.78,4.39-3.85C428.77,374.13,428.77,373.81,428.77,373.49z"
        />
        <path
          class="st27"
          d="M390.34,415.77c0.67-0.04,1.34-0.08,2.01-0.12c0.96,0.64,1.93,1.28,2.89,1.92c-0.97,0.01-1.93,0.02-2.9,0.03
		c-0.79-0.05-1.53-0.2-1.97-0.96c-0.29-0.18-0.4-0.38-0.31-0.57C390.15,415.87,390.25,415.77,390.34,415.77z"
        />
        <path
          class="st48"
          d="M444.1,356.24c-1.56-1.99-0.96-4.58-1.89-6.75c2.16,1,1.91,2.95,1.91,4.81
		C444.11,354.94,444.11,355.59,444.1,356.24z"
        />
        <path
          class="st48"
          d="M446.99,369.66c0-0.64,0-1.28,0-1.92c0.65-0.11,1.56-0.91,1.78,0.33
		C448.97,369.28,447.97,369.56,446.99,369.66z"
        />
        <path
          class="st42"
          d="M267.39,441.4c2.96-0.79,3.9-2.56,3.45-5.67c-0.45-3.12-0.19-6.35-0.25-9.53c0.47-0.3,0.9-0.26,1.3,0.14
		c1.35,2.31,1.39,4.84,1.27,7.41c-0.09,2.07-0.29,4.17,1.26,5.89c0.11,0.63,0.88-0.29,0.31,0.01c-0.15,0.08-0.15-0.08-0.27-0.36
		c-1.26-2.81,0.65-3.52,2.69-3.65c3.14-0.2,3.87-1.74,3.84-4.68c-0.04-4.28,0.99-8.53,0.86-12.85c-0.08-2.63,0.97-4.67,3.73-5.43
		c1.71-0.47,2.74-1.49,2.96-3.31c0.84-7.07,2.51-14.19-1.3-20.98c-0.55-0.98-0.95-2.21-0.28-3.19c0.88-1.28,1.99-0.25,2.97,0.1
		c0.89,0.31,1.93-0.05,2.74,0.63c4.03,0.14,7.79,1.38,11.47,2.9c-3.03,2.25-1.67,5.52-1.89,8.39c-0.29,3.8,0.74,7.56-2.92,10.91
		c-1.76,1.61-1.56,5.62-1.78,8.57c-0.18,2.41-0.54,3.89-3.46,3.82c-3.22-0.08-4.39,2.03-4.33,5.03c0.04,2.07-0.09,4.15,0.03,6.21
		c0.17,2.98,0.04,5.32-4.08,5.13c-2.58-0.12-3.07,2.3-2.58,4.18c1.19,4.53-1.85,7.1-4.11,10.1c-0.73,0.96-1.57,0.93-2.5,0.42
		c-1.02-0.56-1.99-2.05-3.1-0.17c-1.07,1.81,0.49,2.72,1.53,3.48c2.82,2.05,2.75,3.57-0.52,4.86c-0.32-0.74-0.64-0.74-0.96,0
		c-2.36,0.49-2.29,1.92-1.2,3.49c0.52,0.76,1.52,1.17,2.15,1.87c1.2,1.31,1.38,2.96,0.55,4.43c-0.54,0.96-1.82,0.35-2.65,0.19
		c-1.98-0.37-1.53-1.78-1.32-3.31c0.52-3.74-1.33-7.05-2.32-10.51c1.37-1.6,1.37-3.19,0-4.79c0.1-1.68-0.05-3.31-0.96-4.79
		c0.04-0.9-0.24-2.05,0.42-2.62C269.9,442.19,267.89,442.08,267.39,441.4z"
        />
        <path
          class="st163"
          d="M267.39,441.4c5.33,1.31,0.13,3.31,0.32,4.95c-0.63-0.63-1.26-1.27-1.88-1.9c0.29-0.95,0.58-1.9,0.88-2.85
		C266.87,441.35,267.1,441.28,267.39,441.4z"
        />
        <path
          class="st163"
          d="M268.67,451.15c3.06,1.59,3.06,3.19,0,4.79C268.67,454.34,268.67,452.74,268.67,451.15z"
        />
        <path
          class="st163"
          d="M273.46,459.77c-0.19-0.81-1.16-1.55-0.32-2.44c0.46-0.49,1.14-0.49,1.6,0c0.84,0.89-0.13,1.63-0.32,2.44
		C274.1,459.77,273.78,459.77,273.46,459.77z"
        />
        <path
          class="st49"
          d="M436.44,337.06c1.63,1.82,0.59,4.74,2.6,6.43c0.17,0.14,0.2,0.82,0.09,0.88c-6.91,4.11,0.66,3.65,2.53,5.81
		c-4.46-0.71-6.77,3.19-10.64,2.41c-1.13-0.23-2.32,1-2.09,2.14c0.82,4.14-2.87,4.64-4.68,6.82c-3.34,4.01-9.26,4.78-11.47,9.89
		c-0.2,0.46-1.05,0.97-1.55,0.93c-4.07-0.38-5.82,1.55-5.83,5.47c0,0.42-0.44,1.22-0.64,1.21c-4.89-0.3-6.53,5.21-10.79,5.96
		c-0.47,0.08-1.29-0.04-1.37,0.16c-1.77,4.32-5.82,5.55-9.56,7.21c-0.2,0.09-0.12,0.75-0.33,0.85c-4.85,2.42-9.04,5.11-8.51,11.72
		c0.05,0.65-4.64,1.37-7.4,1.17c2.33,1.09,4.76,1.78,6.36,3.83c-0.85,0.83-1.85,0.4-2.81,0.33c-3.4-1.65-7.02-2.7-10.64-3.73
		c-1.5-0.43-3.24-0.43-3.8-2.36c-0.74-0.54-1.47-1.07-2.72-1.98c3.47-0.26,4.98-4.03,8.72-3.16c0.83,0.19,2.36-1.09,3.05-2.06
		c2.51-3.54,5.58-6.23,8.98-8.97c2.44-1.97,3.97-4.8,7.65-5.18c1.38-0.14,1.1-1.75,1.34-2.78c0.75-3.26,2.63-4.86,6.1-4.65
		c2.72,0.16,4.94-0.39,5.52-3.83c0.26-1.53,1.38-3.76,3.28-3.64c3.94,0.24,5.37-3.3,7.4-5.17c1.53-1.42,2.44-2.43,4.62-2.76
		c4.89-0.74,2.73-4.45,2.61-7.56c0.82,0.21,1.55,0.36,2.27,0.59c4.16,1.34,6.94,0.13,7.12-4.47c0.13-3.24,1.56-4.15,4.47-3.81
		c3.44,0.4,5.62-1.26,6.03-4.59c0.34-2.75,0.57-4.63,3.55-1.86C436.08,337.87,436.26,337.46,436.44,337.06z"
        />
        <path
          class="st118"
          d="M355.91,404.17c4.48,2.71,10.08,2.6,14.39,5.72c0.33,0.22,0.43,0.44,0.32,0.66
		c-0.11,0.22-0.22,0.32-0.34,0.32c-1.67,0.15-2.5-1.38-3.84-1.89c-4.94-1.18-10.09-1.76-14.35-4.91
		C353.37,404.1,354.64,404.14,355.91,404.17z"
        />
        <path
          class="st21"
          d="M370.29,410.88c0-0.33,0.01-0.66,0.01-0.99c0.95,0.01,1.91,0.02,2.86,0.04c5.5,2.63,11.46,3.86,17.18,5.84
		c0.04,0.29,0.05,0.58,0.03,0.87c-3.29-0.56-6.13,0.52-8.87,3.04c-0.64-2.72,1.55-3.25,2.46-4.5c-1.8-0.51-3.42-0.97-5.04-1.43
		C376.04,412.8,373.17,411.84,370.29,410.88z"
        />
        <path
          class="st21"
          d="M375.08,413.76c0.64,0,1.28,0,1.91,0c0.11,0.64,0.91,1.56-0.33,1.77
		C375.47,415.74,375.18,414.74,375.08,413.76z"
        />
        <path
          class="st125"
          d="M332.9,322.68c0.43-2.86-0.96-5.93,0.95-8.62c0,3.51,0,7.03,0,10.54c-0.32,0.43-0.63,0.43-0.95,0
		C332.9,323.96,332.9,323.32,332.9,322.68z"
        />
        <path
          class="st92"
          d="M332.9,324.6c0.32,0,0.63,0,0.95,0c0,1.92,0,3.83,0,5.75C332.12,328.66,333.21,326.52,332.9,324.6z"
        />
        <path
          class="st69"
          d="M334.82,179.83c0.69,1.13,1.82,0.93,2.88,0.96c-10.08,6.12-20.95,3.51-31.63,2.87
		c2.94-3.06,7.34-0.76,10.54-2.87C322.95,185.66,328.81,181.36,334.82,179.83z"
        />
        <path
          class="st163"
          d="M292.66,385.94c-1.7,0.23-3.35-0.24-6.1-1.13c6.3,8.64,4,17.1,3.26,25.48c-0.2,2.27-0.6,3.65-3.22,3.49
		c-2.69-0.17-3.86,1.41-3.52,3.88c0.74,5.41-1.53,10.64-0.74,16.08c0.51,3.54-2.42,2.89-4.56,3.04c-1.03,0.07-2.47-0.49-2.85,0.97
		c-0.28,1.08,0.87,1.51,1.65,2.04c0.94,0.63,2.08,1.48,0.93,2.61c-1.3,1.28-2.33,0.04-3.09-0.95c-1.86-2.41-3.41-4.79-2.65-8.25
		c0.48-2.21-0.13-4.65-0.25-6.99c-1.29-4.72,0.38-9.63-0.92-14.35c0-11.76,1.11-23.37,4.66-34.65c-0.01,2.41,1.08,3.39,3.54,4.14
		C283.45,382.79,288.54,382.96,292.66,385.94z"
        />
        <path
          class="st87"
          d="M270.62,411.87c2.04,4.67,0.41,9.58,0.92,14.35c0,0-0.47,0-0.47,0s-0.47-0.01-0.47-0.01
		C270.09,421.42,270.11,416.64,270.62,411.87z"
        />
        <path
          class="st66"
          d="M352.07,141.49c2.72,0.85,3.64,3.63,3.62,5.55c-0.13,9.9,1.09,19.54,4.05,28.97
		c-1.25-0.03-1.88-0.67-1.92-1.92c-0.73-0.43-1.52-0.84-0.96-1.92c-0.94-5.48-3.64-10.66-2.88-16.44
		C354.64,150.8,353.42,146.14,352.07,141.49z"
        />
        <path
          class="st123"
          d="M356.87,172.16c0.32,0.64,0.64,1.28,0.96,1.92c-0.95,0.13-1.3,2.49-2.45,1.03
		C354.38,173.84,354.93,172.43,356.87,172.16z"
        />
        <path
          class="st123"
          d="M343.26,190.27c-0.45,0.38-0.73,0.8-1.04,0.84c-0.37,0.04-1.02-0.17-1.12-0.43
		c-0.27-0.7,0.25-1.11,0.91-1.09C342.36,189.6,342.71,189.96,343.26,190.27z"
        />
        <path
          class="st152"
          d="M382.5,362.41c0.74-2.69,2.93-3.25,5.29-3.56C386.03,360.03,384.27,361.22,382.5,362.41z"
        />
        <path
          class="st128"
          d="M155.67,484.69c1.52,4.96,1.62,9.92-0.03,14.87c-3.78,11.32-15.95,15.41-25.79,8.67
		c-9.23-6.32-15.29-22.14-12.8-33.42c1.97,1.72,1.44,4.1,1.5,6.23c0.08,2.76,1.13,5.25,1.78,7.84c3.57,5.86,5.58,12.92,12.51,16.17
		c7.4,4.94,19.78-1.29,20.07-10.95c0.09-2.9-0.83-5.28-2.53-7.48c-0.97-1.25-2.28-2.24-2.8-3.82c-0.01-3.49,1.83-3.11,3.79-1.63
		C152.84,482.28,154.05,483.74,155.67,484.69z"
        />
        <path
          class="st128"
          d="M119.16,490.48c-1.36-5.13-2.4-10.31-2.1-15.66c-0.36-2.96,1.88-5.35,1.81-8.25c1.9-0.09,0.86-1.8,1.45-2.57
		c1.13-1.5,1-4.09,3.64-4.3c2.63,6.27,5.22,12.56,6.6,19.26c-0.64,0.23-1.24-0.01-1.85-0.18c-6.01-1.69-5.82-1.66-7.13,4.81
		C121.09,485.9,122.71,489.18,119.16,490.48z"
        />
        <path
          class="st116"
          d="M132.62,484.68c0.85,3.86,3.31,4.05,6.4,2.81c0.63-0.34,1.29-0.39,1.98-0.24c0.63,0.59,1.34,0.61,2.19,0.55
		c5.79-0.4,8.96,3.82,7.18,9.48c-2.44,7.8-10.9,10.91-17.7,6.46c-3.98-2.61-5.93-6.61-6.88-11.07c-0.69-3.23,1.08-5.47,3.72-7.1
		C130.92,486.59,131.27,483.88,132.62,484.68z"
        />
        <path
          class="st134"
          d="M132.62,484.68c-0.9-0.15-0.71,1.93-2,0.98c-5.36-1.15-5.65-0.87-5.53,4.48c0.1,4.81,2.86,8.29,5.66,11.75
		c0.86,1.06,2.51,1.55,2.18,3.37c-0.13,0.18-0.26,0.36-0.4,0.55c-4.87-1.28-7.26-5.22-9.3-9.23c-1.14-2.24-2.43-4.25-4.07-6.09
		c1.41-3.68,1.24-7.62,1.84-11.43c0.22-1.42,0.06-2.96,1.64-3.62c1.43-0.6,2.99-0.42,3.75,1.02c0.94,1.78,3.4,0.66,4.16,2.49
		C130.72,481.04,133.15,482.32,132.62,484.68z"
        />
        <path
          class="st134"
          d="M148,482.85c7.3,4.81,7.84,12.21,3.89,17.83c-5.42,7.71-13.03,9.47-19.37,5.13c0,0,0.01-0.02,0.01-0.02
		c1.34-1.38,2.89-0.7,4.45-0.54c6.54,0.65,10.59-1.72,13.23-7.62c1.46-3.27-0.72-8.2-5.07-11.45c-0.1-0.22-0.19-0.44-0.28-0.67
		c0.63-0.28,1.26-0.57,1.89-0.85C147.56,484.32,147.17,483.16,148,482.85z"
        />
        <path
          class="st160"
          d="M148,482.85c-0.13,0.8-0.32,1.56-1.25,1.8c0.95-3.94-2-6.91-2.59-10.46c2.69,1.37,5.76-0.69,8.43,0.94
		c1.96,2.89,3.14,6.03,3.08,9.56c-2.73,1.33-3.5-1.13-4.75-2.52C149.42,480.48,148.43,480.24,148,482.85z"
        />
        <path
          class="st80"
          d="M123.94,459.69c-1.13,2.23-2.91,4.02-3.05,6.86c-0.11,2.37-1.32-0.53-2.04,0.02
		c-2.54-1.28-5.09-2.56-7.63-3.84c2.65-0.54,5-1.53,7.14-3.34c1.12-0.94,2.41-2.79,4.49-1.57
		C123.22,458.44,123.58,459.06,123.94,459.69z"
        />
        <path
          class="st161"
          d="M152.59,475.12c-2.82-0.2-5.89,1.81-8.43-0.94c-0.58-1.47-1.45-2.86-1.23-4.55
		c0.48-1.48,1.38-2.57,2.89-3.08C148.07,469.42,151.9,471.03,152.59,475.12z"
        />
        <path
          class="st119"
          d="M145.82,466.55c-0.96,1.03-1.93,2.05-2.89,3.08c-0.28-0.37-0.84-0.78-0.8-1.11c0.25-1.82-3.32-3.32-1.11-4.7
		C142.7,462.79,144.77,464.6,145.82,466.55z"
        />
        <path
          class="st134"
          d="M130.61,448.28c-0.08-0.76-2.39-1.27-0.17-2.32c2.69-1.27,5.34-1.65,8.13-0.45
		C136.08,446.89,133.4,447.75,130.61,448.28z"
        />
        <path
          class="st134"
          d="M141.15,487.59c-0.71-0.04-1.42-0.08-2.13-0.11c1.73-1.33,3.78-1.69,5.85-1.98l0.2,0.29
		C144.47,487.93,143.15,488.5,141.15,487.59z"
        />
        <path
          class="st47"
          d="M149.7,432c-3.07-1.97-6.13-3.94-9.2-5.91c-2.81-0.33-5-2.07-7.18-3.55c-11.38-7.74-23.38-14.55-34.43-22.78
		c-0.62-0.46-1.33-0.88-1.73-1.6c-1.05-1.27-2.41-2.07-3.92-2.66c-1.7-1.15-2.38-2.66-2.12-4.77c0.29-2.34,0.49-4.73,0.36-7.07
		c-0.25-4.42,1.39-7.48,5.67-8.96c1.23-1.32,3.36-1.07,4.48-2.57c1.53-1.84,3.67-2.61,5.82-3.39c1.78-0.33,3.44-0.98,5.01-1.9
		c12.51-5.87,25.28-11.15,37.73-17.13c2.05-1.31,4.32-1.83,6.72-1.93c0.27,0.12,0.46,0.05,0.56-0.24c3.57-0.82,3.18,2,3.04,3.78
		c-0.3,3.77-0.65,7.54-0.94,11.32c-0.26,3.35-2.96,4.63-5.55,5.89c-9.7,3.75-19.04,8.35-28.65,12.32c-2.95,1.17-5.88,2.37-8.61,4
		c-1.42,0.82-3.39,0.57-4.49,2.27c1.22,1.99,3.4,2.64,5.14,3.87c1.69,0.99,3.33,2.06,5.01,3.07c5.06,3.24,10.14,6.45,15.29,9.53
		c4.56,3.22,9.36,6.05,14.18,8.88c3.03,1.92,4.45,4.17,2.59,7.89c-1.33,2.67,0.41,5.92-0.91,8.76l-0.24,0.31
		c0,0,0.16,0.36,0.16,0.36C153.01,431.87,152.66,434.17,149.7,432z"
        />
        <path
          class="st73"
          d="M137.32,384.03c-1.09,2.56-1.78,5.12,0,7.67c0.32,0.96,0.64,1.92,0.96,2.87c-0.62,0.68-1.42,0.88-2.3,0.84
		c-1.25-0.15-2.13-0.84-2.78-1.89c-1.22-2.21-1.2-4.63-0.85-6.99C132.79,383.55,134.36,382.29,137.32,384.03z"
        />
        <path
          class="st73"
          d="M136.37,394.58c0.64,0,1.28,0,1.92,0c1.28,0.64,2.55,1.28,3.83,1.92c0.96,1.28,1.92,2.56,2.87,3.84
		C140.6,400.69,138.14,398.15,136.37,394.58z"
        />
        <path
          class="st104"
          d="M136.37,394.58c2.77,2.08,5.28,4.54,8.63,5.76c0.54,1.27,1.49,1.91,2.87,1.92c1.75,1.09,3.01,2.79,4.79,3.84
		c1.28,1.91,2.56,3.83,3.84,5.74c0,0.96,0,1.92,0,2.88c-1.41,0.43-2.18-0.62-2.67-1.5c-3.26-5.89-8.59-9.18-14.45-11.87
		c-0.72-0.33-1.3-0.91-1.92-1.42c-1.78-1.61-3.92-2.68-5.95-3.88c-5.34-3.17-7.45-11.13-0.32-14.94c1.65-0.88,3.03-2.28,4.92-2.76
		c3.95-0.02,7.34-1.85,10.35-4.01c2.35-1.69,4.76-2.95,7.47-3.78c1.13-0.39,2.25-0.83,3.44-0.2c0.43,3.54-2.93,3.56-4.69,5.07l0,0
		c-2.47,3.06-6.9,2.18-9.59,4.79l0,0c-2.03,1.33-4.48,1.57-6.66,2.58c-4.57,2.13-5.47,6.61-1.97,10.84
		C134.86,394.4,135.58,394.56,136.37,394.58z"
        />
        <path
          class="st106"
          d="M138.28,399.38c2.22,1.14,4.41,2.35,6.68,3.41c5.38,2.51,7.94,7.71,11.54,11.93
		c0.31,1.36,0.98,2.75,0.83,4.05c-0.11,1.03,1.92,4.43-2.19,2.8c-0.87-0.35-0.39,1.17-0.52,1.81c-0.38,1.9,0.76,4.09-1.06,5.73
		c0.14-2.99-0.07-6.06,0.53-8.96c0.73-3.5-0.49-5.65-3.39-7.24c-0.99-2.96-3.97-4.17-5.7-6.47c-1.23-1.58-3.14-2.06-4.76-3.04
		C138.78,402.53,137.01,401.65,138.28,399.38z"
        />
        <path
          class="st73"
          d="M152.66,406.09c-2.43-0.25-3.6-2.06-4.79-3.84C150.31,402.49,151.48,404.3,152.66,406.09z"
        />
        <path
          class="st117"
          d="M163.14,337.79c-0.94,1.03-1.87,2.07-2.81,3.1c-7.52,1.2-12.87-4.16-19.22-6.46
		c-3.63-1.32-7.01-3.34-10.5-5.05c-1.89-2.09-4.76-2.33-7.06-3.69c-1.33-0.79-2.46-1.34-2.53-3.02c2.91-1.5,5.16,0.47,7.52,1.53
		c7.5,3.39,14.61,7.6,22.29,10.6c2.5,0.98,4.95,2.07,7.69,2.17C160.11,336.99,161.36,338.9,163.14,337.79z"
        />
        <path
          class="st117"
          d="M156.9,347.78c-1.62,1.82-4.22,1.46-6.08,2.74c-11.33,2.72-21.52,8.24-31.94,13.16
		c-2.28,1.07-4.65,2.02-6.79,3.4c-0.73,0.57-1.54,1.03-2.39,1.4c-1.67-0.17-3.62,1.6-4.97-0.74c1.64-1.7,4.71-1.25,5.75-3.84
		c12.33-5.16,24.62-10.37,36.55-16.45C149.68,346.11,153.78,343.77,156.9,347.78z"
        />
        <path
          class="st103"
          d="M152.67,375.41c0.99-2.21,4.02-2.38,4.79-4.8c-0.74-1.73,0.81-2.66,1.38-3.94c0.25-0.36,0.54-0.68,0.84-1
		c3.37-4.95,4.02-10.08,1.06-15.45c-0.51-1.21-0.98-2.43-1.31-3.7c2.45-1.97,4.97-3.86,6.67-6.59c0.32,0,0.64,0,0.96,0
		c0.84,0.96,0.76,1.92,0,2.88c-2.82,5.46-0.68,11.2-0.92,16.81C165.89,365.21,158.4,374.19,152.67,375.41z"
        />
        <path
          class="st117"
          d="M159.42,346.53c0.63,1,1.25,2,1.88,3c1.6,6,2.46,11.92-1.91,17.26l0,0c-1.17,2.02-3.34,3.05-4.8,4.79
		c-4.39,0.6-7.33,3.97-11.02,5.9c-2.36,1.24-4.6,1.95-7.19,1.77c-0.2-2.27,2.37-2.18,3.11-3.66c3-2.32,6.77-3.17,9.93-5.22
		c1.17-0.76,2.65-1.05,3.28-2.5c4.79-1.44,6.34-4.71,5.95-9.55c-0.23-2.79,0.4-5.66,0.69-8.49c0.14-1.43,0.01-2.54-1.86-2.29
		C158.11,347.2,158.76,346.87,159.42,346.53z"
        />
        <path
          class="st58"
          d="M97.15,398.16c14.73,8.87,29.15,18.23,43.34,27.93c-0.87,0.55-1.09,2.98-2.85,0.94
		c-0.83-0.96-1.78-1.8-3.19-1.77c-9-7.05-19.51-11.86-28.49-18.86C102.89,403.99,98.53,402.54,97.15,398.16z"
        />
        <path
          class="st58"
          d="M104.73,367.74c1.6,1.05,3.2-0.32,4.79,0c0.59,1.85-1.64,1.04-1.94,2.06c-1.88,0.92-3.76,1.85-5.63,2.77
		c-0.47,0.44-0.86,0.37-1.16-0.2C101.01,369.91,103.41,369.28,104.73,367.74z"
        />
        <path
          class="st143"
          d="M100.79,372.38c0.39,0.07,0.77,0.13,1.16,0.2c-1.45,1.06-2.92,2.05-4.81,2.13
		C98.26,373.78,98.08,370.82,100.79,372.38z"
        />
        <path
          class="st63"
          d="M186.75,188.61c-5.51,1.22-13.33,10.25-12.88,14.88c0.21,0.59,0.53,1.25,0.05,1.78
		c-0.36,0.4-0.59,1.59-0.39,2.49c1.83,8.36,4.75,16.43,6.62,24.78c0.58,2.57,1.43,5.3-0.64,7.71c-3-2.47-1.73-6.26-2.83-9.36
		c-3.24-9.09-5.86-18.39-5.78-28.19c0.04-4.54,3.03-7.52,5.52-11.01c7.21-10.12,16.38-5.01,24.89-3.68
		c10.13,1.59,19.4,6.28,29.18,9.19c2.55,0.76,5,1.84,7.49,2.78c-1.02,1.07-2.36,1.21-3.72,1.28c-1.28,0.03-2.66,0.09-3.75-0.5
		c-7.22-3.87-15.43-4.65-22.97-7.63C200.96,190.53,193.87,189.25,186.75,188.61z"
        />
        <path
          class="st103"
          d="M179.51,240.23c0.29-8.65-3.07-16.57-5.46-24.6c-1.27-4.27-1.18-8.52-2.38-12.14
		c1.66-2.52,0.33,3.8,2.2-0.02c6.18,20.1,11.79,40.36,17.07,60.72c-1.28,0.15-2.57,0.9-3.13-1.34c-0.47-1.87-0.72-4.05-2.54-5.36
		c0,0,0-0.01,0-0.01c-2.01-2.16-1.25-5.36-2.87-7.67C180.53,246.89,182.51,242.81,179.51,240.23z"
        />
        <path
          class="st59"
          d="M250.47,208.5c-2.11-0.08-4.05-0.66-5.75-1.96c-0.2-0.18-0.29-0.38-0.28-0.6c0.02-0.23,0.05-0.35,0.09-0.33
		c0.4-0.7-0.1-0.76-0.63-0.81c-1.07-0.13-2.01-0.48-2.69-1.36c-0.48-0.79-0.9-1.58-0.36-2.51c4.65,0.63,8.61,2.64,11.91,6.04
		C251.98,207.5,251.22,208,250.47,208.5z"
        />
        <path
          class="st73"
          d="M182.39,249.82c3.02,1.78,1.54,5.25,2.87,7.67C182.53,255.59,182.47,252.7,182.39,249.82z"
        />
        <path
          class="st103"
          d="M240.86,200.93c0.32,0.64,0.64,1.28,0.96,1.91c-3.42,1.35-6.01,0.49-7.67-2.87c1.28,0,2.55,0,3.83,0
		C238.68,201.09,239.81,200.89,240.86,200.93z"
        />
        <path
          class="st151"
          d="M656.93,302.55c-0.49-2.38,0.6-4.22,2.04-5.95c2.23,0.42,2.33,2.4,2.8,3.99c1.09,3.66,2.12,7.33,3.16,10.99
		c0.75,1.87,2.55,2.3,4.16,2.79c1.9,0.57,3.42,1.51,4.56,3.12c3.22,2.02,6.94,2.25,10.5,2.94c3.96,0.76,7.65,2.24,11.2,3.99
		c4.77,2.35,5.64,5.53,3.2,10.2c-1.73,3.31-4.36,5.87-7.03,8.37c-5.62,5.26-10.54,11.01-13.44,18.26c-0.59,1.47-1.36,2.84-2.92,0.73
		c2.11-9.24,8.9-15.16,15.19-21.44c10.16-10.14,9.52-13.22-4.38-16.56c-8.51-2.04-16.82-4.18-24.24-8.98
		C658.53,311.47,656.33,307.55,656.93,302.55z"
        />
        <path
          class="st104"
          d="M679.95,345.69c0.16-1.52,0.67-2.86,1.92-3.83C681.96,343.5,681.7,344.97,679.95,345.69z"
        />
        <path
          class="st27"
          d="M706.53,399.49c3.34-0.06,6.75-0.6,9.99-0.07c7.08,1.16,10.13-4.95,14.82-7.92c1.04-0.66,0.18-4.18,0.38-6.36
		c0.18-1.98-0.76-4.17,0.97-5.9c0.39,6.2-0.18,12.38-0.57,18.56c-0.09,1.48-0.15,2.81-2.31,2.7
		C722.05,400.09,714.25,400.74,706.53,399.49z"
        />
        <path
          class="st164"
          d="M730.82,421.41c-0.82,0.3-1.25,2.01-2.57,0.38c-1.79-2.21-4.33-3.41-7.07-4.11c2.34,0,4.68,0.09,7.01-0.02
		C731.17,417.51,731.76,418.89,730.82,421.41z"
        />
        <path
          class="st158"
          d="M746,413.46c0.72,5.9-0.74,11.9,0.86,17.79c0.37,1.35-0.54,2.71-1.78,3.6
		C744.96,427.71,744.96,420.56,746,413.46z"
        />
        <path
          class="st47"
          d="M663.8,312.66c-1.59-5.36-2.6-10.89-4.82-16.06c0.6-0.62,1.2-1.24,1.8-1.86c0.96,0.35,1.47,1.94,2.88,1.03
		c1.17,0.76,2.34,1.53,3.85,1.1c1.54-0.86,3.11-0.39,4.65-0.05c17.38,3.87,34.8,7.58,52.12,11.72c2.74,0.66,5.43,1.49,7.38,3.74
		c0.74,2.92,1.06,6.03,2.32,8.7c2,4.24,1.23,7.49-2.23,10.36c-2.77,4.76-7.21,8.01-10.91,11.92c-2.52,2.66-5.11,5.24-7.59,7.93
		c-6.19,5.52-11.92,11.51-17.71,17.43c-0.29,0.33-0.6,0.63-0.92,0.93c-0.95,0.87-1.87,1.79-2.91,2.57c-1.49,0.89-2.44,2.32-3.5,3.63
		c-0.76,0.86-1.76,1.25-2.87,1.38c-1.55,1.42-2.62,0.91-3.39-0.83c-0.35-0.94-0.69-1.88-1.04-2.81c-5.06-8.23-4.7-11.74,1.88-18.46
		c5.99-6.3,12.81-11.72,18.94-17.88c0.29-0.33,0.61-0.63,0.93-0.92c0.95-0.87,1.86-1.78,2.76-2.71c2.17-1.79,3.45-4.41,5.71-6.13
		c1.27-0.88,2.31-2.06,3.8-2.95c-2.25,0.12-4.22-0.61-6.24-1.01c-1.29-0.43-2.64-0.5-3.98-0.63c-1.65-0.23-3.24-0.79-4.9-0.99
		c-0.5-0.07-0.99-0.2-1.47-0.34C686.72,318.86,674.85,317.38,663.8,312.66z"
        />
        <path
          class="st128"
          d="M683.82,355.34c-5.8,3.92-6.09,9.06-3.4,14.95c0.43,0.95,0.34,2.13,0.48,3.21
		c-1.06,0.14-1.98,2.85-3.16-0.58c-1.25-3.62-1.81-7.26-2.57-10.92c3.76,0.79,2.13-2.87,2.75-4.06c3.67-7.06,9.32-12.29,14.74-17.81
		c1.65-1.68,3.24-3.5,4.5-5.48c2.95-4.64,2-7.47-3.02-9.64c-4.66-2.01-9.46-3.51-14.5-4.25c-2.66-0.39-5.32-0.84-7.34-2.88
		c1.29-1.3,2.97-1.45,4.45-0.84c5.36,2.21,11.18,2.49,16.65,4.19c1.98,0.62,3.91,1.41,5.63,2.59c4.4,3,5.19,7.3,1.91,11.47
		c-1.77,2.25-3.41,4.62-5.39,6.7C691.92,346.68,686.88,350.14,683.82,355.34z"
        />
        <path
          class="st133"
          d="M687.25,375.25c1.05-1.54,2.1-3.07,3.91-3.83c1.7-0.23,2.84-1.04,2.98-2.88l0.01,0
		c1.92-0.51,3.19-1.88,4.48-3.29c1.15-1.24,2.35-2.56,4.33-2.3c0,0.96,0,1.91-0.01,2.87c0.02,0.81-0.37,1.41-0.95,1.92
		c-0.96,0.96-1.92,1.91-2.89,2.87c-1.29,0.94-2.69,1.74-3.83,2.88v0C692.62,374.14,690.6,377.75,687.25,375.25z"
        />
        <path
          class="st3"
          d="M687.25,375.25c2.99,0.83,5.02-2.72,8.04-1.77c-0.32,0.64-0.64,1.28-0.95,1.92c-2.82,1.5-5.48,3.85-9,1.73
		C685.97,376.51,686.61,375.88,687.25,375.25z"
        />
        <path
          class="st3"
          d="M702,367.74c0.01-0.79,0.18-1.51,0.95-1.92c3.4-2.3,5.42-6.33,9.59-7.67
		C709.32,361.67,706.68,365.82,702,367.74z"
        />
        <path
          class="st3"
          d="M695.29,373.49c0.29-2.27,2.09-2.53,3.83-2.88C698.29,372.16,697.23,373.42,695.29,373.49z"
        />
        <path
          class="st120"
          d="M686.87,251.67c1.35,0.98,2.2,2.32,2.81,3.83c-4.42-0.35-8.18,1.25-11.59,3.92
		c-0.66-1.3-1.32-2.59-1.97-3.89c-0.24-4.55,1.42-6.12,6.04-5.72C683.92,249.96,685.62,250.25,686.87,251.67z"
        />
        <path
          class="st9"
          d="M665.34,265.22c0.87,0.85,1.48,2.14,3.06,1.78c-2.24,3.92-5.08,7.5-6.74,11.76c-0.65-0.91-1.31-1.83-1.96-2.74
		C659.41,269.91,661.07,266.72,665.34,265.22z"
        />
        <path
          class="st31"
          d="M650.39,288.01c3.31,0.55,4.75-2.45,7.07-3.76c1.48-0.84,2.83-1.9,4.24-2.87c0.33,0.66,0.66,1.33,0.99,1.99
		c-2.31,3.5-6.12,4.85-9.58,6.7c-1.37,0.01-2.86,0.2-2.96-1.84L650.39,288.01z"
        />
        <path
          class="st9"
          d="M668.39,267c2.58-2.62,5.62-4.63,8.72-6.57C676.79,264.52,672.61,267.67,668.39,267z"
        />
        <path
          class="st153"
          d="M650.16,288.23c0.99,0.61,1.97,1.23,2.96,1.84c0.57,0.96,0.6,1.92-0.01,2.88c-2.4-0.99-4.93-1.75-6.71-3.82
		c-0.77-0.88-2.53-1.1-1.91-2.89C646.68,286.04,648.37,287.26,650.16,288.23z"
        />
        <path
          class="st87"
          d="M731.65,312.28c-7.37-3.6-15.56-4.12-23.36-6.04c-13.54-3.34-27.19-6.27-40.79-9.37
		c0.91-3.37,3.69-2.14,5.51-1.77c15.65,3.13,31.41,5.85,46.73,10.38C724.09,306.76,729.36,307.1,731.65,312.28z"
        />
        <path
          class="st53"
          d="M712.57,350.58c5.78-7.02,12.57-13.04,19.17-19.24c0.39,2.92-0.42,5.36-2.87,7.12
		c-5.65,4.07-8.73,10.96-15.36,13.94C712.66,352.07,712.16,351.56,712.57,350.58z"
        />
        <path
          class="st110"
          d="M712.57,350.58c0.31,0.61,0.63,1.21,0.94,1.82c-3.49,3.55-6.29,7.77-10.55,10.55
		c-3.46,1.04-4.19,6.38-8.81,5.59C699.94,362.2,705.83,355.96,712.57,350.58z"
        />
        <path
          class="st165"
          d="M488.21,116.59c3.17,0.04,5.87,1.54,8.65,2.8c8.93,5.99,10.58,10.92,7.1,21.18
		c-0.67,1.96-1.58,3.84-2.33,5.77c-0.95,1.26-0.33,3.72-2.86,3.77c-0.26-2.61,0.73-4.86,1.64-7.27c4.46-11.71,3.21-15.67-9.45-22.44
		C489.62,119.7,485.62,120.33,488.21,116.59z"
        />
        <path
          class="st157"
          d="M498.75,150.11c1.56-0.82,0.37-3.01,1.92-3.83c1.68,2.01,0.43,4.08,0.14,6.13
		c-1.04,3.89-1.72,7.89-3.85,11.41C494.85,158.9,497.19,154.56,498.75,150.11z"
        />
        <path
          class="st136"
          d="M495.88,143.41c0.64-0.32,1.28-0.64,1.92-0.96c-0.96,3.51-1.92,7.03-2.88,10.54
		C494.34,149.7,496.02,146.65,495.88,143.41z"
        />
        <path
          class="st89"
          d="M512.15,174.99c-0.11-0.32-0.05-0.61,0.19-0.86c1.21-0.46,2.42-1.22,3.66-0.07c0,0,0.01,0.02,0.01,0.02
		c-0.63,1.28-1.59,2.25-2.88,2.87C512.81,176.3,512.48,175.65,512.15,174.99z"
        />
        <path
          class="st120"
          d="M516,174.07c-1.22-0.04-2.42,1-3.66,0.07c1-3.61,1.82-7.28,3.7-10.58c3.56-4.49,3.61-10.42,6.26-15.27
		c0.22-0.41,0.29-0.91,0.46-1.35c3.48-9.39,8.21-12.52,18.17-11.58c2.79,0.26,5.64,0.57,8.37,1.38c0.74,0.35,1.48,0.71,2.22,1.06
		c0.41,3.81-2.61,1.78-3.45,1.55c-2.84-0.77-5.66-0.72-8.51-0.73c-7.41-0.02-13.06,3.57-14.64,10.59
		C522.95,157.91,518.94,165.78,516,174.07z"
        />
        <path
          class="st124"
          d="M491.89,102.24c-1.12,0.06-2.18-0.07-3.05-0.88c9.73-3.12,18.01,2.31,26.87,4.47
		c6.21,1.51,11.76,5.5,18.51,4.98c5.87,2.31,11.79,4.49,17.57,6.99c3.12,1.35,6.03,3.24,7.21,6.79c-1.89-0.69-3.79-1.38-5.68-2.06
		c-6.71-4.78-14.68-6.57-22.29-9.03c-9.04-2.92-18.1-5.85-27.19-8.64C499.91,103.65,495.92,102.9,491.89,102.24z"
        />
        <path
          class="st125"
          d="M491.89,102.24c3.31-1.21,6.63-0.42,9.72,0.52c13.86,4.22,27.74,8.41,41.39,13.23
		c3.68,1.3,8.35,2.09,10.32,6.54c-16.01-5.19-32.03-10.32-48.01-15.59C500.82,105.45,496.12,104.51,491.89,102.24z"
        />
        <path
          class="st121"
          d="M549.3,136.73c-3.89-0.02-7.79-0.18-11.67-0.01c-7.34,0.31-11.64,3.85-13.89,10.77
		c-1.75,5.36-3.9,10.6-5.62,15.97c-0.84,2.64-1.41,0.04-2.08,0.1c2.15-8.87,5.17-17.46,8.47-25.96c2.56-3.8,5.44-7.01,10.72-5.72
		C539.95,133.39,544.87,134.34,549.3,136.73z"
        />
        <path
          class="st160"
          d="M500.82,152.41c-0.05-2.04-0.09-4.09-0.14-6.13c0.35-1.04,0.65-2.1,1.07-3.1
		c4.63-10.98,4.1-13.59-4.51-22.44c-0.28-0.29-0.27-0.88-0.39-1.33c2.43,0.09,4.61,1,6.71,2.13c5.15,3.6,4.85,8.42,3.07,13.58
		C505.05,141,503.24,146.81,500.82,152.41z"
        />
        <path
          class="st48"
          d="M506.63,135.12c1.33-5.06-0.57-9.39-3.07-13.58c1.38,0.34,2.76,0.68,4.14,1.01c2.36,0.56,3.12,1.79,1.98,4.11
		C508.36,129.35,508.36,132.55,506.63,135.12z"
        />
        <path
          class="st111"
          d="M535.23,131.87c-4.58,0.02-7.33,3.49-10.72,5.72c-0.01-0.16-0.06-0.33-0.02-0.48
		C527.37,127.79,525.26,128.34,535.23,131.87z"
        />
        <path
          class="st136"
          d="M644.48,286.24c0.64,0.96,1.28,1.93,1.91,2.89c-5.09-2.58-8.67-6.67-11.5-11.51c0-0.64,0-1.28,0-1.92
		C638.54,278.8,642.36,281.75,644.48,286.24z"
        />
        <path
          class="st152"
          d="M577.36,164.5c4.68-1.44,7.45,2.68,10.98,4.22c2.7,1.18,5.32,3.33,8.07,4.88c0.87,0.49,1.61,1.9,2.8,0.58
		c1.13-1.25,0.52-2.31-0.55-3.26c-3.44-3.02-6.69-6.28-10.36-8.97c-2.34-1.72-2.35-5.38-5.78-6.17c-0.79-0.18,0.36-1.96,0.69-2.98
		c1.61,0.48,2.77,1.58,3.82,2.82c4.46,5.71,11.56,8.37,16.15,13.93c0.5,0.61,1.22,1.02,1.75,1.61c2.28,2.52,3.5,7.63,1.9,9.2
		c-2.77,2.72-5.97,1.59-8.84,0.13c-4.67-2.38-9.05-5.35-12.96-8.81c-1.58-1.4-3.15-1.89-4.95-2.32c-1.4,0.09-2.2-0.71-2.78-1.86
		C576.87,166.5,576.89,165.5,577.36,164.5z"
        />
        <path
          class="st166"
          d="M580.08,169.37c2.07-0.93,3.21-1.28,5.45,1.04c4.32,4.47,9.77,7.99,15.78,10.16
		c1.54,0.55,4.33,0.98,4.77-0.73c0.74-2.84,0.37-6.05-2.25-8.26c-4.33-3.65-8.56-7.47-13.14-10.77c-1.98-1.43-2.89-3.13-3.66-5.17
		c8.26,5.41,16.33,11.08,23.95,17.38c0.79,2.91,2.04,5.95,0.21,8.75c-2.41,3.67-5.96,4.46-10.04,2.96
		C593.88,179.94,586.81,174.89,580.08,169.37z"
        />
        <path
          class="st134"
          d="M632.02,168.33c8.39,13.19,2.74,32.45-12.47,37.39c-0.56,0.52-1.21,0.61-1.93,0.39
		c-2.31-1.86-0.71-2.53,0.96-3.19c15.78-8.18,18.6-21.7,7.58-36.28c-0.54-1.45-1.41-2.55-2.99-2.92l0.23-0.08l-0.22,0.1
		c-0.16-0.95,0.21-1.35,1.17-1.16C627.95,163.1,629.03,166.98,632.02,168.33z"
        />
        <path
          class="st166"
          d="M590.01,219.51c-0.12-1.7-0.24-3.41-0.37-5.11c0.04-4.96-1.27-9.74-2.36-14.48
		c-1.69-7.34-9.5-10.02-17.22-6.23c-1.27,0.62-2.32,1.7-3.9,1.52c2.08-2.92,4.16-5.84,6.24-8.76c2.08,0.84,4.12-1.1,6.21-0.09
		c0.15,0.05,0.31,0.09,0.45,0.15c9.6,4.57,14.6,11.43,11.82,22.6C590.06,212.45,591.11,216.1,590.01,219.51z"
        />
        <path
          class="st129"
          d="M624.35,162.58c-0.39,0.39-0.78,0.77-1.17,1.16c-9.53-6.39-18.84-13.09-27.84-20.2
		c3.77-2.25,5.96,1.43,8.16,2.84C610.91,151.12,617.84,156.62,624.35,162.58z"
        />
        <path
          class="st152"
          d="M550.5,186.46c-2.17-2.57,0.18-4.56,1.15-6.4c3.59-6.78,7.15-13.71,15.11-16.54
		c-1.42,2.56-2.91,5.07-5.32,6.86c-1.56,0.32-0.42,2.01-1.34,2.66c-0.68,0.97-1.35,1.94-2.03,2.91c-1.59,0.32-1.5,1.72-1.82,2.85
		C554.57,181.55,553.06,184.4,550.5,186.46z"
        />
        <path
          class="st152"
          d="M617.62,205.71c0.64,0,1.29,0,1.93,0.01c-0.8,2.3-3.25,2.89-4.73,4.53c-4.52,5.03-5.05,11.27-5.83,17.48
		c-0.32-0.31-0.63-0.61-0.95-0.92c-0.91-1.98-0.32-4.03-0.37-5.84c-0.49,1.78,0.34,3.9-0.46,5.88c-0.05,1.57-0.1,3.14-0.14,4.71
		c-0.42-0.03-0.85-0.06-1.27-0.09c0.41-5.39,0.82-10.78,1.24-16.17c1.8-1.83,2.17-4.58,4-6.36
		C612.85,207.16,614.27,204.41,617.62,205.71z"
        />
        <path
          class="st167"
          d="M601.15,184.72c1.43-1.06,3.15,0.03,4.39-0.35c2.96-0.91,5.81-2.48,5.35-6.45c-0.19-1.65-1.2-3.3,0.09-4.91
		c1.86,0.38,2.61,2.03,3.73,3.26c0.71,1.71,0.85,3.52,0.92,5.34c-0.34,0.98-0.69,1.97-1.03,2.95c-1.36-0.64-2.13,0.01-3.01,1.07
		c-1.47,1.78-3.34,2.94-5.83,2.05C603.83,187.3,602.46,186.06,601.15,184.72z"
        />
        <path
          class="st168"
          d="M617.62,205.71c-4.47,1.1-6.7,4.51-8.35,8.35c-0.54,1.26-0.85,1.96-2.24,1.23
		c-0.16-3.76-1.36-8.61,1.1-10.87c2.14-1.96,6.87-1.11,10.45-1.51C618.02,203.77,616.56,204.31,617.62,205.71z"
        />
        <path
          class="st169"
          d="M605.76,187.68c2.83-0.05,4.65-1.88,6-3.95c2.21-3.39,1.86,0.73,2.84,0.83
		C612.51,188.01,609.8,189.72,605.76,187.68z"
        />
        <path
          class="st57"
          d="M578.62,186.35c-2.06,0.94-4.11,2.01-6.21,0.09C574.42,181.86,576.52,184.2,578.62,186.35z"
        />
        <path
          class="st169"
          d="M615.63,181.6c-2.18-1.46-0.46-3.58-0.92-5.34C616.18,177.84,617.11,179.51,615.63,181.6z"
        />
        <path
          class="st166"
          d="M556.24,178.81c-0.79-1.84-1.93-3.9,1.82-2.85C558.1,177.32,557.17,178.06,556.24,178.81z"
        />
        <path
          class="st166"
          d="M577.36,164.5c0.66,1.01,0.54,2.01-0.06,3.01c-0.92-0.7-1.84-1.39-2.76-2.09
		C575.48,165.11,576.42,164.81,577.36,164.5z"
        />
        <path
          class="st129"
          d="M623.17,163.72c2.15-0.21,3.04,0.88,2.99,2.92C625.17,165.67,624.17,164.69,623.17,163.72z"
        />
        <path
          class="st166"
          d="M560.09,173.04c0.22-1-1.45-2.96,1.34-2.66C561.64,171.6,561.82,172.8,560.09,173.04z"
        />
        <path
          class="st128"
          d="M639.85,231.6c8.55,10.09,16.25,20.81,23.84,31.62c-4.04,1.64-4.35,6.15-6.89,8.95
		c-7.71-9.63-15.09-19.5-22.03-29.71c-0.63-1.6-1.47-3.04-3.02-3.95l0.13-0.23l-0.15,0.22C634.51,234.37,637.53,231.79,639.85,231.6
		z"
        />
        <path
          class="st151"
          d="M656.8,272.17c-0.57-3,2.03-5.03,2.42-7.86c0.3-2.16,3.15,0.24,4.48-1.09c0.55,0.67,1.1,1.33,1.64,2
		c-4.48,2.24-3.36,7.4-5.65,10.79C658.49,274.91,657.01,274.01,656.8,272.17z"
        />
        <path
          class="st125"
          d="M639.85,231.6c-0.66,0.32-1.82,0.54-1.91,0.99c-0.71,3.46-3.45,4.67-6.2,5.92
		c-1.45-0.94-2.17-2.44-2.98-3.87c6.76-1.9,7.75-3.13,7.12-8.82C637.65,227.43,639.1,229.28,639.85,231.6z"
        />
        <path
          class="st151"
          d="M646.19,282.45c-0.93,0.58-1.85,0.62-2.48-0.36c-2.52-3.89-6.93-6.69-6.94-12.03
		C640.61,273.66,643.48,278,646.19,282.45z"
        />
        <path
          class="st129"
          d="M630.11,261.33c-4.72-2.11-8.38-7.27-7.6-10.71C625.38,253.95,628.48,257.12,630.11,261.33z"
        />
        <path
          class="st151"
          d="M635.83,269c-2.31-1.69-7.5-1.3-4.81-6.62C633.28,264.1,635.01,266.22,635.83,269z"
        />
        <path
          class="st125"
          d="M631.76,238.51c2.77-0.03,2.84,2,3.02,3.95C633.37,241.45,632.44,240.08,631.76,238.51z"
        />
        <path
          class="st136"
          d="M624.35,261.32c-3.73-3.93-8.93-6.91-8.63-13.43C619.21,251.97,621.59,256.77,624.35,261.32z"
        />
        <path
          class="st136"
          d="M634.89,275.7c-2.55-1.56-3.95-3.94-4.8-6.71C632.37,270.75,635.06,272.21,634.89,275.7z"
        />
        <path
          class="st136"
          d="M629.14,268.03c-2.01-1.94-4.04-3.87-4.79-6.71C626.89,262.88,628.7,264.97,629.14,268.03z"
        />
        <path
          class="st154"
          d="M607.21,226.85c0-1.86,0-3.73,0-5.59c0.28-0.01,0.55-0.02,0.83-0.03c0,1.86,0,3.73,0,5.59
		C607.76,226.81,607.49,226.82,607.21,226.85z"
        />
        <path
          class="st121"
          d="M686.87,251.67c-1.68-0.26-3.38-0.46-5.05-0.78c-3.77-0.71-5.16,1.42-5.7,4.64
		c-9.37-11.84-18.37-23.96-27.03-36.33c3.37-1.3,6.47-2.99,8.8-5.85c4.11,3.15,6.4,7.77,9.44,11.77
		C673.97,233.88,680.38,242.81,686.87,251.67z"
        />
        <path
          class="st155"
          d="M657.9,213.35c-0.95,4.93-4.14,6.49-8.8,5.85c-1.38-0.93-2.28-2.23-2.89-3.76c4.27,0.13,7.49-0.93,7.55-6.12
		c0.01-0.94,0.24-2.32,1.75-2.5C654.5,209.67,657.58,211,657.9,213.35z"
        />
        <path
          class="st165"
          d="M684.43,224.04c2.83,1.98,7.47,2.61,5.91,7.89C688.08,229.52,686.07,226.92,684.43,224.04z"
        />
        <path
          class="st165"
          d="M679.54,217.4c4.63-0.47,3.67,3.15,4.18,5.7C682.33,221.2,680.94,219.3,679.54,217.4z"
        />
        <path
          class="st165"
          d="M675.73,212.58c2.22,0.41,4.18,1.02,3.11,4C677.81,215.24,676.77,213.91,675.73,212.58z"
        />
        <path
          class="st58"
          d="M158.52,336.98c-1.95,1.55-3.91,0.67-5.81-0.04c-7.95-2.94-15.33-7.12-22.94-10.79
		c-2.85-1.37-5.62-2.85-8.74-3.48c-0.79-0.03-1.5-0.19-1.92-0.96c-1.36-1.23-3.28-1.04-4.79-1.92c-0.96-0.64-1.92-1.28-2.88-1.92
		c-0.43-1.24-0.05-2.2,1.01-2.93C127.97,321.97,143.38,329.2,158.52,336.98z"
        />
        <path
          class="st117"
          d="M112.45,314.95c-0.34,0.98-0.68,1.95-1.01,2.93c-0.65-2.7-5.99-1.5-4.8-5.75c0.82-0.02,1.46,0.31,1.9,1
		C109.67,314.12,111.11,314.43,112.45,314.95L112.45,314.95z"
        />
        <path
          class="st117"
          d="M114.32,319.81c1.85,0.01,3.83-0.32,4.79,1.92C117.23,321.78,115.56,321.33,114.32,319.81z"
        />
        <path
          class="st9"
          d="M115.89,296.97c5.72-1.82,10.16,1.81,15.04,3.55c0.87,0.31,1.7,0.71,2.55,1.08c3.6,2.22,7.83,3.05,11.46,5.23
		c2.09,1.26,4.42,1.47,6.75,0.52c0.32,0,0.64,0,0.96-0.01c3.97-0.82,6.41-3.63,8.62-6.71c1.9-6.73,6.41-12.03,9.76-17.97
		c0.85-1.5,1.53-1.69,2.57-0.31c-3.92,8.41-7.53,16.98-12.12,25.06c-4.25,5.32-9.8,5.24-15.69,3.81
		C135.62,306.94,125.64,302.19,115.89,296.97z"
        />
        <path
          class="st93"
          d="M188.01,285.98c1.34,2.38,1.17,4.18,0.1,7.13c-2.74,7.58-7.05,14.36-9.81,21.9
		c-2.63,7.2-6.92,13.63-11.36,19.86c-0.87,1.21-1.26-0.92-2.14-0.82C172.39,317.95,179.74,301.74,188.01,285.98z"
        />
        <path
          class="st165"
          d="M145.81,311.23c2.04-1.72,4.21,0.13,6.39-0.23c3.41-0.56,6.25-2.29,9.3-3.58c-0.66,2.38-1.54,4.66-3.16,6.58
		c-2.25-0.11-4.48,1.17-6.74,0.1C149.29,313.9,147.6,312.47,145.81,311.23z"
        />
        <path
          class="st154"
          d="M180.11,276.82c4.8-1.71,7.18-0.59,7.98,3.77C185.2,279.84,182.6,278.45,180.11,276.82z"
        />
        <path
          class="st96"
          d="M151.6,314.1c2.25,0.38,4.46-2.54,6.74-0.1C156.18,319.87,153.85,314.36,151.6,314.1z"
        />
        <path
          class="st58"
          d="M112.45,314.96c-1.69,0.21-3.12-0.12-3.9-1.83C110.04,313.35,111.39,313.85,112.45,314.96z"
        />
        <path
          class="st105"
          d="M235.24,221.01c-0.15,1.53,0.45,2.8-2.55,2.13c-8.14-1.82-15.81-5.69-24.3-5.88
		c-5.59-0.12-6.69,1.82-6.64,7.2c0.08,8.15,2.75,15.61,5.07,23.17c0.78,2.55-0.06,4.67-0.42,6.97c-0.03,1.02-0.06,2.04-0.1,3.05
		c-2.87-9.92-5.75-19.84-8.62-29.76c-0.41-2.31-0.36-4.66-0.5-6.98c-0.24-4.19,5.23-8.17,11.31-8.6
		C217.5,214.92,226.48,217.61,235.24,221.01z"
        />
        <path
          class="st59"
          d="M167.05,342.81c0-0.96,0-1.92,0-2.88c0.8-1.4,1.16-3.13,2.88-3.84c1.32-2.14,3.51-3.56,4.79-5.74
		c1.81-6.88,6.81-12.21,8.83-19.13c1.87-6.38,7.45-11.3,8.43-18.27c1.43-3.68,1.93-7.51,1.92-11.44c-0.02-8.95,0-8.95,8.62-12.51
		c-5.2,3.81-7.19,9.03-6.71,15.33c2.1,3.46,0.69,6.95-0.45,10.12c-1.48,4.1-3.57,8.03-5.79,11.79c-1.06,1.79-2.17,3.48-2.7,5.5
		c-1.3,4.94-2.89,9.73-6.53,13.54c-0.85,0.89-0.82,2.02-0.83,3.14c-3.09,1.65-3.49,4.64-3.83,7.67c-4.32-1.97-4.53,2.15-5.5,4.19
		C169.39,341.92,168.95,343,167.05,342.81z"
        />
        <path
          class="st102"
          d="M174.71,330.35c-0.45,2.87-2.74,4.2-4.79,5.74C170.38,333.23,172.67,331.9,174.71,330.35z"
        />
        <path
          class="st137"
          d="M151.71,307.34c-1.76,1.67-4.25,1.5-5.76,0.65c-4.08-2.3-8.99-2.96-12.45-6.4c2.81-0.39,4.73,2.8,7.67,1.91
		C144.25,305.96,147.59,307.73,151.71,307.34z"
        />
        <path
          class="st137"
          d="M161.29,300.63c-1.02,4.62-4.06,6.65-8.62,6.71C156.19,305.94,157.82,302.1,161.29,300.63z"
        />
        <path
          class="st105"
          d="M234.15,199.97c2.43,1.3,4.76,2.86,7.67,2.87c0.69,1.13,1.82,0.92,2.88,0.96c0.57,0.64,0.57,1.28,0.03,1.94
		c0,0.27,0,0.54-0.01,0.8c-19.46-5.52-38.78-11.51-57.97-17.94c2.12-0.41,4.07-0.8,6.42-0.41c7.65,1.26,14.74,4.65,22.2,5.95
		C222.02,195.31,227.32,200.02,234.15,199.97z"
        />
        <path
          class="st102"
          d="M208.48,212.33c-1.84,0.91-3.74,1.72-5.5,2.76c-3.06,1.82-5.84,3.74-4.43,8.22c0.41,1.31-0.55,3.05-0.88,4.6
		c-1.11-3.16-2.58-6.21-2.87-9.61c-0.36-0.57-0.48-1.16-0.19-1.79c1.57-3.48,4.97-4.52,8.03-6.03
		C204.7,210.71,206.73,211.09,208.48,212.33z"
        />
        <path
          class="st144"
          d="M202.64,210.47c-2.55,2.67-6.2,4.24-7.84,7.82c-1.19-3.46-2.38-6.91-3.76-10.92
		C195.22,208.64,199.23,208.28,202.64,210.47z"
        />
        <path
          class="st88"
          d="M729.64,440.74c-3.71-0.41-2.35-3.95-2.4-5.39c-0.43-11.39-7.89-14.46-17.96-14.86
		c-5.04-0.2-10.1,0.21-15.1-0.94c-1.3-0.3-2.54-0.26-2.75-1.93c8.44-0.16,16.89-0.23,25.2,1.53c9.11,1.92,13.18,7.07,13.15,16.32
		C729.77,437.23,729.69,438.98,729.64,440.74z"
        />
        <path
          class="st135"
          d="M521.35,469.66c1.4,0.07,2.26,0.8,2.1,1.77c-0.47,2.83-3.68,1.65-5.2,3.21c-0.51,0.53-1.3-0.6-1.19-1.47
		C517.41,470.53,520.34,471.18,521.35,469.66z"
        />
        <path
          class="st135"
          d="M493.99,498.11c-0.33-1.27-0.66-2.55-0.99-3.82c0.96-0.11,1.43-2.62,2.47-1
		C496.54,494.97,496.13,497.01,493.99,498.11z"
        />
        <path
          class="st103"
          d="M134.45,393.62c-3.33-1.86-4.18-8.28-1.07-10.16c2.91-1.76,5.82-4.11,9.69-3.26
		c-0.32,0.32-0.64,0.64-0.96,0.96c-1.11,0.97-2.75,0.88-3.83,1.92c-0.32,0.32-0.64,0.64-0.96,0.96c-3.81-0.59-3.99,1.78-3.86,4.59
		C133.54,390.36,133.51,392.07,134.45,393.62z"
        />
        <path
          class="st103"
          d="M143.08,380.2c2.15-3.69,6.21-3.56,9.59-4.79c-0.38,2.62-1.96,3.7-4.53,3.86
		C146.44,379.39,144.76,379.88,143.08,380.2z"
        />
        <path
          class="st73"
          d="M138.28,383.08c0.72-1.75,2.19-2.01,3.83-1.92C141.39,382.91,139.93,383.17,138.28,383.08z"
        />
        <path
          class="st102"
          d="M138.61,501.97c-3.25,0.65-5.99-0.92-7.62-4.25c-0.91-1.85-3.15-3.68-1.35-6c1.81-2.35,4.69-1.55,6.95-1.19
		c1.43,0.22,3.03,0.6,4.5,1.07c2.61,0.83,6.48,1.25,5.57,5.06C145.87,499.94,143.49,502.8,138.61,501.97z"
        />
        <path
          class="st9"
          d="M141.15,487.59c1.52-0.14,2.82-0.75,3.92-1.81c4.52,1.92,7.45,6.92,6.52,11.16
		c-0.78,3.59-6.61,8.77-10.04,8.84c-3,0.06-6.01,0.01-9.01,0c-2.3-3.11-4.55-6.24-6.9-9.32c-2.7-3.55-2.58-7.97-1.38-11.41
		c1.74-4.99,4.24-0.43,6.36,0.6c-4.81,5.59-4.82,8.87-0.07,14.75c3.43,4.24,8.88,5.54,13.18,3.15c4.2-2.33,6.18-6.56,5.54-10.49
		c-0.68-4.21-2.59-5.47-6.56-3.93c-0.7,0.27-2.01,1.28-2.43-0.45C140.22,488.4,140.84,487.96,141.15,487.59z"
        />
        <path
          class="st95"
          d="M152.69,367.87c-0.95,4.54-5.59,4.37-8.45,6.44c-1.12,0.81-2.97,0.75-4.04,2.05
		c-3.72,1.72-7.23,3.8-10.56,6.19c-5.21,3.74-5.29,5.84-1.41,10.74c3.21,4.05,8.5,5.39,11.56,9.52c0.38,0.51,0.84,0.88,0.8,1.57
		c-1.26,2.05-2.39-0.17-3.59-0.1c-5.26-2.81-10.27-6.02-15.11-9.49c-0.3-0.44,0.14-1.06,0.03-1.24c-3.38-5.45-1.37-9.69,2.91-13.46
		C133.91,375.56,143.26,371.61,152.69,367.87z"
        />
        <path
          class="st58"
          d="M111.44,366.78c3.99-3.72,9.2-5.29,13.95-7.56c7.47-3.58,14.88-7.49,23.16-9.02
		c0.71-0.13,1.51,0.21,2.27,0.32c-12.54,6.28-25.34,11.99-38.33,17.26C111.43,368.18,111.23,367.69,111.44,366.78z"
        />
        <path
          class="st80"
          d="M124.82,380.1c0.59,0.9,2.14,1.69-0.14,2.63c-4.31,1.78-4.69,5.04-2.31,8.51c1.18,1.72,0.39,2.48-0.49,3.55
		c-1.59-0.95-3.19-1.91-4.78-2.86c-0.41-2.64-0.68-5.3-0.84-7.97C118.94,382.31,121.64,380.68,124.82,380.1z"
        />
        <path
          class="st95"
          d="M136.99,404.29c1.05-0.48,2.18,0.91,3.21-0.12c2.48-1.07,3.95,0.93,5.75,1.91c1.32,1.12,2.52,2.45,3.99,3.32
		c1.72,1.02,1.57,2.12,0.74,3.52C145.9,410.39,141.31,407.56,136.99,404.29z"
        />
        <path
          class="st133"
          d="M116.25,383.97c2.7,2.4,2.25,5.14,0.84,7.97c-2.49-1.52-4.98-3.04-8.1-4.93
		C111.75,385.51,113.7,384.11,116.25,383.97z"
        />
        <path
          class="st143"
          d="M111.44,366.78c0.35,0.33,0.7,0.67,1.05,1c-1.39,1.27-3.03,1.91-4.9,2.03c0.65-0.69,1.29-1.37,1.94-2.06
		C110.16,367.42,110.8,367.1,111.44,366.78z"
        />
        <path
          class="st117"
          d="M145.96,406.08c-1.92-0.64-3.84-1.27-5.75-1.91c-4.05-4.57-10.26-6.38-14.03-11.46
		c-2.91-3.92-3.39-5.67,0.39-8.83c4.02-3.37,8.37-6.32,13.64-7.51c-0.49,2.01-2.87,1.5-3.83,2.88c-1.44,0.95-2.95,1.82-4.32,2.87
		c-6.03,4.62-5.76,8.72,0.55,13.19c1.9,1.34,4.56,1.67,5.69,4.07c0.06,2.43,1.97,3.11,3.74,3.63
		C143.82,403.54,145.12,404.44,145.96,406.08z"
        />
        <path
          class="st138"
          d="M154.58,371.57c0.94-2.26,2.52-3.87,4.8-4.79c0.14,1.67-1.38,2.5-1.92,3.83
		C156.5,370.93,155.54,371.25,154.58,371.57z"
        />
        <path
          class="st138"
          d="M159.38,366.78c2.77-5.52,1.78-11.45,1.91-17.26C165.31,355.31,164.42,363.34,159.38,366.78z"
        />
        <path
          class="st103"
          d="M244.73,205.74c-0.01-0.65-0.02-1.29-0.03-1.94c0.94,0.13,2.04,0.11,2.1,1.37
		C246.81,205.33,245.45,205.55,244.73,205.74z"
        />
        <path
          class="st53"
          d="M694.33,341.86c1.85-2.34,3.69-4.7,5.57-7.03c3.2-3.95,2.58-7.7-1.87-10.24c-1.63-0.93-3.41-1.8-5.23-2.16
		c-6.87-1.37-13.5-3.85-20.52-4.54c-0.52-2.38-2.94-1.67-4.29-2.67c-1.33-0.98-3.54-0.5-4.19-2.55c11.8,2.65,23.6,5.31,35.4,7.96
		c0.53,0.81-0.28,1.1-0.61,1.57c7.93,4.11,8.13,4.67,4.78,12.94c-0.23,0.58-0.23,1.24-0.47,1.83l-0.05,0.05
		c-1.71,0.94-2.75,2.65-4.33,3.72C697.26,341.57,696.18,343.17,694.33,341.86z"
        />
        <path
          class="st110"
          d="M694.33,341.86c3.67-0.15,4.87-4.64,8.51-4.85c-5.97,6.5-12.39,12.52-19.03,18.33
		c0.42-5.02,5.33-6.8,7.62-10.48C692.16,343.71,693.35,342.85,694.33,341.86z"
        />
        <path
          class="st126"
          d="M704.89,321.81c1.36-0.12,2.68-0.06,3.86,0.74c1.74,1.54,2.9,3.36,2.79,5.79c-2.15,1.7-2.98,4.7-5.72,5.83
		c-2.35-2.2,1.17-4.91-0.62-7.16C705.02,325.28,704.79,323.55,704.89,321.81z"
        />
        <path
          class="st110"
          d="M705.83,326.52c1.97,2.55-0.58,5.1-0.02,7.65c-0.75,1.17-1.64,2.19-2.93,2.8c-0.92-0.92-1.52-1.66-0.6-3.18
		c3.38-5.58,3.12-6.64-2.22-10.07c-1.42-0.91-2.84-1.4-0.88-3.09c0.32-0.15,0.62-0.1,0.88,0.13
		C702.18,322.49,705.24,323.27,705.83,326.52z"
        />
        <path
          class="st170"
          d="M711.54,328.33c-2.2-1.32-1.74-3.91-2.79-5.79c2.31,0.4,4.62,0.8,7.4,1.28
		C714.79,326.06,713.49,327.51,711.54,328.33z"
        />
        <path
          class="st111"
          d="M705.83,326.52c-1.5-2.34-4.95-2.74-5.76-5.77c1.6,0.35,3.2,0.71,4.81,1.06
		C707.18,322.98,706.13,324.82,705.83,326.52z"
        />
        <path
          class="st110"
          d="M694.14,368.54c1.26,3.3,0,3.99-2.98,2.88C691.82,370.12,692.86,369.2,694.14,368.54z"
        />
      </g>
    </React.Fragment>
  ),
  "industry-logo-6": (
    <React.Fragment>
      <g
        transform="translate(0.000000,58.000000) scale(0.100000,-0.100000)"
        fill="#000000"
        stroke="none"
      >
        <path
          d="M143 565 c-29 -8 -71 -24 -93 -35 l-40 -21 2 -222 3 -222 59 -29
c103 -52 256 -47 359 12 l27 16 0 222 c0 220 0 222 -23 237 -71 46 -209 66
-294 42z m225 -88 c30 -16 32 -21 32 -68 0 -47 -2 -50 -22 -47 -18 2 -24 11
-26 35 -4 38 -37 53 -118 53 -83 0 -104 -12 -104 -60 0 -34 4 -41 25 -46 19
-5 25 -13 25 -35 l0 -29 -47 19 -48 19 -3 70 c-3 77 0 81 67 103 43 14 182 5
219 -14z m-108 -188 c0 -67 -1 -70 -22 -67 -21 3 -23 9 -26 71 -3 66 -3 67 23
67 24 0 25 -2 25 -71z m95 -19 l47 -20 -4 -67 c-3 -68 -3 -68 -41 -86 -57 -28
-141 -32 -212 -10 l-60 19 -3 58 c-3 51 -1 58 13 52 9 -3 21 -6 26 -6 5 0 9
-16 9 -35 0 -31 3 -35 38 -44 48 -14 101 -14 141 0 28 10 31 15 31 50 0 28 -5
41 -20 49 -12 6 -20 21 -20 35 0 30 -3 30 55 5z"
        />
        <path
          d="M730 393 c-75 -28 -63 -101 20 -118 50 -11 70 -23 64 -40 -8 -20 -68
-20 -84 0 -17 21 -64 20 -56 -1 3 -9 6 -17 6 -20 0 -2 13 -10 30 -19 78 -40
179 11 147 76 -9 16 -29 28 -67 39 -34 10 -55 21 -55 30 0 18 43 26 58 11 6
-6 24 -11 39 -11 25 0 27 2 19 19 -16 30 -82 48 -121 34z"
        />
        <path
          d="M912 373 c2 -12 14 -19 36 -21 l32 -3 0 -80 c0 -78 0 -79 25 -79 25
0 25 1 25 79 l0 80 37 3 c27 2 39 8 41 21 3 15 -7 17 -98 17 -91 0 -101 -2
-98 -17z"
        />
        <path
          d="M1170 290 l0 -100 25 0 c23 0 25 4 25 40 0 37 2 40 28 40 36 0 52
-16 52 -52 0 -23 4 -28 25 -28 22 0 25 4 25 35 0 19 -6 40 -13 46 -11 11 -10
16 5 31 13 13 17 26 13 41 -12 37 -35 47 -112 47 l-73 0 0 -100z m125 54 c22
-23 2 -44 -41 -44 -31 0 -34 3 -34 30 0 27 3 30 29 30 16 0 37 -7 46 -16z"
        />
        <path
          d="M1430 290 l0 -100 85 0 c78 0 85 2 85 20 0 18 -7 20 -60 20 -53 0
-60 2 -60 20 0 18 7 20 55 20 48 0 55 2 55 20 0 18 -7 20 -55 20 -48 0 -55 2
-55 20 0 18 7 20 60 20 53 0 60 2 60 20 0 18 -7 20 -85 20 l-85 0 0 -100z"
        />
        <path
          d="M1725 358 c-31 -76 -65 -162 -65 -165 0 -2 11 -3 24 -3 16 0 27 7 31
20 5 17 15 20 57 20 41 0 51 -3 55 -20 4 -14 14 -20 34 -20 l28 0 -36 83 c-19
45 -38 90 -40 100 -4 12 -16 17 -40 17 -29 0 -36 -5 -48 -32z m59 -32 c3 -13
9 -31 12 -40 5 -13 -1 -16 -26 -16 -25 0 -31 3 -26 16 3 9 9 27 12 40 8 31 20
31 28 0z"
        />
        <path
          d="M1945 290 c0 -97 1 -100 23 -100 21 0 22 4 23 73 l1 72 22 -70 c19
-61 26 -70 46 -70 20 0 27 11 51 80 l27 80 1 -82 c1 -76 3 -83 21 -83 19 0 20
7 20 101 l0 100 -36 -3 c-35 -3 -37 -5 -58 -73 l-23 -70 -22 73 -22 72 -37 0
-37 0 0 -100z"
        />
        <path
          d="M2270 290 l0 -100 80 0 c73 0 80 2 80 20 0 18 -7 20 -55 20 l-55 0 0
80 c0 79 0 80 -25 80 l-25 0 0 -100z"
        />
        <path d="M2490 290 l0 -100 25 0 25 0 0 100 0 100 -25 0 -25 0 0 -100z" />
        <path
          d="M2620 290 l0 -100 25 0 c24 0 25 2 25 73 l1 72 45 -72 c40 -63 50
-73 75 -73 l29 0 0 100 c0 93 -1 100 -20 100 -17 0 -19 -8 -22 -67 l-3 -68
-45 67 c-40 60 -49 68 -77 68 l-33 0 0 -100z"
        />
        <path
          d="M2910 290 l0 -100 85 0 c78 0 85 2 85 20 0 18 -7 20 -65 20 -58 0
-65 2 -65 20 0 18 7 20 60 20 53 0 60 2 60 20 0 16 -8 19 -57 22 -45 2 -59 7
-61 20 -3 14 7 17 60 20 50 2 63 6 66 21 3 15 -6 17 -82 17 l-86 0 0 -100z"
        />
      </g>
    </React.Fragment>
  ),
  "industry-logo-7": (
    <React.Fragment>
      <g
        transform="translate(0.000000,94.000000) scale(0.100000,-0.100000)"
        fill="#000000"
        stroke="none"
      >
        <path
          d="M85 827 c0 -42 0 -43 30 -39 37 5 57 20 48 36 -4 6 -8 18 -8 26 0 10
-12 16 -35 18 l-35 3 0 -44z m52 -13 c-3 -3 -12 -4 -19 -1 -8 3 -5 6 6 6 11 1
17 -2 13 -5z"
        />
        <path
          d="M227 864 c-4 -4 -7 -18 -7 -30 0 -17 7 -25 24 -30 34 -8 68 12 64 39
-2 17 -11 23 -38 25 -20 2 -39 0 -43 -4z m53 -24 c0 -11 -7 -20 -15 -20 -8 0
-15 9 -15 20 0 11 7 20 15 20 8 0 15 -9 15 -20z"
        />
        <path
          d="M360 860 c0 -5 7 -7 16 -3 14 5 16 1 12 -20 -4 -21 -1 -27 13 -27 14
0 19 7 19 25 0 18 4 23 15 19 8 -4 15 -1 15 5 0 6 -19 11 -45 11 -25 0 -45 -4
-45 -10z"
        />
        <path d="M496 842 l-15 -28 50 -1 49 -1 -17 29 c-22 37 -48 37 -67 1z" />
        <path
          d="M635 840 c0 -16 6 -32 13 -35 7 -3 12 4 12 18 l0 21 16 -22 c24 -34
44 -28 44 13 0 35 -20 51 -20 18 -1 -17 -1 -17 -14 0 -7 9 -22 17 -32 17 -14
0 -19 -7 -19 -30z"
        />
        <path
          d="M780 861 c0 -5 7 -14 16 -22 8 -7 13 -21 11 -31 -4 -13 0 -18 14 -18
13 0 19 7 19 22 0 12 7 30 17 40 11 13 12 18 3 18 -7 0 -19 -8 -26 -17 -13
-17 -13 -17 -14 0 0 17 -40 26 -40 8z"
        />
        <path
          d="M467 723 c-13 -12 -7 -19 20 -21 14 -1 25 -1 22 1 -2 1 -11 8 -20 15
-9 6 -19 9 -22 5z"
        />
        <path d="M446 675 c-3 -9 -6 -24 -5 -33 0 -9 5 -4 10 12 9 32 6 48 -5 21z" />
        <path d="M496 665 c8 -37 14 -45 14 -19 0 10 -5 26 -10 34 -8 11 -9 7 -4 -15z" />
        <path
          d="M375 672 c-5 -4 -16 -14 -22 -23 -10 -12 -10 -16 0 -16 7 0 18 11 24
24 12 25 12 26 -2 15z"
        />
        <path
          d="M563 674 c4 -4 -1 -17 -10 -28 -18 -21 -18 -21 5 -2 18 15 22 16 22
4 0 -8 6 -15 14 -15 11 0 12 4 3 18 -6 10 -18 21 -26 24 -9 3 -12 3 -8 -1z"
        />
        <path
          d="M472 588 c-2 -73 -11 -94 -28 -66 -5 7 -3 8 7 2 10 -6 10 -2 -2 16
-9 14 -22 25 -28 25 -6 0 -16 7 -21 15 -8 13 -10 12 -10 -2 0 -10 5 -19 10
-19 6 -1 15 -2 22 -3 15 -1 23 -26 8 -26 -6 0 -9 -4 -6 -9 4 -5 3 -11 -1 -14
-5 -2 -3 -2 4 -1 7 2 15 -1 18 -6 9 -15 -26 -12 -59 5 -15 8 -35 15 -42 15 -8
0 -14 7 -14 15 0 8 -5 15 -11 15 -5 0 -7 -5 -4 -10 3 -6 -4 -14 -16 -18 l-23
-9 25 -7 c13 -5 30 -7 37 -7 6 1 12 -3 12 -9 0 -5 14 -10 31 -10 22 0 37 -8
53 -27 11 -15 20 -31 19 -35 -2 -4 8 -3 21 4 28 12 57 5 54 -14 -2 -7 4 -12
12 -13 8 0 26 -6 40 -13 l25 -13 -25 23 c-14 13 -41 35 -59 50 -29 25 -31 29
-17 44 9 9 24 13 36 10 58 -17 65 -17 35 0 -36 21 -18 30 28 15 26 -8 29 -8
14 2 -15 10 -11 13 30 23 45 11 46 12 14 13 -30 1 -33 3 -29 26 3 14 1 25 -4
25 -5 0 -6 5 -3 10 3 6 1 10 -5 10 -7 0 -10 -7 -6 -15 3 -8 0 -15 -6 -15 -9 0
-9 -3 0 -12 17 -17 15 -31 -3 -25 -8 4 -17 2 -21 -4 -3 -6 -13 -8 -21 -5 -8 3
-11 2 -8 -4 3 -5 -3 -9 -12 -9 -10 0 -27 -1 -38 -4 -18 -4 -21 3 -26 67 l-5
71 -2 -77z m-2 -140 c0 -5 6 -6 13 -2 9 5 9 4 -1 -7 -10 -11 -15 -11 -28 2
-13 14 -13 16 1 16 8 0 15 -4 15 -9z"
        />
        <path
          d="M505 600 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7
-4 -4 -10z"
        />
        <path
          d="M317 580 c6 -24 19 -26 27 -4 3 8 2 12 -4 9 -6 -3 -10 -1 -10 4 0 6
-4 11 -9 11 -5 0 -7 -9 -4 -20z"
        />
        <path
          d="M545 574 c-9 -15 -12 -23 -6 -20 11 7 35 46 28 46 -3 0 -12 -12 -22
-26z"
        />
        <path d="M197 553 c-10 -9 -9 -23 1 -23 5 0 9 7 9 15 0 17 -1 18 -10 8z" />
        <path
          d="M359 543 c12 -23 29 -38 37 -31 2 3 -8 15 -22 29 -25 23 -26 23 -15
2z"
        />
        <path
          d="M500 545 c0 -8 2 -15 4 -15 2 0 6 7 10 15 3 8 1 15 -4 15 -6 0 -10
-7 -10 -15z"
        />
        <path
          d="M746 545 c-3 -8 -1 -15 4 -15 6 0 10 7 10 15 0 8 -2 15 -4 15 -2 0
-6 -7 -10 -15z"
        />
        <path d="M125 541 c-3 -5 -1 -12 5 -16 5 -3 10 1 10 9 0 18 -6 21 -15 7z" />
        <path
          d="M790 541 c0 -6 -10 -16 -22 -21 -16 -6 -18 -9 -7 -9 19 -1 45 26 35
36 -3 3 -6 1 -6 -6z"
        />
        <path d="M91 524 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
        <path
          d="M840 530 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z"
        />
        <path d="M188 513 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
        <path
          d="M271 318 c-17 -27 -8 -32 23 -16 24 12 24 14 8 25 -15 9 -21 7 -31
-9z"
        />
        <path
          d="M640 315 c0 -8 8 -15 18 -15 14 0 15 -2 2 -10 -8 -5 -10 -10 -4 -10
21 0 35 25 22 38 -17 17 -38 15 -38 -3z"
        />
        <path
          d="M347 272 c-14 -16 -14 -18 9 -29 22 -10 24 -9 24 18 0 33 -10 37 -33
11z"
        />
        <path
          d="M574 275 c-5 -11 -10 -13 -19 -5 -6 5 -14 7 -17 4 -9 -8 3 -44 14
-44 5 0 7 4 4 9 -3 4 6 7 19 5 19 -2 25 3 25 16 0 25 -19 35 -26 15z"
        />
        <path d="M440 245 c0 -31 35 -35 43 -6 6 24 0 31 -25 31 -13 0 -18 -7 -18 -25z" />
        <path d="M603 153 c26 -2 67 -2 90 0 23 2 2 3 -48 3 -49 0 -68 -1 -42 -3z" />
        <path d="M208 143 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z" />
        <path d="M433 143 c15 -2 37 -2 50 0 12 2 0 4 -28 4 -27 0 -38 -2 -22 -4z" />
        <path
          d="M610 129 c0 -5 -4 -7 -10 -4 -5 3 -10 1 -10 -4 0 -6 7 -11 15 -11 8
0 15 7 15 15 0 8 -2 15 -5 15 -3 0 -5 -5 -5 -11z"
        />
        <path d="M637 121 c-3 -14 -1 -18 9 -14 8 3 14 11 14 19 0 21 -17 17 -23 -5z" />
        <path
          d="M680 120 c0 -13 5 -20 13 -17 6 2 12 10 12 17 0 7 -6 15 -12 18 -8 2
-13 -5 -13 -18z"
        />
        <path
          d="M202 113 c2 -9 10 -18 18 -20 13 -4 13 -3 0 6 -13 10 -13 12 0 21 13
8 12 10 -3 10 -12 0 -17 -6 -15 -17z"
        />
        <path
          d="M445 120 c-8 -13 3 -30 18 -30 7 0 6 4 -3 10 -13 9 -13 11 0 20 9 6
10 10 3 10 -6 0 -15 -4 -18 -10z"
        />
        <path
          d="M490 115 c0 -8 7 -15 15 -15 9 0 12 6 9 15 -4 8 -10 15 -15 15 -5 0
-9 -7 -9 -15z"
        />
        <path d="M543 116 c5 -16 27 -19 27 -3 0 7 -7 14 -15 14 -9 0 -14 -5 -12 -11z" />
        <path d="M721 114 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
        <path
          d="M753 115 c0 -8 4 -15 9 -15 4 0 8 7 8 15 0 8 -4 15 -8 15 -5 0 -9 -7
-9 -15z"
        />
        <path
          d="M240 107 c0 -8 7 -14 15 -14 8 0 15 6 15 14 0 7 -7 13 -15 13 -8 0
-15 -6 -15 -13z"
        />
        <path
          d="M290 105 c0 -8 7 -15 15 -15 9 0 12 6 9 15 -4 8 -10 15 -15 15 -5 0
-9 -7 -9 -15z"
        />
        <path d="M341 104 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
        <path d="M381 104 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
        <path d="M593 83 c32 -2 81 -2 110 0 29 2 3 3 -58 3 -60 0 -84 -1 -52 -3z" />
        <path d="M213 73 c9 -2 25 -2 35 0 9 3 1 5 -18 5 -19 0 -27 -2 -17 -5z" />
        <path d="M403 73 c15 -2 39 -2 55 0 15 2 2 4 -28 4 -30 0 -43 -2 -27 -4z" />
      </g>
    </React.Fragment>
  ),
  "industry-logo-8": (
    <React.Fragment>
      <g
        transform="translate(0.000000,40.000000) scale(0.100000,-0.100000)"
        fill="#000000"
        stroke="none"
      >
        <path
          d="M0 200 l0 -200 153 0 153 0 32 64 31 65 -64 135 -64 136 -121 0 -120
0 0 -200z m221 14 c23 -47 38 -92 35 -100 -4 -10 -25 -14 -81 -14 l-75 0 0
100 0 100 41 0 40 0 40 -86z"
        />
        <path
          d="M352 392 c29 -70 64 -142 69 -142 6 0 69 133 69 145 0 3 -32 5 -71 5
-39 0 -69 -4 -67 -8z"
        />
        <path
          d="M581 358 c-10 -24 -51 -110 -90 -192 -39 -82 -71 -153 -71 -157 0 -5
22 -9 49 -9 l49 0 52 108 52 107 51 -108 c71 -152 70 -153 182 84 50 106 91
195 93 200 2 5 -20 9 -50 9 l-53 -1 -51 -107 -50 -107 -51 108 c-42 86 -56
107 -73 107 -15 0 -26 -12 -39 -42z"
        />
        <path
          d="M992 391 c2 -4 43 -94 93 -200 68 -146 94 -191 108 -191 18 0 37 36
168 318 l38 82 -53 0 -53 0 -50 -106 -49 -105 -50 105 -49 106 -53 0 c-30 0
-52 -4 -50 -9z"
        />
        <path
          d="M1440 393 c0 -5 41 -95 91 -200 l92 -193 54 0 53 0 -30 60 -30 60
105 0 c58 0 105 3 105 8 0 4 -27 67 -61 140 l-62 132 -159 0 c-87 0 -158 -3
-158 -7z m273 -128 c9 -20 17 -38 17 -40 0 -3 -24 -5 -53 -5 -51 0 -54 1 -70
35 -9 20 -17 38 -17 40 0 3 24 5 53 5 51 0 54 -1 70 -35z"
        />
        <path
          d="M1370 113 c-25 -53 -46 -100 -48 -104 -2 -5 42 -9 97 -9 l100 0 -49
102 c-28 56 -51 103 -53 104 -1 1 -22 -41 -47 -93z"
        />
        <path
          d="M918 103 l-45 -98 49 -3 c26 -2 70 -2 97 0 l49 3 -46 98 c-24 53 -48
97 -52 97 -4 0 -27 -44 -52 -97z"
        />
      </g>
    </React.Fragment>
  ),
  "industry-logo-9": (
    <g
      transform="translate(0.000000,64.000000) scale(0.100000,-0.100000)"
      fill="#000000"
      stroke="none"
    >
      <path
        d="M196 428 l-127 -203 3 -100 3 -100 260 0 260 0 3 97 3 96 -128 203
c-70 111 -133 204 -139 206 -6 2 -68 -88 -138 -199z m155 150 c7 -13 59 -96
116 -186 56 -89 103 -165 103 -168 0 -3 -26 -4 -57 -2 l-57 3 -53 85 c-29 47
-56 91 -61 99 -6 10 -16 1 -40 -36 -18 -27 -32 -53 -32 -56 0 -4 24 -7 53 -7
50 0 53 -2 79 -43 l27 -42 -84 -3 c-47 -1 -123 -1 -168 0 l-84 3 116 187 c64
103 119 187 123 188 4 0 13 -10 19 -22z m-201 -398 c0 -5 -9 -10 -20 -10 -28
0 -25 -30 3 -31 l22 -2 -22 -4 c-13 -2 -23 -11 -23 -18 0 -7 10 -16 23 -18 16
-3 13 -5 -10 -6 l-33 -1 0 50 c0 49 1 50 30 50 17 0 30 -4 30 -10z m100 0 c0
-5 -11 -10 -25 -10 -32 0 -34 -30 -2 -31 l22 0 -22 -9 c-13 -5 -23 -16 -23
-25 0 -8 -4 -15 -10 -15 -11 0 -14 83 -3 93 10 11 63 8 63 -3z m90 0 c0 -5 -9
-10 -20 -10 -28 0 -25 -30 3 -31 l22 -2 -22 -4 c-15 -3 -23 -12 -23 -24 0 -10
-4 -19 -10 -19 -5 0 -10 23 -10 50 0 49 1 50 30 50 17 0 30 -4 30 -10z m100 0
c0 -5 -9 -10 -19 -10 -29 0 -37 -20 -10 -27 20 -6 21 -7 5 -13 -24 -8 -22 -24
6 -32 20 -5 18 -6 -9 -7 -33 -1 -33 -1 -33 49 0 49 1 50 30 50 17 0 30 -4 30
-10z m59 -4 c9 -10 9 -16 1 -21 -6 -4 -12 -5 -13 -4 -2 2 -9 12 -16 22 -11 14
-11 17 2 17 8 0 20 -6 26 -14z m56 -12 c-15 -24 -15 -27 0 -51 21 -32 12 -42
-16 -17 -19 17 -21 18 -30 1 -6 -9 -17 -17 -25 -17 -11 0 -4 16 23 55 21 30
44 55 52 55 10 0 10 -6 -4 -26z m-265 -113 c0 -4 -6 -8 -13 -8 -8 0 -14 6 -14
13 0 7 6 10 14 7 7 -3 13 -8 13 -12z m-150 -1 c0 -5 -4 -10 -9 -10 -6 0 -13 5
-16 10 -3 6 1 10 9 10 9 0 16 -4 16 -10z m50 0 c0 -13 -11 -13 -30 0 -12 8
-11 10 8 10 12 0 22 -4 22 -10z m200 6 c0 -3 -4 -8 -10 -11 -5 -3 -10 -1 -10
4 0 6 5 11 10 11 6 0 10 -2 10 -4z m114 -4 c3 -5 -1 -9 -9 -9 -8 0 -12 4 -9 9
3 4 7 8 9 8 2 0 6 -4 9 -8z"
      />
    </g>
  ),
  "industry-logo-10": (
    <React.Fragment>
      <g
        transform="translate(0.000000,54.000000) scale(0.100000,-0.100000)"
        fill="#000000"
        stroke="none"
      >
        <path
          d="M467 496 c-3 -8 -27 -27 -54 -42 -66 -38 -83 -53 -102 -94 l-16 -35
-3 58 -3 57 -39 0 -40 0 0 -125 c0 -141 10 -174 60 -200 107 -56 232 35 199
145 -10 33 -9 41 11 68 12 16 25 51 27 76 8 64 -24 135 -40 92z m-72 -136 c-3
-5 -12 -10 -18 -10 -7 0 -6 4 3 10 19 12 23 12 15 0z m-65 -109 c0 -17 5 -33
10 -36 6 -4 10 5 10 20 0 22 4 26 23 23 16 -2 23 -11 25 -31 7 -58 -57 -88
-98 -47 -24 24 -25 48 -4 78 21 30 34 28 34 -7z"
        />
        <path
          d="M532 438 c-27 -27 -6 -68 35 -68 32 0 46 31 27 58 -17 24 -44 28 -62
10z"
        />
        <path
          d="M1271 436 c-7 -8 -11 -25 -9 -38 2 -18 9 -23 32 -23 36 0 56 27 40
53 -14 22 -48 27 -63 8z"
        />
        <path
          d="M1570 385 c0 -30 -2 -55 -5 -55 -2 0 -16 5 -29 12 -38 17 -99 -4
-127 -44 -25 -35 -30 -99 -10 -136 30 -56 128 -80 192 -46 47 24 59 66 59 204
l0 120 -40 0 -40 0 0 -55z m-5 -129 c40 -60 -34 -127 -87 -79 -22 20 -24 66
-2 87 24 25 71 20 89 -8z"
        />
        <path
          d="M765 335 c-19 -10 -31 -12 -33 -6 -2 6 -19 11 -38 11 l-34 0 0 -115
0 -115 40 0 40 0 0 73 c0 78 9 97 47 97 30 0 43 -33 43 -111 l0 -59 35 0 35 0
0 89 c0 79 -3 93 -22 115 -29 33 -74 41 -113 21z"
        />
        <path
          d="M1015 332 c-84 -39 -96 -146 -24 -207 36 -30 112 -34 159 -10 58 30
77 112 40 172 -35 57 -108 76 -175 45z m110 -76 c40 -60 -34 -127 -87 -79 -22
20 -24 66 -2 87 24 25 71 20 89 -8z"
        />
        <path d="M530 225 l0 -115 35 0 35 0 0 115 0 115 -35 0 -35 0 0 -115z" />
        <path d="M1260 226 l0 -116 40 0 41 0 -3 113 -3 112 -37 3 -38 3 0 -115z" />
      </g>
    </React.Fragment>
  ),
  "industry-logo-11": (
    <React.Fragment>
      <g
        transform="translate(0.000000,64.000000) scale(0.100000,-0.100000)"
        fill="#000000"
        stroke="none"
      >
        <path
          d="M510 563 c-1 -21 -7 -55 -14 -75 l-13 -37 32 13 c17 7 43 20 58 27
l27 15 -27 39 c-44 67 -63 72 -63 18z"
        />
        <path
          d="M780 521 c18 -5 24 -13 22 -29 -2 -15 2 -22 14 -22 11 0 15 6 11 20
-5 18 0 20 54 20 61 0 71 -8 42 -31 -13 -11 -17 -11 -21 -1 -2 8 -15 3 -38
-17 -29 -26 -56 -35 -123 -44 -8 -1 -16 -8 -19 -15 -3 -9 3 -10 24 -2 16 6 40
8 54 4 14 -4 27 -8 30 -9 33 -8 50 -19 50 -31 0 -12 -3 -12 -23 1 -13 8 -46
17 -73 20 -27 2 -40 2 -29 -1 38 -11 37 -22 -5 -53 -65 -47 -125 -40 -155 19
-9 18 -23 30 -35 30 -16 0 -20 -6 -18 -31 3 -31 1 -32 -64 -54 -36 -13 -77
-26 -90 -30 -22 -7 -22 -6 -4 7 18 14 18 15 -12 26 -38 13 -40 19 -9 32 17 8
11 9 -22 4 -45 -6 -213 7 -174 14 13 2 23 7 23 12 0 10 -88 118 -114 139 -16
13 -17 12 -10 -15 4 -16 13 -46 21 -68 19 -55 16 -88 -11 -151 -31 -70 -17
-73 54 -10 28 25 58 45 68 45 9 0 50 -11 89 -23 l73 -23 -55 -18 c-72 -22
-128 -46 -123 -52 3 -2 67 7 144 21 162 29 147 27 140 16 -14 -22 84 -28 175
-10 50 10 59 8 124 -19 38 -17 73 -28 77 -26 11 7 -5 34 -38 67 -15 15 -25 29
-23 31 2 2 18 12 36 23 51 31 152 130 170 167 24 50 14 62 -58 69 -83 9 -183
7 -149 -2z m-620 -142 c0 -5 -4 -7 -10 -4 -5 3 -10 2 -10 -4 0 -6 -7 -8 -15
-5 -24 9 -17 24 10 24 14 0 25 -5 25 -11z"
        />
        <path
          d="M275 370 c-3 -5 3 -10 14 -10 12 0 21 5 21 10 0 6 -6 10 -14 10 -8 0
-18 -4 -21 -10z"
        />
        <path d="M1010 101 c0 -6 4 -13 10 -16 6 -3 7 1 4 9 -7 18 -14 21 -14 7z" />
        <path
          d="M56 54 c-8 -31 1 -45 15 -24 8 11 12 12 16 2 8 -20 23 -3 23 26 0 20
-3 23 -12 14 -15 -15 -32 -16 -23 -2 3 6 2 10 -3 10 -6 0 -13 -12 -16 -26z"
        />
        <path d="M136 58 c-22 -30 -21 -33 14 -33 33 0 32 0 24 33 -8 28 -19 28 -38 0z" />
        <path
          d="M200 66 c0 -8 -3 -21 -6 -30 -3 -9 -1 -16 4 -16 6 0 12 8 14 17 3 15
4 15 21 -1 21 -21 22 -20 31 17 5 20 3 27 -9 27 -8 0 -15 -5 -15 -12 0 -9 -3
-9 -12 0 -16 16 -28 15 -28 -2z"
        />
        <path d="M280 48 c0 -25 3 -29 10 -18 13 20 13 50 0 50 -5 0 -10 -15 -10 -32z" />
        <path
          d="M317 67 c-12 -31 -8 -47 13 -47 11 0 20 5 20 10 0 6 -4 10 -9 10 -5
0 -11 10 -13 23 -3 20 -4 20 -11 4z"
        />
        <path
          d="M369 71 c8 -5 11 -16 6 -30 -4 -12 -2 -21 4 -21 6 0 11 8 11 18 0 10
5 23 12 30 9 9 5 12 -17 12 -21 0 -26 -3 -16 -9z"
        />
        <path
          d="M427 73 c-10 -10 -8 -41 3 -48 20 -12 50 6 50 31 0 18 -5 24 -23 24
-13 0 -27 -3 -30 -7z m33 -33 c-18 -11 -24 -6 -16 16 5 14 9 15 19 5 9 -9 9
-14 -3 -21z"
        />
        <path
          d="M500 66 c0 -8 -3 -21 -6 -30 -3 -9 -1 -16 5 -16 6 0 11 8 11 18 1 15
2 15 15 -2 17 -23 20 -21 29 17 4 16 2 27 -4 27 -5 0 -10 -5 -10 -12 0 -9 -3
-9 -12 0 -16 16 -28 15 -28 -2z"
        />
        <path
          d="M596 58 c-9 -34 -8 -38 13 -38 24 0 45 25 37 45 -9 23 -43 18 -50 -7z
m30 -15 c-10 -10 -19 5 -10 18 6 11 8 11 12 0 2 -7 1 -15 -2 -18z"
        />
        <path
          d="M666 64 c-12 -32 -6 -44 22 -44 26 1 26 1 8 15 -20 15 -20 15 0 15
14 0 16 2 5 9 -11 7 -11 9 0 14 9 3 5 6 -7 6 -12 1 -25 -6 -28 -15z"
        />
        <path
          d="M725 65 c17 -53 15 -52 36 -26 10 13 19 28 19 35 0 6 -7 2 -15 -8
-13 -17 -15 -17 -21 -3 -8 21 -25 23 -19 2z"
        />
        <path d="M797 67 c-11 -29 -9 -53 4 -40 6 6 9 21 7 34 -3 21 -4 22 -11 6z" />
        <path
          d="M830 65 c-7 -8 -10 -22 -6 -30 6 -17 46 -21 46 -5 0 6 -5 9 -11 8
-23 -5 -20 22 3 31 22 9 22 10 2 10 -12 1 -27 -6 -34 -14z"
        />
        <path
          d="M897 73 c-4 -3 -7 -17 -7 -30 0 -16 6 -23 20 -23 11 0 20 5 20 10 0
6 -6 10 -12 10 -9 0 -8 4 2 10 13 9 13 10 0 11 -10 0 -8 3 5 9 20 8 20 9 -1 9
-11 1 -24 -2 -27 -6z"
        />
        <path
          d="M954 68 c-4 -6 -2 -14 4 -16 7 -2 12 -8 12 -13 0 -6 -4 -7 -10 -4 -5
3 -10 1 -10 -4 0 -15 37 -14 46 1 4 6 -1 17 -10 24 -16 12 -16 13 1 17 15 4
14 5 -4 6 -12 0 -25 -4 -29 -11z"
        />
      </g>
    </React.Fragment>
  ),
  "industry-logo-12": (
    <React.Fragment>
      <g
        inkscapeLabel="Layer 1"
        inkscapeGroupmode="layer"
        id="layer1"
        transform="translate(-4.9,0.60000152)"
      >
        <g id="g869">
          <path
            inkscapeConnectorCurvature="0"
            class="bcst0"
            d="m 24.100002,1.8999983 c 0,0 -0.6,-0.5 -0.7,-0.5 -1,-0.80000001 -2.2,-1.30000001 -3.5,-1.4000000107349 h -1 -11.5000005 c -1.1,0 -2,0.9000000007349 -2,2.0000000107349 V 21.299998 c 0,1.1 0.9,2 2,2 1.1,0 2,-0.9 2,-2 v -6.6 h 9.9000005 c 1.8,-0.1 3.5,-0.8 4.8,-2 l 0.5,-0.5 c 0.4,-0.4 0.7,-0.8 0.9,-1.2 0.6,-1.0999997 1,-2.2999997 1,-3.6999997 -0.1,-2.2 -1,-4.1 -2.4,-5.4 z m -5.1,9.1999997 H 9.4000015 V 3.3999983 h 9.6000005 c 2.1,0 3.8,1.7 3.8,3.8 0,2.2 -1.7,3.8999997 -3.8,3.8999997 z"
            id="path244"
          />
          <path
            inkscapeConnectorCurvature="0"
            d="m 57.900002,20.399998 -5.1,-10.9999997 -3.6,-8.1 c -0.3,-0.70000001 -0.9,-1.3000000107349 -1.6,-1.40000001 h -1.9 -0.3 c -0.8,0.099999999265 -1.4,0.7 -1.7,1.40000001 l -3.6,8.1 -5.1,10.9999997 c -0.5,1.1 0.2,2.4 1.3,2.7 0.1,0 0.2,0 0.3,0.1 h 0.3 c 0.7,-0.1 1.3,-0.5 1.6,-1.1 l 1.7,-3.9 h 12.2 l 1.7,3.9 c 0.3,0.6 0.9,1 1.6,1.1 h 0.3 c 0.1,0 0.2,0 0.3,-0.1 1.4,-0.3 2.1,-1.6 1.6,-2.7 z m -11.4,-15.9999997 4.7,10.1999997 h -9.3 z"
            id="path246"
          />
          <path
            inkscapeConnectorCurvature="0"
            class="bcst0"
            d="m 72.800002,0.49999829 c -0.8,-0.8 -2.2,-0.8 -3,0 -0.8,0.80000001 -0.8,2.20000001 0,3.00000001 l 5,5 c 0.8,0.8 2.2,0.8 3,0 0.8,-0.8 0.8,-2.2 0,-3 z m 14,13.99999971 c -0.8,-0.8 -2.2,-0.8 -3,0 -0.8,0.8 -0.8,2.2 0,3 l 5,5 c 0.8,0.8 2.2,0.8 3,0 0.8,-0.8 0.8,-2.2 0,-3 z m -3,-5.9999997 c 0.8,0.8 2.2,0.8 3,0 l 5,-5 c 0.8,-0.8 0.8,-2.2 0,-3.00000001 -0.8,-0.8 -2.2,-0.8 -3,0 l -5,5.00000001 c -0.8,0.8 -0.8,2.2 0,3 z m -6,5.9999997 c -0.8,-0.8 -2.2,-0.8 -3,0 l -5,5 c -0.8,0.8 -0.8,2.2 0,3 0.8,0.8 2.2,0.8 3,0 l 5,-5 c 0.8,-0.8 0.8,-2.2 0,-3 z"
            id="path248"
          />
          <path
            id="path250"
            d="m 96.500002,0.09999829 c 0.1,0.1 0.3,0.1 0.4,0.2 0.1,0.1 0.2,0.2 0.2,0.4 0.1,0.1 0.1,0.3 0.1,0.50000001 0,0.2 0,0.3 -0.1,0.5 -0.1,0.1 -0.1,0.3 -0.2,0.4 -0.1,0.1 -0.2,0.2 -0.4,0.2 -0.1,0.1 -0.3,0.1 -0.5,0.1 -0.2,0 -0.3,0 -0.5,-0.1 -0.1,-0.1 -0.3,-0.1 -0.4,-0.2 -0.1,-0.1 -0.2,-0.2 -0.2,-0.4 -0.1,-0.1 -0.1,-0.3 -0.1,-0.5 0,-0.20000001 0,-0.30000001 0.1,-0.50000001 0.1,-0.1 0.1,-0.3 0.2,-0.4 0.1,-0.1 0.2,-0.2 0.4,-0.2 0.1,-0.1000000007349 0.3,-0.1000000007349 0.5,-0.1000000007349 0.2,0 0.3,0.1000000007349 0.5,0.1000000007349 z m -0.9,0.2 c -0.1,0 -0.2,0.1 -0.3,0.2 -0.1,0.1 -0.2,0.2 -0.2,0.3 0,0.1 -0.1,0.30000001 -0.1,0.40000001 0,0.1 0,0.3 0.1,0.4 0,0.1 0.1,0.2 0.2,0.3 0.1,0.1 0.2,0.2 0.3,0.2 0.1,0.1 0.3,0.1 0.4,0.1 0.1,0 0.3,0 0.4,-0.1 0.1,-0.1 0.2,-0.1 0.3,-0.2 0.1,-0.1 0.2,-0.2 0.2,-0.3 0.1,-0.1 0.1,-0.3 0.1,-0.4 0,-0.1 0,-0.30000001 -0.1,-0.40000001 -0.1,-0.1 -0.1,-0.2 -0.2,-0.3 -0.1,-0.1 -0.2,-0.2 -0.3,-0.2 -0.1,-0.1 -0.3,-0.1 -0.4,-0.1 -0.1,0 -0.3,0 -0.4,0.1 z m 0,1.60000001 V 0.49999829 h 0.5 c 0.2,0 0.3,0 0.3,0.1 0.1,0.1 0.1,0.2 0.1,0.3 V 1.0999983 c 0,0 0,0.1 -0.1,0.1 l -0.1,0.1 h -0.1 l 0.4,0.6 h -0.2 l -0.4,-0.6 h -0.3 v 0.6 z m 0.5,-0.8 h 0.1 c 0,0 0.1,0 0.1,-0.10000001 v -0.1 -0.1 c 0,0 0,-0.1 -0.1,-0.1 h -0.1 -0.4 V 1.1999983 h 0.2 c 0.1,-0.1 0.2,-0.1 0.2,-0.1 z"
            inkscapeConnectorCurvature="0"
          />
        </g>
      </g>
    </React.Fragment>
  ),
  "industry-logo-13": (
    <React.Fragment>
      <g
        transform="translate(0.000000,40.000000) scale(0.100000,-0.100000)"
        fill="#000000"
        stroke="none"
      >
        <path
          d="M421 387 c-7 -7 -11 -71 -11 -199 l0 -188 35 0 35 0 0 170 c0 163 1
170 20 170 19 0 20 -7 20 -170 l0 -170 30 0 30 0 0 170 c0 163 1 170 20 170
19 0 20 -7 20 -170 l0 -170 35 0 35 0 0 181 c0 102 -4 188 -10 199 -9 17 -23
19 -129 19 -75 0 -122 -4 -130 -12z"
        />
        <path
          d="M732 388 c-14 -14 -17 -354 -3 -376 5 -9 30 -12 87 -10 l79 3 3 184
c2 127 -1 188 -9 197 -15 18 -140 19 -157 2z m98 -188 c0 -133 -1 -140 -20
-140 -19 0 -20 7 -20 140 0 133 1 140 20 140 19 0 20 -7 20 -140z"
        />
        <path
          d="M941 381 c-16 -29 -14 -343 2 -365 10 -14 25 -16 87 -14 l75 3 0 195
0 195 -77 3 c-68 2 -78 1 -87 -17z m109 -181 l0 -140 -25 0 -25 0 0 140 0 140
25 0 25 0 0 -140z"
        />
        <path
          d="M1150 200 l0 -200 30 0 30 0 0 125 c0 69 4 125 8 125 4 0 15 -13 25
-29 13 -22 17 -52 17 -125 l0 -96 35 0 35 0 0 200 0 200 -34 0 c-34 0 -35 -1
-38 -42 l-3 -43 -24 43 c-20 34 -30 42 -53 42 l-28 0 0 -200z"
        />
        <path
          d="M1362 243 c3 -137 6 -163 24 -198 18 -34 26 -40 58 -43 21 -2 44 2
52 9 11 9 14 9 14 0 0 -8 15 -11 43 -9 39 3 44 6 65 48 20 40 22 58 22 198 l0
153 -32 -3 -33 -3 -5 -162 c-3 -89 -8 -165 -12 -169 -17 -17 -28 57 -28 192
l0 144 -35 0 -36 0 2 -161 c0 -88 -2 -163 -6 -167 -17 -17 -25 37 -25 176 l0
152 -36 0 -35 0 3 -157z"
        />
        <path
          d="M1680 200 l0 -200 71 0 70 0 -3 28 c-3 23 -8 27 -40 30 l-38 3 0 170
0 169 -30 0 -30 0 0 -200z"
        />
        <path
          d="M1857 393 c-4 -3 -7 -93 -7 -200 l0 -193 35 0 34 0 3 72 c2 60 6 73
21 76 15 3 17 -6 17 -72 l0 -76 35 0 35 0 0 89 c0 80 -2 91 -21 105 l-21 14
21 92 c12 50 21 93 21 96 0 2 -15 4 -33 4 -33 0 -33 0 -47 -67 -21 -111 -29
-116 -29 -20 l-1 87 -28 0 c-16 0 -32 -3 -35 -7z"
        />
        <path
          d="M2070 200 l0 -200 30 0 29 0 3 73 c2 56 6 72 18 72 13 0 25 -43 39
-137 1 -5 15 -8 32 -8 l31 0 -7 73 c-4 39 -11 78 -15 86 -5 9 -2 20 6 29 17
16 20 163 4 193 -9 16 -22 19 -90 19 l-80 0 0 -200z m110 75 c0 -63 -1 -65
-25 -65 -24 0 -25 2 -25 65 0 63 1 65 25 65 24 0 25 -2 25 -65z"
        />
        <path
          d="M85 360 c-89 -44 -106 -151 -36 -221 36 -36 43 -39 94 -39 49 0 61 4
92 31 77 68 63 188 -28 230 -53 24 -73 24 -122 -1z"
        />
        <path
          d="M261 81 c-14 -25 -5 -48 20 -56 27 -9 51 13 47 44 -4 34 -51 43 -67
12z"
        />
      </g>
    </React.Fragment>
  ),
  "industry-logo-14": (
    <React.Fragment>
      <path
        d="M59.6796 23.3953H48.6793C48.584 23.2046 48.4252 23.0379 48.449 22.9028C49.005 19.8847 47.0988 18.2486 45.0179 16.6998C41.5308 14.0427 37.2658 12.6076 32.8817 12.6162C28.4977 12.6249 24.2384 14.0767 20.7617 16.7475C17.2479 19.4581 14.7226 23.2486 13.5745 27.5354C12.4263 31.8221 12.7192 36.3675 14.4078 40.4715C16.057 44.5394 19.0077 47.9462 22.7986 50.1592C26.5894 52.3722 31.0067 53.2667 35.3599 52.7028C39.8651 52.258 44.037 50.1309 47.0432 46.746C48.0837 45.5467 47.8374 43.2513 48.2981 41.1148L34.796 43.8391V31.3139L65.5014 25.0949C65.5014 29.1456 65.5014 32.9897 65.4458 36.8338C65.4458 37.1912 64.7548 37.7154 64.2941 37.8425C63.0233 38.2079 61.7128 38.4064 60.2355 38.7082V63.9651H48.1234L47.8851 61.2409C39.1484 65.2756 30.3323 66.0063 21.4051 62.5752C15.1804 60.2645 9.84196 56.0515 6.14769 50.5345C-1.0958 39.7408 -0.809871 24.3245 6.87045 14.0788C11.5207 7.79359 18.2451 3.35665 25.8528 1.55362C33.6523 -0.384334 41.0308 1.31534 48.3457 4.53202C48.3855 3.91251 48.4172 3.4598 48.4411 3.00708C48.4649 2.55436 48.4967 2.04605 48.5284 1.45831H59.6796V23.3953ZM53.2224 30.3052C52.2693 32.5132 52.4282 36.1031 53.5163 36.9689L53.6989 33.5616C54.1278 34.4511 54.3184 34.8879 54.5408 35.301C54.7632 35.714 55.0253 36.1428 55.2715 36.5559L55.6289 36.4208V30.3608L55.0809 30.3211L54.8506 33.5854L53.2224 30.3052ZM45.5103 36.2858C47.3053 35.3724 48.0757 34.0063 47.345 32.807C46.5508 31.4806 45.5103 32.4099 44.7081 32.5529V38.5891H45.2482L45.5103 36.2858ZM51.07 34.1572C47.7739 32.8944 51.2288 32.2987 51.5148 31.0994L48.9414 31.5918V37.8505L51.4274 37.1118L51.2924 36.6432L49.3227 36.4049L51.07 34.1572Z"
        fill="black"
      />
    </React.Fragment>
  ),
  "industry-logo-15": (
    <React.Fragment>
      <g
        transform="translate(0.000000,40.000000) scale(0.100000,-0.100000)"
        fill="#000000"
        stroke="none"
      >
        <path
          d="M20 375 c0 -16 6 -25 15 -25 22 0 22 -115 0 -124 -20 -7 -20 -46 0
-46 12 0 15 -14 15 -65 0 -51 -3 -65 -15 -65 -9 0 -15 -9 -15 -25 0 -25 2 -26
58 -23 49 3 57 6 60 24 2 15 -3 23 -18 27 -19 5 -21 12 -18 64 l3 58 63 3 62
3 0 -66 c0 -52 -3 -65 -16 -65 -10 0 -14 -7 -12 -22 3 -20 10 -23 61 -26 55
-3 57 -2 57 23 0 16 -6 25 -15 25 -12 0 -15 14 -15 65 0 51 3 65 15 65 20 0
20 39 0 46 -22 9 -22 124 0 124 9 0 15 9 15 25 0 24 -3 25 -60 25 -57 0 -60
-1 -60 -25 0 -16 6 -25 15 -25 12 0 15 -13 15 -60 l0 -60 -65 0 -65 0 0 56 c0
48 3 57 21 61 14 4 19 12 17 27 -3 18 -11 21 -60 24 -56 3 -58 2 -58 -23z"
        />
        <path
          d="M350 375 c0 -16 6 -25 15 -25 13 0 15 -23 15 -150 0 -127 -2 -150
-15 -150 -9 0 -15 -9 -15 -25 l0 -25 150 0 150 0 0 60 c0 57 -1 60 -24 60 -21
0 -25 -6 -28 -32 l-3 -33 -77 -3 -78 -3 0 66 0 65 55 0 c52 0 55 1 55 25 0 24
-3 25 -55 25 l-55 0 0 60 0 61 78 -3 77 -3 3 -32 c3 -27 7 -33 28 -33 23 0 24
3 24 60 l0 60 -150 0 -150 0 0 -25z"
        />
        <path
          d="M680 376 c0 -15 7 -26 20 -29 19 -5 20 -14 20 -147 0 -135 -1 -142
-21 -147 -14 -4 -19 -12 -17 -27 3 -18 11 -21 61 -24 55 -3 57 -2 57 23 0 16
-6 25 -15 25 -12 0 -15 17 -15 98 l1 97 47 -120 c63 -160 71 -160 132 -3 25
65 48 118 53 118 4 0 7 -41 7 -91 0 -82 -2 -91 -20 -96 -13 -3 -20 -14 -20
-29 0 -23 3 -24 60 -24 57 0 60 1 60 25 0 16 -6 25 -15 25 -13 0 -15 23 -15
150 0 127 2 150 15 150 9 0 15 9 15 25 0 24 -3 25 -61 25 l-62 0 6 -35 c4 -26
-5 -60 -37 -140 -23 -59 -46 -107 -50 -108 -4 -1 -27 47 -51 108 -32 80 -42
118 -38 142 l6 33 -62 0 c-58 0 -61 -1 -61 -24z"
        />
        <path
          d="M1120 375 c0 -16 6 -25 15 -25 13 0 15 -23 15 -150 0 -127 -2 -150
-15 -150 -9 0 -15 -9 -15 -25 0 -24 3 -25 60 -25 57 0 60 1 60 25 0 16 -6 25
-15 25 -12 0 -15 14 -15 65 l0 65 76 0 c70 0 78 2 105 29 57 57 29 159 -49
181 -20 5 -79 10 -129 10 -93 0 -93 0 -93 -25z m230 -50 c24 -22 26 -52 3 -77
-12 -14 -31 -18 -80 -18 l-63 0 0 61 0 61 60 -4 c39 -3 66 -11 80 -23z"
        />
        <path
          d="M1440 375 c0 -16 6 -25 15 -25 13 0 15 -23 15 -150 0 -127 -2 -150
-15 -150 -9 0 -15 -9 -15 -25 l0 -26 148 3 147 3 3 57 c3 56 2 58 -22 58 -21
0 -25 -5 -28 -32 l-3 -33 -80 0 -80 0 0 60 0 60 58 3 c54 3 58 5 55 25 -3 19
-10 22 -61 25 l-58 3 3 57 3 57 80 0 80 0 3 -32 c3 -27 7 -33 28 -33 23 0 24
3 24 60 l0 60 -150 0 -150 0 0 -25z"
        />
        <path
          d="M1770 375 c0 -16 6 -25 15 -25 13 0 15 -23 15 -150 0 -127 -2 -150
-15 -150 -9 0 -15 -9 -15 -25 0 -25 2 -26 58 -23 49 3 57 6 60 24 2 15 -3 23
-17 27 -18 4 -21 13 -21 61 l0 56 33 0 c31 0 35 -5 77 -82 41 -75 48 -83 78
-86 29 -3 32 -1 32 22 0 16 -6 26 -14 26 -14 0 -76 96 -76 118 0 5 11 13 25
16 31 8 65 60 65 101 0 17 -9 44 -20 62 -24 41 -67 53 -187 53 -93 0 -93 0
-93 -25z m232 -55 c23 -29 23 -45 -2 -70 -16 -16 -33 -20 -85 -20 l-65 0 0 53
c0 30 3 57 8 61 4 5 34 6 67 3 45 -4 64 -11 77 -27z"
        />
      </g>
    </React.Fragment>
  ),
  "industry-logo-16": (
    <React.Fragment>
      <g
        transform="translate(0.000000,56.000000) scale(0.100000,-0.100000)"
        fill="#000000"
        stroke="none"
      >
        <path
          d="M1366 418 l5 -52 -28 24 -28 25 28 -31 c15 -16 27 -39 27 -49 0 -17
-3 -16 -27 6 l-28 24 28 -31 c37 -41 35 -75 -3 -41 -8 6 -5 0 8 -14 25 -28 29
-74 8 -82 -8 -3 -41 -3 -73 0 -32 3 -55 3 -52 -1 6 -6 56 -14 98 -15 20 -1 21
-3 11 -16 -7 -8 -20 -15 -28 -15 -13 0 -13 -3 -4 -12 10 -10 16 -7 28 10 18
27 48 28 66 4 17 -24 49 -37 41 -16 -3 7 -11 14 -18 14 -7 0 -18 6 -24 14 -9
11 -6 15 18 18 17 2 38 0 47 -5 11 -6 15 -6 10 1 -3 6 4 13 16 16 13 3 -3 3
-34 0 -59 -4 -73 1 -40 14 16 6 16 10 5 32 -12 23 -13 24 -13 4 0 -12 -7 -27
-15 -34 -13 -11 -15 -8 -15 20 0 19 8 43 18 54 16 20 16 20 0 7 -30 -23 -22 8
9 42 19 19 22 26 10 22 -9 -4 -17 -11 -17 -16 0 -5 -4 -9 -10 -9 -18 0 -11 23
18 54 15 17 18 23 6 13 -11 -9 -24 -17 -27 -17 -13 0 -7 34 11 54 16 20 16 20
0 7 -16 -12 -18 -11 -18 8 0 11 -4 21 -9 21 -5 0 -8 -23 -5 -52z"
        />
        <path
          d="M1340 440 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
-4 -4 -4 -10z"
        />
        <path
          d="M110 350 c0 -5 5 -10 10 -10 6 0 10 -40 10 -100 0 -60 -4 -100 -10
-100 -5 0 -10 -4 -10 -10 0 -13 87 -13 95 0 3 5 0 10 -8 10 -18 0 -27 21 -27
61 0 27 3 29 35 29 19 0 35 -4 35 -10 0 -5 5 -10 10 -10 6 0 10 14 10 30 0 17
-4 30 -10 30 -5 0 -10 -4 -10 -10 0 -5 -16 -10 -35 -10 -30 0 -35 3 -35 23 0
12 3 32 6 45 9 30 57 30 78 0 16 -22 16 -22 16 10 l0 32 -80 0 c-47 0 -80 -4
-80 -10z"
        />
        <path
          d="M1568 349 c8 -9 12 -46 12 -111 0 -72 -3 -98 -12 -98 -9 0 -8 -4 2
-10 16 -10 80 -14 80 -4 0 3 -7 12 -15 20 -8 9 -15 29 -15 45 0 26 3 29 34 29
46 0 77 27 78 68 2 51 -21 66 -105 70 -59 3 -70 2 -59 -9z m110 -21 c29 -29 1
-103 -37 -96 -16 3 -28 66 -17 94 7 17 38 18 54 2z"
        />
        <path
          d="M1222 290 c15 -23 40 -27 32 -5 -4 8 -10 12 -15 9 -5 -3 -9 0 -9 5 0
6 -5 11 -10 11 -6 0 -5 -8 2 -20z"
        />
        <path
          d="M1487 290 c-4 -15 0 -20 15 -20 18 0 19 2 7 18 -7 9 -14 18 -15 20
-1 1 -4 -6 -7 -18z"
        />
        <path d="M1515 300 c-3 -6 1 -7 9 -4 18 7 21 14 7 14 -6 0 -13 -4 -16 -10z" />
        <path
          d="M870 272 c0 -21 1 -22 16 -8 14 15 64 23 64 10 0 -3 -20 -34 -45 -68
-25 -35 -45 -66 -45 -70 0 -3 34 -6 75 -6 70 0 75 1 75 22 0 20 -1 20 -19 4
-12 -11 -31 -16 -51 -14 l-31 3 45 65 c25 36 46 68 46 72 0 3 -29 8 -65 10
-62 3 -65 2 -65 -20z"
        />
        <path
          d="M1270 285 c0 -7 -8 -19 -17 -24 -16 -9 -14 -10 8 -11 23 0 26 3 21
25 -5 27 -12 33 -12 10z"
        />
        <path
          d="M308 283 c8 -3 12 -28 12 -73 0 -45 -4 -70 -12 -73 -7 -3 7 -6 32 -6
34 -1 41 2 32 11 -14 14 -16 58 -2 58 5 0 16 -13 25 -30 16 -31 43 -50 69 -50
12 0 9 10 -14 42 -27 37 -29 43 -15 58 8 9 15 23 15 31 0 29 -24 39 -89 38
-37 0 -60 -3 -53 -6z m90 -12 c22 -13 11 -56 -15 -59 -19 -3 -23 1 -23 26 0
40 12 50 38 33z"
        />
        <path
          d="M508 283 c15 -6 17 -143 2 -143 -5 0 -10 -4 -10 -10 0 -11 71 -13
119 -4 22 5 31 12 31 27 0 19 -1 19 -19 3 -29 -27 -65 -17 -69 18 -3 27 -2 28
27 24 28 -4 31 -2 31 21 0 19 -3 22 -12 13 -7 -7 -20 -12 -30 -12 -13 0 -18 8
-18 30 0 25 4 30 23 30 13 0 28 -5 35 -12 13 -13 27 -5 17 11 -3 6 -36 11 -73
10 -37 0 -61 -3 -54 -6z"
        />
        <path
          d="M688 278 c15 -15 16 -120 0 -136 -17 -17 -10 -19 67 -13 60 5 70 9
74 26 3 19 3 19 -16 2 -11 -9 -32 -17 -46 -17 -23 0 -27 4 -27 29 0 36 13 46
40 31 18 -10 20 -8 20 17 0 21 -3 24 -12 15 -7 -7 -20 -12 -30 -12 -13 0 -18
8 -18 30 0 25 4 30 23 30 13 0 28 -5 35 -12 13 -13 27 -5 17 11 -3 6 -36 11
-73 11 -51 0 -63 -3 -54 -12z"
        />
        <path
          d="M1048 283 c8 -3 12 -28 12 -73 0 -46 -4 -70 -12 -73 -26 -9 -1 -12
70 -9 64 3 72 6 72 24 0 18 -1 18 -16 3 -24 -24 -68 -16 -72 14 -5 32 11 46
37 32 19 -11 21 -9 20 16 0 15 -3 22 -6 16 -2 -7 -16 -13 -29 -13 -22 0 -25 4
-22 27 4 34 32 42 59 17 18 -16 19 -16 19 4 0 21 -5 22 -72 21 -40 0 -67 -3
-60 -6z"
        />
        <path
          d="M1439 263 c-5 -30 -3 -33 20 -33 21 0 23 2 11 10 -12 7 -8 10 15 10
l30 0 -25 13 c-15 8 -28 10 -31 4 -4 -6 -9 -1 -11 9 -3 13 -6 8 -9 -13z"
        />
        <path
          d="M1778 283 c8 -3 12 -28 12 -74 0 -48 -4 -69 -12 -69 -9 0 -8 -4 2
-10 20 -13 70 -13 70 0 0 6 -4 10 -10 10 -14 0 -13 123 2 138 9 9 2 12 -32 11
-25 0 -39 -3 -32 -6z"
        />
        <path
          d="M1898 278 c15 -15 16 -138 2 -138 -5 0 -10 -4 -10 -10 0 -5 18 -10
40 -10 22 0 40 5 40 10 0 6 -4 10 -10 10 -5 0 -10 11 -10 25 0 19 5 25 23 25
51 0 87 56 55 88 -7 7 -40 12 -77 12 -51 0 -62 -3 -53 -12z m90 -10 c18 -18
15 -46 -7 -57 -24 -13 -31 -5 -31 36 0 34 16 43 38 21z"
        />
        <path
          d="M2078 283 c8 -3 12 -28 12 -73 0 -46 -4 -70 -12 -73 -26 -9 -1 -12
70 -9 65 3 72 6 72 24 0 20 -1 20 -19 4 -27 -24 -65 -17 -69 13 -5 32 11 46
37 32 19 -11 21 -9 21 16 0 21 -3 24 -12 15 -7 -7 -20 -12 -30 -12 -13 0 -18
8 -18 30 0 24 4 30 22 30 12 0 30 -7 40 -17 17 -15 18 -15 18 5 0 21 -5 22
-72 21 -40 0 -67 -3 -60 -6z"
        />
        <path
          d="M1280 244 l-25 -14 28 0 c17 0 27 5 27 15 0 8 -1 15 -2 14 -2 -1 -14
-7 -28 -15z"
        />
        <path
          d="M1314 236 c-10 -22 -9 -25 12 -29 17 -3 21 -1 15 7 -5 6 -10 19 -12
28 -3 15 -6 14 -15 -6z"
        />
        <path d="M1365 130 c-8 -13 -1 -24 14 -19 6 3 7 10 2 18 -6 10 -10 10 -16 1z" />
      </g>
    </React.Fragment>
  ),

  "industry-logo-19": (
    <React.Fragment>
      <g
        transform="translate(0.000000,122.000000) scale(0.100000,-0.100000)"
        fill="#000000"
        stroke="none"
      >
        <path
          d="M742 1160 c-9 -15 -23 -20 -56 -20 -29 0 -52 -7 -70 -21 -25 -19 -26
-25 -26 -110 0 -87 0 -89 -24 -89 -13 0 -60 18 -103 40 -43 22 -91 43 -106 46
l-28 6 22 -53 c18 -47 21 -72 19 -189 -1 -83 -6 -137 -12 -141 -26 -16 124
-69 195 -69 42 0 46 -9 16 -36 -12 -10 -30 -32 -42 -48 l-21 -29 42 5 c39 6
42 4 42 -17 0 -14 11 -32 26 -44 24 -19 40 -21 145 -21 105 0 121 2 139 20 11
11 22 31 26 44 5 22 10 24 42 19 l36 -6 -18 29 c-10 16 -27 38 -37 50 -27 29
-24 34 20 34 39 0 153 31 181 50 11 7 12 12 3 18 -8 5 -12 48 -13 137 -1 112
1 136 19 175 38 84 30 86 -104 19 -86 -42 -119 -48 -129 -23 -3 9 -6 49 -6 90
0 94 -16 114 -89 114 -38 0 -52 5 -62 20 l-14 21 -13 -21z m-39 -92 c-12 -32
-17 -77 -17 -173 l-1 -131 -24 31 c-14 16 -40 47 -60 68 -32 34 -33 37 -13 37
21 0 22 4 22 89 0 104 10 121 70 121 l39 0 -16 -42z m185 30 c8 -8 12 -46 12
-104 0 -90 1 -93 24 -96 22 -3 19 -8 -42 -73 -36 -38 -62 -62 -59 -52 24 65
16 194 -19 315 -6 20 -3 22 33 22 21 0 44 -5 51 -12z m-309 -419 c23 -15 22
-15 -35 -15 -32 1 -78 -2 -101 -7 l-43 -7 0 99 0 99 78 -77 c42 -43 88 -84
101 -92z m531 66 l0 -96 -37 8 c-21 4 -66 7 -101 6 l-63 -1 49 33 c26 18 71
58 98 89 27 30 50 55 52 55 1 1 2 -42 2 -94z m-378 -268 l-5 -78 -51 3 c-46 3
-52 6 -61 32 -8 24 -7 31 9 40 10 6 39 27 65 47 25 20 47 36 47 35 1 0 -1 -36
-4 -79z m147 3 c23 -12 28 -49 9 -68 -7 -7 -34 -12 -60 -12 l-48 0 0 81 0 81
39 -35 c22 -19 49 -40 60 -47z"
        />
        <path
          d="M70 268 c0 -13 -7 -33 -15 -44 -16 -24 -11 -34 18 -34 13 0 17 5 13
15 -3 9 0 15 9 15 8 0 14 -6 12 -12 -1 -7 8 -14 21 -16 26 -4 27 0 7 38 -8 16
-14 35 -13 42 2 8 -9 14 -24 16 -24 3 -28 0 -28 -20z"
        />
        <path
          d="M510 280 c0 -5 7 -10 16 -10 8 0 12 5 9 10 -3 6 -10 10 -16 10 -5 0
-9 -4 -9 -10z"
        />
        <path
          d="M915 240 c0 -46 2 -50 23 -50 19 0 22 4 17 23 l-7 22 17 -22 c18 -26
45 -30 45 -8 0 8 -3 14 -7 13 -12 -4 -15 5 -8 25 10 25 -13 47 -49 47 -31 0
-31 -1 -31 -50z m60 20 c3 -5 -1 -10 -9 -10 -9 0 -16 5 -16 10 0 6 4 10 9 10
6 0 13 -4 16 -10z"
        />
        <path
          d="M1125 240 l0 -51 40 3 c29 2 41 8 43 21 4 19 -24 24 -30 5 -6 -17
-28 0 -28 22 0 10 5 22 10 25 18 11 11 25 -12 25 -21 0 -23 -5 -23 -50z"
        />
        <path
          d="M1424 279 c-4 -7 -8 -29 -9 -50 -2 -35 0 -39 21 -39 13 0 24 5 24 10
0 6 -4 10 -10 10 -14 0 -12 27 3 33 9 4 8 8 -3 16 -13 9 -13 11 3 11 9 0 17 5
17 10 0 14 -37 13 -46 -1z"
        />
        <path
          d="M174 224 c0 -26 4 -34 18 -34 11 0 17 6 15 18 -1 9 3 17 8 17 6 0 9
-8 8 -17 -2 -12 4 -18 17 -18 14 0 19 6 17 19 -1 11 3 20 8 20 6 0 9 -9 8 -20
-2 -13 3 -19 17 -19 17 0 19 4 14 28 -9 37 -9 37 -73 38 l-57 2 0 -34z"
        />
        <path
          d="M331 242 c-13 -25 8 -56 35 -50 29 5 27 62 -3 66 -13 2 -26 -4 -32
-16z m46 -28 c-3 -3 -12 -4 -19 -1 -8 3 -5 6 6 6 11 1 17 -2 13 -5z"
        />
        <path
          d="M415 249 c-4 -5 -1 -9 4 -9 6 0 11 -7 11 -15 0 -8 -5 -15 -11 -15 -5
0 -7 -4 -4 -10 3 -5 15 -10 26 -10 16 0 19 5 14 20 -5 14 -2 20 9 20 9 0 16 6
16 13 0 16 -56 21 -65 6z"
        />
        <path
          d="M504 225 c0 -30 3 -35 23 -35 20 0 23 4 17 28 -9 36 -13 42 -28 42
-7 0 -12 -14 -12 -35z"
        />
        <path
          d="M571 241 c-7 -13 -6 -23 3 -36 13 -18 49 -18 44 0 -1 6 -8 9 -15 7
-7 -2 -13 4 -13 13 0 12 6 15 20 10 14 -5 20 -2 20 9 0 23 -47 20 -59 -3z"
        />
        <path
          d="M657 253 c-2 -5 -3 -19 -3 -33 1 -21 6 -25 34 -27 27 -1 32 2 32 21
0 12 -5 27 -12 34 -13 13 -45 16 -51 5z"
        />
        <path
          d="M740 250 c0 -5 5 -12 11 -16 8 -4 8 -9 0 -17 -18 -18 -13 -29 12 -25
13 2 22 10 22 20 0 10 4 17 10 15 5 -1 8 -10 7 -19 -2 -12 3 -18 17 -18 24 0
24 -2 10 37 -9 27 -15 31 -50 31 -21 1 -39 -3 -39 -8z"
        />
        <path
          d="M1043 253 c-20 -8 -16 -51 6 -58 26 -8 48 3 46 23 -2 36 -20 48 -52
35z m34 -39 c-3 -3 -12 -4 -19 -1 -8 3 -5 6 6 6 11 1 17 -2 13 -5z"
        />
        <path
          d="M1237 254 c-14 -15 -7 -53 12 -59 32 -10 50 3 42 33 -7 26 -39 41
-54 26z m40 -40 c-3 -3 -12 -4 -19 -1 -8 3 -5 6 6 6 11 1 17 -2 13 -5z"
        />
        <path
          d="M1327 253 c-2 -5 -3 -19 -3 -33 1 -20 6 -25 33 -26 31 -2 32 0 27 25
-9 37 -13 41 -34 41 -10 0 -21 -3 -23 -7z"
        />
        <path
          d="M464 105 c-8 -20 4 -35 21 -29 8 4 12 11 9 16 -4 6 -10 5 -15 -3 -7
-11 -9 -10 -9 3 0 9 6 19 13 21 9 4 9 6 -1 6 -7 1 -15 -6 -18 -14z"
        />
        <path d="M1041 111 c-8 -5 -9 -11 -3 -15 5 -3 12 1 16 9 6 17 6 18 -13 6z" />
        <path
          d="M517 96 c-9 -24 -9 -28 3 -21 6 3 10 0 10 -7 0 -9 3 -9 10 2 12 19
13 33 1 26 -5 -4 -11 -1 -13 6 -3 7 -7 5 -11 -6z"
        />
        <path
          d="M985 100 c-3 -5 -2 -17 3 -26 8 -15 10 -15 15 0 4 9 1 16 -6 16 -8 0
-6 4 3 10 9 6 10 10 3 10 -6 0 -15 -4 -18 -10z"
        />
        <path d="M566 84 c-8 -21 -8 -34 2 -34 4 0 9 11 10 25 2 28 -3 32 -12 9z" />
        <path
          d="M610 75 c0 -8 4 -15 8 -15 5 0 9 7 9 15 0 8 -4 15 -9 15 -4 0 -8 -7
-8 -15z"
        />
        <path d="M885 80 c-7 -12 2 -30 16 -30 5 0 9 9 9 20 0 21 -15 27 -25 10z" />
        <path d="M937 71 c-3 -14 0 -17 14 -14 10 3 15 11 12 19 -7 20 -20 17 -26 -5z" />
        <path d="M650 58 c0 -19 2 -20 10 -8 13 19 13 30 0 30 -5 0 -10 -10 -10 -22z" />
        <path d="M677 65 c-4 -8 -2 -17 3 -20 6 -4 10 3 10 14 0 25 -6 27 -13 6z" />
        <path
          d="M737 60 c3 -12 6 -19 7 -18 1 2 8 11 15 21 12 15 11 17 -7 17 -15 0
-19 -5 -15 -20z"
        />
        <path
          d="M780 55 c0 -23 3 -27 10 -15 9 13 11 13 20 0 7 -12 10 -8 10 15 0 23
-3 27 -10 15 -9 -13 -11 -13 -20 0 -7 12 -10 8 -10 -15z"
        />
        <path d="M840 58 c0 -12 3 -18 7 -14 11 10 12 36 2 36 -5 0 -9 -10 -9 -22z" />
      </g>
    </React.Fragment>
  ),
  "industry-logo-20": (
    <React.Fragment>
      <g
        transform="translate(0.000000,82.000000) scale(0.100000,-0.100000)"
        fill="#000000"
        stroke="none"
      >
        <path
          d="M452 804 c-30 -21 -52 -66 -52 -108 0 -26 8 -44 31 -68 28 -29 29
-30 10 -4 -15 20 -21 44 -21 78 0 41 5 54 29 79 45 44 97 36 126 -21 22 -43
19 -102 -7 -136 -16 -20 -17 -25 -5 -15 25 20 47 65 47 96 0 83 -96 143 -158
99z"
        />
        <path
          d="M480 773 c0 -6 5 -15 10 -18 6 -3 10 -13 10 -20 0 -19 -28 -8 -33 13
-4 15 -5 14 -6 -1 0 -10 -5 -16 -9 -13 -4 2 -9 -6 -10 -19 -1 -13 2 -26 7 -30
5 -3 7 4 4 16 -5 17 -2 20 18 17 22 -3 24 -9 27 -59 2 -42 -1 -61 -13 -73 -15
-14 -15 -16 -1 -16 9 0 16 -6 16 -12 0 -10 2 -10 8 0 5 7 17 10 28 6 15 -5 14
-3 -4 11 -20 15 -23 24 -20 78 3 54 5 62 23 62 13 0 19 -6 18 -19 -1 -11 2
-15 8 -9 6 6 4 23 -5 44 -9 19 -15 26 -16 17 0 -10 -7 -18 -15 -18 -17 0 -20
16 -5 25 6 3 10 12 10 18 0 8 -3 7 -9 -2 -7 -11 -9 -11 -14 0 -4 11 -6 11 -6
-1 -1 -13 -2 -13 -11 0 -6 9 -10 10 -10 3z"
        />
        <path
          d="M15 395 c0 -110 1 -115 21 -115 20 0 21 4 17 78 -4 85 -2 84 46 -30
14 -35 25 -48 40 -48 18 0 20 8 23 115 l3 115 -25 0 c-24 0 -25 -2 -22 -62 4
-73 -1 -72 -26 3 -16 47 -22 54 -48 57 l-29 3 0 -116z"
        />
        <path
          d="M256 502 c-2 -4 -14 -46 -25 -92 -12 -47 -26 -95 -31 -107 -9 -21 -7
-23 19 -23 22 0 27 4 27 23 -1 17 5 23 28 25 32 4 51 -15 34 -35 -8 -10 -3
-13 24 -13 l34 0 -29 115 c-27 105 -32 115 -53 115 -13 0 -25 -4 -28 -8z m38
-104 c5 -24 3 -28 -14 -28 -22 0 -23 3 -14 50 7 34 16 27 28 -22z"
        />
        <path
          d="M377 503 c-4 -3 -7 -14 -7 -23 0 -13 7 -16 30 -12 l30 4 0 -84 c0
-52 -5 -89 -12 -96 -9 -9 -4 -12 23 -12 l34 0 -3 96 -3 96 31 -4 c24 -4 30 -1
25 9 -3 8 -5 19 -5 24 0 10 -133 13 -143 2z"
        />
        <path d="M565 395 l0 -115 25 0 25 0 0 115 0 115 -25 0 -25 0 0 -115z" />
        <path
          d="M666 499 c3 -6 18 -57 33 -112 24 -95 28 -102 51 -102 23 0 27 7 50
100 14 55 29 106 33 113 6 8 0 12 -20 12 -27 0 -29 -3 -41 -67 -19 -100 -25
-100 -44 0 -12 64 -14 67 -41 67 -18 0 -26 -4 -21 -11z"
        />
        <path
          d="M875 395 l0 -115 56 0 c43 0 58 4 63 16 10 27 7 30 -34 26 -39 -4
-40 -3 -40 28 0 30 2 32 30 28 26 -4 30 -1 30 19 0 19 -5 23 -30 23 -26 0 -30
4 -30 26 0 24 3 26 40 22 31 -3 39 0 35 10 -3 8 -5 18 -5 23 0 5 -26 9 -57 9
l-58 0 0 -115z"
        />
        <path
          d="M307 229 c-23 -14 -47 -69 -47 -109 0 -75 53 -129 107 -109 59 22 72
160 19 206 -30 25 -51 28 -79 12z m63 -65 c14 -41 6 -96 -16 -115 -24 -20 -44
14 -44 76 0 78 39 104 60 39z"
        />
        <path
          d="M484 217 c-23 -20 -28 -34 -31 -83 -5 -80 20 -124 72 -124 21 0 43 8
54 19 41 41 39 144 -4 187 -30 30 -56 30 -91 1z m64 -29 c16 -16 15 -110 -2
-133 -31 -43 -68 44 -46 111 12 35 27 43 48 22z"
        />
        <path
          d="M85 120 l0 -110 25 0 c24 0 25 3 22 45 -5 61 21 62 40 3 12 -34 20
-44 41 -46 25 -3 26 -2 13 25 -25 50 -27 70 -11 83 20 16 19 74 -1 94 -10 11
-34 16 -72 16 l-57 0 0 -110z m98 58 c13 -20 -6 -48 -34 -48 -15 0 -19 7 -19
36 0 31 3 35 21 32 12 -2 27 -10 32 -20z"
        />
        <path
          d="M630 210 c0 -17 4 -19 26 -14 l25 7 -3 -97 -3 -96 30 0 30 0 -3 96
-3 97 25 -5 c20 -4 26 -1 26 13 0 17 -9 19 -75 19 -69 0 -75 -2 -75 -20z"
        />
        <path
          d="M826 211 c-28 -31 -17 -72 27 -100 20 -13 37 -30 37 -37 0 -20 -31
-33 -57 -23 -24 9 -28 3 -17 -25 9 -23 69 -21 94 4 11 11 20 33 20 48 0 28
-26 62 -47 62 -6 0 -16 7 -23 16 -11 12 -10 18 3 31 13 13 21 14 40 6 22 -10
24 -9 19 13 -4 20 -10 24 -42 24 -24 0 -43 -7 -54 -19z"
        />
      </g>
    </React.Fragment>
  ),
  "industry-logo-21": (
    <React.Fragment>
      <g
        transform="translate(0.000000,121.000000) scale(0.100000,-0.100000)"
        fill="#000000"
        stroke="none"
      >
        <path
          d="M318 984 c-34 -18 -48 -43 -48 -83 0 -23 -5 -31 -18 -31 -10 0 -28
-7 -40 -16 -22 -15 -22 -18 -22 -252 0 -130 4 -243 9 -250 10 -17 501 -141
559 -142 55 0 532 118 555 138 15 14 17 39 17 253 0 237 0 239 -22 253 -29 17
-512 136 -553 136 -16 0 -89 -15 -162 -34 l-131 -33 -11 24 c-10 23 -65 53
-93 53 -7 -1 -25 -7 -40 -16z m715 -80 c144 -36 265 -71 269 -77 4 -7 8 -112
8 -233 0 -166 -3 -224 -12 -231 -15 -11 -513 -133 -543 -133 -31 0 -518 122
-533 133 -9 7 -12 63 -10 240 l3 230 28 10 c22 7 32 4 58 -17 43 -36 91 -35
130 3 16 16 29 38 29 49 0 17 20 25 138 55 75 19 145 36 155 36 10 1 135 -29
280 -65z"
        />
        <path
          d="M317 763 c-4 -3 -7 -68 -7 -143 0 -160 5 -173 71 -174 l44 -1 -4 155
c-2 85 -5 158 -8 163 -5 9 -87 9 -96 0z"
        />
        <path
          d="M464 757 c-2 -7 -3 -80 -2 -162 l3 -150 45 0 45 0 5 125 c5 120 6
125 28 128 22 3 22 2 22 -112 0 -111 1 -116 24 -131 14 -9 39 -15 58 -13 26 2
34 8 36 27 2 13 -1 28 -7 34 -7 7 -11 54 -11 117 0 133 -9 145 -95 138 -31 -3
-58 -1 -61 4 -8 13 -84 9 -90 -5z"
        />
        <path
          d="M780 757 c-19 -10 -26 -21 -28 -52 -2 -34 5 -52 47 -114 28 -41 48
-78 45 -83 -3 -4 -25 -8 -50 -8 -44 0 -45 -1 -42 -27 3 -27 5 -28 73 -31 93
-3 119 10 123 64 3 34 -4 51 -47 114 -28 40 -48 77 -45 82 3 4 25 8 50 8 44 0
45 1 42 28 -3 26 -5 27 -73 30 -42 1 -80 -3 -95 -11z"
        />
        <path
          d="M977 763 c-4 -3 -7 -17 -7 -30 0 -22 4 -23 65 -23 61 0 65 -1 65 -23
0 -19 -8 -26 -42 -36 -81 -24 -88 -33 -88 -111 0 -62 3 -71 23 -85 18 -12 34
-13 69 -7 27 5 53 5 62 0 9 -5 33 -8 54 -6 30 2 38 7 40 27 2 13 -1 28 -7 34
-7 7 -11 58 -11 129 0 118 0 119 -26 128 -28 11 -187 14 -197 3z m123 -203 c0
-38 -4 -50 -15 -50 -19 0 -21 70 -3 88 18 18 18 17 18 -38z"
        />
      </g>
    </React.Fragment>
  ),
  "linkedin-author": (
    <path
      d="M17.4025 32H15.1538C15.0637 31.9793 14.9742 31.9536 14.8822 31.9374C14.2357 31.8429 13.5798 31.7903 12.9421 31.6507C9.15388 30.824 6.02779 28.8958 3.66461 25.8241C0.579824 21.8119 -0.405253 17.2826 0.713755 12.3529C1.62874 8.31742 3.86675 5.12248 7.27635 2.78934C10.8086 0.375463 14.7283 -0.447521 18.9421 0.227138C21.8691 0.695895 24.4651 1.93256 26.7025 3.87893C29.5576 6.35978 31.3444 9.46208 32.0191 13.1921C32.1205 13.7516 32.1855 14.3186 32.2694 14.8819V17.1305C32.2012 17.6312 32.1505 18.1388 32.0635 18.6376C31.4345 22.2287 29.7979 25.2809 27.1225 27.7586C24.8406 29.8723 22.1641 31.2041 19.0929 31.754C18.5328 31.8554 17.9664 31.918 17.4025 32ZM17.6647 24.1769V23.782C17.6647 21.7418 17.6647 19.7013 17.6647 17.6606C17.6647 17.0479 17.7999 16.4834 18.2098 16.0122C18.7731 15.3638 19.4828 15.136 20.3158 15.3237C21.0762 15.4915 21.4673 16.0278 21.6445 16.7406C21.722 17.0422 21.764 17.3518 21.7696 17.6631C21.7815 19.714 21.7784 21.7649 21.7796 23.8158C21.7796 23.936 21.7796 24.0561 21.7796 24.1763H25.6599V23.8258C25.6599 22.2537 25.668 20.6816 25.6599 19.1095C25.653 18.1845 25.6761 17.2532 25.5829 16.3351C25.3876 14.4113 24.3243 12.4298 21.5881 12.2189C20.0892 12.1038 18.8207 12.5625 17.9088 13.8198C17.8519 13.8987 17.7899 13.9744 17.7298 14.0514L17.6628 14.0345V12.5056H13.8051V24.175L17.6647 24.1769ZM11.594 24.1825V12.5012H7.76638V24.1807L11.594 24.1825ZM7.52669 8.86002C7.53044 10.0347 8.43478 10.8752 9.68772 10.8671C10.9738 10.8596 11.8913 10.0141 11.8782 8.84813C11.8663 7.65527 10.9557 6.81101 9.69336 6.82165C8.40975 6.83291 7.5198 7.66904 7.52669 8.86002Z"
      fill="black"
    />
  ),
  "insta-author": (
    <React.Fragment>
      <path
        d="M19.3293 16C19.3293 17.6914 17.9583 19.0625 16.2668 19.0625C14.5754 19.0625 13.2043 17.6914 13.2043 16C13.2043 14.3086 14.5754 12.9375 16.2668 12.9375C17.9583 12.9375 19.3293 14.3086 19.3293 16Z"
        fill="#1B1A1A"
      />
      <path
        d="M23.429 10.5815C23.2817 10.1826 23.0469 9.82151 22.7417 9.52512C22.4453 9.21995 22.0845 8.98508 21.6853 8.83787C21.3616 8.71214 20.8752 8.56248 19.9795 8.52171C19.0105 8.47752 18.72 8.46799 16.2668 8.46799C13.8135 8.46799 13.5229 8.47727 12.5542 8.52146C11.6584 8.56248 11.1719 8.71214 10.8484 8.83787C10.4492 8.98508 10.0881 9.21995 9.79199 9.52512C9.48682 9.82151 9.25195 10.1824 9.10449 10.5815C8.97876 10.9053 8.8291 11.3918 8.78833 12.2876C8.74414 13.2563 8.73462 13.5469 8.73462 16.0002C8.73462 18.4533 8.74414 18.7439 8.78833 19.7129C8.8291 20.6086 8.97876 21.0949 9.10449 21.4187C9.25195 21.8178 9.48657 22.1787 9.79175 22.4751C10.0881 22.7803 10.449 23.0151 10.8481 23.1623C11.1719 23.2883 11.6584 23.438 12.5542 23.4787C13.5229 23.5229 13.8132 23.5322 16.2666 23.5322C18.7202 23.5322 19.0107 23.5229 19.9792 23.4787C20.875 23.438 21.3616 23.2883 21.6853 23.1623C22.4866 22.8532 23.1199 22.2199 23.429 21.4187C23.5547 21.0949 23.7043 20.6086 23.7454 19.7129C23.7896 18.7439 23.7988 18.4533 23.7988 16.0002C23.7988 13.5469 23.7896 13.2563 23.7454 12.2876C23.7046 11.3918 23.5549 10.9053 23.429 10.5815V10.5815ZM16.2668 20.7178C13.6611 20.7178 11.5488 18.6057 11.5488 16C11.5488 13.3943 13.6611 11.2822 16.2668 11.2822C18.8723 11.2822 20.9846 13.3943 20.9846 16C20.9846 18.6057 18.8723 20.7178 16.2668 20.7178ZM21.1711 12.1982C20.5623 12.1982 20.0686 11.7046 20.0686 11.0957C20.0686 10.4868 20.5623 9.99314 21.1711 9.99314C21.78 9.99314 22.2737 10.4868 22.2737 11.0957C22.2734 11.7046 21.78 12.1982 21.1711 12.1982Z"
        fill="#1B1A1A"
      />
      <path
        d="M16.2668 0C7.43164 0 0.266846 7.16479 0.266846 16C0.266846 24.8352 7.43164 32 16.2668 32C25.1021 32 32.2668 24.8352 32.2668 16C32.2668 7.16479 25.1021 0 16.2668 0ZM25.3989 19.7878C25.3545 20.7659 25.199 21.4336 24.9719 22.0181C24.4946 23.2522 23.519 24.2278 22.2849 24.7051C21.7007 24.9321 21.0327 25.0874 20.0549 25.1321C19.0752 25.1768 18.7622 25.1875 16.2671 25.1875C13.7717 25.1875 13.459 25.1768 12.479 25.1321C11.5012 25.0874 10.8333 24.9321 10.249 24.7051C9.63574 24.4744 9.08057 24.1128 8.62158 23.6453C8.1543 23.1865 7.79272 22.6311 7.56201 22.0181C7.33496 21.4338 7.17944 20.7659 7.13501 19.7881C7.08984 18.8081 7.07935 18.4951 7.07935 16C7.07935 13.5049 7.08984 13.1919 7.13477 12.2122C7.1792 11.2341 7.33447 10.5664 7.56152 9.98193C7.79224 9.3689 8.15405 8.81348 8.62158 8.35474C9.08032 7.88721 9.63574 7.52563 10.2488 7.29492C10.8333 7.06787 11.501 6.9126 12.479 6.86792C13.4587 6.82324 13.7717 6.8125 16.2668 6.8125C18.762 6.8125 19.075 6.82324 20.0547 6.86816C21.0327 6.9126 21.7004 7.06787 22.2849 7.29468C22.8979 7.52539 23.4534 7.88721 23.9124 8.35474C24.3796 8.81372 24.7415 9.3689 24.9719 9.98193C25.1992 10.5664 25.3545 11.2341 25.3992 12.2122C25.4438 13.1919 25.4543 13.5049 25.4543 16C25.4543 18.4951 25.4438 18.8081 25.3989 19.7878V19.7878Z"
        fill="#1B1A1A"
      />
    </React.Fragment>
  ),
  "arrow-drop-down": (
    <React.Fragment>
      <path d="M7 10l5 5 5-5z" fill="currentColor" />
      <path d="M0 0h24v24H0z" fill="none" />
    </React.Fragment>
  ),
  "arrow-back": (
    <React.Fragment>
      <path
        d="M11.67 3.87L9.9 2.1 0 12l9.9 9.9 1.77-1.77L3.54 12z"
        fill="currentColor"
      />
      <path fill="none" d="M0 0h24v24H0z" />
    </React.Fragment>
  ),
  "arrow-forward": (
    <React.Fragment>
      <path
        d="M5.88 4.12L13.76 12l-7.88 7.88L8 22l10-10L8 2z"
        fill="currentColor"
      />
      <path fill="none" d="M0 0h24v24H0z" />
    </React.Fragment>
  ),
  cart: (
    <React.Fragment>
      <path d="M0 0h24v24H0z" fill="none" />
      <path
        d="M17.21 9l-4.38-6.56c-.19-.28-.51-.42-.83-.42-.32 0-.64.14-.83.43L6.79 9H2c-.55 0-1 .45-1 1 0 .09.01.18.04.27l2.54 9.27c.23.84 1 1.46 1.92 1.46h13c.92 0 1.69-.62 1.93-1.46l2.54-9.27L23 10c0-.55-.45-1-1-1h-4.79zM9 9l3-4.4L15 9H9zm3 8c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
        fill="currentColor"
      />
    </React.Fragment>
  ),
  check: (
    <React.Fragment>
      <path d="M0 0h24v24H0z" fill="none" />
      <path
        d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
        fill="currentColor"
      />
    </React.Fragment>
  ),
  close: (
    <React.Fragment>
      <path
        d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
        fill="currentColor"
      />
      <path d="M0 0h24v24H0z" fill="none" />
    </React.Fragment>
  ),
  cube: (
    <React.Fragment>
      <path
        fill="currentColor"
        d="M21,16.5C21,16.88 20.79,17.21 20.47,17.38L12.57,21.82C12.41,21.94 12.21,22 12,22C11.79,22 11.59,21.94 11.43,21.82L3.53,17.38C3.21,17.21 3,16.88 3,16.5V7.5C3,7.12 3.21,6.79 3.53,6.62L11.43,2.18C11.59,2.06 11.79,2 12,2C12.21,2 12.41,2.06 12.57,2.18L20.47,6.62C20.79,6.79 21,7.12 21,7.5V16.5M12,4.15L6.04,7.5L12,10.85L17.96,7.5L12,4.15M5,15.91L11,19.29V12.58L5,9.21V15.91M19,15.91V9.21L13,12.58V19.29L19,15.91Z"
      />
    </React.Fragment>
  ),
  filter: (
    <React.Fragment>
      <path
        d="M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z"
        fill="currentColor"
      />
      <path d="M0 0h24v24H0z" fill="none" />
    </React.Fragment>
  ),
  h: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23.103 22.2858C22.6343 21.5515 22.3902 20.6923 22.4015 19.8169V4.18314C22.4015 3.26903 22.635 2.44571 23.103 1.71421C23.564 0.98921 24.2234 0.417191 25 0.0686106V0H14.2896V0.0686106C15.1094 0.43383 15.7528 0.982715 16.2198 1.71527C16.6888 2.44571 16.9223 3.26903 16.9223 4.18314V9.41549C14.5583 9.44293 13.2736 9.90843 12.1404 10.3212C11.084 10.7054 10.0805 11.0685 8.10988 11.0938V4.18314C8.10988 3.26903 8.3444 2.44571 8.81138 1.71421C9.27264 0.989052 9.93242 0.417018 10.7094 0.0686106V0H0V0.0686106C0.819808 0.43383 1.4632 0.982715 1.93018 1.71527C2.39924 2.44571 2.63376 3.26903 2.63376 4.18314V19.8169C2.63376 20.731 2.39924 21.5543 1.93122 22.2858C1.4628 23.0176 0.790377 23.5905 0 23.9314L0 24H10.7094V23.9314C9.93266 23.5825 9.27325 23.0101 8.81242 22.2847C8.34397 21.5507 8.09986 20.6919 8.11091 19.8169V13.1975C10.4749 13.1701 11.7596 12.7056 12.8928 12.2929C13.9502 11.9076 14.9527 11.5445 16.9233 11.5203V19.8169C16.9233 20.731 16.6898 21.5543 16.2218 22.2858C15.7534 23.0176 15.081 23.5905 14.2906 23.9314V24H25V23.9314C24.2233 23.5825 23.5639 23.0101 23.103 22.2847"
      fill="currentColor"
    />
  ),
  list: (
    <React.Fragment>
      <path d="M3 13h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm4 4h14v-2H7v2zm0 4h14v-2H7v2zM7 7v2h14V7H7z" />
      <path d="M0 0h24v24H0z" fill="none" />
    </React.Fragment>
  ),
  map: (
    <React.Fragment>
      <path
        d="M20.5 3l-.16.03L15 5.1 9 3 3.36 4.9c-.21.07-.36.25-.36.48V20.5c0 .28.22.5.5.5l.16-.03L9 18.9l6 2.1 5.64-1.9c.21-.07.36-.25.36-.48V3.5c0-.28-.22-.5-.5-.5zM15 19l-6-2.11V5l6 2.11V19z"
        fill="currentColor"
      />
      <path d="M0 0h24v24H0z" fill="none" />
    </React.Fragment>
  ),
  play: (
    <React.Fragment>
      <path d="M8 5v14l11-7z" fill="currentColor" />
      <path d="M0 0h24v24H0z" fill="none" />
    </React.Fragment>
  ),
  search: (
    <React.Fragment>
      <path
        d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
        fill="currentColor"
      />
      <path d="M0 0h24v24H0z" fill="none" />
    </React.Fragment>
  ),
  "skip-next": (
    <React.Fragment>
      <path d="M6 18l8.5-6L6 6v12zM16 6v12h2V6h-2z" fill="currentColor" />
      <path d="M0 0h24v24H0z" fill="none" />
    </React.Fragment>
  ),
  sort: (
    <React.Fragment>
      <path d="M3 18h6v-2H3v2zM3 6v2h18V6H3zm0 7h12v-2H3v2z" />
      <path d="M0 0h24v24H0z" fill="none" />
    </React.Fragment>
  ),
  store: (
    <React.Fragment>
      <path d="M0 0h24v24H0z" fill="none" />
      <path
        d="M20 4H4v2h16V4zm1 10v-2l-1-5H4l-1 5v2h1v6h10v-6h4v6h2v-6h1zm-9 4H6v-4h6v4z"
        fill="currentColor"
      />
    </React.Fragment>
  ),
  globe: (
    <React.Fragment>
      <path
        d="M22.0505 5.07321C22.0501 5.06548 22.0492 5.05774 22.0479 5.05005C22.0179 5.0072 21.981 4.97033 21.9501 4.92833C21.7261 4.62309 21.4889 4.3293 21.2385 4.04691C21.17 3.96975 21.1013 3.89344 21.0311 3.81798C20.7733 3.54193 20.5029 3.27868 20.22 3.02835C20.1677 2.98203 20.1188 2.93405 20.0665 2.88859C19.3692 2.29122 18.6057 1.77568 17.791 1.35218C17.7584 1.33505 17.7241 1.32048 17.6907 1.3033C17.3279 1.11893 16.9558 0.953192 16.576 0.806851C16.4903 0.776005 16.4123 0.746817 16.3308 0.721095C15.993 0.59937 15.6501 0.492766 15.302 0.401284C15.1991 0.373854 15.0962 0.345571 14.9916 0.321557C14.6486 0.24183 14.3057 0.180943 13.955 0.131208C13.8487 0.115785 13.7441 0.0951874 13.6369 0.0823266C12.7337 -0.0274422 11.8205 -0.0274422 10.9173 0.0823266C10.8101 0.0951874 10.7055 0.115785 10.5992 0.131208C10.2485 0.180943 9.90211 0.24183 9.56255 0.321557C9.45796 0.345571 9.35507 0.373854 9.25219 0.401284C8.90178 0.492716 8.55886 0.59932 8.22333 0.721095C8.13757 0.750233 8.05955 0.779421 7.97812 0.806851C7.59837 0.953192 7.22631 1.11888 6.8635 1.3033C6.83004 1.32043 6.79578 1.335 6.76318 1.35218C5.94576 1.77523 5.17969 2.29071 4.47993 2.88859C4.42764 2.934 4.37876 2.98203 4.32646 3.02835C4.04066 3.27984 3.77028 3.54308 3.51538 3.81798C3.44509 3.89344 3.37647 3.96975 3.30789 4.04691C3.05696 4.32869 2.81974 4.62248 2.59628 4.92828C2.56544 4.97028 2.52856 5.00715 2.49852 5.05C2.4946 5.05749 2.49113 5.06523 2.48822 5.07316C-0.469055 9.2176 -0.469055 14.7824 2.48822 18.9268C2.49113 18.9347 2.49455 18.9425 2.49852 18.9499C2.52851 18.9928 2.56539 19.0297 2.59628 19.0717C2.81979 19.3769 3.05696 19.6707 3.30789 19.9531C3.37647 20.0303 3.44509 20.1066 3.51538 20.182C3.77375 20.4581 4.04407 20.7213 4.32646 20.9717C4.37876 21.018 4.42764 21.0659 4.47993 21.1114C5.17723 21.7088 5.94074 22.2243 6.75544 22.6478C6.78804 22.665 6.8223 22.6795 6.85576 22.6967C7.21858 22.8811 7.59059 23.0468 7.97038 23.1931C8.05614 23.224 8.13415 23.2532 8.21559 23.2789C8.55338 23.4006 8.89636 23.5072 9.24445 23.5987C9.34734 23.6261 9.45022 23.6544 9.55482 23.6784C9.89779 23.7582 10.2407 23.8191 10.5914 23.8688C10.6977 23.8842 10.8023 23.9048 10.9095 23.9177C11.8127 24.0274 12.7259 24.0274 13.6292 23.9177C13.7363 23.9048 13.8409 23.8842 13.9473 23.8688C14.2979 23.8191 14.6443 23.7582 14.9839 23.6784C15.0885 23.6544 15.1914 23.6261 15.2942 23.5987C15.6452 23.5073 15.9882 23.4007 16.3231 23.2789C16.4089 23.2498 16.4869 23.2206 16.5683 23.1931C16.9481 23.0468 17.3201 22.8811 17.6829 22.6967C17.7164 22.6796 17.7507 22.665 17.7833 22.6478C18.598 22.2243 19.3615 21.7088 20.0588 21.1114C20.1111 21.0659 20.1599 21.018 20.2122 20.9717C20.498 20.7207 20.7684 20.4575 21.0233 20.182C21.0936 20.1066 21.1622 20.0303 21.2308 19.9531C21.4817 19.6707 21.719 19.3769 21.9424 19.0717C21.9733 19.0297 22.0101 18.9928 22.0402 18.9499C22.0441 18.9425 22.0476 18.9347 22.0505 18.9268C25.0077 14.7824 25.0077 9.21765 22.0505 5.07321ZM21.0722 6.69543C21.8922 8.04586 22.3873 9.56826 22.5186 11.1427H17.3829C17.32 10.1211 17.1592 9.10788 16.9027 8.117C18.3535 7.84531 19.7576 7.36655 21.0722 6.69543ZM14.4549 1.94804C14.5029 1.9592 14.5492 1.97462 14.5972 1.98577C14.9041 2.05781 15.2085 2.1401 15.506 2.24299C15.5515 2.25841 15.5961 2.27645 15.6407 2.29272C15.9356 2.39561 16.2262 2.50965 16.5109 2.63569C16.5607 2.65885 16.6096 2.68457 16.6593 2.70773C16.9319 2.8375 17.1983 2.97781 17.4584 3.12872L17.6298 3.23246C17.8767 3.38338 18.1168 3.54484 18.35 3.7169C18.4101 3.76061 18.4701 3.80266 18.5292 3.85064C18.7579 4.0221 18.9768 4.20586 19.186 4.40194C19.2408 4.45168 19.2975 4.50056 19.3515 4.552C19.571 4.76033 19.7801 4.98068 19.9825 5.20875C20.0082 5.23875 20.0357 5.26618 20.0614 5.29451C18.9004 5.84777 17.6706 6.24284 16.4046 6.46911C15.8182 4.85689 15.0435 3.31953 14.0966 1.88896C14.2156 1.91037 14.3374 1.92237 14.4549 1.94804ZM8.87501 11.1426C8.94263 10.215 9.10057 9.29607 9.34658 8.39903C10.318 8.51443 11.2954 8.57165 12.2737 8.57049C13.2529 8.57019 14.2312 8.51151 15.2034 8.39471C15.449 9.29321 15.6061 10.2136 15.6724 11.1426H8.87501ZM15.6724 12.8575C15.6048 13.7851 15.4468 14.704 15.2008 15.6011C14.2294 15.4857 13.2519 15.4285 12.2737 15.4296C11.2945 15.4285 10.3163 15.4857 9.34397 15.6011C9.09866 14.704 8.94162 13.7851 8.87496 12.8575H15.6724ZM12.2737 2.27047C13.2494 3.65335 14.0519 5.15068 14.6632 6.72889C13.8695 6.81319 13.0719 6.85554 12.2737 6.85579C11.4763 6.85483 10.6796 6.81223 9.88669 6.72803C10.4988 5.15088 11.3003 3.65406 12.2737 2.27047ZM4.56579 5.20785C4.76729 4.97977 4.97733 4.75943 5.19682 4.5511C5.25083 4.49965 5.30744 4.45077 5.3623 4.40104C5.5738 4.20843 5.79274 4.02466 6.01906 3.84973C6.07824 3.80427 6.13822 3.76398 6.19825 3.716C6.43146 3.54454 6.67154 3.38303 6.91846 3.23156L7.08992 3.12782C7.35 2.9758 7.61636 2.83544 7.889 2.70683C7.93873 2.68367 7.98761 2.65795 8.03735 2.63479C8.32199 2.50618 8.61267 2.39214 8.90761 2.29182C8.95217 2.27554 8.99337 2.25751 9.0422 2.24208C9.3397 2.14261 9.64238 2.06032 9.95104 1.98487C9.99907 1.97372 10.0453 1.95829 10.0942 1.94799C10.2117 1.92227 10.3334 1.91027 10.4526 1.88881C9.50533 3.31963 8.73037 4.85729 8.14365 6.46981C6.87772 6.24355 5.6478 5.84848 4.48692 5.29521C4.51264 5.26527 4.54007 5.23784 4.56579 5.20785ZM3.47519 6.69543C4.78945 7.3665 6.19333 7.84526 7.64379 8.117C7.38763 9.10793 7.22712 10.1211 7.16452 11.1427H2.0288C2.16012 9.56826 2.65526 8.04586 3.47519 6.69543ZM3.47519 17.3047C2.65521 15.9543 2.16007 14.4319 2.0288 12.8575H7.16452C7.22742 13.8791 7.38818 14.8923 7.64464 15.8832C6.19393 16.1548 4.78975 16.6335 3.47519 17.3047ZM10.0925 22.0521C10.0445 22.0409 9.99821 22.0255 9.95019 22.0143C9.64324 21.9423 9.33885 21.86 9.04134 21.7571C8.99588 21.7417 8.95132 21.7237 8.9067 21.7074C8.61176 21.6045 8.32114 21.4905 8.03644 21.3644C7.98671 21.3412 7.93783 21.3155 7.88809 21.2924C7.61545 21.1626 7.34909 21.0223 7.08901 20.8714L6.91755 20.7676C6.67064 20.6167 6.43055 20.4553 6.19735 20.2832C6.13732 20.2395 6.07733 20.1974 6.01815 20.1495C5.78952 19.978 5.57059 19.7942 5.3614 19.5982C5.30654 19.5484 5.24992 19.4995 5.19592 19.4481C4.97643 19.2398 4.76724 19.0194 4.56489 18.7913C4.53916 18.7614 4.51173 18.7339 4.48601 18.7056C5.64695 18.1523 6.87681 17.7573 8.14274 17.531C8.72922 19.1432 9.50393 20.6806 10.4508 22.1111C10.3317 22.0898 10.21 22.0778 10.0925 22.0521ZM12.2737 21.7297C11.298 20.3468 10.4955 18.8495 9.88412 17.2713C11.472 17.1004 13.0736 17.1004 14.6615 17.2713L14.6606 17.2721C14.0486 18.8492 13.2471 20.346 12.2737 21.7297ZM19.9816 18.7922C19.7801 19.0203 19.57 19.2407 19.3506 19.449C19.2966 19.5004 19.2399 19.5493 19.1851 19.5991C18.9736 19.7923 18.7546 19.976 18.5283 20.1504C18.4691 20.1958 18.4092 20.2404 18.3491 20.2841C18.1159 20.4556 17.8758 20.6171 17.6289 20.7685L17.4575 20.8723C17.1979 21.0237 16.9316 21.1641 16.6584 21.2933C16.6087 21.3164 16.5598 21.3422 16.51 21.3653C16.2254 21.4939 15.9347 21.608 15.6398 21.7083C15.5952 21.7246 15.554 21.7426 15.5052 21.758C15.2077 21.8575 14.905 21.9398 14.5963 22.0152C14.5483 22.0264 14.502 22.0418 14.4532 22.0521C14.3357 22.0778 14.2139 22.0898 14.0948 22.1113C15.0416 20.6807 15.8164 19.1434 16.4028 17.5311C17.6688 17.7574 18.8987 18.1525 20.0596 18.7057C20.0347 18.7348 20.0073 18.7623 19.9816 18.7922ZM21.0722 17.3047C19.7579 16.6336 18.3541 16.1549 16.9036 15.8832C17.1598 14.8922 17.3203 13.879 17.3829 12.8575H22.5186C22.3873 14.4318 21.8921 15.9542 21.0722 17.3047Z"
        fill="black"
      />
    </React.Fragment>
  ),
  verified: (
    <React.Fragment>
      <path
        d="M12 0L20.4853 3.51472L24 12L20.4853 20.4853L12 24L3.51472 20.4853L0 12L3.51472 3.51472L12 0Z"
        fill="#1973C0"
      />
      <path
        d="M10.3331 14.3167L8.01643 12L7.22754 12.7833L10.3331 15.8889L16.9998 9.22224L16.2164 8.4389L10.3331 14.3167Z"
        fill="white"
        stroke="white"
      />
    </React.Fragment>
  ),
  plus: (
    <React.Fragment>
      <path d="M19 13H13V19H11V13H5V11H11V5H13V11H19V13Z" fill="currentColor" />
    </React.Fragment>
  ),
  minus: (
    <React.Fragment>
      <path d="M19 13H5V11H19V13Z" fill="currentColor" />
    </React.Fragment>
  ),
  "pointer-right": (
    <React.Fragment>
      <path
        d="M16.787 9.1488C16.9568 8.97072 17.2559 8.94947 17.4551 9.10133L20.8336 11.6776C20.9392 11.7581 21 11.8759 21 12C21 12.1241 20.9392 12.2419 20.8336 12.3224L17.4551 14.8987C17.2559 15.0505 16.9568 15.0293 16.787 14.8512C16.6171 14.6731 16.6409 14.4057 16.84 14.2538L19.2403 12.4236H3.47391C3.21218 12.4236 3 12.2338 3 11.9998C3 11.7658 3.21218 11.5761 3.47391 11.5761H19.2398L16.84 9.74619C16.6409 9.59433 16.6171 9.32687 16.787 9.1488Z"
        fill="currentColor"
      />
    </React.Fragment>
  ),
  "pointer-left": (
    <React.Fragment>
      <path
        d="M7.21305 14.8512C7.04322 15.0293 6.7441 15.0505 6.54495 14.8987L3.1664 12.3224C3.06082 12.2419 3 12.1241 3 12C3 11.8759 3.06082 11.7581 3.1664 11.6776L6.54495 9.10133C6.7441 8.94947 7.04322 8.97072 7.21305 9.14879C7.38288 9.32687 7.35912 9.59433 7.15997 9.74618L4.75973 11.5764L20.5261 11.5764C20.7878 11.5764 21 11.7662 21 12.0002C21 12.2342 20.7878 12.4239 20.5261 12.4239L4.76022 12.4239L7.15997 14.2538C7.35912 14.4057 7.38288 14.6731 7.21305 14.8512Z"
        fill="currentColor"
      />
    </React.Fragment>
  ),
  "star-filled": (
    <React.Fragment>
      <path
        d="M24.7218 9.06824C24.5638 8.56112 24.1328 8.20209 23.6248 8.15413L16.6967 7.49779L13.9587 0.80863C13.7566 0.317185 13.2966 0 12.7846 0C12.2727 0 11.8125 0.317185 11.6116 0.80863L8.87361 7.49779L1.94443 8.15413C1.43649 8.20305 1.00637 8.56208 0.847428 9.06824C0.689405 9.57535 0.835342 10.1316 1.2195 10.4831L6.45658 15.2751L4.91243 22.372C4.79945 22.8939 4.99355 23.4335 5.40847 23.7464C5.6315 23.9155 5.89353 24 6.15647 24C6.38242 24 6.60856 23.9373 6.81053 23.8112L12.7846 20.0837L18.7576 23.8112C19.1958 24.0845 19.7468 24.0594 20.1608 23.7464C20.5757 23.4335 20.7698 22.8939 20.6568 22.372L19.1127 15.2751L24.3497 10.4831C24.7337 10.1316 24.8798 9.5765 24.7218 9.06824V9.06824Z"
        fill="#7428EF"
      />
    </React.Fragment>
  ),
  "star-empty": (
    <React.Fragment>
      <path
        d="M22.97 8.65094L22.9702 8.65096C23.2673 8.67901 23.5361 8.89136 23.6376 9.2164C23.7398 9.54515 23.6426 9.89751 23.4051 10.115C23.4051 10.115 23.4051 10.1151 23.405 10.1151L18.1681 14.907L17.9563 15.1007L18.0173 15.3812L19.5614 22.4776C19.6348 22.8168 19.5061 23.1567 19.2525 23.348L19.2521 23.3484C19.0024 23.5372 18.6761 23.5512 18.4141 23.3879C18.414 23.3878 18.414 23.3878 18.4139 23.3878L12.4411 19.6604L12.1769 19.4955L11.9127 19.6603L5.93864 23.3878L5.9385 23.3879C5.81628 23.4642 5.68181 23.501 5.54874 23.501C5.39366 23.501 5.23773 23.4515 5.10225 23.3488L5.10126 23.348C4.84765 23.1567 4.71901 22.8168 4.79244 22.4776L6.33648 15.3812L6.39751 15.1007L6.18573 14.907L0.948688 10.115C0.948676 10.115 0.948665 10.115 0.948653 10.115C0.711275 9.89771 0.614164 9.54461 0.715983 9.21719C0.818296 8.89208 1.08706 8.67952 1.38454 8.65087L8.31294 7.9946L8.6134 7.96614L8.72773 7.68683L11.4657 0.997671L11.4658 0.997438C11.5937 0.684518 11.8773 0.499032 12.1769 0.499032C12.4762 0.499032 12.7601 0.684282 12.8894 0.998239C12.8894 0.998316 12.8894 0.998392 12.8895 0.998469L15.6272 7.68683L15.7415 7.96613L16.0419 7.9946L22.97 8.65094Z"
        stroke="#7428EF"
        fill="transparent"
        strokeWidth="0.998064"
      />
    </React.Fragment>
  ),
  "icon-savelater": (
    <React.Fragment>
      <path
        d="M15.9794 5C18.1935 5 20 6.97122 20 9.40368C19.9256 10.6722 19.3982 11.88 18.5032 12.8315L12.9084 18.6286C12.7947 18.7456 12.6564 18.8391 12.5022 18.903C12.3481 18.967 12.1814 19 12.0129 19C11.8444 19 11.6778 18.967 11.5236 18.903C11.3694 18.8391 11.2311 18.7456 11.1174 18.6286L5.49677 12.8363C4.59144 11.8909 4.06248 10.6796 4 9.40853C4 6.97607 5.80645 5.00486 8.02065 5.00486C9.48129 5.00486 11.5561 6.80128 12.2581 8.39865C12.96 6.82071 14.5187 5 15.9794 5Z"
        fill="currentColor"
        stroke="#333"
        strokeLinejoin="round"
      />
    </React.Fragment>
  ),
  "icon-like": (
    <React.Fragment>
      <path
        d="M15.9794 5C18.1935 5 20 6.97122 20 9.40368C19.9256 10.6722 19.3982 11.88 18.5032 12.8315L12.9084 18.6286C12.7947 18.7456 12.6564 18.8391 12.5022 18.903C12.3481 18.967 12.1814 19 12.0129 19C11.8444 19 11.6778 18.967 11.5236 18.903C11.3694 18.8391 11.2311 18.7456 11.1174 18.6286L5.49677 12.8363C4.59144 11.8909 4.06248 10.6796 4 9.40853C4 6.97607 5.80645 5.00486 8.02065 5.00486C9.48129 5.00486 11.5561 6.80128 12.2581 8.39865C12.96 6.82071 14.5187 5 15.9794 5Z"
        fill="#F4EEFF"
        stroke="#7428EF"
        strokeLinejoin="round"
      />
    </React.Fragment>
  ),
  "auth-google": (
    <React.Fragment>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM17.9995 11.2871C17.9942 11.2353 17.9505 11.1949 17.8974 11.1949L11.7276 11.1949C11.6709 11.1949 11.625 11.2408 11.625 11.2975V13.4524C11.625 13.5091 11.6709 13.5551 11.7276 13.5551H15.4633C15.255 14.2339 14.8715 14.836 14.3655 15.3089C13.8776 15.7651 13.2755 16.1008 12.6069 16.2689C12.2927 16.3479 11.9637 16.3898 11.625 16.3898C11.4948 16.3898 11.3661 16.3836 11.2391 16.3715C10.4181 16.2933 9.66937 15.9677 9.0679 15.4703C8.67848 15.1482 8.35087 14.7541 8.10552 14.3083C8.02811 14.1677 7.9589 14.0219 7.89851 13.8717C7.71252 13.4091 7.61017 12.904 7.61017 12.375C7.61017 11.7747 7.74203 11.2049 7.9783 10.6936C8.01548 10.6131 8.05524 10.534 8.09749 10.4565C8.71493 9.32333 9.86273 8.52111 11.2073 8.38208L11.2202 8.3806C11.2266 8.37984 11.2329 8.37907 11.2395 8.37845C11.3665 8.36635 11.4949 8.36014 11.625 8.36014C12.4632 8.36014 13.2413 8.61703 13.885 9.0563C13.9421 9.09524 13.9981 9.13562 14.053 9.17737C14.1595 9.25837 14.2618 9.34456 14.3596 9.43554C14.3707 9.44588 14.3817 9.45629 14.3927 9.46675C14.4216 9.49421 14.4624 9.5013 14.4977 9.48856C14.5115 9.48359 14.5244 9.47559 14.5354 9.46456L16.0597 7.94027C16.0801 7.9199 16.09 7.8932 16.0897 7.86659C16.0894 7.8483 16.0843 7.83005 16.0744 7.81392C16.0699 7.80658 16.0644 7.79968 16.058 7.79342C14.9105 6.68337 13.3476 6 11.625 6C11.4053 6 11.1881 6.01112 10.9741 6.03283C8.84716 6.24853 7.02908 7.50977 6.04219 9.29473C5.59074 10.1111 5.31325 11.0371 5.25958 12.0227C5.25348 12.1346 5.25028 12.2473 5.25002 12.3606L5.25 12.375C5.25 12.4055 5.25021 12.436 5.25064 12.4664C5.2981 15.8831 8.00739 18.6376 11.4156 18.7466C11.4395 18.7474 11.4634 18.748 11.4874 18.7485C11.5331 18.7495 11.579 18.75 11.625 18.75C13.337 18.75 14.8916 18.075 16.0368 16.9767C16.0753 16.9398 16.1133 16.9024 16.1509 16.8645C17.0307 15.9776 17.6516 14.8335 17.8907 13.5551C17.9625 13.1726 18 12.7783 18 12.375V11.2976C18 11.294 17.9998 11.2905 17.9995 11.2871Z"
        fill="currentColor"
      />
    </React.Fragment>
  ),
  "auth-facebook": (
    <React.Fragment>
      <path
        d="M24 12C24 5.37188 18.6281 0 12 0C5.37188 0 0 5.37188 0 12C0 18.6281 5.37188 24 12 24C12.0703 24 12.1406 24 12.2109 23.9953V14.6578H9.63281V11.6531H12.2109V9.44062C12.2109 6.87656 13.7766 5.47969 16.0641 5.47969C17.1609 5.47969 18.1031 5.55938 18.375 5.59688V8.27813H16.8C15.5578 8.27813 15.3141 8.86875 15.3141 9.73594V11.6484H18.2906L17.9016 14.6531H15.3141V23.5359C20.3297 22.0969 24 17.4797 24 12Z"
        fill="currentColor"
      />
    </React.Fragment>
  ),
  "auth-twitter": (
    <React.Fragment>
      <path
        d="M12.3636 0C5.53643 0 0 5.3736 0 12C0 18.6264 5.53643 24 12.3636 24C19.1908 24 24.7273 18.6264 24.7273 12C24.7273 5.3736 19.1908 0 12.3636 0ZM18.0087 9.35632C18.0142 9.47443 18.0168 9.59308 18.0168 9.71228C18.0168 13.3519 15.1625 17.5488 9.94264 17.549H9.94283H9.94264C8.34002 17.549 6.84871 17.0931 5.59284 16.3118C5.81489 16.3372 6.04089 16.3499 6.26973 16.3499C7.59937 16.3499 8.82298 15.9097 9.79436 15.1708C8.55207 15.1485 7.50466 14.3522 7.1432 13.2578C7.3162 13.29 7.4941 13.3076 7.67652 13.3076C7.93555 13.3076 8.18646 13.2737 8.42492 13.2105C7.12641 12.9582 6.14824 11.8444 6.14824 10.5106C6.14824 10.4982 6.14824 10.487 6.14861 10.4755C6.53102 10.6818 6.96832 10.806 7.43392 10.8199C6.67194 10.3264 6.17106 9.48285 6.17106 8.52722C6.17106 8.02258 6.31161 7.5498 6.55535 7.14276C7.95479 8.80939 10.0462 9.90546 12.4048 10.0206C12.3561 9.81885 12.331 9.60864 12.331 9.39258C12.331 7.87207 13.602 6.63849 15.1691 6.63849C15.9854 6.63849 16.7227 6.97339 17.2405 7.50879C17.8871 7.38501 18.4941 7.15576 19.0426 6.84027C18.8303 7.48315 18.3806 8.02258 17.7946 8.36371C18.3687 8.29706 18.9158 8.14929 19.4242 7.92993C19.0444 8.48236 18.5628 8.96759 18.0087 9.35632Z"
        fill="currentColor"
      />
    </React.Fragment>
  ),
  "auth-email": (
    <React.Fragment>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12ZM19.3678 7.50356L14.8187 12.0235L19.3678 16.5433C19.4501 16.3715 19.5 16.1814 19.5 15.9785V8.06838C19.5 7.86544 19.4501 7.67545 19.3678 7.50356ZM5.81838 6.75H18.1817C18.3846 6.75 18.5746 6.79989 18.7465 6.88213L12.9321 12.6672C12.418 13.1813 11.582 13.1813 11.0679 12.6672L5.25356 6.88213C5.42545 6.79989 5.61544 6.75 5.81838 6.75ZM4.63213 7.50356C4.54989 7.67545 4.5 7.86544 4.5 8.06838V15.9785C4.5 16.1815 4.54989 16.3715 4.63213 16.5433L9.18132 12.0235L4.63213 7.50356ZM13.5535 13.2886L14.1973 12.6448L18.7465 17.1647C18.5746 17.247 18.3846 17.2969 18.1817 17.2969H5.81838C5.61544 17.2969 5.42545 17.247 5.25356 17.1647L9.80275 12.6448L10.4465 13.2886C11.3031 14.1452 12.6969 14.1452 13.5535 13.2886Z"
        fill="currentColor"
      />
    </React.Fragment>
  ),
  "next-arrow": (
    <React.Fragment>
      <path d="M0.999999 1L31 21L0.999999 41" stroke="black" fill="none" />
    </React.Fragment>
  ),
  "prev-arrow": (
    <React.Fragment>
      <path d="M31 1L1 21L31 41" stroke="black" fill="none" />
    </React.Fragment>
  ),
  profile: (
    <React.Fragment>
      <path
        d="M12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23Z"
        stroke="currentColor"
        strokeMiterlimit="10"
      />
      <path
        d="M18.2155 11.9553C18.2155 15.5723 15.4166 18.2155 11.958 18.2155C8.4993 18.2155 5.69513 15.5723 5.69513 11.9553"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M8.81851 9.60161C9.39272 9.60161 9.8582 9.13612 9.8582 8.56191C9.8582 7.98771 9.39272 7.52222 8.81851 7.52222C8.2443 7.52222 7.77881 7.98771 7.77881 8.56191C7.77881 9.13612 8.2443 9.60161 8.81851 9.60161Z"
        fill="currentColor"
      />
      <path
        d="M15.2092 9.67119C15.7834 9.67119 16.2489 9.2057 16.2489 8.63149C16.2489 8.05729 15.7834 7.5918 15.2092 7.5918C14.635 7.5918 14.1695 8.05729 14.1695 8.63149C14.1695 9.2057 14.635 9.67119 15.2092 9.67119Z"
        fill="currentColor"
      />
    </React.Fragment>
  ),
  menu: (
    <React.Fragment>
      <path
        d="M3 18H21V16H3V18ZM3 13H21V11H3V13ZM3 6V8H21V6H3Z"
        fill="currentColor"
      />
    </React.Fragment>
  ),
  facebook: (
    <React.Fragment>
      <path
        d="M24 12C24 5.37188 18.6281 0 12 0C5.37188 0 0 5.37188 0 12C0 18.6281 5.37188 24 12 24C12.0703 24 12.1406 24 12.2109 23.9953V14.6578H9.63281V11.6531H12.2109V9.44062C12.2109 6.87656 13.7766 5.47969 16.0641 5.47969C17.1609 5.47969 18.1031 5.55938 18.375 5.59688V8.27813H16.8C15.5578 8.27813 15.3141 8.86875 15.3141 9.73594V11.6484H18.2906L17.9016 14.6531H15.3141V23.5359C20.3297 22.0969 24 17.4797 24 12V12Z"
        fill="currentColor"
      />
    </React.Fragment>
  ),
  youtube: (
    <React.Fragment>
      <path
        d="M10.5059 14.2483L14.4093 12.0001L10.5059 9.75195V14.2483Z"
        fill="currentColor"
      />
      <path
        d="M12 0C5.3736 0 0 5.3736 0 12C0 18.6264 5.3736 24 12 24C18.6264 24 24 18.6264 24 12C24 5.3736 18.6264 0 12 0ZM19.4982 12.0123C19.4982 12.0123 19.4982 14.4459 19.1895 15.6194C19.0164 16.2618 18.5099 16.7682 17.8676 16.9411C16.6941 17.25 12 17.25 12 17.25C12 17.25 7.31818 17.25 6.13239 16.9288C5.49005 16.756 4.98358 16.2493 4.81055 15.607C4.50165 14.4459 4.50165 12 4.50165 12C4.50165 12 4.50165 9.56653 4.81055 8.39301C4.9834 7.75067 5.50232 7.23175 6.13239 7.0589C7.30591 6.75 12 6.75 12 6.75C12 6.75 16.6941 6.75 17.8676 7.07117C18.5099 7.24402 19.0164 7.75067 19.1895 8.39301C19.5106 9.56653 19.4982 12.0123 19.4982 12.0123V12.0123Z"
        fill="currentColor"
      />
    </React.Fragment>
  ),
  instagram: (
    <React.Fragment>
      <path
        d="M14.2969 12C14.2969 13.2686 13.2686 14.2969 12 14.2969C10.7314 14.2969 9.70312 13.2686 9.70312 12C9.70312 10.7314 10.7314 9.70312 12 9.70312C13.2686 9.70312 14.2969 10.7314 14.2969 12Z"
        fill="currentColor"
      />
      <path
        d="M17.3713 7.93622C17.2609 7.63702 17.0848 7.36621 16.8559 7.14392C16.6336 6.91504 16.363 6.73889 16.0636 6.62848C15.8208 6.53418 15.4561 6.42194 14.7842 6.39136C14.0575 6.35822 13.8396 6.35107 11.9998 6.35107C10.1597 6.35107 9.94183 6.35803 9.21527 6.39117C8.54346 6.42194 8.17853 6.53418 7.93591 6.62848C7.63654 6.73889 7.36572 6.91504 7.14362 7.14392C6.91473 7.36621 6.73859 7.63684 6.62799 7.93622C6.53369 8.17902 6.42145 8.54395 6.39087 9.21576C6.35773 9.94232 6.35059 10.1602 6.35059 12.0002C6.35059 13.8401 6.35773 14.058 6.39087 14.7847C6.42145 15.4565 6.53369 15.8213 6.62799 16.0641C6.73859 16.3635 6.91455 16.6341 7.14343 16.8564C7.36572 17.0853 7.63635 17.2614 7.93573 17.3718C8.17853 17.4663 8.54346 17.5786 9.21527 17.6091C9.94183 17.6423 10.1595 17.6492 11.9996 17.6492C13.8398 17.6492 14.0577 17.6423 14.7841 17.6091C15.4559 17.5786 15.8208 17.4663 16.0636 17.3718C16.6646 17.14 17.1395 16.665 17.3713 16.0641C17.4656 15.8213 17.5779 15.4565 17.6086 14.7847C17.6418 14.058 17.6487 13.8401 17.6487 12.0002C17.6487 10.1602 17.6418 9.94232 17.6086 9.21576C17.5781 8.54395 17.4658 8.17902 17.3713 7.93622V7.93622ZM11.9998 15.5384C10.0455 15.5384 8.46124 13.9543 8.46124 12.0001C8.46124 10.0458 10.0455 8.46173 11.9998 8.46173C13.9539 8.46173 15.5381 10.0458 15.5381 12.0001C15.5381 13.9543 13.9539 15.5384 11.9998 15.5384ZM15.678 9.14874C15.2213 9.14874 14.8511 8.7785 14.8511 8.32184C14.8511 7.86517 15.2213 7.49493 15.678 7.49493C16.1346 7.49493 16.5049 7.86517 16.5049 8.32184C16.5047 8.7785 16.1346 9.14874 15.678 9.14874Z"
        fill="currentColor"
      />
      <path
        d="M12 0C5.3736 0 0 5.3736 0 12C0 18.6264 5.3736 24 12 24C18.6264 24 24 18.6264 24 12C24 5.3736 18.6264 0 12 0ZM18.8491 14.8409C18.8157 15.5744 18.6991 16.0752 18.5288 16.5135C18.1708 17.4391 17.4391 18.1708 16.5135 18.5288C16.0754 18.6991 15.5744 18.8156 14.8411 18.8491C14.1063 18.8826 13.8715 18.8906 12.0002 18.8906C10.1287 18.8906 9.8941 18.8826 9.15912 18.8491C8.42578 18.8156 7.9248 18.6991 7.48663 18.5288C7.02667 18.3558 6.61029 18.0846 6.26605 17.7339C5.91559 17.3899 5.64441 16.9733 5.47137 16.5135C5.30109 16.0754 5.18445 15.5744 5.15112 14.8411C5.11725 14.1061 5.10938 13.8713 5.10938 12C5.10938 10.1287 5.11725 9.89392 5.15094 9.15912C5.18427 8.4256 5.30072 7.9248 5.47101 7.48645C5.64404 7.02667 5.91541 6.61011 6.26605 6.26605C6.61011 5.91541 7.02667 5.64423 7.48645 5.47119C7.9248 5.3009 8.4256 5.18445 9.15912 5.15094C9.89392 5.11743 10.1287 5.10938 12 5.10938C13.8713 5.10938 14.1061 5.11743 14.8409 5.15112C15.5744 5.18445 16.0752 5.3009 16.5135 5.47101C16.9733 5.64404 17.3899 5.91541 17.7341 6.26605C18.0846 6.61029 18.356 7.02667 18.5288 7.48645C18.6993 7.9248 18.8157 8.4256 18.8492 9.15912C18.8828 9.89392 18.8906 10.1287 18.8906 12C18.8906 13.8713 18.8828 14.1061 18.8491 14.8409V14.8409Z"
        fill="currentColor"
      />
    </React.Fragment>
  ),
  twitter: (
    <React.Fragment>
      <path
        d="M12 0C5.3736 0 0 5.21555 0 11.6471C0 18.0786 5.3736 23.2941 12 23.2941C18.6264 23.2941 24 18.0786 24 11.6471C24 5.21555 18.6264 0 12 0ZM17.4791 9.08114C17.4844 9.19577 17.4869 9.31093 17.4869 9.42663C17.4869 12.9592 14.7166 17.0327 9.65021 17.0329H9.65039H9.65021C8.09473 17.0329 6.64728 16.5903 5.42834 15.832C5.64386 15.8567 5.86322 15.869 6.08533 15.869C7.37585 15.869 8.56348 15.4417 9.50629 14.7246C8.30054 14.703 7.28394 13.9301 6.93311 12.8678C7.10101 12.8991 7.27368 12.9162 7.45074 12.9162C7.70215 12.9162 7.94568 12.8833 8.17712 12.822C6.91681 12.5771 5.96741 11.496 5.96741 10.2015C5.96741 10.1894 5.96741 10.1786 5.96777 10.1674C6.33893 10.3677 6.76337 10.4881 7.21527 10.5017C6.47571 10.0227 5.98956 9.20394 5.98956 8.27642C5.98956 7.78663 6.12598 7.32775 6.36255 6.93268C7.72083 8.55029 9.75073 9.61412 12.0399 9.72591C11.9927 9.53006 11.9683 9.32604 11.9683 9.11633C11.9683 7.64054 13.2019 6.44324 14.723 6.44324C15.5153 6.44324 16.2308 6.76829 16.7335 7.28794C17.361 7.1678 17.9502 6.9453 18.4825 6.63909C18.2765 7.26306 17.84 7.78663 17.2712 8.11772C17.8284 8.05303 18.3594 7.90961 18.8529 7.6967C18.4843 8.23288 18.0168 8.70384 17.4791 9.08114V9.08114Z"
        fill="currentColor"
      />
    </React.Fragment>
  ),
  "twitter-author": (
    <React.Fragment>
      <path
        d="M30.2702 2.84123C29.1717 3.32308 28.0012 3.64246 26.7809 3.79754C28.0363 3.048 28.9945 1.87015 29.4449 0.450461C28.2745 1.14831 26.9822 1.64123 25.6049 1.91631C24.4935 0.732923 22.9095 0 21.1815 0C17.8289 0 15.1298 2.72123 15.1298 6.05723C15.1298 6.53723 15.1705 6.99877 15.2702 7.43815C10.2357 7.19262 5.78092 4.77969 2.7883 1.104C2.26584 2.01046 1.95938 3.048 1.95938 4.16492C1.95938 6.26215 3.03938 8.12123 4.64923 9.19754C3.67631 9.17908 2.72184 8.89662 1.91323 8.45169C1.91323 8.47015 1.91323 8.49415 1.91323 8.51815C1.91323 11.4609 4.0123 13.9052 6.76492 14.4683C6.272 14.6031 5.73477 14.6677 5.17723 14.6677C4.78954 14.6677 4.39815 14.6455 4.03077 14.5643C4.81538 16.9625 7.04184 18.7255 9.68923 18.7828C7.62892 20.3945 5.01292 21.3655 2.18092 21.3655C1.6843 21.3655 1.208 21.3434 0.731689 21.2825C3.41415 23.0123 6.59323 24 10.0215 24C21.1649 24 27.2572 14.7692 27.2572 6.768C27.2572 6.50031 27.248 6.24185 27.2351 5.98523C28.4369 5.13231 29.4468 4.06708 30.2702 2.84123Z"
        fill="black"
      />
    </React.Fragment>
  ),
  pinterest: (
    <React.Fragment>
      <path
        d="M11.9999 0.0241699C5.37253 0.0241699 0 5.39684 0 12.0241C0 17.108 3.16289 21.454 7.62689 23.2024C7.52189 22.253 7.42716 20.7928 7.66856 19.7563C7.88653 18.8198 9.07566 13.7915 9.07566 13.7915C9.07566 13.7915 8.71664 13.0727 8.71664 12.0099C8.71664 10.3413 9.68377 9.09561 10.888 9.09561C11.9117 9.09561 12.4064 9.86431 12.4064 10.786C12.4064 11.8156 11.7509 13.3549 11.4125 14.7814C11.1298 15.9758 12.0115 16.9498 13.1895 16.9498C15.3224 16.9498 16.9618 14.701 16.9618 11.4547C16.9618 8.58162 14.8972 6.57275 11.9494 6.57275C8.53495 6.57275 6.53077 9.13372 6.53077 11.7803C6.53077 12.8118 6.92803 13.9176 7.42383 14.5188C7.5218 14.6376 7.53623 14.7418 7.50708 14.863C7.41591 15.2421 7.21355 16.0571 7.17375 16.2239C7.12139 16.4435 6.9998 16.4902 6.77245 16.3844C5.27367 15.6867 4.33669 13.4956 4.33669 11.7356C4.33669 7.95022 7.08694 4.47397 12.2655 4.47397C16.4283 4.47397 19.6634 7.44017 19.6634 11.4044C19.6634 15.5402 17.0558 18.8684 13.4364 18.8684C12.2205 18.8684 11.0773 18.2368 10.686 17.4906C10.686 17.4906 10.0843 19.7818 9.93839 20.3432C9.66736 21.3856 8.93611 22.6921 8.44692 23.489C9.56981 23.8367 10.763 24.0241 11.9999 24.0241C18.6275 24.0241 24 18.6517 24 12.0241C24 5.39684 18.6275 0.0241699 11.9999 0.0241699V0.0241699Z"
        fill="currentColor"
      />
    </React.Fragment>
  )
};

const StyledIcon = styled(Box)`
  svg {
    width: 100%;
    height: 100%;
    line-height: 1;
    display: block;
  }
`;

export default ({ icon, width, height, svgProps = {}, ...rest }) => (
  <StyledIcon {...rest}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      {...svgProps}
    >
      {icons[icon]}
    </svg>
  </StyledIcon>
);
